import * as Ae from "react";
import N, { useState as gn, useEffect as Xa, useRef as mr, forwardRef as Xo, useMemo as Lr, Fragment as N6, useContext as $r, Component as Za, createContext as bn, useCallback as kr, isValidElement as _r, Children as Gn, PureComponent as xn, useImperativeHandle as $6, cloneElement as vt, createElement as zm } from "react";
import * as Ym from "react-dom";
import Xm, { createPortal as F6 } from "react-dom";
var pa = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Fe(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function D6(e) {
  if (e.__esModule) return e;
  var t = e.default;
  if (typeof t == "function") {
    var r = function n() {
      return this instanceof n ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    r.prototype = t.prototype;
  } else r = {};
  return Object.defineProperty(r, "__esModule", { value: !0 }), Object.keys(e).forEach(function(n) {
    var a = Object.getOwnPropertyDescriptor(e, n);
    Object.defineProperty(r, n, a.get ? a : {
      enumerable: !0,
      get: function() {
        return e[n];
      }
    });
  }), r;
}
var pf = { exports: {} }, bi = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Jp;
function k6() {
  if (Jp) return bi;
  Jp = 1;
  var e = N, t = Symbol.for("react.element"), r = Symbol.for("react.fragment"), n = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function o(u, s, c) {
    var l, f = {}, d = null, p = null;
    c !== void 0 && (d = "" + c), s.key !== void 0 && (d = "" + s.key), s.ref !== void 0 && (p = s.ref);
    for (l in s) n.call(s, l) && !i.hasOwnProperty(l) && (f[l] = s[l]);
    if (u && u.defaultProps) for (l in s = u.defaultProps, s) f[l] === void 0 && (f[l] = s[l]);
    return { $$typeof: t, type: u, key: d, ref: p, props: f, _owner: a.current };
  }
  return bi.Fragment = r, bi.jsx = o, bi.jsxs = o, bi;
}
var xi = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Qp;
function L6() {
  return Qp || (Qp = 1, process.env.NODE_ENV !== "production" && function() {
    var e = N, t = Symbol.for("react.element"), r = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), o = Symbol.for("react.provider"), u = Symbol.for("react.context"), s = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), l = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), d = Symbol.for("react.lazy"), p = Symbol.for("react.offscreen"), h = Symbol.iterator, v = "@@iterator";
    function g(V) {
      if (V === null || typeof V != "object")
        return null;
      var ae = h && V[h] || V[v];
      return typeof ae == "function" ? ae : null;
    }
    var b = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function x(V) {
      {
        for (var ae = arguments.length, se = new Array(ae > 1 ? ae - 1 : 0), xe = 1; xe < ae; xe++)
          se[xe - 1] = arguments[xe];
        w("error", V, se);
      }
    }
    function w(V, ae, se) {
      {
        var xe = b.ReactDebugCurrentFrame, Le = xe.getStackAddendum();
        Le !== "" && (ae += "%s", se = se.concat([Le]));
        var Ze = se.map(function(je) {
          return String(je);
        });
        Ze.unshift("Warning: " + ae), Function.prototype.apply.call(console[V], console, Ze);
      }
    }
    var y = !1, m = !1, C = !1, O = !1, S = !1, A;
    A = Symbol.for("react.module.reference");
    function P(V) {
      return !!(typeof V == "string" || typeof V == "function" || V === n || V === i || S || V === a || V === c || V === l || O || V === p || y || m || C || typeof V == "object" && V !== null && (V.$$typeof === d || V.$$typeof === f || V.$$typeof === o || V.$$typeof === u || V.$$typeof === s || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      V.$$typeof === A || V.getModuleId !== void 0));
    }
    function T(V, ae, se) {
      var xe = V.displayName;
      if (xe)
        return xe;
      var Le = ae.displayName || ae.name || "";
      return Le !== "" ? se + "(" + Le + ")" : se;
    }
    function M(V) {
      return V.displayName || "Context";
    }
    function I(V) {
      if (V == null)
        return null;
      if (typeof V.tag == "number" && x("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof V == "function")
        return V.displayName || V.name || null;
      if (typeof V == "string")
        return V;
      switch (V) {
        case n:
          return "Fragment";
        case r:
          return "Portal";
        case i:
          return "Profiler";
        case a:
          return "StrictMode";
        case c:
          return "Suspense";
        case l:
          return "SuspenseList";
      }
      if (typeof V == "object")
        switch (V.$$typeof) {
          case u:
            var ae = V;
            return M(ae) + ".Consumer";
          case o:
            var se = V;
            return M(se._context) + ".Provider";
          case s:
            return T(V, V.render, "ForwardRef");
          case f:
            var xe = V.displayName || null;
            return xe !== null ? xe : I(V.type) || "Memo";
          case d: {
            var Le = V, Ze = Le._payload, je = Le._init;
            try {
              return I(je(Ze));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var G = Object.assign, Y = 0, L, X, q, re, j, W, D;
    function R() {
    }
    R.__reactDisabledLog = !0;
    function $() {
      {
        if (Y === 0) {
          L = console.log, X = console.info, q = console.warn, re = console.error, j = console.group, W = console.groupCollapsed, D = console.groupEnd;
          var V = {
            configurable: !0,
            enumerable: !0,
            value: R,
            writable: !0
          };
          Object.defineProperties(console, {
            info: V,
            log: V,
            warn: V,
            error: V,
            group: V,
            groupCollapsed: V,
            groupEnd: V
          });
        }
        Y++;
      }
    }
    function B() {
      {
        if (Y--, Y === 0) {
          var V = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: G({}, V, {
              value: L
            }),
            info: G({}, V, {
              value: X
            }),
            warn: G({}, V, {
              value: q
            }),
            error: G({}, V, {
              value: re
            }),
            group: G({}, V, {
              value: j
            }),
            groupCollapsed: G({}, V, {
              value: W
            }),
            groupEnd: G({}, V, {
              value: D
            })
          });
        }
        Y < 0 && x("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var H = b.ReactCurrentDispatcher, z;
    function J(V, ae, se) {
      {
        if (z === void 0)
          try {
            throw Error();
          } catch (Le) {
            var xe = Le.stack.trim().match(/\n( *(at )?)/);
            z = xe && xe[1] || "";
          }
        return `
` + z + V;
      }
    }
    var U = !1, F;
    {
      var k = typeof WeakMap == "function" ? WeakMap : Map;
      F = new k();
    }
    function E(V, ae) {
      if (!V || U)
        return "";
      {
        var se = F.get(V);
        if (se !== void 0)
          return se;
      }
      var xe;
      U = !0;
      var Le = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var Ze;
      Ze = H.current, H.current = null, $();
      try {
        if (ae) {
          var je = function() {
            throw Error();
          };
          if (Object.defineProperty(je.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(je, []);
            } catch (Ft) {
              xe = Ft;
            }
            Reflect.construct(V, [], je);
          } else {
            try {
              je.call();
            } catch (Ft) {
              xe = Ft;
            }
            V.call(je.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Ft) {
            xe = Ft;
          }
          V();
        }
      } catch (Ft) {
        if (Ft && xe && typeof Ft.stack == "string") {
          for (var Pe = Ft.stack.split(`
`), Rt = xe.stack.split(`
`), ct = Pe.length - 1, lt = Rt.length - 1; ct >= 1 && lt >= 0 && Pe[ct] !== Rt[lt]; )
            lt--;
          for (; ct >= 1 && lt >= 0; ct--, lt--)
            if (Pe[ct] !== Rt[lt]) {
              if (ct !== 1 || lt !== 1)
                do
                  if (ct--, lt--, lt < 0 || Pe[ct] !== Rt[lt]) {
                    var Jt = `
` + Pe[ct].replace(" at new ", " at ");
                    return V.displayName && Jt.includes("<anonymous>") && (Jt = Jt.replace("<anonymous>", V.displayName)), typeof V == "function" && F.set(V, Jt), Jt;
                  }
                while (ct >= 1 && lt >= 0);
              break;
            }
        }
      } finally {
        U = !1, H.current = Ze, B(), Error.prepareStackTrace = Le;
      }
      var aa = V ? V.displayName || V.name : "", Mn = aa ? J(aa) : "";
      return typeof V == "function" && F.set(V, Mn), Mn;
    }
    function K(V, ae, se) {
      return E(V, !1);
    }
    function Z(V) {
      var ae = V.prototype;
      return !!(ae && ae.isReactComponent);
    }
    function Q(V, ae, se) {
      if (V == null)
        return "";
      if (typeof V == "function")
        return E(V, Z(V));
      if (typeof V == "string")
        return J(V);
      switch (V) {
        case c:
          return J("Suspense");
        case l:
          return J("SuspenseList");
      }
      if (typeof V == "object")
        switch (V.$$typeof) {
          case s:
            return K(V.render);
          case f:
            return Q(V.type, ae, se);
          case d: {
            var xe = V, Le = xe._payload, Ze = xe._init;
            try {
              return Q(Ze(Le), ae, se);
            } catch {
            }
          }
        }
      return "";
    }
    var ne = Object.prototype.hasOwnProperty, ue = {}, de = b.ReactDebugCurrentFrame;
    function le(V) {
      if (V) {
        var ae = V._owner, se = Q(V.type, V._source, ae ? ae.type : null);
        de.setExtraStackFrame(se);
      } else
        de.setExtraStackFrame(null);
    }
    function pe(V, ae, se, xe, Le) {
      {
        var Ze = Function.call.bind(ne);
        for (var je in V)
          if (Ze(V, je)) {
            var Pe = void 0;
            try {
              if (typeof V[je] != "function") {
                var Rt = Error((xe || "React class") + ": " + se + " type `" + je + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof V[je] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw Rt.name = "Invariant Violation", Rt;
              }
              Pe = V[je](ae, je, xe, se, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (ct) {
              Pe = ct;
            }
            Pe && !(Pe instanceof Error) && (le(Le), x("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", xe || "React class", se, je, typeof Pe), le(null)), Pe instanceof Error && !(Pe.message in ue) && (ue[Pe.message] = !0, le(Le), x("Failed %s type: %s", se, Pe.message), le(null));
          }
      }
    }
    var ie = Array.isArray;
    function Te(V) {
      return ie(V);
    }
    function Qe(V) {
      {
        var ae = typeof Symbol == "function" && Symbol.toStringTag, se = ae && V[Symbol.toStringTag] || V.constructor.name || "Object";
        return se;
      }
    }
    function Ot(V) {
      try {
        return Gt(V), !1;
      } catch {
        return !0;
      }
    }
    function Gt(V) {
      return "" + V;
    }
    function qt(V) {
      if (Ot(V))
        return x("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Qe(V)), Gt(V);
    }
    var dr = b.ReactCurrentOwner, ra = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, na, pi, hi;
    hi = {};
    function kc(V) {
      if (ne.call(V, "ref")) {
        var ae = Object.getOwnPropertyDescriptor(V, "ref").get;
        if (ae && ae.isReactWarning)
          return !1;
      }
      return V.ref !== void 0;
    }
    function fu(V) {
      if (ne.call(V, "key")) {
        var ae = Object.getOwnPropertyDescriptor(V, "key").get;
        if (ae && ae.isReactWarning)
          return !1;
      }
      return V.key !== void 0;
    }
    function St(V, ae) {
      if (typeof V.ref == "string" && dr.current && ae && dr.current.stateNode !== ae) {
        var se = I(dr.current.type);
        hi[se] || (x('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', I(dr.current.type), V.ref), hi[se] = !0);
      }
    }
    function ot(V, ae) {
      {
        var se = function() {
          na || (na = !0, x("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", ae));
        };
        se.isReactWarning = !0, Object.defineProperty(V, "key", {
          get: se,
          configurable: !0
        });
      }
    }
    function yt(V, ae) {
      {
        var se = function() {
          pi || (pi = !0, x("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", ae));
        };
        se.isReactWarning = !0, Object.defineProperty(V, "ref", {
          get: se,
          configurable: !0
        });
      }
    }
    var bt = function(V, ae, se, xe, Le, Ze, je) {
      var Pe = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: V,
        key: ae,
        ref: se,
        props: je,
        // Record the component responsible for creating this element.
        _owner: Ze
      };
      return Pe._store = {}, Object.defineProperty(Pe._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(Pe, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: xe
      }), Object.defineProperty(Pe, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Le
      }), Object.freeze && (Object.freeze(Pe.props), Object.freeze(Pe)), Pe;
    };
    function rt(V, ae, se, xe, Le) {
      {
        var Ze, je = {}, Pe = null, Rt = null;
        se !== void 0 && (qt(se), Pe = "" + se), fu(ae) && (qt(ae.key), Pe = "" + ae.key), kc(ae) && (Rt = ae.ref, St(ae, Le));
        for (Ze in ae)
          ne.call(ae, Ze) && !ra.hasOwnProperty(Ze) && (je[Ze] = ae[Ze]);
        if (V && V.defaultProps) {
          var ct = V.defaultProps;
          for (Ze in ct)
            je[Ze] === void 0 && (je[Ze] = ct[Ze]);
        }
        if (Pe || Rt) {
          var lt = typeof V == "function" ? V.displayName || V.name || "Unknown" : V;
          Pe && ot(je, lt), Rt && yt(je, lt);
        }
        return bt(V, Pe, Rt, Le, xe, dr.current, je);
      }
    }
    var In = b.ReactCurrentOwner, Pn = b.ReactDebugCurrentFrame;
    function pr(V) {
      if (V) {
        var ae = V._owner, se = Q(V.type, V._source, ae ? ae.type : null);
        Pn.setExtraStackFrame(se);
      } else
        Pn.setExtraStackFrame(null);
    }
    var Tn;
    Tn = !1;
    function vi(V) {
      return typeof V == "object" && V !== null && V.$$typeof === t;
    }
    function gi() {
      {
        if (In.current) {
          var V = I(In.current.type);
          if (V)
            return `

Check the render method of \`` + V + "`.";
        }
        return "";
      }
    }
    function Lc(V) {
      return "";
    }
    var du = {};
    function pu(V) {
      {
        var ae = gi();
        if (!ae) {
          var se = typeof V == "string" ? V : V.displayName || V.name;
          se && (ae = `

Check the top-level render call using <` + se + ">.");
        }
        return ae;
      }
    }
    function mi(V, ae) {
      {
        if (!V._store || V._store.validated || V.key != null)
          return;
        V._store.validated = !0;
        var se = pu(ae);
        if (du[se])
          return;
        du[se] = !0;
        var xe = "";
        V && V._owner && V._owner !== In.current && (xe = " It was passed a child from " + I(V._owner.type) + "."), pr(V), x('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', se, xe), pr(null);
      }
    }
    function yi(V, ae) {
      {
        if (typeof V != "object")
          return;
        if (Te(V))
          for (var se = 0; se < V.length; se++) {
            var xe = V[se];
            vi(xe) && mi(xe, ae);
          }
        else if (vi(V))
          V._store && (V._store.validated = !0);
        else if (V) {
          var Le = g(V);
          if (typeof Le == "function" && Le !== V.entries)
            for (var Ze = Le.call(V), je; !(je = Ze.next()).done; )
              vi(je.value) && mi(je.value, ae);
        }
      }
    }
    function Bc(V) {
      {
        var ae = V.type;
        if (ae == null || typeof ae == "string")
          return;
        var se;
        if (typeof ae == "function")
          se = ae.propTypes;
        else if (typeof ae == "object" && (ae.$$typeof === s || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        ae.$$typeof === f))
          se = ae.propTypes;
        else
          return;
        if (se) {
          var xe = I(ae);
          pe(se, V.props, "prop", xe, V);
        } else if (ae.PropTypes !== void 0 && !Tn) {
          Tn = !0;
          var Le = I(ae);
          x("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", Le || "Unknown");
        }
        typeof ae.getDefaultProps == "function" && !ae.getDefaultProps.isReactClassApproved && x("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vc(V) {
      {
        for (var ae = Object.keys(V.props), se = 0; se < ae.length; se++) {
          var xe = ae[se];
          if (xe !== "children" && xe !== "key") {
            pr(V), x("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", xe), pr(null);
            break;
          }
        }
        V.ref !== null && (pr(V), x("Invalid attribute `ref` supplied to `React.Fragment`."), pr(null));
      }
    }
    var Kp = {};
    function qp(V, ae, se, xe, Le, Ze) {
      {
        var je = P(V);
        if (!je) {
          var Pe = "";
          (V === void 0 || typeof V == "object" && V !== null && Object.keys(V).length === 0) && (Pe += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var Rt = Lc();
          Rt ? Pe += Rt : Pe += gi();
          var ct;
          V === null ? ct = "null" : Te(V) ? ct = "array" : V !== void 0 && V.$$typeof === t ? (ct = "<" + (I(V.type) || "Unknown") + " />", Pe = " Did you accidentally export a JSX literal instead of a component?") : ct = typeof V, x("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", ct, Pe);
        }
        var lt = rt(V, ae, se, Le, Ze);
        if (lt == null)
          return lt;
        if (je) {
          var Jt = ae.children;
          if (Jt !== void 0)
            if (xe)
              if (Te(Jt)) {
                for (var aa = 0; aa < Jt.length; aa++)
                  yi(Jt[aa], V);
                Object.freeze && Object.freeze(Jt);
              } else
                x("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              yi(Jt, V);
        }
        if (ne.call(ae, "key")) {
          var Mn = I(V), Ft = Object.keys(ae).filter(function(R6) {
            return R6 !== "key";
          }), Wc = Ft.length > 0 ? "{key: someKey, " + Ft.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Kp[Mn + Wc]) {
            var j6 = Ft.length > 0 ? "{" + Ft.join(": ..., ") + ": ...}" : "{}";
            x(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Wc, Mn, j6, Mn), Kp[Mn + Wc] = !0;
          }
        }
        return V === n ? Vc(lt) : Bc(lt), lt;
      }
    }
    function I6(V, ae, se) {
      return qp(V, ae, se, !0);
    }
    function P6(V, ae, se) {
      return qp(V, ae, se, !1);
    }
    var T6 = P6, M6 = I6;
    xi.Fragment = n, xi.jsx = T6, xi.jsxs = M6;
  }()), xi;
}
process.env.NODE_ENV === "production" ? pf.exports = k6() : pf.exports = L6();
var _ = pf.exports, Zm = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(e) {
  (function() {
    var t = {}.hasOwnProperty;
    function r() {
      for (var i = "", o = 0; o < arguments.length; o++) {
        var u = arguments[o];
        u && (i = a(i, n(u)));
      }
      return i;
    }
    function n(i) {
      if (typeof i == "string" || typeof i == "number")
        return i;
      if (typeof i != "object")
        return "";
      if (Array.isArray(i))
        return r.apply(null, i);
      if (i.toString !== Object.prototype.toString && !i.toString.toString().includes("[native code]"))
        return i.toString();
      var o = "";
      for (var u in i)
        t.call(i, u) && i[u] && (o = a(o, u));
      return o;
    }
    function a(i, o) {
      return o ? i ? i + " " + o : i + o : i;
    }
    e.exports ? (r.default = r, e.exports = r) : window.classNames = r;
  })();
})(Zm);
var B6 = Zm.exports;
const He = /* @__PURE__ */ Fe(B6);
var eh = function(t) {
  return t.reduce(function(r, n) {
    var a = n[0], i = n[1];
    return r[a] = i, r;
  }, {});
}, th = typeof window < "u" && window.document && window.document.createElement ? Ae.useLayoutEffect : Ae.useEffect, Lt = "top", or = "bottom", ur = "right", Bt = "left", d1 = "auto", Zo = [Lt, or, ur, Bt], Ca = "start", no = "end", V6 = "clippingParents", Km = "viewport", Ci = "popper", W6 = "reference", rh = /* @__PURE__ */ Zo.reduce(function(e, t) {
  return e.concat([t + "-" + Ca, t + "-" + no]);
}, []), qm = /* @__PURE__ */ [].concat(Zo, [d1]).reduce(function(e, t) {
  return e.concat([t, t + "-" + Ca, t + "-" + no]);
}, []), G6 = "beforeRead", H6 = "read", U6 = "afterRead", z6 = "beforeMain", Y6 = "main", X6 = "afterMain", Z6 = "beforeWrite", K6 = "write", q6 = "afterWrite", J6 = [G6, H6, U6, z6, Y6, X6, Z6, K6, q6];
function jr(e) {
  return e ? (e.nodeName || "").toLowerCase() : null;
}
function Zt(e) {
  if (e == null)
    return window;
  if (e.toString() !== "[object Window]") {
    var t = e.ownerDocument;
    return t && t.defaultView || window;
  }
  return e;
}
function Xn(e) {
  var t = Zt(e).Element;
  return e instanceof t || e instanceof Element;
}
function ir(e) {
  var t = Zt(e).HTMLElement;
  return e instanceof t || e instanceof HTMLElement;
}
function p1(e) {
  if (typeof ShadowRoot > "u")
    return !1;
  var t = Zt(e).ShadowRoot;
  return e instanceof t || e instanceof ShadowRoot;
}
function Q6(e) {
  var t = e.state;
  Object.keys(t.elements).forEach(function(r) {
    var n = t.styles[r] || {}, a = t.attributes[r] || {}, i = t.elements[r];
    !ir(i) || !jr(i) || (Object.assign(i.style, n), Object.keys(a).forEach(function(o) {
      var u = a[o];
      u === !1 ? i.removeAttribute(o) : i.setAttribute(o, u === !0 ? "" : u);
    }));
  });
}
function e9(e) {
  var t = e.state, r = {
    popper: {
      position: t.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(t.elements.popper.style, r.popper), t.styles = r, t.elements.arrow && Object.assign(t.elements.arrow.style, r.arrow), function() {
    Object.keys(t.elements).forEach(function(n) {
      var a = t.elements[n], i = t.attributes[n] || {}, o = Object.keys(t.styles.hasOwnProperty(n) ? t.styles[n] : r[n]), u = o.reduce(function(s, c) {
        return s[c] = "", s;
      }, {});
      !ir(a) || !jr(a) || (Object.assign(a.style, u), Object.keys(i).forEach(function(s) {
        a.removeAttribute(s);
      }));
    });
  };
}
const t9 = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: Q6,
  effect: e9,
  requires: ["computeStyles"]
};
function Ir(e) {
  return e.split("-")[0];
}
var Hn = Math.max, Vu = Math.min, wa = Math.round;
function hf() {
  var e = navigator.userAgentData;
  return e != null && e.brands && Array.isArray(e.brands) ? e.brands.map(function(t) {
    return t.brand + "/" + t.version;
  }).join(" ") : navigator.userAgent;
}
function Jm() {
  return !/^((?!chrome|android).)*safari/i.test(hf());
}
function Oa(e, t, r) {
  t === void 0 && (t = !1), r === void 0 && (r = !1);
  var n = e.getBoundingClientRect(), a = 1, i = 1;
  t && ir(e) && (a = e.offsetWidth > 0 && wa(n.width) / e.offsetWidth || 1, i = e.offsetHeight > 0 && wa(n.height) / e.offsetHeight || 1);
  var o = Xn(e) ? Zt(e) : window, u = o.visualViewport, s = !Jm() && r, c = (n.left + (s && u ? u.offsetLeft : 0)) / a, l = (n.top + (s && u ? u.offsetTop : 0)) / i, f = n.width / a, d = n.height / i;
  return {
    width: f,
    height: d,
    top: l,
    right: c + f,
    bottom: l + d,
    left: c,
    x: c,
    y: l
  };
}
function h1(e) {
  var t = Oa(e), r = e.offsetWidth, n = e.offsetHeight;
  return Math.abs(t.width - r) <= 1 && (r = t.width), Math.abs(t.height - n) <= 1 && (n = t.height), {
    x: e.offsetLeft,
    y: e.offsetTop,
    width: r,
    height: n
  };
}
function Qm(e, t) {
  var r = t.getRootNode && t.getRootNode();
  if (e.contains(t))
    return !0;
  if (r && p1(r)) {
    var n = t;
    do {
      if (n && e.isSameNode(n))
        return !0;
      n = n.parentNode || n.host;
    } while (n);
  }
  return !1;
}
function Xr(e) {
  return Zt(e).getComputedStyle(e);
}
function r9(e) {
  return ["table", "td", "th"].indexOf(jr(e)) >= 0;
}
function Cn(e) {
  return ((Xn(e) ? e.ownerDocument : (
    // $FlowFixMe[prop-missing]
    e.document
  )) || window.document).documentElement;
}
function qs(e) {
  return jr(e) === "html" ? e : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    e.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    e.parentNode || // DOM Element detected
    (p1(e) ? e.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    Cn(e)
  );
}
function nh(e) {
  return !ir(e) || // https://github.com/popperjs/popper-core/issues/837
  Xr(e).position === "fixed" ? null : e.offsetParent;
}
function n9(e) {
  var t = /firefox/i.test(hf()), r = /Trident/i.test(hf());
  if (r && ir(e)) {
    var n = Xr(e);
    if (n.position === "fixed")
      return null;
  }
  var a = qs(e);
  for (p1(a) && (a = a.host); ir(a) && ["html", "body"].indexOf(jr(a)) < 0; ) {
    var i = Xr(a);
    if (i.transform !== "none" || i.perspective !== "none" || i.contain === "paint" || ["transform", "perspective"].indexOf(i.willChange) !== -1 || t && i.willChange === "filter" || t && i.filter && i.filter !== "none")
      return a;
    a = a.parentNode;
  }
  return null;
}
function Ko(e) {
  for (var t = Zt(e), r = nh(e); r && r9(r) && Xr(r).position === "static"; )
    r = nh(r);
  return r && (jr(r) === "html" || jr(r) === "body" && Xr(r).position === "static") ? t : r || n9(e) || t;
}
function v1(e) {
  return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}
function Gi(e, t, r) {
  return Hn(e, Vu(t, r));
}
function a9(e, t, r) {
  var n = Gi(e, t, r);
  return n > r ? r : n;
}
function ey() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function ty(e) {
  return Object.assign({}, ey(), e);
}
function ry(e, t) {
  return t.reduce(function(r, n) {
    return r[n] = e, r;
  }, {});
}
var i9 = function(t, r) {
  return t = typeof t == "function" ? t(Object.assign({}, r.rects, {
    placement: r.placement
  })) : t, ty(typeof t != "number" ? t : ry(t, Zo));
};
function o9(e) {
  var t, r = e.state, n = e.name, a = e.options, i = r.elements.arrow, o = r.modifiersData.popperOffsets, u = Ir(r.placement), s = v1(u), c = [Bt, ur].indexOf(u) >= 0, l = c ? "height" : "width";
  if (!(!i || !o)) {
    var f = i9(a.padding, r), d = h1(i), p = s === "y" ? Lt : Bt, h = s === "y" ? or : ur, v = r.rects.reference[l] + r.rects.reference[s] - o[s] - r.rects.popper[l], g = o[s] - r.rects.reference[s], b = Ko(i), x = b ? s === "y" ? b.clientHeight || 0 : b.clientWidth || 0 : 0, w = v / 2 - g / 2, y = f[p], m = x - d[l] - f[h], C = x / 2 - d[l] / 2 + w, O = Gi(y, C, m), S = s;
    r.modifiersData[n] = (t = {}, t[S] = O, t.centerOffset = O - C, t);
  }
}
function u9(e) {
  var t = e.state, r = e.options, n = r.element, a = n === void 0 ? "[data-popper-arrow]" : n;
  a != null && (typeof a == "string" && (a = t.elements.popper.querySelector(a), !a) || Qm(t.elements.popper, a) && (t.elements.arrow = a));
}
const s9 = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: o9,
  effect: u9,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function Sa(e) {
  return e.split("-")[1];
}
var c9 = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function l9(e, t) {
  var r = e.x, n = e.y, a = t.devicePixelRatio || 1;
  return {
    x: wa(r * a) / a || 0,
    y: wa(n * a) / a || 0
  };
}
function ah(e) {
  var t, r = e.popper, n = e.popperRect, a = e.placement, i = e.variation, o = e.offsets, u = e.position, s = e.gpuAcceleration, c = e.adaptive, l = e.roundOffsets, f = e.isFixed, d = o.x, p = d === void 0 ? 0 : d, h = o.y, v = h === void 0 ? 0 : h, g = typeof l == "function" ? l({
    x: p,
    y: v
  }) : {
    x: p,
    y: v
  };
  p = g.x, v = g.y;
  var b = o.hasOwnProperty("x"), x = o.hasOwnProperty("y"), w = Bt, y = Lt, m = window;
  if (c) {
    var C = Ko(r), O = "clientHeight", S = "clientWidth";
    if (C === Zt(r) && (C = Cn(r), Xr(C).position !== "static" && u === "absolute" && (O = "scrollHeight", S = "scrollWidth")), C = C, a === Lt || (a === Bt || a === ur) && i === no) {
      y = or;
      var A = f && C === m && m.visualViewport ? m.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        C[O]
      );
      v -= A - n.height, v *= s ? 1 : -1;
    }
    if (a === Bt || (a === Lt || a === or) && i === no) {
      w = ur;
      var P = f && C === m && m.visualViewport ? m.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        C[S]
      );
      p -= P - n.width, p *= s ? 1 : -1;
    }
  }
  var T = Object.assign({
    position: u
  }, c && c9), M = l === !0 ? l9({
    x: p,
    y: v
  }, Zt(r)) : {
    x: p,
    y: v
  };
  if (p = M.x, v = M.y, s) {
    var I;
    return Object.assign({}, T, (I = {}, I[y] = x ? "0" : "", I[w] = b ? "0" : "", I.transform = (m.devicePixelRatio || 1) <= 1 ? "translate(" + p + "px, " + v + "px)" : "translate3d(" + p + "px, " + v + "px, 0)", I));
  }
  return Object.assign({}, T, (t = {}, t[y] = x ? v + "px" : "", t[w] = b ? p + "px" : "", t.transform = "", t));
}
function f9(e) {
  var t = e.state, r = e.options, n = r.gpuAcceleration, a = n === void 0 ? !0 : n, i = r.adaptive, o = i === void 0 ? !0 : i, u = r.roundOffsets, s = u === void 0 ? !0 : u, c = {
    placement: Ir(t.placement),
    variation: Sa(t.placement),
    popper: t.elements.popper,
    popperRect: t.rects.popper,
    gpuAcceleration: a,
    isFixed: t.options.strategy === "fixed"
  };
  t.modifiersData.popperOffsets != null && (t.styles.popper = Object.assign({}, t.styles.popper, ah(Object.assign({}, c, {
    offsets: t.modifiersData.popperOffsets,
    position: t.options.strategy,
    adaptive: o,
    roundOffsets: s
  })))), t.modifiersData.arrow != null && (t.styles.arrow = Object.assign({}, t.styles.arrow, ah(Object.assign({}, c, {
    offsets: t.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: s
  })))), t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-placement": t.placement
  });
}
const d9 = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: f9,
  data: {}
};
var hu = {
  passive: !0
};
function p9(e) {
  var t = e.state, r = e.instance, n = e.options, a = n.scroll, i = a === void 0 ? !0 : a, o = n.resize, u = o === void 0 ? !0 : o, s = Zt(t.elements.popper), c = [].concat(t.scrollParents.reference, t.scrollParents.popper);
  return i && c.forEach(function(l) {
    l.addEventListener("scroll", r.update, hu);
  }), u && s.addEventListener("resize", r.update, hu), function() {
    i && c.forEach(function(l) {
      l.removeEventListener("scroll", r.update, hu);
    }), u && s.removeEventListener("resize", r.update, hu);
  };
}
const h9 = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: p9,
  data: {}
};
var v9 = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function Fu(e) {
  return e.replace(/left|right|bottom|top/g, function(t) {
    return v9[t];
  });
}
var g9 = {
  start: "end",
  end: "start"
};
function ih(e) {
  return e.replace(/start|end/g, function(t) {
    return g9[t];
  });
}
function g1(e) {
  var t = Zt(e), r = t.pageXOffset, n = t.pageYOffset;
  return {
    scrollLeft: r,
    scrollTop: n
  };
}
function m1(e) {
  return Oa(Cn(e)).left + g1(e).scrollLeft;
}
function m9(e, t) {
  var r = Zt(e), n = Cn(e), a = r.visualViewport, i = n.clientWidth, o = n.clientHeight, u = 0, s = 0;
  if (a) {
    i = a.width, o = a.height;
    var c = Jm();
    (c || !c && t === "fixed") && (u = a.offsetLeft, s = a.offsetTop);
  }
  return {
    width: i,
    height: o,
    x: u + m1(e),
    y: s
  };
}
function y9(e) {
  var t, r = Cn(e), n = g1(e), a = (t = e.ownerDocument) == null ? void 0 : t.body, i = Hn(r.scrollWidth, r.clientWidth, a ? a.scrollWidth : 0, a ? a.clientWidth : 0), o = Hn(r.scrollHeight, r.clientHeight, a ? a.scrollHeight : 0, a ? a.clientHeight : 0), u = -n.scrollLeft + m1(e), s = -n.scrollTop;
  return Xr(a || r).direction === "rtl" && (u += Hn(r.clientWidth, a ? a.clientWidth : 0) - i), {
    width: i,
    height: o,
    x: u,
    y: s
  };
}
function y1(e) {
  var t = Xr(e), r = t.overflow, n = t.overflowX, a = t.overflowY;
  return /auto|scroll|overlay|hidden/.test(r + a + n);
}
function ny(e) {
  return ["html", "body", "#document"].indexOf(jr(e)) >= 0 ? e.ownerDocument.body : ir(e) && y1(e) ? e : ny(qs(e));
}
function Hi(e, t) {
  var r;
  t === void 0 && (t = []);
  var n = ny(e), a = n === ((r = e.ownerDocument) == null ? void 0 : r.body), i = Zt(n), o = a ? [i].concat(i.visualViewport || [], y1(n) ? n : []) : n, u = t.concat(o);
  return a ? u : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    u.concat(Hi(qs(o)))
  );
}
function vf(e) {
  return Object.assign({}, e, {
    left: e.x,
    top: e.y,
    right: e.x + e.width,
    bottom: e.y + e.height
  });
}
function b9(e, t) {
  var r = Oa(e, !1, t === "fixed");
  return r.top = r.top + e.clientTop, r.left = r.left + e.clientLeft, r.bottom = r.top + e.clientHeight, r.right = r.left + e.clientWidth, r.width = e.clientWidth, r.height = e.clientHeight, r.x = r.left, r.y = r.top, r;
}
function oh(e, t, r) {
  return t === Km ? vf(m9(e, r)) : Xn(t) ? b9(t, r) : vf(y9(Cn(e)));
}
function x9(e) {
  var t = Hi(qs(e)), r = ["absolute", "fixed"].indexOf(Xr(e).position) >= 0, n = r && ir(e) ? Ko(e) : e;
  return Xn(n) ? t.filter(function(a) {
    return Xn(a) && Qm(a, n) && jr(a) !== "body";
  }) : [];
}
function C9(e, t, r, n) {
  var a = t === "clippingParents" ? x9(e) : [].concat(t), i = [].concat(a, [r]), o = i[0], u = i.reduce(function(s, c) {
    var l = oh(e, c, n);
    return s.top = Hn(l.top, s.top), s.right = Vu(l.right, s.right), s.bottom = Vu(l.bottom, s.bottom), s.left = Hn(l.left, s.left), s;
  }, oh(e, o, n));
  return u.width = u.right - u.left, u.height = u.bottom - u.top, u.x = u.left, u.y = u.top, u;
}
function ay(e) {
  var t = e.reference, r = e.element, n = e.placement, a = n ? Ir(n) : null, i = n ? Sa(n) : null, o = t.x + t.width / 2 - r.width / 2, u = t.y + t.height / 2 - r.height / 2, s;
  switch (a) {
    case Lt:
      s = {
        x: o,
        y: t.y - r.height
      };
      break;
    case or:
      s = {
        x: o,
        y: t.y + t.height
      };
      break;
    case ur:
      s = {
        x: t.x + t.width,
        y: u
      };
      break;
    case Bt:
      s = {
        x: t.x - r.width,
        y: u
      };
      break;
    default:
      s = {
        x: t.x,
        y: t.y
      };
  }
  var c = a ? v1(a) : null;
  if (c != null) {
    var l = c === "y" ? "height" : "width";
    switch (i) {
      case Ca:
        s[c] = s[c] - (t[l] / 2 - r[l] / 2);
        break;
      case no:
        s[c] = s[c] + (t[l] / 2 - r[l] / 2);
        break;
    }
  }
  return s;
}
function ao(e, t) {
  t === void 0 && (t = {});
  var r = t, n = r.placement, a = n === void 0 ? e.placement : n, i = r.strategy, o = i === void 0 ? e.strategy : i, u = r.boundary, s = u === void 0 ? V6 : u, c = r.rootBoundary, l = c === void 0 ? Km : c, f = r.elementContext, d = f === void 0 ? Ci : f, p = r.altBoundary, h = p === void 0 ? !1 : p, v = r.padding, g = v === void 0 ? 0 : v, b = ty(typeof g != "number" ? g : ry(g, Zo)), x = d === Ci ? W6 : Ci, w = e.rects.popper, y = e.elements[h ? x : d], m = C9(Xn(y) ? y : y.contextElement || Cn(e.elements.popper), s, l, o), C = Oa(e.elements.reference), O = ay({
    reference: C,
    element: w,
    strategy: "absolute",
    placement: a
  }), S = vf(Object.assign({}, w, O)), A = d === Ci ? S : C, P = {
    top: m.top - A.top + b.top,
    bottom: A.bottom - m.bottom + b.bottom,
    left: m.left - A.left + b.left,
    right: A.right - m.right + b.right
  }, T = e.modifiersData.offset;
  if (d === Ci && T) {
    var M = T[a];
    Object.keys(P).forEach(function(I) {
      var G = [ur, or].indexOf(I) >= 0 ? 1 : -1, Y = [Lt, or].indexOf(I) >= 0 ? "y" : "x";
      P[I] += M[Y] * G;
    });
  }
  return P;
}
function w9(e, t) {
  t === void 0 && (t = {});
  var r = t, n = r.placement, a = r.boundary, i = r.rootBoundary, o = r.padding, u = r.flipVariations, s = r.allowedAutoPlacements, c = s === void 0 ? qm : s, l = Sa(n), f = l ? u ? rh : rh.filter(function(h) {
    return Sa(h) === l;
  }) : Zo, d = f.filter(function(h) {
    return c.indexOf(h) >= 0;
  });
  d.length === 0 && (d = f);
  var p = d.reduce(function(h, v) {
    return h[v] = ao(e, {
      placement: v,
      boundary: a,
      rootBoundary: i,
      padding: o
    })[Ir(v)], h;
  }, {});
  return Object.keys(p).sort(function(h, v) {
    return p[h] - p[v];
  });
}
function O9(e) {
  if (Ir(e) === d1)
    return [];
  var t = Fu(e);
  return [ih(e), t, ih(t)];
}
function S9(e) {
  var t = e.state, r = e.options, n = e.name;
  if (!t.modifiersData[n]._skip) {
    for (var a = r.mainAxis, i = a === void 0 ? !0 : a, o = r.altAxis, u = o === void 0 ? !0 : o, s = r.fallbackPlacements, c = r.padding, l = r.boundary, f = r.rootBoundary, d = r.altBoundary, p = r.flipVariations, h = p === void 0 ? !0 : p, v = r.allowedAutoPlacements, g = t.options.placement, b = Ir(g), x = b === g, w = s || (x || !h ? [Fu(g)] : O9(g)), y = [g].concat(w).reduce(function($, B) {
      return $.concat(Ir(B) === d1 ? w9(t, {
        placement: B,
        boundary: l,
        rootBoundary: f,
        padding: c,
        flipVariations: h,
        allowedAutoPlacements: v
      }) : B);
    }, []), m = t.rects.reference, C = t.rects.popper, O = /* @__PURE__ */ new Map(), S = !0, A = y[0], P = 0; P < y.length; P++) {
      var T = y[P], M = Ir(T), I = Sa(T) === Ca, G = [Lt, or].indexOf(M) >= 0, Y = G ? "width" : "height", L = ao(t, {
        placement: T,
        boundary: l,
        rootBoundary: f,
        altBoundary: d,
        padding: c
      }), X = G ? I ? ur : Bt : I ? or : Lt;
      m[Y] > C[Y] && (X = Fu(X));
      var q = Fu(X), re = [];
      if (i && re.push(L[M] <= 0), u && re.push(L[X] <= 0, L[q] <= 0), re.every(function($) {
        return $;
      })) {
        A = T, S = !1;
        break;
      }
      O.set(T, re);
    }
    if (S)
      for (var j = h ? 3 : 1, W = function(B) {
        var H = y.find(function(z) {
          var J = O.get(z);
          if (J)
            return J.slice(0, B).every(function(U) {
              return U;
            });
        });
        if (H)
          return A = H, "break";
      }, D = j; D > 0; D--) {
        var R = W(D);
        if (R === "break") break;
      }
    t.placement !== A && (t.modifiersData[n]._skip = !0, t.placement = A, t.reset = !0);
  }
}
const A9 = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: S9,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function uh(e, t, r) {
  return r === void 0 && (r = {
    x: 0,
    y: 0
  }), {
    top: e.top - t.height - r.y,
    right: e.right - t.width + r.x,
    bottom: e.bottom - t.height + r.y,
    left: e.left - t.width - r.x
  };
}
function sh(e) {
  return [Lt, ur, or, Bt].some(function(t) {
    return e[t] >= 0;
  });
}
function E9(e) {
  var t = e.state, r = e.name, n = t.rects.reference, a = t.rects.popper, i = t.modifiersData.preventOverflow, o = ao(t, {
    elementContext: "reference"
  }), u = ao(t, {
    altBoundary: !0
  }), s = uh(o, n), c = uh(u, a, i), l = sh(s), f = sh(c);
  t.modifiersData[r] = {
    referenceClippingOffsets: s,
    popperEscapeOffsets: c,
    isReferenceHidden: l,
    hasPopperEscaped: f
  }, t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-reference-hidden": l,
    "data-popper-escaped": f
  });
}
const _9 = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: E9
};
function I9(e, t, r) {
  var n = Ir(e), a = [Bt, Lt].indexOf(n) >= 0 ? -1 : 1, i = typeof r == "function" ? r(Object.assign({}, t, {
    placement: e
  })) : r, o = i[0], u = i[1];
  return o = o || 0, u = (u || 0) * a, [Bt, ur].indexOf(n) >= 0 ? {
    x: u,
    y: o
  } : {
    x: o,
    y: u
  };
}
function P9(e) {
  var t = e.state, r = e.options, n = e.name, a = r.offset, i = a === void 0 ? [0, 0] : a, o = qm.reduce(function(l, f) {
    return l[f] = I9(f, t.rects, i), l;
  }, {}), u = o[t.placement], s = u.x, c = u.y;
  t.modifiersData.popperOffsets != null && (t.modifiersData.popperOffsets.x += s, t.modifiersData.popperOffsets.y += c), t.modifiersData[n] = o;
}
const T9 = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: P9
};
function M9(e) {
  var t = e.state, r = e.name;
  t.modifiersData[r] = ay({
    reference: t.rects.reference,
    element: t.rects.popper,
    strategy: "absolute",
    placement: t.placement
  });
}
const j9 = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: M9,
  data: {}
};
function R9(e) {
  return e === "x" ? "y" : "x";
}
function N9(e) {
  var t = e.state, r = e.options, n = e.name, a = r.mainAxis, i = a === void 0 ? !0 : a, o = r.altAxis, u = o === void 0 ? !1 : o, s = r.boundary, c = r.rootBoundary, l = r.altBoundary, f = r.padding, d = r.tether, p = d === void 0 ? !0 : d, h = r.tetherOffset, v = h === void 0 ? 0 : h, g = ao(t, {
    boundary: s,
    rootBoundary: c,
    padding: f,
    altBoundary: l
  }), b = Ir(t.placement), x = Sa(t.placement), w = !x, y = v1(b), m = R9(y), C = t.modifiersData.popperOffsets, O = t.rects.reference, S = t.rects.popper, A = typeof v == "function" ? v(Object.assign({}, t.rects, {
    placement: t.placement
  })) : v, P = typeof A == "number" ? {
    mainAxis: A,
    altAxis: A
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, A), T = t.modifiersData.offset ? t.modifiersData.offset[t.placement] : null, M = {
    x: 0,
    y: 0
  };
  if (C) {
    if (i) {
      var I, G = y === "y" ? Lt : Bt, Y = y === "y" ? or : ur, L = y === "y" ? "height" : "width", X = C[y], q = X + g[G], re = X - g[Y], j = p ? -S[L] / 2 : 0, W = x === Ca ? O[L] : S[L], D = x === Ca ? -S[L] : -O[L], R = t.elements.arrow, $ = p && R ? h1(R) : {
        width: 0,
        height: 0
      }, B = t.modifiersData["arrow#persistent"] ? t.modifiersData["arrow#persistent"].padding : ey(), H = B[G], z = B[Y], J = Gi(0, O[L], $[L]), U = w ? O[L] / 2 - j - J - H - P.mainAxis : W - J - H - P.mainAxis, F = w ? -O[L] / 2 + j + J + z + P.mainAxis : D + J + z + P.mainAxis, k = t.elements.arrow && Ko(t.elements.arrow), E = k ? y === "y" ? k.clientTop || 0 : k.clientLeft || 0 : 0, K = (I = T == null ? void 0 : T[y]) != null ? I : 0, Z = X + U - K - E, Q = X + F - K, ne = Gi(p ? Vu(q, Z) : q, X, p ? Hn(re, Q) : re);
      C[y] = ne, M[y] = ne - X;
    }
    if (u) {
      var ue, de = y === "x" ? Lt : Bt, le = y === "x" ? or : ur, pe = C[m], ie = m === "y" ? "height" : "width", Te = pe + g[de], Qe = pe - g[le], Ot = [Lt, Bt].indexOf(b) !== -1, Gt = (ue = T == null ? void 0 : T[m]) != null ? ue : 0, qt = Ot ? Te : pe - O[ie] - S[ie] - Gt + P.altAxis, dr = Ot ? pe + O[ie] + S[ie] - Gt - P.altAxis : Qe, ra = p && Ot ? a9(qt, pe, dr) : Gi(p ? qt : Te, pe, p ? dr : Qe);
      C[m] = ra, M[m] = ra - pe;
    }
    t.modifiersData[n] = M;
  }
}
const $9 = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: N9,
  requiresIfExists: ["offset"]
};
function F9(e) {
  return {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  };
}
function D9(e) {
  return e === Zt(e) || !ir(e) ? g1(e) : F9(e);
}
function k9(e) {
  var t = e.getBoundingClientRect(), r = wa(t.width) / e.offsetWidth || 1, n = wa(t.height) / e.offsetHeight || 1;
  return r !== 1 || n !== 1;
}
function L9(e, t, r) {
  r === void 0 && (r = !1);
  var n = ir(t), a = ir(t) && k9(t), i = Cn(t), o = Oa(e, a, r), u = {
    scrollLeft: 0,
    scrollTop: 0
  }, s = {
    x: 0,
    y: 0
  };
  return (n || !n && !r) && ((jr(t) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  y1(i)) && (u = D9(t)), ir(t) ? (s = Oa(t, !0), s.x += t.clientLeft, s.y += t.clientTop) : i && (s.x = m1(i))), {
    x: o.left + u.scrollLeft - s.x,
    y: o.top + u.scrollTop - s.y,
    width: o.width,
    height: o.height
  };
}
function B9(e) {
  var t = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Set(), n = [];
  e.forEach(function(i) {
    t.set(i.name, i);
  });
  function a(i) {
    r.add(i.name);
    var o = [].concat(i.requires || [], i.requiresIfExists || []);
    o.forEach(function(u) {
      if (!r.has(u)) {
        var s = t.get(u);
        s && a(s);
      }
    }), n.push(i);
  }
  return e.forEach(function(i) {
    r.has(i.name) || a(i);
  }), n;
}
function V9(e) {
  var t = B9(e);
  return J6.reduce(function(r, n) {
    return r.concat(t.filter(function(a) {
      return a.phase === n;
    }));
  }, []);
}
function W9(e) {
  var t;
  return function() {
    return t || (t = new Promise(function(r) {
      Promise.resolve().then(function() {
        t = void 0, r(e());
      });
    })), t;
  };
}
function G9(e) {
  var t = e.reduce(function(r, n) {
    var a = r[n.name];
    return r[n.name] = a ? Object.assign({}, a, n, {
      options: Object.assign({}, a.options, n.options),
      data: Object.assign({}, a.data, n.data)
    }) : n, r;
  }, {});
  return Object.keys(t).map(function(r) {
    return t[r];
  });
}
var ch = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function lh() {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
    t[r] = arguments[r];
  return !t.some(function(n) {
    return !(n && typeof n.getBoundingClientRect == "function");
  });
}
function H9(e) {
  e === void 0 && (e = {});
  var t = e, r = t.defaultModifiers, n = r === void 0 ? [] : r, a = t.defaultOptions, i = a === void 0 ? ch : a;
  return function(u, s, c) {
    c === void 0 && (c = i);
    var l = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, ch, i),
      modifiersData: {},
      elements: {
        reference: u,
        popper: s
      },
      attributes: {},
      styles: {}
    }, f = [], d = !1, p = {
      state: l,
      setOptions: function(b) {
        var x = typeof b == "function" ? b(l.options) : b;
        v(), l.options = Object.assign({}, i, l.options, x), l.scrollParents = {
          reference: Xn(u) ? Hi(u) : u.contextElement ? Hi(u.contextElement) : [],
          popper: Hi(s)
        };
        var w = V9(G9([].concat(n, l.options.modifiers)));
        return l.orderedModifiers = w.filter(function(y) {
          return y.enabled;
        }), h(), p.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!d) {
          var b = l.elements, x = b.reference, w = b.popper;
          if (lh(x, w)) {
            l.rects = {
              reference: L9(x, Ko(w), l.options.strategy === "fixed"),
              popper: h1(w)
            }, l.reset = !1, l.placement = l.options.placement, l.orderedModifiers.forEach(function(P) {
              return l.modifiersData[P.name] = Object.assign({}, P.data);
            });
            for (var y = 0; y < l.orderedModifiers.length; y++) {
              if (l.reset === !0) {
                l.reset = !1, y = -1;
                continue;
              }
              var m = l.orderedModifiers[y], C = m.fn, O = m.options, S = O === void 0 ? {} : O, A = m.name;
              typeof C == "function" && (l = C({
                state: l,
                options: S,
                name: A,
                instance: p
              }) || l);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: W9(function() {
        return new Promise(function(g) {
          p.forceUpdate(), g(l);
        });
      }),
      destroy: function() {
        v(), d = !0;
      }
    };
    if (!lh(u, s))
      return p;
    p.setOptions(c).then(function(g) {
      !d && c.onFirstUpdate && c.onFirstUpdate(g);
    });
    function h() {
      l.orderedModifiers.forEach(function(g) {
        var b = g.name, x = g.options, w = x === void 0 ? {} : x, y = g.effect;
        if (typeof y == "function") {
          var m = y({
            state: l,
            name: b,
            instance: p,
            options: w
          }), C = function() {
          };
          f.push(m || C);
        }
      });
    }
    function v() {
      f.forEach(function(g) {
        return g();
      }), f = [];
    }
    return p;
  };
}
var U9 = [h9, j9, d9, t9, T9, A9, $9, s9, _9], z9 = /* @__PURE__ */ H9({
  defaultModifiers: U9
}), Y9 = typeof Element < "u", X9 = typeof Map == "function", Z9 = typeof Set == "function", K9 = typeof ArrayBuffer == "function" && !!ArrayBuffer.isView;
function Du(e, t) {
  if (e === t) return !0;
  if (e && t && typeof e == "object" && typeof t == "object") {
    if (e.constructor !== t.constructor) return !1;
    var r, n, a;
    if (Array.isArray(e)) {
      if (r = e.length, r != t.length) return !1;
      for (n = r; n-- !== 0; )
        if (!Du(e[n], t[n])) return !1;
      return !0;
    }
    var i;
    if (X9 && e instanceof Map && t instanceof Map) {
      if (e.size !== t.size) return !1;
      for (i = e.entries(); !(n = i.next()).done; )
        if (!t.has(n.value[0])) return !1;
      for (i = e.entries(); !(n = i.next()).done; )
        if (!Du(n.value[1], t.get(n.value[0]))) return !1;
      return !0;
    }
    if (Z9 && e instanceof Set && t instanceof Set) {
      if (e.size !== t.size) return !1;
      for (i = e.entries(); !(n = i.next()).done; )
        if (!t.has(n.value[0])) return !1;
      return !0;
    }
    if (K9 && ArrayBuffer.isView(e) && ArrayBuffer.isView(t)) {
      if (r = e.length, r != t.length) return !1;
      for (n = r; n-- !== 0; )
        if (e[n] !== t[n]) return !1;
      return !0;
    }
    if (e.constructor === RegExp) return e.source === t.source && e.flags === t.flags;
    if (e.valueOf !== Object.prototype.valueOf && typeof e.valueOf == "function" && typeof t.valueOf == "function") return e.valueOf() === t.valueOf();
    if (e.toString !== Object.prototype.toString && typeof e.toString == "function" && typeof t.toString == "function") return e.toString() === t.toString();
    if (a = Object.keys(e), r = a.length, r !== Object.keys(t).length) return !1;
    for (n = r; n-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(t, a[n])) return !1;
    if (Y9 && e instanceof Element) return !1;
    for (n = r; n-- !== 0; )
      if (!((a[n] === "_owner" || a[n] === "__v" || a[n] === "__o") && e.$$typeof) && !Du(e[a[n]], t[a[n]]))
        return !1;
    return !0;
  }
  return e !== e && t !== t;
}
var q9 = function(t, r) {
  try {
    return Du(t, r);
  } catch (n) {
    if ((n.message || "").match(/stack|recursion/i))
      return console.warn("react-fast-compare cannot handle circular refs"), !1;
    throw n;
  }
};
const J9 = /* @__PURE__ */ Fe(q9);
var Q9 = [], e8 = function(t, r, n) {
  n === void 0 && (n = {});
  var a = Ae.useRef(null), i = {
    onFirstUpdate: n.onFirstUpdate,
    placement: n.placement || "bottom",
    strategy: n.strategy || "absolute",
    modifiers: n.modifiers || Q9
  }, o = Ae.useState({
    styles: {
      popper: {
        position: i.strategy,
        left: "0",
        top: "0"
      },
      arrow: {
        position: "absolute"
      }
    },
    attributes: {}
  }), u = o[0], s = o[1], c = Ae.useMemo(function() {
    return {
      name: "updateState",
      enabled: !0,
      phase: "write",
      fn: function(p) {
        var h = p.state, v = Object.keys(h.elements);
        Ym.flushSync(function() {
          s({
            styles: eh(v.map(function(g) {
              return [g, h.styles[g] || {}];
            })),
            attributes: eh(v.map(function(g) {
              return [g, h.attributes[g]];
            }))
          });
        });
      },
      requires: ["computeStyles"]
    };
  }, []), l = Ae.useMemo(function() {
    var d = {
      onFirstUpdate: i.onFirstUpdate,
      placement: i.placement,
      strategy: i.strategy,
      modifiers: [].concat(i.modifiers, [c, {
        name: "applyStyles",
        enabled: !1
      }])
    };
    return J9(a.current, d) ? a.current || d : (a.current = d, d);
  }, [i.onFirstUpdate, i.placement, i.strategy, i.modifiers, c]), f = Ae.useRef();
  return th(function() {
    f.current && f.current.setOptions(l);
  }, [l]), th(function() {
    if (!(t == null || r == null)) {
      var d = n.createPopper || z9, p = d(t, r, l);
      return f.current = p, function() {
        p.destroy(), f.current = null;
      };
    }
  }, [t, r, n.createPopper]), {
    state: f.current ? f.current.state : null,
    styles: u.styles,
    attributes: u.attributes,
    update: f.current ? f.current.update : null,
    forceUpdate: f.current ? f.current.forceUpdate : null
  };
};
const b1 = ({
  label: e,
  referenceElement: t,
  direction: r,
  className: n = ""
}) => {
  const [a, i] = gn(null), [o, u] = gn(null), { styles: s, attributes: c, update: l } = e8(
    t,
    a,
    {
      placement: r,
      strategy: "absolute",
      modifiers: [
        { name: "offset", options: { offset: [0, 12] } },
        { name: "arrow", options: { element: o, padding: 4 } }
      ]
    }
  );
  return Xa(() => {
    const d = new MutationObserver(() => {
      l && l();
    });
    return d.observe(document, { subtree: !0, childList: !0 }), () => d.disconnect();
  }, [l]), /* @__PURE__ */ _.jsx(
    "div",
    {
      className: "input-tooltip__wrapper",
      ref: i,
      style: s.popper,
      ...c.popper,
      children: /* @__PURE__ */ _.jsxs("div", { className: `input-tooltip__content ${n}`, children: [
        e,
        /* @__PURE__ */ _.jsx(
          "div",
          {
            ref: u,
            className: "arrow-container",
            style: s.arrow,
            children: /* @__PURE__ */ _.jsx("div", { className: "arrow" })
          }
        )
      ] })
    }
  );
}, t8 = {
  sm: "small",
  md: "default",
  lg: "large"
}, r8 = ({
  variant: e = "default",
  color: t = "primary",
  size: r = "md",
  children: n,
  disabled: a = !1,
  focused: i = !1,
  iconLeft: o,
  iconRight: u,
  className: s,
  type: c = "button",
  tooltip: l,
  inline: f = !1,
  // only work when the variant is link
  ...d
}) => {
  const p = mr(null), h = t8[r];
  return /* @__PURE__ */ _.jsxs(
    "button",
    {
      className: He("button", `button--${e}`, `button--${r}`, {
        [`button--${t}`]: !!t,
        "button--disabled": a,
        "button--focused": i,
        "button--link--inline": f,
        [`${s}`]: !!s
      }),
      disabled: a,
      type: c,
      ref: p,
      ...d,
      children: [
        o && /* @__PURE__ */ _.jsx("span", { className: "button__icon-left", children: /* @__PURE__ */ _.jsx(o, { fontSize: h }) }),
        /* @__PURE__ */ _.jsx("span", { className: "button__text", children: n }),
        u && /* @__PURE__ */ _.jsx("span", { className: "button__icon-right", children: /* @__PURE__ */ _.jsx(u, { fontSize: h }) }),
        !!l && /* @__PURE__ */ _.jsx("span", { className: He({ "input-tooltip--force-open": !!l }), children: /* @__PURE__ */ _.jsx(b1, { label: l, direction: "top", referenceElement: p.current }) })
      ]
    }
  );
}, Rte = ({
  to: e,
  className: t,
  children: r,
  target: n = "_self",
  variant: a = "default",
  color: i = "primary",
  size: o = "md",
  iconLeft: u,
  iconRight: s,
  inline: c,
  ref: l,
  ...f
}) => {
  const d = [
    "link",
    `link--${a}`,
    `link--${i}`,
    `link--${o}`
  ], p = He(
    {
      [t]: !!t,
      "link--inline": c,
      "link--button": a === "filled" || a === "outlined"
    },
    d
  );
  return /* @__PURE__ */ _.jsxs("a", { className: p, href: e, target: n, ref: l, ...f, children: [
    u && /* @__PURE__ */ _.jsx("span", { className: "link__icon-left", children: /* @__PURE__ */ _.jsx(u, {}) }),
    /* @__PURE__ */ _.jsx("span", { className: "link__text", children: r }),
    s && /* @__PURE__ */ _.jsx("span", { className: "link__icon-right", children: /* @__PURE__ */ _.jsx(s, {}) })
  ] });
}, n8 = ({
  dark: e,
  error: t,
  onChange: r,
  onMax: n,
  className: a,
  value: i,
  ...o
}) => /* @__PURE__ */ _.jsxs(
  "div",
  {
    className: He("input-amount__wrapper", {
      [`${a}`]: !!a,
      "input-amount__wrapper--error": t,
      "input-amount__wrapper--dark": e,
      "input-amount__wrapper--has-max": !!n
    }),
    children: [
      /* @__PURE__ */ _.jsx("div", { className: "input-amount__label", children: /* @__PURE__ */ _.jsx("span", { className: "input-amount__text", children: "$" }) }),
      /* @__PURE__ */ _.jsx(
        "input",
        {
          type: "number",
          value: i,
          className: "input-amount__element",
          onChange: (u) => r && r(u),
          ...o
        }
      ),
      !!n && /* @__PURE__ */ _.jsx("button", { type: "button", className: "input-amount__max", onClick: n, disabled: o.disabled, children: "Max" })
    ]
  }
);
var iy = {
  color: void 0,
  size: void 0,
  className: void 0,
  style: void 0,
  attr: void 0
}, fh = N.createContext && N.createContext(iy), dn = function() {
  return dn = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var a in t) Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
    }
    return e;
  }, dn.apply(this, arguments);
}, a8 = function(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var a = 0, n = Object.getOwnPropertySymbols(e); a < n.length; a++)
    t.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (r[n[a]] = e[n[a]]);
  return r;
};
function oy(e) {
  return e && e.map(function(t, r) {
    return N.createElement(t.tag, dn({
      key: r
    }, t.attr), oy(t.child));
  });
}
function Se(e) {
  return function(t) {
    return N.createElement(i8, dn({
      attr: dn({}, e.attr)
    }, t), oy(e.child));
  };
}
function i8(e) {
  var t = function(r) {
    var n = e.attr, a = e.size, i = e.title, o = a8(e, ["attr", "size", "title"]), u = a || r.size || "1em", s;
    return r.className && (s = r.className), e.className && (s = (s ? s + " " : "") + e.className), N.createElement("svg", dn({
      stroke: "currentColor",
      fill: "currentColor",
      strokeWidth: "0"
    }, r.attr, n, o, {
      className: s,
      style: dn(dn({
        color: e.color || r.color
      }, r.style), e.style),
      height: u,
      width: u,
      xmlns: "http://www.w3.org/2000/svg"
    }), i && N.createElement("title", null, i), e.children);
  };
  return fh !== void 0 ? N.createElement(fh.Consumer, null, function(r) {
    return t(r);
  }) : t(iy);
}
function o8(e) {
  return Se({ tag: "svg", attr: { fill: "currentColor", viewBox: "0 0 16 16" }, child: [{ tag: "path", attr: { d: "M14 1a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H4.414A2 2 0 0 0 3 11.586l-2 2V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12.793a.5.5 0 0 0 .854.353l2.853-2.853A1 1 0 0 1 4.414 12H14a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z" } }, { tag: "path", attr: { d: "M5 6a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm4 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm4 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0z" } }] })(e);
}
function u8(e) {
  return Se({ tag: "svg", attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { fill: "none", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "32", d: "M256 112v288m144-144H112" } }] })(e);
}
function s8(e) {
  return Se({ tag: "svg", attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { fill: "none", strokeMiterlimit: "10", strokeWidth: "32", d: "M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z" } }, { tag: "path", attr: { fill: "none", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "32", d: "M250.26 166.05L256 288l5.73-121.95a5.74 5.74 0 00-5.79-6h0a5.74 5.74 0 00-5.68 6z" } }, { tag: "path", attr: { d: "M256 367.91a20 20 0 1120-20 20 20 0 01-20 20z" } }] })(e);
}
function c8(e) {
  return Se({ tag: "svg", attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { d: "M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm0 319.91a20 20 0 1120-20 20 20 0 01-20 20zm21.72-201.15l-5.74 122a16 16 0 01-32 0l-5.74-121.94v-.05a21.74 21.74 0 1143.44 0z" } }] })(e);
}
function l8(e) {
  return Se({ tag: "svg", attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { fill: "none", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "32", d: "M256 80c-8.66 0-16.58 7.36-16 16l8 216a8 8 0 008 8h0a8 8 0 008-8l8-216c.58-8.64-7.34-16-16-16z" } }, { tag: "circle", attr: { cx: "256", cy: "416", r: "16", fill: "none", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "32" } }] })(e);
}
function f8(e) {
  return Se({ tag: "svg", attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { fill: "none", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "32", d: "M176 262.62L256 342l80-79.38m-80 68.35V170" } }, { tag: "path", attr: { fill: "none", strokeMiterlimit: "10", strokeWidth: "32", d: "M256 64C150 64 64 150 64 256s86 192 192 192 192-86 192-192S362 64 256 64z" } }] })(e);
}
function d8(e) {
  return Se({ tag: "svg", attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { d: "M76.83 480a25.69 25.69 0 01-25.57-25.74 29.13 29.13 0 011.2-7.63L70.88 380c.77-2.46-.1-4.94-1.23-6.9l-.22-.4c-.08-.13-.46-.66-.73-1.05s-.58-.81-.86-1.22l-.19-.27A215.66 215.66 0 0132 251.37c-.18-57.59 22.35-112 63.46-153.28C138 55.47 194.9 32 255.82 32A227.4 227.4 0 01398 81.84c39.45 31.75 66.87 76 77.21 124.68a213.5 213.5 0 014.78 45c0 58.93-22.64 114.28-63.76 155.87-41.48 42-97.18 65.06-156.83 65.06-21 0-47.87-5.36-60.77-9-15.52-4.34-30.23-10-31.85-10.6a15.12 15.12 0 00-5.37-1 14.75 14.75 0 00-5.8 1.15l-.85.33-67.48 24.38A29.44 29.44 0 0176.83 480zm-2-31.8zM87.48 380z" } }] })(e);
}
function p8(e) {
  return Se({ tag: "svg", attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { fill: "none", strokeMiterlimit: "10", strokeWidth: "32", d: "M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z" } }, { tag: "path", attr: { fill: "none", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "32", d: "M352 176L217.6 336 160 272" } }] })(e);
}
function h8(e) {
  return Se({ tag: "svg", attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { d: "M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm108.25 138.29l-134.4 160a16 16 0 01-12 5.71h-.27a16 16 0 01-11.89-5.3l-57.6-64a16 16 0 1123.78-21.4l45.29 50.32 122.59-145.91a16 16 0 0124.5 20.58z" } }] })(e);
}
function v8(e) {
  return Se({ tag: "svg", attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { fill: "none", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "48", d: "M328 112L184 256l144 144" } }] })(e);
}
function g8(e) {
  return Se({ tag: "svg", attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { fill: "none", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "48", d: "M112 184l144 144 144-144" } }] })(e);
}
function m8(e) {
  return Se({ tag: "svg", attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { fill: "none", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "48", d: "M184 112l144 144-144 144" } }] })(e);
}
function y8(e) {
  return Se({ tag: "svg", attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { fill: "none", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "48", d: "M112 328l144-144 144 144" } }] })(e);
}
function b8(e) {
  return Se({ tag: "svg", attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { fill: "none", strokeMiterlimit: "10", strokeWidth: "32", d: "M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z" } }, { tag: "path", attr: { fill: "none", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "32", d: "M320 320L192 192m0 128l128-128" } }] })(e);
}
function x8(e) {
  return Se({ tag: "svg", attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { d: "M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm75.31 260.69a16 16 0 11-22.62 22.62L256 278.63l-52.69 52.68a16 16 0 01-22.62-22.62L233.37 256l-52.68-52.69a16 16 0 0122.62-22.62L256 233.37l52.69-52.68a16 16 0 0122.62 22.62L278.63 256z" } }] })(e);
}
function C8(e) {
  return Se({ tag: "svg", attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { d: "M289.94 256l95-95A24 24 0 00351 127l-95 95-95-95a24 24 0 00-34 34l95 95-95 95a24 24 0 1034 34l95-95 95 95a24 24 0 0034-34z" } }] })(e);
}
function w8(e) {
  return Se({ tag: "svg", attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { d: "M256 464c-114.69 0-208-93.31-208-208S141.31 48 256 48s208 93.31 208 208-93.31 208-208 208z" } }] })(e);
}
function O8(e) {
  return Se({ tag: "svg", attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { fill: "none", strokeLinecap: "round", strokeMiterlimit: "10", strokeWidth: "32", d: "M320 146s24.36-12-64-12a160 160 0 10160 160" } }, { tag: "path", attr: { fill: "none", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "32", d: "M256 58l80 80-80 80" } }] })(e);
}
function S8(e) {
  return Se({ tag: "svg", attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { fill: "none", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "32", d: "M400 256H112" } }] })(e);
}
function A8(e) {
  return Se({ tag: "svg", attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { fill: "none", strokeMiterlimit: "10", strokeWidth: "32", d: "M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z" } }, { tag: "path", attr: { fill: "none", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "32", d: "M351.82 271.87v-16A96.15 96.15 0 00184.09 192m-24.2 48.17v16A96.22 96.22 0 00327.81 320" } }, { tag: "path", attr: { fill: "none", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "32", d: "M135.87 256l23.59-23.6 24.67 23.6m192 0l-23.59 23.6-24.67-23.6" } }] })(e);
}
function E8(e) {
  return Se({ tag: "svg", attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { d: "M256 48C141.13 48 48 141.13 48 256s93.13 208 208 208 208-93.13 208-208S370.87 48 256 48zm83.69 282.65a112.24 112.24 0 01-195-61.29 16 16 0 01-20.13-24.67l23.6-23.6a16 16 0 0122.37-.25l24.67 23.6a16 16 0 01-18 26 80.25 80.25 0 00138.72 38.83 16 16 0 0123.77 21.41zm47.76-63.34l-23.6 23.6a16 16 0 01-22.37.25l-24.67-23.6a16 16 0 0117.68-26.11A80.17 80.17 0 00196 202.64a16 16 0 11-23.82-21.37 112.17 112.17 0 01194.88 61.57 16 16 0 0120.39 24.47z" } }] })(e);
}
function _8(e) {
  return Se({ tag: "svg", attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { fill: "none", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "32", d: "M434.67 285.59v-29.8c0-98.73-80.24-178.79-179.2-178.79a179 179 0 00-140.14 67.36m-38.53 82v29.8C76.8 355 157 435 256 435a180.45 180.45 0 00140-66.92" } }, { tag: "path", attr: { fill: "none", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "32", d: "M32 256l44-44 46 44m358 0l-44 44-46-44" } }] })(e);
}
function I8(e) {
  return Se({ tag: "svg", attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { d: "M368.005 272h-96v96h96v-96zm-32-208v32h-160V64h-48v32h-24.01c-22.002 0-40 17.998-40 40v272c0 22.002 17.998 40 40 40h304.01c22.002 0 40-17.998 40-40V136c0-22.002-17.998-40-40-40h-24V64h-48zm72 344h-304.01V196h304.01v212z" } }] })(e);
}
function P8(e) {
  return Se({ tag: "svg", attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { d: "M256 48C141.2 48 48 141.2 48 256s93.2 208 208 208 208-93.2 208-208S370.8 48 256 48zm21 312h-42V235h42v125zm0-166h-42v-42h42v42z" } }] })(e);
}
function T8(e) {
  return Se({ tag: "svg", attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { d: "M437.332 80H74.668C51.199 80 32 99.198 32 122.667v266.666C32 412.802 51.199 432 74.668 432h362.664C460.801 432 480 412.802 480 389.333V122.667C480 99.198 460.801 80 437.332 80zM432 170.667L256 288 80 170.667V128l176 117.333L432 128v42.667z" } }] })(e);
}
function M8(e) {
  return Se({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { d: "M5.82843 6.99955L8.36396 9.53509L6.94975 10.9493L2 5.99955L6.94975 1.0498L8.36396 2.46402L5.82843 4.99955H13C17.4183 4.99955 21 8.58127 21 12.9996C21 17.4178 17.4183 20.9996 13 20.9996H4V18.9996H13C16.3137 18.9996 19 16.3133 19 12.9996C19 9.68584 16.3137 6.99955 13 6.99955H5.82843Z" } }] })(e);
}
function j8(e) {
  return Se({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { d: "M12.8995 6.85431L17.1421 11.0969L7.24264 20.9964H3V16.7538L12.8995 6.85431ZM14.3137 5.44009L16.435 3.31877C16.8256 2.92825 17.4587 2.92825 17.8492 3.31877L20.6777 6.1472C21.0682 6.53772 21.0682 7.17089 20.6777 7.56141L18.5563 9.68273L14.3137 5.44009Z" } }] })(e);
}
function R8(e) {
  return Se({ tag: "svg", attr: { viewBox: "0 0 20 20", fill: "currentColor", "aria-hidden": "true" }, child: [{ tag: "path", attr: { d: "M11 3a1 1 0 10-2 0v1a1 1 0 102 0V3zM15.657 5.757a1 1 0 00-1.414-1.414l-.707.707a1 1 0 001.414 1.414l.707-.707zM18 10a1 1 0 01-1 1h-1a1 1 0 110-2h1a1 1 0 011 1zM5.05 6.464A1 1 0 106.464 5.05l-.707-.707a1 1 0 00-1.414 1.414l.707.707zM5 10a1 1 0 01-1 1H3a1 1 0 110-2h1a1 1 0 011 1zM8 16v-1h4v1a2 2 0 11-4 0zM12 14c.015-.34.208-.646.477-.859a4 4 0 10-4.954 0c.27.213.462.519.476.859h4.002z" } }] })(e);
}
function N8(e) {
  return Se({ tag: "svg", attr: { viewBox: "0 0 20 20", fill: "currentColor", "aria-hidden": "true" }, child: [{ tag: "path", attr: { d: "M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" } }] })(e);
}
function $8(e) {
  return Se({ tag: "svg", attr: { fill: "none", viewBox: "0 0 24 24", strokeWidth: "2", stroke: "currentColor", "aria-hidden": "true" }, child: [{ tag: "path", attr: { strokeLinecap: "round", strokeLinejoin: "round", d: "M7 16l-4-4m0 0l4-4m-4 4h18" } }] })(e);
}
function F8(e) {
  return Se({ tag: "svg", attr: { fill: "none", viewBox: "0 0 24 24", strokeWidth: "2", stroke: "currentColor", "aria-hidden": "true" }, child: [{ tag: "path", attr: { strokeLinecap: "round", strokeLinejoin: "round", d: "M17 8l4 4m0 0l-4 4m4-4H3" } }] })(e);
}
function D8(e) {
  return Se({ tag: "svg", attr: { fill: "none", viewBox: "0 0 24 24", strokeWidth: "2", stroke: "currentColor", "aria-hidden": "true" }, child: [{ tag: "path", attr: { strokeLinecap: "round", strokeLinejoin: "round", d: "M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" } }] })(e);
}
function k8(e) {
  return Se({ tag: "svg", attr: { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, child: [{ tag: "path", attr: { d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" } }, { tag: "polyline", attr: { points: "7 10 12 15 17 10" } }, { tag: "line", attr: { x1: "12", y1: "15", x2: "12", y2: "3" } }] })(e);
}
function L8(e) {
  return Se({ tag: "svg", attr: { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, child: [{ tag: "path", attr: { d: "M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" } }, { tag: "polyline", attr: { points: "16 17 21 12 16 7" } }, { tag: "line", attr: { x1: "21", y1: "12", x2: "9", y2: "12" } }] })(e);
}
function B8(e) {
  return Se({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { d: "M13.22 19.03a.75.75 0 0 1 0-1.06L18.19 13H3.75a.75.75 0 0 1 0-1.5h14.44l-4.97-4.97a.749.749 0 0 1 .326-1.275.749.749 0 0 1 .734.215l6.25 6.25a.75.75 0 0 1 0 1.06l-6.25 6.25a.75.75 0 0 1-1.06 0Z" } }] })(e);
}
function V8(e) {
  return Se({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { d: "M18.655 10.405a.75.75 0 0 1-1.06 0l-4.97-4.97v14.44a.75.75 0 0 1-1.5 0V5.435l-4.97 4.97a.749.749 0 0 1-1.275-.326.749.749 0 0 1 .215-.734l6.25-6.25a.75.75 0 0 1 1.06 0l6.25 6.25a.75.75 0 0 1 0 1.06Z" } }] })(e);
}
function W8(e) {
  return Se({ tag: "svg", attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { d: "M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z" } }] })(e);
}
function G8(e) {
  return Se({ tag: "svg", attr: { viewBox: "0 0 1024 1024" }, child: [{ tag: "path", attr: { d: "M912 190h-69.9c-9.8 0-19.1 4.5-25.1 12.2L404.7 724.5 207 474a32 32 0 0 0-25.1-12.2H112c-6.7 0-10.4 7.7-6.3 12.9l273.9 347c12.8 16.2 37.4 16.2 50.3 0l488.4-618.9c4.1-5.1.4-12.8-6.3-12.8z" } }] })(e);
}
function H8(e) {
  return Se({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" } }, { tag: "path", attr: { d: "M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z" } }] })(e);
}
function U8(e) {
  return Se({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" } }, { tag: "path", attr: { d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" } }] })(e);
}
function z8(e) {
  return Se({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" } }, { tag: "path", attr: { d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10h5v-2h-5c-4.34 0-8-3.66-8-8s3.66-8 8-8 8 3.66 8 8v1.43c0 .79-.71 1.57-1.5 1.57s-1.5-.78-1.5-1.57V12c0-2.76-2.24-5-5-5s-5 2.24-5 5 2.24 5 5 5c1.38 0 2.64-.56 3.54-1.47.65.89 1.77 1.47 2.96 1.47 1.97 0 3.5-1.6 3.5-3.57V12c0-5.52-4.48-10-10-10zm0 13c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z" } }] })(e);
}
function Y8(e) {
  return Se({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" } }, { tag: "path", attr: { d: "M9 5v2h6.59L4 18.59 5.41 20 17 8.41V15h2V5z" } }] })(e);
}
var Ee = /* @__PURE__ */ ((e) => (e["2xs"] = "0.5rem", e.xs = "0.8rem", e.sm = "1rem", e.md = "1.3rem", e.lg = "2rem", e.xl = "2.7rem", e))(Ee || {});
const Nte = ({
  size: e = "md",
  focusable: t = !1,
  ...r
}) => /* @__PURE__ */ _.jsx(
  H8,
  {
    size: Ee[e],
    focusable: t,
    ...r
  }
), $te = ({
  size: e = "md",
  focusable: t = !1,
  ...r
}) => /* @__PURE__ */ _.jsx(
  E8,
  {
    size: Ee[e],
    focusable: t,
    ...r
  }
), dh = ({
  size: e = "md",
  focusable: t = !1,
  ...r
}) => /* @__PURE__ */ _.jsx(
  U8,
  {
    size: Ee[e],
    focusable: t,
    ...r
  }
), Wu = ({
  size: e = "md",
  focusable: t = !1,
  ...r
}) => /* @__PURE__ */ _.jsx(
  P8,
  {
    focusable: t,
    size: Ee[e],
    color: "#003B70",
    ...r
  }
), Fte = ({
  size: e = "md",
  focusable: t = !1,
  ...r
}) => /* @__PURE__ */ _.jsx(
  c8,
  {
    size: Ee[e],
    focusable: t,
    ...r
  }
), Dte = ({
  size: e = "md",
  focusable: t = !1,
  ...r
}) => /* @__PURE__ */ _.jsx(
  l8,
  {
    size: Ee[e],
    focusable: t,
    ...r
  }
), kte = ({
  size: e = "md",
  focusable: t = !1,
  ...r
}) => /* @__PURE__ */ _.jsx(
  x8,
  {
    size: Ee[e],
    focusable: t,
    ...r
  }
), X8 = ({
  size: e = "md",
  focusable: t = !1,
  ...r
}) => /* @__PURE__ */ _.jsx(
  h8,
  {
    size: Ee[e],
    focusable: t,
    ...r
  }
), Lte = ({
  size: e = "md",
  focusable: t = !1,
  ...r
}) => /* @__PURE__ */ _.jsx(
  A8,
  {
    size: Ee[e],
    focusable: t,
    ...r
  }
), Bte = ({
  size: e = "md",
  focusable: t = !1,
  ...r
}) => /* @__PURE__ */ _.jsx(
  s8,
  {
    size: Ee[e],
    focusable: t,
    ...r
  }
), Vte = ({
  size: e = "md",
  focusable: t = !1,
  ...r
}) => /* @__PURE__ */ _.jsx(
  b8,
  {
    size: Ee[e],
    focusable: t,
    ...r
  }
), Z8 = ({
  size: e = "md",
  focusable: t = !1,
  ...r
}) => /* @__PURE__ */ _.jsx(
  C8,
  {
    size: Ee[e],
    focusable: t,
    ...r
  }
), Wte = ({
  size: e = "md",
  focusable: t = !1,
  ...r
}) => /* @__PURE__ */ _.jsx(
  p8,
  {
    size: Ee[e],
    focusable: t,
    ...r
  }
), Gte = ({
  size: e = "sm",
  focusable: t = !1,
  ...r
}) => /* @__PURE__ */ _.jsx(
  m8,
  {
    size: Ee[e],
    focusable: t,
    ...r
  }
), Hte = ({
  size: e = "sm",
  focusable: t = !1,
  ...r
}) => /* @__PURE__ */ _.jsx(
  B8,
  {
    size: Ee[e],
    focusable: t,
    ...r
  }
), Ute = ({
  size: e = "sm",
  focusable: t = !1,
  ...r
}) => /* @__PURE__ */ _.jsx(
  V8,
  {
    size: Ee[e],
    focusable: t,
    ...r
  }
), zte = ({ size: e = "md", ...t }) => /* @__PURE__ */ _.jsx(v8, { size: Ee[e], ...t }), Yte = ({
  size: e = "md",
  focusable: t = !1,
  ...r
}) => /* @__PURE__ */ _.jsx(
  o8,
  {
    size: Ee[e],
    focusable: t,
    ...r
  }
), Xte = ({
  size: e = "md",
  focusable: t = !1,
  ...r
}) => /* @__PURE__ */ _.jsx(
  d8,
  {
    size: Ee[e],
    focusable: t,
    ...r
  }
), Zte = ({
  size: e = "md",
  focusable: t = !1,
  ...r
}) => /* @__PURE__ */ _.jsx(
  u8,
  {
    size: Ee[e],
    focusable: t,
    ...r
  }
), Kte = ({
  size: e = "md",
  focusable: t = !1,
  ...r
}) => /* @__PURE__ */ _.jsx(
  S8,
  {
    size: Ee[e],
    focusable: t,
    ...r
  }
), qte = ({
  size: e = "md",
  focusable: t = !1,
  ...r
}) => /* @__PURE__ */ _.jsx(
  _8,
  {
    size: Ee[e],
    focusable: t,
    ...r
  }
), Jte = ({
  size: e = "md",
  focusable: t = !1,
  ...r
}) => /* @__PURE__ */ _.jsx(
  f8,
  {
    size: Ee[e],
    focusable: t,
    ...r
  }
), Qte = ({ ...e }) => /* @__PURE__ */ _.jsx(M8, { ...e }), uy = ({
  size: e = "md",
  focusable: t = !1,
  ...r
}) => /* @__PURE__ */ _.jsx(
  g8,
  {
    size: Ee[e],
    focusable: t,
    ...r
  }
), ere = ({
  size: e = "md",
  focusable: t = !1,
  ...r
}) => /* @__PURE__ */ _.jsx(
  y8,
  {
    size: Ee[e],
    focusable: t,
    ...r
  }
), tre = ({
  size: e = "md",
  focusable: t = !1,
  ...r
}) => /* @__PURE__ */ _.jsx(
  O8,
  {
    size: Ee[e],
    focusable: t,
    ...r
  }
), rre = ({
  size: e = "md",
  focusable: t = !1,
  ...r
}) => /* @__PURE__ */ _.jsx(
  w8,
  {
    size: Ee[e],
    focusable: t,
    ...r
  }
), nre = ({
  size: e = "md",
  focusable: t = !1,
  ...r
}) => /* @__PURE__ */ _.jsx(
  R8,
  {
    size: Ee[e],
    focusable: t,
    ...r
  }
), are = ({
  size: e = "md",
  focusable: t = !1,
  ...r
}) => /* @__PURE__ */ _.jsx(
  I8,
  {
    size: Ee[e],
    focusable: t,
    ...r
  }
), ire = ({
  size: e = "md",
  focusable: t = !1,
  ...r
}) => /* @__PURE__ */ _.jsx(
  k8,
  {
    size: Ee[e],
    focusable: t,
    ...r
  }
), ore = ({
  size: e = "md",
  focusable: t = !1,
  ...r
}) => /* @__PURE__ */ _.jsx(
  j8,
  {
    size: Ee[e],
    focusable: t,
    ...r
  }
), ure = ({
  size: e = "md",
  focusable: t = !1,
  ...r
}) => /* @__PURE__ */ _.jsx(
  W8,
  {
    size: Ee[e],
    focusable: t,
    ...r
  }
), sre = ({
  size: e = "md",
  focusable: t = !1,
  ...r
}) => /* @__PURE__ */ _.jsx(
  D8,
  {
    size: Ee[e],
    focusable: t,
    ...r
  }
), cre = ({
  size: e = "md",
  focusable: t = !1,
  ...r
}) => /* @__PURE__ */ _.jsx(
  G8,
  {
    size: Ee[e],
    focusable: t,
    ...r
  }
), lre = ({
  size: e = "md",
  focusable: t = !1,
  ...r
}) => /* @__PURE__ */ _.jsx(
  L8,
  {
    size: Ee[e],
    focusable: t,
    ...r
  }
), fre = ({
  size: e = "md",
  focusable: t = !1,
  ...r
}) => /* @__PURE__ */ _.jsx(
  z8,
  {
    size: Ee[e],
    focusable: t,
    ...r
  }
), dre = ({
  size: e = "md",
  focusable: t = !1,
  ...r
}) => /* @__PURE__ */ _.jsx(
  Y8,
  {
    size: Ee[e],
    focusable: t,
    ...r
  }
), pre = () => /* @__PURE__ */ _.jsx(T8, {}), hre = ({
  size: e = "md",
  focusable: t = !1,
  ...r
}) => /* @__PURE__ */ _.jsx(
  N8,
  {
    size: Ee[e],
    focusable: t,
    ...r
  }
), vre = ({
  size: e = "md",
  focusable: t = !1,
  ...r
}) => /* @__PURE__ */ _.jsx(
  $8,
  {
    size: Ee[e],
    focusable: t,
    ...r
  }
), gre = ({
  size: e = "md",
  focusable: t = !1,
  ...r
}) => /* @__PURE__ */ _.jsx(
  F8,
  {
    size: Ee[e],
    focusable: t,
    ...r
  }
);
var Qr = /* @__PURE__ */ ((e) => (e["2xs"] = "0.5rem", e.xs = "0.8rem", e.sm = "1rem", e.md = "1.3rem", e.lg = "2rem", e.xl = "2.7rem", e["2xl"] = "3.4rem", e))(Qr || {});
const qo = {
  light: {
    fill: "#1B3D6F"
  },
  dark: {
    fill: "white"
  },
  dusk: {
    fill: "#218094"
  }
}, mre = ({
  size: e = "md",
  theme: t = "light",
  ...r
}) => {
  const n = Qr[e], { fill: a } = qo[t];
  return /* @__PURE__ */ _.jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: n,
      height: n,
      viewBox: "0 0 23 23",
      fill: "none",
      ...r,
      children: /* @__PURE__ */ _.jsx(
        "path",
        {
          stroke: a,
          d: "M7.11719 11.65C8.01759 13.5094 9.52112 15.0091 11.3828 15.9047C11.5201 15.9697 11.672 15.9979 11.8235 15.9864C11.975 15.9748 12.1209 15.9241 12.2469 15.8391L14.9813 14.0125C15.1021 13.9306 15.2417 13.8806 15.387 13.8672C15.5324 13.8538 15.6788 13.8775 15.8125 13.9359L20.9313 16.1344C21.1062 16.2072 21.2524 16.3355 21.3472 16.4995C21.4421 16.6636 21.4804 16.8542 21.4563 17.0422C21.294 18.3085 20.6759 19.4722 19.7177 20.3158C18.7594 21.1593 17.5266 21.6247 16.25 21.625C12.3049 21.625 8.52139 20.0578 5.73179 17.2682C2.94218 14.4786 1.375 10.6951 1.375 6.75001C1.37529 5.47338 1.84073 4.24059 2.68425 3.28233C3.52776 2.32407 4.69154 1.70599 5.95781 1.54376C6.14576 1.51961 6.33643 1.55792 6.50047 1.65279C6.66451 1.74765 6.79281 1.89381 6.86563 2.06876L9.06406 7.19844C9.12123 7.33007 9.14515 7.47374 9.13371 7.6168C9.12226 7.75985 9.07581 7.89789 8.99844 8.01876L7.17188 10.7969C7.09056 10.9225 7.04283 11.0669 7.03325 11.2163C7.02368 11.3657 7.05258 11.515 7.11719 11.65Z",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    }
  );
}, yre = ({
  size: e = "md",
  theme: t = "light",
  ...r
}) => {
  const n = Qr[e], { fill: a } = qo[t];
  return /* @__PURE__ */ _.jsxs(
    "svg",
    {
      viewBox: "0 0 89 89",
      fill: "currentColor",
      width: n,
      height: n,
      ...r,
      children: [
        /* @__PURE__ */ _.jsx("g", { clipPath: "url(#clip0_419_276)", children: /* @__PURE__ */ _.jsx(
          "path",
          {
            d: "M44.29 0C19.87 0 0 19.87 0 44.29C0 68.71 19.87 88.58 44.29 88.58C68.71 88.58 88.58 68.71 88.58 44.29C88.58 19.87 68.71 0 44.29 0ZM21.53 78.08V77.32C21.53 64.77 31.74 54.56 44.29 54.56C56.84 54.56 67.05 64.77 67.05 77.32V78.08C60.55 82.47 52.71 85.04 44.29 85.04C35.87 85.04 28.03 82.47 21.53 78.08ZM32.97 39.67C32.97 33.43 38.05 28.35 44.29 28.35C50.53 28.35 55.61 33.43 55.61 39.67C55.61 45.91 50.53 50.99 44.29 50.99C38.05 50.99 32.97 45.91 32.97 39.67ZM70.52 75.44C69.75 64.52 62.28 55.41 52.21 52.23C56.38 49.59 59.16 44.96 59.16 39.67C59.16 31.47 52.49 24.81 44.29 24.81C36.09 24.81 29.42 31.48 29.42 39.67C29.42 44.96 32.2 49.6 36.37 52.23C26.29 55.42 18.83 64.52 18.06 75.44C9.19 67.96 3.54 56.77 3.54 44.29C3.54 21.82 21.82 3.54 44.29 3.54C66.76 3.54 85.04 21.82 85.04 44.29C85.04 56.78 79.39 67.96 70.52 75.44Z",
            fill: a
          }
        ) }),
        /* @__PURE__ */ _.jsx("defs", { children: /* @__PURE__ */ _.jsx("clipPath", { id: "clip0_419_276", children: /* @__PURE__ */ _.jsx("rect", { width: "88.58", height: "88.58", fill: "white" }) }) })
      ]
    }
  );
}, bre = ({
  size: e = "md",
  theme: t = "light",
  ...r
}) => {
  const n = Qr[e], { fill: a } = qo[t];
  return /* @__PURE__ */ _.jsxs(
    "svg",
    {
      viewBox: "0 0 83 69",
      fill: "none",
      width: n,
      height: n,
      ...r,
      children: [
        /* @__PURE__ */ _.jsxs("g", { clipPath: "url(#clip0_443_627)", children: [
          /* @__PURE__ */ _.jsx(
            "path",
            {
              d: "M7.06 46.86C3.17 46.86 0 43.67 0 39.75V23.39C0 19.47 3.17 16.28 7.06 16.28H33.86V25.17H29.86V20.28H7.06C5.37 20.28 4 21.68 4 23.39V39.75C4 41.47 5.37 42.86 7.06 42.86V46.86Z",
              fill: a
            }
          ),
          /* @__PURE__ */ _.jsx(
            "path",
            {
              d: "M33.8701 46.86H7.06006V42.86H29.8701V25.21H33.8701V46.86Z",
              fill: a
            }
          ),
          /* @__PURE__ */ _.jsx(
            "path",
            {
              d: "M59.9899 63.13L30.8799 46.6L32.8499 43.12L55.9899 56.25V6.87L32.8499 20.01L30.8799 16.53L59.9899 0V63.13Z",
              fill: a
            }
          ),
          /* @__PURE__ */ _.jsx(
            "path",
            {
              d: "M12.6299 68.08C10.7399 68.08 8.90992 67.47 7.36992 66.31L1.66992 62L9.66992 51.42L12.8599 53.83L7.27992 61.22L9.78992 63.12C10.7999 63.88 12.0399 64.21 13.2999 64.04C14.5499 63.87 15.6699 63.21 16.4299 62.2L29.1799 45.23L32.3799 47.63L19.6199 64.6C18.2099 66.47 16.1599 67.67 13.8399 67.99C13.4299 68.05 13.0299 68.07 12.6199 68.07L12.6299 68.08Z",
              fill: a
            }
          ),
          /* @__PURE__ */ _.jsx(
            "path",
            {
              d: "M82.1702 29.56H69.4902V33.56H79.0002L82.1702 29.56Z",
              fill: a
            }
          ),
          /* @__PURE__ */ _.jsx(
            "path",
            {
              d: "M74.9002 12.6L65.9302 21.57L68.7602 24.4L75.4902 17.67L74.9002 12.6Z",
              fill: a
            }
          ),
          /* @__PURE__ */ _.jsx(
            "path",
            {
              d: "M74.9002 50.52L65.9302 41.55L68.7602 38.72L75.4902 45.45L74.9002 50.52Z",
              fill: a
            }
          ),
          /* @__PURE__ */ _.jsx(
            "path",
            {
              d: "M2.58984 60.67L9.75984 51.23L15.1998 51.21L5.93984 63.31",
              fill: a
            }
          )
        ] }),
        /* @__PURE__ */ _.jsx("defs", { children: /* @__PURE__ */ _.jsx("clipPath", { id: "clip0_443_627", children: /* @__PURE__ */ _.jsx("rect", { width: "82.17", height: "68.08", fill: "white" }) }) })
      ]
    }
  );
}, xre = ({
  size: e = "md",
  theme: t = "light",
  ...r
}) => {
  const n = Qr[e];
  return /* @__PURE__ */ _.jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: n,
      height: n,
      ...r,
      viewBox: "0 0 55 49",
      fill: "none",
      children: [
        /* @__PURE__ */ _.jsxs("g", { "clip-path": "url(#clip0_4063_1032)", children: [
          /* @__PURE__ */ _.jsx("path", { d: "M43.4211 48.9001H24.4437V29.4269H17.1056V48.9001H11.0071C8.38543 48.9001 6.25342 46.7681 6.25342 44.1464V22.3429L27.0034 7.07788L48.1748 22.3305V44.1402C48.1748 46.7619 46.0428 48.8939 43.4211 48.8939V48.9001ZM26.9228 46.421H43.4211C44.6731 46.421 45.6957 45.3984 45.6957 44.1464V23.6072L27.0158 10.1519L8.72631 23.601V44.1526C8.72631 45.4046 9.74893 46.4272 11.0009 46.4272H14.6203V26.954H26.9166V46.4272L26.9228 46.421Z", fill: "#1B3E6F" }),
          /* @__PURE__ */ _.jsx("path", { d: "M3.58849 20.2356L2.11963 18.2337L27.0035 0L51.3047 17.521L49.8545 19.529L27.0159 3.06787L3.58849 20.2356Z", fill: "#1B3E6F" }),
          /* @__PURE__ */ _.jsx("path", { d: "M41.7231 37.7441H31.187V27.208H41.7231V37.7441ZM33.6661 35.265H39.244V29.6871H33.6661V35.265Z", fill: "#80CCB4" }),
          /* @__PURE__ */ _.jsx("path", { d: "M54.4469 19.6962L49.3214 16.1016L47.9021 18.1344L51.7447 20.8242L54.4469 19.6962Z", fill: "#1B3E6F" }),
          /* @__PURE__ */ _.jsx("path", { d: "M0 19.6962L5.12551 16.1016L6.55099 18.1344L2.70221 20.8242L0 19.6962Z", fill: "#1B3E6F" })
        ] }),
        /* @__PURE__ */ _.jsx("defs", { children: /* @__PURE__ */ _.jsx("clipPath", { id: "clip0_4063_1032", children: /* @__PURE__ */ _.jsx("rect", { width: "54.447", height: "48.9", fill: "white" }) }) })
      ]
    }
  );
}, Cre = ({
  size: e = "md",
  theme: t = "light",
  ...r
}) => {
  const n = Qr[e], { fill: a } = qo[t];
  return /* @__PURE__ */ _.jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: n,
      height: n,
      ...r,
      viewBox: "0 0 22 22",
      fill: "none",
      children: [
        /* @__PURE__ */ _.jsxs("g", { clipPath: "url(#clip0_1059_1841)", children: [
          /* @__PURE__ */ _.jsx(
            "path",
            {
              d: "M11 0C8.82441 0 6.69767 0.645139 4.88873 1.85383C3.07979 3.06253 1.66989 4.7805 0.83733 6.79048C0.00476615 8.80047 -0.213071 11.0122 0.211367 13.146C0.635804 15.2798 1.68345 17.2398 3.22183 18.7782C4.76021 20.3166 6.72022 21.3642 8.85401 21.7886C10.9878 22.2131 13.1995 21.9952 15.2095 21.1627C17.2195 20.3301 18.9375 18.9202 20.1462 17.1113C21.3549 15.3023 22 13.1756 22 11C21.9969 8.08359 20.8369 5.28753 18.7747 3.22531C16.7125 1.16309 13.9164 0.00315432 11 0ZM11 20.1667C9.18701 20.1667 7.41473 19.6291 5.90728 18.6218C4.39983 17.6146 3.22491 16.1829 2.53111 14.5079C1.83731 12.8329 1.65578 10.9898 2.00947 9.21167C2.36317 7.43351 3.23621 5.80017 4.51819 4.51819C5.80017 3.23621 7.43352 2.36317 9.21168 2.00947C10.9898 1.65577 12.8329 1.8373 14.5079 2.5311C16.1829 3.22491 17.6146 4.39982 18.6218 5.90727C19.6291 7.41472 20.1667 9.18701 20.1667 11C20.164 13.4303 19.1974 15.7604 17.4789 17.4789C15.7604 19.1974 13.4303 20.164 11 20.1667Z",
              fill: a
            }
          ),
          /* @__PURE__ */ _.jsx(
            "path",
            {
              d: "M11.6572 4.64108C11.1286 4.54477 10.5852 4.56581 10.0656 4.70272C9.54606 4.83963 9.06292 5.08906 8.6504 5.43336C8.23789 5.77766 7.90609 6.20842 7.67848 6.69515C7.45087 7.18188 7.33301 7.71268 7.33325 8.25C7.33325 8.49311 7.42983 8.72627 7.60174 8.89818C7.77365 9.07009 8.0068 9.16667 8.24992 9.16667C8.49303 9.16667 8.72619 9.07009 8.8981 8.89818C9.07001 8.72627 9.16659 8.49311 9.16659 8.25C9.16635 7.98029 9.22563 7.71386 9.3402 7.46969C9.45476 7.22553 9.62178 7.00965 9.82935 6.83744C10.0369 6.66524 10.2799 6.54095 10.5411 6.47345C10.8022 6.40595 11.075 6.39689 11.34 6.44692C11.7021 6.51721 12.0351 6.69385 12.2963 6.95428C12.5576 7.21471 12.7352 7.5471 12.8067 7.909C12.8788 8.28887 12.829 8.68182 12.6644 9.03167C12.4997 9.38153 12.2287 9.67038 11.89 9.85692C11.3443 10.1389 10.8869 10.566 10.5681 11.0911C10.2494 11.6162 10.0816 12.219 10.0833 12.8333C10.0842 12.9516 10.1088 13.0685 10.1557 13.1772C10.2025 13.2858 10.2707 13.3839 10.3562 13.4657C10.4417 13.5475 10.5427 13.6113 10.6532 13.6533C10.7638 13.6954 10.8817 13.7149 10.9999 13.7106C11.2471 13.7013 11.4809 13.5963 11.652 13.4176C11.8231 13.239 11.918 13.0009 11.9166 12.7536C11.929 12.4815 12.0148 12.2179 12.1649 11.9907C12.315 11.7635 12.5237 11.5811 12.7691 11.4629C13.4332 11.0981 13.968 10.5366 14.3 9.85545C14.6319 9.17432 14.7447 8.40708 14.6228 7.65923C14.5009 6.91138 14.1504 6.21967 13.6193 5.6792C13.0882 5.13874 12.4028 4.77607 11.6572 4.64108Z",
              fill: "#218094"
            }
          ),
          /* @__PURE__ */ _.jsx(
            "path",
            {
              d: "M11.0184 15.5833H11.0092C10.7653 15.5845 10.5318 15.6825 10.3599 15.8556C10.1881 16.0287 10.0919 16.2629 10.0925 16.5069C10.0931 16.7508 10.1905 16.9845 10.3632 17.1568C10.5359 17.3291 10.7698 17.4258 11.0138 17.4258C11.2577 17.4258 11.4917 17.3291 11.6644 17.1568C11.8371 16.9845 11.9344 16.7508 11.935 16.5069C11.9356 16.2629 11.8395 16.0287 11.6676 15.8556C11.4958 15.6825 11.2623 15.5845 11.0184 15.5833Z",
              fill: "#218094"
            }
          )
        ] }),
        /* @__PURE__ */ _.jsx("defs", { children: /* @__PURE__ */ _.jsx("clipPath", { id: "clip0_1059_1841", children: /* @__PURE__ */ _.jsx("rect", { width: "22", height: "22", fill: "white" }) }) })
      ]
    }
  );
}, wre = ({
  size: e = "md",
  theme: t = "light",
  ...r
}) => {
  const n = Qr[e];
  return /* @__PURE__ */ _.jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: n,
      height: n,
      ...r,
      viewBox: "0 0 54 54",
      fill: "none",
      children: [
        /* @__PURE__ */ _.jsx("circle", { cx: "27", cy: "27", r: "26", stroke: "#132438", "stroke-width": "2" }),
        /* @__PURE__ */ _.jsx("path", { d: "M9.64966 36.9999V18.4099H11.9117V36.9999H9.64966Z", fill: "#218094" }),
        /* @__PURE__ */ _.jsx("path", { d: "M16.7306 36.9999V18.4099H22.3206C25.8826 18.4099 28.8206 19.8659 28.8206 23.5839V23.6879C28.8206 26.7559 26.7666 28.2639 24.2186 28.7579L29.9126 36.9999H27.3906L21.8526 28.9139H18.9926V36.9999H16.7306ZM18.9926 27.1199H22.4766C25.1286 27.1199 26.5586 25.9759 26.5586 23.6879V23.5839C26.5586 21.0619 24.9986 20.2299 22.4766 20.2299H18.9926V27.1199Z", fill: "#218094" }),
        /* @__PURE__ */ _.jsx("path", { d: "M35.3188 35.1539H37.8668C42.6508 35.1539 45.0428 32.2939 45.0428 27.7439V27.5359C45.0428 23.2459 42.9628 20.2299 37.8408 20.2299H35.3188V35.1539ZM33.0568 36.9999V18.4099H37.9708C44.3668 18.4099 47.3828 22.3619 47.3828 27.5359V27.7699C47.3828 32.9179 44.4188 36.9999 37.9188 36.9999H33.0568Z", fill: "#218094" })
      ]
    }
  );
}, Ore = ({
  size: e = "md",
  theme: t = "light",
  ...r
}) => {
  const n = Qr[e];
  return /* @__PURE__ */ _.jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: n,
      height: n,
      ...r,
      viewBox: "0 0 64 40",
      fill: "none",
      children: [
        /* @__PURE__ */ _.jsxs("g", { "clip-path": "url(#clip0_4062_983)", children: [
          /* @__PURE__ */ _.jsx("path", { d: "M58.5288 40H5.2C2.3322 40 0 37.6678 0 34.8V5.2C0 2.3322 2.3322 0 5.2 0H58.5288C61.3966 0 63.7288 2.3322 63.7288 5.2V34.8C63.7288 37.6678 61.3966 40 58.5288 40ZM5.2 2.71186C3.83051 2.71186 2.71186 3.83051 2.71186 5.2V34.8C2.71186 36.1695 3.83051 37.2881 5.2 37.2881H58.5288C59.8983 37.2881 61.017 36.1695 61.017 34.8V5.2C61.017 3.83051 59.8983 2.71186 58.5288 2.71186H5.2Z", fill: "#173D65" }),
          /* @__PURE__ */ _.jsx("path", { d: "M53.722 21.7356H51.2406H48.766H46.2847H43.8101H41.3287H38.8474H36.3728V24.1356H38.8474H41.3287H43.8101H46.2847H48.766H51.2406H53.722L55.5864 21.7356H53.722Z", fill: "#80CCB4" }),
          /* @__PURE__ */ _.jsx("path", { d: "M41.3287 14.5289H43.8101H46.2847H48.766H51.2406H53.722L55.5864 12.1221H53.722H51.2406H48.766H46.2847H43.8101H41.3287H38.8474H36.3728V14.5289H38.8474H41.3287Z", fill: "#80CCB4" }),
          /* @__PURE__ */ _.jsx("path", { d: "M24.6781 20.6847C26.8204 19.3966 28.2645 17.0576 28.2645 14.3796C28.2645 10.3254 24.9628 7.02368 20.9086 7.02368C16.8543 7.02368 13.5526 10.3254 13.5526 14.3796C13.5526 17.0305 14.9696 19.3559 17.0781 20.6508C12.2509 22.2305 8.74585 26.7796 8.74585 32.1288V32.5491H11.1459V32.1288C11.1459 26.7932 15.4848 22.4474 20.8272 22.4474C26.1696 22.4474 30.5086 26.7864 30.5086 32.1288V32.5491H32.9086V32.1288C32.9086 26.8135 29.4509 22.2983 24.6781 20.6847ZM20.9086 9.42368C23.6408 9.42368 25.8645 11.6474 25.8645 14.3796C25.8645 17.1118 23.6408 19.3355 20.9086 19.3355C18.1764 19.3355 15.9526 17.1118 15.9526 14.3796C15.9526 11.6474 18.1764 9.42368 20.9086 9.42368Z", fill: "#1A3E6F" })
        ] }),
        /* @__PURE__ */ _.jsx("defs", { children: /* @__PURE__ */ _.jsx("clipPath", { id: "clip0_4062_983", children: /* @__PURE__ */ _.jsx("rect", { width: "63.7288", height: "40", fill: "white" }) }) })
      ]
    }
  );
}, Sre = ({
  size: e = "md",
  theme: t = "light",
  ...r
}) => {
  const n = Qr[e], { fill: a } = qo[t];
  return /* @__PURE__ */ _.jsxs(
    "svg",
    {
      viewBox: "0 0 89 85",
      fill: "none",
      width: n,
      height: n,
      ...r,
      children: [
        /* @__PURE__ */ _.jsxs("g", { clipPath: "url(#clip0_440_593)", children: [
          /* @__PURE__ */ _.jsx(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M59.0198 25.87C59.0198 24.69 60.0098 23.79 61.2098 23.79C62.4098 23.79 63.3498 24.7 63.3498 25.87C63.3498 27.04 62.3898 27.93 61.2098 27.93C60.0298 27.93 59.0198 27.02 59.0198 25.87ZM59.7398 20.98C59.7398 18.87 61.1598 17.56 62.4398 16.3C63.4298 15.31 64.3098 14.43 64.3098 13.28C64.3098 11.92 63.5598 11.04 61.9298 11.04C60.2998 11.04 59.1198 12.22 58.9398 14.06H55.8398C56.0298 10.56 58.5098 8.37 62.0998 8.37C65.9198 8.37 67.7098 10.46 67.7098 13.05C67.7098 14.95 66.5598 16.18 65.3598 17.35C64.0998 18.55 62.8198 19.65 62.7398 21.15V22H59.7498V20.98H59.7398Z",
              fill: a
            }
          ),
          /* @__PURE__ */ _.jsx(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M56.67 74.03C56.09 74.61 55.51 75.18 54.94 75.76C53.98 76.53 53.21 77.49 52.25 78.45C50.9 79.99 49.17 80.57 47.05 80.57H46.47C42.43 80.38 38.58 78.64 35.69 77.3C27.8 73.45 21.06 68.06 15.29 61.32C10.67 55.74 7.39998 50.35 5.27998 44.76C4.11998 41.49 3.73998 38.79 3.92998 36.29C4.11998 34.75 4.69998 33.4 5.85998 32.25L10.48 27.63C11.25 27.05 11.83 26.67 12.6 26.67C13.56 26.67 14.14 27.25 14.53 27.63C15.49 28.4 16.46 29.17 17.23 29.94C17.61 30.52 18 30.9 18.58 31.29L22.43 35.14C23.97 36.68 23.97 38.03 22.43 39.37C22.04 39.76 21.66 40.14 21.28 40.53C20.12 41.68 18.97 42.84 17.81 43.8C16.65 44.95 16.85 46.11 17.04 46.88V47.07C18 49.38 19.35 51.69 21.47 54.39C25.32 59.01 29.36 62.67 33.79 65.56C34.37 65.94 34.94 66.14 35.52 66.52C36.1 66.71 36.48 67.1 36.87 67.29C36.87 67.29 37.06 67.29 37.06 67.48C37.45 67.67 38.02 67.87 38.41 67.87C39.57 67.87 40.34 67.1 40.53 66.91L45.34 62.1C45.73 61.72 46.5 61.14 47.46 61.14C48.23 61.14 49 61.72 49.38 62.1L57.08 69.8C58.24 71.15 58.24 72.69 56.7 74.04M59.39 67.11L51.88 59.6C50.53 58.25 48.99 57.48 47.26 57.48C45.53 57.48 43.99 58.25 42.45 59.6L38.02 64.03C37.64 63.84 37.25 63.64 36.87 63.45C36.29 63.26 35.91 62.87 35.52 62.68C31.48 60.18 27.63 56.71 24.16 52.28C22.43 50.16 21.27 48.24 20.5 46.31C21.65 45.35 22.62 44.19 23.77 43.23C24.16 42.84 24.54 42.46 24.93 42.08C27.82 39.19 27.82 35.34 24.93 32.46L21.08 28.61C20.69 28.22 20.12 27.65 19.73 27.26C18.96 26.49 18.19 25.72 17.23 24.95C15.88 23.6 14.34 22.83 12.61 22.83C10.88 22.83 9.33998 23.6 7.98998 24.95L3.17998 29.57C1.44998 31.3 0.489977 33.42 0.0999769 35.92C-0.290023 39.96 0.869977 43.62 1.82998 46.12C4.13998 52.09 7.40998 57.67 12.42 63.64C18.39 70.76 25.7 76.54 33.98 80.58C37.06 82.12 41.29 83.85 46.11 84.24H47.07C50.34 84.24 52.84 83.09 54.96 80.78C55.73 79.82 56.5 79.05 57.46 78.28C58.04 77.7 58.61 77.13 59.19 76.55C60.54 75.2 61.31 73.47 61.31 71.74C61.5 70.2 60.73 68.47 59.39 67.12",
              fill: a
            }
          ),
          /* @__PURE__ */ _.jsx(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M83.1602 0H37.7402C34.8302 0 32.4702 2.27 32.4702 5.06V31.44C32.4702 34.23 34.8402 36.5 37.7502 36.5L54.9702 36.42L57.7702 32.71L37.7402 32.8C36.8702 32.8 36.1702 32.19 36.1702 31.44V5.06C36.1702 4.31 36.8802 3.7 37.7402 3.7H83.1602C84.0302 3.7 84.7302 4.31 84.7302 5.06V31.44C84.7302 32.19 84.0202 32.8 83.1602 32.8H68.1102L58.8202 47.77L61.9602 49.72L70.1702 36.5H83.1602C86.0702 36.5 88.4302 34.23 88.4302 31.44V5.06C88.4302 2.27 86.0702 0 83.1602 0Z",
              fill: a
            }
          )
        ] }),
        /* @__PURE__ */ _.jsx("defs", { children: /* @__PURE__ */ _.jsx("clipPath", { id: "clip0_440_593", children: /* @__PURE__ */ _.jsx("rect", { width: "88.43", height: "84.23", fill: "white" }) }) })
      ]
    }
  );
}, sy = ({
  amountValue: e,
  amountName: t,
  onAmountChange: r,
  selectValue: n,
  selectName: a,
  options: i,
  onSelectChange: o,
  onBlur: u,
  className: s,
  dark: c,
  error: l,
  isDisabled: f,
  step: d = 10
}) => {
  const p = (h) => {
    if (o) {
      const v = i.find((g) => g.value.toString() === h);
      v && o(v.value);
    }
  };
  return /* @__PURE__ */ _.jsxs(
    "div",
    {
      className: He("amount-select__wrapper", {
        "amount-select__wrapper--error": l,
        "amount-select__wrapper--dark": c,
        [`${s}`]: !!s
      }),
      children: [
        /* @__PURE__ */ _.jsx("div", { className: "amount-select__label", children: /* @__PURE__ */ _.jsx("span", { className: "amount-select__text", children: "$" }) }),
        /* @__PURE__ */ _.jsx(
          "input",
          {
            className: "amount-select__amount-input",
            type: "number",
            step: d,
            value: e,
            onChange: (h) => r && r(h),
            name: t
          }
        ),
        /* @__PURE__ */ _.jsx(
          "select",
          {
            className: "amount-select__select",
            value: n,
            onChange: (h) => p(h.target.value),
            onBlur: u,
            disabled: f,
            name: a,
            children: i.map((h) => /* @__PURE__ */ _.jsx("option", { value: h.value, children: h.label }, h.value))
          }
        ),
        /* @__PURE__ */ _.jsx("div", { className: "position-relative", children: /* @__PURE__ */ _.jsx(uy, { size: "xs", className: "amount-select__icon" }) })
      ]
    }
  );
}, Are = ({ theme: e = "light", children: t, className: r }) => /* @__PURE__ */ _.jsx(
  "div",
  {
    className: He("card", {
      [`card--${e}`]: !!e,
      [`${r}`]: !!r
    }),
    children: t
  }
);
var x1 = {}, cy = { exports: {} };
(function(e) {
  function t(r) {
    return r && r.__esModule ? r : {
      default: r
    };
  }
  e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
})(cy);
var ly = cy.exports, fy = { exports: {} }, dy = { exports: {} };
(function(e) {
  function t(r) {
    "@babel/helpers - typeof";
    return e.exports = t = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(n) {
      return typeof n;
    } : function(n) {
      return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
    }, e.exports.__esModule = !0, e.exports.default = e.exports, t(r);
  }
  e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
})(dy);
var K8 = dy.exports;
(function(e) {
  var t = K8.default;
  function r(a) {
    if (typeof WeakMap != "function") return null;
    var i = /* @__PURE__ */ new WeakMap(), o = /* @__PURE__ */ new WeakMap();
    return (r = function(s) {
      return s ? o : i;
    })(a);
  }
  function n(a, i) {
    if (!i && a && a.__esModule) return a;
    if (a === null || t(a) != "object" && typeof a != "function") return {
      default: a
    };
    var o = r(i);
    if (o && o.has(a)) return o.get(a);
    var u = {
      __proto__: null
    }, s = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var c in a) if (c !== "default" && {}.hasOwnProperty.call(a, c)) {
      var l = s ? Object.getOwnPropertyDescriptor(a, c) : null;
      l && (l.get || l.set) ? Object.defineProperty(u, c, l) : u[c] = a[c];
    }
    return u.default = a, o && o.set(a, u), u;
  }
  e.exports = n, e.exports.__esModule = !0, e.exports.default = e.exports;
})(fy);
var py = fy.exports, Gc = {};
function hy(e, t) {
  return process.env.NODE_ENV === "production" ? function() {
    return null;
  } : function() {
    return e.apply(void 0, arguments) || t.apply(void 0, arguments);
  };
}
function Ce() {
  return Ce = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) ({}).hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Ce.apply(null, arguments);
}
function mn(e) {
  "@babel/helpers - typeof";
  return mn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, mn(e);
}
function Hc(e) {
  return e && mn(e) === "object" && e.constructor === Object;
}
function Aa(e, t) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
    clone: !0
  }, n = r.clone ? Ce({}, e) : e;
  return Hc(e) && Hc(t) && Object.keys(t).forEach(function(a) {
    a !== "__proto__" && (Hc(t[a]) && a in e ? n[a] = Aa(e[a], t[a], r) : n[a] = t[a]);
  }), n;
}
var gf = { exports: {} }, mf = { exports: {} }, Be = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ph;
function q8() {
  if (ph) return Be;
  ph = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, r = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, o = e ? Symbol.for("react.provider") : 60109, u = e ? Symbol.for("react.context") : 60110, s = e ? Symbol.for("react.async_mode") : 60111, c = e ? Symbol.for("react.concurrent_mode") : 60111, l = e ? Symbol.for("react.forward_ref") : 60112, f = e ? Symbol.for("react.suspense") : 60113, d = e ? Symbol.for("react.suspense_list") : 60120, p = e ? Symbol.for("react.memo") : 60115, h = e ? Symbol.for("react.lazy") : 60116, v = e ? Symbol.for("react.block") : 60121, g = e ? Symbol.for("react.fundamental") : 60117, b = e ? Symbol.for("react.responder") : 60118, x = e ? Symbol.for("react.scope") : 60119;
  function w(m) {
    if (typeof m == "object" && m !== null) {
      var C = m.$$typeof;
      switch (C) {
        case t:
          switch (m = m.type, m) {
            case s:
            case c:
            case n:
            case i:
            case a:
            case f:
              return m;
            default:
              switch (m = m && m.$$typeof, m) {
                case u:
                case l:
                case h:
                case p:
                case o:
                  return m;
                default:
                  return C;
              }
          }
        case r:
          return C;
      }
    }
  }
  function y(m) {
    return w(m) === c;
  }
  return Be.AsyncMode = s, Be.ConcurrentMode = c, Be.ContextConsumer = u, Be.ContextProvider = o, Be.Element = t, Be.ForwardRef = l, Be.Fragment = n, Be.Lazy = h, Be.Memo = p, Be.Portal = r, Be.Profiler = i, Be.StrictMode = a, Be.Suspense = f, Be.isAsyncMode = function(m) {
    return y(m) || w(m) === s;
  }, Be.isConcurrentMode = y, Be.isContextConsumer = function(m) {
    return w(m) === u;
  }, Be.isContextProvider = function(m) {
    return w(m) === o;
  }, Be.isElement = function(m) {
    return typeof m == "object" && m !== null && m.$$typeof === t;
  }, Be.isForwardRef = function(m) {
    return w(m) === l;
  }, Be.isFragment = function(m) {
    return w(m) === n;
  }, Be.isLazy = function(m) {
    return w(m) === h;
  }, Be.isMemo = function(m) {
    return w(m) === p;
  }, Be.isPortal = function(m) {
    return w(m) === r;
  }, Be.isProfiler = function(m) {
    return w(m) === i;
  }, Be.isStrictMode = function(m) {
    return w(m) === a;
  }, Be.isSuspense = function(m) {
    return w(m) === f;
  }, Be.isValidElementType = function(m) {
    return typeof m == "string" || typeof m == "function" || m === n || m === c || m === i || m === a || m === f || m === d || typeof m == "object" && m !== null && (m.$$typeof === h || m.$$typeof === p || m.$$typeof === o || m.$$typeof === u || m.$$typeof === l || m.$$typeof === g || m.$$typeof === b || m.$$typeof === x || m.$$typeof === v);
  }, Be.typeOf = w, Be;
}
var Ve = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hh;
function J8() {
  return hh || (hh = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, r = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, o = e ? Symbol.for("react.provider") : 60109, u = e ? Symbol.for("react.context") : 60110, s = e ? Symbol.for("react.async_mode") : 60111, c = e ? Symbol.for("react.concurrent_mode") : 60111, l = e ? Symbol.for("react.forward_ref") : 60112, f = e ? Symbol.for("react.suspense") : 60113, d = e ? Symbol.for("react.suspense_list") : 60120, p = e ? Symbol.for("react.memo") : 60115, h = e ? Symbol.for("react.lazy") : 60116, v = e ? Symbol.for("react.block") : 60121, g = e ? Symbol.for("react.fundamental") : 60117, b = e ? Symbol.for("react.responder") : 60118, x = e ? Symbol.for("react.scope") : 60119;
    function w(E) {
      return typeof E == "string" || typeof E == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      E === n || E === c || E === i || E === a || E === f || E === d || typeof E == "object" && E !== null && (E.$$typeof === h || E.$$typeof === p || E.$$typeof === o || E.$$typeof === u || E.$$typeof === l || E.$$typeof === g || E.$$typeof === b || E.$$typeof === x || E.$$typeof === v);
    }
    function y(E) {
      if (typeof E == "object" && E !== null) {
        var K = E.$$typeof;
        switch (K) {
          case t:
            var Z = E.type;
            switch (Z) {
              case s:
              case c:
              case n:
              case i:
              case a:
              case f:
                return Z;
              default:
                var Q = Z && Z.$$typeof;
                switch (Q) {
                  case u:
                  case l:
                  case h:
                  case p:
                  case o:
                    return Q;
                  default:
                    return K;
                }
            }
          case r:
            return K;
        }
      }
    }
    var m = s, C = c, O = u, S = o, A = t, P = l, T = n, M = h, I = p, G = r, Y = i, L = a, X = f, q = !1;
    function re(E) {
      return q || (q = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), j(E) || y(E) === s;
    }
    function j(E) {
      return y(E) === c;
    }
    function W(E) {
      return y(E) === u;
    }
    function D(E) {
      return y(E) === o;
    }
    function R(E) {
      return typeof E == "object" && E !== null && E.$$typeof === t;
    }
    function $(E) {
      return y(E) === l;
    }
    function B(E) {
      return y(E) === n;
    }
    function H(E) {
      return y(E) === h;
    }
    function z(E) {
      return y(E) === p;
    }
    function J(E) {
      return y(E) === r;
    }
    function U(E) {
      return y(E) === i;
    }
    function F(E) {
      return y(E) === a;
    }
    function k(E) {
      return y(E) === f;
    }
    Ve.AsyncMode = m, Ve.ConcurrentMode = C, Ve.ContextConsumer = O, Ve.ContextProvider = S, Ve.Element = A, Ve.ForwardRef = P, Ve.Fragment = T, Ve.Lazy = M, Ve.Memo = I, Ve.Portal = G, Ve.Profiler = Y, Ve.StrictMode = L, Ve.Suspense = X, Ve.isAsyncMode = re, Ve.isConcurrentMode = j, Ve.isContextConsumer = W, Ve.isContextProvider = D, Ve.isElement = R, Ve.isForwardRef = $, Ve.isFragment = B, Ve.isLazy = H, Ve.isMemo = z, Ve.isPortal = J, Ve.isProfiler = U, Ve.isStrictMode = F, Ve.isSuspense = k, Ve.isValidElementType = w, Ve.typeOf = y;
  }()), Ve;
}
process.env.NODE_ENV === "production" ? mf.exports = q8() : mf.exports = J8();
var Ea = mf.exports;
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var Uc, vh;
function Q8() {
  if (vh) return Uc;
  vh = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, r = Object.prototype.propertyIsEnumerable;
  function n(i) {
    if (i == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(i);
  }
  function a() {
    try {
      if (!Object.assign)
        return !1;
      var i = new String("abc");
      if (i[5] = "de", Object.getOwnPropertyNames(i)[0] === "5")
        return !1;
      for (var o = {}, u = 0; u < 10; u++)
        o["_" + String.fromCharCode(u)] = u;
      var s = Object.getOwnPropertyNames(o).map(function(l) {
        return o[l];
      });
      if (s.join("") !== "0123456789")
        return !1;
      var c = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(l) {
        c[l] = l;
      }), Object.keys(Object.assign({}, c)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return Uc = a() ? Object.assign : function(i, o) {
    for (var u, s = n(i), c, l = 1; l < arguments.length; l++) {
      u = Object(arguments[l]);
      for (var f in u)
        t.call(u, f) && (s[f] = u[f]);
      if (e) {
        c = e(u);
        for (var d = 0; d < c.length; d++)
          r.call(u, c[d]) && (s[c[d]] = u[c[d]]);
      }
    }
    return s;
  }, Uc;
}
var zc, gh;
function C1() {
  if (gh) return zc;
  gh = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return zc = e, zc;
}
var Yc, mh;
function vy() {
  return mh || (mh = 1, Yc = Function.call.bind(Object.prototype.hasOwnProperty)), Yc;
}
var Xc, yh;
function e7() {
  if (yh) return Xc;
  yh = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = C1(), r = {}, n = vy();
    e = function(i) {
      var o = "Warning: " + i;
      typeof console < "u" && console.error(o);
      try {
        throw new Error(o);
      } catch {
      }
    };
  }
  function a(i, o, u, s, c) {
    if (process.env.NODE_ENV !== "production") {
      for (var l in i)
        if (n(i, l)) {
          var f;
          try {
            if (typeof i[l] != "function") {
              var d = Error(
                (s || "React class") + ": " + u + " type `" + l + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof i[l] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw d.name = "Invariant Violation", d;
            }
            f = i[l](o, l, s, u, null, t);
          } catch (h) {
            f = h;
          }
          if (f && !(f instanceof Error) && e(
            (s || "React class") + ": type specification of " + u + " `" + l + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof f + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), f instanceof Error && !(f.message in r)) {
            r[f.message] = !0;
            var p = c ? c() : "";
            e(
              "Failed " + u + " type: " + f.message + (p ?? "")
            );
          }
        }
    }
  }
  return a.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (r = {});
  }, Xc = a, Xc;
}
var Zc, bh;
function t7() {
  if (bh) return Zc;
  bh = 1;
  var e = Ea, t = Q8(), r = C1(), n = vy(), a = e7(), i = function() {
  };
  process.env.NODE_ENV !== "production" && (i = function(u) {
    var s = "Warning: " + u;
    typeof console < "u" && console.error(s);
    try {
      throw new Error(s);
    } catch {
    }
  });
  function o() {
    return null;
  }
  return Zc = function(u, s) {
    var c = typeof Symbol == "function" && Symbol.iterator, l = "@@iterator";
    function f(j) {
      var W = j && (c && j[c] || j[l]);
      if (typeof W == "function")
        return W;
    }
    var d = "<<anonymous>>", p = {
      array: b("array"),
      bigint: b("bigint"),
      bool: b("boolean"),
      func: b("function"),
      number: b("number"),
      object: b("object"),
      string: b("string"),
      symbol: b("symbol"),
      any: x(),
      arrayOf: w,
      element: y(),
      elementType: m(),
      instanceOf: C,
      node: P(),
      objectOf: S,
      oneOf: O,
      oneOfType: A,
      shape: M,
      exact: I
    };
    function h(j, W) {
      return j === W ? j !== 0 || 1 / j === 1 / W : j !== j && W !== W;
    }
    function v(j, W) {
      this.message = j, this.data = W && typeof W == "object" ? W : {}, this.stack = "";
    }
    v.prototype = Error.prototype;
    function g(j) {
      if (process.env.NODE_ENV !== "production")
        var W = {}, D = 0;
      function R(B, H, z, J, U, F, k) {
        if (J = J || d, F = F || z, k !== r) {
          if (s) {
            var E = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw E.name = "Invariant Violation", E;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var K = J + ":" + z;
            !W[K] && // Avoid spamming the console because they are often not actionable except for lib authors
            D < 3 && (i(
              "You are manually calling a React.PropTypes validation function for the `" + F + "` prop on `" + J + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), W[K] = !0, D++);
          }
        }
        return H[z] == null ? B ? H[z] === null ? new v("The " + U + " `" + F + "` is marked as required " + ("in `" + J + "`, but its value is `null`.")) : new v("The " + U + " `" + F + "` is marked as required in " + ("`" + J + "`, but its value is `undefined`.")) : null : j(H, z, J, U, F);
      }
      var $ = R.bind(null, !1);
      return $.isRequired = R.bind(null, !0), $;
    }
    function b(j) {
      function W(D, R, $, B, H, z) {
        var J = D[R], U = L(J);
        if (U !== j) {
          var F = X(J);
          return new v(
            "Invalid " + B + " `" + H + "` of type " + ("`" + F + "` supplied to `" + $ + "`, expected ") + ("`" + j + "`."),
            { expectedType: j }
          );
        }
        return null;
      }
      return g(W);
    }
    function x() {
      return g(o);
    }
    function w(j) {
      function W(D, R, $, B, H) {
        if (typeof j != "function")
          return new v("Property `" + H + "` of component `" + $ + "` has invalid PropType notation inside arrayOf.");
        var z = D[R];
        if (!Array.isArray(z)) {
          var J = L(z);
          return new v("Invalid " + B + " `" + H + "` of type " + ("`" + J + "` supplied to `" + $ + "`, expected an array."));
        }
        for (var U = 0; U < z.length; U++) {
          var F = j(z, U, $, B, H + "[" + U + "]", r);
          if (F instanceof Error)
            return F;
        }
        return null;
      }
      return g(W);
    }
    function y() {
      function j(W, D, R, $, B) {
        var H = W[D];
        if (!u(H)) {
          var z = L(H);
          return new v("Invalid " + $ + " `" + B + "` of type " + ("`" + z + "` supplied to `" + R + "`, expected a single ReactElement."));
        }
        return null;
      }
      return g(j);
    }
    function m() {
      function j(W, D, R, $, B) {
        var H = W[D];
        if (!e.isValidElementType(H)) {
          var z = L(H);
          return new v("Invalid " + $ + " `" + B + "` of type " + ("`" + z + "` supplied to `" + R + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return g(j);
    }
    function C(j) {
      function W(D, R, $, B, H) {
        if (!(D[R] instanceof j)) {
          var z = j.name || d, J = re(D[R]);
          return new v("Invalid " + B + " `" + H + "` of type " + ("`" + J + "` supplied to `" + $ + "`, expected ") + ("instance of `" + z + "`."));
        }
        return null;
      }
      return g(W);
    }
    function O(j) {
      if (!Array.isArray(j))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? i(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : i("Invalid argument supplied to oneOf, expected an array.")), o;
      function W(D, R, $, B, H) {
        for (var z = D[R], J = 0; J < j.length; J++)
          if (h(z, j[J]))
            return null;
        var U = JSON.stringify(j, function(k, E) {
          var K = X(E);
          return K === "symbol" ? String(E) : E;
        });
        return new v("Invalid " + B + " `" + H + "` of value `" + String(z) + "` " + ("supplied to `" + $ + "`, expected one of " + U + "."));
      }
      return g(W);
    }
    function S(j) {
      function W(D, R, $, B, H) {
        if (typeof j != "function")
          return new v("Property `" + H + "` of component `" + $ + "` has invalid PropType notation inside objectOf.");
        var z = D[R], J = L(z);
        if (J !== "object")
          return new v("Invalid " + B + " `" + H + "` of type " + ("`" + J + "` supplied to `" + $ + "`, expected an object."));
        for (var U in z)
          if (n(z, U)) {
            var F = j(z, U, $, B, H + "." + U, r);
            if (F instanceof Error)
              return F;
          }
        return null;
      }
      return g(W);
    }
    function A(j) {
      if (!Array.isArray(j))
        return process.env.NODE_ENV !== "production" && i("Invalid argument supplied to oneOfType, expected an instance of array."), o;
      for (var W = 0; W < j.length; W++) {
        var D = j[W];
        if (typeof D != "function")
          return i(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + q(D) + " at index " + W + "."
          ), o;
      }
      function R($, B, H, z, J) {
        for (var U = [], F = 0; F < j.length; F++) {
          var k = j[F], E = k($, B, H, z, J, r);
          if (E == null)
            return null;
          E.data && n(E.data, "expectedType") && U.push(E.data.expectedType);
        }
        var K = U.length > 0 ? ", expected one of type [" + U.join(", ") + "]" : "";
        return new v("Invalid " + z + " `" + J + "` supplied to " + ("`" + H + "`" + K + "."));
      }
      return g(R);
    }
    function P() {
      function j(W, D, R, $, B) {
        return G(W[D]) ? null : new v("Invalid " + $ + " `" + B + "` supplied to " + ("`" + R + "`, expected a ReactNode."));
      }
      return g(j);
    }
    function T(j, W, D, R, $) {
      return new v(
        (j || "React class") + ": " + W + " type `" + D + "." + R + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + $ + "`."
      );
    }
    function M(j) {
      function W(D, R, $, B, H) {
        var z = D[R], J = L(z);
        if (J !== "object")
          return new v("Invalid " + B + " `" + H + "` of type `" + J + "` " + ("supplied to `" + $ + "`, expected `object`."));
        for (var U in j) {
          var F = j[U];
          if (typeof F != "function")
            return T($, B, H, U, X(F));
          var k = F(z, U, $, B, H + "." + U, r);
          if (k)
            return k;
        }
        return null;
      }
      return g(W);
    }
    function I(j) {
      function W(D, R, $, B, H) {
        var z = D[R], J = L(z);
        if (J !== "object")
          return new v("Invalid " + B + " `" + H + "` of type `" + J + "` " + ("supplied to `" + $ + "`, expected `object`."));
        var U = t({}, D[R], j);
        for (var F in U) {
          var k = j[F];
          if (n(j, F) && typeof k != "function")
            return T($, B, H, F, X(k));
          if (!k)
            return new v(
              "Invalid " + B + " `" + H + "` key `" + F + "` supplied to `" + $ + "`.\nBad object: " + JSON.stringify(D[R], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(j), null, "  ")
            );
          var E = k(z, F, $, B, H + "." + F, r);
          if (E)
            return E;
        }
        return null;
      }
      return g(W);
    }
    function G(j) {
      switch (typeof j) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !j;
        case "object":
          if (Array.isArray(j))
            return j.every(G);
          if (j === null || u(j))
            return !0;
          var W = f(j);
          if (W) {
            var D = W.call(j), R;
            if (W !== j.entries) {
              for (; !(R = D.next()).done; )
                if (!G(R.value))
                  return !1;
            } else
              for (; !(R = D.next()).done; ) {
                var $ = R.value;
                if ($ && !G($[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function Y(j, W) {
      return j === "symbol" ? !0 : W ? W["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && W instanceof Symbol : !1;
    }
    function L(j) {
      var W = typeof j;
      return Array.isArray(j) ? "array" : j instanceof RegExp ? "object" : Y(W, j) ? "symbol" : W;
    }
    function X(j) {
      if (typeof j > "u" || j === null)
        return "" + j;
      var W = L(j);
      if (W === "object") {
        if (j instanceof Date)
          return "date";
        if (j instanceof RegExp)
          return "regexp";
      }
      return W;
    }
    function q(j) {
      var W = X(j);
      switch (W) {
        case "array":
        case "object":
          return "an " + W;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + W;
        default:
          return W;
      }
    }
    function re(j) {
      return !j.constructor || !j.constructor.name ? d : j.constructor.name;
    }
    return p.checkPropTypes = a, p.resetWarningCache = a.resetWarningCache, p.PropTypes = p, p;
  }, Zc;
}
var Kc, xh;
function r7() {
  if (xh) return Kc;
  xh = 1;
  var e = C1();
  function t() {
  }
  function r() {
  }
  return r.resetWarningCache = t, Kc = function() {
    function n(o, u, s, c, l, f) {
      if (f !== e) {
        var d = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw d.name = "Invariant Violation", d;
      }
    }
    n.isRequired = n;
    function a() {
      return n;
    }
    var i = {
      array: n,
      bigint: n,
      bool: n,
      func: n,
      number: n,
      object: n,
      string: n,
      symbol: n,
      any: n,
      arrayOf: a,
      element: n,
      elementType: n,
      instanceOf: a,
      node: n,
      objectOf: a,
      oneOf: a,
      oneOfType: a,
      shape: a,
      exact: a,
      checkPropTypes: r,
      resetWarningCache: t
    };
    return i.PropTypes = i, i;
  }, Kc;
}
if (process.env.NODE_ENV !== "production") {
  var n7 = Ea, a7 = !0;
  gf.exports = t7()(n7.isElement, a7);
} else
  gf.exports = r7()();
var i7 = gf.exports;
const ce = /* @__PURE__ */ Fe(i7);
function o7(e, t) {
  if (mn(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (mn(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function gy(e) {
  var t = o7(e, "string");
  return mn(t) == "symbol" ? t : t + "";
}
function Ui(e, t, r) {
  return (t = gy(t)) in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
var u7 = "exact-prop: ​";
function s7(e) {
  return process.env.NODE_ENV === "production" ? e : Ce({}, e, Ui({}, u7, function(t) {
    var r = Object.keys(t).filter(function(n) {
      return !e.hasOwnProperty(n);
    });
    return r.length > 0 ? new Error("The following props are not supported: ".concat(r.map(function(n) {
      return "`".concat(n, "`");
    }).join(", "), ". Please remove them.")) : null;
  }));
}
function Gu(e) {
  for (var t = "https://mui.com/production-error/?code=" + e, r = 1; r < arguments.length; r += 1)
    t += "&args[]=" + encodeURIComponent(arguments[r]);
  return "Minified Material-UI error #" + e + "; visit " + t + " for the full message.";
}
var yf = { exports: {} }, ze = {};
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ch;
function c7() {
  if (Ch) return ze;
  Ch = 1;
  var e = 60103, t = 60106, r = 60107, n = 60108, a = 60114, i = 60109, o = 60110, u = 60112, s = 60113, c = 60120, l = 60115, f = 60116, d = 60121, p = 60122, h = 60117, v = 60129, g = 60131;
  if (typeof Symbol == "function" && Symbol.for) {
    var b = Symbol.for;
    e = b("react.element"), t = b("react.portal"), r = b("react.fragment"), n = b("react.strict_mode"), a = b("react.profiler"), i = b("react.provider"), o = b("react.context"), u = b("react.forward_ref"), s = b("react.suspense"), c = b("react.suspense_list"), l = b("react.memo"), f = b("react.lazy"), d = b("react.block"), p = b("react.server.block"), h = b("react.fundamental"), v = b("react.debug_trace_mode"), g = b("react.legacy_hidden");
  }
  function x(I) {
    if (typeof I == "object" && I !== null) {
      var G = I.$$typeof;
      switch (G) {
        case e:
          switch (I = I.type, I) {
            case r:
            case a:
            case n:
            case s:
            case c:
              return I;
            default:
              switch (I = I && I.$$typeof, I) {
                case o:
                case u:
                case f:
                case l:
                case i:
                  return I;
                default:
                  return G;
              }
          }
        case t:
          return G;
      }
    }
  }
  var w = i, y = e, m = u, C = r, O = f, S = l, A = t, P = a, T = n, M = s;
  return ze.ContextConsumer = o, ze.ContextProvider = w, ze.Element = y, ze.ForwardRef = m, ze.Fragment = C, ze.Lazy = O, ze.Memo = S, ze.Portal = A, ze.Profiler = P, ze.StrictMode = T, ze.Suspense = M, ze.isAsyncMode = function() {
    return !1;
  }, ze.isConcurrentMode = function() {
    return !1;
  }, ze.isContextConsumer = function(I) {
    return x(I) === o;
  }, ze.isContextProvider = function(I) {
    return x(I) === i;
  }, ze.isElement = function(I) {
    return typeof I == "object" && I !== null && I.$$typeof === e;
  }, ze.isForwardRef = function(I) {
    return x(I) === u;
  }, ze.isFragment = function(I) {
    return x(I) === r;
  }, ze.isLazy = function(I) {
    return x(I) === f;
  }, ze.isMemo = function(I) {
    return x(I) === l;
  }, ze.isPortal = function(I) {
    return x(I) === t;
  }, ze.isProfiler = function(I) {
    return x(I) === a;
  }, ze.isStrictMode = function(I) {
    return x(I) === n;
  }, ze.isSuspense = function(I) {
    return x(I) === s;
  }, ze.isValidElementType = function(I) {
    return typeof I == "string" || typeof I == "function" || I === r || I === a || I === v || I === n || I === s || I === c || I === g || typeof I == "object" && I !== null && (I.$$typeof === f || I.$$typeof === l || I.$$typeof === i || I.$$typeof === o || I.$$typeof === u || I.$$typeof === h || I.$$typeof === d || I[0] === p);
  }, ze.typeOf = x, ze;
}
var Ye = {};
/** @license React v17.0.2
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var wh;
function l7() {
  return wh || (wh = 1, process.env.NODE_ENV !== "production" && function() {
    var e = 60103, t = 60106, r = 60107, n = 60108, a = 60114, i = 60109, o = 60110, u = 60112, s = 60113, c = 60120, l = 60115, f = 60116, d = 60121, p = 60122, h = 60117, v = 60129, g = 60131;
    if (typeof Symbol == "function" && Symbol.for) {
      var b = Symbol.for;
      e = b("react.element"), t = b("react.portal"), r = b("react.fragment"), n = b("react.strict_mode"), a = b("react.profiler"), i = b("react.provider"), o = b("react.context"), u = b("react.forward_ref"), s = b("react.suspense"), c = b("react.suspense_list"), l = b("react.memo"), f = b("react.lazy"), d = b("react.block"), p = b("react.server.block"), h = b("react.fundamental"), b("react.scope"), b("react.opaque.id"), v = b("react.debug_trace_mode"), b("react.offscreen"), g = b("react.legacy_hidden");
    }
    var x = !1;
    function w(k) {
      return !!(typeof k == "string" || typeof k == "function" || k === r || k === a || k === v || k === n || k === s || k === c || k === g || x || typeof k == "object" && k !== null && (k.$$typeof === f || k.$$typeof === l || k.$$typeof === i || k.$$typeof === o || k.$$typeof === u || k.$$typeof === h || k.$$typeof === d || k[0] === p));
    }
    function y(k) {
      if (typeof k == "object" && k !== null) {
        var E = k.$$typeof;
        switch (E) {
          case e:
            var K = k.type;
            switch (K) {
              case r:
              case a:
              case n:
              case s:
              case c:
                return K;
              default:
                var Z = K && K.$$typeof;
                switch (Z) {
                  case o:
                  case u:
                  case f:
                  case l:
                  case i:
                    return Z;
                  default:
                    return E;
                }
            }
          case t:
            return E;
        }
      }
    }
    var m = o, C = i, O = e, S = u, A = r, P = f, T = l, M = t, I = a, G = n, Y = s, L = !1, X = !1;
    function q(k) {
      return L || (L = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function re(k) {
      return X || (X = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function j(k) {
      return y(k) === o;
    }
    function W(k) {
      return y(k) === i;
    }
    function D(k) {
      return typeof k == "object" && k !== null && k.$$typeof === e;
    }
    function R(k) {
      return y(k) === u;
    }
    function $(k) {
      return y(k) === r;
    }
    function B(k) {
      return y(k) === f;
    }
    function H(k) {
      return y(k) === l;
    }
    function z(k) {
      return y(k) === t;
    }
    function J(k) {
      return y(k) === a;
    }
    function U(k) {
      return y(k) === n;
    }
    function F(k) {
      return y(k) === s;
    }
    Ye.ContextConsumer = m, Ye.ContextProvider = C, Ye.Element = O, Ye.ForwardRef = S, Ye.Fragment = A, Ye.Lazy = P, Ye.Memo = T, Ye.Portal = M, Ye.Profiler = I, Ye.StrictMode = G, Ye.Suspense = Y, Ye.isAsyncMode = q, Ye.isConcurrentMode = re, Ye.isContextConsumer = j, Ye.isContextProvider = W, Ye.isElement = D, Ye.isForwardRef = R, Ye.isFragment = $, Ye.isLazy = B, Ye.isMemo = H, Ye.isPortal = z, Ye.isProfiler = J, Ye.isStrictMode = U, Ye.isSuspense = F, Ye.isValidElementType = w, Ye.typeOf = y;
  }()), Ye;
}
process.env.NODE_ENV === "production" ? yf.exports = c7() : yf.exports = l7();
var Oh = yf.exports, f7 = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
function d7(e) {
  var t = "".concat(e).match(f7), r = t && t[1];
  return r || "";
}
function my(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
  return e.displayName || e.name || d7(e) || t;
}
function Sh(e, t, r) {
  var n = my(t);
  return e.displayName || (n !== "" ? "".concat(r, "(").concat(n, ")") : r);
}
function zi(e) {
  if (e != null) {
    if (typeof e == "string")
      return e;
    if (typeof e == "function")
      return my(e, "Component");
    if (mn(e) === "object")
      switch (e.$$typeof) {
        case Oh.ForwardRef:
          return Sh(e, e.render, "ForwardRef");
        case Oh.Memo:
          return Sh(e, e.type, "memo");
        default:
          return;
      }
  }
}
function bf(e) {
  if (typeof e != "string")
    throw new Error(process.env.NODE_ENV !== "production" ? "Material-UI: capitalize(string) expects a string argument." : Gu(7));
  return e.charAt(0).toUpperCase() + e.slice(1);
}
function p7() {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
    t[r] = arguments[r];
  return t.reduce(function(n, a) {
    return a == null ? n : (process.env.NODE_ENV !== "production" && typeof a != "function" && console.error("Material-UI: Invalid Argument Type, must only provide functions, undefined, or null."), function() {
      for (var o = arguments.length, u = new Array(o), s = 0; s < o; s++)
        u[s] = arguments[s];
      n.apply(this, u), a.apply(this, u);
    });
  }, function() {
  });
}
function yy(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e) if ({}.hasOwnProperty.call(e, n)) {
    if (t.includes(n)) continue;
    r[n] = e[n];
  }
  return r;
}
function Rr(e, t) {
  if (e == null) return {};
  var r, n, a = yy(e, t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (n = 0; n < i.length; n++) r = i[n], t.includes(r) || {}.propertyIsEnumerable.call(e, r) && (a[r] = e[r]);
  }
  return a;
}
function by(e) {
  var t, r, n = "";
  if (typeof e == "string" || typeof e == "number") n += e;
  else if (typeof e == "object") if (Array.isArray(e)) for (t = 0; t < e.length; t++) e[t] && (r = by(e[t])) && (n && (n += " "), n += r);
  else for (t in e) e[t] && (n && (n += " "), n += t);
  return n;
}
function h7() {
  for (var e, t, r = 0, n = ""; r < arguments.length; ) (e = arguments[r++]) && (t = by(e)) && (n && (n += " "), n += t);
  return n;
}
var v7 = typeof Symbol == "function" && Symbol.for;
const g7 = v7 ? Symbol.for("mui.nested") : "__THEME_NESTED__";
var m7 = ["checked", "disabled", "error", "focused", "focusVisible", "required", "expanded", "selected"];
function y7() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = e.disableGlobal, r = t === void 0 ? !1 : t, n = e.productionPrefix, a = n === void 0 ? "jss" : n, i = e.seed, o = i === void 0 ? "" : i, u = o === "" ? "" : "".concat(o, "-"), s = 0, c = function() {
    return s += 1, process.env.NODE_ENV !== "production" && s >= 1e10 && console.warn(["Material-UI: You might have a memory leak.", "The ruleCounter is not supposed to grow that much."].join("")), s;
  };
  return function(l, f) {
    var d = f.options.name;
    if (d && d.indexOf("Mui") === 0 && !f.options.link && !r) {
      if (m7.indexOf(l.key) !== -1)
        return "Mui-".concat(l.key);
      var p = "".concat(u).concat(d, "-").concat(l.key);
      return !f.options.theme[g7] || o !== "" ? p : "".concat(p, "-").concat(c());
    }
    if (process.env.NODE_ENV === "production")
      return "".concat(u).concat(a).concat(c());
    var h = "".concat(l.key, "-").concat(c());
    return f.options.classNamePrefix ? "".concat(u).concat(f.options.classNamePrefix, "-").concat(h) : "".concat(u).concat(h);
  };
}
function b7(e) {
  var t = e.theme, r = e.name, n = e.props;
  if (!t || !t.props || !t.props[r])
    return n;
  var a = t.props[r], i;
  for (i in a)
    n[i] === void 0 && (n[i] = a[i]);
  return n;
}
var x7 = process.env.NODE_ENV === "production";
function cr(e, t) {
  if (!x7) {
    var r = "Warning: " + t;
    typeof console < "u" && console.warn(r);
    try {
      throw Error(r);
    } catch {
    }
  }
}
var Ah = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
  return typeof e;
} : function(e) {
  return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
}, Jo = (typeof window > "u" ? "undefined" : Ah(window)) === "object" && (typeof document > "u" ? "undefined" : Ah(document)) === "object" && document.nodeType === 9;
function C7(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, gy(n.key), n);
  }
}
function xy(e, t, r) {
  return t && C7(e.prototype, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function xf(e, t) {
  return xf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, n) {
    return r.__proto__ = n, r;
  }, xf(e, t);
}
function Cy(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, xf(e, t);
}
function Eh(e) {
  if (e === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
var w7 = {}.constructor;
function Cf(e) {
  if (e == null || typeof e != "object") return e;
  if (Array.isArray(e)) return e.map(Cf);
  if (e.constructor !== w7) return e;
  var t = {};
  for (var r in e)
    t[r] = Cf(e[r]);
  return t;
}
function w1(e, t, r) {
  e === void 0 && (e = "unnamed");
  var n = r.jss, a = Cf(t), i = n.plugins.onCreateRule(e, a, r);
  return i || (e[0] === "@" && process.env.NODE_ENV !== "production" && cr(!1, "[JSS] Unknown rule " + e), null);
}
var _h = function(t, r) {
  for (var n = "", a = 0; a < t.length && t[a] !== "!important"; a++)
    n && (n += r), n += t[a];
  return n;
}, Un = function(t) {
  if (!Array.isArray(t)) return t;
  var r = "";
  if (Array.isArray(t[0]))
    for (var n = 0; n < t.length && t[n] !== "!important"; n++)
      r && (r += ", "), r += _h(t[n], " ");
  else r = _h(t, ", ");
  return t[t.length - 1] === "!important" && (r += " !important"), r;
};
function Ka(e) {
  return e && e.format === !1 ? {
    linebreak: "",
    space: ""
  } : {
    linebreak: `
`,
    space: " "
  };
}
function wi(e, t) {
  for (var r = "", n = 0; n < t; n++)
    r += "  ";
  return r + e;
}
function io(e, t, r) {
  r === void 0 && (r = {});
  var n = "";
  if (!t) return n;
  var a = r, i = a.indent, o = i === void 0 ? 0 : i, u = t.fallbacks;
  r.format === !1 && (o = -1 / 0);
  var s = Ka(r), c = s.linebreak, l = s.space;
  if (e && o++, u)
    if (Array.isArray(u))
      for (var f = 0; f < u.length; f++) {
        var d = u[f];
        for (var p in d) {
          var h = d[p];
          h != null && (n && (n += c), n += wi(p + ":" + l + Un(h) + ";", o));
        }
      }
    else
      for (var v in u) {
        var g = u[v];
        g != null && (n && (n += c), n += wi(v + ":" + l + Un(g) + ";", o));
      }
  for (var b in t) {
    var x = t[b];
    x != null && b !== "fallbacks" && (n && (n += c), n += wi(b + ":" + l + Un(x) + ";", o));
  }
  return !n && !r.allowEmpty || !e ? n : (o--, n && (n = "" + c + n + c), wi("" + e + l + "{" + n, o) + wi("}", o));
}
var O7 = /([[\].#*$><+~=|^:(),"'`\s])/g, Ih = typeof CSS < "u" && CSS.escape, O1 = function(e) {
  return Ih ? Ih(e) : e.replace(O7, "\\$1");
}, wy = /* @__PURE__ */ function() {
  function e(r, n, a) {
    this.type = "style", this.isProcessed = !1;
    var i = a.sheet, o = a.Renderer;
    this.key = r, this.options = a, this.style = n, i ? this.renderer = i.renderer : o && (this.renderer = new o());
  }
  var t = e.prototype;
  return t.prop = function(n, a, i) {
    if (a === void 0) return this.style[n];
    var o = i ? i.force : !1;
    if (!o && this.style[n] === a) return this;
    var u = a;
    (!i || i.process !== !1) && (u = this.options.jss.plugins.onChangeValue(a, n, this));
    var s = u == null || u === !1, c = n in this.style;
    if (s && !c && !o) return this;
    var l = s && c;
    if (l ? delete this.style[n] : this.style[n] = u, this.renderable && this.renderer)
      return l ? this.renderer.removeProperty(this.renderable, n) : this.renderer.setProperty(this.renderable, n, u), this;
    var f = this.options.sheet;
    return f && f.attached && process.env.NODE_ENV !== "production" && cr(!1, '[JSS] Rule is not linked. Missing sheet option "link: true".'), this;
  }, e;
}(), wf = /* @__PURE__ */ function(e) {
  Cy(t, e);
  function t(n, a, i) {
    var o;
    o = e.call(this, n, a, i) || this;
    var u = i.selector, s = i.scoped, c = i.sheet, l = i.generateId;
    return u ? o.selectorText = u : s !== !1 && (o.id = l(Eh(Eh(o)), c), o.selectorText = "." + O1(o.id)), o;
  }
  var r = t.prototype;
  return r.applyTo = function(a) {
    var i = this.renderer;
    if (i) {
      var o = this.toJSON();
      for (var u in o)
        i.setProperty(a, u, o[u]);
    }
    return this;
  }, r.toJSON = function() {
    var a = {};
    for (var i in this.style) {
      var o = this.style[i];
      typeof o != "object" ? a[i] = o : Array.isArray(o) && (a[i] = Un(o));
    }
    return a;
  }, r.toString = function(a) {
    var i = this.options.sheet, o = i ? i.options.link : !1, u = o ? Ce({}, a, {
      allowEmpty: !0
    }) : a;
    return io(this.selectorText, this.style, u);
  }, xy(t, [{
    key: "selector",
    set: function(a) {
      if (a !== this.selectorText) {
        this.selectorText = a;
        var i = this.renderer, o = this.renderable;
        if (!(!o || !i)) {
          var u = i.setSelector(o, a);
          u || i.replaceRule(o, this);
        }
      }
    },
    get: function() {
      return this.selectorText;
    }
  }]), t;
}(wy), S7 = {
  onCreateRule: function(t, r, n) {
    return t[0] === "@" || n.parent && n.parent.type === "keyframes" ? null : new wf(t, r, n);
  }
}, qc = {
  indent: 1,
  children: !0
}, A7 = /@([\w-]+)/, E7 = /* @__PURE__ */ function() {
  function e(r, n, a) {
    this.type = "conditional", this.isProcessed = !1, this.key = r;
    var i = r.match(A7);
    this.at = i ? i[1] : "unknown", this.query = a.name || "@" + this.at, this.options = a, this.rules = new Js(Ce({}, a, {
      parent: this
    }));
    for (var o in n)
      this.rules.add(o, n[o]);
    this.rules.process();
  }
  var t = e.prototype;
  return t.getRule = function(n) {
    return this.rules.get(n);
  }, t.indexOf = function(n) {
    return this.rules.indexOf(n);
  }, t.addRule = function(n, a, i) {
    var o = this.rules.add(n, a, i);
    return o ? (this.options.jss.plugins.onProcessRule(o), o) : null;
  }, t.replaceRule = function(n, a, i) {
    var o = this.rules.replace(n, a, i);
    return o && this.options.jss.plugins.onProcessRule(o), o;
  }, t.toString = function(n) {
    n === void 0 && (n = qc);
    var a = Ka(n), i = a.linebreak;
    if (n.indent == null && (n.indent = qc.indent), n.children == null && (n.children = qc.children), n.children === !1)
      return this.query + " {}";
    var o = this.rules.toString(n);
    return o ? this.query + " {" + i + o + i + "}" : "";
  }, e;
}(), _7 = /@container|@media|@supports\s+/, I7 = {
  onCreateRule: function(t, r, n) {
    return _7.test(t) ? new E7(t, r, n) : null;
  }
}, Jc = {
  indent: 1,
  children: !0
}, P7 = /@keyframes\s+([\w-]+)/, Of = /* @__PURE__ */ function() {
  function e(r, n, a) {
    this.type = "keyframes", this.at = "@keyframes", this.isProcessed = !1;
    var i = r.match(P7);
    i && i[1] ? this.name = i[1] : (this.name = "noname", process.env.NODE_ENV !== "production" && cr(!1, "[JSS] Bad keyframes name " + r)), this.key = this.type + "-" + this.name, this.options = a;
    var o = a.scoped, u = a.sheet, s = a.generateId;
    this.id = o === !1 ? this.name : O1(s(this, u)), this.rules = new Js(Ce({}, a, {
      parent: this
    }));
    for (var c in n)
      this.rules.add(c, n[c], Ce({}, a, {
        parent: this
      }));
    this.rules.process();
  }
  var t = e.prototype;
  return t.toString = function(n) {
    n === void 0 && (n = Jc);
    var a = Ka(n), i = a.linebreak;
    if (n.indent == null && (n.indent = Jc.indent), n.children == null && (n.children = Jc.children), n.children === !1)
      return this.at + " " + this.id + " {}";
    var o = this.rules.toString(n);
    return o && (o = "" + i + o + i), this.at + " " + this.id + " {" + o + "}";
  }, e;
}(), T7 = /@keyframes\s+/, M7 = /\$([\w-]+)/g, Sf = function(t, r) {
  return typeof t == "string" ? t.replace(M7, function(n, a) {
    return a in r ? r[a] : (process.env.NODE_ENV !== "production" && cr(!1, '[JSS] Referenced keyframes rule "' + a + '" is not defined.'), n);
  }) : t;
}, Ph = function(t, r, n) {
  var a = t[r], i = Sf(a, n);
  i !== a && (t[r] = i);
}, j7 = {
  onCreateRule: function(t, r, n) {
    return typeof t == "string" && T7.test(t) ? new Of(t, r, n) : null;
  },
  // Animation name ref replacer.
  onProcessStyle: function(t, r, n) {
    return r.type !== "style" || !n || ("animation-name" in t && Ph(t, "animation-name", n.keyframes), "animation" in t && Ph(t, "animation", n.keyframes)), t;
  },
  onChangeValue: function(t, r, n) {
    var a = n.options.sheet;
    if (!a)
      return t;
    switch (r) {
      case "animation":
        return Sf(t, a.keyframes);
      case "animation-name":
        return Sf(t, a.keyframes);
      default:
        return t;
    }
  }
}, R7 = /* @__PURE__ */ function(e) {
  Cy(t, e);
  function t() {
    return e.apply(this, arguments) || this;
  }
  var r = t.prototype;
  return r.toString = function(a) {
    var i = this.options.sheet, o = i ? i.options.link : !1, u = o ? Ce({}, a, {
      allowEmpty: !0
    }) : a;
    return io(this.key, this.style, u);
  }, t;
}(wy), N7 = {
  onCreateRule: function(t, r, n) {
    return n.parent && n.parent.type === "keyframes" ? new R7(t, r, n) : null;
  }
}, $7 = /* @__PURE__ */ function() {
  function e(r, n, a) {
    this.type = "font-face", this.at = "@font-face", this.isProcessed = !1, this.key = r, this.style = n, this.options = a;
  }
  var t = e.prototype;
  return t.toString = function(n) {
    var a = Ka(n), i = a.linebreak;
    if (Array.isArray(this.style)) {
      for (var o = "", u = 0; u < this.style.length; u++)
        o += io(this.at, this.style[u]), this.style[u + 1] && (o += i);
      return o;
    }
    return io(this.at, this.style, n);
  }, e;
}(), F7 = /@font-face/, D7 = {
  onCreateRule: function(t, r, n) {
    return F7.test(t) ? new $7(t, r, n) : null;
  }
}, k7 = /* @__PURE__ */ function() {
  function e(r, n, a) {
    this.type = "viewport", this.at = "@viewport", this.isProcessed = !1, this.key = r, this.style = n, this.options = a;
  }
  var t = e.prototype;
  return t.toString = function(n) {
    return io(this.key, this.style, n);
  }, e;
}(), L7 = {
  onCreateRule: function(t, r, n) {
    return t === "@viewport" || t === "@-ms-viewport" ? new k7(t, r, n) : null;
  }
}, B7 = /* @__PURE__ */ function() {
  function e(r, n, a) {
    this.type = "simple", this.isProcessed = !1, this.key = r, this.value = n, this.options = a;
  }
  var t = e.prototype;
  return t.toString = function(n) {
    if (Array.isArray(this.value)) {
      for (var a = "", i = 0; i < this.value.length; i++)
        a += this.key + " " + this.value[i] + ";", this.value[i + 1] && (a += `
`);
      return a;
    }
    return this.key + " " + this.value + ";";
  }, e;
}(), V7 = {
  "@charset": !0,
  "@import": !0,
  "@namespace": !0
}, W7 = {
  onCreateRule: function(t, r, n) {
    return t in V7 ? new B7(t, r, n) : null;
  }
}, Th = [S7, I7, j7, N7, D7, L7, W7], G7 = {
  process: !0
}, Mh = {
  force: !0,
  process: !0
  /**
   * Contains rules objects and allows adding/removing etc.
   * Is used for e.g. by `StyleSheet` or `ConditionalRule`.
   */
}, Js = /* @__PURE__ */ function() {
  function e(r) {
    this.map = {}, this.raw = {}, this.index = [], this.counter = 0, this.options = r, this.classes = r.classes, this.keyframes = r.keyframes;
  }
  var t = e.prototype;
  return t.add = function(n, a, i) {
    var o = this.options, u = o.parent, s = o.sheet, c = o.jss, l = o.Renderer, f = o.generateId, d = o.scoped, p = Ce({
      classes: this.classes,
      parent: u,
      sheet: s,
      jss: c,
      Renderer: l,
      generateId: f,
      scoped: d,
      name: n,
      keyframes: this.keyframes,
      selector: void 0
    }, i), h = n;
    n in this.raw && (h = n + "-d" + this.counter++), this.raw[h] = a, h in this.classes && (p.selector = "." + O1(this.classes[h]));
    var v = w1(h, a, p);
    if (!v) return null;
    this.register(v);
    var g = p.index === void 0 ? this.index.length : p.index;
    return this.index.splice(g, 0, v), v;
  }, t.replace = function(n, a, i) {
    var o = this.get(n), u = this.index.indexOf(o);
    o && this.remove(o);
    var s = i;
    return u !== -1 && (s = Ce({}, i, {
      index: u
    })), this.add(n, a, s);
  }, t.get = function(n) {
    return this.map[n];
  }, t.remove = function(n) {
    this.unregister(n), delete this.raw[n.key], this.index.splice(this.index.indexOf(n), 1);
  }, t.indexOf = function(n) {
    return this.index.indexOf(n);
  }, t.process = function() {
    var n = this.options.jss.plugins;
    this.index.slice(0).forEach(n.onProcessRule, n);
  }, t.register = function(n) {
    this.map[n.key] = n, n instanceof wf ? (this.map[n.selector] = n, n.id && (this.classes[n.key] = n.id)) : n instanceof Of && this.keyframes && (this.keyframes[n.name] = n.id);
  }, t.unregister = function(n) {
    delete this.map[n.key], n instanceof wf ? (delete this.map[n.selector], delete this.classes[n.key]) : n instanceof Of && delete this.keyframes[n.name];
  }, t.update = function() {
    var n, a, i;
    if (typeof (arguments.length <= 0 ? void 0 : arguments[0]) == "string" ? (n = arguments.length <= 0 ? void 0 : arguments[0], a = arguments.length <= 1 ? void 0 : arguments[1], i = arguments.length <= 2 ? void 0 : arguments[2]) : (a = arguments.length <= 0 ? void 0 : arguments[0], i = arguments.length <= 1 ? void 0 : arguments[1], n = null), n)
      this.updateOne(this.get(n), a, i);
    else
      for (var o = 0; o < this.index.length; o++)
        this.updateOne(this.index[o], a, i);
  }, t.updateOne = function(n, a, i) {
    i === void 0 && (i = G7);
    var o = this.options, u = o.jss.plugins, s = o.sheet;
    if (n.rules instanceof e) {
      n.rules.update(a, i);
      return;
    }
    var c = n.style;
    if (u.onUpdate(a, n, s, i), i.process && c && c !== n.style) {
      u.onProcessStyle(n.style, n, s);
      for (var l in n.style) {
        var f = n.style[l], d = c[l];
        f !== d && n.prop(l, f, Mh);
      }
      for (var p in c) {
        var h = n.style[p], v = c[p];
        h == null && h !== v && n.prop(p, null, Mh);
      }
    }
  }, t.toString = function(n) {
    for (var a = "", i = this.options.sheet, o = i ? i.options.link : !1, u = Ka(n), s = u.linebreak, c = 0; c < this.index.length; c++) {
      var l = this.index[c], f = l.toString(n);
      !f && !o || (a && (a += s), a += f);
    }
    return a;
  }, e;
}(), Oy = /* @__PURE__ */ function() {
  function e(r, n) {
    this.attached = !1, this.deployed = !1, this.classes = {}, this.keyframes = {}, this.options = Ce({}, n, {
      sheet: this,
      parent: this,
      classes: this.classes,
      keyframes: this.keyframes
    }), n.Renderer && (this.renderer = new n.Renderer(this)), this.rules = new Js(this.options);
    for (var a in r)
      this.rules.add(a, r[a]);
    this.rules.process();
  }
  var t = e.prototype;
  return t.attach = function() {
    return this.attached ? this : (this.renderer && this.renderer.attach(), this.attached = !0, this.deployed || this.deploy(), this);
  }, t.detach = function() {
    return this.attached ? (this.renderer && this.renderer.detach(), this.attached = !1, this) : this;
  }, t.addRule = function(n, a, i) {
    var o = this.queue;
    this.attached && !o && (this.queue = []);
    var u = this.rules.add(n, a, i);
    return u ? (this.options.jss.plugins.onProcessRule(u), this.attached ? (this.deployed && (o ? o.push(u) : (this.insertRule(u), this.queue && (this.queue.forEach(this.insertRule, this), this.queue = void 0))), u) : (this.deployed = !1, u)) : null;
  }, t.replaceRule = function(n, a, i) {
    var o = this.rules.get(n);
    if (!o) return this.addRule(n, a, i);
    var u = this.rules.replace(n, a, i);
    return u && this.options.jss.plugins.onProcessRule(u), this.attached ? (this.deployed && this.renderer && (u ? o.renderable && this.renderer.replaceRule(o.renderable, u) : this.renderer.deleteRule(o)), u) : (this.deployed = !1, u);
  }, t.insertRule = function(n) {
    this.renderer && this.renderer.insertRule(n);
  }, t.addRules = function(n, a) {
    var i = [];
    for (var o in n) {
      var u = this.addRule(o, n[o], a);
      u && i.push(u);
    }
    return i;
  }, t.getRule = function(n) {
    return this.rules.get(n);
  }, t.deleteRule = function(n) {
    var a = typeof n == "object" ? n : this.rules.get(n);
    return !a || // Style sheet was created without link: true and attached, in this case we
    // won't be able to remove the CSS rule from the DOM.
    this.attached && !a.renderable ? !1 : (this.rules.remove(a), this.attached && a.renderable && this.renderer ? this.renderer.deleteRule(a.renderable) : !0);
  }, t.indexOf = function(n) {
    return this.rules.indexOf(n);
  }, t.deploy = function() {
    return this.renderer && this.renderer.deploy(), this.deployed = !0, this;
  }, t.update = function() {
    var n;
    return (n = this.rules).update.apply(n, arguments), this;
  }, t.updateOne = function(n, a, i) {
    return this.rules.updateOne(n, a, i), this;
  }, t.toString = function(n) {
    return this.rules.toString(n);
  }, e;
}(), H7 = /* @__PURE__ */ function() {
  function e() {
    this.plugins = {
      internal: [],
      external: []
    }, this.registry = {};
  }
  var t = e.prototype;
  return t.onCreateRule = function(n, a, i) {
    for (var o = 0; o < this.registry.onCreateRule.length; o++) {
      var u = this.registry.onCreateRule[o](n, a, i);
      if (u) return u;
    }
    return null;
  }, t.onProcessRule = function(n) {
    if (!n.isProcessed) {
      for (var a = n.options.sheet, i = 0; i < this.registry.onProcessRule.length; i++)
        this.registry.onProcessRule[i](n, a);
      n.style && this.onProcessStyle(n.style, n, a), n.isProcessed = !0;
    }
  }, t.onProcessStyle = function(n, a, i) {
    for (var o = 0; o < this.registry.onProcessStyle.length; o++)
      a.style = this.registry.onProcessStyle[o](a.style, a, i);
  }, t.onProcessSheet = function(n) {
    for (var a = 0; a < this.registry.onProcessSheet.length; a++)
      this.registry.onProcessSheet[a](n);
  }, t.onUpdate = function(n, a, i, o) {
    for (var u = 0; u < this.registry.onUpdate.length; u++)
      this.registry.onUpdate[u](n, a, i, o);
  }, t.onChangeValue = function(n, a, i) {
    for (var o = n, u = 0; u < this.registry.onChangeValue.length; u++)
      o = this.registry.onChangeValue[u](o, a, i);
    return o;
  }, t.use = function(n, a) {
    a === void 0 && (a = {
      queue: "external"
    });
    var i = this.plugins[a.queue];
    i.indexOf(n) === -1 && (i.push(n), this.registry = [].concat(this.plugins.external, this.plugins.internal).reduce(function(o, u) {
      for (var s in u)
        s in o ? o[s].push(u[s]) : process.env.NODE_ENV !== "production" && cr(!1, '[JSS] Unknown hook "' + s + '".');
      return o;
    }, {
      onCreateRule: [],
      onProcessRule: [],
      onProcessStyle: [],
      onProcessSheet: [],
      onChangeValue: [],
      onUpdate: []
    }));
  }, e;
}(), U7 = /* @__PURE__ */ function() {
  function e() {
    this.registry = [];
  }
  var t = e.prototype;
  return t.add = function(n) {
    var a = this.registry, i = n.options.index;
    if (a.indexOf(n) === -1) {
      if (a.length === 0 || i >= this.index) {
        a.push(n);
        return;
      }
      for (var o = 0; o < a.length; o++)
        if (a[o].options.index > i) {
          a.splice(o, 0, n);
          return;
        }
    }
  }, t.reset = function() {
    this.registry = [];
  }, t.remove = function(n) {
    var a = this.registry.indexOf(n);
    this.registry.splice(a, 1);
  }, t.toString = function(n) {
    for (var a = n === void 0 ? {} : n, i = a.attached, o = yy(a, ["attached"]), u = Ka(o), s = u.linebreak, c = "", l = 0; l < this.registry.length; l++) {
      var f = this.registry[l];
      i != null && f.attached !== i || (c && (c += s), c += f.toString(o));
    }
    return c;
  }, xy(e, [{
    key: "index",
    /**
     * Current highest index number.
     */
    get: function() {
      return this.registry.length === 0 ? 0 : this.registry[this.registry.length - 1].options.index;
    }
  }]), e;
}(), Yi = new U7(), Af = typeof globalThis < "u" ? globalThis : typeof window < "u" && window.Math === Math ? window : typeof self < "u" && self.Math === Math ? self : Function("return this")(), Ef = "2f1acc6c3a606b082e5eef5e54414ffb";
Af[Ef] == null && (Af[Ef] = 0);
var jh = Af[Ef]++, z7 = 1e10, Rh = function(t) {
  t === void 0 && (t = {});
  var r = 0, n = function(i, o) {
    r += 1, r > z7 && process.env.NODE_ENV !== "production" && cr(!1, "[JSS] You might have a memory leak. Rule counter is at " + r + ".");
    var u = "", s = "";
    return o && (o.options.classNamePrefix && (s = o.options.classNamePrefix), o.options.jss.id != null && (u = String(o.options.jss.id))), t.minify ? "" + (s || "c") + jh + u + r : s + i.key + "-" + jh + (u ? "-" + u : "") + "-" + r;
  };
  return n;
}, Sy = function(t) {
  var r;
  return function() {
    return r || (r = t()), r;
  };
}, Y7 = function(t, r) {
  try {
    return t.attributeStyleMap ? t.attributeStyleMap.get(r) : t.style.getPropertyValue(r);
  } catch {
    return "";
  }
}, X7 = function(t, r, n) {
  try {
    var a = n;
    if (Array.isArray(n) && (a = Un(n)), t.attributeStyleMap)
      t.attributeStyleMap.set(r, a);
    else {
      var i = a ? a.indexOf("!important") : -1, o = i > -1 ? a.substr(0, i - 1) : a;
      t.style.setProperty(r, o, i > -1 ? "important" : "");
    }
  } catch {
    return !1;
  }
  return !0;
}, Z7 = function(t, r) {
  try {
    t.attributeStyleMap ? t.attributeStyleMap.delete(r) : t.style.removeProperty(r);
  } catch (n) {
    process.env.NODE_ENV !== "production" && cr(!1, '[JSS] DOMException "' + n.message + '" was thrown. Tried to remove property "' + r + '".');
  }
}, K7 = function(t, r) {
  return t.selectorText = r, t.selectorText === r;
}, Ay = Sy(function() {
  return document.querySelector("head");
});
function q7(e, t) {
  for (var r = 0; r < e.length; r++) {
    var n = e[r];
    if (n.attached && n.options.index > t.index && n.options.insertionPoint === t.insertionPoint)
      return n;
  }
  return null;
}
function J7(e, t) {
  for (var r = e.length - 1; r >= 0; r--) {
    var n = e[r];
    if (n.attached && n.options.insertionPoint === t.insertionPoint)
      return n;
  }
  return null;
}
function Q7(e) {
  for (var t = Ay(), r = 0; r < t.childNodes.length; r++) {
    var n = t.childNodes[r];
    if (n.nodeType === 8 && n.nodeValue.trim() === e)
      return n;
  }
  return null;
}
function ex(e) {
  var t = Yi.registry;
  if (t.length > 0) {
    var r = q7(t, e);
    if (r && r.renderer)
      return {
        parent: r.renderer.element.parentNode,
        node: r.renderer.element
      };
    if (r = J7(t, e), r && r.renderer)
      return {
        parent: r.renderer.element.parentNode,
        node: r.renderer.element.nextSibling
      };
  }
  var n = e.insertionPoint;
  if (n && typeof n == "string") {
    var a = Q7(n);
    if (a)
      return {
        parent: a.parentNode,
        node: a.nextSibling
      };
    process.env.NODE_ENV !== "production" && cr(!1, '[JSS] Insertion point "' + n + '" not found.');
  }
  return !1;
}
function tx(e, t) {
  var r = t.insertionPoint, n = ex(t);
  if (n !== !1 && n.parent) {
    n.parent.insertBefore(e, n.node);
    return;
  }
  if (r && typeof r.nodeType == "number") {
    var a = r, i = a.parentNode;
    i ? i.insertBefore(e, a.nextSibling) : process.env.NODE_ENV !== "production" && cr(!1, "[JSS] Insertion point is not in the DOM.");
    return;
  }
  Ay().appendChild(e);
}
var rx = Sy(function() {
  var e = document.querySelector('meta[property="csp-nonce"]');
  return e ? e.getAttribute("content") : null;
}), Nh = function(t, r, n) {
  try {
    "insertRule" in t ? t.insertRule(r, n) : "appendRule" in t && t.appendRule(r);
  } catch (a) {
    return process.env.NODE_ENV !== "production" && cr(!1, "[JSS] " + a.message), !1;
  }
  return t.cssRules[n];
}, $h = function(t, r) {
  var n = t.cssRules.length;
  return r === void 0 || r > n ? n : r;
}, nx = function() {
  var t = document.createElement("style");
  return t.textContent = `
`, t;
}, ax = /* @__PURE__ */ function() {
  function e(r) {
    this.getPropertyValue = Y7, this.setProperty = X7, this.removeProperty = Z7, this.setSelector = K7, this.hasInsertedRules = !1, this.cssRules = [], r && Yi.add(r), this.sheet = r;
    var n = this.sheet ? this.sheet.options : {}, a = n.media, i = n.meta, o = n.element;
    this.element = o || nx(), this.element.setAttribute("data-jss", ""), a && this.element.setAttribute("media", a), i && this.element.setAttribute("data-meta", i);
    var u = rx();
    u && this.element.setAttribute("nonce", u);
  }
  var t = e.prototype;
  return t.attach = function() {
    if (!(this.element.parentNode || !this.sheet)) {
      tx(this.element, this.sheet.options);
      var n = !!(this.sheet && this.sheet.deployed);
      this.hasInsertedRules && n && (this.hasInsertedRules = !1, this.deploy());
    }
  }, t.detach = function() {
    if (this.sheet) {
      var n = this.element.parentNode;
      n && n.removeChild(this.element), this.sheet.options.link && (this.cssRules = [], this.element.textContent = `
`);
    }
  }, t.deploy = function() {
    var n = this.sheet;
    if (n) {
      if (n.options.link) {
        this.insertRules(n.rules);
        return;
      }
      this.element.textContent = `
` + n.toString() + `
`;
    }
  }, t.insertRules = function(n, a) {
    for (var i = 0; i < n.index.length; i++)
      this.insertRule(n.index[i], i, a);
  }, t.insertRule = function(n, a, i) {
    if (i === void 0 && (i = this.element.sheet), n.rules) {
      var o = n, u = i;
      if (n.type === "conditional" || n.type === "keyframes") {
        var s = $h(i, a);
        if (u = Nh(i, o.toString({
          children: !1
        }), s), u === !1)
          return !1;
        this.refCssRule(n, s, u);
      }
      return this.insertRules(o.rules, u), u;
    }
    var c = n.toString();
    if (!c) return !1;
    var l = $h(i, a), f = Nh(i, c, l);
    return f === !1 ? !1 : (this.hasInsertedRules = !0, this.refCssRule(n, l, f), f);
  }, t.refCssRule = function(n, a, i) {
    n.renderable = i, n.options.parent instanceof Oy && this.cssRules.splice(a, 0, i);
  }, t.deleteRule = function(n) {
    var a = this.element.sheet, i = this.indexOf(n);
    return i === -1 ? !1 : (a.deleteRule(i), this.cssRules.splice(i, 1), !0);
  }, t.indexOf = function(n) {
    return this.cssRules.indexOf(n);
  }, t.replaceRule = function(n, a) {
    var i = this.indexOf(n);
    return i === -1 ? !1 : (this.element.sheet.deleteRule(i), this.cssRules.splice(i, 1), this.insertRule(a, i));
  }, t.getRules = function() {
    return this.element.sheet.cssRules;
  }, e;
}(), ix = 0, ox = /* @__PURE__ */ function() {
  function e(r) {
    this.id = ix++, this.version = "10.10.0", this.plugins = new H7(), this.options = {
      id: {
        minify: !1
      },
      createGenerateId: Rh,
      Renderer: Jo ? ax : null,
      plugins: []
    }, this.generateId = Rh({
      minify: !1
    });
    for (var n = 0; n < Th.length; n++)
      this.plugins.use(Th[n], {
        queue: "internal"
      });
    this.setup(r);
  }
  var t = e.prototype;
  return t.setup = function(n) {
    return n === void 0 && (n = {}), n.createGenerateId && (this.options.createGenerateId = n.createGenerateId), n.id && (this.options.id = Ce({}, this.options.id, n.id)), (n.createGenerateId || n.id) && (this.generateId = this.options.createGenerateId(this.options.id)), n.insertionPoint != null && (this.options.insertionPoint = n.insertionPoint), "Renderer" in n && (this.options.Renderer = n.Renderer), n.plugins && this.use.apply(this, n.plugins), this;
  }, t.createStyleSheet = function(n, a) {
    a === void 0 && (a = {});
    var i = a, o = i.index;
    typeof o != "number" && (o = Yi.index === 0 ? 0 : Yi.index + 1);
    var u = new Oy(n, Ce({}, a, {
      jss: this,
      generateId: a.generateId || this.generateId,
      insertionPoint: this.options.insertionPoint,
      Renderer: this.options.Renderer,
      index: o
    }));
    return this.plugins.onProcessSheet(u), u;
  }, t.removeStyleSheet = function(n) {
    return n.detach(), Yi.remove(n), this;
  }, t.createRule = function(n, a, i) {
    if (a === void 0 && (a = {}), i === void 0 && (i = {}), typeof n == "object")
      return this.createRule(void 0, n, a);
    var o = Ce({}, i, {
      name: n,
      jss: this,
      Renderer: this.options.Renderer
    });
    o.generateId || (o.generateId = this.generateId), o.classes || (o.classes = {}), o.keyframes || (o.keyframes = {});
    var u = w1(n, a, o);
    return u && this.plugins.onProcessRule(u), u;
  }, t.use = function() {
    for (var n = this, a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return i.forEach(function(u) {
      n.plugins.use(u);
    }), this;
  }, e;
}(), S1 = function(t) {
  return new ox(t);
}, A1 = typeof CSS == "object" && CSS != null && "number" in CSS;
function Ey(e) {
  var t = null;
  for (var r in e) {
    var n = e[r], a = typeof n;
    if (a === "function")
      t || (t = {}), t[r] = n;
    else if (a === "object" && n !== null && !Array.isArray(n)) {
      var i = Ey(n);
      i && (t || (t = {}), t[r] = i);
    }
  }
  return t;
}
/**
 * A better abstraction over CSS.
 *
 * @copyright Oleg Isonen (Slobodskoi) / Isonen 2014-present
 * @website https://github.com/cssinjs/jss
 * @license MIT
 */
S1();
var _y = Date.now(), Qc = "fnValues" + _y, el = "fnStyle" + ++_y, ux = function() {
  return {
    onCreateRule: function(r, n, a) {
      if (typeof n != "function") return null;
      var i = w1(r, {}, a);
      return i[el] = n, i;
    },
    onProcessStyle: function(r, n) {
      if (Qc in n || el in n) return r;
      var a = {};
      for (var i in r) {
        var o = r[i];
        typeof o == "function" && (delete r[i], a[i] = o);
      }
      return n[Qc] = a, r;
    },
    onUpdate: function(r, n, a, i) {
      var o = n, u = o[el];
      if (u && (o.style = u(r) || {}, process.env.NODE_ENV === "development")) {
        for (var s in o.style)
          if (typeof o.style[s] == "function") {
            process.env.NODE_ENV !== "production" && cr(!1, "[JSS] Function values inside function rules are not supported.");
            break;
          }
      }
      var c = o[Qc];
      if (c)
        for (var l in c)
          o.prop(l, c[l](r), i);
    }
  };
}, pn = "@global", _f = "@global ", sx = /* @__PURE__ */ function() {
  function e(r, n, a) {
    this.type = "global", this.at = pn, this.isProcessed = !1, this.key = r, this.options = a, this.rules = new Js(Ce({}, a, {
      parent: this
    }));
    for (var i in n)
      this.rules.add(i, n[i]);
    this.rules.process();
  }
  var t = e.prototype;
  return t.getRule = function(n) {
    return this.rules.get(n);
  }, t.addRule = function(n, a, i) {
    var o = this.rules.add(n, a, i);
    return o && this.options.jss.plugins.onProcessRule(o), o;
  }, t.replaceRule = function(n, a, i) {
    var o = this.rules.replace(n, a, i);
    return o && this.options.jss.plugins.onProcessRule(o), o;
  }, t.indexOf = function(n) {
    return this.rules.indexOf(n);
  }, t.toString = function(n) {
    return this.rules.toString(n);
  }, e;
}(), cx = /* @__PURE__ */ function() {
  function e(r, n, a) {
    this.type = "global", this.at = pn, this.isProcessed = !1, this.key = r, this.options = a;
    var i = r.substr(_f.length);
    this.rule = a.jss.createRule(i, n, Ce({}, a, {
      parent: this
    }));
  }
  var t = e.prototype;
  return t.toString = function(n) {
    return this.rule ? this.rule.toString(n) : "";
  }, e;
}(), lx = /\s*,\s*/g;
function Iy(e, t) {
  for (var r = e.split(lx), n = "", a = 0; a < r.length; a++)
    n += t + " " + r[a].trim(), r[a + 1] && (n += ", ");
  return n;
}
function fx(e, t) {
  var r = e.options, n = e.style, a = n ? n[pn] : null;
  if (a) {
    for (var i in a)
      t.addRule(i, a[i], Ce({}, r, {
        selector: Iy(i, e.selector)
      }));
    delete n[pn];
  }
}
function dx(e, t) {
  var r = e.options, n = e.style;
  for (var a in n)
    if (!(a[0] !== "@" || a.substr(0, pn.length) !== pn)) {
      var i = Iy(a.substr(pn.length), e.selector);
      t.addRule(i, n[a], Ce({}, r, {
        selector: i
      })), delete n[a];
    }
}
function px() {
  function e(r, n, a) {
    if (!r) return null;
    if (r === pn)
      return new sx(r, n, a);
    if (r[0] === "@" && r.substr(0, _f.length) === _f)
      return new cx(r, n, a);
    var i = a.parent;
    return i && (i.type === "global" || i.options.parent && i.options.parent.type === "global") && (a.scoped = !1), !a.selector && a.scoped === !1 && (a.selector = r), null;
  }
  function t(r, n) {
    r.type !== "style" || !n || (fx(r, n), dx(r, n));
  }
  return {
    onCreateRule: e,
    onProcessRule: t
  };
}
var Fh = /\s*,\s*/g, hx = /&/g, vx = /\$([\w-]+)/g;
function gx() {
  function e(a, i) {
    return function(o, u) {
      var s = a.getRule(u) || i && i.getRule(u);
      return s ? s.selector : (process.env.NODE_ENV !== "production" && cr(!1, '[JSS] Could not find the referenced rule "' + u + '" in "' + (a.options.meta || a.toString()) + '".'), u);
    };
  }
  function t(a, i) {
    for (var o = i.split(Fh), u = a.split(Fh), s = "", c = 0; c < o.length; c++)
      for (var l = o[c], f = 0; f < u.length; f++) {
        var d = u[f];
        s && (s += ", "), s += d.indexOf("&") !== -1 ? d.replace(hx, l) : l + " " + d;
      }
    return s;
  }
  function r(a, i, o) {
    if (o) return Ce({}, o, {
      index: o.index + 1
    });
    var u = a.options.nestingLevel;
    u = u === void 0 ? 1 : u + 1;
    var s = Ce({}, a.options, {
      nestingLevel: u,
      index: i.indexOf(a) + 1
      // We don't need the parent name to be set options for chlid.
    });
    return delete s.name, s;
  }
  function n(a, i, o) {
    if (i.type !== "style") return a;
    var u = i, s = u.options.parent, c, l;
    for (var f in a) {
      var d = f.indexOf("&") !== -1, p = f[0] === "@";
      if (!(!d && !p)) {
        if (c = r(u, s, c), d) {
          var h = t(f, u.selector);
          l || (l = e(s, o)), h = h.replace(vx, l);
          var v = u.key + "-" + f;
          "replaceRule" in s ? s.replaceRule(v, a[f], Ce({}, c, {
            selector: h
          })) : s.addRule(v, a[f], Ce({}, c, {
            selector: h
          }));
        } else p && s.addRule(f, {}, c).addRule(u.key, a[f], {
          selector: u.selector
        });
        delete a[f];
      }
    }
    return a;
  }
  return {
    onProcessStyle: n
  };
}
var mx = /[A-Z]/g, yx = /^ms-/, tl = {};
function bx(e) {
  return "-" + e.toLowerCase();
}
function Py(e) {
  if (tl.hasOwnProperty(e))
    return tl[e];
  var t = e.replace(mx, bx);
  return tl[e] = yx.test(t) ? "-" + t : t;
}
function Hu(e) {
  var t = {};
  for (var r in e) {
    var n = r.indexOf("--") === 0 ? r : Py(r);
    t[n] = e[r];
  }
  return e.fallbacks && (Array.isArray(e.fallbacks) ? t.fallbacks = e.fallbacks.map(Hu) : t.fallbacks = Hu(e.fallbacks)), t;
}
function xx() {
  function e(r) {
    if (Array.isArray(r)) {
      for (var n = 0; n < r.length; n++)
        r[n] = Hu(r[n]);
      return r;
    }
    return Hu(r);
  }
  function t(r, n, a) {
    if (n.indexOf("--") === 0)
      return r;
    var i = Py(n);
    return n === i ? r : (a.prop(i, r), null);
  }
  return {
    onProcessStyle: e,
    onChangeValue: t
  };
}
var ee = A1 && CSS ? CSS.px : "px", vu = A1 && CSS ? CSS.ms : "ms", ia = A1 && CSS ? CSS.percent : "%", Cx = {
  // Animation properties
  "animation-delay": vu,
  "animation-duration": vu,
  // Background properties
  "background-position": ee,
  "background-position-x": ee,
  "background-position-y": ee,
  "background-size": ee,
  // Border Properties
  border: ee,
  "border-bottom": ee,
  "border-bottom-left-radius": ee,
  "border-bottom-right-radius": ee,
  "border-bottom-width": ee,
  "border-left": ee,
  "border-left-width": ee,
  "border-radius": ee,
  "border-right": ee,
  "border-right-width": ee,
  "border-top": ee,
  "border-top-left-radius": ee,
  "border-top-right-radius": ee,
  "border-top-width": ee,
  "border-width": ee,
  "border-block": ee,
  "border-block-end": ee,
  "border-block-end-width": ee,
  "border-block-start": ee,
  "border-block-start-width": ee,
  "border-block-width": ee,
  "border-inline": ee,
  "border-inline-end": ee,
  "border-inline-end-width": ee,
  "border-inline-start": ee,
  "border-inline-start-width": ee,
  "border-inline-width": ee,
  "border-start-start-radius": ee,
  "border-start-end-radius": ee,
  "border-end-start-radius": ee,
  "border-end-end-radius": ee,
  // Margin properties
  margin: ee,
  "margin-bottom": ee,
  "margin-left": ee,
  "margin-right": ee,
  "margin-top": ee,
  "margin-block": ee,
  "margin-block-end": ee,
  "margin-block-start": ee,
  "margin-inline": ee,
  "margin-inline-end": ee,
  "margin-inline-start": ee,
  // Padding properties
  padding: ee,
  "padding-bottom": ee,
  "padding-left": ee,
  "padding-right": ee,
  "padding-top": ee,
  "padding-block": ee,
  "padding-block-end": ee,
  "padding-block-start": ee,
  "padding-inline": ee,
  "padding-inline-end": ee,
  "padding-inline-start": ee,
  // Mask properties
  "mask-position-x": ee,
  "mask-position-y": ee,
  "mask-size": ee,
  // Width and height properties
  height: ee,
  width: ee,
  "min-height": ee,
  "max-height": ee,
  "min-width": ee,
  "max-width": ee,
  // Position properties
  bottom: ee,
  left: ee,
  top: ee,
  right: ee,
  inset: ee,
  "inset-block": ee,
  "inset-block-end": ee,
  "inset-block-start": ee,
  "inset-inline": ee,
  "inset-inline-end": ee,
  "inset-inline-start": ee,
  // Shadow properties
  "box-shadow": ee,
  "text-shadow": ee,
  // Column properties
  "column-gap": ee,
  "column-rule": ee,
  "column-rule-width": ee,
  "column-width": ee,
  // Font and text properties
  "font-size": ee,
  "font-size-delta": ee,
  "letter-spacing": ee,
  "text-decoration-thickness": ee,
  "text-indent": ee,
  "text-stroke": ee,
  "text-stroke-width": ee,
  "word-spacing": ee,
  // Motion properties
  motion: ee,
  "motion-offset": ee,
  // Outline properties
  outline: ee,
  "outline-offset": ee,
  "outline-width": ee,
  // Perspective properties
  perspective: ee,
  "perspective-origin-x": ia,
  "perspective-origin-y": ia,
  // Transform properties
  "transform-origin": ia,
  "transform-origin-x": ia,
  "transform-origin-y": ia,
  "transform-origin-z": ia,
  // Transition properties
  "transition-delay": vu,
  "transition-duration": vu,
  // Alignment properties
  "vertical-align": ee,
  "flex-basis": ee,
  // Some random properties
  "shape-margin": ee,
  size: ee,
  gap: ee,
  // Grid properties
  grid: ee,
  "grid-gap": ee,
  "row-gap": ee,
  "grid-row-gap": ee,
  "grid-column-gap": ee,
  "grid-template-rows": ee,
  "grid-template-columns": ee,
  "grid-auto-rows": ee,
  "grid-auto-columns": ee,
  // Not existing properties.
  // Used to avoid issues with jss-plugin-expand integration.
  "box-shadow-x": ee,
  "box-shadow-y": ee,
  "box-shadow-blur": ee,
  "box-shadow-spread": ee,
  "font-line-height": ee,
  "text-shadow-x": ee,
  "text-shadow-y": ee,
  "text-shadow-blur": ee
};
function Ty(e) {
  var t = /(-[a-z])/g, r = function(o) {
    return o[1].toUpperCase();
  }, n = {};
  for (var a in e)
    n[a] = e[a], n[a.replace(t, r)] = e[a];
  return n;
}
var wx = Ty(Cx);
function Xi(e, t, r) {
  if (t == null) return t;
  if (Array.isArray(t))
    for (var n = 0; n < t.length; n++)
      t[n] = Xi(e, t[n], r);
  else if (typeof t == "object")
    if (e === "fallbacks")
      for (var a in t)
        t[a] = Xi(a, t[a], r);
    else
      for (var i in t)
        t[i] = Xi(e + "-" + i, t[i], r);
  else if (typeof t == "number" && isNaN(t) === !1) {
    var o = r[e] || wx[e];
    return o && !(t === 0 && o === ee) ? typeof o == "function" ? o(t).toString() : "" + t + o : t.toString();
  }
  return t;
}
function Ox(e) {
  e === void 0 && (e = {});
  var t = Ty(e);
  function r(a, i) {
    if (i.type !== "style") return a;
    for (var o in a)
      a[o] = Xi(o, a[o], t);
    return a;
  }
  function n(a, i) {
    return Xi(i, a, t);
  }
  return {
    onProcessStyle: r,
    onChangeValue: n
  };
}
function If(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function Sx(e) {
  if (Array.isArray(e)) return If(e);
}
function Ax(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function Ex(e, t) {
  if (e) {
    if (typeof e == "string") return If(e, t);
    var r = {}.toString.call(e).slice(8, -1);
    return r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set" ? Array.from(e) : r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? If(e, t) : void 0;
  }
}
function _x() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Ix(e) {
  return Sx(e) || Ax(e) || Ex(e) || _x();
}
var ki = "", Pf = "", My = "", jy = "", Px = Jo && "ontouchstart" in document.documentElement;
if (Jo) {
  var rl = {
    Moz: "-moz-",
    ms: "-ms-",
    O: "-o-",
    Webkit: "-webkit-"
  }, Tx = document.createElement("p"), nl = Tx.style, Mx = "Transform";
  for (var al in rl)
    if (al + Mx in nl) {
      ki = al, Pf = rl[al];
      break;
    }
  ki === "Webkit" && "msHyphens" in nl && (ki = "ms", Pf = rl.ms, jy = "edge"), ki === "Webkit" && "-apple-trailing-word" in nl && (My = "apple");
}
var Oe = {
  js: ki,
  css: Pf,
  vendor: My,
  browser: jy,
  isTouch: Px
};
function jx(e) {
  return e[1] === "-" || Oe.js === "ms" ? e : "@" + Oe.css + "keyframes" + e.substr(10);
}
var Rx = {
  noPrefill: ["appearance"],
  supportedProperty: function(t) {
    return t !== "appearance" ? !1 : Oe.js === "ms" ? "-webkit-" + t : Oe.css + t;
  }
}, Nx = {
  noPrefill: ["color-adjust"],
  supportedProperty: function(t) {
    return t !== "color-adjust" ? !1 : Oe.js === "Webkit" ? Oe.css + "print-" + t : t;
  }
}, $x = /[-\s]+(.)?/g;
function Fx(e, t) {
  return t ? t.toUpperCase() : "";
}
function E1(e) {
  return e.replace($x, Fx);
}
function yn(e) {
  return E1("-" + e);
}
var Dx = {
  noPrefill: ["mask"],
  supportedProperty: function(t, r) {
    if (!/^mask/.test(t)) return !1;
    if (Oe.js === "Webkit") {
      var n = "mask-image";
      if (E1(n) in r)
        return t;
      if (Oe.js + yn(n) in r)
        return Oe.css + t;
    }
    return t;
  }
}, kx = {
  noPrefill: ["text-orientation"],
  supportedProperty: function(t) {
    return t !== "text-orientation" ? !1 : Oe.vendor === "apple" && !Oe.isTouch ? Oe.css + t : t;
  }
}, Lx = {
  noPrefill: ["transform"],
  supportedProperty: function(t, r, n) {
    return t !== "transform" ? !1 : n.transform ? t : Oe.css + t;
  }
}, Bx = {
  noPrefill: ["transition"],
  supportedProperty: function(t, r, n) {
    return t !== "transition" ? !1 : n.transition ? t : Oe.css + t;
  }
}, Vx = {
  noPrefill: ["writing-mode"],
  supportedProperty: function(t) {
    return t !== "writing-mode" ? !1 : Oe.js === "Webkit" || Oe.js === "ms" && Oe.browser !== "edge" ? Oe.css + t : t;
  }
}, Wx = {
  noPrefill: ["user-select"],
  supportedProperty: function(t) {
    return t !== "user-select" ? !1 : Oe.js === "Moz" || Oe.js === "ms" || Oe.vendor === "apple" ? Oe.css + t : t;
  }
}, Gx = {
  supportedProperty: function(t, r) {
    if (!/^break-/.test(t)) return !1;
    if (Oe.js === "Webkit") {
      var n = "WebkitColumn" + yn(t);
      return n in r ? Oe.css + "column-" + t : !1;
    }
    if (Oe.js === "Moz") {
      var a = "page" + yn(t);
      return a in r ? "page-" + t : !1;
    }
    return !1;
  }
}, Hx = {
  supportedProperty: function(t, r) {
    if (!/^(border|margin|padding)-inline/.test(t)) return !1;
    if (Oe.js === "Moz") return t;
    var n = t.replace("-inline", "");
    return Oe.js + yn(n) in r ? Oe.css + n : !1;
  }
}, Ux = {
  supportedProperty: function(t, r) {
    return E1(t) in r ? t : !1;
  }
}, zx = {
  supportedProperty: function(t, r) {
    var n = yn(t);
    return t[0] === "-" || t[0] === "-" && t[1] === "-" ? t : Oe.js + n in r ? Oe.css + t : Oe.js !== "Webkit" && "Webkit" + n in r ? "-webkit-" + t : !1;
  }
}, Yx = {
  supportedProperty: function(t) {
    return t.substring(0, 11) !== "scroll-snap" ? !1 : Oe.js === "ms" ? "" + Oe.css + t : t;
  }
}, Xx = {
  supportedProperty: function(t) {
    return t !== "overscroll-behavior" ? !1 : Oe.js === "ms" ? Oe.css + "scroll-chaining" : t;
  }
}, Zx = {
  "flex-grow": "flex-positive",
  "flex-shrink": "flex-negative",
  "flex-basis": "flex-preferred-size",
  "justify-content": "flex-pack",
  order: "flex-order",
  "align-items": "flex-align",
  "align-content": "flex-line-pack"
  // 'align-self' is handled by 'align-self' plugin.
}, Kx = {
  supportedProperty: function(t, r) {
    var n = Zx[t];
    return n && Oe.js + yn(n) in r ? Oe.css + n : !1;
  }
}, Ry = {
  flex: "box-flex",
  "flex-grow": "box-flex",
  "flex-direction": ["box-orient", "box-direction"],
  order: "box-ordinal-group",
  "align-items": "box-align",
  "flex-flow": ["box-orient", "box-direction"],
  "justify-content": "box-pack"
}, qx = Object.keys(Ry), Jx = function(t) {
  return Oe.css + t;
}, Qx = {
  supportedProperty: function(t, r, n) {
    var a = n.multiple;
    if (qx.indexOf(t) > -1) {
      var i = Ry[t];
      if (!Array.isArray(i))
        return Oe.js + yn(i) in r ? Oe.css + i : !1;
      if (!a) return !1;
      for (var o = 0; o < i.length; o++)
        if (!(Oe.js + yn(i[0]) in r))
          return !1;
      return i.map(Jx);
    }
    return !1;
  }
}, Ny = [Rx, Nx, Dx, kx, Lx, Bx, Vx, Wx, Gx, Hx, Ux, zx, Yx, Xx, Kx, Qx], Dh = Ny.filter(function(e) {
  return e.supportedProperty;
}).map(function(e) {
  return e.supportedProperty;
}), eC = Ny.filter(function(e) {
  return e.noPrefill;
}).reduce(function(e, t) {
  return e.push.apply(e, Ix(t.noPrefill)), e;
}, []), Li, Dn = {};
if (Jo) {
  Li = document.createElement("p");
  var il = window.getComputedStyle(document.documentElement, "");
  for (var ol in il)
    isNaN(ol) || (Dn[il[ol]] = il[ol]);
  eC.forEach(function(e) {
    return delete Dn[e];
  });
}
function Tf(e, t) {
  if (t === void 0 && (t = {}), !Li) return e;
  if (process.env.NODE_ENV !== "benchmark" && Dn[e] != null)
    return Dn[e];
  (e === "transition" || e === "transform") && (t[e] = e in Li.style);
  for (var r = 0; r < Dh.length && (Dn[e] = Dh[r](e, Li.style, t), !Dn[e]); r++)
    ;
  try {
    Li.style[e] = "";
  } catch {
    return !1;
  }
  return Dn[e];
}
var oa = {}, tC = {
  transition: 1,
  "transition-property": 1,
  "-webkit-transition": 1,
  "-webkit-transition-property": 1
}, rC = /(^\s*[\w-]+)|, (\s*[\w-]+)(?![^()]*\))/g, on;
function nC(e, t, r) {
  if (t === "var") return "var";
  if (t === "all") return "all";
  if (r === "all") return ", all";
  var n = t ? Tf(t) : ", " + Tf(r);
  return n || t || r;
}
Jo && (on = document.createElement("p"));
function kh(e, t) {
  var r = t;
  if (!on || e === "content") return t;
  if (typeof r != "string" || !isNaN(parseInt(r, 10)))
    return r;
  var n = e + r;
  if (process.env.NODE_ENV !== "benchmark" && oa[n] != null)
    return oa[n];
  try {
    on.style[e] = r;
  } catch {
    return oa[n] = !1, !1;
  }
  if (tC[e])
    r = r.replace(rC, nC);
  else if (on.style[e] === "" && (r = Oe.css + r, r === "-ms-flex" && (on.style[e] = "-ms-flexbox"), on.style[e] = r, on.style[e] === ""))
    return oa[n] = !1, !1;
  return on.style[e] = "", oa[n] = r, oa[n];
}
function aC() {
  function e(a) {
    if (a.type === "keyframes") {
      var i = a;
      i.at = jx(i.at);
    }
  }
  function t(a) {
    for (var i in a) {
      var o = a[i];
      if (i === "fallbacks" && Array.isArray(o)) {
        a[i] = o.map(t);
        continue;
      }
      var u = !1, s = Tf(i);
      s && s !== i && (u = !0);
      var c = !1, l = kh(s, Un(o));
      l && l !== o && (c = !0), (u || c) && (u && delete a[i], a[s || i] = l || o);
    }
    return a;
  }
  function r(a, i) {
    return i.type !== "style" ? a : t(a);
  }
  function n(a, i) {
    return kh(i, Un(a)) || a;
  }
  return {
    onProcessRule: e,
    onProcessStyle: r,
    onChangeValue: n
  };
}
function iC() {
  var e = function(r, n) {
    return r.length === n.length ? r > n ? 1 : -1 : r.length - n.length;
  };
  return {
    onProcessStyle: function(r, n) {
      if (n.type !== "style") return r;
      for (var a = {}, i = Object.keys(r).sort(e), o = 0; o < i.length; o++)
        a[i[o]] = r[i[o]];
      return a;
    }
  };
}
function $y() {
  return {
    plugins: [
      ux(),
      px(),
      gx(),
      xx(),
      Ox(),
      // Disable the vendor prefixer server-side, it does nothing.
      // This way, we can get a performance boost.
      // In the documentation, we are using `autoprefixer` to solve this problem.
      typeof window > "u" ? null : aC(),
      iC()
    ]
  };
}
function Fy() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = e.baseClasses, r = e.newClasses, n = e.Component;
  if (!r)
    return t;
  var a = Ce({}, t);
  return process.env.NODE_ENV !== "production" && typeof r == "string" ? (console.error(["Material-UI: The value `".concat(r, "` ") + "provided to the classes prop of ".concat(zi(n), " is incorrect."), "You might want to use the className prop instead."].join(`
`)), t) : (Object.keys(r).forEach(function(i) {
    process.env.NODE_ENV !== "production" && (!t[i] && r[i] && console.error(["Material-UI: The key `".concat(i, "` ") + "provided to the classes prop is not implemented in ".concat(zi(n), "."), "You can only override one of the following: ".concat(Object.keys(t).join(","), ".")].join(`
`)), r[i] && typeof r[i] != "string" && console.error(["Material-UI: The key `".concat(i, "` ") + "provided to the classes prop is not valid for ".concat(zi(n), "."), "You need to provide a non empty string instead of: ".concat(r[i], ".")].join(`
`))), r[i] && (a[i] = "".concat(t[i], " ").concat(r[i]));
  }), a);
}
var ha = {
  set: function(t, r, n, a) {
    var i = t.get(r);
    i || (i = /* @__PURE__ */ new Map(), t.set(r, i)), i.set(n, a);
  },
  get: function(t, r, n) {
    var a = t.get(r);
    return a ? a.get(n) : void 0;
  },
  delete: function(t, r, n) {
    var a = t.get(r);
    a.delete(n);
  }
}, Dy = N.createContext(null);
process.env.NODE_ENV !== "production" && (Dy.displayName = "ThemeContext");
function ky() {
  var e = N.useContext(Dy);
  return process.env.NODE_ENV !== "production" && N.useDebugValue(e), e;
}
var oC = S1($y()), uC = y7(), sC = /* @__PURE__ */ new Map(), cC = {
  disableGeneration: !1,
  generateClassName: uC,
  jss: oC,
  sheetsCache: null,
  sheetsManager: sC,
  sheetsRegistry: null
}, Uu = N.createContext(cC);
process.env.NODE_ENV !== "production" && (Uu.displayName = "StylesContext");
var gu;
function Mf(e) {
  var t = e.children, r = e.injectFirst, n = r === void 0 ? !1 : r, a = e.disableGeneration, i = a === void 0 ? !1 : a, o = Rr(e, ["children", "injectFirst", "disableGeneration"]), u = N.useContext(Uu), s = Ce({}, u, {
    disableGeneration: i
  }, o);
  if (process.env.NODE_ENV !== "production" && typeof window > "u" && !s.sheetsManager && console.error("Material-UI: You need to use the ServerStyleSheets API when rendering on the server."), process.env.NODE_ENV !== "production" && s.jss.options.insertionPoint && n && console.error("Material-UI: You cannot use a custom insertionPoint and <StylesContext injectFirst> at the same time."), process.env.NODE_ENV !== "production" && n && o.jss && console.error("Material-UI: You cannot use the jss and injectFirst props at the same time."), !s.jss.options.insertionPoint && n && typeof window < "u") {
    if (!gu) {
      var c = document.head;
      gu = document.createComment("mui-inject-first"), c.insertBefore(gu, c.firstChild);
    }
    s.jss = S1({
      plugins: $y().plugins,
      insertionPoint: gu
    });
  }
  return /* @__PURE__ */ N.createElement(Uu.Provider, {
    value: s
  }, t);
}
process.env.NODE_ENV !== "production" && (Mf.propTypes = {
  /**
   * Your component tree.
   */
  children: ce.node.isRequired,
  /**
   * You can disable the generation of the styles with this option.
   * It can be useful when traversing the React tree outside of the HTML
   * rendering step on the server.
   * Let's say you are using react-apollo to extract all
   * the queries made by the interface server-side - you can significantly speed up the traversal with this prop.
   */
  disableGeneration: ce.bool,
  /**
   * JSS's class name generator.
   */
  generateClassName: ce.func,
  /**
   * By default, the styles are injected last in the <head> element of the page.
   * As a result, they gain more specificity than any other style sheet.
   * If you want to override Material-UI's styles, set this prop.
   */
  injectFirst: ce.bool,
  /**
   * JSS's instance.
   */
  jss: ce.object,
  /**
   * @ignore
   */
  serverGenerateClassName: ce.func,
  /**
   * @ignore
   *
   * Beta feature.
   *
   * Cache for the sheets.
   */
  sheetsCache: ce.object,
  /**
   * @ignore
   *
   * The sheetsManager is used to deduplicate style sheet injection in the page.
   * It's deduplicating using the (theme, styles) couple.
   * On the server, you should provide a new instance for each request.
   */
  sheetsManager: ce.object,
  /**
   * @ignore
   *
   * Collect the sheets.
   */
  sheetsRegistry: ce.object
});
process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "production" && (Mf.propTypes = s7(Mf.propTypes));
var ul = -1e9;
function lC() {
  return ul += 1, process.env.NODE_ENV !== "production" && ul >= 0 && console.warn(["Material-UI: You might have a memory leak.", "The indexCounter is not supposed to grow that much."].join(`
`)), ul;
}
var Ly = {};
function fC(e) {
  var t = typeof e == "function";
  return process.env.NODE_ENV !== "production" && mn(e) !== "object" && !t && console.error(["Material-UI: The `styles` argument provided is invalid.", "You need to provide a function generating the styles or a styles object."].join(`
`)), {
    create: function(n, a) {
      var i;
      try {
        i = t ? e(n) : e;
      } catch (s) {
        throw process.env.NODE_ENV !== "production" && t === !0 && n === Ly && console.error(["Material-UI: The `styles` argument provided is invalid.", "You are providing a function without a theme in the context.", "One of the parent elements needs to use a ThemeProvider."].join(`
`)), s;
      }
      if (!a || !n.overrides || !n.overrides[a])
        return i;
      var o = n.overrides[a], u = Ce({}, i);
      return Object.keys(o).forEach(function(s) {
        process.env.NODE_ENV !== "production" && (u[s] || console.warn(["Material-UI: You are trying to override a style that does not exist.", "Fix the `".concat(s, "` key of `theme.overrides.").concat(a, "`.")].join(`
`))), u[s] = Aa(u[s], o[s]);
      }), u;
    },
    options: {}
  };
}
function dC(e, t, r) {
  var n = e.state, a = e.stylesOptions;
  if (a.disableGeneration)
    return t || {};
  n.cacheClasses || (n.cacheClasses = {
    // Cache for the finalized classes value.
    value: null,
    // Cache for the last used classes prop pointer.
    lastProp: null,
    // Cache for the last used rendered classes pointer.
    lastJSS: {}
  });
  var i = !1;
  return n.classes !== n.cacheClasses.lastJSS && (n.cacheClasses.lastJSS = n.classes, i = !0), t !== n.cacheClasses.lastProp && (n.cacheClasses.lastProp = t, i = !0), i && (n.cacheClasses.value = Fy({
    baseClasses: n.cacheClasses.lastJSS,
    newClasses: t,
    Component: r
  })), n.cacheClasses.value;
}
function pC(e, t) {
  var r = e.state, n = e.theme, a = e.stylesOptions, i = e.stylesCreator, o = e.name;
  if (!a.disableGeneration) {
    var u = ha.get(a.sheetsManager, i, n);
    u || (u = {
      refs: 0,
      staticSheet: null,
      dynamicStyles: null
    }, ha.set(a.sheetsManager, i, n, u));
    var s = Ce({}, i.options, a, {
      theme: n,
      flip: typeof a.flip == "boolean" ? a.flip : n.direction === "rtl"
    });
    s.generateId = s.serverGenerateClassName || s.generateClassName;
    var c = a.sheetsRegistry;
    if (u.refs === 0) {
      var l;
      a.sheetsCache && (l = ha.get(a.sheetsCache, i, n));
      var f = i.create(n, o);
      l || (l = a.jss.createStyleSheet(f, Ce({
        link: !1
      }, s)), l.attach(), a.sheetsCache && ha.set(a.sheetsCache, i, n, l)), c && c.add(l), u.staticSheet = l, u.dynamicStyles = Ey(f);
    }
    if (u.dynamicStyles) {
      var d = a.jss.createStyleSheet(u.dynamicStyles, Ce({
        link: !0
      }, s));
      d.update(t), d.attach(), r.dynamicSheet = d, r.classes = Fy({
        baseClasses: u.staticSheet.classes,
        newClasses: d.classes
      }), c && c.add(d);
    } else
      r.classes = u.staticSheet.classes;
    u.refs += 1;
  }
}
function hC(e, t) {
  var r = e.state;
  r.dynamicSheet && r.dynamicSheet.update(t);
}
function vC(e) {
  var t = e.state, r = e.theme, n = e.stylesOptions, a = e.stylesCreator;
  if (!n.disableGeneration) {
    var i = ha.get(n.sheetsManager, a, r);
    i.refs -= 1;
    var o = n.sheetsRegistry;
    i.refs === 0 && (ha.delete(n.sheetsManager, a, r), n.jss.removeStyleSheet(i.staticSheet), o && o.remove(i.staticSheet)), t.dynamicSheet && (n.jss.removeStyleSheet(t.dynamicSheet), o && o.remove(t.dynamicSheet));
  }
}
function gC(e, t) {
  var r = N.useRef([]), n, a = N.useMemo(function() {
    return {};
  }, t);
  r.current !== a && (r.current = a, n = e()), N.useEffect(
    function() {
      return function() {
        n && n();
      };
    },
    [a]
    // eslint-disable-line react-hooks/exhaustive-deps
  );
}
function mC(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = t.name, n = t.classNamePrefix, a = t.Component, i = t.defaultTheme, o = i === void 0 ? Ly : i, u = Rr(t, ["name", "classNamePrefix", "Component", "defaultTheme"]), s = fC(e), c = r || n || "makeStyles";
  s.options = {
    index: lC(),
    name: r,
    meta: c,
    classNamePrefix: c
  };
  var l = function() {
    var d = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, p = ky() || o, h = Ce({}, N.useContext(Uu), u), v = N.useRef(), g = N.useRef();
    gC(function() {
      var x = {
        name: r,
        state: {},
        stylesCreator: s,
        stylesOptions: h,
        theme: p
      };
      return pC(x, d), g.current = !1, v.current = x, function() {
        vC(x);
      };
    }, [p, s]), N.useEffect(function() {
      g.current && hC(v.current, d), g.current = !0;
    });
    var b = dC(v.current, d.classes, a);
    return process.env.NODE_ENV !== "production" && N.useDebugValue(b), b;
  };
  return l;
}
var _1 = Ea, yC = {
  childContextTypes: !0,
  contextType: !0,
  contextTypes: !0,
  defaultProps: !0,
  displayName: !0,
  getDefaultProps: !0,
  getDerivedStateFromError: !0,
  getDerivedStateFromProps: !0,
  mixins: !0,
  propTypes: !0,
  type: !0
}, bC = {
  name: !0,
  length: !0,
  prototype: !0,
  caller: !0,
  callee: !0,
  arguments: !0,
  arity: !0
}, xC = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, By = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, I1 = {};
I1[_1.ForwardRef] = xC;
I1[_1.Memo] = By;
function Lh(e) {
  return _1.isMemo(e) ? By : I1[e.$$typeof] || yC;
}
var CC = Object.defineProperty, wC = Object.getOwnPropertyNames, Bh = Object.getOwnPropertySymbols, OC = Object.getOwnPropertyDescriptor, SC = Object.getPrototypeOf, Vh = Object.prototype;
function Vy(e, t, r) {
  if (typeof t != "string") {
    if (Vh) {
      var n = SC(t);
      n && n !== Vh && Vy(e, n, r);
    }
    var a = wC(t);
    Bh && (a = a.concat(Bh(t)));
    for (var i = Lh(e), o = Lh(t), u = 0; u < a.length; ++u) {
      var s = a[u];
      if (!bC[s] && !(r && r[s]) && !(o && o[s]) && !(i && i[s])) {
        var c = OC(t, s);
        try {
          CC(e, s, c);
        } catch {
        }
      }
    }
  }
  return e;
}
var AC = Vy;
const EC = /* @__PURE__ */ Fe(AC);
var _C = function(t) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  return function(n) {
    var a = r.defaultTheme, i = r.withTheme, o = i === void 0 ? !1 : i, u = r.name, s = Rr(r, ["defaultTheme", "withTheme", "name"]);
    if (process.env.NODE_ENV !== "production" && n === void 0)
      throw new Error(["You are calling withStyles(styles)(Component) with an undefined component.", "You may have forgotten to import it."].join(`
`));
    var c = u;
    if (process.env.NODE_ENV !== "production" && !u) {
      var l = zi(n);
      l !== void 0 && (c = l);
    }
    var f = mC(t, Ce({
      defaultTheme: a,
      Component: n,
      name: u || n.displayName,
      classNamePrefix: c
    }, s)), d = /* @__PURE__ */ N.forwardRef(function(h, v) {
      h.classes;
      var g = h.innerRef, b = Rr(h, ["classes", "innerRef"]), x = f(Ce({}, n.defaultProps, h)), w, y = b;
      return (typeof u == "string" || o) && (w = ky() || a, u && (y = b7({
        theme: w,
        name: u,
        props: b
      })), o && !y.theme && (y.theme = w)), /* @__PURE__ */ N.createElement(n, Ce({
        ref: g || v,
        classes: x
      }, y));
    });
    return process.env.NODE_ENV !== "production" && (d.propTypes = {
      /**
       * Override or extend the styles applied to the component.
       */
      classes: ce.object,
      /**
       * Use that prop to pass a ref to the decorated component.
       * @deprecated
       */
      innerRef: hy(ce.oneOfType([ce.func, ce.object]), function(p) {
        return p.innerRef == null, null;
      })
    }), process.env.NODE_ENV !== "production" && (d.displayName = "WithStyles(".concat(zi(n), ")")), EC(d, n), process.env.NODE_ENV !== "production" && (d.Naked = n, d.options = r, d.useStyles = f), d;
  };
}, nn = ["xs", "sm", "md", "lg", "xl"];
function IC(e) {
  var t = e.values, r = t === void 0 ? {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1280,
    xl: 1920
  } : t, n = e.unit, a = n === void 0 ? "px" : n, i = e.step, o = i === void 0 ? 5 : i, u = Rr(e, ["values", "unit", "step"]);
  function s(h) {
    var v = typeof r[h] == "number" ? r[h] : h;
    return "@media (min-width:".concat(v).concat(a, ")");
  }
  function c(h) {
    var v = nn.indexOf(h) + 1, g = r[nn[v]];
    if (v === nn.length)
      return s("xs");
    var b = typeof g == "number" && v > 0 ? g : h;
    return "@media (max-width:".concat(b - o / 100).concat(a, ")");
  }
  function l(h, v) {
    var g = nn.indexOf(v);
    return g === nn.length - 1 ? s(h) : "@media (min-width:".concat(typeof r[h] == "number" ? r[h] : h).concat(a, ") and ") + "(max-width:".concat((g !== -1 && typeof r[nn[g + 1]] == "number" ? r[nn[g + 1]] : v) - o / 100).concat(a, ")");
  }
  function f(h) {
    return l(h, h);
  }
  var d = !1;
  function p(h) {
    return process.env.NODE_ENV !== "production" && (d || (d = !0, console.warn(["Material-UI: The `theme.breakpoints.width` utility is deprecated because it's redundant.", "Use the `theme.breakpoints.values` instead."].join(`
`)))), r[h];
  }
  return Ce({
    keys: nn,
    values: r,
    up: s,
    down: c,
    between: l,
    only: f,
    width: p
  }, u);
}
function PC(e, t, r) {
  var n;
  return Ce({
    gutters: function() {
      var i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      return console.warn(["Material-UI: theme.mixins.gutters() is deprecated.", "You can use the source of the mixin directly:", `
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      [theme.breakpoints.up('sm')]: {
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3),
      },
      `].join(`
`)), Ce({
        paddingLeft: t(2),
        paddingRight: t(2)
      }, i, Ui({}, e.up("sm"), Ce({
        paddingLeft: t(3),
        paddingRight: t(3)
      }, i[e.up("sm")])));
    },
    toolbar: (n = {
      minHeight: 56
    }, Ui(n, "".concat(e.up("xs"), " and (orientation: landscape)"), {
      minHeight: 48
    }), Ui(n, e.up("sm"), {
      minHeight: 64
    }), n)
  }, r);
}
var zu = {
  black: "#000",
  white: "#fff"
}, P1 = {
  50: "#fafafa",
  100: "#f5f5f5",
  200: "#eeeeee",
  300: "#e0e0e0",
  400: "#bdbdbd",
  500: "#9e9e9e",
  600: "#757575",
  700: "#616161",
  800: "#424242",
  900: "#212121",
  A100: "#d5d5d5",
  A200: "#aaaaaa",
  A400: "#303030",
  A700: "#616161"
}, sl = {
  50: "#e8eaf6",
  100: "#c5cae9",
  200: "#9fa8da",
  300: "#7986cb",
  400: "#5c6bc0",
  500: "#3f51b5",
  600: "#3949ab",
  700: "#303f9f",
  800: "#283593",
  900: "#1a237e",
  A100: "#8c9eff",
  A200: "#536dfe",
  A400: "#3d5afe",
  A700: "#304ffe"
}, cl = {
  50: "#fce4ec",
  100: "#f8bbd0",
  200: "#f48fb1",
  300: "#f06292",
  400: "#ec407a",
  500: "#e91e63",
  600: "#d81b60",
  700: "#c2185b",
  800: "#ad1457",
  900: "#880e4f",
  A100: "#ff80ab",
  A200: "#ff4081",
  A400: "#f50057",
  A700: "#c51162"
}, ll = {
  50: "#ffebee",
  100: "#ffcdd2",
  200: "#ef9a9a",
  300: "#e57373",
  400: "#ef5350",
  500: "#f44336",
  600: "#e53935",
  700: "#d32f2f",
  800: "#c62828",
  900: "#b71c1c",
  A100: "#ff8a80",
  A200: "#ff5252",
  A400: "#ff1744",
  A700: "#d50000"
}, fl = {
  50: "#fff3e0",
  100: "#ffe0b2",
  200: "#ffcc80",
  300: "#ffb74d",
  400: "#ffa726",
  500: "#ff9800",
  600: "#fb8c00",
  700: "#f57c00",
  800: "#ef6c00",
  900: "#e65100",
  A100: "#ffd180",
  A200: "#ffab40",
  A400: "#ff9100",
  A700: "#ff6d00"
}, dl = {
  50: "#e3f2fd",
  100: "#bbdefb",
  200: "#90caf9",
  300: "#64b5f6",
  400: "#42a5f5",
  500: "#2196f3",
  600: "#1e88e5",
  700: "#1976d2",
  800: "#1565c0",
  900: "#0d47a1",
  A100: "#82b1ff",
  A200: "#448aff",
  A400: "#2979ff",
  A700: "#2962ff"
}, pl = {
  50: "#e8f5e9",
  100: "#c8e6c9",
  200: "#a5d6a7",
  300: "#81c784",
  400: "#66bb6a",
  500: "#4caf50",
  600: "#43a047",
  700: "#388e3c",
  800: "#2e7d32",
  900: "#1b5e20",
  A100: "#b9f6ca",
  A200: "#69f0ae",
  A400: "#00e676",
  A700: "#00c853"
};
function Wy(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1;
  return process.env.NODE_ENV !== "production" && (e < t || e > r) && console.error("Material-UI: The value provided ".concat(e, " is out of range [").concat(t, ", ").concat(r, "].")), Math.min(Math.max(t, e), r);
}
function TC(e) {
  e = e.substr(1);
  var t = new RegExp(".{1,".concat(e.length >= 6 ? 2 : 1, "}"), "g"), r = e.match(t);
  return r && r[0].length === 1 && (r = r.map(function(n) {
    return n + n;
  })), r ? "rgb".concat(r.length === 4 ? "a" : "", "(").concat(r.map(function(n, a) {
    return a < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1e3) / 1e3;
  }).join(", "), ")") : "";
}
function MC(e) {
  e = _a(e);
  var t = e, r = t.values, n = r[0], a = r[1] / 100, i = r[2] / 100, o = a * Math.min(i, 1 - i), u = function(f) {
    var d = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : (f + n / 30) % 12;
    return i - o * Math.max(Math.min(d - 3, 9 - d, 1), -1);
  }, s = "rgb", c = [Math.round(u(0) * 255), Math.round(u(8) * 255), Math.round(u(4) * 255)];
  return e.type === "hsla" && (s += "a", c.push(r[3])), T1({
    type: s,
    values: c
  });
}
function _a(e) {
  if (e.type)
    return e;
  if (e.charAt(0) === "#")
    return _a(TC(e));
  var t = e.indexOf("("), r = e.substring(0, t);
  if (["rgb", "rgba", "hsl", "hsla"].indexOf(r) === -1)
    throw new Error(process.env.NODE_ENV !== "production" ? "Material-UI: Unsupported `".concat(e, "` color.\nWe support the following formats: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla().") : Gu(3, e));
  var n = e.substring(t + 1, e.length - 1).split(",");
  return n = n.map(function(a) {
    return parseFloat(a);
  }), {
    type: r,
    values: n
  };
}
function T1(e) {
  var t = e.type, r = e.values;
  return t.indexOf("rgb") !== -1 ? r = r.map(function(n, a) {
    return a < 3 ? parseInt(n, 10) : n;
  }) : t.indexOf("hsl") !== -1 && (r[1] = "".concat(r[1], "%"), r[2] = "".concat(r[2], "%")), "".concat(t, "(").concat(r.join(", "), ")");
}
function Wh(e, t) {
  var r = Gh(e), n = Gh(t);
  return (Math.max(r, n) + 0.05) / (Math.min(r, n) + 0.05);
}
function Gh(e) {
  e = _a(e);
  var t = e.type === "hsl" ? _a(MC(e)).values : e.values;
  return t = t.map(function(r) {
    return r /= 255, r <= 0.03928 ? r / 12.92 : Math.pow((r + 0.055) / 1.055, 2.4);
  }), Number((0.2126 * t[0] + 0.7152 * t[1] + 0.0722 * t[2]).toFixed(3));
}
function jC(e, t) {
  if (e = _a(e), t = Wy(t), e.type.indexOf("hsl") !== -1)
    e.values[2] *= 1 - t;
  else if (e.type.indexOf("rgb") !== -1)
    for (var r = 0; r < 3; r += 1)
      e.values[r] *= 1 - t;
  return T1(e);
}
function RC(e, t) {
  if (e = _a(e), t = Wy(t), e.type.indexOf("hsl") !== -1)
    e.values[2] += (100 - e.values[2]) * t;
  else if (e.type.indexOf("rgb") !== -1)
    for (var r = 0; r < 3; r += 1)
      e.values[r] += (255 - e.values[r]) * t;
  return T1(e);
}
var Hh = {
  // The colors used to style the text.
  text: {
    // The most important text.
    primary: "rgba(0, 0, 0, 0.87)",
    // Secondary text.
    secondary: "rgba(0, 0, 0, 0.54)",
    // Disabled text have even lower visual prominence.
    disabled: "rgba(0, 0, 0, 0.38)",
    // Text hints.
    hint: "rgba(0, 0, 0, 0.38)"
  },
  // The color used to divide different elements.
  divider: "rgba(0, 0, 0, 0.12)",
  // The background colors used to style the surfaces.
  // Consistency between these values is important.
  background: {
    paper: zu.white,
    default: P1[50]
  },
  // The colors used to style the action elements.
  action: {
    // The color of an active action like an icon button.
    active: "rgba(0, 0, 0, 0.54)",
    // The color of an hovered action.
    hover: "rgba(0, 0, 0, 0.04)",
    hoverOpacity: 0.04,
    // The color of a selected action.
    selected: "rgba(0, 0, 0, 0.08)",
    selectedOpacity: 0.08,
    // The color of a disabled action.
    disabled: "rgba(0, 0, 0, 0.26)",
    // The background color of a disabled action.
    disabledBackground: "rgba(0, 0, 0, 0.12)",
    disabledOpacity: 0.38,
    focus: "rgba(0, 0, 0, 0.12)",
    focusOpacity: 0.12,
    activatedOpacity: 0.12
  }
}, hl = {
  text: {
    primary: zu.white,
    secondary: "rgba(255, 255, 255, 0.7)",
    disabled: "rgba(255, 255, 255, 0.5)",
    hint: "rgba(255, 255, 255, 0.5)",
    icon: "rgba(255, 255, 255, 0.5)"
  },
  divider: "rgba(255, 255, 255, 0.12)",
  background: {
    paper: P1[800],
    default: "#303030"
  },
  action: {
    active: zu.white,
    hover: "rgba(255, 255, 255, 0.08)",
    hoverOpacity: 0.08,
    selected: "rgba(255, 255, 255, 0.16)",
    selectedOpacity: 0.16,
    disabled: "rgba(255, 255, 255, 0.3)",
    disabledBackground: "rgba(255, 255, 255, 0.12)",
    disabledOpacity: 0.38,
    focus: "rgba(255, 255, 255, 0.12)",
    focusOpacity: 0.12,
    activatedOpacity: 0.24
  }
};
function Uh(e, t, r, n) {
  var a = n.light || n, i = n.dark || n * 1.5;
  e[t] || (e.hasOwnProperty(r) ? e[t] = e[r] : t === "light" ? e.light = RC(e.main, a) : t === "dark" && (e.dark = jC(e.main, i)));
}
function NC(e) {
  var t = e.primary, r = t === void 0 ? {
    light: sl[300],
    main: sl[500],
    dark: sl[700]
  } : t, n = e.secondary, a = n === void 0 ? {
    light: cl.A200,
    main: cl.A400,
    dark: cl.A700
  } : n, i = e.error, o = i === void 0 ? {
    light: ll[300],
    main: ll[500],
    dark: ll[700]
  } : i, u = e.warning, s = u === void 0 ? {
    light: fl[300],
    main: fl[500],
    dark: fl[700]
  } : u, c = e.info, l = c === void 0 ? {
    light: dl[300],
    main: dl[500],
    dark: dl[700]
  } : c, f = e.success, d = f === void 0 ? {
    light: pl[300],
    main: pl[500],
    dark: pl[700]
  } : f, p = e.type, h = p === void 0 ? "light" : p, v = e.contrastThreshold, g = v === void 0 ? 3 : v, b = e.tonalOffset, x = b === void 0 ? 0.2 : b, w = Rr(e, ["primary", "secondary", "error", "warning", "info", "success", "type", "contrastThreshold", "tonalOffset"]);
  function y(S) {
    var A = Wh(S, hl.text.primary) >= g ? hl.text.primary : Hh.text.primary;
    if (process.env.NODE_ENV !== "production") {
      var P = Wh(S, A);
      P < 3 && console.error(["Material-UI: The contrast ratio of ".concat(P, ":1 for ").concat(A, " on ").concat(S), "falls below the WCAG recommended absolute minimum contrast ratio of 3:1.", "https://www.w3.org/TR/2008/REC-WCAG20-20081211/#visual-audio-contrast-contrast"].join(`
`));
    }
    return A;
  }
  var m = function(A) {
    var P = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 500, T = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 300, M = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 700;
    if (A = Ce({}, A), !A.main && A[P] && (A.main = A[P]), !A.main)
      throw new Error(process.env.NODE_ENV !== "production" ? "Material-UI: The color provided to augmentColor(color) is invalid.\nThe color object needs to have a `main` property or a `".concat(P, "` property.") : Gu(4, P));
    if (typeof A.main != "string")
      throw new Error(process.env.NODE_ENV !== "production" ? "Material-UI: The color provided to augmentColor(color) is invalid.\n`color.main` should be a string, but `".concat(JSON.stringify(A.main), `\` was provided instead.

Did you intend to use one of the following approaches?

import { green } from "@material-ui/core/colors";

const theme1 = createTheme({ palette: {
  primary: green,
} });

const theme2 = createTheme({ palette: {
  primary: { main: green[500] },
} });`) : Gu(5, JSON.stringify(A.main)));
    return Uh(A, "light", T, x), Uh(A, "dark", M, x), A.contrastText || (A.contrastText = y(A.main)), A;
  }, C = {
    dark: hl,
    light: Hh
  };
  process.env.NODE_ENV !== "production" && (C[h] || console.error("Material-UI: The palette type `".concat(h, "` is not supported.")));
  var O = Aa(Ce({
    // A collection of common colors.
    common: zu,
    // The palette type, can be light or dark.
    type: h,
    // The colors used to represent primary interface elements for a user.
    primary: m(r),
    // The colors used to represent secondary interface elements for a user.
    secondary: m(a, "A400", "A200", "A700"),
    // The colors used to represent interface elements that the user should be made aware of.
    error: m(o),
    // The colors used to represent potentially dangerous actions or important messages.
    warning: m(s),
    // The colors used to present information to the user that is neutral and not necessarily important.
    info: m(l),
    // The colors used to indicate the successful completion of an action that user triggered.
    success: m(d),
    // The grey colors.
    grey: P1,
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold: g,
    // Takes a background color and returns the text color that maximizes the contrast.
    getContrastText: y,
    // Generate a rich color object.
    augmentColor: m,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: x
  }, C[h]), w);
  return O;
}
function Gy(e) {
  return Math.round(e * 1e5) / 1e5;
}
var zh = !1;
function $C(e) {
  return process.env.NODE_ENV !== "production" && (zh || (console.warn(["Material-UI: The `theme.typography.round` helper is deprecated.", "Head to https://mui.com/r/migration-v4/#theme for a migration path."].join(`
`)), zh = !0)), Gy(e);
}
var Yh = {
  textTransform: "uppercase"
}, Xh = '"Roboto", "Helvetica", "Arial", sans-serif';
function FC(e, t) {
  var r = typeof t == "function" ? t(e) : t, n = r.fontFamily, a = n === void 0 ? Xh : n, i = r.fontSize, o = i === void 0 ? 14 : i, u = r.fontWeightLight, s = u === void 0 ? 300 : u, c = r.fontWeightRegular, l = c === void 0 ? 400 : c, f = r.fontWeightMedium, d = f === void 0 ? 500 : f, p = r.fontWeightBold, h = p === void 0 ? 700 : p, v = r.htmlFontSize, g = v === void 0 ? 16 : v, b = r.allVariants, x = r.pxToRem, w = Rr(r, ["fontFamily", "fontSize", "fontWeightLight", "fontWeightRegular", "fontWeightMedium", "fontWeightBold", "htmlFontSize", "allVariants", "pxToRem"]);
  process.env.NODE_ENV !== "production" && (typeof o != "number" && console.error("Material-UI: `fontSize` is required to be a number."), typeof g != "number" && console.error("Material-UI: `htmlFontSize` is required to be a number."));
  var y = o / 14, m = x || function(S) {
    return "".concat(S / g * y, "rem");
  }, C = function(A, P, T, M, I) {
    return Ce({
      fontFamily: a,
      fontWeight: A,
      fontSize: m(P),
      // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
      lineHeight: T
    }, a === Xh ? {
      letterSpacing: "".concat(Gy(M / P), "em")
    } : {}, I, b);
  }, O = {
    h1: C(s, 96, 1.167, -1.5),
    h2: C(s, 60, 1.2, -0.5),
    h3: C(l, 48, 1.167, 0),
    h4: C(l, 34, 1.235, 0.25),
    h5: C(l, 24, 1.334, 0),
    h6: C(d, 20, 1.6, 0.15),
    subtitle1: C(l, 16, 1.75, 0.15),
    subtitle2: C(d, 14, 1.57, 0.1),
    body1: C(l, 16, 1.5, 0.15),
    body2: C(l, 14, 1.43, 0.15),
    button: C(d, 14, 1.75, 0.4, Yh),
    caption: C(l, 12, 1.66, 0.4),
    overline: C(l, 12, 2.66, 1, Yh)
  };
  return Aa(Ce({
    htmlFontSize: g,
    pxToRem: m,
    round: $C,
    // TODO v5: remove
    fontFamily: a,
    fontSize: o,
    fontWeightLight: s,
    fontWeightRegular: l,
    fontWeightMedium: d,
    fontWeightBold: h
  }, O), w, {
    clone: !1
    // No need to clone deep
  });
}
var DC = 0.2, kC = 0.14, LC = 0.12;
function nt() {
  return ["".concat(arguments.length <= 0 ? void 0 : arguments[0], "px ").concat(arguments.length <= 1 ? void 0 : arguments[1], "px ").concat(arguments.length <= 2 ? void 0 : arguments[2], "px ").concat(arguments.length <= 3 ? void 0 : arguments[3], "px rgba(0,0,0,").concat(DC, ")"), "".concat(arguments.length <= 4 ? void 0 : arguments[4], "px ").concat(arguments.length <= 5 ? void 0 : arguments[5], "px ").concat(arguments.length <= 6 ? void 0 : arguments[6], "px ").concat(arguments.length <= 7 ? void 0 : arguments[7], "px rgba(0,0,0,").concat(kC, ")"), "".concat(arguments.length <= 8 ? void 0 : arguments[8], "px ").concat(arguments.length <= 9 ? void 0 : arguments[9], "px ").concat(arguments.length <= 10 ? void 0 : arguments[10], "px ").concat(arguments.length <= 11 ? void 0 : arguments[11], "px rgba(0,0,0,").concat(LC, ")")].join(",");
}
var BC = ["none", nt(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), nt(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), nt(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), nt(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), nt(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), nt(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), nt(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), nt(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), nt(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), nt(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), nt(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), nt(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), nt(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), nt(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), nt(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), nt(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), nt(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), nt(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), nt(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), nt(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), nt(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), nt(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), nt(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), nt(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)], VC = {
  borderRadius: 4
}, WC = process.env.NODE_ENV !== "production" ? ce.oneOfType([ce.number, ce.string, ce.object, ce.array]) : {}, GC = ["m", "mt", "mr", "mb", "ml", "mx", "my", "p", "pt", "pr", "pb", "pl", "px", "py", "margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "marginX", "marginY", "padding", "paddingTop", "paddingRight", "paddingBottom", "paddingLeft", "paddingX", "paddingY"];
function HC(e) {
  var t = e.spacing || 8;
  return typeof t == "number" ? function(r) {
    return process.env.NODE_ENV !== "production" && typeof r != "number" && console.error("Material-UI: Expected spacing argument to be a number, got ".concat(r, ".")), t * r;
  } : Array.isArray(t) ? function(r) {
    return process.env.NODE_ENV !== "production" && r > t.length - 1 && console.error(["Material-UI: The value provided (".concat(r, ") overflows."), "The supported values are: ".concat(JSON.stringify(t), "."), "".concat(r, " > ").concat(t.length - 1, ", you need to add the missing values.")].join(`
`)), t[r];
  } : typeof t == "function" ? t : (process.env.NODE_ENV !== "production" && console.error(["Material-UI: The `theme.spacing` value (".concat(t, ") is invalid."), "It should be a number, an array or a function."].join(`
`)), function() {
  });
}
process.env.NODE_ENV !== "production" && GC.reduce(function(e, t) {
  return e[t] = WC, e;
}, {});
var Zh;
function UC() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 8;
  if (e.mui)
    return e;
  var t = HC({
    spacing: e
  }), r = function() {
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return process.env.NODE_ENV !== "production" && (i.length <= 4 || console.error("Material-UI: Too many arguments provided, expected between 0 and 4, got ".concat(i.length))), i.length === 0 ? t(1) : i.length === 1 ? t(i[0]) : i.map(function(u) {
      if (typeof u == "string")
        return u;
      var s = t(u);
      return typeof s == "number" ? "".concat(s, "px") : s;
    }).join(" ");
  };
  return Object.defineProperty(r, "unit", {
    get: function() {
      return process.env.NODE_ENV !== "production" && ((!Zh || process.env.NODE_ENV === "test") && console.error(["Material-UI: theme.spacing.unit usage has been deprecated.", "It will be removed in v5.", "You can replace `theme.spacing.unit * y` with `theme.spacing(y)`.", "", "You can use the `https://github.com/mui-org/material-ui/tree/master/packages/material-ui-codemod/README.md#theme-spacing-api` migration helper to make the process smoother."].join(`
`)), Zh = !0), e;
    }
  }), r.mui = !0, r;
}
var Kh = {
  // This is the most common easing curve.
  easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: "cubic-bezier(0.4, 0, 1, 1)",
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
}, qh = {
  shortest: 150,
  shorter: 200,
  short: 250,
  // most basic recommended timing
  standard: 300,
  // this is to be used in complex animations
  complex: 375,
  // recommended when something is entering screen
  enteringScreen: 225,
  // recommended when something is leaving screen
  leavingScreen: 195
};
function Jh(e) {
  return "".concat(Math.round(e), "ms");
}
const zC = {
  easing: Kh,
  duration: qh,
  create: function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : ["all"], r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = r.duration, a = n === void 0 ? qh.standard : n, i = r.easing, o = i === void 0 ? Kh.easeInOut : i, u = r.delay, s = u === void 0 ? 0 : u, c = Rr(r, ["duration", "easing", "delay"]);
    if (process.env.NODE_ENV !== "production") {
      var l = function(p) {
        return typeof p == "string";
      }, f = function(p) {
        return !isNaN(parseFloat(p));
      };
      !l(t) && !Array.isArray(t) && console.error('Material-UI: Argument "props" must be a string or Array.'), !f(a) && !l(a) && console.error('Material-UI: Argument "duration" must be a number or a string but found '.concat(a, ".")), l(o) || console.error('Material-UI: Argument "easing" must be a string.'), !f(s) && !l(s) && console.error('Material-UI: Argument "delay" must be a number or a string.'), Object.keys(c).length !== 0 && console.error("Material-UI: Unrecognized argument(s) [".concat(Object.keys(c).join(","), "]."));
    }
    return (Array.isArray(t) ? t : [t]).map(function(d) {
      return "".concat(d, " ").concat(typeof a == "string" ? a : Jh(a), " ").concat(o, " ").concat(typeof s == "string" ? s : Jh(s));
    }).join(",");
  },
  getAutoHeightDuration: function(t) {
    if (!t)
      return 0;
    var r = t / 36;
    return Math.round((4 + 15 * Math.pow(r, 0.25) + r / 5) * 10);
  }
};
var YC = {
  mobileStepper: 1e3,
  speedDial: 1050,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
};
function XC() {
  for (var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = e.breakpoints, r = t === void 0 ? {} : t, n = e.mixins, a = n === void 0 ? {} : n, i = e.palette, o = i === void 0 ? {} : i, u = e.spacing, s = e.typography, c = s === void 0 ? {} : s, l = Rr(e, ["breakpoints", "mixins", "palette", "spacing", "typography"]), f = NC(o), d = IC(r), p = UC(u), h = Aa({
    breakpoints: d,
    direction: "ltr",
    mixins: PC(d, p, a),
    overrides: {},
    // Inject custom styles
    palette: f,
    props: {},
    // Provide default props
    shadows: BC,
    typography: FC(f, c),
    spacing: p,
    shape: VC,
    transitions: zC,
    zIndex: YC
  }, l), v = arguments.length, g = new Array(v > 1 ? v - 1 : 0), b = 1; b < v; b++)
    g[b - 1] = arguments[b];
  if (h = g.reduce(function(y, m) {
    return Aa(y, m);
  }, h), process.env.NODE_ENV !== "production") {
    var x = ["checked", "disabled", "error", "focused", "focusVisible", "required", "expanded", "selected"], w = function y(m, C) {
      var O = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, S;
      for (S in m) {
        var A = m[S];
        O === 1 ? S.indexOf("Mui") === 0 && A && y(A, S, O + 1) : x.indexOf(S) !== -1 && Object.keys(A).length > 0 && (process.env.NODE_ENV !== "production" && console.error(["Material-UI: The `".concat(C, "` component increases ") + "the CSS specificity of the `".concat(S, "` internal state."), "You can not override it like this: ", JSON.stringify(m, null, 2), "", "Instead, you need to use the $ruleName syntax:", JSON.stringify({
          root: Ui({}, "&$".concat(S), A)
        }, null, 2), "", "https://mui.com/r/pseudo-classes-guide"].join(`
`)), m[S] = {});
      }
    };
    w(h.overrides);
  }
  return h;
}
var ZC = XC();
function KC(e, t) {
  return _C(e, Ce({
    defaultTheme: ZC
  }, t));
}
var qC = function(t) {
  return {
    /* Styles applied to the root element. */
    root: {
      userSelect: "none",
      width: "1em",
      height: "1em",
      display: "inline-block",
      fill: "currentColor",
      flexShrink: 0,
      fontSize: t.typography.pxToRem(24),
      transition: t.transitions.create("fill", {
        duration: t.transitions.duration.shorter
      })
    },
    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: t.palette.primary.main
    },
    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      color: t.palette.secondary.main
    },
    /* Styles applied to the root element if `color="action"`. */
    colorAction: {
      color: t.palette.action.active
    },
    /* Styles applied to the root element if `color="error"`. */
    colorError: {
      color: t.palette.error.main
    },
    /* Styles applied to the root element if `color="disabled"`. */
    colorDisabled: {
      color: t.palette.action.disabled
    },
    /* Styles applied to the root element if `fontSize="inherit"`. */
    fontSizeInherit: {
      fontSize: "inherit"
    },
    /* Styles applied to the root element if `fontSize="small"`. */
    fontSizeSmall: {
      fontSize: t.typography.pxToRem(20)
    },
    /* Styles applied to the root element if `fontSize="large"`. */
    fontSizeLarge: {
      fontSize: t.typography.pxToRem(35)
    }
  };
}, M1 = /* @__PURE__ */ Ae.forwardRef(function(t, r) {
  var n = t.children, a = t.classes, i = t.className, o = t.color, u = o === void 0 ? "inherit" : o, s = t.component, c = s === void 0 ? "svg" : s, l = t.fontSize, f = l === void 0 ? "medium" : l, d = t.htmlColor, p = t.titleAccess, h = t.viewBox, v = h === void 0 ? "0 0 24 24" : h, g = Rr(t, ["children", "classes", "className", "color", "component", "fontSize", "htmlColor", "titleAccess", "viewBox"]);
  return /* @__PURE__ */ Ae.createElement(c, Ce({
    className: h7(a.root, i, u !== "inherit" && a["color".concat(bf(u))], f !== "default" && f !== "medium" && a["fontSize".concat(bf(f))]),
    focusable: "false",
    viewBox: v,
    color: d,
    "aria-hidden": p ? void 0 : !0,
    role: p ? "img" : void 0,
    ref: r
  }, g), n, p ? /* @__PURE__ */ Ae.createElement("title", null, p) : null);
});
process.env.NODE_ENV !== "production" && (M1.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * Node passed into the SVG element.
   */
  children: ce.node,
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: ce.object,
  /**
   * @ignore
   */
  className: ce.string,
  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   * You can use the `htmlColor` prop to apply a color attribute to the SVG element.
   */
  color: ce.oneOf(["action", "disabled", "error", "inherit", "primary", "secondary"]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: ce.elementType,
  /**
   * The fontSize applied to the icon. Defaults to 24px, but can be configure to inherit font size.
   */
  fontSize: hy(ce.oneOf(["default", "inherit", "large", "medium", "small"]), function(e) {
    var t = e.fontSize;
    if (t === "default")
      throw new Error('Material-UI: `fontSize="default"` is deprecated. Use `fontSize="medium"` instead.');
    return null;
  }),
  /**
   * Applies a color attribute to the SVG element.
   */
  htmlColor: ce.string,
  /**
   * The shape-rendering attribute. The behavior of the different options is described on the
   * [MDN Web Docs](https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/shape-rendering).
   * If you are having issues with blurry icons you should investigate this property.
   */
  shapeRendering: ce.string,
  /**
   * Provides a human-readable title for the element that contains it.
   * https://www.w3.org/TR/SVG-access/#Equivalent
   */
  titleAccess: ce.string,
  /**
   * Allows you to redefine what the coordinates without units mean inside an SVG element.
   * For example, if the SVG element is 500 (width) by 200 (height),
   * and you pass viewBox="0 0 50 20",
   * this means that the coordinates inside the SVG will go from the top left corner (0,0)
   * to bottom right (50,20) and each unit will be worth 10px.
   */
  viewBox: ce.string
});
M1.muiName = "SvgIcon";
const Qh = KC(qC, {
  name: "MuiSvgIcon"
})(M1);
function JC(e, t) {
  var r = function(a, i) {
    return /* @__PURE__ */ N.createElement(Qh, Ce({
      ref: i
    }, a), e);
  };
  return process.env.NODE_ENV !== "production" && (r.displayName = "".concat(t, "Icon")), r.muiName = Qh.muiName, /* @__PURE__ */ N.memo(/* @__PURE__ */ N.forwardRef(r));
}
function QC(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 166, r;
  function n() {
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    var u = this, s = function() {
      e.apply(u, i);
    };
    clearTimeout(r), r = setTimeout(s, t);
  }
  return n.clear = function() {
    clearTimeout(r);
  }, n;
}
function ew(e, t) {
  return process.env.NODE_ENV === "production" ? function() {
    return null;
  } : function(r, n, a, i, o) {
    var u = a || "<<anonymous>>", s = o || n;
    return typeof r[n] < "u" ? new Error("The ".concat(i, " `").concat(s, "` of ") + "`".concat(u, "` is deprecated. ").concat(t)) : null;
  };
}
function tw(e, t) {
  return /* @__PURE__ */ Ae.isValidElement(e) && t.indexOf(e.type.muiName) !== -1;
}
function Hy(e) {
  return e && e.ownerDocument || document;
}
function rw(e) {
  var t = Hy(e);
  return t.defaultView || window;
}
function nw(e) {
  if (process.env.NODE_ENV === "production")
    return function() {
      return null;
    };
  var t = function(n) {
    return function(a, i, o, u, s) {
      var c = s || i;
      return typeof a[i] < "u" && !a[n] ? new Error("The prop `".concat(c, "` of ") + "`".concat(e, "` must be used on `").concat(n, "`.")) : null;
    };
  };
  return t;
}
function jf(e, t) {
  typeof e == "function" ? e(t) : e && (e.current = t);
}
function aw(e, t, r, n, a) {
  if (process.env.NODE_ENV === "production")
    return null;
  var i = a || t;
  return typeof e[t] < "u" ? new Error("The prop `".concat(i, "` is not supported. Please remove it.")) : null;
}
function iw(e) {
  var t = e.controlled, r = e.default, n = e.name, a = e.state, i = a === void 0 ? "value" : a, o = Ae.useRef(t !== void 0), u = o.current, s = Ae.useState(r), c = s[0], l = s[1], f = u ? t : c;
  if (process.env.NODE_ENV !== "production") {
    Ae.useEffect(function() {
      u !== (t !== void 0) && console.error(["Material-UI: A component is changing the ".concat(u ? "" : "un", "controlled ").concat(i, " state of ").concat(n, " to be ").concat(u ? "un" : "", "controlled."), "Elements should not switch from uncontrolled to controlled (or vice versa).", "Decide between using a controlled or uncontrolled ".concat(n, " ") + "element for the lifetime of the component.", "The nature of the state is determined during the first render, it's considered controlled if the value is not `undefined`.", "More info: https://fb.me/react-controlled-components"].join(`
`));
    }, [t]);
    var d = Ae.useRef(r), p = d.current;
    Ae.useEffect(function() {
      !u && p !== r && console.error(["Material-UI: A component is changing the default ".concat(i, " state of an uncontrolled ").concat(n, " after being initialized. ") + "To suppress this warning opt to use a controlled ".concat(n, ".")].join(`
`));
    }, [JSON.stringify(r)]);
  }
  var h = Ae.useCallback(function(v) {
    u || l(v);
  }, []);
  return [f, h];
}
var ow = typeof window < "u" ? Ae.useLayoutEffect : Ae.useEffect;
function uw(e) {
  var t = Ae.useRef(e);
  return ow(function() {
    t.current = e;
  }), Ae.useCallback(function() {
    return t.current.apply(void 0, arguments);
  }, []);
}
function sw(e, t) {
  return Ae.useMemo(function() {
    return e == null && t == null ? null : function(r) {
      jf(e, r), jf(t, r);
    };
  }, [e, t]);
}
function cw(e) {
  var t = Ae.useState(e), r = t[0], n = t[1], a = e || r;
  return Ae.useEffect(function() {
    r == null && n("mui-".concat(Math.round(Math.random() * 1e5)));
  }, [r]), a;
}
var Qs = !0, Rf = !1, e0 = null, lw = {
  text: !0,
  search: !0,
  url: !0,
  tel: !0,
  email: !0,
  password: !0,
  number: !0,
  date: !0,
  month: !0,
  week: !0,
  time: !0,
  datetime: !0,
  "datetime-local": !0
};
function fw(e) {
  var t = e.type, r = e.tagName;
  return !!(r === "INPUT" && lw[t] && !e.readOnly || r === "TEXTAREA" && !e.readOnly || e.isContentEditable);
}
function dw(e) {
  e.metaKey || e.altKey || e.ctrlKey || (Qs = !0);
}
function vl() {
  Qs = !1;
}
function pw() {
  this.visibilityState === "hidden" && Rf && (Qs = !0);
}
function hw(e) {
  e.addEventListener("keydown", dw, !0), e.addEventListener("mousedown", vl, !0), e.addEventListener("pointerdown", vl, !0), e.addEventListener("touchstart", vl, !0), e.addEventListener("visibilitychange", pw, !0);
}
function t0(e) {
  var t = e.target;
  try {
    return t.matches(":focus-visible");
  } catch {
  }
  return Qs || fw(t);
}
function vw() {
  Rf = !0, window.clearTimeout(e0), e0 = window.setTimeout(function() {
    Rf = !1;
  }, 100);
}
function gw() {
  var e = Ae.useCallback(function(t) {
    var r = Ym.findDOMNode(t);
    r != null && hw(r.ownerDocument);
  }, []);
  return process.env.NODE_ENV !== "production" && Ae.useDebugValue(t0), {
    isFocusVisible: t0,
    onBlurVisible: vw,
    ref: e
  };
}
const mw = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  capitalize: bf,
  createChainedFunction: p7,
  createSvgIcon: JC,
  debounce: QC,
  deprecatedPropType: ew,
  isMuiElement: tw,
  ownerDocument: Hy,
  ownerWindow: rw,
  requirePropFactory: nw,
  setRef: jf,
  unstable_useId: cw,
  unsupportedProp: aw,
  useControlled: iw,
  useEventCallback: uw,
  useForkRef: sw,
  useIsFocusVisible: gw
}, Symbol.toStringTag, { value: "Module" })), yw = /* @__PURE__ */ D6(mw);
var r0;
function Uy() {
  return r0 || (r0 = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "default", {
      enumerable: !0,
      get: function() {
        return t.createSvgIcon;
      }
    });
    var t = yw;
  }(Gc)), Gc;
}
var bw = ly, xw = py;
Object.defineProperty(x1, "__esModule", {
  value: !0
});
var zy = x1.default = void 0, Cw = xw(N), ww = bw(Uy()), Ow = (0, ww.default)(/* @__PURE__ */ Cw.createElement("path", {
  d: "M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
}), "Check");
zy = x1.default = Ow;
const Ere = Xo(
  (e, t) => {
    const r = Lr(() => Math.floor(Math.random() * 1e4), []), {
      className: n,
      size: a = "medium",
      theme: i = "gray",
      id: o,
      ...u
    } = e, s = o || `checkbox-${r}`;
    return /* @__PURE__ */ _.jsx(
      "label",
      {
        htmlFor: s,
        className: He(
          `form-checkbox form-checkbox--${a} form-checkbox--${i}`,
          {
            [`${n}`]: !!n,
            "form-checkbox--disabled": u.disabled,
            "form-checkbox--checked": u.checked
          }
        ),
        children: /* @__PURE__ */ _.jsxs("div", { className: "form-checkbox__wrapper", children: [
          /* @__PURE__ */ _.jsx(
            "input",
            {
              type: "checkbox",
              className: "form-checkbox__input",
              id: s,
              ref: t,
              ...u
            }
          ),
          /* @__PURE__ */ _.jsx(zy, { className: "form-checkbox__check-icon" })
        ] })
      }
    );
  }
), _re = ({
  children: e,
  className: t,
  tooltipContent: r,
  size: n = "md",
  infoIcon: a = !0
}) => {
  const [i, o] = gn(null);
  return /* @__PURE__ */ _.jsxs(
    "button",
    {
      className: He("info-tooltip input-tooltip__parent", {
        [`${t}`]: !!t
      }),
      ref: (u) => o(u),
      children: [
        /* @__PURE__ */ _.jsx(
          b1,
          {
            direction: "top",
            label: r,
            referenceElement: i
          }
        ),
        e,
        a && /* @__PURE__ */ _.jsx(Wu, { className: "info-tooltip__icon", size: n })
      ]
    }
  );
}, Ire = Xo(
  (e, t) => {
    const {
      className: r,
      inputText: n,
      size: a = "medium",
      theme: i = "gray",
      error: o = !1,
      ...u
    } = e;
    return /* @__PURE__ */ _.jsxs(
      "div",
      {
        className: He(`form-input form-input--${a} form-input--${i}`, {
          [`${r}`]: !!r,
          "form-input--disabled": u.disabled,
          "form-input--has-text": !!n,
          "form-input--error": o
        }),
        children: [
          /* @__PURE__ */ _.jsx("input", { className: "form-input__input", ref: t, ...u }),
          !!n && /* @__PURE__ */ _.jsx("span", { className: "form-input__text", children: n })
        ]
      }
    );
  }
);
var Nf = { exports: {} }, gl = { exports: {} }, $f = { exports: {} }, Ff = { exports: {} }, We = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var n0;
function Sw() {
  if (n0) return We;
  n0 = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, r = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, o = e ? Symbol.for("react.provider") : 60109, u = e ? Symbol.for("react.context") : 60110, s = e ? Symbol.for("react.async_mode") : 60111, c = e ? Symbol.for("react.concurrent_mode") : 60111, l = e ? Symbol.for("react.forward_ref") : 60112, f = e ? Symbol.for("react.suspense") : 60113, d = e ? Symbol.for("react.suspense_list") : 60120, p = e ? Symbol.for("react.memo") : 60115, h = e ? Symbol.for("react.lazy") : 60116, v = e ? Symbol.for("react.block") : 60121, g = e ? Symbol.for("react.fundamental") : 60117, b = e ? Symbol.for("react.responder") : 60118, x = e ? Symbol.for("react.scope") : 60119;
  function w(m) {
    if (typeof m == "object" && m !== null) {
      var C = m.$$typeof;
      switch (C) {
        case t:
          switch (m = m.type, m) {
            case s:
            case c:
            case n:
            case i:
            case a:
            case f:
              return m;
            default:
              switch (m = m && m.$$typeof, m) {
                case u:
                case l:
                case h:
                case p:
                case o:
                  return m;
                default:
                  return C;
              }
          }
        case r:
          return C;
      }
    }
  }
  function y(m) {
    return w(m) === c;
  }
  return We.AsyncMode = s, We.ConcurrentMode = c, We.ContextConsumer = u, We.ContextProvider = o, We.Element = t, We.ForwardRef = l, We.Fragment = n, We.Lazy = h, We.Memo = p, We.Portal = r, We.Profiler = i, We.StrictMode = a, We.Suspense = f, We.isAsyncMode = function(m) {
    return y(m) || w(m) === s;
  }, We.isConcurrentMode = y, We.isContextConsumer = function(m) {
    return w(m) === u;
  }, We.isContextProvider = function(m) {
    return w(m) === o;
  }, We.isElement = function(m) {
    return typeof m == "object" && m !== null && m.$$typeof === t;
  }, We.isForwardRef = function(m) {
    return w(m) === l;
  }, We.isFragment = function(m) {
    return w(m) === n;
  }, We.isLazy = function(m) {
    return w(m) === h;
  }, We.isMemo = function(m) {
    return w(m) === p;
  }, We.isPortal = function(m) {
    return w(m) === r;
  }, We.isProfiler = function(m) {
    return w(m) === i;
  }, We.isStrictMode = function(m) {
    return w(m) === a;
  }, We.isSuspense = function(m) {
    return w(m) === f;
  }, We.isValidElementType = function(m) {
    return typeof m == "string" || typeof m == "function" || m === n || m === c || m === i || m === a || m === f || m === d || typeof m == "object" && m !== null && (m.$$typeof === h || m.$$typeof === p || m.$$typeof === o || m.$$typeof === u || m.$$typeof === l || m.$$typeof === g || m.$$typeof === b || m.$$typeof === x || m.$$typeof === v);
  }, We.typeOf = w, We;
}
var Ge = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var a0;
function Aw() {
  return a0 || (a0 = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, r = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, o = e ? Symbol.for("react.provider") : 60109, u = e ? Symbol.for("react.context") : 60110, s = e ? Symbol.for("react.async_mode") : 60111, c = e ? Symbol.for("react.concurrent_mode") : 60111, l = e ? Symbol.for("react.forward_ref") : 60112, f = e ? Symbol.for("react.suspense") : 60113, d = e ? Symbol.for("react.suspense_list") : 60120, p = e ? Symbol.for("react.memo") : 60115, h = e ? Symbol.for("react.lazy") : 60116, v = e ? Symbol.for("react.block") : 60121, g = e ? Symbol.for("react.fundamental") : 60117, b = e ? Symbol.for("react.responder") : 60118, x = e ? Symbol.for("react.scope") : 60119;
    function w(E) {
      return typeof E == "string" || typeof E == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      E === n || E === c || E === i || E === a || E === f || E === d || typeof E == "object" && E !== null && (E.$$typeof === h || E.$$typeof === p || E.$$typeof === o || E.$$typeof === u || E.$$typeof === l || E.$$typeof === g || E.$$typeof === b || E.$$typeof === x || E.$$typeof === v);
    }
    function y(E) {
      if (typeof E == "object" && E !== null) {
        var K = E.$$typeof;
        switch (K) {
          case t:
            var Z = E.type;
            switch (Z) {
              case s:
              case c:
              case n:
              case i:
              case a:
              case f:
                return Z;
              default:
                var Q = Z && Z.$$typeof;
                switch (Q) {
                  case u:
                  case l:
                  case h:
                  case p:
                  case o:
                    return Q;
                  default:
                    return K;
                }
            }
          case r:
            return K;
        }
      }
    }
    var m = s, C = c, O = u, S = o, A = t, P = l, T = n, M = h, I = p, G = r, Y = i, L = a, X = f, q = !1;
    function re(E) {
      return q || (q = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), j(E) || y(E) === s;
    }
    function j(E) {
      return y(E) === c;
    }
    function W(E) {
      return y(E) === u;
    }
    function D(E) {
      return y(E) === o;
    }
    function R(E) {
      return typeof E == "object" && E !== null && E.$$typeof === t;
    }
    function $(E) {
      return y(E) === l;
    }
    function B(E) {
      return y(E) === n;
    }
    function H(E) {
      return y(E) === h;
    }
    function z(E) {
      return y(E) === p;
    }
    function J(E) {
      return y(E) === r;
    }
    function U(E) {
      return y(E) === i;
    }
    function F(E) {
      return y(E) === a;
    }
    function k(E) {
      return y(E) === f;
    }
    Ge.AsyncMode = m, Ge.ConcurrentMode = C, Ge.ContextConsumer = O, Ge.ContextProvider = S, Ge.Element = A, Ge.ForwardRef = P, Ge.Fragment = T, Ge.Lazy = M, Ge.Memo = I, Ge.Portal = G, Ge.Profiler = Y, Ge.StrictMode = L, Ge.Suspense = X, Ge.isAsyncMode = re, Ge.isConcurrentMode = j, Ge.isContextConsumer = W, Ge.isContextProvider = D, Ge.isElement = R, Ge.isForwardRef = $, Ge.isFragment = B, Ge.isLazy = H, Ge.isMemo = z, Ge.isPortal = J, Ge.isProfiler = U, Ge.isStrictMode = F, Ge.isSuspense = k, Ge.isValidElementType = w, Ge.typeOf = y;
  }()), Ge;
}
process.env.NODE_ENV === "production" ? Ff.exports = Sw() : Ff.exports = Aw();
var j1 = Ff.exports;
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var ml, i0;
function Ew() {
  if (i0) return ml;
  i0 = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, r = Object.prototype.propertyIsEnumerable;
  function n(i) {
    if (i == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(i);
  }
  function a() {
    try {
      if (!Object.assign)
        return !1;
      var i = new String("abc");
      if (i[5] = "de", Object.getOwnPropertyNames(i)[0] === "5")
        return !1;
      for (var o = {}, u = 0; u < 10; u++)
        o["_" + String.fromCharCode(u)] = u;
      var s = Object.getOwnPropertyNames(o).map(function(l) {
        return o[l];
      });
      if (s.join("") !== "0123456789")
        return !1;
      var c = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(l) {
        c[l] = l;
      }), Object.keys(Object.assign({}, c)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return ml = a() ? Object.assign : function(i, o) {
    for (var u, s = n(i), c, l = 1; l < arguments.length; l++) {
      u = Object(arguments[l]);
      for (var f in u)
        t.call(u, f) && (s[f] = u[f]);
      if (e) {
        c = e(u);
        for (var d = 0; d < c.length; d++)
          r.call(u, c[d]) && (s[c[d]] = u[c[d]]);
      }
    }
    return s;
  }, ml;
}
var yl, o0;
function R1() {
  if (o0) return yl;
  o0 = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return yl = e, yl;
}
var bl, u0;
function Yy() {
  return u0 || (u0 = 1, bl = Function.call.bind(Object.prototype.hasOwnProperty)), bl;
}
var xl, s0;
function _w() {
  if (s0) return xl;
  s0 = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = R1(), r = {}, n = Yy();
    e = function(i) {
      var o = "Warning: " + i;
      typeof console < "u" && console.error(o);
      try {
        throw new Error(o);
      } catch {
      }
    };
  }
  function a(i, o, u, s, c) {
    if (process.env.NODE_ENV !== "production") {
      for (var l in i)
        if (n(i, l)) {
          var f;
          try {
            if (typeof i[l] != "function") {
              var d = Error(
                (s || "React class") + ": " + u + " type `" + l + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof i[l] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw d.name = "Invariant Violation", d;
            }
            f = i[l](o, l, s, u, null, t);
          } catch (h) {
            f = h;
          }
          if (f && !(f instanceof Error) && e(
            (s || "React class") + ": type specification of " + u + " `" + l + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof f + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), f instanceof Error && !(f.message in r)) {
            r[f.message] = !0;
            var p = c ? c() : "";
            e(
              "Failed " + u + " type: " + f.message + (p ?? "")
            );
          }
        }
    }
  }
  return a.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (r = {});
  }, xl = a, xl;
}
var Cl, c0;
function Iw() {
  if (c0) return Cl;
  c0 = 1;
  var e = j1, t = Ew(), r = R1(), n = Yy(), a = _w(), i = function() {
  };
  process.env.NODE_ENV !== "production" && (i = function(u) {
    var s = "Warning: " + u;
    typeof console < "u" && console.error(s);
    try {
      throw new Error(s);
    } catch {
    }
  });
  function o() {
    return null;
  }
  return Cl = function(u, s) {
    var c = typeof Symbol == "function" && Symbol.iterator, l = "@@iterator";
    function f(j) {
      var W = j && (c && j[c] || j[l]);
      if (typeof W == "function")
        return W;
    }
    var d = "<<anonymous>>", p = {
      array: b("array"),
      bigint: b("bigint"),
      bool: b("boolean"),
      func: b("function"),
      number: b("number"),
      object: b("object"),
      string: b("string"),
      symbol: b("symbol"),
      any: x(),
      arrayOf: w,
      element: y(),
      elementType: m(),
      instanceOf: C,
      node: P(),
      objectOf: S,
      oneOf: O,
      oneOfType: A,
      shape: M,
      exact: I
    };
    function h(j, W) {
      return j === W ? j !== 0 || 1 / j === 1 / W : j !== j && W !== W;
    }
    function v(j, W) {
      this.message = j, this.data = W && typeof W == "object" ? W : {}, this.stack = "";
    }
    v.prototype = Error.prototype;
    function g(j) {
      if (process.env.NODE_ENV !== "production")
        var W = {}, D = 0;
      function R(B, H, z, J, U, F, k) {
        if (J = J || d, F = F || z, k !== r) {
          if (s) {
            var E = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw E.name = "Invariant Violation", E;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var K = J + ":" + z;
            !W[K] && // Avoid spamming the console because they are often not actionable except for lib authors
            D < 3 && (i(
              "You are manually calling a React.PropTypes validation function for the `" + F + "` prop on `" + J + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), W[K] = !0, D++);
          }
        }
        return H[z] == null ? B ? H[z] === null ? new v("The " + U + " `" + F + "` is marked as required " + ("in `" + J + "`, but its value is `null`.")) : new v("The " + U + " `" + F + "` is marked as required in " + ("`" + J + "`, but its value is `undefined`.")) : null : j(H, z, J, U, F);
      }
      var $ = R.bind(null, !1);
      return $.isRequired = R.bind(null, !0), $;
    }
    function b(j) {
      function W(D, R, $, B, H, z) {
        var J = D[R], U = L(J);
        if (U !== j) {
          var F = X(J);
          return new v(
            "Invalid " + B + " `" + H + "` of type " + ("`" + F + "` supplied to `" + $ + "`, expected ") + ("`" + j + "`."),
            { expectedType: j }
          );
        }
        return null;
      }
      return g(W);
    }
    function x() {
      return g(o);
    }
    function w(j) {
      function W(D, R, $, B, H) {
        if (typeof j != "function")
          return new v("Property `" + H + "` of component `" + $ + "` has invalid PropType notation inside arrayOf.");
        var z = D[R];
        if (!Array.isArray(z)) {
          var J = L(z);
          return new v("Invalid " + B + " `" + H + "` of type " + ("`" + J + "` supplied to `" + $ + "`, expected an array."));
        }
        for (var U = 0; U < z.length; U++) {
          var F = j(z, U, $, B, H + "[" + U + "]", r);
          if (F instanceof Error)
            return F;
        }
        return null;
      }
      return g(W);
    }
    function y() {
      function j(W, D, R, $, B) {
        var H = W[D];
        if (!u(H)) {
          var z = L(H);
          return new v("Invalid " + $ + " `" + B + "` of type " + ("`" + z + "` supplied to `" + R + "`, expected a single ReactElement."));
        }
        return null;
      }
      return g(j);
    }
    function m() {
      function j(W, D, R, $, B) {
        var H = W[D];
        if (!e.isValidElementType(H)) {
          var z = L(H);
          return new v("Invalid " + $ + " `" + B + "` of type " + ("`" + z + "` supplied to `" + R + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return g(j);
    }
    function C(j) {
      function W(D, R, $, B, H) {
        if (!(D[R] instanceof j)) {
          var z = j.name || d, J = re(D[R]);
          return new v("Invalid " + B + " `" + H + "` of type " + ("`" + J + "` supplied to `" + $ + "`, expected ") + ("instance of `" + z + "`."));
        }
        return null;
      }
      return g(W);
    }
    function O(j) {
      if (!Array.isArray(j))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? i(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : i("Invalid argument supplied to oneOf, expected an array.")), o;
      function W(D, R, $, B, H) {
        for (var z = D[R], J = 0; J < j.length; J++)
          if (h(z, j[J]))
            return null;
        var U = JSON.stringify(j, function(k, E) {
          var K = X(E);
          return K === "symbol" ? String(E) : E;
        });
        return new v("Invalid " + B + " `" + H + "` of value `" + String(z) + "` " + ("supplied to `" + $ + "`, expected one of " + U + "."));
      }
      return g(W);
    }
    function S(j) {
      function W(D, R, $, B, H) {
        if (typeof j != "function")
          return new v("Property `" + H + "` of component `" + $ + "` has invalid PropType notation inside objectOf.");
        var z = D[R], J = L(z);
        if (J !== "object")
          return new v("Invalid " + B + " `" + H + "` of type " + ("`" + J + "` supplied to `" + $ + "`, expected an object."));
        for (var U in z)
          if (n(z, U)) {
            var F = j(z, U, $, B, H + "." + U, r);
            if (F instanceof Error)
              return F;
          }
        return null;
      }
      return g(W);
    }
    function A(j) {
      if (!Array.isArray(j))
        return process.env.NODE_ENV !== "production" && i("Invalid argument supplied to oneOfType, expected an instance of array."), o;
      for (var W = 0; W < j.length; W++) {
        var D = j[W];
        if (typeof D != "function")
          return i(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + q(D) + " at index " + W + "."
          ), o;
      }
      function R($, B, H, z, J) {
        for (var U = [], F = 0; F < j.length; F++) {
          var k = j[F], E = k($, B, H, z, J, r);
          if (E == null)
            return null;
          E.data && n(E.data, "expectedType") && U.push(E.data.expectedType);
        }
        var K = U.length > 0 ? ", expected one of type [" + U.join(", ") + "]" : "";
        return new v("Invalid " + z + " `" + J + "` supplied to " + ("`" + H + "`" + K + "."));
      }
      return g(R);
    }
    function P() {
      function j(W, D, R, $, B) {
        return G(W[D]) ? null : new v("Invalid " + $ + " `" + B + "` supplied to " + ("`" + R + "`, expected a ReactNode."));
      }
      return g(j);
    }
    function T(j, W, D, R, $) {
      return new v(
        (j || "React class") + ": " + W + " type `" + D + "." + R + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + $ + "`."
      );
    }
    function M(j) {
      function W(D, R, $, B, H) {
        var z = D[R], J = L(z);
        if (J !== "object")
          return new v("Invalid " + B + " `" + H + "` of type `" + J + "` " + ("supplied to `" + $ + "`, expected `object`."));
        for (var U in j) {
          var F = j[U];
          if (typeof F != "function")
            return T($, B, H, U, X(F));
          var k = F(z, U, $, B, H + "." + U, r);
          if (k)
            return k;
        }
        return null;
      }
      return g(W);
    }
    function I(j) {
      function W(D, R, $, B, H) {
        var z = D[R], J = L(z);
        if (J !== "object")
          return new v("Invalid " + B + " `" + H + "` of type `" + J + "` " + ("supplied to `" + $ + "`, expected `object`."));
        var U = t({}, D[R], j);
        for (var F in U) {
          var k = j[F];
          if (n(j, F) && typeof k != "function")
            return T($, B, H, F, X(k));
          if (!k)
            return new v(
              "Invalid " + B + " `" + H + "` key `" + F + "` supplied to `" + $ + "`.\nBad object: " + JSON.stringify(D[R], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(j), null, "  ")
            );
          var E = k(z, F, $, B, H + "." + F, r);
          if (E)
            return E;
        }
        return null;
      }
      return g(W);
    }
    function G(j) {
      switch (typeof j) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !j;
        case "object":
          if (Array.isArray(j))
            return j.every(G);
          if (j === null || u(j))
            return !0;
          var W = f(j);
          if (W) {
            var D = W.call(j), R;
            if (W !== j.entries) {
              for (; !(R = D.next()).done; )
                if (!G(R.value))
                  return !1;
            } else
              for (; !(R = D.next()).done; ) {
                var $ = R.value;
                if ($ && !G($[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function Y(j, W) {
      return j === "symbol" ? !0 : W ? W["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && W instanceof Symbol : !1;
    }
    function L(j) {
      var W = typeof j;
      return Array.isArray(j) ? "array" : j instanceof RegExp ? "object" : Y(W, j) ? "symbol" : W;
    }
    function X(j) {
      if (typeof j > "u" || j === null)
        return "" + j;
      var W = L(j);
      if (W === "object") {
        if (j instanceof Date)
          return "date";
        if (j instanceof RegExp)
          return "regexp";
      }
      return W;
    }
    function q(j) {
      var W = X(j);
      switch (W) {
        case "array":
        case "object":
          return "an " + W;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + W;
        default:
          return W;
      }
    }
    function re(j) {
      return !j.constructor || !j.constructor.name ? d : j.constructor.name;
    }
    return p.checkPropTypes = a, p.resetWarningCache = a.resetWarningCache, p.PropTypes = p, p;
  }, Cl;
}
var wl, l0;
function Pw() {
  if (l0) return wl;
  l0 = 1;
  var e = R1();
  function t() {
  }
  function r() {
  }
  return r.resetWarningCache = t, wl = function() {
    function n(o, u, s, c, l, f) {
      if (f !== e) {
        var d = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw d.name = "Invariant Violation", d;
      }
    }
    n.isRequired = n;
    function a() {
      return n;
    }
    var i = {
      array: n,
      bigint: n,
      bool: n,
      func: n,
      number: n,
      object: n,
      string: n,
      symbol: n,
      any: n,
      arrayOf: a,
      element: n,
      elementType: n,
      instanceOf: a,
      node: n,
      objectOf: a,
      oneOf: a,
      oneOfType: a,
      shape: a,
      exact: a,
      checkPropTypes: r,
      resetWarningCache: t
    };
    return i.PropTypes = i, i;
  }, wl;
}
if (process.env.NODE_ENV !== "production") {
  var Tw = j1, Mw = !0;
  $f.exports = Iw()(Tw.isElement, Mw);
} else
  $f.exports = Pw()();
var Xy = $f.exports, Ol, f0;
function Zy() {
  if (f0) return Ol;
  f0 = 1;
  var e = function(t, r, n, a, i, o, u, s) {
    if (process.env.NODE_ENV !== "production" && r === void 0)
      throw new Error("invariant requires an error message argument");
    if (!t) {
      var c;
      if (r === void 0)
        c = new Error(
          "Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings."
        );
      else {
        var l = [n, a, i, o, u, s], f = 0;
        c = new Error(
          r.replace(/%s/g, function() {
            return l[f++];
          })
        ), c.name = "Invariant Violation";
      }
      throw c.framesToPop = 1, c;
    }
  };
  return Ol = e, Ol;
}
var Sl, d0;
function Ky() {
  if (d0) return Sl;
  d0 = 1;
  var e = process.env.NODE_ENV !== "production", t = function() {
  };
  if (e) {
    var r = function(a, i) {
      var o = arguments.length;
      i = new Array(o > 1 ? o - 1 : 0);
      for (var u = 1; u < o; u++)
        i[u - 1] = arguments[u];
      var s = 0, c = "Warning: " + a.replace(/%s/g, function() {
        return i[s++];
      });
      typeof console < "u" && console.error(c);
      try {
        throw new Error(c);
      } catch {
      }
    };
    t = function(n, a, i) {
      var o = arguments.length;
      i = new Array(o > 2 ? o - 2 : 0);
      for (var u = 2; u < o; u++)
        i[u - 2] = arguments[u];
      if (a === void 0)
        throw new Error(
          "`warning(condition, format, ...args)` requires a warning message argument"
        );
      n || r.apply(null, [a].concat(i));
    };
  }
  return Sl = t, Sl;
}
var p0;
function jw() {
  if (p0) return gl.exports;
  p0 = 1;
  function e(m) {
    return m && typeof m == "object" && "default" in m ? m.default : m;
  }
  var t = N, r = e(t), n = Xm, a = e(Zy());
  function i() {
    return (i = Object.assign || function(m) {
      for (var C = 1; C < arguments.length; C++) {
        var O = arguments[C];
        for (var S in O) Object.prototype.hasOwnProperty.call(O, S) && (m[S] = O[S]);
      }
      return m;
    }).apply(this, arguments);
  }
  function o(m, C) {
    m.prototype = Object.create(C.prototype), m.prototype.constructor = m, function(O, S) {
      for (var A = Object.getOwnPropertyNames(S), P = 0; P < A.length; P++) {
        var T = A[P], M = Object.getOwnPropertyDescriptor(S, T);
        M && M.configurable && O[T] === void 0 && Object.defineProperty(O, T, M);
      }
    }(m, C);
  }
  function u(m, C) {
    if (m == null) return {};
    var O, S, A = {}, P = Object.keys(m);
    for (S = 0; S < P.length; S++) O = P[S], C.indexOf(O) >= 0 || (A[O] = m[O]);
    return A;
  }
  function s(m) {
    return requestAnimationFrame(m);
  }
  function c(m) {
    cancelAnimationFrame(m);
  }
  function l(m) {
    var C = m.ownerDocument;
    return C.hasFocus() && C.activeElement === m;
  }
  function f(m) {
    return m == null ? void 0 : m.ownerDocument;
  }
  function d(m) {
    var C = function(O) {
      var S;
      return (S = f(O)) == null ? void 0 : S.defaultView;
    }(m);
    return !!C && m instanceof C.HTMLElement;
  }
  function p(m) {
    return t.useCallback(function() {
      var C = m.current, O = typeof window < "u" && d(C);
      if (!C || !O) return null;
      if (C.nodeName !== "INPUT" && (C = C.querySelector("input")), !C) throw new Error("react-input-mask: inputComponent doesn't contain input node");
      return C;
    }, [m]);
  }
  function h(m, C) {
    var O, S, A, P, T = t.useRef({ start: null, end: null }), M = p(m), I = t.useCallback(function() {
      return function(j) {
        var W = j.selectionStart, D = j.selectionEnd;
        return { start: W, end: D, length: D - W };
      }(M());
    }, [M]), G = t.useCallback(function() {
      return T.current;
    }, []), Y = t.useCallback(function(j) {
      var W = M();
      W && l(W) && (function(D, R, $) {
        $ === void 0 && ($ = R), D.setSelectionRange(R, $);
      }(W, j.start, j.end), T.current = I());
    }, [M, I]), L = t.useCallback(function() {
      T.current = I();
    }, [I]), X = (O = L, S = t.useRef(null), A = t.useCallback(function() {
      S.current === null && function j() {
        O(), S.current = s(j);
      }();
    }, [O]), P = t.useCallback(function() {
      c(S.current), S.current = null;
    }, []), t.useEffect(function() {
      S.current && (P(), A());
    }, [A, P]), t.useEffect(c, []), [A, P]), q = X[0], re = X[1];
    return t.useLayoutEffect(function() {
      if (C) {
        var j = M();
        return j.addEventListener("focus", q), j.addEventListener("blur", re), l(j) && q(), function() {
          j.removeEventListener("focus", q), j.removeEventListener("blur", re), re();
        };
      }
    }), { getSelection: I, getLastSelection: G, setSelection: Y };
  }
  function v(m, C) {
    var O = t.useRef(), S = h(O, C), A = S.getSelection, P = S.getLastSelection, T = S.setSelection, M = function(L, X) {
      var q = p(L), re = t.useRef(X);
      return { getValue: t.useCallback(function() {
        return q().value;
      }, [q]), getLastValue: t.useCallback(function() {
        return re.current;
      }, []), setValue: t.useCallback(function(j) {
        re.current = j;
        var W = q();
        W && (W.value = j);
      }, [q]) };
    }(O, m), I = M.getValue, G = M.getLastValue, Y = M.setValue;
    return { inputRef: O, getInputState: function() {
      return { value: I(), selection: A() };
    }, getLastInputState: function() {
      return { value: G(), selection: P() };
    }, setInputState: function(L) {
      var X = L.value, q = L.selection;
      Y(X), T(q);
    } };
  }
  Ky();
  var g = ["disabled", "onBlur", "onChange", "onFocus", "onMouseDown", "readOnly", "value"], b = { 9: /[0-9]/, a: /[A-Za-z]/, "*": /[A-Za-z0-9]/ }, x = function(m) {
    var C = this;
    this.isCharacterAllowedAtPosition = function(O, S) {
      var A = C.maskOptions.maskPlaceholder;
      return !!C.isCharacterFillingPosition(O, S) || !!A && A[S] === O;
    }, this.isCharacterFillingPosition = function(O, S) {
      var A = C.maskOptions.mask;
      if (!O || S >= A.length) return !1;
      if (!C.isPositionEditable(S)) return A[S] === O;
      var P = A[S];
      return new RegExp(P).test(O);
    }, this.isPositionEditable = function(O) {
      var S = C.maskOptions, A = S.mask, P = S.permanents;
      return O < A.length && P.indexOf(O) === -1;
    }, this.isValueEmpty = function(O) {
      return O.split("").every(function(S, A) {
        return !C.isPositionEditable(A) || !C.isCharacterFillingPosition(S, A);
      });
    }, this.isValueFilled = function(O) {
      return C.getFilledLength(O) === C.maskOptions.lastEditablePosition + 1;
    }, this.getDefaultSelectionForValue = function(O) {
      var S = C.getFilledLength(O), A = C.getRightEditablePosition(S);
      return { start: A, end: A };
    }, this.getFilledLength = function(O) {
      return function(S, A) {
        for (var P = S.length - 1; P >= 0; P--)
          if (A(S[P], P)) return P;
        return -1;
      }(O.split(""), function(S, A) {
        return C.isPositionEditable(A) && C.isCharacterFillingPosition(S, A);
      }) + 1;
    }, this.getStringFillingLengthAtPosition = function(O, S) {
      return O.split("").reduce(function(A, P) {
        return C.insertCharacterAtPosition(A, P, A.length);
      }, function(A, P) {
        P === void 0 && (P = 1);
        for (var T = "", M = 0; M < P; M++) T += A;
        return T;
      }(" ", S)).length - S;
    }, this.getLeftEditablePosition = function(O) {
      for (var S = O; S >= 0; S--) if (C.isPositionEditable(S)) return S;
      return null;
    }, this.getRightEditablePosition = function(O) {
      for (var S = C.maskOptions.mask, A = O; A < S.length; A++) if (C.isPositionEditable(A)) return A;
      return null;
    }, this.formatValue = function(O) {
      var S = C.maskOptions, A = S.maskPlaceholder, P = S.mask;
      if (!A) {
        for (O = C.insertStringAtPosition("", O, 0); O.length < P.length && !C.isPositionEditable(O.length); ) O += P[O.length];
        return O;
      }
      return C.insertStringAtPosition(A, O, 0);
    }, this.clearRange = function(O, S, A) {
      if (!A) return O;
      var P = S + A, T = C.maskOptions, M = T.maskPlaceholder, I = T.mask, G = O.split("").map(function(Y, L) {
        var X = C.isPositionEditable(L);
        return !M && L >= P && !X ? "" : L < S || L >= P ? Y : X ? M ? M[L] : "" : I[L];
      }).join("");
      return C.formatValue(G);
    }, this.insertCharacterAtPosition = function(O, S, A) {
      var P = C.maskOptions, T = P.mask, M = P.maskPlaceholder;
      if (A >= T.length) return O;
      var I = C.isCharacterAllowedAtPosition(S, A), G = C.isPositionEditable(A), Y = C.getRightEditablePosition(A), L = M && Y ? S === M[Y] : null, X = O.slice(0, A);
      return !I && G || (O = X + (I ? S : T[A])), I || G || L || (O = C.insertCharacterAtPosition(O, S, A + 1)), O;
    }, this.insertStringAtPosition = function(O, S, A) {
      var P = C.maskOptions, T = P.mask, M = P.maskPlaceholder;
      if (!S || A >= T.length) return O;
      var I = S.split(""), G = C.isValueFilled(O) || !!M, Y = O.slice(A);
      return O = I.reduce(function(L, X) {
        return C.insertCharacterAtPosition(L, X, L.length);
      }, O.slice(0, A)), G ? O += Y.slice(O.length - A) : C.isValueFilled(O) ? O += T.slice(O.length).join("") : O = Y.split("").filter(function(L, X) {
        return C.isPositionEditable(A + X);
      }).reduce(function(L, X) {
        var q = C.getRightEditablePosition(L.length);
        return q === null ? L : (C.isPositionEditable(L.length) || (L += T.slice(L.length, q).join("")), C.insertCharacterAtPosition(L, X, L.length));
      }, O), O;
    }, this.processChange = function(O, S) {
      var A = C.maskOptions, P = A.mask, T = A.prefix, M = A.lastEditablePosition, I = O.value, G = O.selection, Y = S.value, L = S.selection, X = I, q = "", re = 0, j = 0, W = Math.min(L.start, G.start);
      return G.end > L.start ? (q = X.slice(L.start, G.end), j = (re = C.getStringFillingLengthAtPosition(q, W)) ? L.length : 0) : X.length < Y.length && (j = Y.length - X.length), X = Y, j && (j === 1 && !L.length && (W = L.start === G.start ? C.getRightEditablePosition(G.start) : C.getLeftEditablePosition(G.start)), X = C.clearRange(X, W, j)), X = C.insertStringAtPosition(X, q, W), (W += re) >= P.length ? W = P.length : W < T.length && !re ? W = T.length : W >= T.length && W < M && re && (W = C.getRightEditablePosition(W)), { value: X = C.formatValue(X), enteredString: q, selection: { start: W, end: W } };
    }, this.maskOptions = function(O) {
      var S = O.mask, A = O.maskPlaceholder, P = [];
      if (!S) return { maskPlaceholder: null, mask: null, prefix: null, lastEditablePosition: null, permanents: [] };
      if (typeof S == "string") {
        var T = !1, M = "";
        S.split("").forEach(function(Y) {
          T || Y !== "\\" ? (!T && b[Y] || P.push(M.length), M += Y, T = !1) : T = !0;
        }), S = M.split("").map(function(Y, L) {
          return P.indexOf(L) === -1 ? b[Y] : Y;
        });
      } else S.forEach(function(Y, L) {
        typeof Y == "string" && P.push(L);
      });
      A && (A = A.length === 1 ? S.map(function(Y, L) {
        return P.indexOf(L) !== -1 ? Y : A;
      }) : A.split(""), P.forEach(function(Y) {
        A[Y] = S[Y];
      }), A = A.join(""));
      for (var I = P.filter(function(Y, L) {
        return Y === L;
      }).map(function(Y) {
        return S[Y];
      }).join(""), G = S.length - 1; P.indexOf(G) !== -1; ) G--;
      return { maskPlaceholder: A, prefix: I, mask: S, lastEditablePosition: G, permanents: P };
    }(m);
  }, w = function(m) {
    function C() {
      return m.apply(this, arguments) || this;
    }
    return o(C, m), C.prototype.render = function() {
      var O = this.props, S = O.children, A = u(O, ["children"]);
      return r.cloneElement(S, A);
    }, C;
  }(r.Component), y = t.forwardRef(function(m, C) {
    var O = m.alwaysShowMask, S = m.children, A = m.mask, P = m.maskPlaceholder, T = m.beforeMaskedStateChange, M = u(m, ["alwaysShowMask", "children", "mask", "maskPlaceholder", "beforeMaskedStateChange"]);
    (function(E) {
      var K = E.mask, Z = E.maskPlaceholder;
      K && Z && Z.length !== 1 && Z.length !== K.length && a(!1);
    })(m);
    var I, G, Y = new x({ mask: A, maskPlaceholder: P }), L = !!A, X = !M.disabled && !M.readOnly, q = m.value !== null && m.value !== void 0, re = (I = L, G = t.useRef(), t.useEffect(function() {
      G.current = I;
    }), G.current), j = v(function(E) {
      return "" + E;
    }((q ? m.value : m.defaultValue) || ""), L), W = j.inputRef, D = j.getInputState, R = j.setInputState, $ = j.getLastInputState, B = p(W);
    if (L && q) {
      var H = B(), z = H && l(H) || O || m.value ? Y.formatValue(m.value) : m.value;
      T && (z = T({ nextState: { value: z, selection: { start: null, end: null } } }).value), R(i({}, $(), { value: z }));
    }
    var J = $(), U = J.selection, F = J.value;
    t.useLayoutEffect(function() {
      if (L) {
        var E = l(B()), K = U, Z = D(), Q = i({}, Z);
        if (!q) {
          var ne = Z.value, ue = Y.formatValue(ne), de = Y.isValueEmpty(ue);
          !de || E || O ? Q.value = ue : de && !E && (Q.value = "");
        }
        E && !re ? Q.selection = Y.getDefaultSelectionForValue(Q.value) : q && E && K && K.start !== null && K.end !== null && (Q.selection = K), T && (Q = T({ currentState: Z, nextState: Q })), R(Q);
      }
    });
    var k = i({}, M, { onFocus: function(E) {
      W.current = E.target;
      var K = D().value;
      if (L && !Y.isValueFilled(K)) {
        var Z = Y.formatValue(K), Q = Y.getDefaultSelectionForValue(Z), ne = { value: Z, selection: Q };
        T && (Z = (ne = T({ currentState: D(), nextState: ne })).value, Q = ne.selection), R(ne), Z !== K && m.onChange && m.onChange(E), s(function() {
          R($());
        });
      }
      m.onFocus && m.onFocus(E);
    }, onBlur: function(E) {
      var K = D().value, Z = $().value;
      if (L && !O && Y.isValueEmpty(Z)) {
        var Q = "", ne = { value: Q, selection: { start: null, end: null } };
        T && (Q = (ne = T({ currentState: D(), nextState: ne })).value), R(ne), Q !== K && m.onChange && m.onChange(E);
      }
      m.onBlur && m.onBlur(E);
    }, onChange: L && X ? function(E) {
      var K = D(), Z = $(), Q = Y.processChange(K, Z);
      T && (Q = T({ currentState: K, previousState: Z, nextState: Q })), R(Q), m.onChange && m.onChange(E);
    } : m.onChange, onMouseDown: L && X ? function(E) {
      var K = B(), Z = D().value, Q = f(K);
      if (!l(K) && !Y.isValueFilled(Z)) {
        var ne = E.clientX, ue = E.clientY, de = (/* @__PURE__ */ new Date()).getTime();
        Q.addEventListener("mouseup", function le(pe) {
          if (Q.removeEventListener("mouseup", le), l(K)) {
            var ie = Math.abs(pe.clientX - ne), Te = Math.abs(pe.clientY - ue), Qe = Math.max(ie, Te), Ot = (/* @__PURE__ */ new Date()).getTime() - de;
            if (Qe <= 10 && Ot <= 200 || Qe <= 5 && Ot <= 300) {
              var Gt = $(), qt = i({}, Gt, { selection: Y.getDefaultSelectionForValue(Gt.value) });
              R(qt);
            }
          }
        });
      }
      m.onMouseDown && m.onMouseDown(E);
    } : m.onMouseDown, ref: function(E) {
      W.current = n.findDOMNode(E), /* @__PURE__ */ function(K) {
        return typeof K == "function";
      }(C) ? C(E) : C !== null && typeof C == "object" && (C.current = E);
    }, value: L && q ? F : m.value });
    return S ? (function(E, K) {
      g.filter(function(Z) {
        return K.props[Z] != null && K.props[Z] !== E[Z];
      }).length && a(!1);
    }(m, S), r.createElement(w, k, S)) : r.createElement("input", k);
  });
  return y.displayName = "InputMask", y.defaultProps = { alwaysShowMask: !1, maskPlaceholder: "_" }, gl.exports = y, gl.exports;
}
var Al, h0;
function Rw() {
  if (h0) return Al;
  h0 = 1;
  function e(D) {
    return D && typeof D == "object" && "default" in D ? D.default : D;
  }
  var t = N, r = e(t), n = Xm, a = e(Xy), i = e(Zy()), o = e(Ky());
  function u(D, R) {
    for (var $ = Object.getOwnPropertyNames(R), B = 0; B < $.length; B++) {
      var H = $[B], z = Object.getOwnPropertyDescriptor(R, H);
      z && z.configurable && D[H] === void 0 && Object.defineProperty(D, H, z);
    }
    return D;
  }
  function s() {
    return s = Object.assign || function(D) {
      for (var R = 1; R < arguments.length; R++) {
        var $ = arguments[R];
        for (var B in $)
          Object.prototype.hasOwnProperty.call($, B) && (D[B] = $[B]);
      }
      return D;
    }, s.apply(this, arguments);
  }
  function c(D, R) {
    D.prototype = Object.create(R.prototype), D.prototype.constructor = D, u(D, R);
  }
  function l(D, R) {
    if (D == null) return {};
    var $ = {}, B = Object.keys(D), H, z;
    for (z = 0; z < B.length; z++)
      H = B[z], !(R.indexOf(H) >= 0) && ($[H] = D[H]);
    return $;
  }
  function f(D) {
    return requestAnimationFrame(D);
  }
  function d(D) {
    cancelAnimationFrame(D);
  }
  function p(D, R, $) {
    $ === void 0 && ($ = R), D.setSelectionRange(R, $);
  }
  function h(D) {
    var R = D.selectionStart, $ = D.selectionEnd;
    return {
      start: R,
      end: $,
      length: $ - R
    };
  }
  function v(D) {
    var R = D.ownerDocument;
    return R.hasFocus() && R.activeElement === D;
  }
  function g(D) {
    return D == null ? void 0 : D.ownerDocument;
  }
  function b(D) {
    var R;
    return (R = g(D)) == null ? void 0 : R.defaultView;
  }
  function x(D) {
    var R = b(D);
    return !!R && D instanceof R.HTMLElement;
  }
  function w(D) {
    return typeof D == "function";
  }
  function y(D, R) {
    for (var $ = D.length - 1; $ >= 0; $--) {
      var B = D[$];
      if (R(B, $))
        return $;
    }
    return -1;
  }
  function m(D, R) {
    R === void 0 && (R = 1);
    for (var $ = "", B = 0; B < R; B++)
      $ += D;
    return $;
  }
  function C(D) {
    return "" + D;
  }
  function O(D) {
    return t.useCallback(function() {
      var R = D.current, $ = typeof window < "u" && x(R);
      if (!R || !$)
        return null;
      if (R.nodeName !== "INPUT" && (R = R.querySelector("input")), !R)
        throw new Error("react-input-mask: inputComponent doesn't contain input node");
      return R;
    }, [D]);
  }
  function S(D) {
    var R = t.useRef(null), $ = t.useCallback(function() {
      if (R.current !== null)
        return;
      function H() {
        D(), R.current = f(H);
      }
      H();
    }, [D]), B = t.useCallback(function() {
      d(R.current), R.current = null;
    }, []);
    return t.useEffect(function() {
      R.current && (B(), $());
    }, [$, B]), t.useEffect(d, []), [$, B];
  }
  function A(D, R) {
    var $ = t.useRef({
      start: null,
      end: null
    }), B = O(D), H = t.useCallback(function() {
      var K = B();
      return h(K);
    }, [B]), z = t.useCallback(function() {
      return $.current;
    }, []), J = t.useCallback(function(K) {
      var Z = B();
      !Z || !v(Z) || (p(Z, K.start, K.end), $.current = H());
    }, [B, H]), U = t.useCallback(function() {
      $.current = H();
    }, [H]), F = S(U), k = F[0], E = F[1];
    return t.useLayoutEffect(function() {
      if (R) {
        var K = B();
        return K.addEventListener("focus", k), K.addEventListener("blur", E), v(K) && k(), function() {
          K.removeEventListener("focus", k), K.removeEventListener("blur", E), E();
        };
      }
    }), {
      getSelection: H,
      getLastSelection: z,
      setSelection: J
    };
  }
  function P(D, R) {
    var $ = O(D), B = t.useRef(R), H = t.useCallback(function() {
      var U = $();
      return U.value;
    }, [$]), z = t.useCallback(function() {
      return B.current;
    }, []), J = t.useCallback(function(U) {
      B.current = U;
      var F = $();
      F && (F.value = U);
    }, [$]);
    return {
      getValue: H,
      getLastValue: z,
      setValue: J
    };
  }
  function T(D, R) {
    var $ = t.useRef(), B = A($, R), H = B.getSelection, z = B.getLastSelection, J = B.setSelection, U = P($, D), F = U.getValue, k = U.getLastValue, E = U.setValue;
    function K() {
      return {
        value: k(),
        selection: z()
      };
    }
    function Z() {
      return {
        value: F(),
        selection: H()
      };
    }
    function Q(ne) {
      var ue = ne.value, de = ne.selection;
      E(ue), J(de);
    }
    return {
      inputRef: $,
      getInputState: Z,
      getLastInputState: K,
      setInputState: Q
    };
  }
  function M(D) {
    var R = t.useRef();
    return t.useEffect(function() {
      R.current = D;
    }), R.current;
  }
  var I = ["disabled", "onBlur", "onChange", "onFocus", "onMouseDown", "readOnly", "value"], G = {
    9: /[0-9]/,
    a: /[A-Za-z]/,
    "*": /[A-Za-z0-9]/
  };
  function Y(D) {
    process.env.NODE_ENV !== "production" && o(!D.maxLength || !D.mask, "react-input-mask: maxLength property shouldn't be passed to the masked input. It breaks masking and unnecessary because length is limited by the mask length.");
  }
  function L(D) {
    var R = D.mask, $ = D.maskPlaceholder;
    !R || !$ || $.length === 1 || $.length === R.length || (process.env.NODE_ENV !== "production" ? i(!1, `react-input-mask: maskPlaceholder should either be a single character or have the same length as the mask:
` + ("mask: " + R + `
`) + ("maskPlaceholder: " + $)) : i(!1));
  }
  function X(D, R) {
    var $ = I.filter(function(B) {
      return R.props[B] != null && R.props[B] !== D[B];
    });
    $.length && (process.env.NODE_ENV !== "production" ? i(!1, "react-input-mask: the following props should be passed to the InputMask component, not to children: " + $.join(",")) : i(!1));
  }
  function q(D) {
    var R = D.mask, $ = D.maskPlaceholder, B = [];
    if (!R)
      return {
        maskPlaceholder: null,
        mask: null,
        prefix: null,
        lastEditablePosition: null,
        permanents: []
      };
    if (typeof R == "string") {
      var H = !1, z = "";
      R.split("").forEach(function(F) {
        !H && F === "\\" ? H = !0 : ((H || !G[F]) && B.push(z.length), z += F, H = !1);
      }), R = z.split("").map(function(F, k) {
        return B.indexOf(k) === -1 ? G[F] : F;
      });
    } else
      R.forEach(function(F, k) {
        typeof F == "string" && B.push(k);
      });
    $ && ($.length === 1 ? $ = R.map(function(F, k) {
      return B.indexOf(k) !== -1 ? F : $;
    }) : $ = $.split(""), B.forEach(function(F) {
      $[F] = R[F];
    }), $ = $.join(""));
    for (var J = B.filter(function(F, k) {
      return F === k;
    }).map(function(F) {
      return R[F];
    }).join(""), U = R.length - 1; B.indexOf(U) !== -1; )
      U--;
    return {
      maskPlaceholder: $,
      prefix: J,
      mask: R,
      lastEditablePosition: U,
      permanents: B
    };
  }
  var re = function(R) {
    var $ = this;
    this.isCharacterAllowedAtPosition = function(B, H) {
      var z = $.maskOptions.maskPlaceholder;
      return $.isCharacterFillingPosition(B, H) ? !0 : z ? z[H] === B : !1;
    }, this.isCharacterFillingPosition = function(B, H) {
      var z = $.maskOptions.mask;
      if (!B || H >= z.length)
        return !1;
      if (!$.isPositionEditable(H))
        return z[H] === B;
      var J = z[H];
      return new RegExp(J).test(B);
    }, this.isPositionEditable = function(B) {
      var H = $.maskOptions, z = H.mask, J = H.permanents;
      return B < z.length && J.indexOf(B) === -1;
    }, this.isValueEmpty = function(B) {
      return B.split("").every(function(H, z) {
        return !$.isPositionEditable(z) || !$.isCharacterFillingPosition(H, z);
      });
    }, this.isValueFilled = function(B) {
      return $.getFilledLength(B) === $.maskOptions.lastEditablePosition + 1;
    }, this.getDefaultSelectionForValue = function(B) {
      var H = $.getFilledLength(B), z = $.getRightEditablePosition(H);
      return {
        start: z,
        end: z
      };
    }, this.getFilledLength = function(B) {
      var H = B.split(""), z = y(H, function(J, U) {
        return $.isPositionEditable(U) && $.isCharacterFillingPosition(J, U);
      });
      return z + 1;
    }, this.getStringFillingLengthAtPosition = function(B, H) {
      var z = B.split(""), J = z.reduce(function(U, F) {
        return $.insertCharacterAtPosition(U, F, U.length);
      }, m(" ", H));
      return J.length - H;
    }, this.getLeftEditablePosition = function(B) {
      for (var H = B; H >= 0; H--)
        if ($.isPositionEditable(H))
          return H;
      return null;
    }, this.getRightEditablePosition = function(B) {
      for (var H = $.maskOptions.mask, z = B; z < H.length; z++)
        if ($.isPositionEditable(z))
          return z;
      return null;
    }, this.formatValue = function(B) {
      var H = $.maskOptions, z = H.maskPlaceholder, J = H.mask;
      if (!z) {
        for (B = $.insertStringAtPosition("", B, 0); B.length < J.length && !$.isPositionEditable(B.length); )
          B += J[B.length];
        return B;
      }
      return $.insertStringAtPosition(z, B, 0);
    }, this.clearRange = function(B, H, z) {
      if (!z)
        return B;
      var J = H + z, U = $.maskOptions, F = U.maskPlaceholder, k = U.mask, E = B.split("").map(function(K, Z) {
        var Q = $.isPositionEditable(Z);
        return !F && Z >= J && !Q ? "" : Z < H || Z >= J ? K : Q ? F ? F[Z] : "" : k[Z];
      }).join("");
      return $.formatValue(E);
    }, this.insertCharacterAtPosition = function(B, H, z) {
      var J = $.maskOptions, U = J.mask, F = J.maskPlaceholder;
      if (z >= U.length)
        return B;
      var k = $.isCharacterAllowedAtPosition(H, z), E = $.isPositionEditable(z), K = $.getRightEditablePosition(z), Z = F && K ? H === F[K] : null, Q = B.slice(0, z);
      if (k || !E) {
        var ne = k ? H : U[z];
        B = Q + ne;
      }
      return !k && !E && !Z && (B = $.insertCharacterAtPosition(B, H, z + 1)), B;
    }, this.insertStringAtPosition = function(B, H, z) {
      var J = $.maskOptions, U = J.mask, F = J.maskPlaceholder;
      if (!H || z >= U.length)
        return B;
      var k = H.split(""), E = $.isValueFilled(B) || !!F, K = B.slice(z);
      if (B = k.reduce(function(Q, ne) {
        return $.insertCharacterAtPosition(Q, ne, Q.length);
      }, B.slice(0, z)), E)
        B += K.slice(B.length - z);
      else if ($.isValueFilled(B))
        B += U.slice(B.length).join("");
      else {
        var Z = K.split("").filter(function(Q, ne) {
          return $.isPositionEditable(z + ne);
        });
        B = Z.reduce(function(Q, ne) {
          var ue = $.getRightEditablePosition(Q.length);
          return ue === null ? Q : ($.isPositionEditable(Q.length) || (Q += U.slice(Q.length, ue).join("")), $.insertCharacterAtPosition(Q, ne, Q.length));
        }, B);
      }
      return B;
    }, this.processChange = function(B, H) {
      var z = $.maskOptions, J = z.mask, U = z.prefix, F = z.lastEditablePosition, k = B.value, E = B.selection, K = H.value, Z = H.selection, Q = k, ne = "", ue = 0, de = 0, le = Math.min(Z.start, E.start);
      if (E.end > Z.start ? (ne = Q.slice(Z.start, E.end), ue = $.getStringFillingLengthAtPosition(ne, le), ue ? de = Z.length : de = 0) : Q.length < K.length && (de = K.length - Q.length), Q = K, de) {
        if (de === 1 && !Z.length) {
          var pe = Z.start === E.start;
          le = pe ? $.getRightEditablePosition(E.start) : $.getLeftEditablePosition(E.start);
        }
        Q = $.clearRange(Q, le, de);
      }
      return Q = $.insertStringAtPosition(Q, ne, le), le += ue, le >= J.length ? le = J.length : le < U.length && !ue ? le = U.length : le >= U.length && le < F && ue && (le = $.getRightEditablePosition(le)), Q = $.formatValue(Q), {
        value: Q,
        enteredString: ne,
        selection: {
          start: le,
          end: le
        }
      };
    }, this.maskOptions = q(R);
  }, j = /* @__PURE__ */ function(D) {
    c(R, D);
    function R() {
      return D.apply(this, arguments) || this;
    }
    var $ = R.prototype;
    return $.render = function() {
      var H = this.props, z = H.children, J = l(H, ["children"]);
      return r.cloneElement(z, J);
    }, R;
  }(r.Component), W = t.forwardRef(function(R, $) {
    var B = R.alwaysShowMask, H = R.children, z = R.mask, J = R.maskPlaceholder, U = R.beforeMaskedStateChange, F = l(R, ["alwaysShowMask", "children", "mask", "maskPlaceholder", "beforeMaskedStateChange"]);
    Y(R), L(R);
    var k = new re({
      mask: z,
      maskPlaceholder: J
    }), E = !!z, K = !F.disabled && !F.readOnly, Z = R.value !== null && R.value !== void 0, Q = M(E), ne = C((Z ? R.value : R.defaultValue) || ""), ue = T(ne, E), de = ue.inputRef, le = ue.getInputState, pe = ue.setInputState, ie = ue.getLastInputState, Te = O(de);
    function Qe(St) {
      var ot = le(), yt = ie(), bt = k.processChange(ot, yt);
      U && (bt = U({
        currentState: ot,
        previousState: yt,
        nextState: bt
      })), pe(bt), R.onChange && R.onChange(St);
    }
    function Ot(St) {
      de.current = St.target;
      var ot = le().value;
      if (E && !k.isValueFilled(ot)) {
        var yt = k.formatValue(ot), bt = k.getDefaultSelectionForValue(yt), rt = {
          value: yt,
          selection: bt
        };
        U && (rt = U({
          currentState: le(),
          nextState: rt
        }), yt = rt.value, bt = rt.selection), pe(rt), yt !== ot && R.onChange && R.onChange(St), f(function() {
          pe(ie());
        });
      }
      R.onFocus && R.onFocus(St);
    }
    function Gt(St) {
      var ot = le().value, yt = ie().value;
      if (E && !B && k.isValueEmpty(yt)) {
        var bt = "", rt = {
          value: bt,
          selection: {
            start: null,
            end: null
          }
        };
        U && (rt = U({
          currentState: le(),
          nextState: rt
        }), bt = rt.value), pe(rt), bt !== ot && R.onChange && R.onChange(St);
      }
      R.onBlur && R.onBlur(St);
    }
    function qt(St) {
      var ot = Te(), yt = le(), bt = yt.value, rt = g(ot);
      if (!v(ot) && !k.isValueFilled(bt)) {
        var In = St.clientX, Pn = St.clientY, pr = (/* @__PURE__ */ new Date()).getTime(), Tn = function vi(gi) {
          if (rt.removeEventListener("mouseup", vi), !!v(ot)) {
            var Lc = Math.abs(gi.clientX - In), du = Math.abs(gi.clientY - Pn), pu = Math.max(Lc, du), mi = (/* @__PURE__ */ new Date()).getTime() - pr;
            if (pu <= 10 && mi <= 200 || pu <= 5 && mi <= 300) {
              var yi = ie(), Bc = k.getDefaultSelectionForValue(yi.value), Vc = s({}, yi, {
                selection: Bc
              });
              pe(Vc);
            }
          }
        };
        rt.addEventListener("mouseup", Tn);
      }
      R.onMouseDown && R.onMouseDown(St);
    }
    if (E && Z) {
      var dr = Te(), ra = dr && v(dr), na = ra || B || R.value ? k.formatValue(R.value) : R.value;
      U && (na = U({
        nextState: {
          value: na,
          selection: {
            start: null,
            end: null
          }
        }
      }).value), pe(s({}, ie(), {
        value: na
      }));
    }
    var pi = ie(), hi = pi.selection, kc = pi.value;
    t.useLayoutEffect(function() {
      if (E) {
        var St = Te(), ot = v(St), yt = hi, bt = le(), rt = s({}, bt);
        if (!Z) {
          var In = bt.value, Pn = k.formatValue(In), pr = k.isValueEmpty(Pn), Tn = !pr || ot || B;
          Tn ? rt.value = Pn : pr && !ot && (rt.value = "");
        }
        ot && !Q ? rt.selection = k.getDefaultSelectionForValue(rt.value) : Z && ot && yt && yt.start !== null && yt.end !== null && (rt.selection = yt), U && (rt = U({
          currentState: bt,
          nextState: rt
        })), pe(rt);
      }
    });
    var fu = s({}, F, {
      onFocus: Ot,
      onBlur: Gt,
      onChange: E && K ? Qe : R.onChange,
      onMouseDown: E && K ? qt : R.onMouseDown,
      ref: function(ot) {
        de.current = n.findDOMNode(ot), w($) ? $(ot) : $ !== null && typeof $ == "object" && ($.current = ot);
      },
      value: E && Z ? kc : R.value
    });
    return H ? (X(R, H), r.createElement(j, fu, H)) : r.createElement("input", fu);
  });
  return W.displayName = "InputMask", W.defaultProps = {
    alwaysShowMask: !1,
    maskPlaceholder: "_"
  }, W.propTypes = {
    alwaysShowMask: a.bool,
    beforeMaskedStateChange: a.func,
    children: a.element,
    mask: a.oneOfType([a.string, a.arrayOf(a.oneOfType([a.string, a.instanceOf(RegExp)]))]),
    maskPlaceholder: a.string,
    onFocus: a.func,
    onBlur: a.func,
    onChange: a.func,
    onMouseDown: a.func
  }, Al = W, Al;
}
process.env.NODE_ENV === "production" ? Nf.exports = jw() : Nf.exports = Rw();
var Nw = Nf.exports;
const $w = /* @__PURE__ */ Fe(Nw), qy = (e) => /* @__PURE__ */ _.jsx($w, { ...e }), Df = "9 9 - 9 9 9 9 - 9 9 9 9 9 9 9 - 9 9 9", kf = Df.replace(/ /g, "").length, Fw = 3, El = kf - Fw, Pre = ({
  className: e,
  onChange: t,
  onBlur: r,
  value: n,
  name: a = "bank-account-input",
  dark: i = !1,
  disabled: o = !1,
  ...u
}) => /* @__PURE__ */ _.jsx(
  lr,
  {
    className: He("bank-account-input", {
      "bank-account-input--dark": i,
      [`${e}`]: !!e
    }),
    htmlFor: a,
    ...u,
    children: /* @__PURE__ */ _.jsxs("div", { className: "bank-account-input__wrapper input-text__element", children: [
      /* @__PURE__ */ _.jsx(
        qy,
        {
          id: "bank-account-input",
          name: a,
          className: "bank-account-input__input",
          mask: Df,
          placeholder: Df.replaceAll("9", "0"),
          maskPlaceholder: null,
          value: n,
          disabled: o,
          onChange: (s) => t(s.currentTarget.value.replace(/ /g, "")),
          onBlur: (s) => {
            const c = s.currentTarget.value.replace(/ /g, ""), { length: l } = c;
            if (l < kf && l >= El) {
              const d = kf - l, p = c.slice(0, El) + "0".repeat(d) + c.slice(El);
              t(p);
            } else
              t(c);
            r && r(s);
          }
        }
      ),
      /* @__PURE__ */ _.jsxs("div", { className: "bank-account-input__sections", children: [
        /* @__PURE__ */ _.jsx("span", { children: "Bank" }),
        /* @__PURE__ */ _.jsx("span", { children: "Branch" }),
        /* @__PURE__ */ _.jsx("span", { children: "Account" }),
        /* @__PURE__ */ _.jsx("span", { children: "Suffix" })
      ] })
    ] })
  }
);
var Dw = Array.isArray, Wt = Dw, kw = typeof pa == "object" && pa && pa.Object === Object && pa, Jy = kw, Lw = Jy, Bw = typeof self == "object" && self && self.Object === Object && self, Vw = Lw || Bw || Function("return this")(), Fr = Vw, Ww = Fr, Gw = Ww.Symbol, Qo = Gw, v0 = Qo, Qy = Object.prototype, Hw = Qy.hasOwnProperty, Uw = Qy.toString, Oi = v0 ? v0.toStringTag : void 0;
function zw(e) {
  var t = Hw.call(e, Oi), r = e[Oi];
  try {
    e[Oi] = void 0;
    var n = !0;
  } catch {
  }
  var a = Uw.call(e);
  return n && (t ? e[Oi] = r : delete e[Oi]), a;
}
var Yw = zw, Xw = Object.prototype, Zw = Xw.toString;
function Kw(e) {
  return Zw.call(e);
}
var qw = Kw, g0 = Qo, Jw = Yw, Qw = qw, eO = "[object Null]", tO = "[object Undefined]", m0 = g0 ? g0.toStringTag : void 0;
function rO(e) {
  return e == null ? e === void 0 ? tO : eO : m0 && m0 in Object(e) ? Jw(e) : Qw(e);
}
var en = rO;
function nO(e) {
  return e != null && typeof e == "object";
}
var tn = nO, aO = en, iO = tn, oO = "[object Symbol]";
function uO(e) {
  return typeof e == "symbol" || iO(e) && aO(e) == oO;
}
var qa = uO, sO = Wt, cO = qa, lO = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, fO = /^\w*$/;
function dO(e, t) {
  if (sO(e))
    return !1;
  var r = typeof e;
  return r == "number" || r == "symbol" || r == "boolean" || e == null || cO(e) ? !0 : fO.test(e) || !lO.test(e) || t != null && e in Object(t);
}
var N1 = dO;
function pO(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var wn = pO;
const Ja = /* @__PURE__ */ Fe(wn);
var hO = en, vO = wn, gO = "[object AsyncFunction]", mO = "[object Function]", yO = "[object GeneratorFunction]", bO = "[object Proxy]";
function xO(e) {
  if (!vO(e))
    return !1;
  var t = hO(e);
  return t == mO || t == yO || t == gO || t == bO;
}
var $1 = xO;
const _e = /* @__PURE__ */ Fe($1);
var CO = Fr, wO = CO["__core-js_shared__"], OO = wO, _l = OO, y0 = function() {
  var e = /[^.]+$/.exec(_l && _l.keys && _l.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function SO(e) {
  return !!y0 && y0 in e;
}
var AO = SO, EO = Function.prototype, _O = EO.toString;
function IO(e) {
  if (e != null) {
    try {
      return _O.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var eb = IO, PO = $1, TO = AO, MO = wn, jO = eb, RO = /[\\^$.*+?()[\]{}|]/g, NO = /^\[object .+?Constructor\]$/, $O = Function.prototype, FO = Object.prototype, DO = $O.toString, kO = FO.hasOwnProperty, LO = RegExp(
  "^" + DO.call(kO).replace(RO, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function BO(e) {
  if (!MO(e) || TO(e))
    return !1;
  var t = PO(e) ? LO : NO;
  return t.test(jO(e));
}
var VO = BO;
function WO(e, t) {
  return e == null ? void 0 : e[t];
}
var GO = WO, HO = VO, UO = GO;
function zO(e, t) {
  var r = UO(e, t);
  return HO(r) ? r : void 0;
}
var Qn = zO, YO = Qn, XO = YO(Object, "create"), ec = XO, b0 = ec;
function ZO() {
  this.__data__ = b0 ? b0(null) : {}, this.size = 0;
}
var KO = ZO;
function qO(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var JO = qO, QO = ec, eS = "__lodash_hash_undefined__", tS = Object.prototype, rS = tS.hasOwnProperty;
function nS(e) {
  var t = this.__data__;
  if (QO) {
    var r = t[e];
    return r === eS ? void 0 : r;
  }
  return rS.call(t, e) ? t[e] : void 0;
}
var aS = nS, iS = ec, oS = Object.prototype, uS = oS.hasOwnProperty;
function sS(e) {
  var t = this.__data__;
  return iS ? t[e] !== void 0 : uS.call(t, e);
}
var cS = sS, lS = ec, fS = "__lodash_hash_undefined__";
function dS(e, t) {
  var r = this.__data__;
  return this.size += this.has(e) ? 0 : 1, r[e] = lS && t === void 0 ? fS : t, this;
}
var pS = dS, hS = KO, vS = JO, gS = aS, mS = cS, yS = pS;
function Qa(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
Qa.prototype.clear = hS;
Qa.prototype.delete = vS;
Qa.prototype.get = gS;
Qa.prototype.has = mS;
Qa.prototype.set = yS;
var bS = Qa;
function xS() {
  this.__data__ = [], this.size = 0;
}
var CS = xS;
function wS(e, t) {
  return e === t || e !== e && t !== t;
}
var F1 = wS, OS = F1;
function SS(e, t) {
  for (var r = e.length; r--; )
    if (OS(e[r][0], t))
      return r;
  return -1;
}
var tc = SS, AS = tc, ES = Array.prototype, _S = ES.splice;
function IS(e) {
  var t = this.__data__, r = AS(t, e);
  if (r < 0)
    return !1;
  var n = t.length - 1;
  return r == n ? t.pop() : _S.call(t, r, 1), --this.size, !0;
}
var PS = IS, TS = tc;
function MS(e) {
  var t = this.__data__, r = TS(t, e);
  return r < 0 ? void 0 : t[r][1];
}
var jS = MS, RS = tc;
function NS(e) {
  return RS(this.__data__, e) > -1;
}
var $S = NS, FS = tc;
function DS(e, t) {
  var r = this.__data__, n = FS(r, e);
  return n < 0 ? (++this.size, r.push([e, t])) : r[n][1] = t, this;
}
var kS = DS, LS = CS, BS = PS, VS = jS, WS = $S, GS = kS;
function ei(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
ei.prototype.clear = LS;
ei.prototype.delete = BS;
ei.prototype.get = VS;
ei.prototype.has = WS;
ei.prototype.set = GS;
var rc = ei, HS = Qn, US = Fr, zS = HS(US, "Map"), D1 = zS, x0 = bS, YS = rc, XS = D1;
function ZS() {
  this.size = 0, this.__data__ = {
    hash: new x0(),
    map: new (XS || YS)(),
    string: new x0()
  };
}
var KS = ZS;
function qS(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
var JS = qS, QS = JS;
function eA(e, t) {
  var r = e.__data__;
  return QS(t) ? r[typeof t == "string" ? "string" : "hash"] : r.map;
}
var nc = eA, tA = nc;
function rA(e) {
  var t = tA(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
var nA = rA, aA = nc;
function iA(e) {
  return aA(this, e).get(e);
}
var oA = iA, uA = nc;
function sA(e) {
  return uA(this, e).has(e);
}
var cA = sA, lA = nc;
function fA(e, t) {
  var r = lA(this, e), n = r.size;
  return r.set(e, t), this.size += r.size == n ? 0 : 1, this;
}
var dA = fA, pA = KS, hA = nA, vA = oA, gA = cA, mA = dA;
function ti(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
ti.prototype.clear = pA;
ti.prototype.delete = hA;
ti.prototype.get = vA;
ti.prototype.has = gA;
ti.prototype.set = mA;
var k1 = ti, tb = k1, yA = "Expected a function";
function L1(e, t) {
  if (typeof e != "function" || t != null && typeof t != "function")
    throw new TypeError(yA);
  var r = function() {
    var n = arguments, a = t ? t.apply(this, n) : n[0], i = r.cache;
    if (i.has(a))
      return i.get(a);
    var o = e.apply(this, n);
    return r.cache = i.set(a, o) || i, o;
  };
  return r.cache = new (L1.Cache || tb)(), r;
}
L1.Cache = tb;
var rb = L1;
const bA = /* @__PURE__ */ Fe(rb);
var xA = rb, CA = 500;
function wA(e) {
  var t = xA(e, function(n) {
    return r.size === CA && r.clear(), n;
  }), r = t.cache;
  return t;
}
var OA = wA, SA = OA, AA = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, EA = /\\(\\)?/g, _A = SA(function(e) {
  var t = [];
  return e.charCodeAt(0) === 46 && t.push(""), e.replace(AA, function(r, n, a, i) {
    t.push(a ? i.replace(EA, "$1") : n || r);
  }), t;
}), IA = _A;
function PA(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length, a = Array(n); ++r < n; )
    a[r] = t(e[r], r, e);
  return a;
}
var B1 = PA, C0 = Qo, TA = B1, MA = Wt, jA = qa, RA = 1 / 0, w0 = C0 ? C0.prototype : void 0, O0 = w0 ? w0.toString : void 0;
function nb(e) {
  if (typeof e == "string")
    return e;
  if (MA(e))
    return TA(e, nb) + "";
  if (jA(e))
    return O0 ? O0.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -RA ? "-0" : t;
}
var NA = nb, $A = NA;
function FA(e) {
  return e == null ? "" : $A(e);
}
var ac = FA, DA = Wt, kA = N1, LA = IA, BA = ac;
function VA(e, t) {
  return DA(e) ? e : kA(e, t) ? [e] : LA(BA(e));
}
var ab = VA, WA = qa, GA = 1 / 0;
function HA(e) {
  if (typeof e == "string" || WA(e))
    return e;
  var t = e + "";
  return t == "0" && 1 / e == -GA ? "-0" : t;
}
var ic = HA, UA = ab, zA = ic;
function YA(e, t) {
  t = UA(t, e);
  for (var r = 0, n = t.length; e != null && r < n; )
    e = e[zA(t[r++])];
  return r && r == n ? e : void 0;
}
var V1 = YA, XA = V1;
function ZA(e, t, r) {
  var n = e == null ? void 0 : XA(e, t);
  return n === void 0 ? r : n;
}
var ib = ZA;
const ve = /* @__PURE__ */ Fe(ib), ob = N.forwardRef(
  ({
    className: e = "",
    dark: t,
    error: r,
    disabled: n,
    autoComplete: a,
    ...i
  }, o) => /* @__PURE__ */ _.jsx(
    "input",
    {
      className: He(`input-number__element ${e}`, {
        "input-number__element--error": r,
        "input-number__element--disabled": n,
        "input-number__element--dark": t
      }),
      disabled: n,
      autoComplete: a,
      type: "number",
      ref: o,
      ...i
    }
  )
);
ob.displayName = "NumberInput";
const W1 = ({
  value: e,
  className: t,
  setSelected: r,
  options: n,
  dark: a
}) => /* @__PURE__ */ _.jsx(
  "div",
  {
    className: He("option-buttons", {
      "option-buttons--dark": a,
      [`${t}`]: !!t
    }),
    children: n.map((i) => /* @__PURE__ */ _.jsx(
      "button",
      {
        className: He("option-buttons__button", {
          "option-buttons__button--selected": e === i.value
        }),
        onClick: () => r && r(i.value),
        children: /* @__PURE__ */ _.jsx("span", { children: i.label })
      },
      i.label
    ))
  }
), Tre = ({
  form: e,
  name: t,
  label: r,
  action: n,
  className: a,
  inputClass: i,
  disabled: o,
  autoComplete: u,
  dark: s,
  labelSize: c,
  hidden: l,
  placeholder: f
}) => {
  const {
    values: d,
    errors: p,
    touched: h,
    handleChange: v,
    handleBlur: g,
    setFieldTouched: b
  } = e, x = ve(h, t) && ve(p, t) ? ve(p, t) : "";
  return /* @__PURE__ */ _.jsx(
    lr,
    {
      label: r || t,
      labelSize: c,
      action: n,
      className: a,
      error: x,
      hidden: l,
      children: /* @__PURE__ */ _.jsx(
        v3,
        {
          value: ve(d, t, ""),
          name: t,
          autoComplete: u,
          className: i,
          onChange: (w) => {
            b(t, !0, !0), v(w);
          },
          onBlur: g,
          error: !!(ve(h, t) && ve(p, t)),
          disabled: o,
          placeholder: f,
          dark: s
        }
      )
    }
  );
}, Mre = ({
  form: e,
  name: t,
  label: r,
  labelSize: n,
  action: a,
  className: i,
  inputClass: o,
  disabled: u,
  dark: s,
  min: c,
  max: l,
  hidden: f
}) => {
  const {
    values: d,
    errors: p,
    touched: h,
    setFieldTouched: v,
    handleBlur: g,
    handleChange: b
  } = e, x = ve(h, t) && ve(p, t) ? ve(p, t) : "";
  return /* @__PURE__ */ _.jsx(
    lr,
    {
      label: r || t,
      labelSize: n,
      action: a,
      className: i,
      error: x,
      hidden: f,
      children: /* @__PURE__ */ _.jsx(
        ob,
        {
          value: ve(d, t, ""),
          name: t,
          className: o,
          onChange: (w) => {
            v(t, !0, !0), b(w);
          },
          onBlur: g,
          error: !!(ve(h, t) && ve(p, t)),
          disabled: u,
          dark: s,
          min: c,
          max: l
        }
      )
    }
  );
}, jre = ({
  form: e,
  name: t,
  action: r,
  hidden: n,
  label: a,
  labelSize: i,
  showErrorLabel: o,
  className: u,
  inputClass: s,
  disabled: c,
  dark: l,
  id: f,
  onMax: d,
  ...p
}) => {
  const {
    values: h,
    errors: v,
    touched: g,
    handleBlur: b,
    handleChange: x,
    setFieldTouched: w
  } = e, y = ve(g, t) && ve(v, t) ? ve(v, t) : "";
  return /* @__PURE__ */ _.jsx(
    lr,
    {
      action: r,
      label: a,
      labelSize: i,
      className: u,
      error: y,
      hidden: n,
      showErrorLabel: o,
      htmlFor: f,
      children: /* @__PURE__ */ _.jsx(
        n8,
        {
          id: f,
          value: ve(h, t, ""),
          name: t,
          className: s,
          onChange: (m) => {
            w(t, !0, !0), x(m);
          },
          onBlur: b,
          error: !!(ve(g, t) && ve(v, t)),
          disabled: c,
          dark: l,
          onMax: d,
          ...p
        }
      )
    }
  );
}, Rre = ({
  form: e,
  name: t,
  label: r,
  options: n,
  onSelect: a,
  className: i,
  selectClass: o,
  dark: u,
  menuPlacement: s,
  labelSize: c,
  hidden: l
}) => {
  const {
    values: f,
    errors: d,
    touched: p,
    setFieldValue: h,
    setFieldTouched: v
  } = e, g = ve(p, t) && ve(d, t) ? ve(d, t) : "", b = ve(f, t, "");
  return /* @__PURE__ */ _.jsx(
    lr,
    {
      label: r,
      className: i,
      error: g,
      labelSize: c,
      hidden: l,
      children: /* @__PURE__ */ _.jsx(
        yT,
        {
          onChange: (x) => {
            a ? a(x) : h(t, x);
          },
          onBlur: () => v(t, !0, !0),
          value: b,
          options: n,
          name: t,
          className: o,
          dark: u,
          error: !!(ve(p, t) && ve(d, t)),
          menuPlacement: s
        }
      )
    }
  );
}, KA = ({
  form: e,
  amountName: t,
  selectName: r,
  label: n,
  options: a,
  className: i,
  dark: o,
  labelSize: u,
  hidden: s
}) => {
  const {
    values: c,
    errors: l,
    touched: f,
    setFieldValue: d,
    setFieldTouched: p
  } = e, h = ve(f, t) && ve(l, t) ? ve(l, t) : "", v = ve(c, t, ""), g = ve(c, r, "");
  return /* @__PURE__ */ _.jsx(
    lr,
    {
      label: n,
      className: i,
      error: h,
      labelSize: u,
      hidden: s,
      children: /* @__PURE__ */ _.jsx(
        sy,
        {
          amountValue: v,
          amountName: t,
          onAmountChange: (b) => {
            p(t, !0, !0), d(t, parseFloat(b.target.value));
          },
          selectValue: g,
          selectName: r,
          options: a,
          onSelectChange: (b) => d(r, b),
          onBlur: () => p(t, !0, !0),
          dark: o,
          error: !!(ve(f, t) && ve(l, t))
        }
      )
    }
  );
}, qA = ({
  form: e,
  name: t,
  label: r,
  labelSize: n,
  showErrorLabel: a,
  options: i,
  className: o,
  direction: u = "vertical",
  onChange: s,
  size: c = "medium",
  hidden: l,
  disabled: f
}) => {
  const {
    values: d,
    errors: p,
    touched: h,
    setFieldValue: v,
    setFieldTouched: g
  } = e, b = ve(h, t) && ve(p, t) ? ve(p, t) : "", x = i == null ? void 0 : i.find(
    (w) => w.value === ve(d, t, "")
  );
  return /* @__PURE__ */ _.jsx(
    lr,
    {
      label: r,
      className: o,
      error: b,
      labelSize: n,
      hidden: l,
      showErrorLabel: a,
      children: /* @__PURE__ */ _.jsx(
        f_,
        {
          onChange: (w) => {
            g(t, !0, !0), v(t, w == null ? void 0 : w.value), s && s(w);
          },
          value: x,
          options: i,
          name: t,
          direction: u,
          size: c,
          disabled: f
        }
      )
    }
  );
}, Nre = ({
  form: e,
  name: t,
  label: r,
  options: n,
  className: a,
  dark: i,
  labelSize: o,
  hidden: u
}) => {
  const { values: s, errors: c, touched: l, setFieldValue: f } = e, d = ve(l, t) && ve(c, t) ? ve(c, t) : "", p = n == null ? void 0 : n.find(
    (h) => h.value === ve(s, t, "")
  );
  return /* @__PURE__ */ _.jsx(
    lr,
    {
      label: r,
      className: a,
      error: d,
      labelSize: o,
      hidden: u,
      children: /* @__PURE__ */ _.jsx(
        W1,
        {
          setSelected: (h) => f(t, h),
          value: p == null ? void 0 : p.value,
          options: n,
          dark: i
        }
      )
    }
  );
}, Lf = "9 9 9 - 9 9 9 - 9 9 9", ub = Lf.replace(/[^\d]/g, "").length, JA = 1, QA = ub - JA, $re = ({
  className: e,
  onChange: t,
  onBlur: r,
  value: n,
  name: a = "ird-number-input",
  ...i
}) => /* @__PURE__ */ _.jsx(
  lr,
  {
    className: He("ird-number-input", {
      [`${e}`]: !!e
    }),
    htmlFor: a,
    ...i,
    children: /* @__PURE__ */ _.jsx(
      qy,
      {
        id: "ird-number-input",
        name: a,
        value: n,
        className: "ird-number-input__wrapper input-text__element",
        mask: Lf,
        placeholder: Lf.replaceAll("9", "0"),
        maskPlaceholder: null,
        onChange: (o) => t(o.currentTarget.value.replace(/[^\d]/g, "")),
        onBlur: (o) => {
          const u = o.currentTarget.value.replace(/[^\d]/g, "");
          t(u.length >= QA ? `${u.padStart(ub, "0")}` : u), r && r(o);
        }
      }
    )
  }
);
function eE(e, t, r, n) {
  var a = -1, i = e == null ? 0 : e.length;
  for (n && i && (r = e[++a]); ++a < i; )
    r = t(r, e[a], a, e);
  return r;
}
var tE = eE;
function rE(e) {
  return function(t) {
    return e == null ? void 0 : e[t];
  };
}
var nE = rE, aE = nE, iE = {
  // Latin-1 Supplement block.
  À: "A",
  Á: "A",
  Â: "A",
  Ã: "A",
  Ä: "A",
  Å: "A",
  à: "a",
  á: "a",
  â: "a",
  ã: "a",
  ä: "a",
  å: "a",
  Ç: "C",
  ç: "c",
  Ð: "D",
  ð: "d",
  È: "E",
  É: "E",
  Ê: "E",
  Ë: "E",
  è: "e",
  é: "e",
  ê: "e",
  ë: "e",
  Ì: "I",
  Í: "I",
  Î: "I",
  Ï: "I",
  ì: "i",
  í: "i",
  î: "i",
  ï: "i",
  Ñ: "N",
  ñ: "n",
  Ò: "O",
  Ó: "O",
  Ô: "O",
  Õ: "O",
  Ö: "O",
  Ø: "O",
  ò: "o",
  ó: "o",
  ô: "o",
  õ: "o",
  ö: "o",
  ø: "o",
  Ù: "U",
  Ú: "U",
  Û: "U",
  Ü: "U",
  ù: "u",
  ú: "u",
  û: "u",
  ü: "u",
  Ý: "Y",
  ý: "y",
  ÿ: "y",
  Æ: "Ae",
  æ: "ae",
  Þ: "Th",
  þ: "th",
  ß: "ss",
  // Latin Extended-A block.
  Ā: "A",
  Ă: "A",
  Ą: "A",
  ā: "a",
  ă: "a",
  ą: "a",
  Ć: "C",
  Ĉ: "C",
  Ċ: "C",
  Č: "C",
  ć: "c",
  ĉ: "c",
  ċ: "c",
  č: "c",
  Ď: "D",
  Đ: "D",
  ď: "d",
  đ: "d",
  Ē: "E",
  Ĕ: "E",
  Ė: "E",
  Ę: "E",
  Ě: "E",
  ē: "e",
  ĕ: "e",
  ė: "e",
  ę: "e",
  ě: "e",
  Ĝ: "G",
  Ğ: "G",
  Ġ: "G",
  Ģ: "G",
  ĝ: "g",
  ğ: "g",
  ġ: "g",
  ģ: "g",
  Ĥ: "H",
  Ħ: "H",
  ĥ: "h",
  ħ: "h",
  Ĩ: "I",
  Ī: "I",
  Ĭ: "I",
  Į: "I",
  İ: "I",
  ĩ: "i",
  ī: "i",
  ĭ: "i",
  į: "i",
  ı: "i",
  Ĵ: "J",
  ĵ: "j",
  Ķ: "K",
  ķ: "k",
  ĸ: "k",
  Ĺ: "L",
  Ļ: "L",
  Ľ: "L",
  Ŀ: "L",
  Ł: "L",
  ĺ: "l",
  ļ: "l",
  ľ: "l",
  ŀ: "l",
  ł: "l",
  Ń: "N",
  Ņ: "N",
  Ň: "N",
  Ŋ: "N",
  ń: "n",
  ņ: "n",
  ň: "n",
  ŋ: "n",
  Ō: "O",
  Ŏ: "O",
  Ő: "O",
  ō: "o",
  ŏ: "o",
  ő: "o",
  Ŕ: "R",
  Ŗ: "R",
  Ř: "R",
  ŕ: "r",
  ŗ: "r",
  ř: "r",
  Ś: "S",
  Ŝ: "S",
  Ş: "S",
  Š: "S",
  ś: "s",
  ŝ: "s",
  ş: "s",
  š: "s",
  Ţ: "T",
  Ť: "T",
  Ŧ: "T",
  ţ: "t",
  ť: "t",
  ŧ: "t",
  Ũ: "U",
  Ū: "U",
  Ŭ: "U",
  Ů: "U",
  Ű: "U",
  Ų: "U",
  ũ: "u",
  ū: "u",
  ŭ: "u",
  ů: "u",
  ű: "u",
  ų: "u",
  Ŵ: "W",
  ŵ: "w",
  Ŷ: "Y",
  ŷ: "y",
  Ÿ: "Y",
  Ź: "Z",
  Ż: "Z",
  Ž: "Z",
  ź: "z",
  ż: "z",
  ž: "z",
  Ĳ: "IJ",
  ĳ: "ij",
  Œ: "Oe",
  œ: "oe",
  ŉ: "'n",
  ſ: "s"
}, oE = aE(iE), uE = oE, sE = uE, cE = ac, lE = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, fE = "\\u0300-\\u036f", dE = "\\ufe20-\\ufe2f", pE = "\\u20d0-\\u20ff", hE = fE + dE + pE, vE = "[" + hE + "]", gE = RegExp(vE, "g");
function mE(e) {
  return e = cE(e), e && e.replace(lE, sE).replace(gE, "");
}
var yE = mE, bE = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
function xE(e) {
  return e.match(bE) || [];
}
var CE = xE, wE = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
function OE(e) {
  return wE.test(e);
}
var SE = OE, sb = "\\ud800-\\udfff", AE = "\\u0300-\\u036f", EE = "\\ufe20-\\ufe2f", _E = "\\u20d0-\\u20ff", IE = AE + EE + _E, cb = "\\u2700-\\u27bf", lb = "a-z\\xdf-\\xf6\\xf8-\\xff", PE = "\\xac\\xb1\\xd7\\xf7", TE = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", ME = "\\u2000-\\u206f", jE = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", fb = "A-Z\\xc0-\\xd6\\xd8-\\xde", RE = "\\ufe0e\\ufe0f", db = PE + TE + ME + jE, pb = "['’]", S0 = "[" + db + "]", NE = "[" + IE + "]", hb = "\\d+", $E = "[" + cb + "]", vb = "[" + lb + "]", gb = "[^" + sb + db + hb + cb + lb + fb + "]", FE = "\\ud83c[\\udffb-\\udfff]", DE = "(?:" + NE + "|" + FE + ")", kE = "[^" + sb + "]", mb = "(?:\\ud83c[\\udde6-\\uddff]){2}", yb = "[\\ud800-\\udbff][\\udc00-\\udfff]", da = "[" + fb + "]", LE = "\\u200d", A0 = "(?:" + vb + "|" + gb + ")", BE = "(?:" + da + "|" + gb + ")", E0 = "(?:" + pb + "(?:d|ll|m|re|s|t|ve))?", _0 = "(?:" + pb + "(?:D|LL|M|RE|S|T|VE))?", bb = DE + "?", xb = "[" + RE + "]?", VE = "(?:" + LE + "(?:" + [kE, mb, yb].join("|") + ")" + xb + bb + ")*", WE = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", GE = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", HE = xb + bb + VE, UE = "(?:" + [$E, mb, yb].join("|") + ")" + HE, zE = RegExp([
  da + "?" + vb + "+" + E0 + "(?=" + [S0, da, "$"].join("|") + ")",
  BE + "+" + _0 + "(?=" + [S0, da + A0, "$"].join("|") + ")",
  da + "?" + A0 + "+" + E0,
  da + "+" + _0,
  GE,
  WE,
  hb,
  UE
].join("|"), "g");
function YE(e) {
  return e.match(zE) || [];
}
var XE = YE, ZE = CE, KE = SE, qE = ac, JE = XE;
function QE(e, t, r) {
  return e = qE(e), t = r ? void 0 : t, t === void 0 ? KE(e) ? JE(e) : ZE(e) : e.match(t) || [];
}
var e_ = QE, t_ = tE, r_ = yE, n_ = e_, a_ = "['’]", i_ = RegExp(a_, "g");
function o_(e) {
  return function(t) {
    return t_(n_(r_(t).replace(i_, "")), e, "");
  };
}
var u_ = o_, s_ = u_, c_ = s_(function(e, t, r) {
  return e + (r ? "-" : "") + t.toLowerCase();
}), l_ = c_;
const Yu = /* @__PURE__ */ Fe(l_), Cb = Xo(
  (e, t) => {
    const r = Lr(() => Math.floor(Math.random() * 1e4), []), {
      className: n,
      size: a = "medium",
      theme: i = "gray",
      border: o = "default",
      id: u,
      ...s
    } = e, c = u || `radio-${r}`;
    return /* @__PURE__ */ _.jsx(
      "label",
      {
        htmlFor: c,
        className: He(`form-radio form-radio--${a} form-radio--${i}`, {
          [`${n}`]: !!n,
          "form-radio--disabled": s.disabled,
          "form-radio--checked": s.checked
        }),
        children: /* @__PURE__ */ _.jsxs("div", { className: He(`form-radio__wrapper border--${o}`), children: [
          /* @__PURE__ */ _.jsx(
            "input",
            {
              type: "radio",
              className: "form-radio__input",
              id: c,
              ref: t,
              ...s
            }
          ),
          /* @__PURE__ */ _.jsx("span", { className: "form-radio__icon" })
        ] })
      }
    );
  }
), f_ = ({
  options: e,
  value: t,
  direction: r,
  onChange: n,
  size: a = "medium",
  disabled: i,
  name: o
}) => /* @__PURE__ */ _.jsx("div", { className: `input-radio-menu__container--${r}`, children: e.map((u) => /* @__PURE__ */ _.jsxs(N6, { children: [
  /* @__PURE__ */ _.jsxs(
    "span",
    {
      className: `input-radio-menu__item input-radio-menu__item-${a}`,
      children: [
        /* @__PURE__ */ _.jsx(
          Cb,
          {
            id: `${Yu(u.label)}-${o}`,
            border: "gray",
            theme: "white",
            name: o,
            size: a,
            label: u.label,
            onChange: () => {
              n && n(u);
            },
            checked: (t == null ? void 0 : t.label) === u.label,
            disabled: i,
            "data-cy": u.label
          }
        ),
        " ",
        /* @__PURE__ */ _.jsx("label", { className: "ml-2xs", htmlFor: `${Yu(u.label)}-${o}`, children: u.label })
      ]
    }
  ),
  !!(u != null && u.subLabel) && u.subLabel
] }, u.label)) });
function ye() {
  return ye = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) ({}).hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, ye.apply(null, arguments);
}
var d_ = !1;
function p_(e) {
  if (e.sheet)
    return e.sheet;
  for (var t = 0; t < document.styleSheets.length; t++)
    if (document.styleSheets[t].ownerNode === e)
      return document.styleSheets[t];
}
function h_(e) {
  var t = document.createElement("style");
  return t.setAttribute("data-emotion", e.key), e.nonce !== void 0 && t.setAttribute("nonce", e.nonce), t.appendChild(document.createTextNode("")), t.setAttribute("data-s", ""), t;
}
var v_ = /* @__PURE__ */ function() {
  function e(r) {
    var n = this;
    this._insertTag = function(a) {
      var i;
      n.tags.length === 0 ? n.insertionPoint ? i = n.insertionPoint.nextSibling : n.prepend ? i = n.container.firstChild : i = n.before : i = n.tags[n.tags.length - 1].nextSibling, n.container.insertBefore(a, i), n.tags.push(a);
    }, this.isSpeedy = r.speedy === void 0 ? !d_ : r.speedy, this.tags = [], this.ctr = 0, this.nonce = r.nonce, this.key = r.key, this.container = r.container, this.prepend = r.prepend, this.insertionPoint = r.insertionPoint, this.before = null;
  }
  var t = e.prototype;
  return t.hydrate = function(n) {
    n.forEach(this._insertTag);
  }, t.insert = function(n) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(h_(this));
    var a = this.tags[this.tags.length - 1];
    if (this.isSpeedy) {
      var i = p_(a);
      try {
        i.insertRule(n, i.cssRules.length);
      } catch {
      }
    } else
      a.appendChild(document.createTextNode(n));
    this.ctr++;
  }, t.flush = function() {
    this.tags.forEach(function(n) {
      var a;
      return (a = n.parentNode) == null ? void 0 : a.removeChild(n);
    }), this.tags = [], this.ctr = 0;
  }, e;
}(), Pt = "-ms-", Xu = "-moz-", De = "-webkit-", wb = "comm", G1 = "rule", H1 = "decl", g_ = "@import", Ob = "@keyframes", m_ = "@layer", y_ = Math.abs, oc = String.fromCharCode, b_ = Object.assign;
function x_(e, t) {
  return Et(e, 0) ^ 45 ? (((t << 2 ^ Et(e, 0)) << 2 ^ Et(e, 1)) << 2 ^ Et(e, 2)) << 2 ^ Et(e, 3) : 0;
}
function Sb(e) {
  return e.trim();
}
function C_(e, t) {
  return (e = t.exec(e)) ? e[0] : e;
}
function ke(e, t, r) {
  return e.replace(t, r);
}
function Bf(e, t) {
  return e.indexOf(t);
}
function Et(e, t) {
  return e.charCodeAt(t) | 0;
}
function oo(e, t, r) {
  return e.slice(t, r);
}
function Or(e) {
  return e.length;
}
function U1(e) {
  return e.length;
}
function mu(e, t) {
  return t.push(e), e;
}
function w_(e, t) {
  return e.map(t).join("");
}
var uc = 1, Ia = 1, Ab = 0, Vt = 0, ft = 0, ri = "";
function sc(e, t, r, n, a, i, o) {
  return { value: e, root: t, parent: r, type: n, props: a, children: i, line: uc, column: Ia, length: o, return: "" };
}
function Si(e, t) {
  return b_(sc("", null, null, "", null, null, 0), e, { length: -e.length }, t);
}
function O_() {
  return ft;
}
function S_() {
  return ft = Vt > 0 ? Et(ri, --Vt) : 0, Ia--, ft === 10 && (Ia = 1, uc--), ft;
}
function Xt() {
  return ft = Vt < Ab ? Et(ri, Vt++) : 0, Ia++, ft === 10 && (Ia = 1, uc++), ft;
}
function Pr() {
  return Et(ri, Vt);
}
function ku() {
  return Vt;
}
function eu(e, t) {
  return oo(ri, e, t);
}
function uo(e) {
  switch (e) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function Eb(e) {
  return uc = Ia = 1, Ab = Or(ri = e), Vt = 0, [];
}
function _b(e) {
  return ri = "", e;
}
function Lu(e) {
  return Sb(eu(Vt - 1, Vf(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function A_(e) {
  for (; (ft = Pr()) && ft < 33; )
    Xt();
  return uo(e) > 2 || uo(ft) > 3 ? "" : " ";
}
function E_(e, t) {
  for (; --t && Xt() && !(ft < 48 || ft > 102 || ft > 57 && ft < 65 || ft > 70 && ft < 97); )
    ;
  return eu(e, ku() + (t < 6 && Pr() == 32 && Xt() == 32));
}
function Vf(e) {
  for (; Xt(); )
    switch (ft) {
      case e:
        return Vt;
      case 34:
      case 39:
        e !== 34 && e !== 39 && Vf(ft);
        break;
      case 40:
        e === 41 && Vf(e);
        break;
      case 92:
        Xt();
        break;
    }
  return Vt;
}
function __(e, t) {
  for (; Xt() && e + ft !== 57; )
    if (e + ft === 84 && Pr() === 47)
      break;
  return "/*" + eu(t, Vt - 1) + "*" + oc(e === 47 ? e : Xt());
}
function I_(e) {
  for (; !uo(Pr()); )
    Xt();
  return eu(e, Vt);
}
function P_(e) {
  return _b(Bu("", null, null, null, [""], e = Eb(e), 0, [0], e));
}
function Bu(e, t, r, n, a, i, o, u, s) {
  for (var c = 0, l = 0, f = o, d = 0, p = 0, h = 0, v = 1, g = 1, b = 1, x = 0, w = "", y = a, m = i, C = n, O = w; g; )
    switch (h = x, x = Xt()) {
      case 40:
        if (h != 108 && Et(O, f - 1) == 58) {
          Bf(O += ke(Lu(x), "&", "&\f"), "&\f") != -1 && (b = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        O += Lu(x);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        O += A_(h);
        break;
      case 92:
        O += E_(ku() - 1, 7);
        continue;
      case 47:
        switch (Pr()) {
          case 42:
          case 47:
            mu(T_(__(Xt(), ku()), t, r), s);
            break;
          default:
            O += "/";
        }
        break;
      case 123 * v:
        u[c++] = Or(O) * b;
      case 125 * v:
      case 59:
      case 0:
        switch (x) {
          case 0:
          case 125:
            g = 0;
          case 59 + l:
            b == -1 && (O = ke(O, /\f/g, "")), p > 0 && Or(O) - f && mu(p > 32 ? P0(O + ";", n, r, f - 1) : P0(ke(O, " ", "") + ";", n, r, f - 2), s);
            break;
          case 59:
            O += ";";
          default:
            if (mu(C = I0(O, t, r, c, l, a, u, w, y = [], m = [], f), i), x === 123)
              if (l === 0)
                Bu(O, t, C, C, y, i, f, u, m);
              else
                switch (d === 99 && Et(O, 3) === 110 ? 100 : d) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    Bu(e, C, C, n && mu(I0(e, C, C, 0, 0, a, u, w, a, y = [], f), m), a, m, f, u, n ? y : m);
                    break;
                  default:
                    Bu(O, C, C, C, [""], m, 0, u, m);
                }
        }
        c = l = p = 0, v = b = 1, w = O = "", f = o;
        break;
      case 58:
        f = 1 + Or(O), p = h;
      default:
        if (v < 1) {
          if (x == 123)
            --v;
          else if (x == 125 && v++ == 0 && S_() == 125)
            continue;
        }
        switch (O += oc(x), x * v) {
          case 38:
            b = l > 0 ? 1 : (O += "\f", -1);
            break;
          case 44:
            u[c++] = (Or(O) - 1) * b, b = 1;
            break;
          case 64:
            Pr() === 45 && (O += Lu(Xt())), d = Pr(), l = f = Or(w = O += I_(ku())), x++;
            break;
          case 45:
            h === 45 && Or(O) == 2 && (v = 0);
        }
    }
  return i;
}
function I0(e, t, r, n, a, i, o, u, s, c, l) {
  for (var f = a - 1, d = a === 0 ? i : [""], p = U1(d), h = 0, v = 0, g = 0; h < n; ++h)
    for (var b = 0, x = oo(e, f + 1, f = y_(v = o[h])), w = e; b < p; ++b)
      (w = Sb(v > 0 ? d[b] + " " + x : ke(x, /&\f/g, d[b]))) && (s[g++] = w);
  return sc(e, t, r, a === 0 ? G1 : u, s, c, l);
}
function T_(e, t, r) {
  return sc(e, t, r, wb, oc(O_()), oo(e, 2, -2), 0);
}
function P0(e, t, r, n) {
  return sc(e, t, r, H1, oo(e, 0, n), oo(e, n + 1, -1), n);
}
function ma(e, t) {
  for (var r = "", n = U1(e), a = 0; a < n; a++)
    r += t(e[a], a, e, t) || "";
  return r;
}
function M_(e, t, r, n) {
  switch (e.type) {
    case m_:
      if (e.children.length) break;
    case g_:
    case H1:
      return e.return = e.return || e.value;
    case wb:
      return "";
    case Ob:
      return e.return = e.value + "{" + ma(e.children, n) + "}";
    case G1:
      e.value = e.props.join(",");
  }
  return Or(r = ma(e.children, n)) ? e.return = e.value + "{" + r + "}" : "";
}
function j_(e) {
  var t = U1(e);
  return function(r, n, a, i) {
    for (var o = "", u = 0; u < t; u++)
      o += e[u](r, n, a, i) || "";
    return o;
  };
}
function R_(e) {
  return function(t) {
    t.root || (t = t.return) && e(t);
  };
}
function N_(e) {
  var t = /* @__PURE__ */ Object.create(null);
  return function(r) {
    return t[r] === void 0 && (t[r] = e(r)), t[r];
  };
}
var $_ = function(t, r, n) {
  for (var a = 0, i = 0; a = i, i = Pr(), a === 38 && i === 12 && (r[n] = 1), !uo(i); )
    Xt();
  return eu(t, Vt);
}, F_ = function(t, r) {
  var n = -1, a = 44;
  do
    switch (uo(a)) {
      case 0:
        a === 38 && Pr() === 12 && (r[n] = 1), t[n] += $_(Vt - 1, r, n);
        break;
      case 2:
        t[n] += Lu(a);
        break;
      case 4:
        if (a === 44) {
          t[++n] = Pr() === 58 ? "&\f" : "", r[n] = t[n].length;
          break;
        }
      default:
        t[n] += oc(a);
    }
  while (a = Xt());
  return t;
}, D_ = function(t, r) {
  return _b(F_(Eb(t), r));
}, T0 = /* @__PURE__ */ new WeakMap(), k_ = function(t) {
  if (!(t.type !== "rule" || !t.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  t.length < 1)) {
    for (var r = t.value, n = t.parent, a = t.column === n.column && t.line === n.line; n.type !== "rule"; )
      if (n = n.parent, !n) return;
    if (!(t.props.length === 1 && r.charCodeAt(0) !== 58 && !T0.get(n)) && !a) {
      T0.set(t, !0);
      for (var i = [], o = D_(r, i), u = n.props, s = 0, c = 0; s < o.length; s++)
        for (var l = 0; l < u.length; l++, c++)
          t.props[c] = i[s] ? o[s].replace(/&\f/g, u[l]) : u[l] + " " + o[s];
    }
  }
}, L_ = function(t) {
  if (t.type === "decl") {
    var r = t.value;
    // charcode for l
    r.charCodeAt(0) === 108 && // charcode for b
    r.charCodeAt(2) === 98 && (t.return = "", t.value = "");
  }
};
function Ib(e, t) {
  switch (x_(e, t)) {
    case 5103:
      return De + "print-" + e + e;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return De + e + e;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return De + e + Xu + e + Pt + e + e;
    case 6828:
    case 4268:
      return De + e + Pt + e + e;
    case 6165:
      return De + e + Pt + "flex-" + e + e;
    case 5187:
      return De + e + ke(e, /(\w+).+(:[^]+)/, De + "box-$1$2" + Pt + "flex-$1$2") + e;
    case 5443:
      return De + e + Pt + "flex-item-" + ke(e, /flex-|-self/, "") + e;
    case 4675:
      return De + e + Pt + "flex-line-pack" + ke(e, /align-content|flex-|-self/, "") + e;
    case 5548:
      return De + e + Pt + ke(e, "shrink", "negative") + e;
    case 5292:
      return De + e + Pt + ke(e, "basis", "preferred-size") + e;
    case 6060:
      return De + "box-" + ke(e, "-grow", "") + De + e + Pt + ke(e, "grow", "positive") + e;
    case 4554:
      return De + ke(e, /([^-])(transform)/g, "$1" + De + "$2") + e;
    case 6187:
      return ke(ke(ke(e, /(zoom-|grab)/, De + "$1"), /(image-set)/, De + "$1"), e, "") + e;
    case 5495:
    case 3959:
      return ke(e, /(image-set\([^]*)/, De + "$1$`$1");
    case 4968:
      return ke(ke(e, /(.+:)(flex-)?(.*)/, De + "box-pack:$3" + Pt + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + De + e + e;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return ke(e, /(.+)-inline(.+)/, De + "$1$2") + e;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (Or(e) - 1 - t > 6) switch (Et(e, t + 1)) {
        case 109:
          if (Et(e, t + 4) !== 45) break;
        case 102:
          return ke(e, /(.+:)(.+)-([^]+)/, "$1" + De + "$2-$3$1" + Xu + (Et(e, t + 3) == 108 ? "$3" : "$2-$3")) + e;
        case 115:
          return ~Bf(e, "stretch") ? Ib(ke(e, "stretch", "fill-available"), t) + e : e;
      }
      break;
    case 4949:
      if (Et(e, t + 1) !== 115) break;
    case 6444:
      switch (Et(e, Or(e) - 3 - (~Bf(e, "!important") && 10))) {
        case 107:
          return ke(e, ":", ":" + De) + e;
        case 101:
          return ke(e, /(.+:)([^;!]+)(;|!.+)?/, "$1" + De + (Et(e, 14) === 45 ? "inline-" : "") + "box$3$1" + De + "$2$3$1" + Pt + "$2box$3") + e;
      }
      break;
    case 5936:
      switch (Et(e, t + 11)) {
        case 114:
          return De + e + Pt + ke(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
        case 108:
          return De + e + Pt + ke(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
        case 45:
          return De + e + Pt + ke(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
      }
      return De + e + Pt + e + e;
  }
  return e;
}
var B_ = function(t, r, n, a) {
  if (t.length > -1 && !t.return) switch (t.type) {
    case H1:
      t.return = Ib(t.value, t.length);
      break;
    case Ob:
      return ma([Si(t, {
        value: ke(t.value, "@", "@" + De)
      })], a);
    case G1:
      if (t.length) return w_(t.props, function(i) {
        switch (C_(i, /(::plac\w+|:read-\w+)/)) {
          case ":read-only":
          case ":read-write":
            return ma([Si(t, {
              props: [ke(i, /:(read-\w+)/, ":" + Xu + "$1")]
            })], a);
          case "::placeholder":
            return ma([Si(t, {
              props: [ke(i, /:(plac\w+)/, ":" + De + "input-$1")]
            }), Si(t, {
              props: [ke(i, /:(plac\w+)/, ":" + Xu + "$1")]
            }), Si(t, {
              props: [ke(i, /:(plac\w+)/, Pt + "input-$1")]
            })], a);
        }
        return "";
      });
  }
}, V_ = [B_], W_ = function(t) {
  var r = t.key;
  if (r === "css") {
    var n = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(n, function(v) {
      var g = v.getAttribute("data-emotion");
      g.indexOf(" ") !== -1 && (document.head.appendChild(v), v.setAttribute("data-s", ""));
    });
  }
  var a = t.stylisPlugins || V_, i = {}, o, u = [];
  o = t.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + r + ' "]'),
    function(v) {
      for (var g = v.getAttribute("data-emotion").split(" "), b = 1; b < g.length; b++)
        i[g[b]] = !0;
      u.push(v);
    }
  );
  var s, c = [k_, L_];
  {
    var l, f = [M_, R_(function(v) {
      l.insert(v);
    })], d = j_(c.concat(a, f)), p = function(g) {
      return ma(P_(g), d);
    };
    s = function(g, b, x, w) {
      l = x, p(g ? g + "{" + b.styles + "}" : b.styles), w && (h.inserted[b.name] = !0);
    };
  }
  var h = {
    key: r,
    sheet: new v_({
      key: r,
      container: o,
      nonce: t.nonce,
      speedy: t.speedy,
      prepend: t.prepend,
      insertionPoint: t.insertionPoint
    }),
    nonce: t.nonce,
    inserted: i,
    registered: {},
    insert: s
  };
  return h.sheet.hydrate(u), h;
}, Pb = j1, G_ = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, H_ = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, Tb = {};
Tb[Pb.ForwardRef] = G_;
Tb[Pb.Memo] = H_;
var U_ = !0;
function Mb(e, t, r) {
  var n = "";
  return r.split(" ").forEach(function(a) {
    e[a] !== void 0 ? t.push(e[a] + ";") : a && (n += a + " ");
  }), n;
}
var z1 = function(t, r, n) {
  var a = t.key + "-" + r.name;
  // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (n === !1 || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  U_ === !1) && t.registered[a] === void 0 && (t.registered[a] = r.styles);
}, jb = function(t, r, n) {
  z1(t, r, n);
  var a = t.key + "-" + r.name;
  if (t.inserted[r.name] === void 0) {
    var i = r;
    do
      t.insert(r === i ? "." + a : "", i, t.sheet, !0), i = i.next;
    while (i !== void 0);
  }
};
function z_(e) {
  for (var t = 0, r, n = 0, a = e.length; a >= 4; ++n, a -= 4)
    r = e.charCodeAt(n) & 255 | (e.charCodeAt(++n) & 255) << 8 | (e.charCodeAt(++n) & 255) << 16 | (e.charCodeAt(++n) & 255) << 24, r = /* Math.imul(k, m): */
    (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16), r ^= /* k >>> r: */
    r >>> 24, t = /* Math.imul(k, m): */
    (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  switch (a) {
    case 3:
      t ^= (e.charCodeAt(n + 2) & 255) << 16;
    case 2:
      t ^= (e.charCodeAt(n + 1) & 255) << 8;
    case 1:
      t ^= e.charCodeAt(n) & 255, t = /* Math.imul(h, m): */
      (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  }
  return t ^= t >>> 13, t = /* Math.imul(h, m): */
  (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16), ((t ^ t >>> 15) >>> 0).toString(36);
}
var Y_ = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  scale: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, X_ = !1, Z_ = /[A-Z]|^ms/g, K_ = /_EMO_([^_]+?)_([^]*?)_EMO_/g, Rb = function(t) {
  return t.charCodeAt(1) === 45;
}, M0 = function(t) {
  return t != null && typeof t != "boolean";
}, Il = /* @__PURE__ */ N_(function(e) {
  return Rb(e) ? e : e.replace(Z_, "-$&").toLowerCase();
}), j0 = function(t, r) {
  switch (t) {
    case "animation":
    case "animationName":
      if (typeof r == "string")
        return r.replace(K_, function(n, a, i) {
          return Sr = {
            name: a,
            styles: i,
            next: Sr
          }, a;
        });
  }
  return Y_[t] !== 1 && !Rb(t) && typeof r == "number" && r !== 0 ? r + "px" : r;
}, q_ = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function so(e, t, r) {
  if (r == null)
    return "";
  var n = r;
  if (n.__emotion_styles !== void 0)
    return n;
  switch (typeof r) {
    case "boolean":
      return "";
    case "object": {
      var a = r;
      if (a.anim === 1)
        return Sr = {
          name: a.name,
          styles: a.styles,
          next: Sr
        }, a.name;
      var i = r;
      if (i.styles !== void 0) {
        var o = i.next;
        if (o !== void 0)
          for (; o !== void 0; )
            Sr = {
              name: o.name,
              styles: o.styles,
              next: Sr
            }, o = o.next;
        var u = i.styles + ";";
        return u;
      }
      return J_(e, t, r);
    }
    case "function": {
      if (e !== void 0) {
        var s = Sr, c = r(e);
        return Sr = s, so(e, t, c);
      }
      break;
    }
  }
  var l = r;
  if (t == null)
    return l;
  var f = t[l];
  return f !== void 0 ? f : l;
}
function J_(e, t, r) {
  var n = "";
  if (Array.isArray(r))
    for (var a = 0; a < r.length; a++)
      n += so(e, t, r[a]) + ";";
  else
    for (var i in r) {
      var o = r[i];
      if (typeof o != "object") {
        var u = o;
        t != null && t[u] !== void 0 ? n += i + "{" + t[u] + "}" : M0(u) && (n += Il(i) + ":" + j0(i, u) + ";");
      } else {
        if (i === "NO_COMPONENT_SELECTOR" && X_)
          throw new Error(q_);
        if (Array.isArray(o) && typeof o[0] == "string" && (t == null || t[o[0]] === void 0))
          for (var s = 0; s < o.length; s++)
            M0(o[s]) && (n += Il(i) + ":" + j0(i, o[s]) + ";");
        else {
          var c = so(e, t, o);
          switch (i) {
            case "animation":
            case "animationName": {
              n += Il(i) + ":" + c + ";";
              break;
            }
            default:
              n += i + "{" + c + "}";
          }
        }
      }
    }
  return n;
}
var R0 = /label:\s*([^\s;{]+)\s*(;|$)/g, Sr;
function Y1(e, t, r) {
  if (e.length === 1 && typeof e[0] == "object" && e[0] !== null && e[0].styles !== void 0)
    return e[0];
  var n = !0, a = "";
  Sr = void 0;
  var i = e[0];
  if (i == null || i.raw === void 0)
    n = !1, a += so(r, t, i);
  else {
    var o = i;
    a += o[0];
  }
  for (var u = 1; u < e.length; u++)
    if (a += so(r, t, e[u]), n) {
      var s = i;
      a += s[u];
    }
  R0.lastIndex = 0;
  for (var c = "", l; (l = R0.exec(a)) !== null; )
    c += "-" + l[1];
  var f = z_(a) + c;
  return {
    name: f,
    styles: a,
    next: Sr
  };
}
var Q_ = function(t) {
  return t();
}, eI = Ae.useInsertionEffect ? Ae.useInsertionEffect : !1, Nb = eI || Q_, Wf = !1, $b = /* @__PURE__ */ Ae.createContext(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement < "u" ? /* @__PURE__ */ W_({
    key: "css"
  }) : null
);
$b.Provider;
var Fb = function(t) {
  return /* @__PURE__ */ Xo(function(r, n) {
    var a = $r($b);
    return t(r, a, n);
  });
}, Db = /* @__PURE__ */ Ae.createContext({}), X1 = {}.hasOwnProperty, Gf = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__", tI = function(t, r) {
  var n = {};
  for (var a in r)
    X1.call(r, a) && (n[a] = r[a]);
  return n[Gf] = t, n;
}, rI = function(t) {
  var r = t.cache, n = t.serialized, a = t.isStringTag;
  return z1(r, n, a), Nb(function() {
    return jb(r, n, a);
  }), null;
}, nI = /* @__PURE__ */ Fb(function(e, t, r) {
  var n = e.css;
  typeof n == "string" && t.registered[n] !== void 0 && (n = t.registered[n]);
  var a = e[Gf], i = [n], o = "";
  typeof e.className == "string" ? o = Mb(t.registered, i, e.className) : e.className != null && (o = e.className + " ");
  var u = Y1(i, void 0, Ae.useContext(Db));
  o += t.key + "-" + u.name;
  var s = {};
  for (var c in e)
    X1.call(e, c) && c !== "css" && c !== Gf && !Wf && (s[c] = e[c]);
  return s.className = o, r && (s.ref = r), /* @__PURE__ */ Ae.createElement(Ae.Fragment, null, /* @__PURE__ */ Ae.createElement(rI, {
    cache: t,
    serialized: u,
    isStringTag: typeof a == "string"
  }), /* @__PURE__ */ Ae.createElement(a, s));
}), aI = nI, ge = function(t, r) {
  var n = arguments;
  if (r == null || !X1.call(r, "css"))
    return Ae.createElement.apply(void 0, n);
  var a = n.length, i = new Array(a);
  i[0] = aI, i[1] = tI(t, r);
  for (var o = 2; o < a; o++)
    i[o] = n[o];
  return Ae.createElement.apply(null, i);
};
(function(e) {
  var t;
  t || (t = e.JSX || (e.JSX = {}));
})(ge || (ge = {}));
function Z1() {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
    t[r] = arguments[r];
  return Y1(t);
}
function iI() {
  var e = Z1.apply(void 0, arguments), t = "animation-" + e.name;
  return {
    name: t,
    styles: "@keyframes " + t + "{" + e.styles + "}",
    anim: 1,
    toString: function() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
}
var oI = function e(t) {
  for (var r = t.length, n = 0, a = ""; n < r; n++) {
    var i = t[n];
    if (i != null) {
      var o = void 0;
      switch (typeof i) {
        case "boolean":
          break;
        case "object": {
          if (Array.isArray(i))
            o = e(i);
          else {
            o = "";
            for (var u in i)
              i[u] && u && (o && (o += " "), o += u);
          }
          break;
        }
        default:
          o = i;
      }
      o && (a && (a += " "), a += o);
    }
  }
  return a;
};
function uI(e, t, r) {
  var n = [], a = Mb(e, n, r);
  return n.length < 2 ? r : a + t(n);
}
var sI = function(t) {
  var r = t.cache, n = t.serializedArr;
  return Nb(function() {
    for (var a = 0; a < n.length; a++)
      jb(r, n[a], !1);
  }), null;
}, cI = /* @__PURE__ */ Fb(function(e, t) {
  var r = !1, n = [], a = function() {
    if (r && Wf)
      throw new Error("css can only be used during render");
    for (var c = arguments.length, l = new Array(c), f = 0; f < c; f++)
      l[f] = arguments[f];
    var d = Y1(l, t.registered);
    return n.push(d), z1(t, d, !1), t.key + "-" + d.name;
  }, i = function() {
    if (r && Wf)
      throw new Error("cx can only be used during render");
    for (var c = arguments.length, l = new Array(c), f = 0; f < c; f++)
      l[f] = arguments[f];
    return uI(t.registered, a, oI(l));
  }, o = {
    css: a,
    cx: i,
    theme: Ae.useContext(Db)
  }, u = e.children(o);
  return r = !0, /* @__PURE__ */ Ae.createElement(Ae.Fragment, null, /* @__PURE__ */ Ae.createElement(sI, {
    cache: t,
    serializedArr: n
  }), u);
});
function lI(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
    raw: {
      value: Object.freeze(t)
    }
  }));
}
function fI(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e) if ({}.hasOwnProperty.call(e, n)) {
    if (t.indexOf(n) !== -1) continue;
    r[n] = e[n];
  }
  return r;
}
function ni(e, t) {
  if (e == null) return {};
  var r, n, a = fI(e, t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (n = 0; n < i.length; n++) r = i[n], t.indexOf(r) === -1 && {}.propertyIsEnumerable.call(e, r) && (a[r] = e[r]);
  }
  return a;
}
function Pa(e) {
  "@babel/helpers - typeof";
  return Pa = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Pa(e);
}
var kb = {};
Object.defineProperty(kb, "__esModule", {
  value: !0
});
var Pl = Object.assign || function(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t];
    for (var n in r)
      Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
  }
  return e;
}, N0 = /* @__PURE__ */ function() {
  function e(t, r) {
    for (var n = 0; n < r.length; n++) {
      var a = r[n];
      a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(t, a.key, a);
    }
  }
  return function(t, r, n) {
    return r && e(t.prototype, r), n && e(t, n), t;
  };
}(), Lb = N, Ai = Bb(Lb), dI = Xy, pt = Bb(dI);
function Bb(e) {
  return e && e.__esModule ? e : { default: e };
}
function pI(e, t) {
  var r = {};
  for (var n in e)
    t.indexOf(n) >= 0 || Object.prototype.hasOwnProperty.call(e, n) && (r[n] = e[n]);
  return r;
}
function hI(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function vI(e, t) {
  if (!e)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t && (typeof t == "object" || typeof t == "function") ? t : e;
}
function gI(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof t);
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, enumerable: !1, writable: !0, configurable: !0 } }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
}
var $0 = {
  position: "absolute",
  top: 0,
  left: 0,
  visibility: "hidden",
  height: 0,
  overflow: "scroll",
  whiteSpace: "pre"
}, mI = ["extraWidth", "injectStyles", "inputClassName", "inputRef", "inputStyle", "minWidth", "onAutosize", "placeholderIsMinWidth"], yI = function(t) {
  return mI.forEach(function(r) {
    return delete t[r];
  }), t;
}, F0 = function(t, r) {
  r.style.fontSize = t.fontSize, r.style.fontFamily = t.fontFamily, r.style.fontWeight = t.fontWeight, r.style.fontStyle = t.fontStyle, r.style.letterSpacing = t.letterSpacing, r.style.textTransform = t.textTransform;
}, Vb = typeof window < "u" && window.navigator ? /MSIE |Trident\/|Edge\//.test(window.navigator.userAgent) : !1, D0 = function() {
  return Vb ? "_" + Math.random().toString(36).substr(2, 12) : void 0;
}, K1 = function(e) {
  gI(t, e), N0(t, null, [{
    key: "getDerivedStateFromProps",
    value: function(n, a) {
      var i = n.id;
      return i !== a.prevId ? { inputId: i || D0(), prevId: i } : null;
    }
  }]);
  function t(r) {
    hI(this, t);
    var n = vI(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, r));
    return n.inputRef = function(a) {
      n.input = a, typeof n.props.inputRef == "function" && n.props.inputRef(a);
    }, n.placeHolderSizerRef = function(a) {
      n.placeHolderSizer = a;
    }, n.sizerRef = function(a) {
      n.sizer = a;
    }, n.state = {
      inputWidth: r.minWidth,
      inputId: r.id || D0(),
      prevId: r.id
    }, n;
  }
  return N0(t, [{
    key: "componentDidMount",
    value: function() {
      this.mounted = !0, this.copyInputStyles(), this.updateInputWidth();
    }
  }, {
    key: "componentDidUpdate",
    value: function(n, a) {
      a.inputWidth !== this.state.inputWidth && typeof this.props.onAutosize == "function" && this.props.onAutosize(this.state.inputWidth), this.updateInputWidth();
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.mounted = !1;
    }
  }, {
    key: "copyInputStyles",
    value: function() {
      if (!(!this.mounted || !window.getComputedStyle)) {
        var n = this.input && window.getComputedStyle(this.input);
        n && (F0(n, this.sizer), this.placeHolderSizer && F0(n, this.placeHolderSizer));
      }
    }
  }, {
    key: "updateInputWidth",
    value: function() {
      if (!(!this.mounted || !this.sizer || typeof this.sizer.scrollWidth > "u")) {
        var n = void 0;
        this.props.placeholder && (!this.props.value || this.props.value && this.props.placeholderIsMinWidth) ? n = Math.max(this.sizer.scrollWidth, this.placeHolderSizer.scrollWidth) + 2 : n = this.sizer.scrollWidth + 2;
        var a = this.props.type === "number" && this.props.extraWidth === void 0 ? 16 : parseInt(this.props.extraWidth) || 0;
        n += a, n < this.props.minWidth && (n = this.props.minWidth), n !== this.state.inputWidth && this.setState({
          inputWidth: n
        });
      }
    }
  }, {
    key: "getInput",
    value: function() {
      return this.input;
    }
  }, {
    key: "focus",
    value: function() {
      this.input.focus();
    }
  }, {
    key: "blur",
    value: function() {
      this.input.blur();
    }
  }, {
    key: "select",
    value: function() {
      this.input.select();
    }
  }, {
    key: "renderStyles",
    value: function() {
      var n = this.props.injectStyles;
      return Vb && n ? Ai.default.createElement("style", { dangerouslySetInnerHTML: {
        __html: "input#" + this.state.inputId + "::-ms-clear {display: none;}"
      } }) : null;
    }
  }, {
    key: "render",
    value: function() {
      var n = [this.props.defaultValue, this.props.value, ""].reduce(function(u, s) {
        return u ?? s;
      }), a = Pl({}, this.props.style);
      a.display || (a.display = "inline-block");
      var i = Pl({
        boxSizing: "content-box",
        width: this.state.inputWidth + "px"
      }, this.props.inputStyle), o = pI(this.props, []);
      return yI(o), o.className = this.props.inputClassName, o.id = this.state.inputId, o.style = i, Ai.default.createElement(
        "div",
        { className: this.props.className, style: a },
        this.renderStyles(),
        Ai.default.createElement("input", Pl({}, o, { ref: this.inputRef })),
        Ai.default.createElement(
          "div",
          { ref: this.sizerRef, style: $0 },
          n
        ),
        this.props.placeholder ? Ai.default.createElement(
          "div",
          { ref: this.placeHolderSizerRef, style: $0 },
          this.props.placeholder
        ) : null
      );
    }
  }]), t;
}(Lb.Component);
K1.propTypes = {
  className: pt.default.string,
  // className for the outer element
  defaultValue: pt.default.any,
  // default field value
  extraWidth: pt.default.oneOfType([
    // additional width for input element
    pt.default.number,
    pt.default.string
  ]),
  id: pt.default.string,
  // id to use for the input, can be set for consistent snapshots
  injectStyles: pt.default.bool,
  // inject the custom stylesheet to hide clear UI, defaults to true
  inputClassName: pt.default.string,
  // className for the input element
  inputRef: pt.default.func,
  // ref callback for the input element
  inputStyle: pt.default.object,
  // css styles for the input element
  minWidth: pt.default.oneOfType([
    // minimum width for input element
    pt.default.number,
    pt.default.string
  ]),
  onAutosize: pt.default.func,
  // onAutosize handler: function(newWidth) {}
  onChange: pt.default.func,
  // onChange handler: function(event) {}
  placeholder: pt.default.string,
  // placeholder text
  placeholderIsMinWidth: pt.default.bool,
  // don't collapse size to less than the placeholder
  style: pt.default.object,
  // css styles for the outer element
  value: pt.default.any
  // field value
};
K1.defaultProps = {
  minWidth: 1,
  injectStyles: !0
};
var bI = kb.default = K1;
function cc(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function xI(e, t) {
  if (Pa(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (Pa(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
function Wb(e) {
  var t = xI(e, "string");
  return Pa(t) == "symbol" ? t : t + "";
}
function k0(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Wb(n.key), n);
  }
}
function lc(e, t, r) {
  return t && k0(e.prototype, t), r && k0(e, r), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function Hf(e, t) {
  return Hf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, n) {
    return r.__proto__ = n, r;
  }, Hf(e, t);
}
function fc(e, t) {
  if (typeof t != "function" && t !== null) throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(e, "prototype", {
    writable: !1
  }), t && Hf(e, t);
}
function Dr(e, t, r) {
  return (t = Wb(t)) in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
function CI(e, t, r) {
  return t in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
function L0(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function _t(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? L0(Object(r), !0).forEach(function(n) {
      CI(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : L0(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Zu(e) {
  return Zu = Object.setPrototypeOf ? Object.getPrototypeOf : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Zu(e);
}
function wI() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function OI(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function SI(e, t) {
  return t && (typeof t == "object" || typeof t == "function") ? t : OI(e);
}
function dc(e) {
  var t = wI();
  return function() {
    var n = Zu(e), a;
    if (t) {
      var i = Zu(this).constructor;
      a = Reflect.construct(n, arguments, i);
    } else
      a = n.apply(this, arguments);
    return SI(this, a);
  };
}
var Ku = function() {
};
function AI(e, t) {
  return t ? t[0] === "-" ? e + t : e + "__" + t : e;
}
function EI(e, t, r) {
  var n = [r];
  if (t && e)
    for (var a in t)
      t.hasOwnProperty(a) && t[a] && n.push("".concat(AI(e, a)));
  return n.filter(function(i) {
    return i;
  }).map(function(i) {
    return String(i).trim();
  }).join(" ");
}
var B0 = function(t) {
  return Array.isArray(t) ? t.filter(Boolean) : Pa(t) === "object" && t !== null ? [t] : [];
}, Gb = function(t) {
  t.className, t.clearValue, t.cx, t.getStyles, t.getValue, t.hasValue, t.isMulti, t.isRtl, t.options, t.selectOption, t.selectProps, t.setValue, t.theme;
  var r = ni(t, ["className", "clearValue", "cx", "getStyles", "getValue", "hasValue", "isMulti", "isRtl", "options", "selectOption", "selectProps", "setValue", "theme"]);
  return _t({}, r);
};
function q1(e) {
  return [document.documentElement, document.body, window].indexOf(e) > -1;
}
function Hb(e) {
  return q1(e) ? window.pageYOffset : e.scrollTop;
}
function qu(e, t) {
  if (q1(e)) {
    window.scrollTo(0, t);
    return;
  }
  e.scrollTop = t;
}
function _I(e) {
  var t = getComputedStyle(e), r = t.position === "absolute", n = /(auto|scroll)/, a = document.documentElement;
  if (t.position === "fixed") return a;
  for (var i = e; i = i.parentElement; )
    if (t = getComputedStyle(i), !(r && t.position === "static") && n.test(t.overflow + t.overflowY + t.overflowX))
      return i;
  return a;
}
function II(e, t, r, n) {
  return r * ((e = e / n - 1) * e * e + 1) + t;
}
function yu(e, t) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 200, n = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : Ku, a = Hb(e), i = t - a, o = 10, u = 0;
  function s() {
    u += o;
    var c = II(u, a, i, r);
    qu(e, c), u < r ? window.requestAnimationFrame(s) : n(e);
  }
  s();
}
function PI(e, t) {
  var r = e.getBoundingClientRect(), n = t.getBoundingClientRect(), a = t.offsetHeight / 3;
  n.bottom + a > r.bottom ? qu(e, Math.min(t.offsetTop + t.clientHeight - e.offsetHeight + a, e.scrollHeight)) : n.top - a < r.top && qu(e, Math.max(t.offsetTop - a, 0));
}
function TI(e) {
  var t = e.getBoundingClientRect();
  return {
    bottom: t.bottom,
    height: t.height,
    left: t.left,
    right: t.right,
    top: t.top,
    width: t.width
  };
}
function V0() {
  try {
    return document.createEvent("TouchEvent"), !0;
  } catch {
    return !1;
  }
}
function MI() {
  try {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  } catch {
    return !1;
  }
}
var Ub = !1, jI = {
  get passive() {
    return Ub = !0;
  }
}, bu = typeof window < "u" ? window : {};
bu.addEventListener && bu.removeEventListener && (bu.addEventListener("p", Ku, jI), bu.removeEventListener("p", Ku, !1));
var RI = Ub;
function NI(e) {
  var t = e.maxHeight, r = e.menuEl, n = e.minHeight, a = e.placement, i = e.shouldScroll, o = e.isFixedPosition, u = e.theme, s = u.spacing, c = _I(r), l = {
    placement: "bottom",
    maxHeight: t
  };
  if (!r || !r.offsetParent) return l;
  var f = c.getBoundingClientRect(), d = f.height, p = r.getBoundingClientRect(), h = p.bottom, v = p.height, g = p.top, b = r.offsetParent.getBoundingClientRect(), x = b.top, w = window.innerHeight, y = Hb(c), m = parseInt(getComputedStyle(r).marginBottom, 10), C = parseInt(getComputedStyle(r).marginTop, 10), O = x - C, S = w - g, A = O + y, P = d - y - g, T = h - w + y + m, M = y + g - C, I = 160;
  switch (a) {
    case "auto":
    case "bottom":
      if (S >= v)
        return {
          placement: "bottom",
          maxHeight: t
        };
      if (P >= v && !o)
        return i && yu(c, T, I), {
          placement: "bottom",
          maxHeight: t
        };
      if (!o && P >= n || o && S >= n) {
        i && yu(c, T, I);
        var G = o ? S - m : P - m;
        return {
          placement: "bottom",
          maxHeight: G
        };
      }
      if (a === "auto" || o) {
        var Y = t, L = o ? O : A;
        return L >= n && (Y = Math.min(L - m - s.controlHeight, t)), {
          placement: "top",
          maxHeight: Y
        };
      }
      if (a === "bottom")
        return i && qu(c, T), {
          placement: "bottom",
          maxHeight: t
        };
      break;
    case "top":
      if (O >= v)
        return {
          placement: "top",
          maxHeight: t
        };
      if (A >= v && !o)
        return i && yu(c, M, I), {
          placement: "top",
          maxHeight: t
        };
      if (!o && A >= n || o && O >= n) {
        var X = t;
        return (!o && A >= n || o && O >= n) && (X = o ? O - C : A - C), i && yu(c, M, I), {
          placement: "top",
          maxHeight: X
        };
      }
      return {
        placement: "bottom",
        maxHeight: t
      };
    default:
      throw new Error('Invalid placement provided "'.concat(a, '".'));
  }
  return l;
}
function $I(e) {
  var t = {
    bottom: "top",
    top: "bottom"
  };
  return e ? t[e] : "bottom";
}
var Uf = function(t) {
  return t === "auto" ? "bottom" : t;
}, FI = function(t) {
  var r, n = t.placement, a = t.theme, i = a.borderRadius, o = a.spacing, u = a.colors;
  return r = {
    label: "menu"
  }, Dr(r, $I(n), "100%"), Dr(r, "backgroundColor", u.neutral0), Dr(r, "borderRadius", i), Dr(r, "boxShadow", "0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)"), Dr(r, "marginBottom", o.menuGutter), Dr(r, "marginTop", o.menuGutter), Dr(r, "position", "absolute"), Dr(r, "width", "100%"), Dr(r, "zIndex", 1), r;
}, zb = /* @__PURE__ */ bn({
  getPortalPlacement: null
}), Yb = /* @__PURE__ */ function(e) {
  fc(r, e);
  var t = dc(r);
  function r() {
    var n;
    cc(this, r);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(i)), n.state = {
      maxHeight: n.props.maxMenuHeight,
      placement: null
    }, n.getPlacement = function(u) {
      var s = n.props, c = s.minMenuHeight, l = s.maxMenuHeight, f = s.menuPlacement, d = s.menuPosition, p = s.menuShouldScrollIntoView, h = s.theme;
      if (u) {
        var v = d === "fixed", g = p && !v, b = NI({
          maxHeight: l,
          menuEl: u,
          minHeight: c,
          placement: f,
          shouldScroll: g,
          isFixedPosition: v,
          theme: h
        }), x = n.context.getPortalPlacement;
        x && x(b), n.setState(b);
      }
    }, n.getUpdatedProps = function() {
      var u = n.props.menuPlacement, s = n.state.placement || Uf(u);
      return _t(_t({}, n.props), {}, {
        placement: s,
        maxHeight: n.state.maxHeight
      });
    }, n;
  }
  return lc(r, [{
    key: "render",
    value: function() {
      var a = this.props.children;
      return a({
        ref: this.getPlacement,
        placerProps: this.getUpdatedProps()
      });
    }
  }]), r;
}(Za);
Yb.contextType = zb;
var DI = function(t) {
  var r = t.children, n = t.className, a = t.cx, i = t.getStyles, o = t.innerRef, u = t.innerProps;
  return ge("div", ye({
    css: i("menu", t),
    className: a({
      menu: !0
    }, n),
    ref: o
  }, u), r);
}, kI = function(t) {
  var r = t.maxHeight, n = t.theme.spacing.baseUnit;
  return {
    maxHeight: r,
    overflowY: "auto",
    paddingBottom: n,
    paddingTop: n,
    position: "relative",
    // required for offset[Height, Top] > keyboard scroll
    WebkitOverflowScrolling: "touch"
  };
}, LI = function(t) {
  var r = t.children, n = t.className, a = t.cx, i = t.getStyles, o = t.innerProps, u = t.innerRef, s = t.isMulti;
  return ge("div", ye({
    css: i("menuList", t),
    className: a({
      "menu-list": !0,
      "menu-list--is-multi": s
    }, n),
    ref: u
  }, o), r);
}, Xb = function(t) {
  var r = t.theme, n = r.spacing.baseUnit, a = r.colors;
  return {
    color: a.neutral40,
    padding: "".concat(n * 2, "px ").concat(n * 3, "px"),
    textAlign: "center"
  };
}, BI = Xb, VI = Xb, Zb = function(t) {
  var r = t.children, n = t.className, a = t.cx, i = t.getStyles, o = t.innerProps;
  return ge("div", ye({
    css: i("noOptionsMessage", t),
    className: a({
      "menu-notice": !0,
      "menu-notice--no-options": !0
    }, n)
  }, o), r);
};
Zb.defaultProps = {
  children: "No options"
};
var Kb = function(t) {
  var r = t.children, n = t.className, a = t.cx, i = t.getStyles, o = t.innerProps;
  return ge("div", ye({
    css: i("loadingMessage", t),
    className: a({
      "menu-notice": !0,
      "menu-notice--loading": !0
    }, n)
  }, o), r);
};
Kb.defaultProps = {
  children: "Loading..."
};
var WI = function(t) {
  var r = t.rect, n = t.offset, a = t.position;
  return {
    left: r.left,
    position: a,
    top: n,
    width: r.width,
    zIndex: 1
  };
}, GI = /* @__PURE__ */ function(e) {
  fc(r, e);
  var t = dc(r);
  function r() {
    var n;
    cc(this, r);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(i)), n.state = {
      placement: null
    }, n.getPortalPlacement = function(u) {
      var s = u.placement, c = Uf(n.props.menuPlacement);
      s !== c && n.setState({
        placement: s
      });
    }, n;
  }
  return lc(r, [{
    key: "render",
    value: function() {
      var a = this.props, i = a.appendTo, o = a.children, u = a.className, s = a.controlElement, c = a.cx, l = a.innerProps, f = a.menuPlacement, d = a.menuPosition, p = a.getStyles, h = d === "fixed";
      if (!i && !h || !s)
        return null;
      var v = this.state.placement || Uf(f), g = TI(s), b = h ? 0 : window.pageYOffset, x = g[v] + b, w = {
        offset: x,
        position: d,
        rect: g
      }, y = ge("div", ye({
        css: p("menuPortal", w),
        className: c({
          "menu-portal": !0
        }, u)
      }, l), o);
      return ge(zb.Provider, {
        value: {
          getPortalPlacement: this.getPortalPlacement
        }
      }, i ? /* @__PURE__ */ F6(y, i) : y);
    }
  }]), r;
}(Za), HI = function(t) {
  var r = t.isDisabled, n = t.isRtl;
  return {
    label: "container",
    direction: n ? "rtl" : null,
    pointerEvents: r ? "none" : null,
    // cancel mouse events when disabled
    position: "relative"
  };
}, UI = function(t) {
  var r = t.children, n = t.className, a = t.cx, i = t.getStyles, o = t.innerProps, u = t.isDisabled, s = t.isRtl;
  return ge("div", ye({
    css: i("container", t),
    className: a({
      "--is-disabled": u,
      "--is-rtl": s
    }, n)
  }, o), r);
}, zI = function(t) {
  var r = t.theme.spacing;
  return {
    alignItems: "center",
    display: "flex",
    flex: 1,
    flexWrap: "wrap",
    padding: "".concat(r.baseUnit / 2, "px ").concat(r.baseUnit * 2, "px"),
    WebkitOverflowScrolling: "touch",
    position: "relative",
    overflow: "hidden"
  };
}, YI = function(t) {
  var r = t.children, n = t.className, a = t.cx, i = t.innerProps, o = t.isMulti, u = t.getStyles, s = t.hasValue;
  return ge("div", ye({
    css: u("valueContainer", t),
    className: a({
      "value-container": !0,
      "value-container--is-multi": o,
      "value-container--has-value": s
    }, n)
  }, i), r);
}, XI = function() {
  return {
    alignItems: "center",
    alignSelf: "stretch",
    display: "flex",
    flexShrink: 0
  };
}, ZI = function(t) {
  var r = t.children, n = t.className, a = t.cx, i = t.innerProps, o = t.getStyles;
  return ge("div", ye({
    css: o("indicatorsContainer", t),
    className: a({
      indicators: !0
    }, n)
  }, i), r);
}, W0;
function KI() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var qI = process.env.NODE_ENV === "production" ? {
  name: "8mmkcg",
  styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
} : {
  name: "tj5bde-Svg",
  styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0;label:Svg;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: KI
}, qb = function(t) {
  var r = t.size, n = ni(t, ["size"]);
  return ge("svg", ye({
    height: r,
    width: r,
    viewBox: "0 0 20 20",
    "aria-hidden": "true",
    focusable: "false",
    css: qI
  }, n));
}, J1 = function(t) {
  return ge(qb, ye({
    size: 20
  }, t), ge("path", {
    d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
  }));
}, Jb = function(t) {
  return ge(qb, ye({
    size: 20
  }, t), ge("path", {
    d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
  }));
}, Qb = function(t) {
  var r = t.isFocused, n = t.theme, a = n.spacing.baseUnit, i = n.colors;
  return {
    label: "indicatorContainer",
    color: r ? i.neutral60 : i.neutral20,
    display: "flex",
    padding: a * 2,
    transition: "color 150ms",
    ":hover": {
      color: r ? i.neutral80 : i.neutral40
    }
  };
}, JI = Qb, QI = function(t) {
  var r = t.children, n = t.className, a = t.cx, i = t.getStyles, o = t.innerProps;
  return ge("div", ye({
    css: i("dropdownIndicator", t),
    className: a({
      indicator: !0,
      "dropdown-indicator": !0
    }, n)
  }, o), r || ge(Jb, null));
}, eP = Qb, tP = function(t) {
  var r = t.children, n = t.className, a = t.cx, i = t.getStyles, o = t.innerProps;
  return ge("div", ye({
    css: i("clearIndicator", t),
    className: a({
      indicator: !0,
      "clear-indicator": !0
    }, n)
  }, o), r || ge(J1, null));
}, rP = function(t) {
  var r = t.isDisabled, n = t.theme, a = n.spacing.baseUnit, i = n.colors;
  return {
    label: "indicatorSeparator",
    alignSelf: "stretch",
    backgroundColor: r ? i.neutral10 : i.neutral20,
    marginBottom: a * 2,
    marginTop: a * 2,
    width: 1
  };
}, nP = function(t) {
  var r = t.className, n = t.cx, a = t.getStyles, i = t.innerProps;
  return ge("span", ye({}, i, {
    css: a("indicatorSeparator", t),
    className: n({
      "indicator-separator": !0
    }, r)
  }));
}, aP = iI(W0 || (W0 = lI([`
  0%, 80%, 100% { opacity: 0; }
  40% { opacity: 1; }
`]))), iP = function(t) {
  var r = t.isFocused, n = t.size, a = t.theme, i = a.colors, o = a.spacing.baseUnit;
  return {
    label: "loadingIndicator",
    color: r ? i.neutral60 : i.neutral20,
    display: "flex",
    padding: o * 2,
    transition: "color 150ms",
    alignSelf: "center",
    fontSize: n,
    lineHeight: 1,
    marginRight: n,
    textAlign: "center",
    verticalAlign: "middle"
  };
}, Tl = function(t) {
  var r = t.delay, n = t.offset;
  return ge("span", {
    css: /* @__PURE__ */ Z1({
      animation: "".concat(aP, " 1s ease-in-out ").concat(r, "ms infinite;"),
      backgroundColor: "currentColor",
      borderRadius: "1em",
      display: "inline-block",
      marginLeft: n ? "1em" : null,
      height: "1em",
      verticalAlign: "top",
      width: "1em"
    }, process.env.NODE_ENV === "production" ? "" : ";label:LoadingDot;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")
  });
}, e3 = function(t) {
  var r = t.className, n = t.cx, a = t.getStyles, i = t.innerProps, o = t.isRtl;
  return ge("div", ye({
    css: a("loadingIndicator", t),
    className: n({
      indicator: !0,
      "loading-indicator": !0
    }, r)
  }, i), ge(Tl, {
    delay: 0,
    offset: o
  }), ge(Tl, {
    delay: 160,
    offset: !0
  }), ge(Tl, {
    delay: 320,
    offset: !o
  }));
};
e3.defaultProps = {
  size: 4
};
var oP = function(t) {
  var r = t.isDisabled, n = t.isFocused, a = t.theme, i = a.colors, o = a.borderRadius, u = a.spacing;
  return {
    label: "control",
    alignItems: "center",
    backgroundColor: r ? i.neutral5 : i.neutral0,
    borderColor: r ? i.neutral10 : n ? i.primary : i.neutral20,
    borderRadius: o,
    borderStyle: "solid",
    borderWidth: 1,
    boxShadow: n ? "0 0 0 1px ".concat(i.primary) : null,
    cursor: "default",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    minHeight: u.controlHeight,
    outline: "0 !important",
    position: "relative",
    transition: "all 100ms",
    "&:hover": {
      borderColor: n ? i.primary : i.neutral30
    }
  };
}, uP = function(t) {
  var r = t.children, n = t.cx, a = t.getStyles, i = t.className, o = t.isDisabled, u = t.isFocused, s = t.innerRef, c = t.innerProps, l = t.menuIsOpen;
  return ge("div", ye({
    ref: s,
    css: a("control", t),
    className: n({
      control: !0,
      "control--is-disabled": o,
      "control--is-focused": u,
      "control--menu-is-open": l
    }, i)
  }, c), r);
}, sP = function(t) {
  var r = t.theme.spacing;
  return {
    paddingBottom: r.baseUnit * 2,
    paddingTop: r.baseUnit * 2
  };
}, cP = function(t) {
  var r = t.children, n = t.className, a = t.cx, i = t.getStyles, o = t.Heading, u = t.headingProps, s = t.innerProps, c = t.label, l = t.theme, f = t.selectProps;
  return ge("div", ye({
    css: i("group", t),
    className: a({
      group: !0
    }, n)
  }, s), ge(o, ye({}, u, {
    selectProps: f,
    theme: l,
    getStyles: i,
    cx: a
  }), c), ge("div", null, r));
}, lP = function(t) {
  var r = t.theme.spacing;
  return {
    label: "group",
    color: "#999",
    cursor: "default",
    display: "block",
    fontSize: "75%",
    fontWeight: "500",
    marginBottom: "0.25em",
    paddingLeft: r.baseUnit * 3,
    paddingRight: r.baseUnit * 3,
    textTransform: "uppercase"
  };
}, fP = function(t) {
  var r = t.getStyles, n = t.cx, a = t.className, i = Gb(t);
  i.data;
  var o = ni(i, ["data"]);
  return ge("div", ye({
    css: r("groupHeading", t),
    className: n({
      "group-heading": !0
    }, a)
  }, o));
}, dP = function(t) {
  var r = t.isDisabled, n = t.theme, a = n.spacing, i = n.colors;
  return {
    margin: a.baseUnit / 2,
    paddingBottom: a.baseUnit / 2,
    paddingTop: a.baseUnit / 2,
    visibility: r ? "hidden" : "visible",
    color: i.neutral80
  };
}, pP = function(t) {
  return {
    label: "input",
    background: 0,
    border: 0,
    fontSize: "inherit",
    opacity: t ? 0 : 1,
    outline: 0,
    padding: 0,
    color: "inherit"
  };
}, hP = function(t) {
  var r = t.className, n = t.cx, a = t.getStyles, i = Gb(t), o = i.innerRef, u = i.isDisabled, s = i.isHidden, c = ni(i, ["innerRef", "isDisabled", "isHidden"]);
  return ge("div", {
    css: a("input", t)
  }, ge(bI, ye({
    className: n({
      input: !0
    }, r),
    inputRef: o,
    inputStyle: pP(s),
    disabled: u
  }, c)));
}, vP = function(t) {
  var r = t.theme, n = r.spacing, a = r.borderRadius, i = r.colors;
  return {
    label: "multiValue",
    backgroundColor: i.neutral10,
    borderRadius: a / 2,
    display: "flex",
    margin: n.baseUnit / 2,
    minWidth: 0
    // resolves flex/text-overflow bug
  };
}, gP = function(t) {
  var r = t.theme, n = r.borderRadius, a = r.colors, i = t.cropWithEllipsis;
  return {
    borderRadius: n / 2,
    color: a.neutral80,
    fontSize: "85%",
    overflow: "hidden",
    padding: 3,
    paddingLeft: 6,
    textOverflow: i ? "ellipsis" : null,
    whiteSpace: "nowrap"
  };
}, mP = function(t) {
  var r = t.theme, n = r.spacing, a = r.borderRadius, i = r.colors, o = t.isFocused;
  return {
    alignItems: "center",
    borderRadius: a / 2,
    backgroundColor: o && i.dangerLight,
    display: "flex",
    paddingLeft: n.baseUnit,
    paddingRight: n.baseUnit,
    ":hover": {
      backgroundColor: i.dangerLight,
      color: i.danger
    }
  };
}, t3 = function(t) {
  var r = t.children, n = t.innerProps;
  return ge("div", n, r);
}, yP = t3, bP = t3;
function xP(e) {
  var t = e.children, r = e.innerProps;
  return ge("div", r, t || ge(J1, {
    size: 14
  }));
}
var r3 = function(t) {
  var r = t.children, n = t.className, a = t.components, i = t.cx, o = t.data, u = t.getStyles, s = t.innerProps, c = t.isDisabled, l = t.removeProps, f = t.selectProps, d = a.Container, p = a.Label, h = a.Remove;
  return ge(cI, null, function(v) {
    var g = v.css, b = v.cx;
    return ge(d, {
      data: o,
      innerProps: _t({
        className: b(g(u("multiValue", t)), i({
          "multi-value": !0,
          "multi-value--is-disabled": c
        }, n))
      }, s),
      selectProps: f
    }, ge(p, {
      data: o,
      innerProps: {
        className: b(g(u("multiValueLabel", t)), i({
          "multi-value__label": !0
        }, n))
      },
      selectProps: f
    }, r), ge(h, {
      data: o,
      innerProps: _t({
        className: b(g(u("multiValueRemove", t)), i({
          "multi-value__remove": !0
        }, n))
      }, l),
      selectProps: f
    }));
  });
};
r3.defaultProps = {
  cropWithEllipsis: !0
};
var CP = function(t) {
  var r = t.isDisabled, n = t.isFocused, a = t.isSelected, i = t.theme, o = i.spacing, u = i.colors;
  return {
    label: "option",
    backgroundColor: a ? u.primary : n ? u.primary25 : "transparent",
    color: r ? u.neutral20 : a ? u.neutral0 : "inherit",
    cursor: "default",
    display: "block",
    fontSize: "inherit",
    padding: "".concat(o.baseUnit * 2, "px ").concat(o.baseUnit * 3, "px"),
    width: "100%",
    userSelect: "none",
    WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
    // provide some affordance on touch devices
    ":active": {
      backgroundColor: !r && (a ? u.primary : u.primary50)
    }
  };
}, wP = function(t) {
  var r = t.children, n = t.className, a = t.cx, i = t.getStyles, o = t.isDisabled, u = t.isFocused, s = t.isSelected, c = t.innerRef, l = t.innerProps;
  return ge("div", ye({
    css: i("option", t),
    className: a({
      option: !0,
      "option--is-disabled": o,
      "option--is-focused": u,
      "option--is-selected": s
    }, n),
    ref: c
  }, l), r);
}, OP = function(t) {
  var r = t.theme, n = r.spacing, a = r.colors;
  return {
    label: "placeholder",
    color: a.neutral50,
    marginLeft: n.baseUnit / 2,
    marginRight: n.baseUnit / 2,
    position: "absolute",
    top: "50%",
    transform: "translateY(-50%)"
  };
}, SP = function(t) {
  var r = t.children, n = t.className, a = t.cx, i = t.getStyles, o = t.innerProps;
  return ge("div", ye({
    css: i("placeholder", t),
    className: a({
      placeholder: !0
    }, n)
  }, o), r);
}, AP = function(t) {
  var r = t.isDisabled, n = t.theme, a = n.spacing, i = n.colors;
  return {
    label: "singleValue",
    color: r ? i.neutral40 : i.neutral80,
    marginLeft: a.baseUnit / 2,
    marginRight: a.baseUnit / 2,
    maxWidth: "calc(100% - ".concat(a.baseUnit * 2, "px)"),
    overflow: "hidden",
    position: "absolute",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    top: "50%",
    transform: "translateY(-50%)"
  };
}, EP = function(t) {
  var r = t.children, n = t.className, a = t.cx, i = t.getStyles, o = t.isDisabled, u = t.innerProps;
  return ge("div", ye({
    css: i("singleValue", t),
    className: a({
      "single-value": !0,
      "single-value--is-disabled": o
    }, n)
  }, u), r);
}, _P = {
  ClearIndicator: tP,
  Control: uP,
  DropdownIndicator: QI,
  DownChevron: Jb,
  CrossIcon: J1,
  Group: cP,
  GroupHeading: fP,
  IndicatorsContainer: ZI,
  IndicatorSeparator: nP,
  Input: hP,
  LoadingIndicator: e3,
  Menu: DI,
  MenuList: LI,
  MenuPortal: GI,
  LoadingMessage: Kb,
  NoOptionsMessage: Zb,
  MultiValue: r3,
  MultiValueContainer: yP,
  MultiValueLabel: bP,
  MultiValueRemove: xP,
  Option: wP,
  Placeholder: SP,
  SelectContainer: UI,
  SingleValue: EP,
  ValueContainer: YI
}, IP = function(t) {
  return _t(_t({}, _P), t.components);
};
function zf(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function PP(e) {
  if (Array.isArray(e)) return zf(e);
}
function TP(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function MP(e, t) {
  if (e) {
    if (typeof e == "string") return zf(e, t);
    var r = {}.toString.call(e).slice(8, -1);
    return r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set" ? Array.from(e) : r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? zf(e, t) : void 0;
  }
}
function jP() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function n3(e) {
  return PP(e) || TP(e) || MP(e) || jP();
}
var G0 = Number.isNaN || function(t) {
  return typeof t == "number" && t !== t;
};
function RP(e, t) {
  return !!(e === t || G0(e) && G0(t));
}
function NP(e, t) {
  if (e.length !== t.length)
    return !1;
  for (var r = 0; r < e.length; r++)
    if (!RP(e[r], t[r]))
      return !1;
  return !0;
}
function $P(e, t) {
  t === void 0 && (t = NP);
  var r, n = [], a, i = !1;
  function o() {
    for (var u = [], s = 0; s < arguments.length; s++)
      u[s] = arguments[s];
    return i && r === this && t(u, n) || (a = e.apply(this, u), i = !0, r = this, n = u), a;
  }
  return o;
}
function FP() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var DP = process.env.NODE_ENV === "production" ? {
  name: "7pg0cj-a11yText",
  styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap"
} : {
  name: "1f43avz-a11yText-A11yText",
  styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap;label:A11yText;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkExMXlUZXh0LmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQVFJIiwiZmlsZSI6IkExMXlUZXh0LmpzIiwic291cmNlc0NvbnRlbnQiOlsiLy8gQGZsb3dcbi8qKiBAanN4IGpzeCAqL1xuaW1wb3J0IHsgdHlwZSBFbGVtZW50Q29uZmlnIH0gZnJvbSAncmVhY3QnO1xuaW1wb3J0IHsganN4IH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuXG4vLyBBc3Npc3RpdmUgdGV4dCB0byBkZXNjcmliZSB2aXN1YWwgZWxlbWVudHMuIEhpZGRlbiBmb3Igc2lnaHRlZCB1c2Vycy5cbmNvbnN0IEExMXlUZXh0ID0gKHByb3BzOiBFbGVtZW50Q29uZmlnPCdzcGFuJz4pID0+IChcbiAgPHNwYW5cbiAgICBjc3M9e3tcbiAgICAgIGxhYmVsOiAnYTExeVRleHQnLFxuICAgICAgekluZGV4OiA5OTk5LFxuICAgICAgYm9yZGVyOiAwLFxuICAgICAgY2xpcDogJ3JlY3QoMXB4LCAxcHgsIDFweCwgMXB4KScsXG4gICAgICBoZWlnaHQ6IDEsXG4gICAgICB3aWR0aDogMSxcbiAgICAgIHBvc2l0aW9uOiAnYWJzb2x1dGUnLFxuICAgICAgb3ZlcmZsb3c6ICdoaWRkZW4nLFxuICAgICAgcGFkZGluZzogMCxcbiAgICAgIHdoaXRlU3BhY2U6ICdub3dyYXAnLFxuICAgIH19XG4gICAgey4uLnByb3BzfVxuICAvPlxuKTtcblxuZXhwb3J0IGRlZmF1bHQgQTExeVRleHQ7XG4iXX0= */",
  toString: FP
}, kP = function(t) {
  return ge("span", ye({
    css: DP
  }, t));
}, LP = {
  guidance: function(t) {
    var r = t.isSearchable, n = t.isMulti, a = t.isDisabled, i = t.tabSelectsValue, o = t.context;
    switch (o) {
      case "menu":
        return "Use Up and Down to choose options".concat(a ? "" : ", press Enter to select the currently focused option", ", press Escape to exit the menu").concat(i ? ", press Tab to select the option and exit the menu" : "", ".");
      case "input":
        return "".concat(t["aria-label"] || "Select", " is focused ").concat(r ? ",type to refine list" : "", ", press Down to open the menu, ").concat(n ? " press left to focus selected values" : "");
      case "value":
        return "Use left and right to toggle between focused values, press Backspace to remove the currently focused value";
      default:
        return "";
    }
  },
  onChange: function(t) {
    var r = t.action, n = t.label, a = n === void 0 ? "" : n, i = t.isDisabled;
    switch (r) {
      case "deselect-option":
      case "pop-value":
      case "remove-value":
        return "option ".concat(a, ", deselected.");
      case "select-option":
        return i ? "option ".concat(a, " is disabled. Select another option.") : "option ".concat(a, ", selected.");
      default:
        return "";
    }
  },
  onFocus: function(t) {
    var r = t.context, n = t.focused, a = n === void 0 ? {} : n, i = t.options, o = t.label, u = o === void 0 ? "" : o, s = t.selectValue, c = t.isDisabled, l = t.isSelected, f = function(v, g) {
      return v && v.length ? "".concat(v.indexOf(g) + 1, " of ").concat(v.length) : "";
    };
    if (r === "value" && s)
      return "value ".concat(u, " focused, ").concat(f(s, a), ".");
    if (r === "menu") {
      var d = c ? " disabled" : "", p = "".concat(l ? "selected" : "focused").concat(d);
      return "option ".concat(u, " ").concat(p, ", ").concat(f(i, a), ".");
    }
    return "";
  },
  onFilter: function(t) {
    var r = t.inputValue, n = t.resultsMessage;
    return "".concat(n).concat(r ? " for search term " + r : "", ".");
  }
}, BP = function(t) {
  var r = t.ariaSelection, n = t.focusedOption, a = t.focusedValue, i = t.focusableOptions, o = t.isFocused, u = t.selectValue, s = t.selectProps, c = s.ariaLiveMessages, l = s.getOptionLabel, f = s.inputValue, d = s.isMulti, p = s.isOptionDisabled, h = s.isSearchable, v = s.menuIsOpen, g = s.options, b = s.screenReaderStatus, x = s.tabSelectsValue, w = s["aria-label"], y = s["aria-live"], m = Lr(function() {
    return _t(_t({}, LP), c || {});
  }, [c]), C = Lr(function() {
    var T = "";
    if (r && m.onChange) {
      var M = r.option, I = r.removedValue, G = r.value, Y = function(re) {
        return Array.isArray(re) ? null : re;
      }, L = I || M || Y(G), X = _t({
        isDisabled: L && p(L),
        label: L ? l(L) : ""
      }, r);
      T = m.onChange(X);
    }
    return T;
  }, [r, p, l, m]), O = Lr(function() {
    var T = "", M = n || a, I = !!(n && u && u.includes(n));
    if (M && m.onFocus) {
      var G = {
        focused: M,
        label: l(M),
        isDisabled: p(M),
        isSelected: I,
        options: g,
        context: M === n ? "menu" : "value",
        selectValue: u
      };
      T = m.onFocus(G);
    }
    return T;
  }, [n, a, l, p, m, g, u]), S = Lr(function() {
    var T = "";
    if (v && g.length && m.onFilter) {
      var M = b({
        count: i.length
      });
      T = m.onFilter({
        inputValue: f,
        resultsMessage: M
      });
    }
    return T;
  }, [i, f, v, m, g, b]), A = Lr(function() {
    var T = "";
    if (m.guidance) {
      var M = a ? "value" : v ? "menu" : "input";
      T = m.guidance({
        "aria-label": w,
        context: M,
        isDisabled: n && p(n),
        isMulti: d,
        isSearchable: h,
        tabSelectsValue: x
      });
    }
    return T;
  }, [w, n, a, d, p, h, v, m, x]), P = "".concat(O, " ").concat(S, " ").concat(A);
  return ge(kP, {
    "aria-live": y,
    "aria-atomic": "false",
    "aria-relevant": "additions text"
  }, o && ge(N.Fragment, null, ge("span", {
    id: "aria-selection"
  }, C), ge("span", {
    id: "aria-context"
  }, P)));
}, Yf = [{
  base: "A",
  letters: "AⒶＡÀÁÂẦẤẪẨÃĀĂẰẮẴẲȦǠÄǞẢÅǺǍȀȂẠẬẶḀĄȺⱯ"
}, {
  base: "AA",
  letters: "Ꜳ"
}, {
  base: "AE",
  letters: "ÆǼǢ"
}, {
  base: "AO",
  letters: "Ꜵ"
}, {
  base: "AU",
  letters: "Ꜷ"
}, {
  base: "AV",
  letters: "ꜸꜺ"
}, {
  base: "AY",
  letters: "Ꜽ"
}, {
  base: "B",
  letters: "BⒷＢḂḄḆɃƂƁ"
}, {
  base: "C",
  letters: "CⒸＣĆĈĊČÇḈƇȻꜾ"
}, {
  base: "D",
  letters: "DⒹＤḊĎḌḐḒḎĐƋƊƉꝹ"
}, {
  base: "DZ",
  letters: "ǱǄ"
}, {
  base: "Dz",
  letters: "ǲǅ"
}, {
  base: "E",
  letters: "EⒺＥÈÉÊỀẾỄỂẼĒḔḖĔĖËẺĚȄȆẸỆȨḜĘḘḚƐƎ"
}, {
  base: "F",
  letters: "FⒻＦḞƑꝻ"
}, {
  base: "G",
  letters: "GⒼＧǴĜḠĞĠǦĢǤƓꞠꝽꝾ"
}, {
  base: "H",
  letters: "HⒽＨĤḢḦȞḤḨḪĦⱧⱵꞍ"
}, {
  base: "I",
  letters: "IⒾＩÌÍÎĨĪĬİÏḮỈǏȈȊỊĮḬƗ"
}, {
  base: "J",
  letters: "JⒿＪĴɈ"
}, {
  base: "K",
  letters: "KⓀＫḰǨḲĶḴƘⱩꝀꝂꝄꞢ"
}, {
  base: "L",
  letters: "LⓁＬĿĹĽḶḸĻḼḺŁȽⱢⱠꝈꝆꞀ"
}, {
  base: "LJ",
  letters: "Ǉ"
}, {
  base: "Lj",
  letters: "ǈ"
}, {
  base: "M",
  letters: "MⓂＭḾṀṂⱮƜ"
}, {
  base: "N",
  letters: "NⓃＮǸŃÑṄŇṆŅṊṈȠƝꞐꞤ"
}, {
  base: "NJ",
  letters: "Ǌ"
}, {
  base: "Nj",
  letters: "ǋ"
}, {
  base: "O",
  letters: "OⓄＯÒÓÔỒỐỖỔÕṌȬṎŌṐṒŎȮȰÖȪỎŐǑȌȎƠỜỚỠỞỢỌỘǪǬØǾƆƟꝊꝌ"
}, {
  base: "OI",
  letters: "Ƣ"
}, {
  base: "OO",
  letters: "Ꝏ"
}, {
  base: "OU",
  letters: "Ȣ"
}, {
  base: "P",
  letters: "PⓅＰṔṖƤⱣꝐꝒꝔ"
}, {
  base: "Q",
  letters: "QⓆＱꝖꝘɊ"
}, {
  base: "R",
  letters: "RⓇＲŔṘŘȐȒṚṜŖṞɌⱤꝚꞦꞂ"
}, {
  base: "S",
  letters: "SⓈＳẞŚṤŜṠŠṦṢṨȘŞⱾꞨꞄ"
}, {
  base: "T",
  letters: "TⓉＴṪŤṬȚŢṰṮŦƬƮȾꞆ"
}, {
  base: "TZ",
  letters: "Ꜩ"
}, {
  base: "U",
  letters: "UⓊＵÙÚÛŨṸŪṺŬÜǛǗǕǙỦŮŰǓȔȖƯỪỨỮỬỰỤṲŲṶṴɄ"
}, {
  base: "V",
  letters: "VⓋＶṼṾƲꝞɅ"
}, {
  base: "VY",
  letters: "Ꝡ"
}, {
  base: "W",
  letters: "WⓌＷẀẂŴẆẄẈⱲ"
}, {
  base: "X",
  letters: "XⓍＸẊẌ"
}, {
  base: "Y",
  letters: "YⓎＹỲÝŶỸȲẎŸỶỴƳɎỾ"
}, {
  base: "Z",
  letters: "ZⓏＺŹẐŻŽẒẔƵȤⱿⱫꝢ"
}, {
  base: "a",
  letters: "aⓐａẚàáâầấẫẩãāăằắẵẳȧǡäǟảåǻǎȁȃạậặḁąⱥɐ"
}, {
  base: "aa",
  letters: "ꜳ"
}, {
  base: "ae",
  letters: "æǽǣ"
}, {
  base: "ao",
  letters: "ꜵ"
}, {
  base: "au",
  letters: "ꜷ"
}, {
  base: "av",
  letters: "ꜹꜻ"
}, {
  base: "ay",
  letters: "ꜽ"
}, {
  base: "b",
  letters: "bⓑｂḃḅḇƀƃɓ"
}, {
  base: "c",
  letters: "cⓒｃćĉċčçḉƈȼꜿↄ"
}, {
  base: "d",
  letters: "dⓓｄḋďḍḑḓḏđƌɖɗꝺ"
}, {
  base: "dz",
  letters: "ǳǆ"
}, {
  base: "e",
  letters: "eⓔｅèéêềếễểẽēḕḗĕėëẻěȅȇẹệȩḝęḙḛɇɛǝ"
}, {
  base: "f",
  letters: "fⓕｆḟƒꝼ"
}, {
  base: "g",
  letters: "gⓖｇǵĝḡğġǧģǥɠꞡᵹꝿ"
}, {
  base: "h",
  letters: "hⓗｈĥḣḧȟḥḩḫẖħⱨⱶɥ"
}, {
  base: "hv",
  letters: "ƕ"
}, {
  base: "i",
  letters: "iⓘｉìíîĩīĭïḯỉǐȉȋịįḭɨı"
}, {
  base: "j",
  letters: "jⓙｊĵǰɉ"
}, {
  base: "k",
  letters: "kⓚｋḱǩḳķḵƙⱪꝁꝃꝅꞣ"
}, {
  base: "l",
  letters: "lⓛｌŀĺľḷḹļḽḻſłƚɫⱡꝉꞁꝇ"
}, {
  base: "lj",
  letters: "ǉ"
}, {
  base: "m",
  letters: "mⓜｍḿṁṃɱɯ"
}, {
  base: "n",
  letters: "nⓝｎǹńñṅňṇņṋṉƞɲŉꞑꞥ"
}, {
  base: "nj",
  letters: "ǌ"
}, {
  base: "o",
  letters: "oⓞｏòóôồốỗổõṍȭṏōṑṓŏȯȱöȫỏőǒȍȏơờớỡởợọộǫǭøǿɔꝋꝍɵ"
}, {
  base: "oi",
  letters: "ƣ"
}, {
  base: "ou",
  letters: "ȣ"
}, {
  base: "oo",
  letters: "ꝏ"
}, {
  base: "p",
  letters: "pⓟｐṕṗƥᵽꝑꝓꝕ"
}, {
  base: "q",
  letters: "qⓠｑɋꝗꝙ"
}, {
  base: "r",
  letters: "rⓡｒŕṙřȑȓṛṝŗṟɍɽꝛꞧꞃ"
}, {
  base: "s",
  letters: "sⓢｓßśṥŝṡšṧṣṩșşȿꞩꞅẛ"
}, {
  base: "t",
  letters: "tⓣｔṫẗťṭțţṱṯŧƭʈⱦꞇ"
}, {
  base: "tz",
  letters: "ꜩ"
}, {
  base: "u",
  letters: "uⓤｕùúûũṹūṻŭüǜǘǖǚủůűǔȕȗưừứữửựụṳųṷṵʉ"
}, {
  base: "v",
  letters: "vⓥｖṽṿʋꝟʌ"
}, {
  base: "vy",
  letters: "ꝡ"
}, {
  base: "w",
  letters: "wⓦｗẁẃŵẇẅẘẉⱳ"
}, {
  base: "x",
  letters: "xⓧｘẋẍ"
}, {
  base: "y",
  letters: "yⓨｙỳýŷỹȳẏÿỷẙỵƴɏỿ"
}, {
  base: "z",
  letters: "zⓩｚźẑżžẓẕƶȥɀⱬꝣ"
}], VP = new RegExp("[" + Yf.map(function(e) {
  return e.letters;
}).join("") + "]", "g"), a3 = {};
for (var Ml = 0; Ml < Yf.length; Ml++)
  for (var jl = Yf[Ml], Rl = 0; Rl < jl.letters.length; Rl++)
    a3[jl.letters[Rl]] = jl.base;
var i3 = function(t) {
  return t.replace(VP, function(r) {
    return a3[r];
  });
}, WP = $P(i3), H0 = function(t) {
  return t.replace(/^\s+|\s+$/g, "");
}, GP = function(t) {
  return "".concat(t.label, " ").concat(t.value);
}, HP = function(t) {
  return function(r, n) {
    var a = _t({
      ignoreCase: !0,
      ignoreAccents: !0,
      stringify: GP,
      trim: !0,
      matchFrom: "any"
    }, t), i = a.ignoreCase, o = a.ignoreAccents, u = a.stringify, s = a.trim, c = a.matchFrom, l = s ? H0(n) : n, f = s ? H0(u(r)) : u(r);
    return i && (l = l.toLowerCase(), f = f.toLowerCase()), o && (l = WP(l), f = i3(f)), c === "start" ? f.substr(0, l.length) === l : f.indexOf(l) > -1;
  };
};
function UP(e) {
  e.in, e.out, e.onExited, e.appear, e.enter, e.exit;
  var t = e.innerRef;
  e.emotion;
  var r = ni(e, ["in", "out", "onExited", "appear", "enter", "exit", "innerRef", "emotion"]);
  return ge("input", ye({
    ref: t
  }, r, {
    css: /* @__PURE__ */ Z1({
      label: "dummyInput",
      // get rid of any default styles
      background: 0,
      border: 0,
      fontSize: "inherit",
      outline: 0,
      padding: 0,
      // important! without `width` browsers won't allow focus
      width: 1,
      // remove cursor on desktop
      color: "transparent",
      // remove cursor on mobile whilst maintaining "scroll into view" behaviour
      left: -100,
      opacity: 0,
      position: "relative",
      transform: "scale(0)"
    }, process.env.NODE_ENV === "production" ? "" : ";label:DummyInput;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkR1bW15SW5wdXQuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBbUJNIiwiZmlsZSI6IkR1bW15SW5wdXQuanMiLCJzb3VyY2VzQ29udGVudCI6WyIvLyBAZmxvd1xuLyoqIEBqc3gganN4ICovXG5pbXBvcnQgeyBqc3ggfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIER1bW15SW5wdXQoe1xuICBpbjogaW5Qcm9wLFxuICBvdXQsXG4gIG9uRXhpdGVkLFxuICBhcHBlYXIsXG4gIGVudGVyLFxuICBleGl0LFxuICBpbm5lclJlZixcbiAgZW1vdGlvbixcbiAgLi4ucHJvcHNcbn06IGFueSkge1xuICByZXR1cm4gKFxuICAgIDxpbnB1dFxuICAgICAgcmVmPXtpbm5lclJlZn1cbiAgICAgIHsuLi5wcm9wc31cbiAgICAgIGNzcz17e1xuICAgICAgICBsYWJlbDogJ2R1bW15SW5wdXQnLFxuICAgICAgICAvLyBnZXQgcmlkIG9mIGFueSBkZWZhdWx0IHN0eWxlc1xuICAgICAgICBiYWNrZ3JvdW5kOiAwLFxuICAgICAgICBib3JkZXI6IDAsXG4gICAgICAgIGZvbnRTaXplOiAnaW5oZXJpdCcsXG4gICAgICAgIG91dGxpbmU6IDAsXG4gICAgICAgIHBhZGRpbmc6IDAsXG4gICAgICAgIC8vIGltcG9ydGFudCEgd2l0aG91dCBgd2lkdGhgIGJyb3dzZXJzIHdvbid0IGFsbG93IGZvY3VzXG4gICAgICAgIHdpZHRoOiAxLFxuXG4gICAgICAgIC8vIHJlbW92ZSBjdXJzb3Igb24gZGVza3RvcFxuICAgICAgICBjb2xvcjogJ3RyYW5zcGFyZW50JyxcblxuICAgICAgICAvLyByZW1vdmUgY3Vyc29yIG9uIG1vYmlsZSB3aGlsc3QgbWFpbnRhaW5pbmcgXCJzY3JvbGwgaW50byB2aWV3XCIgYmVoYXZpb3VyXG4gICAgICAgIGxlZnQ6IC0xMDAsXG4gICAgICAgIG9wYWNpdHk6IDAsXG4gICAgICAgIHBvc2l0aW9uOiAncmVsYXRpdmUnLFxuICAgICAgICB0cmFuc2Zvcm06ICdzY2FsZSgwKScsXG4gICAgICB9fVxuICAgIC8+XG4gICk7XG59XG4iXX0= */")
  }));
}
var zP = function(t) {
  t.preventDefault(), t.stopPropagation();
};
function YP(e) {
  var t = e.isEnabled, r = e.onBottomArrive, n = e.onBottomLeave, a = e.onTopArrive, i = e.onTopLeave, o = mr(!1), u = mr(!1), s = mr(0), c = mr(null), l = kr(function(g, b) {
    if (c.current !== null) {
      var x = c.current, w = x.scrollTop, y = x.scrollHeight, m = x.clientHeight, C = c.current, O = b > 0, S = y - m - w, A = !1;
      S > b && o.current && (n && n(g), o.current = !1), O && u.current && (i && i(g), u.current = !1), O && b > S ? (r && !o.current && r(g), C.scrollTop = y, A = !0, o.current = !0) : !O && -b > w && (a && !u.current && a(g), C.scrollTop = 0, A = !0, u.current = !0), A && zP(g);
    }
  }, []), f = kr(function(g) {
    l(g, g.deltaY);
  }, [l]), d = kr(function(g) {
    s.current = g.changedTouches[0].clientY;
  }, []), p = kr(function(g) {
    var b = s.current - g.changedTouches[0].clientY;
    l(g, b);
  }, [l]), h = kr(function(g) {
    if (g) {
      var b = RI ? {
        passive: !1
      } : !1;
      typeof g.addEventListener == "function" && g.addEventListener("wheel", f, b), typeof g.addEventListener == "function" && g.addEventListener("touchstart", d, b), typeof g.addEventListener == "function" && g.addEventListener("touchmove", p, b);
    }
  }, [p, d, f]), v = kr(function(g) {
    g && (typeof g.removeEventListener == "function" && g.removeEventListener("wheel", f, !1), typeof g.removeEventListener == "function" && g.removeEventListener("touchstart", d, !1), typeof g.removeEventListener == "function" && g.removeEventListener("touchmove", p, !1));
  }, [p, d, f]);
  return Xa(function() {
    if (t) {
      var g = c.current;
      return h(g), function() {
        v(g);
      };
    }
  }, [t, h, v]), function(g) {
    c.current = g;
  };
}
var U0 = ["boxSizing", "height", "overflow", "paddingRight", "position"], z0 = {
  boxSizing: "border-box",
  // account for possible declaration `width: 100%;` on body
  overflow: "hidden",
  position: "relative",
  height: "100%"
};
function Y0(e) {
  e.preventDefault();
}
function X0(e) {
  e.stopPropagation();
}
function Z0() {
  var e = this.scrollTop, t = this.scrollHeight, r = e + this.offsetHeight;
  e === 0 ? this.scrollTop = 1 : r === t && (this.scrollTop = e - 1);
}
function K0() {
  return "ontouchstart" in window || navigator.maxTouchPoints;
}
var q0 = !!(typeof window < "u" && window.document && window.document.createElement), Ei = 0, ua = {
  capture: !1,
  passive: !1
};
function XP(e) {
  var t = e.isEnabled, r = e.accountForScrollbars, n = r === void 0 ? !0 : r, a = mr({}), i = mr(null), o = kr(function(s) {
    if (q0) {
      var c = document.body, l = c && c.style;
      if (n && U0.forEach(function(h) {
        var v = l && l[h];
        a.current[h] = v;
      }), n && Ei < 1) {
        var f = parseInt(a.current.paddingRight, 10) || 0, d = document.body ? document.body.clientWidth : 0, p = window.innerWidth - d + f || 0;
        Object.keys(z0).forEach(function(h) {
          var v = z0[h];
          l && (l[h] = v);
        }), l && (l.paddingRight = "".concat(p, "px"));
      }
      c && K0() && (c.addEventListener("touchmove", Y0, ua), s && (s.addEventListener("touchstart", Z0, ua), s.addEventListener("touchmove", X0, ua))), Ei += 1;
    }
  }, []), u = kr(function(s) {
    if (q0) {
      var c = document.body, l = c && c.style;
      Ei = Math.max(Ei - 1, 0), n && Ei < 1 && U0.forEach(function(f) {
        var d = a.current[f];
        l && (l[f] = d);
      }), c && K0() && (c.removeEventListener("touchmove", Y0, ua), s && (s.removeEventListener("touchstart", Z0, ua), s.removeEventListener("touchmove", X0, ua)));
    }
  }, []);
  return Xa(function() {
    if (t) {
      var s = i.current;
      return o(s), function() {
        u(s);
      };
    }
  }, [t, o, u]), function(s) {
    i.current = s;
  };
}
function ZP() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var KP = function() {
  return document.activeElement && document.activeElement.blur();
}, qP = process.env.NODE_ENV === "production" ? {
  name: "1kfdb0e",
  styles: "position:fixed;left:0;bottom:0;right:0;top:0"
} : {
  name: "bp8cua-ScrollManager",
  styles: "position:fixed;left:0;bottom:0;right:0;top:0;label:ScrollManager;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: ZP
};
function JP(e) {
  var t = e.children, r = e.lockEnabled, n = e.captureEnabled, a = n === void 0 ? !0 : n, i = e.onBottomArrive, o = e.onBottomLeave, u = e.onTopArrive, s = e.onTopLeave, c = YP({
    isEnabled: a,
    onBottomArrive: i,
    onBottomLeave: o,
    onTopArrive: u,
    onTopLeave: s
  }), l = XP({
    isEnabled: r
  }), f = function(p) {
    c(p), l(p);
  };
  return ge(N.Fragment, null, r && ge("div", {
    onClick: KP,
    css: qP
  }), t(f));
}
var QP = function(t) {
  return t.label;
}, eT = function(t) {
  return t.label;
}, tT = function(t) {
  return t.value;
}, rT = function(t) {
  return !!t.isDisabled;
}, nT = {
  clearIndicator: eP,
  container: HI,
  control: oP,
  dropdownIndicator: JI,
  group: sP,
  groupHeading: lP,
  indicatorsContainer: XI,
  indicatorSeparator: rP,
  input: dP,
  loadingIndicator: iP,
  loadingMessage: VI,
  menu: FI,
  menuList: kI,
  menuPortal: WI,
  multiValue: vP,
  multiValueLabel: gP,
  multiValueRemove: mP,
  noOptionsMessage: BI,
  option: CP,
  placeholder: OP,
  singleValue: AP,
  valueContainer: zI
}, aT = {
  primary: "#2684FF",
  primary75: "#4C9AFF",
  primary50: "#B2D4FF",
  primary25: "#DEEBFF",
  danger: "#DE350B",
  dangerLight: "#FFBDAD",
  neutral0: "hsl(0, 0%, 100%)",
  neutral5: "hsl(0, 0%, 95%)",
  neutral10: "hsl(0, 0%, 90%)",
  neutral20: "hsl(0, 0%, 80%)",
  neutral30: "hsl(0, 0%, 70%)",
  neutral40: "hsl(0, 0%, 60%)",
  neutral50: "hsl(0, 0%, 50%)",
  neutral60: "hsl(0, 0%, 40%)",
  neutral70: "hsl(0, 0%, 30%)",
  neutral80: "hsl(0, 0%, 20%)",
  neutral90: "hsl(0, 0%, 10%)"
}, iT = 4, o3 = 4, oT = 38, uT = o3 * 2, sT = {
  baseUnit: o3,
  controlHeight: oT,
  menuGutter: uT
}, Nl = {
  borderRadius: iT,
  colors: aT,
  spacing: sT
}, cT = {
  "aria-live": "polite",
  backspaceRemovesValue: !0,
  blurInputOnSelect: V0(),
  captureMenuScroll: !V0(),
  closeMenuOnSelect: !0,
  closeMenuOnScroll: !1,
  components: {},
  controlShouldRenderValue: !0,
  escapeClearsValue: !1,
  filterOption: HP(),
  formatGroupLabel: QP,
  getOptionLabel: eT,
  getOptionValue: tT,
  isDisabled: !1,
  isLoading: !1,
  isMulti: !1,
  isRtl: !1,
  isSearchable: !0,
  isOptionDisabled: rT,
  loadingMessage: function() {
    return "Loading...";
  },
  maxMenuHeight: 300,
  minMenuHeight: 140,
  menuIsOpen: !1,
  menuPlacement: "bottom",
  menuPosition: "absolute",
  menuShouldBlockScroll: !1,
  menuShouldScrollIntoView: !MI(),
  noOptionsMessage: function() {
    return "No options";
  },
  openMenuOnFocus: !1,
  openMenuOnClick: !0,
  options: [],
  pageSize: 5,
  placeholder: "Select...",
  screenReaderStatus: function(t) {
    var r = t.count;
    return "".concat(r, " result").concat(r !== 1 ? "s" : "", " available");
  },
  styles: {},
  tabIndex: "0",
  tabSelectsValue: !0
};
function J0(e, t, r, n) {
  var a = l3(e, t, r), i = f3(e, t, r), o = c3(e, t), u = Ju(e, t);
  return {
    type: "option",
    data: t,
    isDisabled: a,
    isSelected: i,
    label: o,
    value: u,
    index: n
  };
}
function u3(e, t) {
  return e.options.map(function(r, n) {
    if (r.options) {
      var a = r.options.map(function(o, u) {
        return J0(e, o, t, u);
      }).filter(function(o) {
        return Q0(e, o);
      });
      return a.length > 0 ? {
        type: "group",
        data: r,
        options: a,
        index: n
      } : void 0;
    }
    var i = J0(e, r, t, n);
    return Q0(e, i) ? i : void 0;
  }).filter(function(r) {
    return !!r;
  });
}
function s3(e) {
  return e.reduce(function(t, r) {
    return r.type === "group" ? t.push.apply(t, n3(r.options.map(function(n) {
      return n.data;
    }))) : t.push(r.data), t;
  }, []);
}
function lT(e, t) {
  return s3(u3(e, t));
}
function Q0(e, t) {
  var r = e.inputValue, n = r === void 0 ? "" : r, a = t.data, i = t.isSelected, o = t.label, u = t.value;
  return (!p3(e) || !i) && d3(e, {
    label: o,
    value: u,
    data: a
  }, n);
}
function fT(e, t) {
  var r = e.focusedValue, n = e.selectValue, a = n.indexOf(r);
  if (a > -1) {
    var i = t.indexOf(r);
    if (i > -1)
      return r;
    if (a < t.length)
      return t[a];
  }
  return null;
}
function dT(e, t) {
  var r = e.focusedOption;
  return r && t.indexOf(r) > -1 ? r : t[0];
}
var c3 = function(t, r) {
  return t.getOptionLabel(r);
}, Ju = function(t, r) {
  return t.getOptionValue(r);
};
function l3(e, t, r) {
  return typeof e.isOptionDisabled == "function" ? e.isOptionDisabled(t, r) : !1;
}
function f3(e, t, r) {
  if (r.indexOf(t) > -1) return !0;
  if (typeof e.isOptionSelected == "function")
    return e.isOptionSelected(t, r);
  var n = Ju(e, t);
  return r.some(function(a) {
    return Ju(e, a) === n;
  });
}
function d3(e, t, r) {
  return e.filterOption ? e.filterOption(t, r) : !0;
}
var p3 = function(t) {
  var r = t.hideSelectedOptions, n = t.isMulti;
  return r === void 0 ? n : r;
}, pT = 1, h3 = /* @__PURE__ */ function(e) {
  fc(r, e);
  var t = dc(r);
  function r(n) {
    var a;
    return cc(this, r), a = t.call(this, n), a.state = {
      ariaSelection: null,
      focusedOption: null,
      focusedValue: null,
      inputIsHidden: !1,
      isFocused: !1,
      selectValue: [],
      clearFocusValueOnUpdate: !1,
      inputIsHiddenAfterUpdate: void 0,
      prevProps: void 0
    }, a.blockOptionHover = !1, a.isComposing = !1, a.commonProps = void 0, a.initialTouchX = 0, a.initialTouchY = 0, a.instancePrefix = "", a.openAfterFocus = !1, a.scrollToFocusedOptionOnUpdate = !1, a.userIsDragging = void 0, a.controlRef = null, a.getControlRef = function(i) {
      a.controlRef = i;
    }, a.focusedOptionRef = null, a.getFocusedOptionRef = function(i) {
      a.focusedOptionRef = i;
    }, a.menuListRef = null, a.getMenuListRef = function(i) {
      a.menuListRef = i;
    }, a.inputRef = null, a.getInputRef = function(i) {
      a.inputRef = i;
    }, a.focus = a.focusInput, a.blur = a.blurInput, a.onChange = function(i, o) {
      var u = a.props, s = u.onChange, c = u.name;
      o.name = c, a.ariaOnChange(i, o), s(i, o);
    }, a.setValue = function(i) {
      var o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "set-value", u = arguments.length > 2 ? arguments[2] : void 0, s = a.props, c = s.closeMenuOnSelect, l = s.isMulti;
      a.onInputChange("", {
        action: "set-value"
      }), c && (a.setState({
        inputIsHiddenAfterUpdate: !l
      }), a.onMenuClose()), a.setState({
        clearFocusValueOnUpdate: !0
      }), a.onChange(i, {
        action: o,
        option: u
      });
    }, a.selectOption = function(i) {
      var o = a.props, u = o.blurInputOnSelect, s = o.isMulti, c = o.name, l = a.state.selectValue, f = s && a.isOptionSelected(i, l), d = a.isOptionDisabled(i, l);
      if (f) {
        var p = a.getOptionValue(i);
        a.setValue(l.filter(function(h) {
          return a.getOptionValue(h) !== p;
        }), "deselect-option", i);
      } else if (!d)
        s ? a.setValue([].concat(n3(l), [i]), "select-option", i) : a.setValue(i, "select-option");
      else {
        a.ariaOnChange(i, {
          action: "select-option",
          name: c
        });
        return;
      }
      u && a.blurInput();
    }, a.removeValue = function(i) {
      var o = a.props.isMulti, u = a.state.selectValue, s = a.getOptionValue(i), c = u.filter(function(f) {
        return a.getOptionValue(f) !== s;
      }), l = o ? c : c[0] || null;
      a.onChange(l, {
        action: "remove-value",
        removedValue: i
      }), a.focusInput();
    }, a.clearValue = function() {
      var i = a.state.selectValue;
      a.onChange(a.props.isMulti ? [] : null, {
        action: "clear",
        removedValues: i
      });
    }, a.popValue = function() {
      var i = a.props.isMulti, o = a.state.selectValue, u = o[o.length - 1], s = o.slice(0, o.length - 1), c = i ? s : s[0] || null;
      a.onChange(c, {
        action: "pop-value",
        removedValue: u
      });
    }, a.getValue = function() {
      return a.state.selectValue;
    }, a.cx = function() {
      for (var i = arguments.length, o = new Array(i), u = 0; u < i; u++)
        o[u] = arguments[u];
      return EI.apply(void 0, [a.props.classNamePrefix].concat(o));
    }, a.getOptionLabel = function(i) {
      return c3(a.props, i);
    }, a.getOptionValue = function(i) {
      return Ju(a.props, i);
    }, a.getStyles = function(i, o) {
      var u = nT[i](o);
      u.boxSizing = "border-box";
      var s = a.props.styles[i];
      return s ? s(u, o) : u;
    }, a.getElementId = function(i) {
      return "".concat(a.instancePrefix, "-").concat(i);
    }, a.getComponents = function() {
      return IP(a.props);
    }, a.buildCategorizedOptions = function() {
      return u3(a.props, a.state.selectValue);
    }, a.getCategorizedOptions = function() {
      return a.props.menuIsOpen ? a.buildCategorizedOptions() : [];
    }, a.buildFocusableOptions = function() {
      return s3(a.buildCategorizedOptions());
    }, a.getFocusableOptions = function() {
      return a.props.menuIsOpen ? a.buildFocusableOptions() : [];
    }, a.ariaOnChange = function(i, o) {
      a.setState({
        ariaSelection: _t({
          value: i
        }, o)
      });
    }, a.onMenuMouseDown = function(i) {
      i.button === 0 && (i.stopPropagation(), i.preventDefault(), a.focusInput());
    }, a.onMenuMouseMove = function(i) {
      a.blockOptionHover = !1;
    }, a.onControlMouseDown = function(i) {
      var o = a.props.openMenuOnClick;
      a.state.isFocused ? a.props.menuIsOpen ? (
        // $FlowFixMe
        i.target.tagName !== "INPUT" && i.target.tagName !== "TEXTAREA" && a.onMenuClose()
      ) : o && a.openMenu("first") : (o && (a.openAfterFocus = !0), a.focusInput()), // $FlowFixMe
      i.target.tagName !== "INPUT" && i.target.tagName !== "TEXTAREA" && i.preventDefault();
    }, a.onDropdownIndicatorMouseDown = function(i) {
      if (!(i && i.type === "mousedown" && i.button !== 0) && !a.props.isDisabled) {
        var o = a.props, u = o.isMulti, s = o.menuIsOpen;
        a.focusInput(), s ? (a.setState({
          inputIsHiddenAfterUpdate: !u
        }), a.onMenuClose()) : a.openMenu("first"), i.preventDefault(), i.stopPropagation();
      }
    }, a.onClearIndicatorMouseDown = function(i) {
      i && i.type === "mousedown" && i.button !== 0 || (a.clearValue(), i.stopPropagation(), a.openAfterFocus = !1, i.type === "touchend" ? a.focusInput() : setTimeout(function() {
        return a.focusInput();
      }));
    }, a.onScroll = function(i) {
      typeof a.props.closeMenuOnScroll == "boolean" ? i.target instanceof HTMLElement && q1(i.target) && a.props.onMenuClose() : typeof a.props.closeMenuOnScroll == "function" && a.props.closeMenuOnScroll(i) && a.props.onMenuClose();
    }, a.onCompositionStart = function() {
      a.isComposing = !0;
    }, a.onCompositionEnd = function() {
      a.isComposing = !1;
    }, a.onTouchStart = function(i) {
      var o = i.touches, u = o && o.item(0);
      u && (a.initialTouchX = u.clientX, a.initialTouchY = u.clientY, a.userIsDragging = !1);
    }, a.onTouchMove = function(i) {
      var o = i.touches, u = o && o.item(0);
      if (u) {
        var s = Math.abs(u.clientX - a.initialTouchX), c = Math.abs(u.clientY - a.initialTouchY), l = 5;
        a.userIsDragging = s > l || c > l;
      }
    }, a.onTouchEnd = function(i) {
      a.userIsDragging || (a.controlRef && !a.controlRef.contains(i.target) && a.menuListRef && !a.menuListRef.contains(i.target) && a.blurInput(), a.initialTouchX = 0, a.initialTouchY = 0);
    }, a.onControlTouchEnd = function(i) {
      a.userIsDragging || a.onControlMouseDown(i);
    }, a.onClearIndicatorTouchEnd = function(i) {
      a.userIsDragging || a.onClearIndicatorMouseDown(i);
    }, a.onDropdownIndicatorTouchEnd = function(i) {
      a.userIsDragging || a.onDropdownIndicatorMouseDown(i);
    }, a.handleInputChange = function(i) {
      var o = i.currentTarget.value;
      a.setState({
        inputIsHiddenAfterUpdate: !1
      }), a.onInputChange(o, {
        action: "input-change"
      }), a.props.menuIsOpen || a.onMenuOpen();
    }, a.onInputFocus = function(i) {
      a.props.onFocus && a.props.onFocus(i), a.setState({
        inputIsHiddenAfterUpdate: !1,
        isFocused: !0
      }), (a.openAfterFocus || a.props.openMenuOnFocus) && a.openMenu("first"), a.openAfterFocus = !1;
    }, a.onInputBlur = function(i) {
      if (a.menuListRef && a.menuListRef.contains(document.activeElement)) {
        a.inputRef.focus();
        return;
      }
      a.props.onBlur && a.props.onBlur(i), a.onInputChange("", {
        action: "input-blur"
      }), a.onMenuClose(), a.setState({
        focusedValue: null,
        isFocused: !1
      });
    }, a.onOptionHover = function(i) {
      a.blockOptionHover || a.state.focusedOption === i || a.setState({
        focusedOption: i
      });
    }, a.shouldHideSelectedOptions = function() {
      return p3(a.props);
    }, a.onKeyDown = function(i) {
      var o = a.props, u = o.isMulti, s = o.backspaceRemovesValue, c = o.escapeClearsValue, l = o.inputValue, f = o.isClearable, d = o.isDisabled, p = o.menuIsOpen, h = o.onKeyDown, v = o.tabSelectsValue, g = o.openMenuOnFocus, b = a.state, x = b.focusedOption, w = b.focusedValue, y = b.selectValue;
      if (!d && !(typeof h == "function" && (h(i), i.defaultPrevented))) {
        switch (a.blockOptionHover = !0, i.key) {
          case "ArrowLeft":
            if (!u || l) return;
            a.focusValue("previous");
            break;
          case "ArrowRight":
            if (!u || l) return;
            a.focusValue("next");
            break;
          case "Delete":
          case "Backspace":
            if (l) return;
            if (w)
              a.removeValue(w);
            else {
              if (!s) return;
              u ? a.popValue() : f && a.clearValue();
            }
            break;
          case "Tab":
            if (a.isComposing || i.shiftKey || !p || !v || !x || // don't capture the event if the menu opens on focus and the focused
            // option is already selected; it breaks the flow of navigation
            g && a.isOptionSelected(x, y))
              return;
            a.selectOption(x);
            break;
          case "Enter":
            if (i.keyCode === 229)
              break;
            if (p) {
              if (!x || a.isComposing) return;
              a.selectOption(x);
              break;
            }
            return;
          case "Escape":
            p ? (a.setState({
              inputIsHiddenAfterUpdate: !1
            }), a.onInputChange("", {
              action: "menu-close"
            }), a.onMenuClose()) : f && c && a.clearValue();
            break;
          case " ":
            if (l)
              return;
            if (!p) {
              a.openMenu("first");
              break;
            }
            if (!x) return;
            a.selectOption(x);
            break;
          case "ArrowUp":
            p ? a.focusOption("up") : a.openMenu("last");
            break;
          case "ArrowDown":
            p ? a.focusOption("down") : a.openMenu("first");
            break;
          case "PageUp":
            if (!p) return;
            a.focusOption("pageup");
            break;
          case "PageDown":
            if (!p) return;
            a.focusOption("pagedown");
            break;
          case "Home":
            if (!p) return;
            a.focusOption("first");
            break;
          case "End":
            if (!p) return;
            a.focusOption("last");
            break;
          default:
            return;
        }
        i.preventDefault();
      }
    }, a.instancePrefix = "react-select-" + (a.props.instanceId || ++pT), a.state.selectValue = B0(n.value), a;
  }
  return lc(r, [{
    key: "componentDidMount",
    value: function() {
      this.startListeningComposition(), this.startListeningToTouch(), this.props.closeMenuOnScroll && document && document.addEventListener && document.addEventListener("scroll", this.onScroll, !0), this.props.autoFocus && this.focusInput();
    }
  }, {
    key: "componentDidUpdate",
    value: function(a) {
      var i = this.props, o = i.isDisabled, u = i.menuIsOpen, s = this.state.isFocused;
      // ensure focus is restored correctly when the control becomes enabled
      (s && !o && a.isDisabled || // ensure focus is on the Input when the menu opens
      s && u && !a.menuIsOpen) && this.focusInput(), s && o && !a.isDisabled && this.setState({
        isFocused: !1
      }, this.onMenuClose), this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate && (PI(this.menuListRef, this.focusedOptionRef), this.scrollToFocusedOptionOnUpdate = !1);
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.stopListeningComposition(), this.stopListeningToTouch(), document.removeEventListener("scroll", this.onScroll, !0);
    }
    // ==============================
    // Consumer Handlers
    // ==============================
  }, {
    key: "onMenuOpen",
    value: function() {
      this.props.onMenuOpen();
    }
  }, {
    key: "onMenuClose",
    value: function() {
      this.onInputChange("", {
        action: "menu-close"
      }), this.props.onMenuClose();
    }
  }, {
    key: "onInputChange",
    value: function(a, i) {
      this.props.onInputChange(a, i);
    }
    // ==============================
    // Methods
    // ==============================
  }, {
    key: "focusInput",
    value: function() {
      this.inputRef && this.inputRef.focus();
    }
  }, {
    key: "blurInput",
    value: function() {
      this.inputRef && this.inputRef.blur();
    }
    // aliased for consumers
  }, {
    key: "openMenu",
    value: function(a) {
      var i = this, o = this.state, u = o.selectValue, s = o.isFocused, c = this.buildFocusableOptions(), l = a === "first" ? 0 : c.length - 1;
      if (!this.props.isMulti) {
        var f = c.indexOf(u[0]);
        f > -1 && (l = f);
      }
      this.scrollToFocusedOptionOnUpdate = !(s && this.menuListRef), this.setState({
        inputIsHiddenAfterUpdate: !1,
        focusedValue: null,
        focusedOption: c[l]
      }, function() {
        return i.onMenuOpen();
      });
    }
  }, {
    key: "focusValue",
    value: function(a) {
      var i = this.state, o = i.selectValue, u = i.focusedValue;
      if (this.props.isMulti) {
        this.setState({
          focusedOption: null
        });
        var s = o.indexOf(u);
        u || (s = -1);
        var c = o.length - 1, l = -1;
        if (o.length) {
          switch (a) {
            case "previous":
              s === 0 ? l = 0 : s === -1 ? l = c : l = s - 1;
              break;
            case "next":
              s > -1 && s < c && (l = s + 1);
              break;
          }
          this.setState({
            inputIsHidden: l !== -1,
            focusedValue: o[l]
          });
        }
      }
    }
  }, {
    key: "focusOption",
    value: function() {
      var a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "first", i = this.props.pageSize, o = this.state.focusedOption, u = this.getFocusableOptions();
      if (u.length) {
        var s = 0, c = u.indexOf(o);
        o || (c = -1), a === "up" ? s = c > 0 ? c - 1 : u.length - 1 : a === "down" ? s = (c + 1) % u.length : a === "pageup" ? (s = c - i, s < 0 && (s = 0)) : a === "pagedown" ? (s = c + i, s > u.length - 1 && (s = u.length - 1)) : a === "last" && (s = u.length - 1), this.scrollToFocusedOptionOnUpdate = !0, this.setState({
          focusedOption: u[s],
          focusedValue: null
        });
      }
    }
  }, {
    key: "getTheme",
    value: (
      // ==============================
      // Getters
      // ==============================
      function() {
        return this.props.theme ? typeof this.props.theme == "function" ? this.props.theme(Nl) : _t(_t({}, Nl), this.props.theme) : Nl;
      }
    )
  }, {
    key: "getCommonProps",
    value: function() {
      var a = this.clearValue, i = this.cx, o = this.getStyles, u = this.getValue, s = this.selectOption, c = this.setValue, l = this.props, f = l.isMulti, d = l.isRtl, p = l.options, h = this.hasValue();
      return {
        clearValue: a,
        cx: i,
        getStyles: o,
        getValue: u,
        hasValue: h,
        isMulti: f,
        isRtl: d,
        options: p,
        selectOption: s,
        selectProps: l,
        setValue: c,
        theme: this.getTheme()
      };
    }
  }, {
    key: "hasValue",
    value: function() {
      var a = this.state.selectValue;
      return a.length > 0;
    }
  }, {
    key: "hasOptions",
    value: function() {
      return !!this.getFocusableOptions().length;
    }
  }, {
    key: "isClearable",
    value: function() {
      var a = this.props, i = a.isClearable, o = a.isMulti;
      return i === void 0 ? o : i;
    }
  }, {
    key: "isOptionDisabled",
    value: function(a, i) {
      return l3(this.props, a, i);
    }
  }, {
    key: "isOptionSelected",
    value: function(a, i) {
      return f3(this.props, a, i);
    }
  }, {
    key: "filterOption",
    value: function(a, i) {
      return d3(this.props, a, i);
    }
  }, {
    key: "formatOptionLabel",
    value: function(a, i) {
      if (typeof this.props.formatOptionLabel == "function") {
        var o = this.props.inputValue, u = this.state.selectValue;
        return this.props.formatOptionLabel(a, {
          context: i,
          inputValue: o,
          selectValue: u
        });
      } else
        return this.getOptionLabel(a);
    }
  }, {
    key: "formatGroupLabel",
    value: function(a) {
      return this.props.formatGroupLabel(a);
    }
    // ==============================
    // Mouse Handlers
    // ==============================
  }, {
    key: "startListeningComposition",
    value: (
      // ==============================
      // Composition Handlers
      // ==============================
      function() {
        document && document.addEventListener && (document.addEventListener("compositionstart", this.onCompositionStart, !1), document.addEventListener("compositionend", this.onCompositionEnd, !1));
      }
    )
  }, {
    key: "stopListeningComposition",
    value: function() {
      document && document.removeEventListener && (document.removeEventListener("compositionstart", this.onCompositionStart), document.removeEventListener("compositionend", this.onCompositionEnd));
    }
  }, {
    key: "startListeningToTouch",
    value: (
      // ==============================
      // Touch Handlers
      // ==============================
      function() {
        document && document.addEventListener && (document.addEventListener("touchstart", this.onTouchStart, !1), document.addEventListener("touchmove", this.onTouchMove, !1), document.addEventListener("touchend", this.onTouchEnd, !1));
      }
    )
  }, {
    key: "stopListeningToTouch",
    value: function() {
      document && document.removeEventListener && (document.removeEventListener("touchstart", this.onTouchStart), document.removeEventListener("touchmove", this.onTouchMove), document.removeEventListener("touchend", this.onTouchEnd));
    }
  }, {
    key: "renderInput",
    value: (
      // ==============================
      // Renderers
      // ==============================
      function() {
        var a = this.props, i = a.isDisabled, o = a.isSearchable, u = a.inputId, s = a.inputValue, c = a.tabIndex, l = a.form, f = this.getComponents(), d = f.Input, p = this.state.inputIsHidden, h = this.commonProps, v = u || this.getElementId("input"), g = {
          "aria-autocomplete": "list",
          "aria-label": this.props["aria-label"],
          "aria-labelledby": this.props["aria-labelledby"]
        };
        return o ? /* @__PURE__ */ N.createElement(d, ye({}, h, {
          autoCapitalize: "none",
          autoComplete: "off",
          autoCorrect: "off",
          id: v,
          innerRef: this.getInputRef,
          isDisabled: i,
          isHidden: p,
          onBlur: this.onInputBlur,
          onChange: this.handleInputChange,
          onFocus: this.onInputFocus,
          spellCheck: "false",
          tabIndex: c,
          form: l,
          type: "text",
          value: s
        }, g)) : /* @__PURE__ */ N.createElement(UP, ye({
          id: v,
          innerRef: this.getInputRef,
          onBlur: this.onInputBlur,
          onChange: Ku,
          onFocus: this.onInputFocus,
          readOnly: !0,
          disabled: i,
          tabIndex: c,
          form: l,
          value: ""
        }, g));
      }
    )
  }, {
    key: "renderPlaceholderOrValue",
    value: function() {
      var a = this, i = this.getComponents(), o = i.MultiValue, u = i.MultiValueContainer, s = i.MultiValueLabel, c = i.MultiValueRemove, l = i.SingleValue, f = i.Placeholder, d = this.commonProps, p = this.props, h = p.controlShouldRenderValue, v = p.isDisabled, g = p.isMulti, b = p.inputValue, x = p.placeholder, w = this.state, y = w.selectValue, m = w.focusedValue, C = w.isFocused;
      if (!this.hasValue() || !h)
        return b ? null : /* @__PURE__ */ N.createElement(f, ye({}, d, {
          key: "placeholder",
          isDisabled: v,
          isFocused: C
        }), x);
      if (g) {
        var O = y.map(function(A, P) {
          var T = A === m;
          return /* @__PURE__ */ N.createElement(o, ye({}, d, {
            components: {
              Container: u,
              Label: s,
              Remove: c
            },
            isFocused: T,
            isDisabled: v,
            key: "".concat(a.getOptionValue(A)).concat(P),
            index: P,
            removeProps: {
              onClick: function() {
                return a.removeValue(A);
              },
              onTouchEnd: function() {
                return a.removeValue(A);
              },
              onMouseDown: function(I) {
                I.preventDefault(), I.stopPropagation();
              }
            },
            data: A
          }), a.formatOptionLabel(A, "value"));
        });
        return O;
      }
      if (b)
        return null;
      var S = y[0];
      return /* @__PURE__ */ N.createElement(l, ye({}, d, {
        data: S,
        isDisabled: v
      }), this.formatOptionLabel(S, "value"));
    }
  }, {
    key: "renderClearIndicator",
    value: function() {
      var a = this.getComponents(), i = a.ClearIndicator, o = this.commonProps, u = this.props, s = u.isDisabled, c = u.isLoading, l = this.state.isFocused;
      if (!this.isClearable() || !i || s || !this.hasValue() || c)
        return null;
      var f = {
        onMouseDown: this.onClearIndicatorMouseDown,
        onTouchEnd: this.onClearIndicatorTouchEnd,
        "aria-hidden": "true"
      };
      return /* @__PURE__ */ N.createElement(i, ye({}, o, {
        innerProps: f,
        isFocused: l
      }));
    }
  }, {
    key: "renderLoadingIndicator",
    value: function() {
      var a = this.getComponents(), i = a.LoadingIndicator, o = this.commonProps, u = this.props, s = u.isDisabled, c = u.isLoading, l = this.state.isFocused;
      if (!i || !c) return null;
      var f = {
        "aria-hidden": "true"
      };
      return /* @__PURE__ */ N.createElement(i, ye({}, o, {
        innerProps: f,
        isDisabled: s,
        isFocused: l
      }));
    }
  }, {
    key: "renderIndicatorSeparator",
    value: function() {
      var a = this.getComponents(), i = a.DropdownIndicator, o = a.IndicatorSeparator;
      if (!i || !o) return null;
      var u = this.commonProps, s = this.props.isDisabled, c = this.state.isFocused;
      return /* @__PURE__ */ N.createElement(o, ye({}, u, {
        isDisabled: s,
        isFocused: c
      }));
    }
  }, {
    key: "renderDropdownIndicator",
    value: function() {
      var a = this.getComponents(), i = a.DropdownIndicator;
      if (!i) return null;
      var o = this.commonProps, u = this.props.isDisabled, s = this.state.isFocused, c = {
        onMouseDown: this.onDropdownIndicatorMouseDown,
        onTouchEnd: this.onDropdownIndicatorTouchEnd,
        "aria-hidden": "true"
      };
      return /* @__PURE__ */ N.createElement(i, ye({}, o, {
        innerProps: c,
        isDisabled: u,
        isFocused: s
      }));
    }
  }, {
    key: "renderMenu",
    value: function() {
      var a = this, i = this.getComponents(), o = i.Group, u = i.GroupHeading, s = i.Menu, c = i.MenuList, l = i.MenuPortal, f = i.LoadingMessage, d = i.NoOptionsMessage, p = i.Option, h = this.commonProps, v = this.state.focusedOption, g = this.props, b = g.captureMenuScroll, x = g.inputValue, w = g.isLoading, y = g.loadingMessage, m = g.minMenuHeight, C = g.maxMenuHeight, O = g.menuIsOpen, S = g.menuPlacement, A = g.menuPosition, P = g.menuPortalTarget, T = g.menuShouldBlockScroll, M = g.menuShouldScrollIntoView, I = g.noOptionsMessage, G = g.onMenuScrollToTop, Y = g.onMenuScrollToBottom;
      if (!O) return null;
      var L = function(R, $) {
        var B = R.type, H = R.data, z = R.isDisabled, J = R.isSelected, U = R.label, F = R.value, k = v === H, E = z ? void 0 : function() {
          return a.onOptionHover(H);
        }, K = z ? void 0 : function() {
          return a.selectOption(H);
        }, Z = "".concat(a.getElementId("option"), "-").concat($), Q = {
          id: Z,
          onClick: K,
          onMouseMove: E,
          onMouseOver: E,
          tabIndex: -1
        };
        return /* @__PURE__ */ N.createElement(p, ye({}, h, {
          innerProps: Q,
          data: H,
          isDisabled: z,
          isSelected: J,
          key: Z,
          label: U,
          type: B,
          value: F,
          isFocused: k,
          innerRef: k ? a.getFocusedOptionRef : void 0
        }), a.formatOptionLabel(R.data, "menu"));
      }, X;
      if (this.hasOptions())
        X = this.getCategorizedOptions().map(function(D) {
          if (D.type === "group") {
            var R = D.data, $ = D.options, B = D.index, H = "".concat(a.getElementId("group"), "-").concat(B), z = "".concat(H, "-heading");
            return /* @__PURE__ */ N.createElement(o, ye({}, h, {
              key: H,
              data: R,
              options: $,
              Heading: u,
              headingProps: {
                id: z,
                data: D.data
              },
              label: a.formatGroupLabel(D.data)
            }), D.options.map(function(J) {
              return L(J, "".concat(B, "-").concat(J.index));
            }));
          } else if (D.type === "option")
            return L(D, "".concat(D.index));
        });
      else if (w) {
        var q = y({
          inputValue: x
        });
        if (q === null) return null;
        X = /* @__PURE__ */ N.createElement(f, h, q);
      } else {
        var re = I({
          inputValue: x
        });
        if (re === null) return null;
        X = /* @__PURE__ */ N.createElement(d, h, re);
      }
      var j = {
        minMenuHeight: m,
        maxMenuHeight: C,
        menuPlacement: S,
        menuPosition: A,
        menuShouldScrollIntoView: M
      }, W = /* @__PURE__ */ N.createElement(Yb, ye({}, h, j), function(D) {
        var R = D.ref, $ = D.placerProps, B = $.placement, H = $.maxHeight;
        return /* @__PURE__ */ N.createElement(s, ye({}, h, j, {
          innerRef: R,
          innerProps: {
            onMouseDown: a.onMenuMouseDown,
            onMouseMove: a.onMenuMouseMove
          },
          isLoading: w,
          placement: B
        }), /* @__PURE__ */ N.createElement(JP, {
          captureEnabled: b,
          onTopArrive: G,
          onBottomArrive: Y,
          lockEnabled: T
        }, function(z) {
          return /* @__PURE__ */ N.createElement(c, ye({}, h, {
            innerRef: function(U) {
              a.getMenuListRef(U), z(U);
            },
            isLoading: w,
            maxHeight: H,
            focusedOption: v
          }), X);
        }));
      });
      return P || A === "fixed" ? /* @__PURE__ */ N.createElement(l, ye({}, h, {
        appendTo: P,
        controlElement: this.controlRef,
        menuPlacement: S,
        menuPosition: A
      }), W) : W;
    }
  }, {
    key: "renderFormField",
    value: function() {
      var a = this, i = this.props, o = i.delimiter, u = i.isDisabled, s = i.isMulti, c = i.name, l = this.state.selectValue;
      if (!(!c || u))
        if (s)
          if (o) {
            var f = l.map(function(h) {
              return a.getOptionValue(h);
            }).join(o);
            return /* @__PURE__ */ N.createElement("input", {
              name: c,
              type: "hidden",
              value: f
            });
          } else {
            var d = l.length > 0 ? l.map(function(h, v) {
              return /* @__PURE__ */ N.createElement("input", {
                key: "i-".concat(v),
                name: c,
                type: "hidden",
                value: a.getOptionValue(h)
              });
            }) : /* @__PURE__ */ N.createElement("input", {
              name: c,
              type: "hidden"
            });
            return /* @__PURE__ */ N.createElement("div", null, d);
          }
        else {
          var p = l[0] ? this.getOptionValue(l[0]) : "";
          return /* @__PURE__ */ N.createElement("input", {
            name: c,
            type: "hidden",
            value: p
          });
        }
    }
  }, {
    key: "renderLiveRegion",
    value: function() {
      var a = this.commonProps, i = this.state, o = i.ariaSelection, u = i.focusedOption, s = i.focusedValue, c = i.isFocused, l = i.selectValue, f = this.getFocusableOptions();
      return /* @__PURE__ */ N.createElement(BP, ye({}, a, {
        ariaSelection: o,
        focusedOption: u,
        focusedValue: s,
        isFocused: c,
        selectValue: l,
        focusableOptions: f
      }));
    }
  }, {
    key: "render",
    value: function() {
      var a = this.getComponents(), i = a.Control, o = a.IndicatorsContainer, u = a.SelectContainer, s = a.ValueContainer, c = this.props, l = c.className, f = c.id, d = c.isDisabled, p = c.menuIsOpen, h = this.state.isFocused, v = this.commonProps = this.getCommonProps();
      return /* @__PURE__ */ N.createElement(u, ye({}, v, {
        className: l,
        innerProps: {
          id: f,
          onKeyDown: this.onKeyDown
        },
        isDisabled: d,
        isFocused: h
      }), this.renderLiveRegion(), /* @__PURE__ */ N.createElement(i, ye({}, v, {
        innerRef: this.getControlRef,
        innerProps: {
          onMouseDown: this.onControlMouseDown,
          onTouchEnd: this.onControlTouchEnd
        },
        isDisabled: d,
        isFocused: h,
        menuIsOpen: p
      }), /* @__PURE__ */ N.createElement(s, ye({}, v, {
        isDisabled: d
      }), this.renderPlaceholderOrValue(), this.renderInput()), /* @__PURE__ */ N.createElement(o, ye({}, v, {
        isDisabled: d
      }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(a, i) {
      var o = i.prevProps, u = i.clearFocusValueOnUpdate, s = i.inputIsHiddenAfterUpdate, c = a.options, l = a.value, f = a.menuIsOpen, d = a.inputValue, p = {};
      if (o && (l !== o.value || c !== o.options || f !== o.menuIsOpen || d !== o.inputValue)) {
        var h = B0(l), v = f ? lT(a, h) : [], g = u ? fT(i, h) : null, b = dT(i, v);
        p = {
          selectValue: h,
          focusedOption: b,
          focusedValue: g,
          clearFocusValueOnUpdate: !1
        };
      }
      var x = s != null && a !== o ? {
        inputIsHidden: s,
        inputIsHiddenAfterUpdate: void 0
      } : {};
      return _t(_t(_t({}, p), x), {}, {
        prevProps: a
      });
    }
  }]), r;
}(Za);
h3.defaultProps = cT;
var hT = {
  defaultInputValue: "",
  defaultMenuIsOpen: !1,
  defaultValue: null
}, vT = function(t) {
  var r, n;
  return n = r = /* @__PURE__ */ function(a) {
    fc(o, a);
    var i = dc(o);
    function o() {
      var u;
      cc(this, o);
      for (var s = arguments.length, c = new Array(s), l = 0; l < s; l++)
        c[l] = arguments[l];
      return u = i.call.apply(i, [this].concat(c)), u.select = void 0, u.state = {
        inputValue: u.props.inputValue !== void 0 ? u.props.inputValue : u.props.defaultInputValue,
        menuIsOpen: u.props.menuIsOpen !== void 0 ? u.props.menuIsOpen : u.props.defaultMenuIsOpen,
        value: u.props.value !== void 0 ? u.props.value : u.props.defaultValue
      }, u.onChange = function(f, d) {
        u.callProp("onChange", f, d), u.setState({
          value: f
        });
      }, u.onInputChange = function(f, d) {
        var p = u.callProp("onInputChange", f, d);
        u.setState({
          inputValue: p !== void 0 ? p : f
        });
      }, u.onMenuOpen = function() {
        u.callProp("onMenuOpen"), u.setState({
          menuIsOpen: !0
        });
      }, u.onMenuClose = function() {
        u.callProp("onMenuClose"), u.setState({
          menuIsOpen: !1
        });
      }, u;
    }
    return lc(o, [{
      key: "focus",
      value: function() {
        this.select.focus();
      }
    }, {
      key: "blur",
      value: function() {
        this.select.blur();
      }
      // FIXME: untyped flow code, return any
    }, {
      key: "getProp",
      value: function(s) {
        return this.props[s] !== void 0 ? this.props[s] : this.state[s];
      }
      // FIXME: untyped flow code, return any
    }, {
      key: "callProp",
      value: function(s) {
        if (typeof this.props[s] == "function") {
          for (var c, l = arguments.length, f = new Array(l > 1 ? l - 1 : 0), d = 1; d < l; d++)
            f[d - 1] = arguments[d];
          return (c = this.props)[s].apply(c, f);
        }
      }
    }, {
      key: "render",
      value: function() {
        var s = this, c = this.props;
        c.defaultInputValue, c.defaultMenuIsOpen, c.defaultValue;
        var l = ni(c, ["defaultInputValue", "defaultMenuIsOpen", "defaultValue"]);
        return /* @__PURE__ */ N.createElement(t, ye({}, l, {
          ref: function(d) {
            s.select = d;
          },
          inputValue: this.getProp("inputValue"),
          menuIsOpen: this.getProp("menuIsOpen"),
          onChange: this.onChange,
          onInputChange: this.onInputChange,
          onMenuClose: this.onMenuClose,
          onMenuOpen: this.onMenuOpen,
          value: this.getProp("value")
        }));
      }
    }]), o;
  }(Za), r.defaultProps = hT, n;
}, gT = vT(h3);
const mT = ({
  id: e,
  label: t,
  size: r = "md",
  className: n,
  isDisabled: a,
  children: i
}) => /* @__PURE__ */ _.jsx(
  "div",
  {
    className: He("form-inputs__select", `form-inputs__select--${r}`, {
      [`${n}`]: !!n,
      "form-inputs__select--disabled": a
    }),
    children: /* @__PURE__ */ _.jsxs("label", { htmlFor: e, children: [
      !!t && /* @__PURE__ */ _.jsx("span", { className: "form-inputs__select__label", children: t }),
      /* @__PURE__ */ _.jsxs("div", { className: "position-relative", children: [
        i,
        /* @__PURE__ */ _.jsx(uy, { size: "xs", className: "form-inputs__select__icon" })
      ] })
    ] })
  }
), yT = ({
  id: e,
  value: t,
  error: r,
  options: n,
  name: a,
  dark: i,
  isSearchable: o,
  menuPlacement: u = "bottom",
  onChange: s,
  onBlur: c,
  placeholder: l = "Please select",
  variant: f = "default",
  className: d,
  ...p
}) => {
  const h = {
    value: "placeholder",
    label: l
  }, v = (n == null ? void 0 : n.find((w) => w.value === t)) || h, g = !s, b = (w) => {
    if (s) {
      const y = n.find((m) => m.value.toString() === w);
      y && s(y.value);
    }
  }, x = () => {
    if (g)
      return /* @__PURE__ */ _.jsx("option", { value: v.value, children: v.label }, v.value);
    const w = [];
    return l && !t && w.push(
      /* @__PURE__ */ _.jsx(
        "option",
        {
          value: h.value,
          disabled: !0,
          hidden: !0,
          children: h.label
        },
        h.value
      )
    ), n == null || n.forEach((y) => {
      w.push(
        /* @__PURE__ */ _.jsx("option", { value: y.value, children: y.label }, y.value)
      );
    }), w;
  };
  return o ? /* @__PURE__ */ _.jsx(
    gT,
    {
      className: He("form-inputs__select__select", {
        [`${d}`]: !!d,
        "form-inputs__select--error": r,
        "form-inputs__select--dark": i,
        "form-inputs__select--menu-top": u === "top",
        "form-inputs__select--disabled": g
      }),
      classNamePrefix: "form-inputs__select",
      isSearchable: !0,
      menuPlacement: u,
      placeholder: "Please select",
      options: n,
      value: v,
      onChange: (w) => s && w && s(w.value),
      onBlur: c,
      styles: {
        control: (w) => ({
          ...w,
          "&:hover": {}
          // Clear default hover styles
        })
      },
      ...p
    }
  ) : /* @__PURE__ */ _.jsx(
    mT,
    {
      id: e,
      className: d,
      ...p,
      isDisabled: g,
      children: /* @__PURE__ */ _.jsx(
        "select",
        {
          id: e,
          className: He("form-inputs__select__select", {
            "form-inputs__select__select--dark": i,
            "form-inputs__select__select--error": r,
            "form-inputs__select__select--link": f === "link"
          }),
          value: v.value,
          onChange: (w) => b(w.target.value),
          onBlur: c,
          disabled: g,
          name: a,
          children: x()
        }
      )
    }
  );
}, Fre = {
  value: "all",
  label: "All"
}, Dre = ({ className: e, label: t, ...r }) => /* @__PURE__ */ _.jsxs("label", { className: He("switch", { [`${e}`]: !!e }), htmlFor: r.id, children: [
  /* @__PURE__ */ _.jsx("span", { className: "switch-label", children: t }),
  /* @__PURE__ */ _.jsxs("div", { className: "switch-box", children: [
    /* @__PURE__ */ _.jsx("input", { type: "checkbox", ...r }),
    /* @__PURE__ */ _.jsx("span", { className: "slider round" })
  ] })
] }), bT = N.forwardRef(
  ({ className: e = "", error: t, disabled: r, dark: n, ...a }, i) => /* @__PURE__ */ _.jsx(
    "textarea",
    {
      className: He("input-textarea__element", {
        [`${e}`]: !!e,
        "input-textarea__element--error": !!t,
        "input-textarea__element--disabled": !!r,
        "input-textarea__element--dark": n
      }),
      disabled: r,
      type: "text",
      ref: i,
      ...a
    }
  )
);
bT.displayName = "TextAreaInput";
const v3 = N.forwardRef(
  ({
    className: e = "",
    dark: t,
    error: r,
    disabled: n,
    autoComplete: a,
    ...i
  }, o) => /* @__PURE__ */ _.jsx(
    "input",
    {
      className: He(`input-text__element ${e}`, {
        "input-text__element--error": r,
        "input-text__element--disabled": n,
        "input-text__element--dark": t
      }),
      disabled: n,
      autoComplete: a,
      type: "text",
      ref: o,
      ...i
    }
  )
);
v3.displayName = "TextInput";
const lr = (e) => {
  const {
    label: t,
    error: r,
    showErrorLabel: n = !0,
    tooltip: a,
    tooltipLabel: i,
    children: o,
    labelSize: u = "md",
    className: s = "",
    action: c,
    htmlFor: l,
    hidden: f,
    dark: d = !1,
    ...p
  } = e, [h, v] = gn(
    null
  ), g = n && r;
  return /* @__PURE__ */ _.jsxs(
    "span",
    {
      className: He("input-wrapper__wrapper", {
        [`${s}`]: s,
        "input-wrapper--hidden": f,
        "input-wrapper--save-error-space": n,
        "input-wrapper--has-error": g,
        "input-wrapper--dark": d
      }),
      ...p,
      children: [
        t && /* @__PURE__ */ _.jsxs("div", { className: "input-wrapper__label", children: [
          /* @__PURE__ */ _.jsx(
            "label",
            {
              className: `input-wrapper__label__text input-wrapper__label__text-${u}`,
              htmlFor: l,
              children: t
            }
          ),
          a && /* @__PURE__ */ _.jsxs("span", { className: "input-wrapper__tooltip-icon input-tooltip__parent ", children: [
            /* @__PURE__ */ _.jsx("span", { className: "input-wrapper__tooltip-label", children: i }),
            /* @__PURE__ */ _.jsx(
              b1,
              {
                direction: "top",
                label: a,
                referenceElement: h
              }
            ),
            /* @__PURE__ */ _.jsx("span", { ref: v, children: /* @__PURE__ */ _.jsx(
              Wu,
              {
                className: "input-wrapper__label__icon",
                size: "sm"
              }
            ) })
          ] }),
          c
        ] }),
        o,
        g && /* @__PURE__ */ _.jsx("div", { className: "input-wrapper__error-label", children: r })
      ]
    }
  );
}, kre = ({
  className: e,
  children: t,
  type: r = "info",
  actions: n,
  onClose: a,
  backgroundColor: i = "grey",
  iconType: o
}) => {
  const u = !!a, s = () => {
    switch (o ?? r) {
      case "error":
        return /* @__PURE__ */ _.jsx(dh, { className: "notification__icon" });
      case "success":
        return /* @__PURE__ */ _.jsx(X8, { className: "notification__icon" });
      case "info":
        return /* @__PURE__ */ _.jsx(Wu, { className: "notification__icon" });
      case "warning":
        return /* @__PURE__ */ _.jsx(dh, { className: "notification__icon" });
      default:
        return /* @__PURE__ */ _.jsx(Wu, { className: "notification__icon" });
    }
  };
  return /* @__PURE__ */ _.jsxs(
    "div",
    {
      className: He(
        "notification",
        `notification--${r}`,
        {
          [`${e}`]: !!e,
          [`notification--${i}`]: !["warning", "error"].includes(r)
        }
      ),
      children: [
        s(),
        /* @__PURE__ */ _.jsxs("div", { className: "notification__content p-0 ml-xs", children: [
          t,
          !!n && /* @__PURE__ */ _.jsx("div", { className: "notification__actions", children: n })
        ] }),
        u && /* @__PURE__ */ _.jsx(Z8, { className: "notification__close ml-lg", onClick: a })
      ]
    }
  );
};
var Q1 = {}, xT = ly, CT = py;
Object.defineProperty(Q1, "__esModule", {
  value: !0
});
var g3 = Q1.default = void 0, wT = CT(N), OT = xT(Uy()), ST = (0, OT.default)(/* @__PURE__ */ wT.createElement("path", {
  d: "M9 5v2h6.59L4 18.59 5.41 20 17 8.41V15h2V5z"
}), "CallMade");
g3 = Q1.default = ST;
const Lre = ({
  className: e,
  option: t,
  isCurrent: r = !1,
  onSelect: n,
  onMoreInfoClick: a,
  selected: i,
  error: o,
  moreInfoLabel: u = "More info"
}) => {
  const s = t.shortName.replace(/fund|strategy/i, "").trim();
  return /* @__PURE__ */ _.jsxs(
    "label",
    {
      className: He("retirement-projector__option", {
        "retirement-projector__option--error": o,
        [`${e}`]: !!e
      }),
      htmlFor: `${Yu(t.shortName)}-option`,
      children: [
        /* @__PURE__ */ _.jsx(
          Cb,
          {
            id: `${Yu(t.shortName)}-option`,
            name: "retirement-projector-option",
            border: "gray",
            size: "small",
            label: t.shortName,
            checked: i,
            onChange: n
          }
        ),
        /* @__PURE__ */ _.jsx("h6", { children: s }),
        r && /* @__PURE__ */ _.jsx("span", { children: "  (Current) " }),
        /* @__PURE__ */ _.jsx(
          r8,
          {
            variant: "link",
            size: "sm",
            iconRight: g3,
            onClick: () => {
              a(t);
            },
            children: u
          }
        )
      ]
    }
  );
};
function m3(e) {
  var t, r, n = "";
  if (typeof e == "string" || typeof e == "number") n += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var a = e.length;
    for (t = 0; t < a; t++) e[t] && (r = m3(e[t])) && (n && (n += " "), n += r);
  } else for (r in e) e[r] && (n && (n += " "), n += r);
  return n;
}
function Ne() {
  for (var e, t, r = 0, n = "", a = arguments.length; r < a; r++) (e = arguments[r]) && (t = m3(e)) && (n && (n += " "), n += t);
  return n;
}
function AT(e) {
  return e == null;
}
var ET = AT;
const Me = /* @__PURE__ */ Fe(ET);
var _T = en, IT = Wt, PT = tn, TT = "[object String]";
function MT(e) {
  return typeof e == "string" || !IT(e) && PT(e) && _T(e) == TT;
}
var jT = MT;
const tu = /* @__PURE__ */ Fe(jT);
var RT = en, NT = tn, $T = "[object Number]";
function FT(e) {
  return typeof e == "number" || NT(e) && RT(e) == $T;
}
var y3 = FT;
const DT = /* @__PURE__ */ Fe(y3);
var kT = y3;
function LT(e) {
  return kT(e) && e != +e;
}
var BT = LT;
const ai = /* @__PURE__ */ Fe(BT);
var yr = function(t) {
  return t === 0 ? 0 : t > 0 ? 1 : -1;
}, kn = function(t) {
  return tu(t) && t.indexOf("%") === t.length - 1;
}, oe = function(t) {
  return DT(t) && !ai(t);
}, gt = function(t) {
  return oe(t) || tu(t);
}, VT = 0, ru = function(t) {
  var r = ++VT;
  return "".concat(t || "").concat(r);
}, Zn = function(t, r) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
  if (!oe(t) && !tu(t))
    return n;
  var i;
  if (kn(t)) {
    var o = t.indexOf("%");
    i = r * parseFloat(t.slice(0, o)) / 100;
  } else
    i = +t;
  return ai(i) && (i = n), a && i > r && (i = r), i;
}, cn = function(t) {
  if (!t)
    return null;
  var r = Object.keys(t);
  return r && r.length ? t[r[0]] : null;
}, WT = function(t) {
  if (!Array.isArray(t))
    return !1;
  for (var r = t.length, n = {}, a = 0; a < r; a++)
    if (!n[t[a]])
      n[t[a]] = !0;
    else
      return !0;
  return !1;
}, rr = function(t, r) {
  return oe(t) && oe(r) ? function(n) {
    return t + n * (r - t);
  } : function() {
    return r;
  };
};
function Qu(e, t, r) {
  return !e || !e.length ? null : e.find(function(n) {
    return n && (typeof t == "function" ? t(n) : ve(n, t)) === r;
  });
}
function ya(e, t) {
  for (var r in e)
    if ({}.hasOwnProperty.call(e, r) && (!{}.hasOwnProperty.call(t, r) || e[r] !== t[r]))
      return !1;
  for (var n in t)
    if ({}.hasOwnProperty.call(t, n) && !{}.hasOwnProperty.call(e, n))
      return !1;
  return !0;
}
function Xf(e) {
  "@babel/helpers - typeof";
  return Xf = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Xf(e);
}
var GT = ["viewBox", "children"], HT = [
  "aria-activedescendant",
  "aria-atomic",
  "aria-autocomplete",
  "aria-busy",
  "aria-checked",
  "aria-colcount",
  "aria-colindex",
  "aria-colspan",
  "aria-controls",
  "aria-current",
  "aria-describedby",
  "aria-details",
  "aria-disabled",
  "aria-errormessage",
  "aria-expanded",
  "aria-flowto",
  "aria-haspopup",
  "aria-hidden",
  "aria-invalid",
  "aria-keyshortcuts",
  "aria-label",
  "aria-labelledby",
  "aria-level",
  "aria-live",
  "aria-modal",
  "aria-multiline",
  "aria-multiselectable",
  "aria-orientation",
  "aria-owns",
  "aria-placeholder",
  "aria-posinset",
  "aria-pressed",
  "aria-readonly",
  "aria-relevant",
  "aria-required",
  "aria-roledescription",
  "aria-rowcount",
  "aria-rowindex",
  "aria-rowspan",
  "aria-selected",
  "aria-setsize",
  "aria-sort",
  "aria-valuemax",
  "aria-valuemin",
  "aria-valuenow",
  "aria-valuetext",
  "className",
  "color",
  "height",
  "id",
  "lang",
  "max",
  "media",
  "method",
  "min",
  "name",
  "style",
  /*
   * removed 'type' SVGElementPropKey because we do not currently use any SVG elements
   * that can use it and it conflicts with the recharts prop 'type'
   * https://github.com/recharts/recharts/pull/3327
   * https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/type
   */
  // 'type',
  "target",
  "width",
  "role",
  "tabIndex",
  "accentHeight",
  "accumulate",
  "additive",
  "alignmentBaseline",
  "allowReorder",
  "alphabetic",
  "amplitude",
  "arabicForm",
  "ascent",
  "attributeName",
  "attributeType",
  "autoReverse",
  "azimuth",
  "baseFrequency",
  "baselineShift",
  "baseProfile",
  "bbox",
  "begin",
  "bias",
  "by",
  "calcMode",
  "capHeight",
  "clip",
  "clipPath",
  "clipPathUnits",
  "clipRule",
  "colorInterpolation",
  "colorInterpolationFilters",
  "colorProfile",
  "colorRendering",
  "contentScriptType",
  "contentStyleType",
  "cursor",
  "cx",
  "cy",
  "d",
  "decelerate",
  "descent",
  "diffuseConstant",
  "direction",
  "display",
  "divisor",
  "dominantBaseline",
  "dur",
  "dx",
  "dy",
  "edgeMode",
  "elevation",
  "enableBackground",
  "end",
  "exponent",
  "externalResourcesRequired",
  "fill",
  "fillOpacity",
  "fillRule",
  "filter",
  "filterRes",
  "filterUnits",
  "floodColor",
  "floodOpacity",
  "focusable",
  "fontFamily",
  "fontSize",
  "fontSizeAdjust",
  "fontStretch",
  "fontStyle",
  "fontVariant",
  "fontWeight",
  "format",
  "from",
  "fx",
  "fy",
  "g1",
  "g2",
  "glyphName",
  "glyphOrientationHorizontal",
  "glyphOrientationVertical",
  "glyphRef",
  "gradientTransform",
  "gradientUnits",
  "hanging",
  "horizAdvX",
  "horizOriginX",
  "href",
  "ideographic",
  "imageRendering",
  "in2",
  "in",
  "intercept",
  "k1",
  "k2",
  "k3",
  "k4",
  "k",
  "kernelMatrix",
  "kernelUnitLength",
  "kerning",
  "keyPoints",
  "keySplines",
  "keyTimes",
  "lengthAdjust",
  "letterSpacing",
  "lightingColor",
  "limitingConeAngle",
  "local",
  "markerEnd",
  "markerHeight",
  "markerMid",
  "markerStart",
  "markerUnits",
  "markerWidth",
  "mask",
  "maskContentUnits",
  "maskUnits",
  "mathematical",
  "mode",
  "numOctaves",
  "offset",
  "opacity",
  "operator",
  "order",
  "orient",
  "orientation",
  "origin",
  "overflow",
  "overlinePosition",
  "overlineThickness",
  "paintOrder",
  "panose1",
  "pathLength",
  "patternContentUnits",
  "patternTransform",
  "patternUnits",
  "pointerEvents",
  "pointsAtX",
  "pointsAtY",
  "pointsAtZ",
  "preserveAlpha",
  "preserveAspectRatio",
  "primitiveUnits",
  "r",
  "radius",
  "refX",
  "refY",
  "renderingIntent",
  "repeatCount",
  "repeatDur",
  "requiredExtensions",
  "requiredFeatures",
  "restart",
  "result",
  "rotate",
  "rx",
  "ry",
  "seed",
  "shapeRendering",
  "slope",
  "spacing",
  "specularConstant",
  "specularExponent",
  "speed",
  "spreadMethod",
  "startOffset",
  "stdDeviation",
  "stemh",
  "stemv",
  "stitchTiles",
  "stopColor",
  "stopOpacity",
  "strikethroughPosition",
  "strikethroughThickness",
  "string",
  "stroke",
  "strokeDasharray",
  "strokeDashoffset",
  "strokeLinecap",
  "strokeLinejoin",
  "strokeMiterlimit",
  "strokeOpacity",
  "strokeWidth",
  "surfaceScale",
  "systemLanguage",
  "tableValues",
  "targetX",
  "targetY",
  "textAnchor",
  "textDecoration",
  "textLength",
  "textRendering",
  "to",
  "transform",
  "u1",
  "u2",
  "underlinePosition",
  "underlineThickness",
  "unicode",
  "unicodeBidi",
  "unicodeRange",
  "unitsPerEm",
  "vAlphabetic",
  "values",
  "vectorEffect",
  "version",
  "vertAdvY",
  "vertOriginX",
  "vertOriginY",
  "vHanging",
  "vIdeographic",
  "viewTarget",
  "visibility",
  "vMathematical",
  "widths",
  "wordSpacing",
  "writingMode",
  "x1",
  "x2",
  "x",
  "xChannelSelector",
  "xHeight",
  "xlinkActuate",
  "xlinkArcrole",
  "xlinkHref",
  "xlinkRole",
  "xlinkShow",
  "xlinkTitle",
  "xlinkType",
  "xmlBase",
  "xmlLang",
  "xmlns",
  "xmlnsXlink",
  "xmlSpace",
  "y1",
  "y2",
  "y",
  "yChannelSelector",
  "z",
  "zoomAndPan",
  "ref",
  "key",
  "angle"
], ev = ["points", "pathLength"], $l = {
  svg: GT,
  polygon: ev,
  polyline: ev
}, ep = ["dangerouslySetInnerHTML", "onCopy", "onCopyCapture", "onCut", "onCutCapture", "onPaste", "onPasteCapture", "onCompositionEnd", "onCompositionEndCapture", "onCompositionStart", "onCompositionStartCapture", "onCompositionUpdate", "onCompositionUpdateCapture", "onFocus", "onFocusCapture", "onBlur", "onBlurCapture", "onChange", "onChangeCapture", "onBeforeInput", "onBeforeInputCapture", "onInput", "onInputCapture", "onReset", "onResetCapture", "onSubmit", "onSubmitCapture", "onInvalid", "onInvalidCapture", "onLoad", "onLoadCapture", "onError", "onErrorCapture", "onKeyDown", "onKeyDownCapture", "onKeyPress", "onKeyPressCapture", "onKeyUp", "onKeyUpCapture", "onAbort", "onAbortCapture", "onCanPlay", "onCanPlayCapture", "onCanPlayThrough", "onCanPlayThroughCapture", "onDurationChange", "onDurationChangeCapture", "onEmptied", "onEmptiedCapture", "onEncrypted", "onEncryptedCapture", "onEnded", "onEndedCapture", "onLoadedData", "onLoadedDataCapture", "onLoadedMetadata", "onLoadedMetadataCapture", "onLoadStart", "onLoadStartCapture", "onPause", "onPauseCapture", "onPlay", "onPlayCapture", "onPlaying", "onPlayingCapture", "onProgress", "onProgressCapture", "onRateChange", "onRateChangeCapture", "onSeeked", "onSeekedCapture", "onSeeking", "onSeekingCapture", "onStalled", "onStalledCapture", "onSuspend", "onSuspendCapture", "onTimeUpdate", "onTimeUpdateCapture", "onVolumeChange", "onVolumeChangeCapture", "onWaiting", "onWaitingCapture", "onAuxClick", "onAuxClickCapture", "onClick", "onClickCapture", "onContextMenu", "onContextMenuCapture", "onDoubleClick", "onDoubleClickCapture", "onDrag", "onDragCapture", "onDragEnd", "onDragEndCapture", "onDragEnter", "onDragEnterCapture", "onDragExit", "onDragExitCapture", "onDragLeave", "onDragLeaveCapture", "onDragOver", "onDragOverCapture", "onDragStart", "onDragStartCapture", "onDrop", "onDropCapture", "onMouseDown", "onMouseDownCapture", "onMouseEnter", "onMouseLeave", "onMouseMove", "onMouseMoveCapture", "onMouseOut", "onMouseOutCapture", "onMouseOver", "onMouseOverCapture", "onMouseUp", "onMouseUpCapture", "onSelect", "onSelectCapture", "onTouchCancel", "onTouchCancelCapture", "onTouchEnd", "onTouchEndCapture", "onTouchMove", "onTouchMoveCapture", "onTouchStart", "onTouchStartCapture", "onPointerDown", "onPointerDownCapture", "onPointerMove", "onPointerMoveCapture", "onPointerUp", "onPointerUpCapture", "onPointerCancel", "onPointerCancelCapture", "onPointerEnter", "onPointerEnterCapture", "onPointerLeave", "onPointerLeaveCapture", "onPointerOver", "onPointerOverCapture", "onPointerOut", "onPointerOutCapture", "onGotPointerCapture", "onGotPointerCaptureCapture", "onLostPointerCapture", "onLostPointerCaptureCapture", "onScroll", "onScrollCapture", "onWheel", "onWheelCapture", "onAnimationStart", "onAnimationStartCapture", "onAnimationEnd", "onAnimationEndCapture", "onAnimationIteration", "onAnimationIterationCapture", "onTransitionEnd", "onTransitionEndCapture"], es = function(t, r) {
  if (!t || typeof t == "function" || typeof t == "boolean")
    return null;
  var n = t;
  if (/* @__PURE__ */ _r(t) && (n = t.props), !Ja(n))
    return null;
  var a = {};
  return Object.keys(n).forEach(function(i) {
    ep.includes(i) && (a[i] = r || function(o) {
      return n[i](n, o);
    });
  }), a;
}, UT = function(t, r, n) {
  return function(a) {
    return t(r, n, a), null;
  };
}, ts = function(t, r, n) {
  if (!Ja(t) || Xf(t) !== "object")
    return null;
  var a = null;
  return Object.keys(t).forEach(function(i) {
    var o = t[i];
    ep.includes(i) && typeof o == "function" && (a || (a = {}), a[i] = UT(o, r, n));
  }), a;
}, zT = ["children"], YT = ["children"];
function tv(e, t) {
  if (e == null) return {};
  var r = XT(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function XT(e, t) {
  if (e == null) return {};
  var r = {}, n = Object.keys(e), a, i;
  for (i = 0; i < n.length; i++)
    a = n[i], !(t.indexOf(a) >= 0) && (r[a] = e[a]);
  return r;
}
function Zf(e) {
  "@babel/helpers - typeof";
  return Zf = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Zf(e);
}
var rv = {
  click: "onClick",
  mousedown: "onMouseDown",
  mouseup: "onMouseUp",
  mouseover: "onMouseOver",
  mousemove: "onMouseMove",
  mouseout: "onMouseOut",
  mouseenter: "onMouseEnter",
  mouseleave: "onMouseLeave",
  touchcancel: "onTouchCancel",
  touchend: "onTouchEnd",
  touchmove: "onTouchMove",
  touchstart: "onTouchStart"
}, Hr = function(t) {
  return typeof t == "string" ? t : t ? t.displayName || t.name || "Component" : "";
}, nv = null, Fl = null, tp = function e(t) {
  if (t === nv && Array.isArray(Fl))
    return Fl;
  var r = [];
  return Gn.forEach(t, function(n) {
    Me(n) || (Ea.isFragment(n) ? r = r.concat(e(n.props.children)) : r.push(n));
  }), Fl = r, nv = t, r;
};
function br(e, t) {
  var r = [], n = [];
  return Array.isArray(t) ? n = t.map(function(a) {
    return Hr(a);
  }) : n = [Hr(t)], tp(e).forEach(function(a) {
    var i = ve(a, "type.displayName") || ve(a, "type.name");
    n.indexOf(i) !== -1 && r.push(a);
  }), r;
}
function Ut(e, t) {
  var r = br(e, t);
  return r && r[0];
}
var av = function(t) {
  if (!t || !t.props)
    return !1;
  var r = t.props, n = r.width, a = r.height;
  return !(!oe(n) || n <= 0 || !oe(a) || a <= 0);
}, ZT = ["a", "altGlyph", "altGlyphDef", "altGlyphItem", "animate", "animateColor", "animateMotion", "animateTransform", "circle", "clipPath", "color-profile", "cursor", "defs", "desc", "ellipse", "feBlend", "feColormatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence", "filter", "font", "font-face", "font-face-format", "font-face-name", "font-face-url", "foreignObject", "g", "glyph", "glyphRef", "hkern", "image", "line", "lineGradient", "marker", "mask", "metadata", "missing-glyph", "mpath", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "script", "set", "stop", "style", "svg", "switch", "symbol", "text", "textPath", "title", "tref", "tspan", "use", "view", "vkern"], KT = function(t) {
  return t && t.type && tu(t.type) && ZT.indexOf(t.type) >= 0;
}, qT = function(t) {
  return t && Zf(t) === "object" && "cx" in t && "cy" in t && "r" in t;
}, JT = function(t, r, n, a) {
  var i, o = (i = $l == null ? void 0 : $l[a]) !== null && i !== void 0 ? i : [];
  return !_e(t) && (a && o.includes(r) || HT.includes(r)) || n && ep.includes(r);
}, Ie = function(t, r, n) {
  if (!t || typeof t == "function" || typeof t == "boolean")
    return null;
  var a = t;
  if (/* @__PURE__ */ _r(t) && (a = t.props), !Ja(a))
    return null;
  var i = {};
  return Object.keys(a).forEach(function(o) {
    var u;
    JT((u = a) === null || u === void 0 ? void 0 : u[o], o, r, n) && (i[o] = a[o]);
  }), i;
}, Kf = function e(t, r) {
  if (t === r)
    return !0;
  var n = Gn.count(t);
  if (n !== Gn.count(r))
    return !1;
  if (n === 0)
    return !0;
  if (n === 1)
    return iv(Array.isArray(t) ? t[0] : t, Array.isArray(r) ? r[0] : r);
  for (var a = 0; a < n; a++) {
    var i = t[a], o = r[a];
    if (Array.isArray(i) || Array.isArray(o)) {
      if (!e(i, o))
        return !1;
    } else if (!iv(i, o))
      return !1;
  }
  return !0;
}, iv = function(t, r) {
  if (Me(t) && Me(r))
    return !0;
  if (!Me(t) && !Me(r)) {
    var n = t.props || {}, a = n.children, i = tv(n, zT), o = r.props || {}, u = o.children, s = tv(o, YT);
    return a && u ? ya(i, s) && Kf(a, u) : !a && !u ? ya(i, s) : !1;
  }
  return !1;
}, ov = function(t, r) {
  var n = [], a = {};
  return tp(t).forEach(function(i, o) {
    if (KT(i))
      n.push(i);
    else if (i) {
      var u = Hr(i.type), s = r[u] || {}, c = s.handler, l = s.once;
      if (c && (!l || !a[u])) {
        var f = c(i, u, o);
        n.push(f), a[u] = !0;
      }
    }
  }), n;
}, QT = function(t) {
  var r = t && t.type;
  return r && rv[r] ? rv[r] : null;
}, eM = function(t, r) {
  return tp(r).indexOf(t);
}, tM = ["children", "width", "height", "viewBox", "className", "style", "title", "desc"];
function qf() {
  return qf = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, qf.apply(this, arguments);
}
function rM(e, t) {
  if (e == null) return {};
  var r = nM(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function nM(e, t) {
  if (e == null) return {};
  var r = {}, n = Object.keys(e), a, i;
  for (i = 0; i < n.length; i++)
    a = n[i], !(t.indexOf(a) >= 0) && (r[a] = e[a]);
  return r;
}
function Jf(e) {
  var t = e.children, r = e.width, n = e.height, a = e.viewBox, i = e.className, o = e.style, u = e.title, s = e.desc, c = rM(e, tM), l = a || {
    width: r,
    height: n,
    x: 0,
    y: 0
  }, f = Ne("recharts-surface", i);
  return /* @__PURE__ */ N.createElement("svg", qf({}, Ie(c, !0, "svg"), {
    className: f,
    width: r,
    height: n,
    style: o,
    viewBox: "".concat(l.x, " ").concat(l.y, " ").concat(l.width, " ").concat(l.height)
  }), /* @__PURE__ */ N.createElement("title", null, u), /* @__PURE__ */ N.createElement("desc", null, s), t);
}
var aM = ["children", "className"];
function Qf() {
  return Qf = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Qf.apply(this, arguments);
}
function iM(e, t) {
  if (e == null) return {};
  var r = oM(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function oM(e, t) {
  if (e == null) return {};
  var r = {}, n = Object.keys(e), a, i;
  for (i = 0; i < n.length; i++)
    a = n[i], !(t.indexOf(a) >= 0) && (r[a] = e[a]);
  return r;
}
var ut = /* @__PURE__ */ N.forwardRef(function(e, t) {
  var r = e.children, n = e.className, a = iM(e, aM), i = Ne("recharts-layer", n);
  return /* @__PURE__ */ N.createElement("g", Qf({
    className: i
  }, Ie(a, !0), {
    ref: t
  }), r);
}), uM = process.env.NODE_ENV !== "production", Ur = function(t, r) {
  for (var n = arguments.length, a = new Array(n > 2 ? n - 2 : 0), i = 2; i < n; i++)
    a[i - 2] = arguments[i];
  if (uM && typeof console < "u" && console.warn && (r === void 0 && console.warn("LogUtils requires an error message argument"), !t))
    if (r === void 0)
      console.warn("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
    else {
      var o = 0;
      console.warn(r.replace(/%s/g, function() {
        return a[o++];
      }));
    }
};
function sM(e, t, r) {
  var n = -1, a = e.length;
  t < 0 && (t = -t > a ? 0 : a + t), r = r > a ? a : r, r < 0 && (r += a), a = t > r ? 0 : r - t >>> 0, t >>>= 0;
  for (var i = Array(a); ++n < a; )
    i[n] = e[n + t];
  return i;
}
var cM = sM, lM = cM;
function fM(e, t, r) {
  var n = e.length;
  return r = r === void 0 ? n : r, !t && r >= n ? e : lM(e, t, r);
}
var dM = fM, pM = "\\ud800-\\udfff", hM = "\\u0300-\\u036f", vM = "\\ufe20-\\ufe2f", gM = "\\u20d0-\\u20ff", mM = hM + vM + gM, yM = "\\ufe0e\\ufe0f", bM = "\\u200d", xM = RegExp("[" + bM + pM + mM + yM + "]");
function CM(e) {
  return xM.test(e);
}
var b3 = CM;
function wM(e) {
  return e.split("");
}
var OM = wM, x3 = "\\ud800-\\udfff", SM = "\\u0300-\\u036f", AM = "\\ufe20-\\ufe2f", EM = "\\u20d0-\\u20ff", _M = SM + AM + EM, IM = "\\ufe0e\\ufe0f", PM = "[" + x3 + "]", ed = "[" + _M + "]", td = "\\ud83c[\\udffb-\\udfff]", TM = "(?:" + ed + "|" + td + ")", C3 = "[^" + x3 + "]", w3 = "(?:\\ud83c[\\udde6-\\uddff]){2}", O3 = "[\\ud800-\\udbff][\\udc00-\\udfff]", MM = "\\u200d", S3 = TM + "?", A3 = "[" + IM + "]?", jM = "(?:" + MM + "(?:" + [C3, w3, O3].join("|") + ")" + A3 + S3 + ")*", RM = A3 + S3 + jM, NM = "(?:" + [C3 + ed + "?", ed, w3, O3, PM].join("|") + ")", $M = RegExp(td + "(?=" + td + ")|" + NM + RM, "g");
function FM(e) {
  return e.match($M) || [];
}
var DM = FM, kM = OM, LM = b3, BM = DM;
function VM(e) {
  return LM(e) ? BM(e) : kM(e);
}
var WM = VM, GM = dM, HM = b3, UM = WM, zM = ac;
function YM(e) {
  return function(t) {
    t = zM(t);
    var r = HM(t) ? UM(t) : void 0, n = r ? r[0] : t.charAt(0), a = r ? GM(r, 1).join("") : t.slice(1);
    return n[e]() + a;
  };
}
var XM = YM, ZM = XM, KM = ZM("toUpperCase"), qM = KM;
const pc = /* @__PURE__ */ Fe(qM);
function Je(e) {
  return function() {
    return e;
  };
}
const E3 = Math.cos, rs = Math.sin, xr = Math.sqrt, ns = Math.PI, hc = 2 * ns, rd = Math.PI, nd = 2 * rd, Rn = 1e-6, JM = nd - Rn;
function _3(e) {
  this._ += e[0];
  for (let t = 1, r = e.length; t < r; ++t)
    this._ += arguments[t] + e[t];
}
function QM(e) {
  let t = Math.floor(e);
  if (!(t >= 0)) throw new Error(`invalid digits: ${e}`);
  if (t > 15) return _3;
  const r = 10 ** t;
  return function(n) {
    this._ += n[0];
    for (let a = 1, i = n.length; a < i; ++a)
      this._ += Math.round(arguments[a] * r) / r + n[a];
  };
}
class ej {
  constructor(t) {
    this._x0 = this._y0 = // start of current subpath
    this._x1 = this._y1 = null, this._ = "", this._append = t == null ? _3 : QM(t);
  }
  moveTo(t, r) {
    this._append`M${this._x0 = this._x1 = +t},${this._y0 = this._y1 = +r}`;
  }
  closePath() {
    this._x1 !== null && (this._x1 = this._x0, this._y1 = this._y0, this._append`Z`);
  }
  lineTo(t, r) {
    this._append`L${this._x1 = +t},${this._y1 = +r}`;
  }
  quadraticCurveTo(t, r, n, a) {
    this._append`Q${+t},${+r},${this._x1 = +n},${this._y1 = +a}`;
  }
  bezierCurveTo(t, r, n, a, i, o) {
    this._append`C${+t},${+r},${+n},${+a},${this._x1 = +i},${this._y1 = +o}`;
  }
  arcTo(t, r, n, a, i) {
    if (t = +t, r = +r, n = +n, a = +a, i = +i, i < 0) throw new Error(`negative radius: ${i}`);
    let o = this._x1, u = this._y1, s = n - t, c = a - r, l = o - t, f = u - r, d = l * l + f * f;
    if (this._x1 === null)
      this._append`M${this._x1 = t},${this._y1 = r}`;
    else if (d > Rn) if (!(Math.abs(f * s - c * l) > Rn) || !i)
      this._append`L${this._x1 = t},${this._y1 = r}`;
    else {
      let p = n - o, h = a - u, v = s * s + c * c, g = p * p + h * h, b = Math.sqrt(v), x = Math.sqrt(d), w = i * Math.tan((rd - Math.acos((v + d - g) / (2 * b * x))) / 2), y = w / x, m = w / b;
      Math.abs(y - 1) > Rn && this._append`L${t + y * l},${r + y * f}`, this._append`A${i},${i},0,0,${+(f * p > l * h)},${this._x1 = t + m * s},${this._y1 = r + m * c}`;
    }
  }
  arc(t, r, n, a, i, o) {
    if (t = +t, r = +r, n = +n, o = !!o, n < 0) throw new Error(`negative radius: ${n}`);
    let u = n * Math.cos(a), s = n * Math.sin(a), c = t + u, l = r + s, f = 1 ^ o, d = o ? a - i : i - a;
    this._x1 === null ? this._append`M${c},${l}` : (Math.abs(this._x1 - c) > Rn || Math.abs(this._y1 - l) > Rn) && this._append`L${c},${l}`, n && (d < 0 && (d = d % nd + nd), d > JM ? this._append`A${n},${n},0,1,${f},${t - u},${r - s}A${n},${n},0,1,${f},${this._x1 = c},${this._y1 = l}` : d > Rn && this._append`A${n},${n},0,${+(d >= rd)},${f},${this._x1 = t + n * Math.cos(i)},${this._y1 = r + n * Math.sin(i)}`);
  }
  rect(t, r, n, a) {
    this._append`M${this._x0 = this._x1 = +t},${this._y0 = this._y1 = +r}h${n = +n}v${+a}h${-n}Z`;
  }
  toString() {
    return this._;
  }
}
function rp(e) {
  let t = 3;
  return e.digits = function(r) {
    if (!arguments.length) return t;
    if (r == null)
      t = null;
    else {
      const n = Math.floor(r);
      if (!(n >= 0)) throw new RangeError(`invalid digits: ${r}`);
      t = n;
    }
    return e;
  }, () => new ej(t);
}
function np(e) {
  return typeof e == "object" && "length" in e ? e : Array.from(e);
}
function I3(e) {
  this._context = e;
}
I3.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
        break;
      case 1:
        this._point = 2;
      default:
        this._context.lineTo(e, t);
        break;
    }
  }
};
function vc(e) {
  return new I3(e);
}
function P3(e) {
  return e[0];
}
function T3(e) {
  return e[1];
}
function M3(e, t) {
  var r = Je(!0), n = null, a = vc, i = null, o = rp(u);
  e = typeof e == "function" ? e : e === void 0 ? P3 : Je(e), t = typeof t == "function" ? t : t === void 0 ? T3 : Je(t);
  function u(s) {
    var c, l = (s = np(s)).length, f, d = !1, p;
    for (n == null && (i = a(p = o())), c = 0; c <= l; ++c)
      !(c < l && r(f = s[c], c, s)) === d && ((d = !d) ? i.lineStart() : i.lineEnd()), d && i.point(+e(f, c, s), +t(f, c, s));
    if (p) return i = null, p + "" || null;
  }
  return u.x = function(s) {
    return arguments.length ? (e = typeof s == "function" ? s : Je(+s), u) : e;
  }, u.y = function(s) {
    return arguments.length ? (t = typeof s == "function" ? s : Je(+s), u) : t;
  }, u.defined = function(s) {
    return arguments.length ? (r = typeof s == "function" ? s : Je(!!s), u) : r;
  }, u.curve = function(s) {
    return arguments.length ? (a = s, n != null && (i = a(n)), u) : a;
  }, u.context = function(s) {
    return arguments.length ? (s == null ? n = i = null : i = a(n = s), u) : n;
  }, u;
}
function xu(e, t, r) {
  var n = null, a = Je(!0), i = null, o = vc, u = null, s = rp(c);
  e = typeof e == "function" ? e : e === void 0 ? P3 : Je(+e), t = typeof t == "function" ? t : Je(t === void 0 ? 0 : +t), r = typeof r == "function" ? r : r === void 0 ? T3 : Je(+r);
  function c(f) {
    var d, p, h, v = (f = np(f)).length, g, b = !1, x, w = new Array(v), y = new Array(v);
    for (i == null && (u = o(x = s())), d = 0; d <= v; ++d) {
      if (!(d < v && a(g = f[d], d, f)) === b)
        if (b = !b)
          p = d, u.areaStart(), u.lineStart();
        else {
          for (u.lineEnd(), u.lineStart(), h = d - 1; h >= p; --h)
            u.point(w[h], y[h]);
          u.lineEnd(), u.areaEnd();
        }
      b && (w[d] = +e(g, d, f), y[d] = +t(g, d, f), u.point(n ? +n(g, d, f) : w[d], r ? +r(g, d, f) : y[d]));
    }
    if (x) return u = null, x + "" || null;
  }
  function l() {
    return M3().defined(a).curve(o).context(i);
  }
  return c.x = function(f) {
    return arguments.length ? (e = typeof f == "function" ? f : Je(+f), n = null, c) : e;
  }, c.x0 = function(f) {
    return arguments.length ? (e = typeof f == "function" ? f : Je(+f), c) : e;
  }, c.x1 = function(f) {
    return arguments.length ? (n = f == null ? null : typeof f == "function" ? f : Je(+f), c) : n;
  }, c.y = function(f) {
    return arguments.length ? (t = typeof f == "function" ? f : Je(+f), r = null, c) : t;
  }, c.y0 = function(f) {
    return arguments.length ? (t = typeof f == "function" ? f : Je(+f), c) : t;
  }, c.y1 = function(f) {
    return arguments.length ? (r = f == null ? null : typeof f == "function" ? f : Je(+f), c) : r;
  }, c.lineX0 = c.lineY0 = function() {
    return l().x(e).y(t);
  }, c.lineY1 = function() {
    return l().x(e).y(r);
  }, c.lineX1 = function() {
    return l().x(n).y(t);
  }, c.defined = function(f) {
    return arguments.length ? (a = typeof f == "function" ? f : Je(!!f), c) : a;
  }, c.curve = function(f) {
    return arguments.length ? (o = f, i != null && (u = o(i)), c) : o;
  }, c.context = function(f) {
    return arguments.length ? (f == null ? i = u = null : u = o(i = f), c) : i;
  }, c;
}
class j3 {
  constructor(t, r) {
    this._context = t, this._x = r;
  }
  areaStart() {
    this._line = 0;
  }
  areaEnd() {
    this._line = NaN;
  }
  lineStart() {
    this._point = 0;
  }
  lineEnd() {
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  }
  point(t, r) {
    switch (t = +t, r = +r, this._point) {
      case 0: {
        this._point = 1, this._line ? this._context.lineTo(t, r) : this._context.moveTo(t, r);
        break;
      }
      case 1:
        this._point = 2;
      default: {
        this._x ? this._context.bezierCurveTo(this._x0 = (this._x0 + t) / 2, this._y0, this._x0, r, t, r) : this._context.bezierCurveTo(this._x0, this._y0 = (this._y0 + r) / 2, t, this._y0, t, r);
        break;
      }
    }
    this._x0 = t, this._y0 = r;
  }
}
function tj(e) {
  return new j3(e, !0);
}
function rj(e) {
  return new j3(e, !1);
}
const ap = {
  draw(e, t) {
    const r = xr(t / ns);
    e.moveTo(r, 0), e.arc(0, 0, r, 0, hc);
  }
}, nj = {
  draw(e, t) {
    const r = xr(t / 5) / 2;
    e.moveTo(-3 * r, -r), e.lineTo(-r, -r), e.lineTo(-r, -3 * r), e.lineTo(r, -3 * r), e.lineTo(r, -r), e.lineTo(3 * r, -r), e.lineTo(3 * r, r), e.lineTo(r, r), e.lineTo(r, 3 * r), e.lineTo(-r, 3 * r), e.lineTo(-r, r), e.lineTo(-3 * r, r), e.closePath();
  }
}, R3 = xr(1 / 3), aj = R3 * 2, ij = {
  draw(e, t) {
    const r = xr(t / aj), n = r * R3;
    e.moveTo(0, -r), e.lineTo(n, 0), e.lineTo(0, r), e.lineTo(-n, 0), e.closePath();
  }
}, oj = {
  draw(e, t) {
    const r = xr(t), n = -r / 2;
    e.rect(n, n, r, r);
  }
}, uj = 0.8908130915292852, N3 = rs(ns / 10) / rs(7 * ns / 10), sj = rs(hc / 10) * N3, cj = -E3(hc / 10) * N3, lj = {
  draw(e, t) {
    const r = xr(t * uj), n = sj * r, a = cj * r;
    e.moveTo(0, -r), e.lineTo(n, a);
    for (let i = 1; i < 5; ++i) {
      const o = hc * i / 5, u = E3(o), s = rs(o);
      e.lineTo(s * r, -u * r), e.lineTo(u * n - s * a, s * n + u * a);
    }
    e.closePath();
  }
}, Dl = xr(3), fj = {
  draw(e, t) {
    const r = -xr(t / (Dl * 3));
    e.moveTo(0, r * 2), e.lineTo(-Dl * r, -r), e.lineTo(Dl * r, -r), e.closePath();
  }
}, Qt = -0.5, er = xr(3) / 2, ad = 1 / xr(12), dj = (ad / 2 + 1) * 3, pj = {
  draw(e, t) {
    const r = xr(t / dj), n = r / 2, a = r * ad, i = n, o = r * ad + r, u = -i, s = o;
    e.moveTo(n, a), e.lineTo(i, o), e.lineTo(u, s), e.lineTo(Qt * n - er * a, er * n + Qt * a), e.lineTo(Qt * i - er * o, er * i + Qt * o), e.lineTo(Qt * u - er * s, er * u + Qt * s), e.lineTo(Qt * n + er * a, Qt * a - er * n), e.lineTo(Qt * i + er * o, Qt * o - er * i), e.lineTo(Qt * u + er * s, Qt * s - er * u), e.closePath();
  }
};
function hj(e, t) {
  let r = null, n = rp(a);
  e = typeof e == "function" ? e : Je(e || ap), t = typeof t == "function" ? t : Je(t === void 0 ? 64 : +t);
  function a() {
    let i;
    if (r || (r = i = n()), e.apply(this, arguments).draw(r, +t.apply(this, arguments)), i) return r = null, i + "" || null;
  }
  return a.type = function(i) {
    return arguments.length ? (e = typeof i == "function" ? i : Je(i), a) : e;
  }, a.size = function(i) {
    return arguments.length ? (t = typeof i == "function" ? i : Je(+i), a) : t;
  }, a.context = function(i) {
    return arguments.length ? (r = i ?? null, a) : r;
  }, a;
}
function as() {
}
function is(e, t, r) {
  e._context.bezierCurveTo(
    (2 * e._x0 + e._x1) / 3,
    (2 * e._y0 + e._y1) / 3,
    (e._x0 + 2 * e._x1) / 3,
    (e._y0 + 2 * e._y1) / 3,
    (e._x0 + 4 * e._x1 + t) / 6,
    (e._y0 + 4 * e._y1 + r) / 6
  );
}
function $3(e) {
  this._context = e;
}
$3.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 3:
        is(this, this._x1, this._y1);
      case 2:
        this._context.lineTo(this._x1, this._y1);
        break;
    }
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3, this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6);
      default:
        is(this, e, t);
        break;
    }
    this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = t;
  }
};
function vj(e) {
  return new $3(e);
}
function F3(e) {
  this._context = e;
}
F3.prototype = {
  areaStart: as,
  areaEnd: as,
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x2, this._y2), this._context.closePath();
        break;
      }
      case 2: {
        this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3), this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3), this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x2, this._y2), this.point(this._x3, this._y3), this.point(this._x4, this._y4);
        break;
      }
    }
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._x2 = e, this._y2 = t;
        break;
      case 1:
        this._point = 2, this._x3 = e, this._y3 = t;
        break;
      case 2:
        this._point = 3, this._x4 = e, this._y4 = t, this._context.moveTo((this._x0 + 4 * this._x1 + e) / 6, (this._y0 + 4 * this._y1 + t) / 6);
        break;
      default:
        is(this, e, t);
        break;
    }
    this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = t;
  }
};
function gj(e) {
  return new F3(e);
}
function D3(e) {
  this._context = e;
}
D3.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = NaN, this._point = 0;
  },
  lineEnd: function() {
    (this._line || this._line !== 0 && this._point === 3) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1;
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3;
        var r = (this._x0 + 4 * this._x1 + e) / 6, n = (this._y0 + 4 * this._y1 + t) / 6;
        this._line ? this._context.lineTo(r, n) : this._context.moveTo(r, n);
        break;
      case 3:
        this._point = 4;
      default:
        is(this, e, t);
        break;
    }
    this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = t;
  }
};
function mj(e) {
  return new D3(e);
}
function k3(e) {
  this._context = e;
}
k3.prototype = {
  areaStart: as,
  areaEnd: as,
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    this._point && this._context.closePath();
  },
  point: function(e, t) {
    e = +e, t = +t, this._point ? this._context.lineTo(e, t) : (this._point = 1, this._context.moveTo(e, t));
  }
};
function yj(e) {
  return new k3(e);
}
function uv(e) {
  return e < 0 ? -1 : 1;
}
function sv(e, t, r) {
  var n = e._x1 - e._x0, a = t - e._x1, i = (e._y1 - e._y0) / (n || a < 0 && -0), o = (r - e._y1) / (a || n < 0 && -0), u = (i * a + o * n) / (n + a);
  return (uv(i) + uv(o)) * Math.min(Math.abs(i), Math.abs(o), 0.5 * Math.abs(u)) || 0;
}
function cv(e, t) {
  var r = e._x1 - e._x0;
  return r ? (3 * (e._y1 - e._y0) / r - t) / 2 : t;
}
function kl(e, t, r) {
  var n = e._x0, a = e._y0, i = e._x1, o = e._y1, u = (i - n) / 3;
  e._context.bezierCurveTo(n + u, a + u * t, i - u, o - u * r, i, o);
}
function os(e) {
  this._context = e;
}
os.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2:
        this._context.lineTo(this._x1, this._y1);
        break;
      case 3:
        kl(this, this._t0, cv(this, this._t0));
        break;
    }
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    var r = NaN;
    if (e = +e, t = +t, !(e === this._x1 && t === this._y1)) {
      switch (this._point) {
        case 0:
          this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
          break;
        case 1:
          this._point = 2;
          break;
        case 2:
          this._point = 3, kl(this, cv(this, r = sv(this, e, t)), r);
          break;
        default:
          kl(this, this._t0, r = sv(this, e, t));
          break;
      }
      this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = t, this._t0 = r;
    }
  }
};
function L3(e) {
  this._context = new B3(e);
}
(L3.prototype = Object.create(os.prototype)).point = function(e, t) {
  os.prototype.point.call(this, t, e);
};
function B3(e) {
  this._context = e;
}
B3.prototype = {
  moveTo: function(e, t) {
    this._context.moveTo(t, e);
  },
  closePath: function() {
    this._context.closePath();
  },
  lineTo: function(e, t) {
    this._context.lineTo(t, e);
  },
  bezierCurveTo: function(e, t, r, n, a, i) {
    this._context.bezierCurveTo(t, e, n, r, i, a);
  }
};
function bj(e) {
  return new os(e);
}
function xj(e) {
  return new L3(e);
}
function V3(e) {
  this._context = e;
}
V3.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = [], this._y = [];
  },
  lineEnd: function() {
    var e = this._x, t = this._y, r = e.length;
    if (r)
      if (this._line ? this._context.lineTo(e[0], t[0]) : this._context.moveTo(e[0], t[0]), r === 2)
        this._context.lineTo(e[1], t[1]);
      else
        for (var n = lv(e), a = lv(t), i = 0, o = 1; o < r; ++i, ++o)
          this._context.bezierCurveTo(n[0][i], a[0][i], n[1][i], a[1][i], e[o], t[o]);
    (this._line || this._line !== 0 && r === 1) && this._context.closePath(), this._line = 1 - this._line, this._x = this._y = null;
  },
  point: function(e, t) {
    this._x.push(+e), this._y.push(+t);
  }
};
function lv(e) {
  var t, r = e.length - 1, n, a = new Array(r), i = new Array(r), o = new Array(r);
  for (a[0] = 0, i[0] = 2, o[0] = e[0] + 2 * e[1], t = 1; t < r - 1; ++t) a[t] = 1, i[t] = 4, o[t] = 4 * e[t] + 2 * e[t + 1];
  for (a[r - 1] = 2, i[r - 1] = 7, o[r - 1] = 8 * e[r - 1] + e[r], t = 1; t < r; ++t) n = a[t] / i[t - 1], i[t] -= n, o[t] -= n * o[t - 1];
  for (a[r - 1] = o[r - 1] / i[r - 1], t = r - 2; t >= 0; --t) a[t] = (o[t] - a[t + 1]) / i[t];
  for (i[r - 1] = (e[r] + a[r - 1]) / 2, t = 0; t < r - 1; ++t) i[t] = 2 * e[t + 1] - a[t + 1];
  return [a, i];
}
function Cj(e) {
  return new V3(e);
}
function gc(e, t) {
  this._context = e, this._t = t;
}
gc.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = this._y = NaN, this._point = 0;
  },
  lineEnd: function() {
    0 < this._t && this._t < 1 && this._point === 2 && this._context.lineTo(this._x, this._y), (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line >= 0 && (this._t = 1 - this._t, this._line = 1 - this._line);
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
        break;
      case 1:
        this._point = 2;
      default: {
        if (this._t <= 0)
          this._context.lineTo(this._x, t), this._context.lineTo(e, t);
        else {
          var r = this._x * (1 - this._t) + e * this._t;
          this._context.lineTo(r, this._y), this._context.lineTo(r, t);
        }
        break;
      }
    }
    this._x = e, this._y = t;
  }
};
function wj(e) {
  return new gc(e, 0.5);
}
function Oj(e) {
  return new gc(e, 0);
}
function Sj(e) {
  return new gc(e, 1);
}
function Ta(e, t) {
  if ((o = e.length) > 1)
    for (var r = 1, n, a, i = e[t[0]], o, u = i.length; r < o; ++r)
      for (a = i, i = e[t[r]], n = 0; n < u; ++n)
        i[n][1] += i[n][0] = isNaN(a[n][1]) ? a[n][0] : a[n][1];
}
function id(e) {
  for (var t = e.length, r = new Array(t); --t >= 0; ) r[t] = t;
  return r;
}
function Aj(e, t) {
  return e[t];
}
function Ej(e) {
  const t = [];
  return t.key = e, t;
}
function _j() {
  var e = Je([]), t = id, r = Ta, n = Aj;
  function a(i) {
    var o = Array.from(e.apply(this, arguments), Ej), u, s = o.length, c = -1, l;
    for (const f of i)
      for (u = 0, ++c; u < s; ++u)
        (o[u][c] = [0, +n(f, o[u].key, c, i)]).data = f;
    for (u = 0, l = np(t(o)); u < s; ++u)
      o[l[u]].index = u;
    return r(o, l), o;
  }
  return a.keys = function(i) {
    return arguments.length ? (e = typeof i == "function" ? i : Je(Array.from(i)), a) : e;
  }, a.value = function(i) {
    return arguments.length ? (n = typeof i == "function" ? i : Je(+i), a) : n;
  }, a.order = function(i) {
    return arguments.length ? (t = i == null ? id : typeof i == "function" ? i : Je(Array.from(i)), a) : t;
  }, a.offset = function(i) {
    return arguments.length ? (r = i ?? Ta, a) : r;
  }, a;
}
function Ij(e, t) {
  if ((n = e.length) > 0) {
    for (var r, n, a = 0, i = e[0].length, o; a < i; ++a) {
      for (o = r = 0; r < n; ++r) o += e[r][a][1] || 0;
      if (o) for (r = 0; r < n; ++r) e[r][a][1] /= o;
    }
    Ta(e, t);
  }
}
function Pj(e, t) {
  if ((a = e.length) > 0) {
    for (var r = 0, n = e[t[0]], a, i = n.length; r < i; ++r) {
      for (var o = 0, u = 0; o < a; ++o) u += e[o][r][1] || 0;
      n[r][1] += n[r][0] = -u / 2;
    }
    Ta(e, t);
  }
}
function Tj(e, t) {
  if (!(!((o = e.length) > 0) || !((i = (a = e[t[0]]).length) > 0))) {
    for (var r = 0, n = 1, a, i, o; n < i; ++n) {
      for (var u = 0, s = 0, c = 0; u < o; ++u) {
        for (var l = e[t[u]], f = l[n][1] || 0, d = l[n - 1][1] || 0, p = (f - d) / 2, h = 0; h < u; ++h) {
          var v = e[t[h]], g = v[n][1] || 0, b = v[n - 1][1] || 0;
          p += g - b;
        }
        s += f, c += p * f;
      }
      a[n - 1][1] += a[n - 1][0] = r, s && (r -= c / s);
    }
    a[n - 1][1] += a[n - 1][0] = r, Ta(e, t);
  }
}
function co(e) {
  "@babel/helpers - typeof";
  return co = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, co(e);
}
var Mj = ["type", "size", "sizeType"];
function od() {
  return od = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, od.apply(this, arguments);
}
function fv(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function dv(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? fv(Object(r), !0).forEach(function(n) {
      jj(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : fv(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function jj(e, t, r) {
  return t = Rj(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Rj(e) {
  var t = Nj(e, "string");
  return co(t) == "symbol" ? t : String(t);
}
function Nj(e, t) {
  if (co(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (co(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function $j(e, t) {
  if (e == null) return {};
  var r = Fj(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function Fj(e, t) {
  if (e == null) return {};
  var r = {}, n = Object.keys(e), a, i;
  for (i = 0; i < n.length; i++)
    a = n[i], !(t.indexOf(a) >= 0) && (r[a] = e[a]);
  return r;
}
var W3 = {
  symbolCircle: ap,
  symbolCross: nj,
  symbolDiamond: ij,
  symbolSquare: oj,
  symbolStar: lj,
  symbolTriangle: fj,
  symbolWye: pj
}, Dj = Math.PI / 180, kj = function(t) {
  var r = "symbol".concat(pc(t));
  return W3[r] || ap;
}, Lj = function(t, r, n) {
  if (r === "area")
    return t;
  switch (n) {
    case "cross":
      return 5 * t * t / 9;
    case "diamond":
      return 0.5 * t * t / Math.sqrt(3);
    case "square":
      return t * t;
    case "star": {
      var a = 18 * Dj;
      return 1.25 * t * t * (Math.tan(a) - Math.tan(a * 2) * Math.pow(Math.tan(a), 2));
    }
    case "triangle":
      return Math.sqrt(3) * t * t / 4;
    case "wye":
      return (21 - 10 * Math.sqrt(3)) * t * t / 8;
    default:
      return Math.PI * t * t / 4;
  }
}, Bj = function(t, r) {
  W3["symbol".concat(pc(t))] = r;
}, ip = function(t) {
  var r = t.type, n = r === void 0 ? "circle" : r, a = t.size, i = a === void 0 ? 64 : a, o = t.sizeType, u = o === void 0 ? "area" : o, s = $j(t, Mj), c = dv(dv({}, s), {}, {
    type: n,
    size: i,
    sizeType: u
  }), l = function() {
    var g = kj(n), b = hj().type(g).size(Lj(i, u, n));
    return b();
  }, f = c.className, d = c.cx, p = c.cy, h = Ie(c, !0);
  return d === +d && p === +p && i === +i ? /* @__PURE__ */ N.createElement("path", od({}, h, {
    className: Ne("recharts-symbols", f),
    transform: "translate(".concat(d, ", ").concat(p, ")"),
    d: l()
  })) : null;
};
ip.registerSymbol = Bj;
function Ma(e) {
  "@babel/helpers - typeof";
  return Ma = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ma(e);
}
function ud() {
  return ud = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, ud.apply(this, arguments);
}
function pv(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Vj(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? pv(Object(r), !0).forEach(function(n) {
      lo(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : pv(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Wj(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Gj(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, H3(n.key), n);
  }
}
function Hj(e, t, r) {
  return t && Gj(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function Uj(e, t, r) {
  return t = us(t), zj(e, G3() ? Reflect.construct(t, r || [], us(e).constructor) : t.apply(e, r));
}
function zj(e, t) {
  if (t && (Ma(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Yj(e);
}
function Yj(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function G3() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (G3 = function() {
    return !!e;
  })();
}
function us(e) {
  return us = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, us(e);
}
function Xj(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && sd(e, t);
}
function sd(e, t) {
  return sd = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, sd(e, t);
}
function lo(e, t, r) {
  return t = H3(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function H3(e) {
  var t = Zj(e, "string");
  return Ma(t) == "symbol" ? t : String(t);
}
function Zj(e, t) {
  if (Ma(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (Ma(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var tr = 32, op = /* @__PURE__ */ function(e) {
  Xj(t, e);
  function t() {
    return Wj(this, t), Uj(this, t, arguments);
  }
  return Hj(t, [{
    key: "renderIcon",
    value: (
      /**
       * Render the path of icon
       * @param {Object} data Data of each legend item
       * @return {String} Path element
       */
      function(n) {
        var a = this.props.inactiveColor, i = tr / 2, o = tr / 6, u = tr / 3, s = n.inactive ? a : n.color;
        if (n.type === "plainline")
          return /* @__PURE__ */ N.createElement("line", {
            strokeWidth: 4,
            fill: "none",
            stroke: s,
            strokeDasharray: n.payload.strokeDasharray,
            x1: 0,
            y1: i,
            x2: tr,
            y2: i,
            className: "recharts-legend-icon"
          });
        if (n.type === "line")
          return /* @__PURE__ */ N.createElement("path", {
            strokeWidth: 4,
            fill: "none",
            stroke: s,
            d: "M0,".concat(i, "h").concat(u, `
            A`).concat(o, ",").concat(o, ",0,1,1,").concat(2 * u, ",").concat(i, `
            H`).concat(tr, "M").concat(2 * u, ",").concat(i, `
            A`).concat(o, ",").concat(o, ",0,1,1,").concat(u, ",").concat(i),
            className: "recharts-legend-icon"
          });
        if (n.type === "rect")
          return /* @__PURE__ */ N.createElement("path", {
            stroke: "none",
            fill: s,
            d: "M0,".concat(tr / 8, "h").concat(tr, "v").concat(tr * 3 / 4, "h").concat(-tr, "z"),
            className: "recharts-legend-icon"
          });
        if (/* @__PURE__ */ N.isValidElement(n.legendIcon)) {
          var c = Vj({}, n);
          return delete c.legendIcon, /* @__PURE__ */ N.cloneElement(n.legendIcon, c);
        }
        return /* @__PURE__ */ N.createElement(ip, {
          fill: s,
          cx: i,
          cy: i,
          size: tr,
          sizeType: "diameter",
          type: n.type
        });
      }
    )
    /**
     * Draw items of legend
     * @return {ReactElement} Items
     */
  }, {
    key: "renderItems",
    value: function() {
      var n = this, a = this.props, i = a.payload, o = a.iconSize, u = a.layout, s = a.formatter, c = a.inactiveColor, l = {
        x: 0,
        y: 0,
        width: tr,
        height: tr
      }, f = {
        display: u === "horizontal" ? "inline-block" : "block",
        marginRight: 10
      }, d = {
        display: "inline-block",
        verticalAlign: "middle",
        marginRight: 4
      };
      return i.map(function(p, h) {
        var v = p.formatter || s, g = Ne(lo(lo({
          "recharts-legend-item": !0
        }, "legend-item-".concat(h), !0), "inactive", p.inactive));
        if (p.type === "none")
          return null;
        var b = _e(p.value) ? null : p.value;
        Ur(
          !_e(p.value),
          `The name property is also required when using a function for the dataKey of a chart's cartesian components. Ex: <Bar name="Name of my Data"/>`
          // eslint-disable-line max-len
        );
        var x = p.inactive ? c : p.color;
        return /* @__PURE__ */ N.createElement("li", ud({
          className: g,
          style: f,
          key: "legend-item-".concat(h)
        }, ts(n.props, p, h)), /* @__PURE__ */ N.createElement(Jf, {
          width: o,
          height: o,
          viewBox: l,
          style: d
        }, n.renderIcon(p)), /* @__PURE__ */ N.createElement("span", {
          className: "recharts-legend-item-text",
          style: {
            color: x
          }
        }, v ? v(b, p, h) : b));
      });
    }
  }, {
    key: "render",
    value: function() {
      var n = this.props, a = n.payload, i = n.layout, o = n.align;
      if (!a || !a.length)
        return null;
      var u = {
        padding: 0,
        margin: 0,
        textAlign: i === "horizontal" ? o : "left"
      };
      return /* @__PURE__ */ N.createElement("ul", {
        className: "recharts-default-legend",
        style: u
      }, this.renderItems());
    }
  }]), t;
}(xn);
lo(op, "displayName", "Legend");
lo(op, "defaultProps", {
  iconSize: 14,
  layout: "horizontal",
  align: "center",
  verticalAlign: "middle",
  inactiveColor: "#ccc"
});
var Kj = rc;
function qj() {
  this.__data__ = new Kj(), this.size = 0;
}
var Jj = qj;
function Qj(e) {
  var t = this.__data__, r = t.delete(e);
  return this.size = t.size, r;
}
var eR = Qj;
function tR(e) {
  return this.__data__.get(e);
}
var rR = tR;
function nR(e) {
  return this.__data__.has(e);
}
var aR = nR, iR = rc, oR = D1, uR = k1, sR = 200;
function cR(e, t) {
  var r = this.__data__;
  if (r instanceof iR) {
    var n = r.__data__;
    if (!oR || n.length < sR - 1)
      return n.push([e, t]), this.size = ++r.size, this;
    r = this.__data__ = new uR(n);
  }
  return r.set(e, t), this.size = r.size, this;
}
var lR = cR, fR = rc, dR = Jj, pR = eR, hR = rR, vR = aR, gR = lR;
function ii(e) {
  var t = this.__data__ = new fR(e);
  this.size = t.size;
}
ii.prototype.clear = dR;
ii.prototype.delete = pR;
ii.prototype.get = hR;
ii.prototype.has = vR;
ii.prototype.set = gR;
var U3 = ii, mR = "__lodash_hash_undefined__";
function yR(e) {
  return this.__data__.set(e, mR), this;
}
var bR = yR;
function xR(e) {
  return this.__data__.has(e);
}
var CR = xR, wR = k1, OR = bR, SR = CR;
function ss(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.__data__ = new wR(); ++t < r; )
    this.add(e[t]);
}
ss.prototype.add = ss.prototype.push = OR;
ss.prototype.has = SR;
var z3 = ss;
function AR(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length; ++r < n; )
    if (t(e[r], r, e))
      return !0;
  return !1;
}
var Y3 = AR;
function ER(e, t) {
  return e.has(t);
}
var X3 = ER, _R = z3, IR = Y3, PR = X3, TR = 1, MR = 2;
function jR(e, t, r, n, a, i) {
  var o = r & TR, u = e.length, s = t.length;
  if (u != s && !(o && s > u))
    return !1;
  var c = i.get(e), l = i.get(t);
  if (c && l)
    return c == t && l == e;
  var f = -1, d = !0, p = r & MR ? new _R() : void 0;
  for (i.set(e, t), i.set(t, e); ++f < u; ) {
    var h = e[f], v = t[f];
    if (n)
      var g = o ? n(v, h, f, t, e, i) : n(h, v, f, e, t, i);
    if (g !== void 0) {
      if (g)
        continue;
      d = !1;
      break;
    }
    if (p) {
      if (!IR(t, function(b, x) {
        if (!PR(p, x) && (h === b || a(h, b, r, n, i)))
          return p.push(x);
      })) {
        d = !1;
        break;
      }
    } else if (!(h === v || a(h, v, r, n, i))) {
      d = !1;
      break;
    }
  }
  return i.delete(e), i.delete(t), d;
}
var Z3 = jR, RR = Fr, NR = RR.Uint8Array, $R = NR;
function FR(e) {
  var t = -1, r = Array(e.size);
  return e.forEach(function(n, a) {
    r[++t] = [a, n];
  }), r;
}
var DR = FR;
function kR(e) {
  var t = -1, r = Array(e.size);
  return e.forEach(function(n) {
    r[++t] = n;
  }), r;
}
var up = kR, hv = Qo, vv = $R, LR = F1, BR = Z3, VR = DR, WR = up, GR = 1, HR = 2, UR = "[object Boolean]", zR = "[object Date]", YR = "[object Error]", XR = "[object Map]", ZR = "[object Number]", KR = "[object RegExp]", qR = "[object Set]", JR = "[object String]", QR = "[object Symbol]", eN = "[object ArrayBuffer]", tN = "[object DataView]", gv = hv ? hv.prototype : void 0, Ll = gv ? gv.valueOf : void 0;
function rN(e, t, r, n, a, i, o) {
  switch (r) {
    case tN:
      if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset)
        return !1;
      e = e.buffer, t = t.buffer;
    case eN:
      return !(e.byteLength != t.byteLength || !i(new vv(e), new vv(t)));
    case UR:
    case zR:
    case ZR:
      return LR(+e, +t);
    case YR:
      return e.name == t.name && e.message == t.message;
    case KR:
    case JR:
      return e == t + "";
    case XR:
      var u = VR;
    case qR:
      var s = n & GR;
      if (u || (u = WR), e.size != t.size && !s)
        return !1;
      var c = o.get(e);
      if (c)
        return c == t;
      n |= HR, o.set(e, t);
      var l = BR(u(e), u(t), n, a, i, o);
      return o.delete(e), l;
    case QR:
      if (Ll)
        return Ll.call(e) == Ll.call(t);
  }
  return !1;
}
var nN = rN;
function aN(e, t) {
  for (var r = -1, n = t.length, a = e.length; ++r < n; )
    e[a + r] = t[r];
  return e;
}
var K3 = aN, iN = K3, oN = Wt;
function uN(e, t, r) {
  var n = t(e);
  return oN(e) ? n : iN(n, r(e));
}
var sN = uN;
function cN(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length, a = 0, i = []; ++r < n; ) {
    var o = e[r];
    t(o, r, e) && (i[a++] = o);
  }
  return i;
}
var lN = cN;
function fN() {
  return [];
}
var dN = fN, pN = lN, hN = dN, vN = Object.prototype, gN = vN.propertyIsEnumerable, mv = Object.getOwnPropertySymbols, mN = mv ? function(e) {
  return e == null ? [] : (e = Object(e), pN(mv(e), function(t) {
    return gN.call(e, t);
  }));
} : hN, yN = mN;
function bN(e, t) {
  for (var r = -1, n = Array(e); ++r < e; )
    n[r] = t(r);
  return n;
}
var xN = bN, CN = en, wN = tn, ON = "[object Arguments]";
function SN(e) {
  return wN(e) && CN(e) == ON;
}
var AN = SN, yv = AN, EN = tn, q3 = Object.prototype, _N = q3.hasOwnProperty, IN = q3.propertyIsEnumerable, PN = yv(/* @__PURE__ */ function() {
  return arguments;
}()) ? yv : function(e) {
  return EN(e) && _N.call(e, "callee") && !IN.call(e, "callee");
}, sp = PN, cs = { exports: {} };
function TN() {
  return !1;
}
var MN = TN;
cs.exports;
(function(e, t) {
  var r = Fr, n = MN, a = t && !t.nodeType && t, i = a && !0 && e && !e.nodeType && e, o = i && i.exports === a, u = o ? r.Buffer : void 0, s = u ? u.isBuffer : void 0, c = s || n;
  e.exports = c;
})(cs, cs.exports);
var J3 = cs.exports, jN = 9007199254740991, RN = /^(?:0|[1-9]\d*)$/;
function NN(e, t) {
  var r = typeof e;
  return t = t ?? jN, !!t && (r == "number" || r != "symbol" && RN.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
var cp = NN, $N = 9007199254740991;
function FN(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= $N;
}
var lp = FN, DN = en, kN = lp, LN = tn, BN = "[object Arguments]", VN = "[object Array]", WN = "[object Boolean]", GN = "[object Date]", HN = "[object Error]", UN = "[object Function]", zN = "[object Map]", YN = "[object Number]", XN = "[object Object]", ZN = "[object RegExp]", KN = "[object Set]", qN = "[object String]", JN = "[object WeakMap]", QN = "[object ArrayBuffer]", e$ = "[object DataView]", t$ = "[object Float32Array]", r$ = "[object Float64Array]", n$ = "[object Int8Array]", a$ = "[object Int16Array]", i$ = "[object Int32Array]", o$ = "[object Uint8Array]", u$ = "[object Uint8ClampedArray]", s$ = "[object Uint16Array]", c$ = "[object Uint32Array]", et = {};
et[t$] = et[r$] = et[n$] = et[a$] = et[i$] = et[o$] = et[u$] = et[s$] = et[c$] = !0;
et[BN] = et[VN] = et[QN] = et[WN] = et[e$] = et[GN] = et[HN] = et[UN] = et[zN] = et[YN] = et[XN] = et[ZN] = et[KN] = et[qN] = et[JN] = !1;
function l$(e) {
  return LN(e) && kN(e.length) && !!et[DN(e)];
}
var f$ = l$;
function d$(e) {
  return function(t) {
    return e(t);
  };
}
var Q3 = d$, ls = { exports: {} };
ls.exports;
(function(e, t) {
  var r = Jy, n = t && !t.nodeType && t, a = n && !0 && e && !e.nodeType && e, i = a && a.exports === n, o = i && r.process, u = function() {
    try {
      var s = a && a.require && a.require("util").types;
      return s || o && o.binding && o.binding("util");
    } catch {
    }
  }();
  e.exports = u;
})(ls, ls.exports);
var p$ = ls.exports, h$ = f$, v$ = Q3, bv = p$, xv = bv && bv.isTypedArray, g$ = xv ? v$(xv) : h$, e4 = g$, m$ = xN, y$ = sp, b$ = Wt, x$ = J3, C$ = cp, w$ = e4, O$ = Object.prototype, S$ = O$.hasOwnProperty;
function A$(e, t) {
  var r = b$(e), n = !r && y$(e), a = !r && !n && x$(e), i = !r && !n && !a && w$(e), o = r || n || a || i, u = o ? m$(e.length, String) : [], s = u.length;
  for (var c in e)
    (t || S$.call(e, c)) && !(o && // Safari 9 has enumerable `arguments.length` in strict mode.
    (c == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    a && (c == "offset" || c == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    i && (c == "buffer" || c == "byteLength" || c == "byteOffset") || // Skip index properties.
    C$(c, s))) && u.push(c);
  return u;
}
var E$ = A$, _$ = Object.prototype;
function I$(e) {
  var t = e && e.constructor, r = typeof t == "function" && t.prototype || _$;
  return e === r;
}
var P$ = I$;
function T$(e, t) {
  return function(r) {
    return e(t(r));
  };
}
var t4 = T$, M$ = t4, j$ = M$(Object.keys, Object), R$ = j$, N$ = P$, $$ = R$, F$ = Object.prototype, D$ = F$.hasOwnProperty;
function k$(e) {
  if (!N$(e))
    return $$(e);
  var t = [];
  for (var r in Object(e))
    D$.call(e, r) && r != "constructor" && t.push(r);
  return t;
}
var L$ = k$, B$ = $1, V$ = lp;
function W$(e) {
  return e != null && V$(e.length) && !B$(e);
}
var nu = W$, G$ = E$, H$ = L$, U$ = nu;
function z$(e) {
  return U$(e) ? G$(e) : H$(e);
}
var mc = z$, Y$ = sN, X$ = yN, Z$ = mc;
function K$(e) {
  return Y$(e, Z$, X$);
}
var q$ = K$, Cv = q$, J$ = 1, Q$ = Object.prototype, eF = Q$.hasOwnProperty;
function tF(e, t, r, n, a, i) {
  var o = r & J$, u = Cv(e), s = u.length, c = Cv(t), l = c.length;
  if (s != l && !o)
    return !1;
  for (var f = s; f--; ) {
    var d = u[f];
    if (!(o ? d in t : eF.call(t, d)))
      return !1;
  }
  var p = i.get(e), h = i.get(t);
  if (p && h)
    return p == t && h == e;
  var v = !0;
  i.set(e, t), i.set(t, e);
  for (var g = o; ++f < s; ) {
    d = u[f];
    var b = e[d], x = t[d];
    if (n)
      var w = o ? n(x, b, d, t, e, i) : n(b, x, d, e, t, i);
    if (!(w === void 0 ? b === x || a(b, x, r, n, i) : w)) {
      v = !1;
      break;
    }
    g || (g = d == "constructor");
  }
  if (v && !g) {
    var y = e.constructor, m = t.constructor;
    y != m && "constructor" in e && "constructor" in t && !(typeof y == "function" && y instanceof y && typeof m == "function" && m instanceof m) && (v = !1);
  }
  return i.delete(e), i.delete(t), v;
}
var rF = tF, nF = Qn, aF = Fr, iF = nF(aF, "DataView"), oF = iF, uF = Qn, sF = Fr, cF = uF(sF, "Promise"), lF = cF, fF = Qn, dF = Fr, pF = fF(dF, "Set"), r4 = pF, hF = Qn, vF = Fr, gF = hF(vF, "WeakMap"), mF = gF, cd = oF, ld = D1, fd = lF, dd = r4, pd = mF, n4 = en, oi = eb, wv = "[object Map]", yF = "[object Object]", Ov = "[object Promise]", Sv = "[object Set]", Av = "[object WeakMap]", Ev = "[object DataView]", bF = oi(cd), xF = oi(ld), CF = oi(fd), wF = oi(dd), OF = oi(pd), Nn = n4;
(cd && Nn(new cd(new ArrayBuffer(1))) != Ev || ld && Nn(new ld()) != wv || fd && Nn(fd.resolve()) != Ov || dd && Nn(new dd()) != Sv || pd && Nn(new pd()) != Av) && (Nn = function(e) {
  var t = n4(e), r = t == yF ? e.constructor : void 0, n = r ? oi(r) : "";
  if (n)
    switch (n) {
      case bF:
        return Ev;
      case xF:
        return wv;
      case CF:
        return Ov;
      case wF:
        return Sv;
      case OF:
        return Av;
    }
  return t;
});
var SF = Nn, Bl = U3, AF = Z3, EF = nN, _F = rF, _v = SF, Iv = Wt, Pv = J3, IF = e4, PF = 1, Tv = "[object Arguments]", Mv = "[object Array]", Cu = "[object Object]", TF = Object.prototype, jv = TF.hasOwnProperty;
function MF(e, t, r, n, a, i) {
  var o = Iv(e), u = Iv(t), s = o ? Mv : _v(e), c = u ? Mv : _v(t);
  s = s == Tv ? Cu : s, c = c == Tv ? Cu : c;
  var l = s == Cu, f = c == Cu, d = s == c;
  if (d && Pv(e)) {
    if (!Pv(t))
      return !1;
    o = !0, l = !1;
  }
  if (d && !l)
    return i || (i = new Bl()), o || IF(e) ? AF(e, t, r, n, a, i) : EF(e, t, s, r, n, a, i);
  if (!(r & PF)) {
    var p = l && jv.call(e, "__wrapped__"), h = f && jv.call(t, "__wrapped__");
    if (p || h) {
      var v = p ? e.value() : e, g = h ? t.value() : t;
      return i || (i = new Bl()), a(v, g, r, n, i);
    }
  }
  return d ? (i || (i = new Bl()), _F(e, t, r, n, a, i)) : !1;
}
var jF = MF, RF = jF, Rv = tn;
function a4(e, t, r, n, a) {
  return e === t ? !0 : e == null || t == null || !Rv(e) && !Rv(t) ? e !== e && t !== t : RF(e, t, r, n, a4, a);
}
var fp = a4, NF = U3, $F = fp, FF = 1, DF = 2;
function kF(e, t, r, n) {
  var a = r.length, i = a, o = !n;
  if (e == null)
    return !i;
  for (e = Object(e); a--; ) {
    var u = r[a];
    if (o && u[2] ? u[1] !== e[u[0]] : !(u[0] in e))
      return !1;
  }
  for (; ++a < i; ) {
    u = r[a];
    var s = u[0], c = e[s], l = u[1];
    if (o && u[2]) {
      if (c === void 0 && !(s in e))
        return !1;
    } else {
      var f = new NF();
      if (n)
        var d = n(c, l, s, e, t, f);
      if (!(d === void 0 ? $F(l, c, FF | DF, n, f) : d))
        return !1;
    }
  }
  return !0;
}
var LF = kF, BF = wn;
function VF(e) {
  return e === e && !BF(e);
}
var i4 = VF, WF = i4, GF = mc;
function HF(e) {
  for (var t = GF(e), r = t.length; r--; ) {
    var n = t[r], a = e[n];
    t[r] = [n, a, WF(a)];
  }
  return t;
}
var UF = HF;
function zF(e, t) {
  return function(r) {
    return r == null ? !1 : r[e] === t && (t !== void 0 || e in Object(r));
  };
}
var o4 = zF, YF = LF, XF = UF, ZF = o4;
function KF(e) {
  var t = XF(e);
  return t.length == 1 && t[0][2] ? ZF(t[0][0], t[0][1]) : function(r) {
    return r === e || YF(r, e, t);
  };
}
var qF = KF;
function JF(e, t) {
  return e != null && t in Object(e);
}
var QF = JF, eD = ab, tD = sp, rD = Wt, nD = cp, aD = lp, iD = ic;
function oD(e, t, r) {
  t = eD(t, e);
  for (var n = -1, a = t.length, i = !1; ++n < a; ) {
    var o = iD(t[n]);
    if (!(i = e != null && r(e, o)))
      break;
    e = e[o];
  }
  return i || ++n != a ? i : (a = e == null ? 0 : e.length, !!a && aD(a) && nD(o, a) && (rD(e) || tD(e)));
}
var uD = oD, sD = QF, cD = uD;
function lD(e, t) {
  return e != null && cD(e, t, sD);
}
var fD = lD, dD = fp, pD = ib, hD = fD, vD = N1, gD = i4, mD = o4, yD = ic, bD = 1, xD = 2;
function CD(e, t) {
  return vD(e) && gD(t) ? mD(yD(e), t) : function(r) {
    var n = pD(r, e);
    return n === void 0 && n === t ? hD(r, e) : dD(t, n, bD | xD);
  };
}
var wD = CD;
function OD(e) {
  return e;
}
var ui = OD;
function SD(e) {
  return function(t) {
    return t == null ? void 0 : t[e];
  };
}
var AD = SD, ED = V1;
function _D(e) {
  return function(t) {
    return ED(t, e);
  };
}
var ID = _D, PD = AD, TD = ID, MD = N1, jD = ic;
function RD(e) {
  return MD(e) ? PD(jD(e)) : TD(e);
}
var ND = RD, $D = qF, FD = wD, DD = ui, kD = Wt, LD = ND;
function BD(e) {
  return typeof e == "function" ? e : e == null ? DD : typeof e == "object" ? kD(e) ? FD(e[0], e[1]) : $D(e) : LD(e);
}
var On = BD;
function VD(e, t, r, n) {
  for (var a = e.length, i = r + (n ? 1 : -1); n ? i-- : ++i < a; )
    if (t(e[i], i, e))
      return i;
  return -1;
}
var u4 = VD;
function WD(e) {
  return e !== e;
}
var GD = WD;
function HD(e, t, r) {
  for (var n = r - 1, a = e.length; ++n < a; )
    if (e[n] === t)
      return n;
  return -1;
}
var UD = HD, zD = u4, YD = GD, XD = UD;
function ZD(e, t, r) {
  return t === t ? XD(e, t, r) : zD(e, YD, r);
}
var KD = ZD, qD = KD;
function JD(e, t) {
  var r = e == null ? 0 : e.length;
  return !!r && qD(e, t, 0) > -1;
}
var QD = JD;
function ek(e, t, r) {
  for (var n = -1, a = e == null ? 0 : e.length; ++n < a; )
    if (r(t, e[n]))
      return !0;
  return !1;
}
var tk = ek;
function rk() {
}
var nk = rk, Vl = r4, ak = nk, ik = up, ok = 1 / 0, uk = Vl && 1 / ik(new Vl([, -0]))[1] == ok ? function(e) {
  return new Vl(e);
} : ak, sk = uk, ck = z3, lk = QD, fk = tk, dk = X3, pk = sk, hk = up, vk = 200;
function gk(e, t, r) {
  var n = -1, a = lk, i = e.length, o = !0, u = [], s = u;
  if (r)
    o = !1, a = fk;
  else if (i >= vk) {
    var c = t ? null : pk(e);
    if (c)
      return hk(c);
    o = !1, a = dk, s = new ck();
  } else
    s = t ? [] : u;
  e:
    for (; ++n < i; ) {
      var l = e[n], f = t ? t(l) : l;
      if (l = r || l !== 0 ? l : 0, o && f === f) {
        for (var d = s.length; d--; )
          if (s[d] === f)
            continue e;
        t && s.push(f), u.push(l);
      } else a(s, f, r) || (s !== u && s.push(f), u.push(l));
    }
  return u;
}
var mk = gk, yk = On, bk = mk;
function xk(e, t) {
  return e && e.length ? bk(e, yk(t)) : [];
}
var Ck = xk;
const Nv = /* @__PURE__ */ Fe(Ck);
function s4(e, t, r) {
  return t === !0 ? Nv(e, r) : _e(t) ? Nv(e, t) : e;
}
function ja(e) {
  "@babel/helpers - typeof";
  return ja = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ja(e);
}
var wk = ["ref"];
function $v(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function jn(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? $v(Object(r), !0).forEach(function(n) {
      yc(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : $v(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Ok(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Fv(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, f4(n.key), n);
  }
}
function Sk(e, t, r) {
  return t && Fv(e.prototype, t), r && Fv(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function Ak(e, t, r) {
  return t = fs(t), Ek(e, c4() ? Reflect.construct(t, r || [], fs(e).constructor) : t.apply(e, r));
}
function Ek(e, t) {
  if (t && (ja(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return l4(e);
}
function c4() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (c4 = function() {
    return !!e;
  })();
}
function fs(e) {
  return fs = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, fs(e);
}
function l4(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _k(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && hd(e, t);
}
function hd(e, t) {
  return hd = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, hd(e, t);
}
function yc(e, t, r) {
  return t = f4(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function f4(e) {
  var t = Ik(e, "string");
  return ja(t) == "symbol" ? t : String(t);
}
function Ik(e, t) {
  if (ja(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (ja(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Pk(e, t) {
  if (e == null) return {};
  var r = Tk(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function Tk(e, t) {
  if (e == null) return {};
  var r = {}, n = Object.keys(e), a, i;
  for (i = 0; i < n.length; i++)
    a = n[i], !(t.indexOf(a) >= 0) && (r[a] = e[a]);
  return r;
}
function Mk(e) {
  return e.value;
}
function jk(e, t) {
  if (/* @__PURE__ */ N.isValidElement(e))
    return /* @__PURE__ */ N.cloneElement(e, t);
  if (typeof e == "function")
    return /* @__PURE__ */ N.createElement(e, t);
  t.ref;
  var r = Pk(t, wk);
  return /* @__PURE__ */ N.createElement(op, r);
}
var Dv = 1, Ra = /* @__PURE__ */ function(e) {
  _k(t, e);
  function t() {
    var r;
    Ok(this, t);
    for (var n = arguments.length, a = new Array(n), i = 0; i < n; i++)
      a[i] = arguments[i];
    return r = Ak(this, t, [].concat(a)), yc(l4(r), "lastBoundingBox", {
      width: -1,
      height: -1
    }), r;
  }
  return Sk(t, [{
    key: "componentDidMount",
    value: function() {
      this.updateBBox();
    }
  }, {
    key: "componentDidUpdate",
    value: function() {
      this.updateBBox();
    }
  }, {
    key: "getBBox",
    value: function() {
      if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
        var n = this.wrapperNode.getBoundingClientRect();
        return n.height = this.wrapperNode.offsetHeight, n.width = this.wrapperNode.offsetWidth, n;
      }
      return null;
    }
  }, {
    key: "updateBBox",
    value: function() {
      var n = this.props.onBBoxUpdate, a = this.getBBox();
      a ? (Math.abs(a.width - this.lastBoundingBox.width) > Dv || Math.abs(a.height - this.lastBoundingBox.height) > Dv) && (this.lastBoundingBox.width = a.width, this.lastBoundingBox.height = a.height, n && n(a)) : (this.lastBoundingBox.width !== -1 || this.lastBoundingBox.height !== -1) && (this.lastBoundingBox.width = -1, this.lastBoundingBox.height = -1, n && n(null));
    }
  }, {
    key: "getBBoxSnapshot",
    value: function() {
      return this.lastBoundingBox.width >= 0 && this.lastBoundingBox.height >= 0 ? jn({}, this.lastBoundingBox) : {
        width: 0,
        height: 0
      };
    }
  }, {
    key: "getDefaultPosition",
    value: function(n) {
      var a = this.props, i = a.layout, o = a.align, u = a.verticalAlign, s = a.margin, c = a.chartWidth, l = a.chartHeight, f, d;
      if (!n || (n.left === void 0 || n.left === null) && (n.right === void 0 || n.right === null))
        if (o === "center" && i === "vertical") {
          var p = this.getBBoxSnapshot();
          f = {
            left: ((c || 0) - p.width) / 2
          };
        } else
          f = o === "right" ? {
            right: s && s.right || 0
          } : {
            left: s && s.left || 0
          };
      if (!n || (n.top === void 0 || n.top === null) && (n.bottom === void 0 || n.bottom === null))
        if (u === "middle") {
          var h = this.getBBoxSnapshot();
          d = {
            top: ((l || 0) - h.height) / 2
          };
        } else
          d = u === "bottom" ? {
            bottom: s && s.bottom || 0
          } : {
            top: s && s.top || 0
          };
      return jn(jn({}, f), d);
    }
  }, {
    key: "render",
    value: function() {
      var n = this, a = this.props, i = a.content, o = a.width, u = a.height, s = a.wrapperStyle, c = a.payloadUniqBy, l = a.payload, f = jn(jn({
        position: "absolute",
        width: o || "auto",
        height: u || "auto"
      }, this.getDefaultPosition(s)), s);
      return /* @__PURE__ */ N.createElement("div", {
        className: "recharts-legend-wrapper",
        style: f,
        ref: function(p) {
          n.wrapperNode = p;
        }
      }, jk(i, jn(jn({}, this.props), {}, {
        payload: s4(l, c, Mk)
      })));
    }
  }], [{
    key: "getWithHeight",
    value: function(n, a) {
      var i = n.props.layout;
      return i === "vertical" && oe(n.props.height) ? {
        height: n.props.height
      } : i === "horizontal" ? {
        width: n.props.width || a
      } : null;
    }
  }]), t;
}(xn);
yc(Ra, "displayName", "Legend");
yc(Ra, "defaultProps", {
  iconSize: 14,
  layout: "horizontal",
  align: "center",
  verticalAlign: "bottom"
});
var kv = Qo, Rk = sp, Nk = Wt, Lv = kv ? kv.isConcatSpreadable : void 0;
function $k(e) {
  return Nk(e) || Rk(e) || !!(Lv && e && e[Lv]);
}
var Fk = $k, Dk = K3, kk = Fk;
function d4(e, t, r, n, a) {
  var i = -1, o = e.length;
  for (r || (r = kk), a || (a = []); ++i < o; ) {
    var u = e[i];
    t > 0 && r(u) ? t > 1 ? d4(u, t - 1, r, n, a) : Dk(a, u) : n || (a[a.length] = u);
  }
  return a;
}
var p4 = d4;
function Lk(e) {
  return function(t, r, n) {
    for (var a = -1, i = Object(t), o = n(t), u = o.length; u--; ) {
      var s = o[e ? u : ++a];
      if (r(i[s], s, i) === !1)
        break;
    }
    return t;
  };
}
var Bk = Lk, Vk = Bk, Wk = Vk(), Gk = Wk, Hk = Gk, Uk = mc;
function zk(e, t) {
  return e && Hk(e, t, Uk);
}
var h4 = zk, Yk = nu;
function Xk(e, t) {
  return function(r, n) {
    if (r == null)
      return r;
    if (!Yk(r))
      return e(r, n);
    for (var a = r.length, i = t ? a : -1, o = Object(r); (t ? i-- : ++i < a) && n(o[i], i, o) !== !1; )
      ;
    return r;
  };
}
var Zk = Xk, Kk = h4, qk = Zk, Jk = qk(Kk), dp = Jk, Qk = dp, eL = nu;
function tL(e, t) {
  var r = -1, n = eL(e) ? Array(e.length) : [];
  return Qk(e, function(a, i, o) {
    n[++r] = t(a, i, o);
  }), n;
}
var v4 = tL;
function rL(e, t) {
  var r = e.length;
  for (e.sort(t); r--; )
    e[r] = e[r].value;
  return e;
}
var nL = rL, Bv = qa;
function aL(e, t) {
  if (e !== t) {
    var r = e !== void 0, n = e === null, a = e === e, i = Bv(e), o = t !== void 0, u = t === null, s = t === t, c = Bv(t);
    if (!u && !c && !i && e > t || i && o && s && !u && !c || n && o && s || !r && s || !a)
      return 1;
    if (!n && !i && !c && e < t || c && r && a && !n && !i || u && r && a || !o && a || !s)
      return -1;
  }
  return 0;
}
var iL = aL, oL = iL;
function uL(e, t, r) {
  for (var n = -1, a = e.criteria, i = t.criteria, o = a.length, u = r.length; ++n < o; ) {
    var s = oL(a[n], i[n]);
    if (s) {
      if (n >= u)
        return s;
      var c = r[n];
      return s * (c == "desc" ? -1 : 1);
    }
  }
  return e.index - t.index;
}
var sL = uL, Wl = B1, cL = V1, lL = On, fL = v4, dL = nL, pL = Q3, hL = sL, vL = ui, gL = Wt;
function mL(e, t, r) {
  t.length ? t = Wl(t, function(i) {
    return gL(i) ? function(o) {
      return cL(o, i.length === 1 ? i[0] : i);
    } : i;
  }) : t = [vL];
  var n = -1;
  t = Wl(t, pL(lL));
  var a = fL(e, function(i, o, u) {
    var s = Wl(t, function(c) {
      return c(i);
    });
    return { criteria: s, index: ++n, value: i };
  });
  return dL(a, function(i, o) {
    return hL(i, o, r);
  });
}
var yL = mL;
function bL(e, t, r) {
  switch (r.length) {
    case 0:
      return e.call(t);
    case 1:
      return e.call(t, r[0]);
    case 2:
      return e.call(t, r[0], r[1]);
    case 3:
      return e.call(t, r[0], r[1], r[2]);
  }
  return e.apply(t, r);
}
var xL = bL, CL = xL, Vv = Math.max;
function wL(e, t, r) {
  return t = Vv(t === void 0 ? e.length - 1 : t, 0), function() {
    for (var n = arguments, a = -1, i = Vv(n.length - t, 0), o = Array(i); ++a < i; )
      o[a] = n[t + a];
    a = -1;
    for (var u = Array(t + 1); ++a < t; )
      u[a] = n[a];
    return u[t] = r(o), CL(e, this, u);
  };
}
var OL = wL;
function SL(e) {
  return function() {
    return e;
  };
}
var AL = SL, EL = Qn, _L = function() {
  try {
    var e = EL(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
}(), g4 = _L, IL = AL, Wv = g4, PL = ui, TL = Wv ? function(e, t) {
  return Wv(e, "toString", {
    configurable: !0,
    enumerable: !1,
    value: IL(t),
    writable: !0
  });
} : PL, ML = TL, jL = 800, RL = 16, NL = Date.now;
function $L(e) {
  var t = 0, r = 0;
  return function() {
    var n = NL(), a = RL - (n - r);
    if (r = n, a > 0) {
      if (++t >= jL)
        return arguments[0];
    } else
      t = 0;
    return e.apply(void 0, arguments);
  };
}
var FL = $L, DL = ML, kL = FL, LL = kL(DL), BL = LL, VL = ui, WL = OL, GL = BL;
function HL(e, t) {
  return GL(WL(e, t, VL), e + "");
}
var UL = HL, zL = F1, YL = nu, XL = cp, ZL = wn;
function KL(e, t, r) {
  if (!ZL(r))
    return !1;
  var n = typeof t;
  return (n == "number" ? YL(r) && XL(t, r.length) : n == "string" && t in r) ? zL(r[t], e) : !1;
}
var bc = KL, qL = p4, JL = yL, QL = UL, Gv = bc, eB = QL(function(e, t) {
  if (e == null)
    return [];
  var r = t.length;
  return r > 1 && Gv(e, t[0], t[1]) ? t = [] : r > 2 && Gv(t[0], t[1], t[2]) && (t = [t[0]]), JL(e, qL(t, 1), []);
}), tB = eB;
const pp = /* @__PURE__ */ Fe(tB);
function fo(e) {
  "@babel/helpers - typeof";
  return fo = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, fo(e);
}
function vd() {
  return vd = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, vd.apply(this, arguments);
}
function rB(e, t) {
  return oB(e) || iB(e, t) || aB(e, t) || nB();
}
function nB() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function aB(e, t) {
  if (e) {
    if (typeof e == "string") return Hv(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Hv(e, t);
  }
}
function Hv(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function iB(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, a, i, o, u = [], s = !0, c = !1;
    try {
      if (i = (r = r.call(e)).next, t !== 0) for (; !(s = (n = i.call(r)).done) && (u.push(n.value), u.length !== t); s = !0) ;
    } catch (l) {
      c = !0, a = l;
    } finally {
      try {
        if (!s && r.return != null && (o = r.return(), Object(o) !== o)) return;
      } finally {
        if (c) throw a;
      }
    }
    return u;
  }
}
function oB(e) {
  if (Array.isArray(e)) return e;
}
function Uv(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Gl(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Uv(Object(r), !0).forEach(function(n) {
      uB(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Uv(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function uB(e, t, r) {
  return t = sB(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function sB(e) {
  var t = cB(e, "string");
  return fo(t) == "symbol" ? t : String(t);
}
function cB(e, t) {
  if (fo(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (fo(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function lB(e) {
  return Array.isArray(e) && gt(e[0]) && gt(e[1]) ? e.join(" ~ ") : e;
}
var fB = function(t) {
  var r = t.separator, n = r === void 0 ? " : " : r, a = t.contentStyle, i = a === void 0 ? {} : a, o = t.itemStyle, u = o === void 0 ? {} : o, s = t.labelStyle, c = s === void 0 ? {} : s, l = t.payload, f = t.formatter, d = t.itemSorter, p = t.wrapperClassName, h = t.labelClassName, v = t.label, g = t.labelFormatter, b = t.accessibilityLayer, x = b === void 0 ? !1 : b, w = function() {
    if (l && l.length) {
      var M = {
        padding: 0,
        margin: 0
      }, I = (d ? pp(l, d) : l).map(function(G, Y) {
        if (G.type === "none")
          return null;
        var L = Gl({
          display: "block",
          paddingTop: 4,
          paddingBottom: 4,
          color: G.color || "#000"
        }, u), X = G.formatter || f || lB, q = G.value, re = G.name, j = q, W = re;
        if (X && j != null && W != null) {
          var D = X(q, re, G, Y, l);
          if (Array.isArray(D)) {
            var R = rB(D, 2);
            j = R[0], W = R[1];
          } else
            j = D;
        }
        return (
          // eslint-disable-next-line react/no-array-index-key
          /* @__PURE__ */ N.createElement("li", {
            className: "recharts-tooltip-item",
            key: "tooltip-item-".concat(Y),
            style: L
          }, gt(W) ? /* @__PURE__ */ N.createElement("span", {
            className: "recharts-tooltip-item-name"
          }, W) : null, gt(W) ? /* @__PURE__ */ N.createElement("span", {
            className: "recharts-tooltip-item-separator"
          }, n) : null, /* @__PURE__ */ N.createElement("span", {
            className: "recharts-tooltip-item-value"
          }, j), /* @__PURE__ */ N.createElement("span", {
            className: "recharts-tooltip-item-unit"
          }, G.unit || ""))
        );
      });
      return /* @__PURE__ */ N.createElement("ul", {
        className: "recharts-tooltip-item-list",
        style: M
      }, I);
    }
    return null;
  }, y = Gl({
    margin: 0,
    padding: 10,
    backgroundColor: "#fff",
    border: "1px solid #ccc",
    whiteSpace: "nowrap"
  }, i), m = Gl({
    margin: 0
  }, c), C = !Me(v), O = C ? v : "", S = Ne("recharts-default-tooltip", p), A = Ne("recharts-tooltip-label", h);
  C && g && l !== void 0 && l !== null && (O = g(v, l));
  var P = x ? {
    role: "status",
    "aria-live": "assertive"
  } : {};
  return /* @__PURE__ */ N.createElement("div", vd({
    className: S,
    style: y
  }, P), /* @__PURE__ */ N.createElement("p", {
    className: A,
    style: m
  }, /* @__PURE__ */ N.isValidElement(O) ? O : "".concat(O)), w());
};
function po(e) {
  "@babel/helpers - typeof";
  return po = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, po(e);
}
function wu(e, t, r) {
  return t = dB(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function dB(e) {
  var t = pB(e, "string");
  return po(t) == "symbol" ? t : String(t);
}
function pB(e, t) {
  if (po(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (po(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var _i = "recharts-tooltip-wrapper", hB = {
  visibility: "hidden"
};
function vB(e) {
  var t = e.coordinate, r = e.translateX, n = e.translateY;
  return Ne(_i, wu(wu(wu(wu({}, "".concat(_i, "-right"), oe(r) && t && oe(t.x) && r >= t.x), "".concat(_i, "-left"), oe(r) && t && oe(t.x) && r < t.x), "".concat(_i, "-bottom"), oe(n) && t && oe(t.y) && n >= t.y), "".concat(_i, "-top"), oe(n) && t && oe(t.y) && n < t.y));
}
function zv(e) {
  var t = e.allowEscapeViewBox, r = e.coordinate, n = e.key, a = e.offsetTopLeft, i = e.position, o = e.reverseDirection, u = e.tooltipDimension, s = e.viewBox, c = e.viewBoxDimension;
  if (i && oe(i[n]))
    return i[n];
  var l = r[n] - u - a, f = r[n] + a;
  if (t[n])
    return o[n] ? l : f;
  if (o[n]) {
    var d = l, p = s[n];
    return d < p ? Math.max(f, s[n]) : Math.max(l, s[n]);
  }
  var h = f + u, v = s[n] + c;
  return h > v ? Math.max(l, s[n]) : Math.max(f, s[n]);
}
function gB(e) {
  var t = e.translateX, r = e.translateY, n = e.useTranslate3d;
  return {
    transform: n ? "translate3d(".concat(t, "px, ").concat(r, "px, 0)") : "translate(".concat(t, "px, ").concat(r, "px)")
  };
}
function mB(e) {
  var t = e.allowEscapeViewBox, r = e.coordinate, n = e.offsetTopLeft, a = e.position, i = e.reverseDirection, o = e.tooltipBox, u = e.useTranslate3d, s = e.viewBox, c, l, f;
  return o.height > 0 && o.width > 0 && r ? (l = zv({
    allowEscapeViewBox: t,
    coordinate: r,
    key: "x",
    offsetTopLeft: n,
    position: a,
    reverseDirection: i,
    tooltipDimension: o.width,
    viewBox: s,
    viewBoxDimension: s.width
  }), f = zv({
    allowEscapeViewBox: t,
    coordinate: r,
    key: "y",
    offsetTopLeft: n,
    position: a,
    reverseDirection: i,
    tooltipDimension: o.height,
    viewBox: s,
    viewBoxDimension: s.height
  }), c = gB({
    translateX: l,
    translateY: f,
    useTranslate3d: u
  })) : c = hB, {
    cssProperties: c,
    cssClasses: vB({
      translateX: l,
      translateY: f,
      coordinate: r
    })
  };
}
function Na(e) {
  "@babel/helpers - typeof";
  return Na = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Na(e);
}
function Yv(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Xv(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Yv(Object(r), !0).forEach(function(n) {
      yd(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Yv(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function yB(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function bB(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, y4(n.key), n);
  }
}
function xB(e, t, r) {
  return t && bB(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function CB(e, t, r) {
  return t = ds(t), wB(e, m4() ? Reflect.construct(t, r || [], ds(e).constructor) : t.apply(e, r));
}
function wB(e, t) {
  if (t && (Na(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return gd(e);
}
function m4() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (m4 = function() {
    return !!e;
  })();
}
function ds(e) {
  return ds = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, ds(e);
}
function gd(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function OB(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && md(e, t);
}
function md(e, t) {
  return md = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, md(e, t);
}
function yd(e, t, r) {
  return t = y4(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function y4(e) {
  var t = SB(e, "string");
  return Na(t) == "symbol" ? t : String(t);
}
function SB(e, t) {
  if (Na(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (Na(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var Zv = 1, AB = /* @__PURE__ */ function(e) {
  OB(t, e);
  function t() {
    var r;
    yB(this, t);
    for (var n = arguments.length, a = new Array(n), i = 0; i < n; i++)
      a[i] = arguments[i];
    return r = CB(this, t, [].concat(a)), yd(gd(r), "state", {
      dismissed: !1,
      dismissedAtCoordinate: {
        x: 0,
        y: 0
      },
      lastBoundingBox: {
        width: -1,
        height: -1
      }
    }), yd(gd(r), "handleKeyDown", function(o) {
      if (o.key === "Escape") {
        var u, s, c, l;
        r.setState({
          dismissed: !0,
          dismissedAtCoordinate: {
            x: (u = (s = r.props.coordinate) === null || s === void 0 ? void 0 : s.x) !== null && u !== void 0 ? u : 0,
            y: (c = (l = r.props.coordinate) === null || l === void 0 ? void 0 : l.y) !== null && c !== void 0 ? c : 0
          }
        });
      }
    }), r;
  }
  return xB(t, [{
    key: "updateBBox",
    value: function() {
      if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
        var n = this.wrapperNode.getBoundingClientRect();
        (Math.abs(n.width - this.state.lastBoundingBox.width) > Zv || Math.abs(n.height - this.state.lastBoundingBox.height) > Zv) && this.setState({
          lastBoundingBox: {
            width: n.width,
            height: n.height
          }
        });
      } else (this.state.lastBoundingBox.width !== -1 || this.state.lastBoundingBox.height !== -1) && this.setState({
        lastBoundingBox: {
          width: -1,
          height: -1
        }
      });
    }
  }, {
    key: "componentDidMount",
    value: function() {
      document.addEventListener("keydown", this.handleKeyDown), this.updateBBox();
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      document.removeEventListener("keydown", this.handleKeyDown);
    }
  }, {
    key: "componentDidUpdate",
    value: function() {
      var n, a;
      this.props.active && this.updateBBox(), this.state.dismissed && (((n = this.props.coordinate) === null || n === void 0 ? void 0 : n.x) !== this.state.dismissedAtCoordinate.x || ((a = this.props.coordinate) === null || a === void 0 ? void 0 : a.y) !== this.state.dismissedAtCoordinate.y) && (this.state.dismissed = !1);
    }
  }, {
    key: "render",
    value: function() {
      var n = this, a = this.props, i = a.active, o = a.allowEscapeViewBox, u = a.animationDuration, s = a.animationEasing, c = a.children, l = a.coordinate, f = a.hasPayload, d = a.isAnimationActive, p = a.offset, h = a.position, v = a.reverseDirection, g = a.useTranslate3d, b = a.viewBox, x = a.wrapperStyle, w = mB({
        allowEscapeViewBox: o,
        coordinate: l,
        offsetTopLeft: p,
        position: h,
        reverseDirection: v,
        tooltipBox: this.state.lastBoundingBox,
        useTranslate3d: g,
        viewBox: b
      }), y = w.cssClasses, m = w.cssProperties, C = Xv(Xv({
        transition: d && i ? "transform ".concat(u, "ms ").concat(s) : void 0
      }, m), {}, {
        pointerEvents: "none",
        visibility: !this.state.dismissed && i && f ? "visible" : "hidden",
        position: "absolute",
        top: 0,
        left: 0
      }, x);
      return (
        // This element allow listening to the `Escape` key.
        // See https://github.com/recharts/recharts/pull/2925
        /* @__PURE__ */ N.createElement("div", {
          tabIndex: -1,
          className: y,
          style: C,
          ref: function(S) {
            n.wrapperNode = S;
          }
        }, c)
      );
    }
  }]), t;
}(xn), EB = function() {
  return !(typeof window < "u" && window.document && window.document.createElement && window.setTimeout);
}, zr = {
  isSsr: EB(),
  get: function(t) {
    return zr[t];
  },
  set: function(t, r) {
    if (typeof t == "string")
      zr[t] = r;
    else {
      var n = Object.keys(t);
      n && n.length && n.forEach(function(a) {
        zr[a] = t[a];
      });
    }
  }
};
function $a(e) {
  "@babel/helpers - typeof";
  return $a = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, $a(e);
}
function Kv(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function qv(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Kv(Object(r), !0).forEach(function(n) {
      hp(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Kv(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function _B(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function IB(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, x4(n.key), n);
  }
}
function PB(e, t, r) {
  return t && IB(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function TB(e, t, r) {
  return t = ps(t), MB(e, b4() ? Reflect.construct(t, r || [], ps(e).constructor) : t.apply(e, r));
}
function MB(e, t) {
  if (t && ($a(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return jB(e);
}
function jB(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function b4() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (b4 = function() {
    return !!e;
  })();
}
function ps(e) {
  return ps = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, ps(e);
}
function RB(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && bd(e, t);
}
function bd(e, t) {
  return bd = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, bd(e, t);
}
function hp(e, t, r) {
  return t = x4(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function x4(e) {
  var t = NB(e, "string");
  return $a(t) == "symbol" ? t : String(t);
}
function NB(e, t) {
  if ($a(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if ($a(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function $B(e) {
  return e.dataKey;
}
function FB(e, t) {
  return /* @__PURE__ */ N.isValidElement(e) ? /* @__PURE__ */ N.cloneElement(e, t) : typeof e == "function" ? /* @__PURE__ */ N.createElement(e, t) : /* @__PURE__ */ N.createElement(fB, t);
}
var wr = /* @__PURE__ */ function(e) {
  RB(t, e);
  function t() {
    return _B(this, t), TB(this, t, arguments);
  }
  return PB(t, [{
    key: "render",
    value: function() {
      var n = this, a = this.props, i = a.active, o = a.allowEscapeViewBox, u = a.animationDuration, s = a.animationEasing, c = a.content, l = a.coordinate, f = a.filterNull, d = a.isAnimationActive, p = a.offset, h = a.payload, v = a.payloadUniqBy, g = a.position, b = a.reverseDirection, x = a.useTranslate3d, w = a.viewBox, y = a.wrapperStyle, m = h ?? [];
      f && m.length && (m = s4(h.filter(function(O) {
        return O.value != null && (O.hide !== !0 || n.props.includeHidden);
      }), v, $B));
      var C = m.length > 0;
      return /* @__PURE__ */ N.createElement(AB, {
        allowEscapeViewBox: o,
        animationDuration: u,
        animationEasing: s,
        isAnimationActive: d,
        active: i,
        coordinate: l,
        hasPayload: C,
        offset: p,
        position: g,
        reverseDirection: b,
        useTranslate3d: x,
        viewBox: w,
        wrapperStyle: y
      }, FB(c, qv(qv({}, this.props), {}, {
        payload: m
      })));
    }
  }]), t;
}(xn);
hp(wr, "displayName", "Tooltip");
hp(wr, "defaultProps", {
  accessibilityLayer: !1,
  allowEscapeViewBox: {
    x: !1,
    y: !1
  },
  animationDuration: 400,
  animationEasing: "ease",
  contentStyle: {},
  coordinate: {
    x: 0,
    y: 0
  },
  cursor: !0,
  cursorStyle: {},
  filterNull: !0,
  isAnimationActive: !zr.isSsr,
  itemStyle: {},
  labelStyle: {},
  offset: 10,
  reverseDirection: {
    x: !1,
    y: !1
  },
  separator: " : ",
  trigger: "hover",
  useTranslate3d: !1,
  viewBox: {
    x: 0,
    y: 0,
    height: 0,
    width: 0
  },
  wrapperStyle: {}
});
var DB = Fr, kB = function() {
  return DB.Date.now();
}, LB = kB, BB = /\s/;
function VB(e) {
  for (var t = e.length; t-- && BB.test(e.charAt(t)); )
    ;
  return t;
}
var WB = VB, GB = WB, HB = /^\s+/;
function UB(e) {
  return e && e.slice(0, GB(e) + 1).replace(HB, "");
}
var zB = UB, YB = zB, Jv = wn, XB = qa, Qv = NaN, ZB = /^[-+]0x[0-9a-f]+$/i, KB = /^0b[01]+$/i, qB = /^0o[0-7]+$/i, JB = parseInt;
function QB(e) {
  if (typeof e == "number")
    return e;
  if (XB(e))
    return Qv;
  if (Jv(e)) {
    var t = typeof e.valueOf == "function" ? e.valueOf() : e;
    e = Jv(t) ? t + "" : t;
  }
  if (typeof e != "string")
    return e === 0 ? e : +e;
  e = YB(e);
  var r = KB.test(e);
  return r || qB.test(e) ? JB(e.slice(2), r ? 2 : 8) : ZB.test(e) ? Qv : +e;
}
var C4 = QB, eV = wn, Hl = LB, e2 = C4, tV = "Expected a function", rV = Math.max, nV = Math.min;
function aV(e, t, r) {
  var n, a, i, o, u, s, c = 0, l = !1, f = !1, d = !0;
  if (typeof e != "function")
    throw new TypeError(tV);
  t = e2(t) || 0, eV(r) && (l = !!r.leading, f = "maxWait" in r, i = f ? rV(e2(r.maxWait) || 0, t) : i, d = "trailing" in r ? !!r.trailing : d);
  function p(C) {
    var O = n, S = a;
    return n = a = void 0, c = C, o = e.apply(S, O), o;
  }
  function h(C) {
    return c = C, u = setTimeout(b, t), l ? p(C) : o;
  }
  function v(C) {
    var O = C - s, S = C - c, A = t - O;
    return f ? nV(A, i - S) : A;
  }
  function g(C) {
    var O = C - s, S = C - c;
    return s === void 0 || O >= t || O < 0 || f && S >= i;
  }
  function b() {
    var C = Hl();
    if (g(C))
      return x(C);
    u = setTimeout(b, v(C));
  }
  function x(C) {
    return u = void 0, d && n ? p(C) : (n = a = void 0, o);
  }
  function w() {
    u !== void 0 && clearTimeout(u), c = 0, n = s = a = u = void 0;
  }
  function y() {
    return u === void 0 ? o : x(Hl());
  }
  function m() {
    var C = Hl(), O = g(C);
    if (n = arguments, a = this, s = C, O) {
      if (u === void 0)
        return h(s);
      if (f)
        return clearTimeout(u), u = setTimeout(b, t), p(s);
    }
    return u === void 0 && (u = setTimeout(b, t)), o;
  }
  return m.cancel = w, m.flush = y, m;
}
var iV = aV, oV = iV, uV = wn, sV = "Expected a function";
function cV(e, t, r) {
  var n = !0, a = !0;
  if (typeof e != "function")
    throw new TypeError(sV);
  return uV(r) && (n = "leading" in r ? !!r.leading : n, a = "trailing" in r ? !!r.trailing : a), oV(e, t, {
    leading: n,
    maxWait: t,
    trailing: a
  });
}
var lV = cV;
const w4 = /* @__PURE__ */ Fe(lV);
function ho(e) {
  "@babel/helpers - typeof";
  return ho = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ho(e);
}
function t2(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Ou(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? t2(Object(r), !0).forEach(function(n) {
      fV(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : t2(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function fV(e, t, r) {
  return t = dV(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function dV(e) {
  var t = pV(e, "string");
  return ho(t) == "symbol" ? t : String(t);
}
function pV(e, t) {
  if (ho(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (ho(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function hV(e, t) {
  return yV(e) || mV(e, t) || gV(e, t) || vV();
}
function vV() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function gV(e, t) {
  if (e) {
    if (typeof e == "string") return r2(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return r2(e, t);
  }
}
function r2(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function mV(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, a, i, o, u = [], s = !0, c = !1;
    try {
      if (i = (r = r.call(e)).next, t !== 0) for (; !(s = (n = i.call(r)).done) && (u.push(n.value), u.length !== t); s = !0) ;
    } catch (l) {
      c = !0, a = l;
    } finally {
      try {
        if (!s && r.return != null && (o = r.return(), Object(o) !== o)) return;
      } finally {
        if (c) throw a;
      }
    }
    return u;
  }
}
function yV(e) {
  if (Array.isArray(e)) return e;
}
var bV = /* @__PURE__ */ Xo(function(e, t) {
  var r = e.aspect, n = e.initialDimension, a = n === void 0 ? {
    width: -1,
    height: -1
  } : n, i = e.width, o = i === void 0 ? "100%" : i, u = e.height, s = u === void 0 ? "100%" : u, c = e.minWidth, l = c === void 0 ? 0 : c, f = e.minHeight, d = e.maxHeight, p = e.children, h = e.debounce, v = h === void 0 ? 0 : h, g = e.id, b = e.className, x = e.onResize, w = e.style, y = w === void 0 ? {} : w, m = mr(null), C = mr();
  C.current = x, $6(t, function() {
    return Object.defineProperty(m.current, "current", {
      get: function() {
        return console.warn("The usage of ref.current.current is deprecated and will no longer be supported."), m.current;
      },
      configurable: !0
    });
  });
  var O = gn({
    containerWidth: a.width,
    containerHeight: a.height
  }), S = hV(O, 2), A = S[0], P = S[1], T = kr(function(I, G) {
    P(function(Y) {
      var L = Math.round(I), X = Math.round(G);
      return Y.containerWidth === L && Y.containerHeight === X ? Y : {
        containerWidth: L,
        containerHeight: X
      };
    });
  }, []);
  Xa(function() {
    var I = function(re) {
      var j, W = re[0].contentRect, D = W.width, R = W.height;
      T(D, R), (j = C.current) === null || j === void 0 || j.call(C, D, R);
    };
    v > 0 && (I = w4(I, v, {
      trailing: !0,
      leading: !1
    }));
    var G = new ResizeObserver(I), Y = m.current.getBoundingClientRect(), L = Y.width, X = Y.height;
    return T(L, X), G.observe(m.current), function() {
      G.disconnect();
    };
  }, [T, v]);
  var M = Lr(function() {
    var I = A.containerWidth, G = A.containerHeight;
    if (I < 0 || G < 0)
      return null;
    Ur(kn(o) || kn(s), `The width(%s) and height(%s) are both fixed numbers,
       maybe you don't need to use a ResponsiveContainer.`, o, s), Ur(!r || r > 0, "The aspect(%s) must be greater than zero.", r);
    var Y = kn(o) ? I : o, L = kn(s) ? G : s;
    r && r > 0 && (Y ? L = Y / r : L && (Y = L * r), d && L > d && (L = d)), Ur(Y > 0 || L > 0, `The width(%s) and height(%s) of chart should be greater than 0,
       please check the style of container, or the props width(%s) and height(%s),
       or add a minWidth(%s) or minHeight(%s) or use aspect(%s) to control the
       height and width.`, Y, L, o, s, l, f, r);
    var X = !Array.isArray(p) && Ea.isElement(p) && Hr(p.type).endsWith("Chart");
    return N.Children.map(p, function(q) {
      return Ea.isElement(q) ? /* @__PURE__ */ vt(q, Ou({
        width: Y,
        height: L
      }, X ? {
        style: Ou({
          height: "100%",
          width: "100%",
          maxHeight: L,
          maxWidth: Y
        }, q.props.style)
      } : {})) : q;
    });
  }, [r, p, s, d, f, l, A, o]);
  return /* @__PURE__ */ N.createElement("div", {
    id: g ? "".concat(g) : void 0,
    className: Ne("recharts-responsive-container", b),
    style: Ou(Ou({}, y), {}, {
      width: o,
      height: s,
      minWidth: l,
      minHeight: f,
      maxHeight: d
    }),
    ref: m
  }, M);
}), O4 = function(t) {
  return null;
};
O4.displayName = "Cell";
function vo(e) {
  "@babel/helpers - typeof";
  return vo = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, vo(e);
}
function n2(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function xd(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? n2(Object(r), !0).forEach(function(n) {
      xV(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : n2(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function xV(e, t, r) {
  return t = CV(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function CV(e) {
  var t = wV(e, "string");
  return vo(t) == "symbol" ? t : String(t);
}
function wV(e, t) {
  if (vo(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (vo(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var sa = {
  widthCache: {},
  cacheCount: 0
}, OV = 2e3, SV = {
  position: "absolute",
  top: "-20000px",
  left: 0,
  padding: 0,
  margin: 0,
  border: "none",
  whiteSpace: "pre"
}, a2 = "recharts_measurement_span";
function AV(e) {
  var t = xd({}, e);
  return Object.keys(t).forEach(function(r) {
    t[r] || delete t[r];
  }), t;
}
var Zi = function(t) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  if (t == null || zr.isSsr)
    return {
      width: 0,
      height: 0
    };
  var n = AV(r), a = JSON.stringify({
    text: t,
    copyStyle: n
  });
  if (sa.widthCache[a])
    return sa.widthCache[a];
  try {
    var i = document.getElementById(a2);
    i || (i = document.createElement("span"), i.setAttribute("id", a2), i.setAttribute("aria-hidden", "true"), document.body.appendChild(i));
    var o = xd(xd({}, SV), n);
    Object.assign(i.style, o), i.textContent = "".concat(t);
    var u = i.getBoundingClientRect(), s = {
      width: u.width,
      height: u.height
    };
    return sa.widthCache[a] = s, ++sa.cacheCount > OV && (sa.cacheCount = 0, sa.widthCache = {}), s;
  } catch {
    return {
      width: 0,
      height: 0
    };
  }
}, EV = function(t) {
  return {
    top: t.top + window.scrollY - document.documentElement.clientTop,
    left: t.left + window.scrollX - document.documentElement.clientLeft
  };
};
function go(e) {
  "@babel/helpers - typeof";
  return go = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, go(e);
}
function hs(e, t) {
  return TV(e) || PV(e, t) || IV(e, t) || _V();
}
function _V() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function IV(e, t) {
  if (e) {
    if (typeof e == "string") return i2(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return i2(e, t);
  }
}
function i2(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function PV(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, a, i, o, u = [], s = !0, c = !1;
    try {
      if (i = (r = r.call(e)).next, t === 0) {
        if (Object(r) !== r) return;
        s = !1;
      } else for (; !(s = (n = i.call(r)).done) && (u.push(n.value), u.length !== t); s = !0) ;
    } catch (l) {
      c = !0, a = l;
    } finally {
      try {
        if (!s && r.return != null && (o = r.return(), Object(o) !== o)) return;
      } finally {
        if (c) throw a;
      }
    }
    return u;
  }
}
function TV(e) {
  if (Array.isArray(e)) return e;
}
function MV(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function o2(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, RV(n.key), n);
  }
}
function jV(e, t, r) {
  return t && o2(e.prototype, t), r && o2(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function RV(e) {
  var t = NV(e, "string");
  return go(t) == "symbol" ? t : String(t);
}
function NV(e, t) {
  if (go(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (go(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var u2 = /(-?\d+(?:\.\d+)?[a-zA-Z%]*)([*/])(-?\d+(?:\.\d+)?[a-zA-Z%]*)/, s2 = /(-?\d+(?:\.\d+)?[a-zA-Z%]*)([+-])(-?\d+(?:\.\d+)?[a-zA-Z%]*)/, $V = /^px|cm|vh|vw|em|rem|%|mm|in|pt|pc|ex|ch|vmin|vmax|Q$/, FV = /(-?\d+(?:\.\d+)?)([a-zA-Z%]+)?/, S4 = {
  cm: 96 / 2.54,
  mm: 96 / 25.4,
  pt: 96 / 72,
  pc: 96 / 6,
  in: 96,
  Q: 96 / (2.54 * 40),
  px: 1
}, DV = Object.keys(S4), va = "NaN";
function kV(e, t) {
  return e * S4[t];
}
var Su = /* @__PURE__ */ function() {
  function e(t, r) {
    MV(this, e), this.num = t, this.unit = r, this.num = t, this.unit = r, Number.isNaN(t) && (this.unit = ""), r !== "" && !$V.test(r) && (this.num = NaN, this.unit = ""), DV.includes(r) && (this.num = kV(t, r), this.unit = "px");
  }
  return jV(e, [{
    key: "add",
    value: function(r) {
      return this.unit !== r.unit ? new e(NaN, "") : new e(this.num + r.num, this.unit);
    }
  }, {
    key: "subtract",
    value: function(r) {
      return this.unit !== r.unit ? new e(NaN, "") : new e(this.num - r.num, this.unit);
    }
  }, {
    key: "multiply",
    value: function(r) {
      return this.unit !== "" && r.unit !== "" && this.unit !== r.unit ? new e(NaN, "") : new e(this.num * r.num, this.unit || r.unit);
    }
  }, {
    key: "divide",
    value: function(r) {
      return this.unit !== "" && r.unit !== "" && this.unit !== r.unit ? new e(NaN, "") : new e(this.num / r.num, this.unit || r.unit);
    }
  }, {
    key: "toString",
    value: function() {
      return "".concat(this.num).concat(this.unit);
    }
  }, {
    key: "isNaN",
    value: function() {
      return Number.isNaN(this.num);
    }
  }], [{
    key: "parse",
    value: function(r) {
      var n, a = (n = FV.exec(r)) !== null && n !== void 0 ? n : [], i = hs(a, 3), o = i[1], u = i[2];
      return new e(parseFloat(o), u ?? "");
    }
  }]), e;
}();
function A4(e) {
  if (e.includes(va))
    return va;
  for (var t = e; t.includes("*") || t.includes("/"); ) {
    var r, n = (r = u2.exec(t)) !== null && r !== void 0 ? r : [], a = hs(n, 4), i = a[1], o = a[2], u = a[3], s = Su.parse(i ?? ""), c = Su.parse(u ?? ""), l = o === "*" ? s.multiply(c) : s.divide(c);
    if (l.isNaN())
      return va;
    t = t.replace(u2, l.toString());
  }
  for (; t.includes("+") || /.-\d+(?:\.\d+)?/.test(t); ) {
    var f, d = (f = s2.exec(t)) !== null && f !== void 0 ? f : [], p = hs(d, 4), h = p[1], v = p[2], g = p[3], b = Su.parse(h ?? ""), x = Su.parse(g ?? ""), w = v === "+" ? b.add(x) : b.subtract(x);
    if (w.isNaN())
      return va;
    t = t.replace(s2, w.toString());
  }
  return t;
}
var c2 = /\(([^()]*)\)/;
function LV(e) {
  for (var t = e; t.includes("("); ) {
    var r = c2.exec(t), n = hs(r, 2), a = n[1];
    t = t.replace(c2, A4(a));
  }
  return t;
}
function BV(e) {
  var t = e.replace(/\s+/g, "");
  return t = LV(t), t = A4(t), t;
}
function VV(e) {
  try {
    return BV(e);
  } catch {
    return va;
  }
}
function Ul(e) {
  var t = VV(e.slice(5, -1));
  return t === va ? "" : t;
}
var WV = ["x", "y", "lineHeight", "capHeight", "scaleToFit", "textAnchor", "verticalAnchor", "fill"], GV = ["dx", "dy", "angle", "className", "breakAll"];
function Cd() {
  return Cd = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Cd.apply(this, arguments);
}
function l2(e, t) {
  if (e == null) return {};
  var r = HV(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function HV(e, t) {
  if (e == null) return {};
  var r = {}, n = Object.keys(e), a, i;
  for (i = 0; i < n.length; i++)
    a = n[i], !(t.indexOf(a) >= 0) && (r[a] = e[a]);
  return r;
}
function f2(e, t) {
  return XV(e) || YV(e, t) || zV(e, t) || UV();
}
function UV() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function zV(e, t) {
  if (e) {
    if (typeof e == "string") return d2(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return d2(e, t);
  }
}
function d2(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function YV(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, a, i, o, u = [], s = !0, c = !1;
    try {
      if (i = (r = r.call(e)).next, t === 0) {
        if (Object(r) !== r) return;
        s = !1;
      } else for (; !(s = (n = i.call(r)).done) && (u.push(n.value), u.length !== t); s = !0) ;
    } catch (l) {
      c = !0, a = l;
    } finally {
      try {
        if (!s && r.return != null && (o = r.return(), Object(o) !== o)) return;
      } finally {
        if (c) throw a;
      }
    }
    return u;
  }
}
function XV(e) {
  if (Array.isArray(e)) return e;
}
var E4 = /[ \f\n\r\t\v\u2028\u2029]+/, _4 = function(t) {
  var r = t.children, n = t.breakAll, a = t.style;
  try {
    var i = [];
    Me(r) || (n ? i = r.toString().split("") : i = r.toString().split(E4));
    var o = i.map(function(s) {
      return {
        word: s,
        width: Zi(s, a).width
      };
    }), u = n ? 0 : Zi(" ", a).width;
    return {
      wordsWithComputedWidth: o,
      spaceWidth: u
    };
  } catch {
    return null;
  }
}, ZV = function(t, r, n, a, i) {
  var o = t.maxLines, u = t.children, s = t.style, c = t.breakAll, l = oe(o), f = u, d = function() {
    var Y = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return Y.reduce(function(L, X) {
      var q = X.word, re = X.width, j = L[L.length - 1];
      if (j && (a == null || i || j.width + re + n < Number(a)))
        j.words.push(q), j.width += re + n;
      else {
        var W = {
          words: [q],
          width: re
        };
        L.push(W);
      }
      return L;
    }, []);
  }, p = d(r), h = function(Y) {
    return Y.reduce(function(L, X) {
      return L.width > X.width ? L : X;
    });
  };
  if (!l)
    return p;
  for (var v = "…", g = function(Y) {
    var L = f.slice(0, Y), X = _4({
      breakAll: c,
      style: s,
      children: L + v
    }).wordsWithComputedWidth, q = d(X), re = q.length > o || h(q).width > Number(a);
    return [re, q];
  }, b = 0, x = f.length - 1, w = 0, y; b <= x && w <= f.length - 1; ) {
    var m = Math.floor((b + x) / 2), C = m - 1, O = g(C), S = f2(O, 2), A = S[0], P = S[1], T = g(m), M = f2(T, 1), I = M[0];
    if (!A && !I && (b = m + 1), A && I && (x = m - 1), !A && I) {
      y = P;
      break;
    }
    w++;
  }
  return y || p;
}, p2 = function(t) {
  var r = Me(t) ? [] : t.toString().split(E4);
  return [{
    words: r
  }];
}, KV = function(t) {
  var r = t.width, n = t.scaleToFit, a = t.children, i = t.style, o = t.breakAll, u = t.maxLines;
  if ((r || n) && !zr.isSsr) {
    var s, c, l = _4({
      breakAll: o,
      children: a,
      style: i
    });
    if (l) {
      var f = l.wordsWithComputedWidth, d = l.spaceWidth;
      s = f, c = d;
    } else
      return p2(a);
    return ZV({
      breakAll: o,
      children: a,
      maxLines: u,
      style: i
    }, s, c, r, n);
  }
  return p2(a);
}, h2 = "#808080", vs = function(t) {
  var r = t.x, n = r === void 0 ? 0 : r, a = t.y, i = a === void 0 ? 0 : a, o = t.lineHeight, u = o === void 0 ? "1em" : o, s = t.capHeight, c = s === void 0 ? "0.71em" : s, l = t.scaleToFit, f = l === void 0 ? !1 : l, d = t.textAnchor, p = d === void 0 ? "start" : d, h = t.verticalAnchor, v = h === void 0 ? "end" : h, g = t.fill, b = g === void 0 ? h2 : g, x = l2(t, WV), w = Lr(function() {
    return KV({
      breakAll: x.breakAll,
      children: x.children,
      maxLines: x.maxLines,
      scaleToFit: f,
      style: x.style,
      width: x.width
    });
  }, [x.breakAll, x.children, x.maxLines, f, x.style, x.width]), y = x.dx, m = x.dy, C = x.angle, O = x.className, S = x.breakAll, A = l2(x, GV);
  if (!gt(n) || !gt(i))
    return null;
  var P = n + (oe(y) ? y : 0), T = i + (oe(m) ? m : 0), M;
  switch (v) {
    case "start":
      M = Ul("calc(".concat(c, ")"));
      break;
    case "middle":
      M = Ul("calc(".concat((w.length - 1) / 2, " * -").concat(u, " + (").concat(c, " / 2))"));
      break;
    default:
      M = Ul("calc(".concat(w.length - 1, " * -").concat(u, ")"));
      break;
  }
  var I = [];
  if (f) {
    var G = w[0].width, Y = x.width;
    I.push("scale(".concat((oe(Y) ? Y / G : 1) / G, ")"));
  }
  return C && I.push("rotate(".concat(C, ", ").concat(P, ", ").concat(T, ")")), I.length && (A.transform = I.join(" ")), /* @__PURE__ */ N.createElement("text", Cd({}, Ie(A, !0), {
    x: P,
    y: T,
    className: Ne("recharts-text", O),
    textAnchor: p,
    fill: b.includes("url") ? h2 : b
  }), w.map(function(L, X) {
    var q = L.words.join(S ? "" : " ");
    return /* @__PURE__ */ N.createElement("tspan", {
      x: P,
      dy: X === 0 ? M : u,
      key: q
    }, q);
  }));
};
function hn(e, t) {
  return e == null || t == null ? NaN : e < t ? -1 : e > t ? 1 : e >= t ? 0 : NaN;
}
function qV(e, t) {
  return e == null || t == null ? NaN : t < e ? -1 : t > e ? 1 : t >= e ? 0 : NaN;
}
function vp(e) {
  let t, r, n;
  e.length !== 2 ? (t = hn, r = (u, s) => hn(e(u), s), n = (u, s) => e(u) - s) : (t = e === hn || e === qV ? e : JV, r = e, n = e);
  function a(u, s, c = 0, l = u.length) {
    if (c < l) {
      if (t(s, s) !== 0) return l;
      do {
        const f = c + l >>> 1;
        r(u[f], s) < 0 ? c = f + 1 : l = f;
      } while (c < l);
    }
    return c;
  }
  function i(u, s, c = 0, l = u.length) {
    if (c < l) {
      if (t(s, s) !== 0) return l;
      do {
        const f = c + l >>> 1;
        r(u[f], s) <= 0 ? c = f + 1 : l = f;
      } while (c < l);
    }
    return c;
  }
  function o(u, s, c = 0, l = u.length) {
    const f = a(u, s, c, l - 1);
    return f > c && n(u[f - 1], s) > -n(u[f], s) ? f - 1 : f;
  }
  return { left: a, center: o, right: i };
}
function JV() {
  return 0;
}
function I4(e) {
  return e === null ? NaN : +e;
}
function* QV(e, t) {
  for (let r of e)
    r != null && (r = +r) >= r && (yield r);
}
const eW = vp(hn), au = eW.right;
vp(I4).center;
class v2 extends Map {
  constructor(t, r = nW) {
    if (super(), Object.defineProperties(this, { _intern: { value: /* @__PURE__ */ new Map() }, _key: { value: r } }), t != null) for (const [n, a] of t) this.set(n, a);
  }
  get(t) {
    return super.get(g2(this, t));
  }
  has(t) {
    return super.has(g2(this, t));
  }
  set(t, r) {
    return super.set(tW(this, t), r);
  }
  delete(t) {
    return super.delete(rW(this, t));
  }
}
function g2({ _intern: e, _key: t }, r) {
  const n = t(r);
  return e.has(n) ? e.get(n) : r;
}
function tW({ _intern: e, _key: t }, r) {
  const n = t(r);
  return e.has(n) ? e.get(n) : (e.set(n, r), r);
}
function rW({ _intern: e, _key: t }, r) {
  const n = t(r);
  return e.has(n) && (r = e.get(n), e.delete(n)), r;
}
function nW(e) {
  return e !== null && typeof e == "object" ? e.valueOf() : e;
}
function aW(e = hn) {
  if (e === hn) return P4;
  if (typeof e != "function") throw new TypeError("compare is not a function");
  return (t, r) => {
    const n = e(t, r);
    return n || n === 0 ? n : (e(r, r) === 0) - (e(t, t) === 0);
  };
}
function P4(e, t) {
  return (e == null || !(e >= e)) - (t == null || !(t >= t)) || (e < t ? -1 : e > t ? 1 : 0);
}
const iW = Math.sqrt(50), oW = Math.sqrt(10), uW = Math.sqrt(2);
function gs(e, t, r) {
  const n = (t - e) / Math.max(0, r), a = Math.floor(Math.log10(n)), i = n / Math.pow(10, a), o = i >= iW ? 10 : i >= oW ? 5 : i >= uW ? 2 : 1;
  let u, s, c;
  return a < 0 ? (c = Math.pow(10, -a) / o, u = Math.round(e * c), s = Math.round(t * c), u / c < e && ++u, s / c > t && --s, c = -c) : (c = Math.pow(10, a) * o, u = Math.round(e / c), s = Math.round(t / c), u * c < e && ++u, s * c > t && --s), s < u && 0.5 <= r && r < 2 ? gs(e, t, r * 2) : [u, s, c];
}
function wd(e, t, r) {
  if (t = +t, e = +e, r = +r, !(r > 0)) return [];
  if (e === t) return [e];
  const n = t < e, [a, i, o] = n ? gs(t, e, r) : gs(e, t, r);
  if (!(i >= a)) return [];
  const u = i - a + 1, s = new Array(u);
  if (n)
    if (o < 0) for (let c = 0; c < u; ++c) s[c] = (i - c) / -o;
    else for (let c = 0; c < u; ++c) s[c] = (i - c) * o;
  else if (o < 0) for (let c = 0; c < u; ++c) s[c] = (a + c) / -o;
  else for (let c = 0; c < u; ++c) s[c] = (a + c) * o;
  return s;
}
function Od(e, t, r) {
  return t = +t, e = +e, r = +r, gs(e, t, r)[2];
}
function Sd(e, t, r) {
  t = +t, e = +e, r = +r;
  const n = t < e, a = n ? Od(t, e, r) : Od(e, t, r);
  return (n ? -1 : 1) * (a < 0 ? 1 / -a : a);
}
function m2(e, t) {
  let r;
  for (const n of e)
    n != null && (r < n || r === void 0 && n >= n) && (r = n);
  return r;
}
function y2(e, t) {
  let r;
  for (const n of e)
    n != null && (r > n || r === void 0 && n >= n) && (r = n);
  return r;
}
function T4(e, t, r = 0, n = 1 / 0, a) {
  if (t = Math.floor(t), r = Math.floor(Math.max(0, r)), n = Math.floor(Math.min(e.length - 1, n)), !(r <= t && t <= n)) return e;
  for (a = a === void 0 ? P4 : aW(a); n > r; ) {
    if (n - r > 600) {
      const s = n - r + 1, c = t - r + 1, l = Math.log(s), f = 0.5 * Math.exp(2 * l / 3), d = 0.5 * Math.sqrt(l * f * (s - f) / s) * (c - s / 2 < 0 ? -1 : 1), p = Math.max(r, Math.floor(t - c * f / s + d)), h = Math.min(n, Math.floor(t + (s - c) * f / s + d));
      T4(e, t, p, h, a);
    }
    const i = e[t];
    let o = r, u = n;
    for (Ii(e, r, t), a(e[n], i) > 0 && Ii(e, r, n); o < u; ) {
      for (Ii(e, o, u), ++o, --u; a(e[o], i) < 0; ) ++o;
      for (; a(e[u], i) > 0; ) --u;
    }
    a(e[r], i) === 0 ? Ii(e, r, u) : (++u, Ii(e, u, n)), u <= t && (r = u + 1), t <= u && (n = u - 1);
  }
  return e;
}
function Ii(e, t, r) {
  const n = e[t];
  e[t] = e[r], e[r] = n;
}
function sW(e, t, r) {
  if (e = Float64Array.from(QV(e)), !(!(n = e.length) || isNaN(t = +t))) {
    if (t <= 0 || n < 2) return y2(e);
    if (t >= 1) return m2(e);
    var n, a = (n - 1) * t, i = Math.floor(a), o = m2(T4(e, i).subarray(0, i + 1)), u = y2(e.subarray(i + 1));
    return o + (u - o) * (a - i);
  }
}
function cW(e, t, r = I4) {
  if (!(!(n = e.length) || isNaN(t = +t))) {
    if (t <= 0 || n < 2) return +r(e[0], 0, e);
    if (t >= 1) return +r(e[n - 1], n - 1, e);
    var n, a = (n - 1) * t, i = Math.floor(a), o = +r(e[i], i, e), u = +r(e[i + 1], i + 1, e);
    return o + (u - o) * (a - i);
  }
}
function lW(e, t, r) {
  e = +e, t = +t, r = (a = arguments.length) < 2 ? (t = e, e = 0, 1) : a < 3 ? 1 : +r;
  for (var n = -1, a = Math.max(0, Math.ceil((t - e) / r)) | 0, i = new Array(a); ++n < a; )
    i[n] = e + n * r;
  return i;
}
function fr(e, t) {
  switch (arguments.length) {
    case 0:
      break;
    case 1:
      this.range(e);
      break;
    default:
      this.range(t).domain(e);
      break;
  }
  return this;
}
function rn(e, t) {
  switch (arguments.length) {
    case 0:
      break;
    case 1: {
      typeof e == "function" ? this.interpolator(e) : this.range(e);
      break;
    }
    default: {
      this.domain(e), typeof t == "function" ? this.interpolator(t) : this.range(t);
      break;
    }
  }
  return this;
}
const Ad = Symbol("implicit");
function gp() {
  var e = new v2(), t = [], r = [], n = Ad;
  function a(i) {
    let o = e.get(i);
    if (o === void 0) {
      if (n !== Ad) return n;
      e.set(i, o = t.push(i) - 1);
    }
    return r[o % r.length];
  }
  return a.domain = function(i) {
    if (!arguments.length) return t.slice();
    t = [], e = new v2();
    for (const o of i)
      e.has(o) || e.set(o, t.push(o) - 1);
    return a;
  }, a.range = function(i) {
    return arguments.length ? (r = Array.from(i), a) : r.slice();
  }, a.unknown = function(i) {
    return arguments.length ? (n = i, a) : n;
  }, a.copy = function() {
    return gp(t, r).unknown(n);
  }, fr.apply(a, arguments), a;
}
function mo() {
  var e = gp().unknown(void 0), t = e.domain, r = e.range, n = 0, a = 1, i, o, u = !1, s = 0, c = 0, l = 0.5;
  delete e.unknown;
  function f() {
    var d = t().length, p = a < n, h = p ? a : n, v = p ? n : a;
    i = (v - h) / Math.max(1, d - s + c * 2), u && (i = Math.floor(i)), h += (v - h - i * (d - s)) * l, o = i * (1 - s), u && (h = Math.round(h), o = Math.round(o));
    var g = lW(d).map(function(b) {
      return h + i * b;
    });
    return r(p ? g.reverse() : g);
  }
  return e.domain = function(d) {
    return arguments.length ? (t(d), f()) : t();
  }, e.range = function(d) {
    return arguments.length ? ([n, a] = d, n = +n, a = +a, f()) : [n, a];
  }, e.rangeRound = function(d) {
    return [n, a] = d, n = +n, a = +a, u = !0, f();
  }, e.bandwidth = function() {
    return o;
  }, e.step = function() {
    return i;
  }, e.round = function(d) {
    return arguments.length ? (u = !!d, f()) : u;
  }, e.padding = function(d) {
    return arguments.length ? (s = Math.min(1, c = +d), f()) : s;
  }, e.paddingInner = function(d) {
    return arguments.length ? (s = Math.min(1, d), f()) : s;
  }, e.paddingOuter = function(d) {
    return arguments.length ? (c = +d, f()) : c;
  }, e.align = function(d) {
    return arguments.length ? (l = Math.max(0, Math.min(1, d)), f()) : l;
  }, e.copy = function() {
    return mo(t(), [n, a]).round(u).paddingInner(s).paddingOuter(c).align(l);
  }, fr.apply(f(), arguments);
}
function M4(e) {
  var t = e.copy;
  return e.padding = e.paddingOuter, delete e.paddingInner, delete e.paddingOuter, e.copy = function() {
    return M4(t());
  }, e;
}
function Ki() {
  return M4(mo.apply(null, arguments).paddingInner(1));
}
function mp(e, t, r) {
  e.prototype = t.prototype = r, r.constructor = e;
}
function j4(e, t) {
  var r = Object.create(e.prototype);
  for (var n in t) r[n] = t[n];
  return r;
}
function iu() {
}
var yo = 0.7, ms = 1 / yo, ba = "\\s*([+-]?\\d+)\\s*", bo = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", Tr = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", fW = /^#([0-9a-f]{3,8})$/, dW = new RegExp(`^rgb\\(${ba},${ba},${ba}\\)$`), pW = new RegExp(`^rgb\\(${Tr},${Tr},${Tr}\\)$`), hW = new RegExp(`^rgba\\(${ba},${ba},${ba},${bo}\\)$`), vW = new RegExp(`^rgba\\(${Tr},${Tr},${Tr},${bo}\\)$`), gW = new RegExp(`^hsl\\(${bo},${Tr},${Tr}\\)$`), mW = new RegExp(`^hsla\\(${bo},${Tr},${Tr},${bo}\\)$`), b2 = {
  aliceblue: 15792383,
  antiquewhite: 16444375,
  aqua: 65535,
  aquamarine: 8388564,
  azure: 15794175,
  beige: 16119260,
  bisque: 16770244,
  black: 0,
  blanchedalmond: 16772045,
  blue: 255,
  blueviolet: 9055202,
  brown: 10824234,
  burlywood: 14596231,
  cadetblue: 6266528,
  chartreuse: 8388352,
  chocolate: 13789470,
  coral: 16744272,
  cornflowerblue: 6591981,
  cornsilk: 16775388,
  crimson: 14423100,
  cyan: 65535,
  darkblue: 139,
  darkcyan: 35723,
  darkgoldenrod: 12092939,
  darkgray: 11119017,
  darkgreen: 25600,
  darkgrey: 11119017,
  darkkhaki: 12433259,
  darkmagenta: 9109643,
  darkolivegreen: 5597999,
  darkorange: 16747520,
  darkorchid: 10040012,
  darkred: 9109504,
  darksalmon: 15308410,
  darkseagreen: 9419919,
  darkslateblue: 4734347,
  darkslategray: 3100495,
  darkslategrey: 3100495,
  darkturquoise: 52945,
  darkviolet: 9699539,
  deeppink: 16716947,
  deepskyblue: 49151,
  dimgray: 6908265,
  dimgrey: 6908265,
  dodgerblue: 2003199,
  firebrick: 11674146,
  floralwhite: 16775920,
  forestgreen: 2263842,
  fuchsia: 16711935,
  gainsboro: 14474460,
  ghostwhite: 16316671,
  gold: 16766720,
  goldenrod: 14329120,
  gray: 8421504,
  green: 32768,
  greenyellow: 11403055,
  grey: 8421504,
  honeydew: 15794160,
  hotpink: 16738740,
  indianred: 13458524,
  indigo: 4915330,
  ivory: 16777200,
  khaki: 15787660,
  lavender: 15132410,
  lavenderblush: 16773365,
  lawngreen: 8190976,
  lemonchiffon: 16775885,
  lightblue: 11393254,
  lightcoral: 15761536,
  lightcyan: 14745599,
  lightgoldenrodyellow: 16448210,
  lightgray: 13882323,
  lightgreen: 9498256,
  lightgrey: 13882323,
  lightpink: 16758465,
  lightsalmon: 16752762,
  lightseagreen: 2142890,
  lightskyblue: 8900346,
  lightslategray: 7833753,
  lightslategrey: 7833753,
  lightsteelblue: 11584734,
  lightyellow: 16777184,
  lime: 65280,
  limegreen: 3329330,
  linen: 16445670,
  magenta: 16711935,
  maroon: 8388608,
  mediumaquamarine: 6737322,
  mediumblue: 205,
  mediumorchid: 12211667,
  mediumpurple: 9662683,
  mediumseagreen: 3978097,
  mediumslateblue: 8087790,
  mediumspringgreen: 64154,
  mediumturquoise: 4772300,
  mediumvioletred: 13047173,
  midnightblue: 1644912,
  mintcream: 16121850,
  mistyrose: 16770273,
  moccasin: 16770229,
  navajowhite: 16768685,
  navy: 128,
  oldlace: 16643558,
  olive: 8421376,
  olivedrab: 7048739,
  orange: 16753920,
  orangered: 16729344,
  orchid: 14315734,
  palegoldenrod: 15657130,
  palegreen: 10025880,
  paleturquoise: 11529966,
  palevioletred: 14381203,
  papayawhip: 16773077,
  peachpuff: 16767673,
  peru: 13468991,
  pink: 16761035,
  plum: 14524637,
  powderblue: 11591910,
  purple: 8388736,
  rebeccapurple: 6697881,
  red: 16711680,
  rosybrown: 12357519,
  royalblue: 4286945,
  saddlebrown: 9127187,
  salmon: 16416882,
  sandybrown: 16032864,
  seagreen: 3050327,
  seashell: 16774638,
  sienna: 10506797,
  silver: 12632256,
  skyblue: 8900331,
  slateblue: 6970061,
  slategray: 7372944,
  slategrey: 7372944,
  snow: 16775930,
  springgreen: 65407,
  steelblue: 4620980,
  tan: 13808780,
  teal: 32896,
  thistle: 14204888,
  tomato: 16737095,
  turquoise: 4251856,
  violet: 15631086,
  wheat: 16113331,
  white: 16777215,
  whitesmoke: 16119285,
  yellow: 16776960,
  yellowgreen: 10145074
};
mp(iu, xo, {
  copy(e) {
    return Object.assign(new this.constructor(), this, e);
  },
  displayable() {
    return this.rgb().displayable();
  },
  hex: x2,
  // Deprecated! Use color.formatHex.
  formatHex: x2,
  formatHex8: yW,
  formatHsl: bW,
  formatRgb: C2,
  toString: C2
});
function x2() {
  return this.rgb().formatHex();
}
function yW() {
  return this.rgb().formatHex8();
}
function bW() {
  return R4(this).formatHsl();
}
function C2() {
  return this.rgb().formatRgb();
}
function xo(e) {
  var t, r;
  return e = (e + "").trim().toLowerCase(), (t = fW.exec(e)) ? (r = t[1].length, t = parseInt(t[1], 16), r === 6 ? w2(t) : r === 3 ? new Dt(t >> 8 & 15 | t >> 4 & 240, t >> 4 & 15 | t & 240, (t & 15) << 4 | t & 15, 1) : r === 8 ? Au(t >> 24 & 255, t >> 16 & 255, t >> 8 & 255, (t & 255) / 255) : r === 4 ? Au(t >> 12 & 15 | t >> 8 & 240, t >> 8 & 15 | t >> 4 & 240, t >> 4 & 15 | t & 240, ((t & 15) << 4 | t & 15) / 255) : null) : (t = dW.exec(e)) ? new Dt(t[1], t[2], t[3], 1) : (t = pW.exec(e)) ? new Dt(t[1] * 255 / 100, t[2] * 255 / 100, t[3] * 255 / 100, 1) : (t = hW.exec(e)) ? Au(t[1], t[2], t[3], t[4]) : (t = vW.exec(e)) ? Au(t[1] * 255 / 100, t[2] * 255 / 100, t[3] * 255 / 100, t[4]) : (t = gW.exec(e)) ? A2(t[1], t[2] / 100, t[3] / 100, 1) : (t = mW.exec(e)) ? A2(t[1], t[2] / 100, t[3] / 100, t[4]) : b2.hasOwnProperty(e) ? w2(b2[e]) : e === "transparent" ? new Dt(NaN, NaN, NaN, 0) : null;
}
function w2(e) {
  return new Dt(e >> 16 & 255, e >> 8 & 255, e & 255, 1);
}
function Au(e, t, r, n) {
  return n <= 0 && (e = t = r = NaN), new Dt(e, t, r, n);
}
function xW(e) {
  return e instanceof iu || (e = xo(e)), e ? (e = e.rgb(), new Dt(e.r, e.g, e.b, e.opacity)) : new Dt();
}
function Ed(e, t, r, n) {
  return arguments.length === 1 ? xW(e) : new Dt(e, t, r, n ?? 1);
}
function Dt(e, t, r, n) {
  this.r = +e, this.g = +t, this.b = +r, this.opacity = +n;
}
mp(Dt, Ed, j4(iu, {
  brighter(e) {
    return e = e == null ? ms : Math.pow(ms, e), new Dt(this.r * e, this.g * e, this.b * e, this.opacity);
  },
  darker(e) {
    return e = e == null ? yo : Math.pow(yo, e), new Dt(this.r * e, this.g * e, this.b * e, this.opacity);
  },
  rgb() {
    return this;
  },
  clamp() {
    return new Dt(zn(this.r), zn(this.g), zn(this.b), ys(this.opacity));
  },
  displayable() {
    return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
  },
  hex: O2,
  // Deprecated! Use color.formatHex.
  formatHex: O2,
  formatHex8: CW,
  formatRgb: S2,
  toString: S2
}));
function O2() {
  return `#${Ln(this.r)}${Ln(this.g)}${Ln(this.b)}`;
}
function CW() {
  return `#${Ln(this.r)}${Ln(this.g)}${Ln(this.b)}${Ln((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function S2() {
  const e = ys(this.opacity);
  return `${e === 1 ? "rgb(" : "rgba("}${zn(this.r)}, ${zn(this.g)}, ${zn(this.b)}${e === 1 ? ")" : `, ${e})`}`;
}
function ys(e) {
  return isNaN(e) ? 1 : Math.max(0, Math.min(1, e));
}
function zn(e) {
  return Math.max(0, Math.min(255, Math.round(e) || 0));
}
function Ln(e) {
  return e = zn(e), (e < 16 ? "0" : "") + e.toString(16);
}
function A2(e, t, r, n) {
  return n <= 0 ? e = t = r = NaN : r <= 0 || r >= 1 ? e = t = NaN : t <= 0 && (e = NaN), new gr(e, t, r, n);
}
function R4(e) {
  if (e instanceof gr) return new gr(e.h, e.s, e.l, e.opacity);
  if (e instanceof iu || (e = xo(e)), !e) return new gr();
  if (e instanceof gr) return e;
  e = e.rgb();
  var t = e.r / 255, r = e.g / 255, n = e.b / 255, a = Math.min(t, r, n), i = Math.max(t, r, n), o = NaN, u = i - a, s = (i + a) / 2;
  return u ? (t === i ? o = (r - n) / u + (r < n) * 6 : r === i ? o = (n - t) / u + 2 : o = (t - r) / u + 4, u /= s < 0.5 ? i + a : 2 - i - a, o *= 60) : u = s > 0 && s < 1 ? 0 : o, new gr(o, u, s, e.opacity);
}
function wW(e, t, r, n) {
  return arguments.length === 1 ? R4(e) : new gr(e, t, r, n ?? 1);
}
function gr(e, t, r, n) {
  this.h = +e, this.s = +t, this.l = +r, this.opacity = +n;
}
mp(gr, wW, j4(iu, {
  brighter(e) {
    return e = e == null ? ms : Math.pow(ms, e), new gr(this.h, this.s, this.l * e, this.opacity);
  },
  darker(e) {
    return e = e == null ? yo : Math.pow(yo, e), new gr(this.h, this.s, this.l * e, this.opacity);
  },
  rgb() {
    var e = this.h % 360 + (this.h < 0) * 360, t = isNaN(e) || isNaN(this.s) ? 0 : this.s, r = this.l, n = r + (r < 0.5 ? r : 1 - r) * t, a = 2 * r - n;
    return new Dt(
      zl(e >= 240 ? e - 240 : e + 120, a, n),
      zl(e, a, n),
      zl(e < 120 ? e + 240 : e - 120, a, n),
      this.opacity
    );
  },
  clamp() {
    return new gr(E2(this.h), Eu(this.s), Eu(this.l), ys(this.opacity));
  },
  displayable() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
  },
  formatHsl() {
    const e = ys(this.opacity);
    return `${e === 1 ? "hsl(" : "hsla("}${E2(this.h)}, ${Eu(this.s) * 100}%, ${Eu(this.l) * 100}%${e === 1 ? ")" : `, ${e})`}`;
  }
}));
function E2(e) {
  return e = (e || 0) % 360, e < 0 ? e + 360 : e;
}
function Eu(e) {
  return Math.max(0, Math.min(1, e || 0));
}
function zl(e, t, r) {
  return (e < 60 ? t + (r - t) * e / 60 : e < 180 ? r : e < 240 ? t + (r - t) * (240 - e) / 60 : t) * 255;
}
const yp = (e) => () => e;
function OW(e, t) {
  return function(r) {
    return e + r * t;
  };
}
function SW(e, t, r) {
  return e = Math.pow(e, r), t = Math.pow(t, r) - e, r = 1 / r, function(n) {
    return Math.pow(e + n * t, r);
  };
}
function AW(e) {
  return (e = +e) == 1 ? N4 : function(t, r) {
    return r - t ? SW(t, r, e) : yp(isNaN(t) ? r : t);
  };
}
function N4(e, t) {
  var r = t - e;
  return r ? OW(e, r) : yp(isNaN(e) ? t : e);
}
const _2 = function e(t) {
  var r = AW(t);
  function n(a, i) {
    var o = r((a = Ed(a)).r, (i = Ed(i)).r), u = r(a.g, i.g), s = r(a.b, i.b), c = N4(a.opacity, i.opacity);
    return function(l) {
      return a.r = o(l), a.g = u(l), a.b = s(l), a.opacity = c(l), a + "";
    };
  }
  return n.gamma = e, n;
}(1);
function EW(e, t) {
  t || (t = []);
  var r = e ? Math.min(t.length, e.length) : 0, n = t.slice(), a;
  return function(i) {
    for (a = 0; a < r; ++a) n[a] = e[a] * (1 - i) + t[a] * i;
    return n;
  };
}
function _W(e) {
  return ArrayBuffer.isView(e) && !(e instanceof DataView);
}
function IW(e, t) {
  var r = t ? t.length : 0, n = e ? Math.min(r, e.length) : 0, a = new Array(n), i = new Array(r), o;
  for (o = 0; o < n; ++o) a[o] = si(e[o], t[o]);
  for (; o < r; ++o) i[o] = t[o];
  return function(u) {
    for (o = 0; o < n; ++o) i[o] = a[o](u);
    return i;
  };
}
function PW(e, t) {
  var r = /* @__PURE__ */ new Date();
  return e = +e, t = +t, function(n) {
    return r.setTime(e * (1 - n) + t * n), r;
  };
}
function bs(e, t) {
  return e = +e, t = +t, function(r) {
    return e * (1 - r) + t * r;
  };
}
function TW(e, t) {
  var r = {}, n = {}, a;
  (e === null || typeof e != "object") && (e = {}), (t === null || typeof t != "object") && (t = {});
  for (a in t)
    a in e ? r[a] = si(e[a], t[a]) : n[a] = t[a];
  return function(i) {
    for (a in r) n[a] = r[a](i);
    return n;
  };
}
var _d = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, Yl = new RegExp(_d.source, "g");
function MW(e) {
  return function() {
    return e;
  };
}
function jW(e) {
  return function(t) {
    return e(t) + "";
  };
}
function RW(e, t) {
  var r = _d.lastIndex = Yl.lastIndex = 0, n, a, i, o = -1, u = [], s = [];
  for (e = e + "", t = t + ""; (n = _d.exec(e)) && (a = Yl.exec(t)); )
    (i = a.index) > r && (i = t.slice(r, i), u[o] ? u[o] += i : u[++o] = i), (n = n[0]) === (a = a[0]) ? u[o] ? u[o] += a : u[++o] = a : (u[++o] = null, s.push({ i: o, x: bs(n, a) })), r = Yl.lastIndex;
  return r < t.length && (i = t.slice(r), u[o] ? u[o] += i : u[++o] = i), u.length < 2 ? s[0] ? jW(s[0].x) : MW(t) : (t = s.length, function(c) {
    for (var l = 0, f; l < t; ++l) u[(f = s[l]).i] = f.x(c);
    return u.join("");
  });
}
function si(e, t) {
  var r = typeof t, n;
  return t == null || r === "boolean" ? yp(t) : (r === "number" ? bs : r === "string" ? (n = xo(t)) ? (t = n, _2) : RW : t instanceof xo ? _2 : t instanceof Date ? PW : _W(t) ? EW : Array.isArray(t) ? IW : typeof t.valueOf != "function" && typeof t.toString != "function" || isNaN(t) ? TW : bs)(e, t);
}
function bp(e, t) {
  return e = +e, t = +t, function(r) {
    return Math.round(e * (1 - r) + t * r);
  };
}
function NW(e, t) {
  t === void 0 && (t = e, e = si);
  for (var r = 0, n = t.length - 1, a = t[0], i = new Array(n < 0 ? 0 : n); r < n; ) i[r] = e(a, a = t[++r]);
  return function(o) {
    var u = Math.max(0, Math.min(n - 1, Math.floor(o *= n)));
    return i[u](o - u);
  };
}
function $W(e) {
  return function() {
    return e;
  };
}
function xs(e) {
  return +e;
}
var I2 = [0, 1];
function $t(e) {
  return e;
}
function Id(e, t) {
  return (t -= e = +e) ? function(r) {
    return (r - e) / t;
  } : $W(isNaN(t) ? NaN : 0.5);
}
function FW(e, t) {
  var r;
  return e > t && (r = e, e = t, t = r), function(n) {
    return Math.max(e, Math.min(t, n));
  };
}
function DW(e, t, r) {
  var n = e[0], a = e[1], i = t[0], o = t[1];
  return a < n ? (n = Id(a, n), i = r(o, i)) : (n = Id(n, a), i = r(i, o)), function(u) {
    return i(n(u));
  };
}
function kW(e, t, r) {
  var n = Math.min(e.length, t.length) - 1, a = new Array(n), i = new Array(n), o = -1;
  for (e[n] < e[0] && (e = e.slice().reverse(), t = t.slice().reverse()); ++o < n; )
    a[o] = Id(e[o], e[o + 1]), i[o] = r(t[o], t[o + 1]);
  return function(u) {
    var s = au(e, u, 1, n) - 1;
    return i[s](a[s](u));
  };
}
function ou(e, t) {
  return t.domain(e.domain()).range(e.range()).interpolate(e.interpolate()).clamp(e.clamp()).unknown(e.unknown());
}
function xc() {
  var e = I2, t = I2, r = si, n, a, i, o = $t, u, s, c;
  function l() {
    var d = Math.min(e.length, t.length);
    return o !== $t && (o = FW(e[0], e[d - 1])), u = d > 2 ? kW : DW, s = c = null, f;
  }
  function f(d) {
    return d == null || isNaN(d = +d) ? i : (s || (s = u(e.map(n), t, r)))(n(o(d)));
  }
  return f.invert = function(d) {
    return o(a((c || (c = u(t, e.map(n), bs)))(d)));
  }, f.domain = function(d) {
    return arguments.length ? (e = Array.from(d, xs), l()) : e.slice();
  }, f.range = function(d) {
    return arguments.length ? (t = Array.from(d), l()) : t.slice();
  }, f.rangeRound = function(d) {
    return t = Array.from(d), r = bp, l();
  }, f.clamp = function(d) {
    return arguments.length ? (o = d ? !0 : $t, l()) : o !== $t;
  }, f.interpolate = function(d) {
    return arguments.length ? (r = d, l()) : r;
  }, f.unknown = function(d) {
    return arguments.length ? (i = d, f) : i;
  }, function(d, p) {
    return n = d, a = p, l();
  };
}
function xp() {
  return xc()($t, $t);
}
function LW(e) {
  return Math.abs(e = Math.round(e)) >= 1e21 ? e.toLocaleString("en").replace(/,/g, "") : e.toString(10);
}
function Cs(e, t) {
  if ((r = (e = t ? e.toExponential(t - 1) : e.toExponential()).indexOf("e")) < 0) return null;
  var r, n = e.slice(0, r);
  return [
    n.length > 1 ? n[0] + n.slice(2) : n,
    +e.slice(r + 1)
  ];
}
function Fa(e) {
  return e = Cs(Math.abs(e)), e ? e[1] : NaN;
}
function BW(e, t) {
  return function(r, n) {
    for (var a = r.length, i = [], o = 0, u = e[0], s = 0; a > 0 && u > 0 && (s + u + 1 > n && (u = Math.max(1, n - s)), i.push(r.substring(a -= u, a + u)), !((s += u + 1) > n)); )
      u = e[o = (o + 1) % e.length];
    return i.reverse().join(t);
  };
}
function VW(e) {
  return function(t) {
    return t.replace(/[0-9]/g, function(r) {
      return e[+r];
    });
  };
}
var WW = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function Co(e) {
  if (!(t = WW.exec(e))) throw new Error("invalid format: " + e);
  var t;
  return new Cp({
    fill: t[1],
    align: t[2],
    sign: t[3],
    symbol: t[4],
    zero: t[5],
    width: t[6],
    comma: t[7],
    precision: t[8] && t[8].slice(1),
    trim: t[9],
    type: t[10]
  });
}
Co.prototype = Cp.prototype;
function Cp(e) {
  this.fill = e.fill === void 0 ? " " : e.fill + "", this.align = e.align === void 0 ? ">" : e.align + "", this.sign = e.sign === void 0 ? "-" : e.sign + "", this.symbol = e.symbol === void 0 ? "" : e.symbol + "", this.zero = !!e.zero, this.width = e.width === void 0 ? void 0 : +e.width, this.comma = !!e.comma, this.precision = e.precision === void 0 ? void 0 : +e.precision, this.trim = !!e.trim, this.type = e.type === void 0 ? "" : e.type + "";
}
Cp.prototype.toString = function() {
  return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === void 0 ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === void 0 ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};
function GW(e) {
  e: for (var t = e.length, r = 1, n = -1, a; r < t; ++r)
    switch (e[r]) {
      case ".":
        n = a = r;
        break;
      case "0":
        n === 0 && (n = r), a = r;
        break;
      default:
        if (!+e[r]) break e;
        n > 0 && (n = 0);
        break;
    }
  return n > 0 ? e.slice(0, n) + e.slice(a + 1) : e;
}
var $4;
function HW(e, t) {
  var r = Cs(e, t);
  if (!r) return e + "";
  var n = r[0], a = r[1], i = a - ($4 = Math.max(-8, Math.min(8, Math.floor(a / 3))) * 3) + 1, o = n.length;
  return i === o ? n : i > o ? n + new Array(i - o + 1).join("0") : i > 0 ? n.slice(0, i) + "." + n.slice(i) : "0." + new Array(1 - i).join("0") + Cs(e, Math.max(0, t + i - 1))[0];
}
function P2(e, t) {
  var r = Cs(e, t);
  if (!r) return e + "";
  var n = r[0], a = r[1];
  return a < 0 ? "0." + new Array(-a).join("0") + n : n.length > a + 1 ? n.slice(0, a + 1) + "." + n.slice(a + 1) : n + new Array(a - n.length + 2).join("0");
}
const T2 = {
  "%": (e, t) => (e * 100).toFixed(t),
  b: (e) => Math.round(e).toString(2),
  c: (e) => e + "",
  d: LW,
  e: (e, t) => e.toExponential(t),
  f: (e, t) => e.toFixed(t),
  g: (e, t) => e.toPrecision(t),
  o: (e) => Math.round(e).toString(8),
  p: (e, t) => P2(e * 100, t),
  r: P2,
  s: HW,
  X: (e) => Math.round(e).toString(16).toUpperCase(),
  x: (e) => Math.round(e).toString(16)
};
function M2(e) {
  return e;
}
var j2 = Array.prototype.map, R2 = ["y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y"];
function UW(e) {
  var t = e.grouping === void 0 || e.thousands === void 0 ? M2 : BW(j2.call(e.grouping, Number), e.thousands + ""), r = e.currency === void 0 ? "" : e.currency[0] + "", n = e.currency === void 0 ? "" : e.currency[1] + "", a = e.decimal === void 0 ? "." : e.decimal + "", i = e.numerals === void 0 ? M2 : VW(j2.call(e.numerals, String)), o = e.percent === void 0 ? "%" : e.percent + "", u = e.minus === void 0 ? "−" : e.minus + "", s = e.nan === void 0 ? "NaN" : e.nan + "";
  function c(f) {
    f = Co(f);
    var d = f.fill, p = f.align, h = f.sign, v = f.symbol, g = f.zero, b = f.width, x = f.comma, w = f.precision, y = f.trim, m = f.type;
    m === "n" ? (x = !0, m = "g") : T2[m] || (w === void 0 && (w = 12), y = !0, m = "g"), (g || d === "0" && p === "=") && (g = !0, d = "0", p = "=");
    var C = v === "$" ? r : v === "#" && /[boxX]/.test(m) ? "0" + m.toLowerCase() : "", O = v === "$" ? n : /[%p]/.test(m) ? o : "", S = T2[m], A = /[defgprs%]/.test(m);
    w = w === void 0 ? 6 : /[gprs]/.test(m) ? Math.max(1, Math.min(21, w)) : Math.max(0, Math.min(20, w));
    function P(T) {
      var M = C, I = O, G, Y, L;
      if (m === "c")
        I = S(T) + I, T = "";
      else {
        T = +T;
        var X = T < 0 || 1 / T < 0;
        if (T = isNaN(T) ? s : S(Math.abs(T), w), y && (T = GW(T)), X && +T == 0 && h !== "+" && (X = !1), M = (X ? h === "(" ? h : u : h === "-" || h === "(" ? "" : h) + M, I = (m === "s" ? R2[8 + $4 / 3] : "") + I + (X && h === "(" ? ")" : ""), A) {
          for (G = -1, Y = T.length; ++G < Y; )
            if (L = T.charCodeAt(G), 48 > L || L > 57) {
              I = (L === 46 ? a + T.slice(G + 1) : T.slice(G)) + I, T = T.slice(0, G);
              break;
            }
        }
      }
      x && !g && (T = t(T, 1 / 0));
      var q = M.length + T.length + I.length, re = q < b ? new Array(b - q + 1).join(d) : "";
      switch (x && g && (T = t(re + T, re.length ? b - I.length : 1 / 0), re = ""), p) {
        case "<":
          T = M + T + I + re;
          break;
        case "=":
          T = M + re + T + I;
          break;
        case "^":
          T = re.slice(0, q = re.length >> 1) + M + T + I + re.slice(q);
          break;
        default:
          T = re + M + T + I;
          break;
      }
      return i(T);
    }
    return P.toString = function() {
      return f + "";
    }, P;
  }
  function l(f, d) {
    var p = c((f = Co(f), f.type = "f", f)), h = Math.max(-8, Math.min(8, Math.floor(Fa(d) / 3))) * 3, v = Math.pow(10, -h), g = R2[8 + h / 3];
    return function(b) {
      return p(v * b) + g;
    };
  }
  return {
    format: c,
    formatPrefix: l
  };
}
var _u, wp, F4;
zW({
  thousands: ",",
  grouping: [3],
  currency: ["$", ""]
});
function zW(e) {
  return _u = UW(e), wp = _u.format, F4 = _u.formatPrefix, _u;
}
function YW(e) {
  return Math.max(0, -Fa(Math.abs(e)));
}
function XW(e, t) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(Fa(t) / 3))) * 3 - Fa(Math.abs(e)));
}
function ZW(e, t) {
  return e = Math.abs(e), t = Math.abs(t) - e, Math.max(0, Fa(t) - Fa(e)) + 1;
}
function D4(e, t, r, n) {
  var a = Sd(e, t, r), i;
  switch (n = Co(n ?? ",f"), n.type) {
    case "s": {
      var o = Math.max(Math.abs(e), Math.abs(t));
      return n.precision == null && !isNaN(i = XW(a, o)) && (n.precision = i), F4(n, o);
    }
    case "":
    case "e":
    case "g":
    case "p":
    case "r": {
      n.precision == null && !isNaN(i = ZW(a, Math.max(Math.abs(e), Math.abs(t)))) && (n.precision = i - (n.type === "e"));
      break;
    }
    case "f":
    case "%": {
      n.precision == null && !isNaN(i = YW(a)) && (n.precision = i - (n.type === "%") * 2);
      break;
    }
  }
  return wp(n);
}
function Sn(e) {
  var t = e.domain;
  return e.ticks = function(r) {
    var n = t();
    return wd(n[0], n[n.length - 1], r ?? 10);
  }, e.tickFormat = function(r, n) {
    var a = t();
    return D4(a[0], a[a.length - 1], r ?? 10, n);
  }, e.nice = function(r) {
    r == null && (r = 10);
    var n = t(), a = 0, i = n.length - 1, o = n[a], u = n[i], s, c, l = 10;
    for (u < o && (c = o, o = u, u = c, c = a, a = i, i = c); l-- > 0; ) {
      if (c = Od(o, u, r), c === s)
        return n[a] = o, n[i] = u, t(n);
      if (c > 0)
        o = Math.floor(o / c) * c, u = Math.ceil(u / c) * c;
      else if (c < 0)
        o = Math.ceil(o * c) / c, u = Math.floor(u * c) / c;
      else
        break;
      s = c;
    }
    return e;
  }, e;
}
function ws() {
  var e = xp();
  return e.copy = function() {
    return ou(e, ws());
  }, fr.apply(e, arguments), Sn(e);
}
function k4(e) {
  var t;
  function r(n) {
    return n == null || isNaN(n = +n) ? t : n;
  }
  return r.invert = r, r.domain = r.range = function(n) {
    return arguments.length ? (e = Array.from(n, xs), r) : e.slice();
  }, r.unknown = function(n) {
    return arguments.length ? (t = n, r) : t;
  }, r.copy = function() {
    return k4(e).unknown(t);
  }, e = arguments.length ? Array.from(e, xs) : [0, 1], Sn(r);
}
function L4(e, t) {
  e = e.slice();
  var r = 0, n = e.length - 1, a = e[r], i = e[n], o;
  return i < a && (o = r, r = n, n = o, o = a, a = i, i = o), e[r] = t.floor(a), e[n] = t.ceil(i), e;
}
function N2(e) {
  return Math.log(e);
}
function $2(e) {
  return Math.exp(e);
}
function KW(e) {
  return -Math.log(-e);
}
function qW(e) {
  return -Math.exp(-e);
}
function JW(e) {
  return isFinite(e) ? +("1e" + e) : e < 0 ? 0 : e;
}
function QW(e) {
  return e === 10 ? JW : e === Math.E ? Math.exp : (t) => Math.pow(e, t);
}
function eG(e) {
  return e === Math.E ? Math.log : e === 10 && Math.log10 || e === 2 && Math.log2 || (e = Math.log(e), (t) => Math.log(t) / e);
}
function F2(e) {
  return (t, r) => -e(-t, r);
}
function Op(e) {
  const t = e(N2, $2), r = t.domain;
  let n = 10, a, i;
  function o() {
    return a = eG(n), i = QW(n), r()[0] < 0 ? (a = F2(a), i = F2(i), e(KW, qW)) : e(N2, $2), t;
  }
  return t.base = function(u) {
    return arguments.length ? (n = +u, o()) : n;
  }, t.domain = function(u) {
    return arguments.length ? (r(u), o()) : r();
  }, t.ticks = (u) => {
    const s = r();
    let c = s[0], l = s[s.length - 1];
    const f = l < c;
    f && ([c, l] = [l, c]);
    let d = a(c), p = a(l), h, v;
    const g = u == null ? 10 : +u;
    let b = [];
    if (!(n % 1) && p - d < g) {
      if (d = Math.floor(d), p = Math.ceil(p), c > 0) {
        for (; d <= p; ++d)
          for (h = 1; h < n; ++h)
            if (v = d < 0 ? h / i(-d) : h * i(d), !(v < c)) {
              if (v > l) break;
              b.push(v);
            }
      } else for (; d <= p; ++d)
        for (h = n - 1; h >= 1; --h)
          if (v = d > 0 ? h / i(-d) : h * i(d), !(v < c)) {
            if (v > l) break;
            b.push(v);
          }
      b.length * 2 < g && (b = wd(c, l, g));
    } else
      b = wd(d, p, Math.min(p - d, g)).map(i);
    return f ? b.reverse() : b;
  }, t.tickFormat = (u, s) => {
    if (u == null && (u = 10), s == null && (s = n === 10 ? "s" : ","), typeof s != "function" && (!(n % 1) && (s = Co(s)).precision == null && (s.trim = !0), s = wp(s)), u === 1 / 0) return s;
    const c = Math.max(1, n * u / t.ticks().length);
    return (l) => {
      let f = l / i(Math.round(a(l)));
      return f * n < n - 0.5 && (f *= n), f <= c ? s(l) : "";
    };
  }, t.nice = () => r(L4(r(), {
    floor: (u) => i(Math.floor(a(u))),
    ceil: (u) => i(Math.ceil(a(u)))
  })), t;
}
function B4() {
  const e = Op(xc()).domain([1, 10]);
  return e.copy = () => ou(e, B4()).base(e.base()), fr.apply(e, arguments), e;
}
function D2(e) {
  return function(t) {
    return Math.sign(t) * Math.log1p(Math.abs(t / e));
  };
}
function k2(e) {
  return function(t) {
    return Math.sign(t) * Math.expm1(Math.abs(t)) * e;
  };
}
function Sp(e) {
  var t = 1, r = e(D2(t), k2(t));
  return r.constant = function(n) {
    return arguments.length ? e(D2(t = +n), k2(t)) : t;
  }, Sn(r);
}
function V4() {
  var e = Sp(xc());
  return e.copy = function() {
    return ou(e, V4()).constant(e.constant());
  }, fr.apply(e, arguments);
}
function L2(e) {
  return function(t) {
    return t < 0 ? -Math.pow(-t, e) : Math.pow(t, e);
  };
}
function tG(e) {
  return e < 0 ? -Math.sqrt(-e) : Math.sqrt(e);
}
function rG(e) {
  return e < 0 ? -e * e : e * e;
}
function Ap(e) {
  var t = e($t, $t), r = 1;
  function n() {
    return r === 1 ? e($t, $t) : r === 0.5 ? e(tG, rG) : e(L2(r), L2(1 / r));
  }
  return t.exponent = function(a) {
    return arguments.length ? (r = +a, n()) : r;
  }, Sn(t);
}
function Ep() {
  var e = Ap(xc());
  return e.copy = function() {
    return ou(e, Ep()).exponent(e.exponent());
  }, fr.apply(e, arguments), e;
}
function nG() {
  return Ep.apply(null, arguments).exponent(0.5);
}
function B2(e) {
  return Math.sign(e) * e * e;
}
function aG(e) {
  return Math.sign(e) * Math.sqrt(Math.abs(e));
}
function W4() {
  var e = xp(), t = [0, 1], r = !1, n;
  function a(i) {
    var o = aG(e(i));
    return isNaN(o) ? n : r ? Math.round(o) : o;
  }
  return a.invert = function(i) {
    return e.invert(B2(i));
  }, a.domain = function(i) {
    return arguments.length ? (e.domain(i), a) : e.domain();
  }, a.range = function(i) {
    return arguments.length ? (e.range((t = Array.from(i, xs)).map(B2)), a) : t.slice();
  }, a.rangeRound = function(i) {
    return a.range(i).round(!0);
  }, a.round = function(i) {
    return arguments.length ? (r = !!i, a) : r;
  }, a.clamp = function(i) {
    return arguments.length ? (e.clamp(i), a) : e.clamp();
  }, a.unknown = function(i) {
    return arguments.length ? (n = i, a) : n;
  }, a.copy = function() {
    return W4(e.domain(), t).round(r).clamp(e.clamp()).unknown(n);
  }, fr.apply(a, arguments), Sn(a);
}
function G4() {
  var e = [], t = [], r = [], n;
  function a() {
    var o = 0, u = Math.max(1, t.length);
    for (r = new Array(u - 1); ++o < u; ) r[o - 1] = cW(e, o / u);
    return i;
  }
  function i(o) {
    return o == null || isNaN(o = +o) ? n : t[au(r, o)];
  }
  return i.invertExtent = function(o) {
    var u = t.indexOf(o);
    return u < 0 ? [NaN, NaN] : [
      u > 0 ? r[u - 1] : e[0],
      u < r.length ? r[u] : e[e.length - 1]
    ];
  }, i.domain = function(o) {
    if (!arguments.length) return e.slice();
    e = [];
    for (let u of o) u != null && !isNaN(u = +u) && e.push(u);
    return e.sort(hn), a();
  }, i.range = function(o) {
    return arguments.length ? (t = Array.from(o), a()) : t.slice();
  }, i.unknown = function(o) {
    return arguments.length ? (n = o, i) : n;
  }, i.quantiles = function() {
    return r.slice();
  }, i.copy = function() {
    return G4().domain(e).range(t).unknown(n);
  }, fr.apply(i, arguments);
}
function H4() {
  var e = 0, t = 1, r = 1, n = [0.5], a = [0, 1], i;
  function o(s) {
    return s != null && s <= s ? a[au(n, s, 0, r)] : i;
  }
  function u() {
    var s = -1;
    for (n = new Array(r); ++s < r; ) n[s] = ((s + 1) * t - (s - r) * e) / (r + 1);
    return o;
  }
  return o.domain = function(s) {
    return arguments.length ? ([e, t] = s, e = +e, t = +t, u()) : [e, t];
  }, o.range = function(s) {
    return arguments.length ? (r = (a = Array.from(s)).length - 1, u()) : a.slice();
  }, o.invertExtent = function(s) {
    var c = a.indexOf(s);
    return c < 0 ? [NaN, NaN] : c < 1 ? [e, n[0]] : c >= r ? [n[r - 1], t] : [n[c - 1], n[c]];
  }, o.unknown = function(s) {
    return arguments.length && (i = s), o;
  }, o.thresholds = function() {
    return n.slice();
  }, o.copy = function() {
    return H4().domain([e, t]).range(a).unknown(i);
  }, fr.apply(Sn(o), arguments);
}
function U4() {
  var e = [0.5], t = [0, 1], r, n = 1;
  function a(i) {
    return i != null && i <= i ? t[au(e, i, 0, n)] : r;
  }
  return a.domain = function(i) {
    return arguments.length ? (e = Array.from(i), n = Math.min(e.length, t.length - 1), a) : e.slice();
  }, a.range = function(i) {
    return arguments.length ? (t = Array.from(i), n = Math.min(e.length, t.length - 1), a) : t.slice();
  }, a.invertExtent = function(i) {
    var o = t.indexOf(i);
    return [e[o - 1], e[o]];
  }, a.unknown = function(i) {
    return arguments.length ? (r = i, a) : r;
  }, a.copy = function() {
    return U4().domain(e).range(t).unknown(r);
  }, fr.apply(a, arguments);
}
const Xl = /* @__PURE__ */ new Date(), Zl = /* @__PURE__ */ new Date();
function mt(e, t, r, n) {
  function a(i) {
    return e(i = arguments.length === 0 ? /* @__PURE__ */ new Date() : /* @__PURE__ */ new Date(+i)), i;
  }
  return a.floor = (i) => (e(i = /* @__PURE__ */ new Date(+i)), i), a.ceil = (i) => (e(i = new Date(i - 1)), t(i, 1), e(i), i), a.round = (i) => {
    const o = a(i), u = a.ceil(i);
    return i - o < u - i ? o : u;
  }, a.offset = (i, o) => (t(i = /* @__PURE__ */ new Date(+i), o == null ? 1 : Math.floor(o)), i), a.range = (i, o, u) => {
    const s = [];
    if (i = a.ceil(i), u = u == null ? 1 : Math.floor(u), !(i < o) || !(u > 0)) return s;
    let c;
    do
      s.push(c = /* @__PURE__ */ new Date(+i)), t(i, u), e(i);
    while (c < i && i < o);
    return s;
  }, a.filter = (i) => mt((o) => {
    if (o >= o) for (; e(o), !i(o); ) o.setTime(o - 1);
  }, (o, u) => {
    if (o >= o)
      if (u < 0) for (; ++u <= 0; )
        for (; t(o, -1), !i(o); )
          ;
      else for (; --u >= 0; )
        for (; t(o, 1), !i(o); )
          ;
  }), r && (a.count = (i, o) => (Xl.setTime(+i), Zl.setTime(+o), e(Xl), e(Zl), Math.floor(r(Xl, Zl))), a.every = (i) => (i = Math.floor(i), !isFinite(i) || !(i > 0) ? null : i > 1 ? a.filter(n ? (o) => n(o) % i === 0 : (o) => a.count(0, o) % i === 0) : a)), a;
}
const Os = mt(() => {
}, (e, t) => {
  e.setTime(+e + t);
}, (e, t) => t - e);
Os.every = (e) => (e = Math.floor(e), !isFinite(e) || !(e > 0) ? null : e > 1 ? mt((t) => {
  t.setTime(Math.floor(t / e) * e);
}, (t, r) => {
  t.setTime(+t + r * e);
}, (t, r) => (r - t) / e) : Os);
Os.range;
const Br = 1e3, ar = Br * 60, Vr = ar * 60, Zr = Vr * 24, _p = Zr * 7, V2 = Zr * 30, Kl = Zr * 365, Bn = mt((e) => {
  e.setTime(e - e.getMilliseconds());
}, (e, t) => {
  e.setTime(+e + t * Br);
}, (e, t) => (t - e) / Br, (e) => e.getUTCSeconds());
Bn.range;
const Ip = mt((e) => {
  e.setTime(e - e.getMilliseconds() - e.getSeconds() * Br);
}, (e, t) => {
  e.setTime(+e + t * ar);
}, (e, t) => (t - e) / ar, (e) => e.getMinutes());
Ip.range;
const Pp = mt((e) => {
  e.setUTCSeconds(0, 0);
}, (e, t) => {
  e.setTime(+e + t * ar);
}, (e, t) => (t - e) / ar, (e) => e.getUTCMinutes());
Pp.range;
const Tp = mt((e) => {
  e.setTime(e - e.getMilliseconds() - e.getSeconds() * Br - e.getMinutes() * ar);
}, (e, t) => {
  e.setTime(+e + t * Vr);
}, (e, t) => (t - e) / Vr, (e) => e.getHours());
Tp.range;
const Mp = mt((e) => {
  e.setUTCMinutes(0, 0, 0);
}, (e, t) => {
  e.setTime(+e + t * Vr);
}, (e, t) => (t - e) / Vr, (e) => e.getUTCHours());
Mp.range;
const uu = mt(
  (e) => e.setHours(0, 0, 0, 0),
  (e, t) => e.setDate(e.getDate() + t),
  (e, t) => (t - e - (t.getTimezoneOffset() - e.getTimezoneOffset()) * ar) / Zr,
  (e) => e.getDate() - 1
);
uu.range;
const Cc = mt((e) => {
  e.setUTCHours(0, 0, 0, 0);
}, (e, t) => {
  e.setUTCDate(e.getUTCDate() + t);
}, (e, t) => (t - e) / Zr, (e) => e.getUTCDate() - 1);
Cc.range;
const z4 = mt((e) => {
  e.setUTCHours(0, 0, 0, 0);
}, (e, t) => {
  e.setUTCDate(e.getUTCDate() + t);
}, (e, t) => (t - e) / Zr, (e) => Math.floor(e / Zr));
z4.range;
function ea(e) {
  return mt((t) => {
    t.setDate(t.getDate() - (t.getDay() + 7 - e) % 7), t.setHours(0, 0, 0, 0);
  }, (t, r) => {
    t.setDate(t.getDate() + r * 7);
  }, (t, r) => (r - t - (r.getTimezoneOffset() - t.getTimezoneOffset()) * ar) / _p);
}
const wc = ea(0), Ss = ea(1), iG = ea(2), oG = ea(3), Da = ea(4), uG = ea(5), sG = ea(6);
wc.range;
Ss.range;
iG.range;
oG.range;
Da.range;
uG.range;
sG.range;
function ta(e) {
  return mt((t) => {
    t.setUTCDate(t.getUTCDate() - (t.getUTCDay() + 7 - e) % 7), t.setUTCHours(0, 0, 0, 0);
  }, (t, r) => {
    t.setUTCDate(t.getUTCDate() + r * 7);
  }, (t, r) => (r - t) / _p);
}
const Oc = ta(0), As = ta(1), cG = ta(2), lG = ta(3), ka = ta(4), fG = ta(5), dG = ta(6);
Oc.range;
As.range;
cG.range;
lG.range;
ka.range;
fG.range;
dG.range;
const jp = mt((e) => {
  e.setDate(1), e.setHours(0, 0, 0, 0);
}, (e, t) => {
  e.setMonth(e.getMonth() + t);
}, (e, t) => t.getMonth() - e.getMonth() + (t.getFullYear() - e.getFullYear()) * 12, (e) => e.getMonth());
jp.range;
const Rp = mt((e) => {
  e.setUTCDate(1), e.setUTCHours(0, 0, 0, 0);
}, (e, t) => {
  e.setUTCMonth(e.getUTCMonth() + t);
}, (e, t) => t.getUTCMonth() - e.getUTCMonth() + (t.getUTCFullYear() - e.getUTCFullYear()) * 12, (e) => e.getUTCMonth());
Rp.range;
const Kr = mt((e) => {
  e.setMonth(0, 1), e.setHours(0, 0, 0, 0);
}, (e, t) => {
  e.setFullYear(e.getFullYear() + t);
}, (e, t) => t.getFullYear() - e.getFullYear(), (e) => e.getFullYear());
Kr.every = (e) => !isFinite(e = Math.floor(e)) || !(e > 0) ? null : mt((t) => {
  t.setFullYear(Math.floor(t.getFullYear() / e) * e), t.setMonth(0, 1), t.setHours(0, 0, 0, 0);
}, (t, r) => {
  t.setFullYear(t.getFullYear() + r * e);
});
Kr.range;
const qr = mt((e) => {
  e.setUTCMonth(0, 1), e.setUTCHours(0, 0, 0, 0);
}, (e, t) => {
  e.setUTCFullYear(e.getUTCFullYear() + t);
}, (e, t) => t.getUTCFullYear() - e.getUTCFullYear(), (e) => e.getUTCFullYear());
qr.every = (e) => !isFinite(e = Math.floor(e)) || !(e > 0) ? null : mt((t) => {
  t.setUTCFullYear(Math.floor(t.getUTCFullYear() / e) * e), t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
}, (t, r) => {
  t.setUTCFullYear(t.getUTCFullYear() + r * e);
});
qr.range;
function Y4(e, t, r, n, a, i) {
  const o = [
    [Bn, 1, Br],
    [Bn, 5, 5 * Br],
    [Bn, 15, 15 * Br],
    [Bn, 30, 30 * Br],
    [i, 1, ar],
    [i, 5, 5 * ar],
    [i, 15, 15 * ar],
    [i, 30, 30 * ar],
    [a, 1, Vr],
    [a, 3, 3 * Vr],
    [a, 6, 6 * Vr],
    [a, 12, 12 * Vr],
    [n, 1, Zr],
    [n, 2, 2 * Zr],
    [r, 1, _p],
    [t, 1, V2],
    [t, 3, 3 * V2],
    [e, 1, Kl]
  ];
  function u(c, l, f) {
    const d = l < c;
    d && ([c, l] = [l, c]);
    const p = f && typeof f.range == "function" ? f : s(c, l, f), h = p ? p.range(c, +l + 1) : [];
    return d ? h.reverse() : h;
  }
  function s(c, l, f) {
    const d = Math.abs(l - c) / f, p = vp(([, , g]) => g).right(o, d);
    if (p === o.length) return e.every(Sd(c / Kl, l / Kl, f));
    if (p === 0) return Os.every(Math.max(Sd(c, l, f), 1));
    const [h, v] = o[d / o[p - 1][2] < o[p][2] / d ? p - 1 : p];
    return h.every(v);
  }
  return [u, s];
}
const [pG, hG] = Y4(qr, Rp, Oc, z4, Mp, Pp), [vG, gG] = Y4(Kr, jp, wc, uu, Tp, Ip);
function ql(e) {
  if (0 <= e.y && e.y < 100) {
    var t = new Date(-1, e.m, e.d, e.H, e.M, e.S, e.L);
    return t.setFullYear(e.y), t;
  }
  return new Date(e.y, e.m, e.d, e.H, e.M, e.S, e.L);
}
function Jl(e) {
  if (0 <= e.y && e.y < 100) {
    var t = new Date(Date.UTC(-1, e.m, e.d, e.H, e.M, e.S, e.L));
    return t.setUTCFullYear(e.y), t;
  }
  return new Date(Date.UTC(e.y, e.m, e.d, e.H, e.M, e.S, e.L));
}
function Pi(e, t, r) {
  return { y: e, m: t, d: r, H: 0, M: 0, S: 0, L: 0 };
}
function mG(e) {
  var t = e.dateTime, r = e.date, n = e.time, a = e.periods, i = e.days, o = e.shortDays, u = e.months, s = e.shortMonths, c = Ti(a), l = Mi(a), f = Ti(i), d = Mi(i), p = Ti(o), h = Mi(o), v = Ti(u), g = Mi(u), b = Ti(s), x = Mi(s), w = {
    a: X,
    A: q,
    b: re,
    B: j,
    c: null,
    d: Y2,
    e: Y2,
    f: BG,
    g: KG,
    G: JG,
    H: DG,
    I: kG,
    j: LG,
    L: X4,
    m: VG,
    M: WG,
    p: W,
    q: D,
    Q: K2,
    s: q2,
    S: GG,
    u: HG,
    U: UG,
    V: zG,
    w: YG,
    W: XG,
    x: null,
    X: null,
    y: ZG,
    Y: qG,
    Z: QG,
    "%": Z2
  }, y = {
    a: R,
    A: $,
    b: B,
    B: H,
    c: null,
    d: X2,
    e: X2,
    f: nH,
    g: pH,
    G: vH,
    H: eH,
    I: tH,
    j: rH,
    L: K4,
    m: aH,
    M: iH,
    p: z,
    q: J,
    Q: K2,
    s: q2,
    S: oH,
    u: uH,
    U: sH,
    V: cH,
    w: lH,
    W: fH,
    x: null,
    X: null,
    y: dH,
    Y: hH,
    Z: gH,
    "%": Z2
  }, m = {
    a: P,
    A: T,
    b: M,
    B: I,
    c: G,
    d: U2,
    e: U2,
    f: RG,
    g: H2,
    G: G2,
    H: z2,
    I: z2,
    j: PG,
    L: jG,
    m: IG,
    M: TG,
    p: A,
    q: _G,
    Q: $G,
    s: FG,
    S: MG,
    u: wG,
    U: OG,
    V: SG,
    w: CG,
    W: AG,
    x: Y,
    X: L,
    y: H2,
    Y: G2,
    Z: EG,
    "%": NG
  };
  w.x = C(r, w), w.X = C(n, w), w.c = C(t, w), y.x = C(r, y), y.X = C(n, y), y.c = C(t, y);
  function C(U, F) {
    return function(k) {
      var E = [], K = -1, Z = 0, Q = U.length, ne, ue, de;
      for (k instanceof Date || (k = /* @__PURE__ */ new Date(+k)); ++K < Q; )
        U.charCodeAt(K) === 37 && (E.push(U.slice(Z, K)), (ue = W2[ne = U.charAt(++K)]) != null ? ne = U.charAt(++K) : ue = ne === "e" ? " " : "0", (de = F[ne]) && (ne = de(k, ue)), E.push(ne), Z = K + 1);
      return E.push(U.slice(Z, K)), E.join("");
    };
  }
  function O(U, F) {
    return function(k) {
      var E = Pi(1900, void 0, 1), K = S(E, U, k += "", 0), Z, Q;
      if (K != k.length) return null;
      if ("Q" in E) return new Date(E.Q);
      if ("s" in E) return new Date(E.s * 1e3 + ("L" in E ? E.L : 0));
      if (F && !("Z" in E) && (E.Z = 0), "p" in E && (E.H = E.H % 12 + E.p * 12), E.m === void 0 && (E.m = "q" in E ? E.q : 0), "V" in E) {
        if (E.V < 1 || E.V > 53) return null;
        "w" in E || (E.w = 1), "Z" in E ? (Z = Jl(Pi(E.y, 0, 1)), Q = Z.getUTCDay(), Z = Q > 4 || Q === 0 ? As.ceil(Z) : As(Z), Z = Cc.offset(Z, (E.V - 1) * 7), E.y = Z.getUTCFullYear(), E.m = Z.getUTCMonth(), E.d = Z.getUTCDate() + (E.w + 6) % 7) : (Z = ql(Pi(E.y, 0, 1)), Q = Z.getDay(), Z = Q > 4 || Q === 0 ? Ss.ceil(Z) : Ss(Z), Z = uu.offset(Z, (E.V - 1) * 7), E.y = Z.getFullYear(), E.m = Z.getMonth(), E.d = Z.getDate() + (E.w + 6) % 7);
      } else ("W" in E || "U" in E) && ("w" in E || (E.w = "u" in E ? E.u % 7 : "W" in E ? 1 : 0), Q = "Z" in E ? Jl(Pi(E.y, 0, 1)).getUTCDay() : ql(Pi(E.y, 0, 1)).getDay(), E.m = 0, E.d = "W" in E ? (E.w + 6) % 7 + E.W * 7 - (Q + 5) % 7 : E.w + E.U * 7 - (Q + 6) % 7);
      return "Z" in E ? (E.H += E.Z / 100 | 0, E.M += E.Z % 100, Jl(E)) : ql(E);
    };
  }
  function S(U, F, k, E) {
    for (var K = 0, Z = F.length, Q = k.length, ne, ue; K < Z; ) {
      if (E >= Q) return -1;
      if (ne = F.charCodeAt(K++), ne === 37) {
        if (ne = F.charAt(K++), ue = m[ne in W2 ? F.charAt(K++) : ne], !ue || (E = ue(U, k, E)) < 0) return -1;
      } else if (ne != k.charCodeAt(E++))
        return -1;
    }
    return E;
  }
  function A(U, F, k) {
    var E = c.exec(F.slice(k));
    return E ? (U.p = l.get(E[0].toLowerCase()), k + E[0].length) : -1;
  }
  function P(U, F, k) {
    var E = p.exec(F.slice(k));
    return E ? (U.w = h.get(E[0].toLowerCase()), k + E[0].length) : -1;
  }
  function T(U, F, k) {
    var E = f.exec(F.slice(k));
    return E ? (U.w = d.get(E[0].toLowerCase()), k + E[0].length) : -1;
  }
  function M(U, F, k) {
    var E = b.exec(F.slice(k));
    return E ? (U.m = x.get(E[0].toLowerCase()), k + E[0].length) : -1;
  }
  function I(U, F, k) {
    var E = v.exec(F.slice(k));
    return E ? (U.m = g.get(E[0].toLowerCase()), k + E[0].length) : -1;
  }
  function G(U, F, k) {
    return S(U, t, F, k);
  }
  function Y(U, F, k) {
    return S(U, r, F, k);
  }
  function L(U, F, k) {
    return S(U, n, F, k);
  }
  function X(U) {
    return o[U.getDay()];
  }
  function q(U) {
    return i[U.getDay()];
  }
  function re(U) {
    return s[U.getMonth()];
  }
  function j(U) {
    return u[U.getMonth()];
  }
  function W(U) {
    return a[+(U.getHours() >= 12)];
  }
  function D(U) {
    return 1 + ~~(U.getMonth() / 3);
  }
  function R(U) {
    return o[U.getUTCDay()];
  }
  function $(U) {
    return i[U.getUTCDay()];
  }
  function B(U) {
    return s[U.getUTCMonth()];
  }
  function H(U) {
    return u[U.getUTCMonth()];
  }
  function z(U) {
    return a[+(U.getUTCHours() >= 12)];
  }
  function J(U) {
    return 1 + ~~(U.getUTCMonth() / 3);
  }
  return {
    format: function(U) {
      var F = C(U += "", w);
      return F.toString = function() {
        return U;
      }, F;
    },
    parse: function(U) {
      var F = O(U += "", !1);
      return F.toString = function() {
        return U;
      }, F;
    },
    utcFormat: function(U) {
      var F = C(U += "", y);
      return F.toString = function() {
        return U;
      }, F;
    },
    utcParse: function(U) {
      var F = O(U += "", !0);
      return F.toString = function() {
        return U;
      }, F;
    }
  };
}
var W2 = { "-": "", _: " ", 0: "0" }, wt = /^\s*\d+/, yG = /^%/, bG = /[\\^$*+?|[\]().{}]/g;
function $e(e, t, r) {
  var n = e < 0 ? "-" : "", a = (n ? -e : e) + "", i = a.length;
  return n + (i < r ? new Array(r - i + 1).join(t) + a : a);
}
function xG(e) {
  return e.replace(bG, "\\$&");
}
function Ti(e) {
  return new RegExp("^(?:" + e.map(xG).join("|") + ")", "i");
}
function Mi(e) {
  return new Map(e.map((t, r) => [t.toLowerCase(), r]));
}
function CG(e, t, r) {
  var n = wt.exec(t.slice(r, r + 1));
  return n ? (e.w = +n[0], r + n[0].length) : -1;
}
function wG(e, t, r) {
  var n = wt.exec(t.slice(r, r + 1));
  return n ? (e.u = +n[0], r + n[0].length) : -1;
}
function OG(e, t, r) {
  var n = wt.exec(t.slice(r, r + 2));
  return n ? (e.U = +n[0], r + n[0].length) : -1;
}
function SG(e, t, r) {
  var n = wt.exec(t.slice(r, r + 2));
  return n ? (e.V = +n[0], r + n[0].length) : -1;
}
function AG(e, t, r) {
  var n = wt.exec(t.slice(r, r + 2));
  return n ? (e.W = +n[0], r + n[0].length) : -1;
}
function G2(e, t, r) {
  var n = wt.exec(t.slice(r, r + 4));
  return n ? (e.y = +n[0], r + n[0].length) : -1;
}
function H2(e, t, r) {
  var n = wt.exec(t.slice(r, r + 2));
  return n ? (e.y = +n[0] + (+n[0] > 68 ? 1900 : 2e3), r + n[0].length) : -1;
}
function EG(e, t, r) {
  var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(t.slice(r, r + 6));
  return n ? (e.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), r + n[0].length) : -1;
}
function _G(e, t, r) {
  var n = wt.exec(t.slice(r, r + 1));
  return n ? (e.q = n[0] * 3 - 3, r + n[0].length) : -1;
}
function IG(e, t, r) {
  var n = wt.exec(t.slice(r, r + 2));
  return n ? (e.m = n[0] - 1, r + n[0].length) : -1;
}
function U2(e, t, r) {
  var n = wt.exec(t.slice(r, r + 2));
  return n ? (e.d = +n[0], r + n[0].length) : -1;
}
function PG(e, t, r) {
  var n = wt.exec(t.slice(r, r + 3));
  return n ? (e.m = 0, e.d = +n[0], r + n[0].length) : -1;
}
function z2(e, t, r) {
  var n = wt.exec(t.slice(r, r + 2));
  return n ? (e.H = +n[0], r + n[0].length) : -1;
}
function TG(e, t, r) {
  var n = wt.exec(t.slice(r, r + 2));
  return n ? (e.M = +n[0], r + n[0].length) : -1;
}
function MG(e, t, r) {
  var n = wt.exec(t.slice(r, r + 2));
  return n ? (e.S = +n[0], r + n[0].length) : -1;
}
function jG(e, t, r) {
  var n = wt.exec(t.slice(r, r + 3));
  return n ? (e.L = +n[0], r + n[0].length) : -1;
}
function RG(e, t, r) {
  var n = wt.exec(t.slice(r, r + 6));
  return n ? (e.L = Math.floor(n[0] / 1e3), r + n[0].length) : -1;
}
function NG(e, t, r) {
  var n = yG.exec(t.slice(r, r + 1));
  return n ? r + n[0].length : -1;
}
function $G(e, t, r) {
  var n = wt.exec(t.slice(r));
  return n ? (e.Q = +n[0], r + n[0].length) : -1;
}
function FG(e, t, r) {
  var n = wt.exec(t.slice(r));
  return n ? (e.s = +n[0], r + n[0].length) : -1;
}
function Y2(e, t) {
  return $e(e.getDate(), t, 2);
}
function DG(e, t) {
  return $e(e.getHours(), t, 2);
}
function kG(e, t) {
  return $e(e.getHours() % 12 || 12, t, 2);
}
function LG(e, t) {
  return $e(1 + uu.count(Kr(e), e), t, 3);
}
function X4(e, t) {
  return $e(e.getMilliseconds(), t, 3);
}
function BG(e, t) {
  return X4(e, t) + "000";
}
function VG(e, t) {
  return $e(e.getMonth() + 1, t, 2);
}
function WG(e, t) {
  return $e(e.getMinutes(), t, 2);
}
function GG(e, t) {
  return $e(e.getSeconds(), t, 2);
}
function HG(e) {
  var t = e.getDay();
  return t === 0 ? 7 : t;
}
function UG(e, t) {
  return $e(wc.count(Kr(e) - 1, e), t, 2);
}
function Z4(e) {
  var t = e.getDay();
  return t >= 4 || t === 0 ? Da(e) : Da.ceil(e);
}
function zG(e, t) {
  return e = Z4(e), $e(Da.count(Kr(e), e) + (Kr(e).getDay() === 4), t, 2);
}
function YG(e) {
  return e.getDay();
}
function XG(e, t) {
  return $e(Ss.count(Kr(e) - 1, e), t, 2);
}
function ZG(e, t) {
  return $e(e.getFullYear() % 100, t, 2);
}
function KG(e, t) {
  return e = Z4(e), $e(e.getFullYear() % 100, t, 2);
}
function qG(e, t) {
  return $e(e.getFullYear() % 1e4, t, 4);
}
function JG(e, t) {
  var r = e.getDay();
  return e = r >= 4 || r === 0 ? Da(e) : Da.ceil(e), $e(e.getFullYear() % 1e4, t, 4);
}
function QG(e) {
  var t = e.getTimezoneOffset();
  return (t > 0 ? "-" : (t *= -1, "+")) + $e(t / 60 | 0, "0", 2) + $e(t % 60, "0", 2);
}
function X2(e, t) {
  return $e(e.getUTCDate(), t, 2);
}
function eH(e, t) {
  return $e(e.getUTCHours(), t, 2);
}
function tH(e, t) {
  return $e(e.getUTCHours() % 12 || 12, t, 2);
}
function rH(e, t) {
  return $e(1 + Cc.count(qr(e), e), t, 3);
}
function K4(e, t) {
  return $e(e.getUTCMilliseconds(), t, 3);
}
function nH(e, t) {
  return K4(e, t) + "000";
}
function aH(e, t) {
  return $e(e.getUTCMonth() + 1, t, 2);
}
function iH(e, t) {
  return $e(e.getUTCMinutes(), t, 2);
}
function oH(e, t) {
  return $e(e.getUTCSeconds(), t, 2);
}
function uH(e) {
  var t = e.getUTCDay();
  return t === 0 ? 7 : t;
}
function sH(e, t) {
  return $e(Oc.count(qr(e) - 1, e), t, 2);
}
function q4(e) {
  var t = e.getUTCDay();
  return t >= 4 || t === 0 ? ka(e) : ka.ceil(e);
}
function cH(e, t) {
  return e = q4(e), $e(ka.count(qr(e), e) + (qr(e).getUTCDay() === 4), t, 2);
}
function lH(e) {
  return e.getUTCDay();
}
function fH(e, t) {
  return $e(As.count(qr(e) - 1, e), t, 2);
}
function dH(e, t) {
  return $e(e.getUTCFullYear() % 100, t, 2);
}
function pH(e, t) {
  return e = q4(e), $e(e.getUTCFullYear() % 100, t, 2);
}
function hH(e, t) {
  return $e(e.getUTCFullYear() % 1e4, t, 4);
}
function vH(e, t) {
  var r = e.getUTCDay();
  return e = r >= 4 || r === 0 ? ka(e) : ka.ceil(e), $e(e.getUTCFullYear() % 1e4, t, 4);
}
function gH() {
  return "+0000";
}
function Z2() {
  return "%";
}
function K2(e) {
  return +e;
}
function q2(e) {
  return Math.floor(+e / 1e3);
}
var ca, J4, Q4;
mH({
  dateTime: "%x, %X",
  date: "%-m/%-d/%Y",
  time: "%-I:%M:%S %p",
  periods: ["AM", "PM"],
  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
});
function mH(e) {
  return ca = mG(e), J4 = ca.format, ca.parse, Q4 = ca.utcFormat, ca.utcParse, ca;
}
function yH(e) {
  return new Date(e);
}
function bH(e) {
  return e instanceof Date ? +e : +/* @__PURE__ */ new Date(+e);
}
function Np(e, t, r, n, a, i, o, u, s, c) {
  var l = xp(), f = l.invert, d = l.domain, p = c(".%L"), h = c(":%S"), v = c("%I:%M"), g = c("%I %p"), b = c("%a %d"), x = c("%b %d"), w = c("%B"), y = c("%Y");
  function m(C) {
    return (s(C) < C ? p : u(C) < C ? h : o(C) < C ? v : i(C) < C ? g : n(C) < C ? a(C) < C ? b : x : r(C) < C ? w : y)(C);
  }
  return l.invert = function(C) {
    return new Date(f(C));
  }, l.domain = function(C) {
    return arguments.length ? d(Array.from(C, bH)) : d().map(yH);
  }, l.ticks = function(C) {
    var O = d();
    return e(O[0], O[O.length - 1], C ?? 10);
  }, l.tickFormat = function(C, O) {
    return O == null ? m : c(O);
  }, l.nice = function(C) {
    var O = d();
    return (!C || typeof C.range != "function") && (C = t(O[0], O[O.length - 1], C ?? 10)), C ? d(L4(O, C)) : l;
  }, l.copy = function() {
    return ou(l, Np(e, t, r, n, a, i, o, u, s, c));
  }, l;
}
function xH() {
  return fr.apply(Np(vG, gG, Kr, jp, wc, uu, Tp, Ip, Bn, J4).domain([new Date(2e3, 0, 1), new Date(2e3, 0, 2)]), arguments);
}
function CH() {
  return fr.apply(Np(pG, hG, qr, Rp, Oc, Cc, Mp, Pp, Bn, Q4).domain([Date.UTC(2e3, 0, 1), Date.UTC(2e3, 0, 2)]), arguments);
}
function Sc() {
  var e = 0, t = 1, r, n, a, i, o = $t, u = !1, s;
  function c(f) {
    return f == null || isNaN(f = +f) ? s : o(a === 0 ? 0.5 : (f = (i(f) - r) * a, u ? Math.max(0, Math.min(1, f)) : f));
  }
  c.domain = function(f) {
    return arguments.length ? ([e, t] = f, r = i(e = +e), n = i(t = +t), a = r === n ? 0 : 1 / (n - r), c) : [e, t];
  }, c.clamp = function(f) {
    return arguments.length ? (u = !!f, c) : u;
  }, c.interpolator = function(f) {
    return arguments.length ? (o = f, c) : o;
  };
  function l(f) {
    return function(d) {
      var p, h;
      return arguments.length ? ([p, h] = d, o = f(p, h), c) : [o(0), o(1)];
    };
  }
  return c.range = l(si), c.rangeRound = l(bp), c.unknown = function(f) {
    return arguments.length ? (s = f, c) : s;
  }, function(f) {
    return i = f, r = f(e), n = f(t), a = r === n ? 0 : 1 / (n - r), c;
  };
}
function An(e, t) {
  return t.domain(e.domain()).interpolator(e.interpolator()).clamp(e.clamp()).unknown(e.unknown());
}
function e5() {
  var e = Sn(Sc()($t));
  return e.copy = function() {
    return An(e, e5());
  }, rn.apply(e, arguments);
}
function t5() {
  var e = Op(Sc()).domain([1, 10]);
  return e.copy = function() {
    return An(e, t5()).base(e.base());
  }, rn.apply(e, arguments);
}
function r5() {
  var e = Sp(Sc());
  return e.copy = function() {
    return An(e, r5()).constant(e.constant());
  }, rn.apply(e, arguments);
}
function $p() {
  var e = Ap(Sc());
  return e.copy = function() {
    return An(e, $p()).exponent(e.exponent());
  }, rn.apply(e, arguments);
}
function wH() {
  return $p.apply(null, arguments).exponent(0.5);
}
function n5() {
  var e = [], t = $t;
  function r(n) {
    if (n != null && !isNaN(n = +n)) return t((au(e, n, 1) - 1) / (e.length - 1));
  }
  return r.domain = function(n) {
    if (!arguments.length) return e.slice();
    e = [];
    for (let a of n) a != null && !isNaN(a = +a) && e.push(a);
    return e.sort(hn), r;
  }, r.interpolator = function(n) {
    return arguments.length ? (t = n, r) : t;
  }, r.range = function() {
    return e.map((n, a) => t(a / (e.length - 1)));
  }, r.quantiles = function(n) {
    return Array.from({ length: n + 1 }, (a, i) => sW(e, i / n));
  }, r.copy = function() {
    return n5(t).domain(e);
  }, rn.apply(r, arguments);
}
function Ac() {
  var e = 0, t = 0.5, r = 1, n = 1, a, i, o, u, s, c = $t, l, f = !1, d;
  function p(v) {
    return isNaN(v = +v) ? d : (v = 0.5 + ((v = +l(v)) - i) * (n * v < n * i ? u : s), c(f ? Math.max(0, Math.min(1, v)) : v));
  }
  p.domain = function(v) {
    return arguments.length ? ([e, t, r] = v, a = l(e = +e), i = l(t = +t), o = l(r = +r), u = a === i ? 0 : 0.5 / (i - a), s = i === o ? 0 : 0.5 / (o - i), n = i < a ? -1 : 1, p) : [e, t, r];
  }, p.clamp = function(v) {
    return arguments.length ? (f = !!v, p) : f;
  }, p.interpolator = function(v) {
    return arguments.length ? (c = v, p) : c;
  };
  function h(v) {
    return function(g) {
      var b, x, w;
      return arguments.length ? ([b, x, w] = g, c = NW(v, [b, x, w]), p) : [c(0), c(0.5), c(1)];
    };
  }
  return p.range = h(si), p.rangeRound = h(bp), p.unknown = function(v) {
    return arguments.length ? (d = v, p) : d;
  }, function(v) {
    return l = v, a = v(e), i = v(t), o = v(r), u = a === i ? 0 : 0.5 / (i - a), s = i === o ? 0 : 0.5 / (o - i), n = i < a ? -1 : 1, p;
  };
}
function a5() {
  var e = Sn(Ac()($t));
  return e.copy = function() {
    return An(e, a5());
  }, rn.apply(e, arguments);
}
function i5() {
  var e = Op(Ac()).domain([0.1, 1, 10]);
  return e.copy = function() {
    return An(e, i5()).base(e.base());
  }, rn.apply(e, arguments);
}
function o5() {
  var e = Sp(Ac());
  return e.copy = function() {
    return An(e, o5()).constant(e.constant());
  }, rn.apply(e, arguments);
}
function Fp() {
  var e = Ap(Ac());
  return e.copy = function() {
    return An(e, Fp()).exponent(e.exponent());
  }, rn.apply(e, arguments);
}
function OH() {
  return Fp.apply(null, arguments).exponent(0.5);
}
const J2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  scaleBand: mo,
  scaleDiverging: a5,
  scaleDivergingLog: i5,
  scaleDivergingPow: Fp,
  scaleDivergingSqrt: OH,
  scaleDivergingSymlog: o5,
  scaleIdentity: k4,
  scaleImplicit: Ad,
  scaleLinear: ws,
  scaleLog: B4,
  scaleOrdinal: gp,
  scalePoint: Ki,
  scalePow: Ep,
  scaleQuantile: G4,
  scaleQuantize: H4,
  scaleRadial: W4,
  scaleSequential: e5,
  scaleSequentialLog: t5,
  scaleSequentialPow: $p,
  scaleSequentialQuantile: n5,
  scaleSequentialSqrt: wH,
  scaleSequentialSymlog: r5,
  scaleSqrt: nG,
  scaleSymlog: V4,
  scaleThreshold: U4,
  scaleTime: xH,
  scaleUtc: CH,
  tickFormat: D4
}, Symbol.toStringTag, { value: "Module" }));
var SH = qa;
function AH(e, t, r) {
  for (var n = -1, a = e.length; ++n < a; ) {
    var i = e[n], o = t(i);
    if (o != null && (u === void 0 ? o === o && !SH(o) : r(o, u)))
      var u = o, s = i;
  }
  return s;
}
var u5 = AH;
function EH(e, t) {
  return e > t;
}
var _H = EH, IH = u5, PH = _H, TH = ui;
function MH(e) {
  return e && e.length ? IH(e, TH, PH) : void 0;
}
var jH = MH;
const ln = /* @__PURE__ */ Fe(jH);
function RH(e, t) {
  return e < t;
}
var NH = RH, $H = u5, FH = NH, DH = ui;
function kH(e) {
  return e && e.length ? $H(e, DH, FH) : void 0;
}
var LH = kH;
const Ec = /* @__PURE__ */ Fe(LH);
var BH = B1, VH = On, WH = v4, GH = Wt;
function HH(e, t) {
  var r = GH(e) ? BH : WH;
  return r(e, VH(t));
}
var UH = HH, zH = p4, YH = UH;
function XH(e, t) {
  return zH(YH(e, t), 1);
}
var ZH = XH;
const KH = /* @__PURE__ */ Fe(ZH);
var qH = fp;
function JH(e, t) {
  return qH(e, t);
}
var QH = JH;
const wo = /* @__PURE__ */ Fe(QH);
var ci = 1e9, eU = {
  // These values must be integers within the stated ranges (inclusive).
  // Most of these values can be changed during run-time using `Decimal.config`.
  // The maximum number of significant digits of the result of a calculation or base conversion.
  // E.g. `Decimal.config({ precision: 20 });`
  precision: 20,
  // 1 to MAX_DIGITS
  // The rounding mode used by default by `toInteger`, `toDecimalPlaces`, `toExponential`,
  // `toFixed`, `toPrecision` and `toSignificantDigits`.
  //
  // ROUND_UP         0 Away from zero.
  // ROUND_DOWN       1 Towards zero.
  // ROUND_CEIL       2 Towards +Infinity.
  // ROUND_FLOOR      3 Towards -Infinity.
  // ROUND_HALF_UP    4 Towards nearest neighbour. If equidistant, up.
  // ROUND_HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
  // ROUND_HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
  // ROUND_HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
  // ROUND_HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
  //
  // E.g.
  // `Decimal.rounding = 4;`
  // `Decimal.rounding = Decimal.ROUND_HALF_UP;`
  rounding: 4,
  // 0 to 8
  // The exponent value at and beneath which `toString` returns exponential notation.
  // JavaScript numbers: -7
  toExpNeg: -7,
  // 0 to -MAX_E
  // The exponent value at and above which `toString` returns exponential notation.
  // JavaScript numbers: 21
  toExpPos: 21,
  // 0 to MAX_E
  // The natural logarithm of 10.
  // 115 digits
  LN10: "2.302585092994045684017991454684364207601101488628772976033327900967572609677352480235997205089598298341967784042286"
}, kp, at = !0, sr = "[DecimalError] ", Yn = sr + "Invalid argument: ", Dp = sr + "Exponent out of range: ", li = Math.floor, $n = Math.pow, tU = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i, Yt, Ct = 1e7, tt = 7, s5 = 9007199254740991, Es = li(s5 / tt), fe = {};
fe.absoluteValue = fe.abs = function() {
  var e = new this.constructor(this);
  return e.s && (e.s = 1), e;
};
fe.comparedTo = fe.cmp = function(e) {
  var t, r, n, a, i = this;
  if (e = new i.constructor(e), i.s !== e.s) return i.s || -e.s;
  if (i.e !== e.e) return i.e > e.e ^ i.s < 0 ? 1 : -1;
  for (n = i.d.length, a = e.d.length, t = 0, r = n < a ? n : a; t < r; ++t)
    if (i.d[t] !== e.d[t]) return i.d[t] > e.d[t] ^ i.s < 0 ? 1 : -1;
  return n === a ? 0 : n > a ^ i.s < 0 ? 1 : -1;
};
fe.decimalPlaces = fe.dp = function() {
  var e = this, t = e.d.length - 1, r = (t - e.e) * tt;
  if (t = e.d[t], t) for (; t % 10 == 0; t /= 10) r--;
  return r < 0 ? 0 : r;
};
fe.dividedBy = fe.div = function(e) {
  return Yr(this, new this.constructor(e));
};
fe.dividedToIntegerBy = fe.idiv = function(e) {
  var t = this, r = t.constructor;
  return qe(Yr(t, new r(e), 0, 1), r.precision);
};
fe.equals = fe.eq = function(e) {
  return !this.cmp(e);
};
fe.exponent = function() {
  return dt(this);
};
fe.greaterThan = fe.gt = function(e) {
  return this.cmp(e) > 0;
};
fe.greaterThanOrEqualTo = fe.gte = function(e) {
  return this.cmp(e) >= 0;
};
fe.isInteger = fe.isint = function() {
  return this.e > this.d.length - 2;
};
fe.isNegative = fe.isneg = function() {
  return this.s < 0;
};
fe.isPositive = fe.ispos = function() {
  return this.s > 0;
};
fe.isZero = function() {
  return this.s === 0;
};
fe.lessThan = fe.lt = function(e) {
  return this.cmp(e) < 0;
};
fe.lessThanOrEqualTo = fe.lte = function(e) {
  return this.cmp(e) < 1;
};
fe.logarithm = fe.log = function(e) {
  var t, r = this, n = r.constructor, a = n.precision, i = a + 5;
  if (e === void 0)
    e = new n(10);
  else if (e = new n(e), e.s < 1 || e.eq(Yt)) throw Error(sr + "NaN");
  if (r.s < 1) throw Error(sr + (r.s ? "NaN" : "-Infinity"));
  return r.eq(Yt) ? new n(0) : (at = !1, t = Yr(Oo(r, i), Oo(e, i), i), at = !0, qe(t, a));
};
fe.minus = fe.sub = function(e) {
  var t = this;
  return e = new t.constructor(e), t.s == e.s ? f5(t, e) : c5(t, (e.s = -e.s, e));
};
fe.modulo = fe.mod = function(e) {
  var t, r = this, n = r.constructor, a = n.precision;
  if (e = new n(e), !e.s) throw Error(sr + "NaN");
  return r.s ? (at = !1, t = Yr(r, e, 0, 1).times(e), at = !0, r.minus(t)) : qe(new n(r), a);
};
fe.naturalExponential = fe.exp = function() {
  return l5(this);
};
fe.naturalLogarithm = fe.ln = function() {
  return Oo(this);
};
fe.negated = fe.neg = function() {
  var e = new this.constructor(this);
  return e.s = -e.s || 0, e;
};
fe.plus = fe.add = function(e) {
  var t = this;
  return e = new t.constructor(e), t.s == e.s ? c5(t, e) : f5(t, (e.s = -e.s, e));
};
fe.precision = fe.sd = function(e) {
  var t, r, n, a = this;
  if (e !== void 0 && e !== !!e && e !== 1 && e !== 0) throw Error(Yn + e);
  if (t = dt(a) + 1, n = a.d.length - 1, r = n * tt + 1, n = a.d[n], n) {
    for (; n % 10 == 0; n /= 10) r--;
    for (n = a.d[0]; n >= 10; n /= 10) r++;
  }
  return e && t > r ? t : r;
};
fe.squareRoot = fe.sqrt = function() {
  var e, t, r, n, a, i, o, u = this, s = u.constructor;
  if (u.s < 1) {
    if (!u.s) return new s(0);
    throw Error(sr + "NaN");
  }
  for (e = dt(u), at = !1, a = Math.sqrt(+u), a == 0 || a == 1 / 0 ? (t = Ar(u.d), (t.length + e) % 2 == 0 && (t += "0"), a = Math.sqrt(t), e = li((e + 1) / 2) - (e < 0 || e % 2), a == 1 / 0 ? t = "5e" + e : (t = a.toExponential(), t = t.slice(0, t.indexOf("e") + 1) + e), n = new s(t)) : n = new s(a.toString()), r = s.precision, a = o = r + 3; ; )
    if (i = n, n = i.plus(Yr(u, i, o + 2)).times(0.5), Ar(i.d).slice(0, o) === (t = Ar(n.d)).slice(0, o)) {
      if (t = t.slice(o - 3, o + 1), a == o && t == "4999") {
        if (qe(i, r + 1, 0), i.times(i).eq(u)) {
          n = i;
          break;
        }
      } else if (t != "9999")
        break;
      o += 4;
    }
  return at = !0, qe(n, r);
};
fe.times = fe.mul = function(e) {
  var t, r, n, a, i, o, u, s, c, l = this, f = l.constructor, d = l.d, p = (e = new f(e)).d;
  if (!l.s || !e.s) return new f(0);
  for (e.s *= l.s, r = l.e + e.e, s = d.length, c = p.length, s < c && (i = d, d = p, p = i, o = s, s = c, c = o), i = [], o = s + c, n = o; n--; ) i.push(0);
  for (n = c; --n >= 0; ) {
    for (t = 0, a = s + n; a > n; )
      u = i[a] + p[n] * d[a - n - 1] + t, i[a--] = u % Ct | 0, t = u / Ct | 0;
    i[a] = (i[a] + t) % Ct | 0;
  }
  for (; !i[--o]; ) i.pop();
  return t ? ++r : i.shift(), e.d = i, e.e = r, at ? qe(e, f.precision) : e;
};
fe.toDecimalPlaces = fe.todp = function(e, t) {
  var r = this, n = r.constructor;
  return r = new n(r), e === void 0 ? r : (Nr(e, 0, ci), t === void 0 ? t = n.rounding : Nr(t, 0, 8), qe(r, e + dt(r) + 1, t));
};
fe.toExponential = function(e, t) {
  var r, n = this, a = n.constructor;
  return e === void 0 ? r = Kn(n, !0) : (Nr(e, 0, ci), t === void 0 ? t = a.rounding : Nr(t, 0, 8), n = qe(new a(n), e + 1, t), r = Kn(n, !0, e + 1)), r;
};
fe.toFixed = function(e, t) {
  var r, n, a = this, i = a.constructor;
  return e === void 0 ? Kn(a) : (Nr(e, 0, ci), t === void 0 ? t = i.rounding : Nr(t, 0, 8), n = qe(new i(a), e + dt(a) + 1, t), r = Kn(n.abs(), !1, e + dt(n) + 1), a.isneg() && !a.isZero() ? "-" + r : r);
};
fe.toInteger = fe.toint = function() {
  var e = this, t = e.constructor;
  return qe(new t(e), dt(e) + 1, t.rounding);
};
fe.toNumber = function() {
  return +this;
};
fe.toPower = fe.pow = function(e) {
  var t, r, n, a, i, o, u = this, s = u.constructor, c = 12, l = +(e = new s(e));
  if (!e.s) return new s(Yt);
  if (u = new s(u), !u.s) {
    if (e.s < 1) throw Error(sr + "Infinity");
    return u;
  }
  if (u.eq(Yt)) return u;
  if (n = s.precision, e.eq(Yt)) return qe(u, n);
  if (t = e.e, r = e.d.length - 1, o = t >= r, i = u.s, o) {
    if ((r = l < 0 ? -l : l) <= s5) {
      for (a = new s(Yt), t = Math.ceil(n / tt + 4), at = !1; r % 2 && (a = a.times(u), eg(a.d, t)), r = li(r / 2), r !== 0; )
        u = u.times(u), eg(u.d, t);
      return at = !0, e.s < 0 ? new s(Yt).div(a) : qe(a, n);
    }
  } else if (i < 0) throw Error(sr + "NaN");
  return i = i < 0 && e.d[Math.max(t, r)] & 1 ? -1 : 1, u.s = 1, at = !1, a = e.times(Oo(u, n + c)), at = !0, a = l5(a), a.s = i, a;
};
fe.toPrecision = function(e, t) {
  var r, n, a = this, i = a.constructor;
  return e === void 0 ? (r = dt(a), n = Kn(a, r <= i.toExpNeg || r >= i.toExpPos)) : (Nr(e, 1, ci), t === void 0 ? t = i.rounding : Nr(t, 0, 8), a = qe(new i(a), e, t), r = dt(a), n = Kn(a, e <= r || r <= i.toExpNeg, e)), n;
};
fe.toSignificantDigits = fe.tosd = function(e, t) {
  var r = this, n = r.constructor;
  return e === void 0 ? (e = n.precision, t = n.rounding) : (Nr(e, 1, ci), t === void 0 ? t = n.rounding : Nr(t, 0, 8)), qe(new n(r), e, t);
};
fe.toString = fe.valueOf = fe.val = fe.toJSON = fe[Symbol.for("nodejs.util.inspect.custom")] = function() {
  var e = this, t = dt(e), r = e.constructor;
  return Kn(e, t <= r.toExpNeg || t >= r.toExpPos);
};
function c5(e, t) {
  var r, n, a, i, o, u, s, c, l = e.constructor, f = l.precision;
  if (!e.s || !t.s)
    return t.s || (t = new l(e)), at ? qe(t, f) : t;
  if (s = e.d, c = t.d, o = e.e, a = t.e, s = s.slice(), i = o - a, i) {
    for (i < 0 ? (n = s, i = -i, u = c.length) : (n = c, a = o, u = s.length), o = Math.ceil(f / tt), u = o > u ? o + 1 : u + 1, i > u && (i = u, n.length = 1), n.reverse(); i--; ) n.push(0);
    n.reverse();
  }
  for (u = s.length, i = c.length, u - i < 0 && (i = u, n = c, c = s, s = n), r = 0; i; )
    r = (s[--i] = s[i] + c[i] + r) / Ct | 0, s[i] %= Ct;
  for (r && (s.unshift(r), ++a), u = s.length; s[--u] == 0; ) s.pop();
  return t.d = s, t.e = a, at ? qe(t, f) : t;
}
function Nr(e, t, r) {
  if (e !== ~~e || e < t || e > r)
    throw Error(Yn + e);
}
function Ar(e) {
  var t, r, n, a = e.length - 1, i = "", o = e[0];
  if (a > 0) {
    for (i += o, t = 1; t < a; t++)
      n = e[t] + "", r = tt - n.length, r && (i += sn(r)), i += n;
    o = e[t], n = o + "", r = tt - n.length, r && (i += sn(r));
  } else if (o === 0)
    return "0";
  for (; o % 10 === 0; ) o /= 10;
  return i + o;
}
var Yr = /* @__PURE__ */ function() {
  function e(n, a) {
    var i, o = 0, u = n.length;
    for (n = n.slice(); u--; )
      i = n[u] * a + o, n[u] = i % Ct | 0, o = i / Ct | 0;
    return o && n.unshift(o), n;
  }
  function t(n, a, i, o) {
    var u, s;
    if (i != o)
      s = i > o ? 1 : -1;
    else
      for (u = s = 0; u < i; u++)
        if (n[u] != a[u]) {
          s = n[u] > a[u] ? 1 : -1;
          break;
        }
    return s;
  }
  function r(n, a, i) {
    for (var o = 0; i--; )
      n[i] -= o, o = n[i] < a[i] ? 1 : 0, n[i] = o * Ct + n[i] - a[i];
    for (; !n[0] && n.length > 1; ) n.shift();
  }
  return function(n, a, i, o) {
    var u, s, c, l, f, d, p, h, v, g, b, x, w, y, m, C, O, S, A = n.constructor, P = n.s == a.s ? 1 : -1, T = n.d, M = a.d;
    if (!n.s) return new A(n);
    if (!a.s) throw Error(sr + "Division by zero");
    for (s = n.e - a.e, O = M.length, m = T.length, p = new A(P), h = p.d = [], c = 0; M[c] == (T[c] || 0); ) ++c;
    if (M[c] > (T[c] || 0) && --s, i == null ? x = i = A.precision : o ? x = i + (dt(n) - dt(a)) + 1 : x = i, x < 0) return new A(0);
    if (x = x / tt + 2 | 0, c = 0, O == 1)
      for (l = 0, M = M[0], x++; (c < m || l) && x--; c++)
        w = l * Ct + (T[c] || 0), h[c] = w / M | 0, l = w % M | 0;
    else {
      for (l = Ct / (M[0] + 1) | 0, l > 1 && (M = e(M, l), T = e(T, l), O = M.length, m = T.length), y = O, v = T.slice(0, O), g = v.length; g < O; ) v[g++] = 0;
      S = M.slice(), S.unshift(0), C = M[0], M[1] >= Ct / 2 && ++C;
      do
        l = 0, u = t(M, v, O, g), u < 0 ? (b = v[0], O != g && (b = b * Ct + (v[1] || 0)), l = b / C | 0, l > 1 ? (l >= Ct && (l = Ct - 1), f = e(M, l), d = f.length, g = v.length, u = t(f, v, d, g), u == 1 && (l--, r(f, O < d ? S : M, d))) : (l == 0 && (u = l = 1), f = M.slice()), d = f.length, d < g && f.unshift(0), r(v, f, g), u == -1 && (g = v.length, u = t(M, v, O, g), u < 1 && (l++, r(v, O < g ? S : M, g))), g = v.length) : u === 0 && (l++, v = [0]), h[c++] = l, u && v[0] ? v[g++] = T[y] || 0 : (v = [T[y]], g = 1);
      while ((y++ < m || v[0] !== void 0) && x--);
    }
    return h[0] || h.shift(), p.e = s, qe(p, o ? i + dt(p) + 1 : i);
  };
}();
function l5(e, t) {
  var r, n, a, i, o, u, s = 0, c = 0, l = e.constructor, f = l.precision;
  if (dt(e) > 16) throw Error(Dp + dt(e));
  if (!e.s) return new l(Yt);
  for (t == null ? (at = !1, u = f) : u = t, o = new l(0.03125); e.abs().gte(0.1); )
    e = e.times(o), c += 5;
  for (n = Math.log($n(2, c)) / Math.LN10 * 2 + 5 | 0, u += n, r = a = i = new l(Yt), l.precision = u; ; ) {
    if (a = qe(a.times(e), u), r = r.times(++s), o = i.plus(Yr(a, r, u)), Ar(o.d).slice(0, u) === Ar(i.d).slice(0, u)) {
      for (; c--; ) i = qe(i.times(i), u);
      return l.precision = f, t == null ? (at = !0, qe(i, f)) : i;
    }
    i = o;
  }
}
function dt(e) {
  for (var t = e.e * tt, r = e.d[0]; r >= 10; r /= 10) t++;
  return t;
}
function Ql(e, t, r) {
  if (t > e.LN10.sd())
    throw at = !0, r && (e.precision = r), Error(sr + "LN10 precision limit exceeded");
  return qe(new e(e.LN10), t);
}
function sn(e) {
  for (var t = ""; e--; ) t += "0";
  return t;
}
function Oo(e, t) {
  var r, n, a, i, o, u, s, c, l, f = 1, d = 10, p = e, h = p.d, v = p.constructor, g = v.precision;
  if (p.s < 1) throw Error(sr + (p.s ? "NaN" : "-Infinity"));
  if (p.eq(Yt)) return new v(0);
  if (t == null ? (at = !1, c = g) : c = t, p.eq(10))
    return t == null && (at = !0), Ql(v, c);
  if (c += d, v.precision = c, r = Ar(h), n = r.charAt(0), i = dt(p), Math.abs(i) < 15e14) {
    for (; n < 7 && n != 1 || n == 1 && r.charAt(1) > 3; )
      p = p.times(e), r = Ar(p.d), n = r.charAt(0), f++;
    i = dt(p), n > 1 ? (p = new v("0." + r), i++) : p = new v(n + "." + r.slice(1));
  } else
    return s = Ql(v, c + 2, g).times(i + ""), p = Oo(new v(n + "." + r.slice(1)), c - d).plus(s), v.precision = g, t == null ? (at = !0, qe(p, g)) : p;
  for (u = o = p = Yr(p.minus(Yt), p.plus(Yt), c), l = qe(p.times(p), c), a = 3; ; ) {
    if (o = qe(o.times(l), c), s = u.plus(Yr(o, new v(a), c)), Ar(s.d).slice(0, c) === Ar(u.d).slice(0, c))
      return u = u.times(2), i !== 0 && (u = u.plus(Ql(v, c + 2, g).times(i + ""))), u = Yr(u, new v(f), c), v.precision = g, t == null ? (at = !0, qe(u, g)) : u;
    u = s, a += 2;
  }
}
function Q2(e, t) {
  var r, n, a;
  for ((r = t.indexOf(".")) > -1 && (t = t.replace(".", "")), (n = t.search(/e/i)) > 0 ? (r < 0 && (r = n), r += +t.slice(n + 1), t = t.substring(0, n)) : r < 0 && (r = t.length), n = 0; t.charCodeAt(n) === 48; ) ++n;
  for (a = t.length; t.charCodeAt(a - 1) === 48; ) --a;
  if (t = t.slice(n, a), t) {
    if (a -= n, r = r - n - 1, e.e = li(r / tt), e.d = [], n = (r + 1) % tt, r < 0 && (n += tt), n < a) {
      for (n && e.d.push(+t.slice(0, n)), a -= tt; n < a; ) e.d.push(+t.slice(n, n += tt));
      t = t.slice(n), n = tt - t.length;
    } else
      n -= a;
    for (; n--; ) t += "0";
    if (e.d.push(+t), at && (e.e > Es || e.e < -Es)) throw Error(Dp + r);
  } else
    e.s = 0, e.e = 0, e.d = [0];
  return e;
}
function qe(e, t, r) {
  var n, a, i, o, u, s, c, l, f = e.d;
  for (o = 1, i = f[0]; i >= 10; i /= 10) o++;
  if (n = t - o, n < 0)
    n += tt, a = t, c = f[l = 0];
  else {
    if (l = Math.ceil((n + 1) / tt), i = f.length, l >= i) return e;
    for (c = i = f[l], o = 1; i >= 10; i /= 10) o++;
    n %= tt, a = n - tt + o;
  }
  if (r !== void 0 && (i = $n(10, o - a - 1), u = c / i % 10 | 0, s = t < 0 || f[l + 1] !== void 0 || c % i, s = r < 4 ? (u || s) && (r == 0 || r == (e.s < 0 ? 3 : 2)) : u > 5 || u == 5 && (r == 4 || s || r == 6 && // Check whether the digit to the left of the rounding digit is odd.
  (n > 0 ? a > 0 ? c / $n(10, o - a) : 0 : f[l - 1]) % 10 & 1 || r == (e.s < 0 ? 8 : 7))), t < 1 || !f[0])
    return s ? (i = dt(e), f.length = 1, t = t - i - 1, f[0] = $n(10, (tt - t % tt) % tt), e.e = li(-t / tt) || 0) : (f.length = 1, f[0] = e.e = e.s = 0), e;
  if (n == 0 ? (f.length = l, i = 1, l--) : (f.length = l + 1, i = $n(10, tt - n), f[l] = a > 0 ? (c / $n(10, o - a) % $n(10, a) | 0) * i : 0), s)
    for (; ; )
      if (l == 0) {
        (f[0] += i) == Ct && (f[0] = 1, ++e.e);
        break;
      } else {
        if (f[l] += i, f[l] != Ct) break;
        f[l--] = 0, i = 1;
      }
  for (n = f.length; f[--n] === 0; ) f.pop();
  if (at && (e.e > Es || e.e < -Es))
    throw Error(Dp + dt(e));
  return e;
}
function f5(e, t) {
  var r, n, a, i, o, u, s, c, l, f, d = e.constructor, p = d.precision;
  if (!e.s || !t.s)
    return t.s ? t.s = -t.s : t = new d(e), at ? qe(t, p) : t;
  if (s = e.d, f = t.d, n = t.e, c = e.e, s = s.slice(), o = c - n, o) {
    for (l = o < 0, l ? (r = s, o = -o, u = f.length) : (r = f, n = c, u = s.length), a = Math.max(Math.ceil(p / tt), u) + 2, o > a && (o = a, r.length = 1), r.reverse(), a = o; a--; ) r.push(0);
    r.reverse();
  } else {
    for (a = s.length, u = f.length, l = a < u, l && (u = a), a = 0; a < u; a++)
      if (s[a] != f[a]) {
        l = s[a] < f[a];
        break;
      }
    o = 0;
  }
  for (l && (r = s, s = f, f = r, t.s = -t.s), u = s.length, a = f.length - u; a > 0; --a) s[u++] = 0;
  for (a = f.length; a > o; ) {
    if (s[--a] < f[a]) {
      for (i = a; i && s[--i] === 0; ) s[i] = Ct - 1;
      --s[i], s[a] += Ct;
    }
    s[a] -= f[a];
  }
  for (; s[--u] === 0; ) s.pop();
  for (; s[0] === 0; s.shift()) --n;
  return s[0] ? (t.d = s, t.e = n, at ? qe(t, p) : t) : new d(0);
}
function Kn(e, t, r) {
  var n, a = dt(e), i = Ar(e.d), o = i.length;
  return t ? (r && (n = r - o) > 0 ? i = i.charAt(0) + "." + i.slice(1) + sn(n) : o > 1 && (i = i.charAt(0) + "." + i.slice(1)), i = i + (a < 0 ? "e" : "e+") + a) : a < 0 ? (i = "0." + sn(-a - 1) + i, r && (n = r - o) > 0 && (i += sn(n))) : a >= o ? (i += sn(a + 1 - o), r && (n = r - a - 1) > 0 && (i = i + "." + sn(n))) : ((n = a + 1) < o && (i = i.slice(0, n) + "." + i.slice(n)), r && (n = r - o) > 0 && (a + 1 === o && (i += "."), i += sn(n))), e.s < 0 ? "-" + i : i;
}
function eg(e, t) {
  if (e.length > t)
    return e.length = t, !0;
}
function d5(e) {
  var t, r, n;
  function a(i) {
    var o = this;
    if (!(o instanceof a)) return new a(i);
    if (o.constructor = a, i instanceof a) {
      o.s = i.s, o.e = i.e, o.d = (i = i.d) ? i.slice() : i;
      return;
    }
    if (typeof i == "number") {
      if (i * 0 !== 0)
        throw Error(Yn + i);
      if (i > 0)
        o.s = 1;
      else if (i < 0)
        i = -i, o.s = -1;
      else {
        o.s = 0, o.e = 0, o.d = [0];
        return;
      }
      if (i === ~~i && i < 1e7) {
        o.e = 0, o.d = [i];
        return;
      }
      return Q2(o, i.toString());
    } else if (typeof i != "string")
      throw Error(Yn + i);
    if (i.charCodeAt(0) === 45 ? (i = i.slice(1), o.s = -1) : o.s = 1, tU.test(i)) Q2(o, i);
    else throw Error(Yn + i);
  }
  if (a.prototype = fe, a.ROUND_UP = 0, a.ROUND_DOWN = 1, a.ROUND_CEIL = 2, a.ROUND_FLOOR = 3, a.ROUND_HALF_UP = 4, a.ROUND_HALF_DOWN = 5, a.ROUND_HALF_EVEN = 6, a.ROUND_HALF_CEIL = 7, a.ROUND_HALF_FLOOR = 8, a.clone = d5, a.config = a.set = rU, e === void 0 && (e = {}), e)
    for (n = ["precision", "rounding", "toExpNeg", "toExpPos", "LN10"], t = 0; t < n.length; ) e.hasOwnProperty(r = n[t++]) || (e[r] = this[r]);
  return a.config(e), a;
}
function rU(e) {
  if (!e || typeof e != "object")
    throw Error(sr + "Object expected");
  var t, r, n, a = [
    "precision",
    1,
    ci,
    "rounding",
    0,
    8,
    "toExpNeg",
    -1 / 0,
    0,
    "toExpPos",
    0,
    1 / 0
  ];
  for (t = 0; t < a.length; t += 3)
    if ((n = e[r = a[t]]) !== void 0)
      if (li(n) === n && n >= a[t + 1] && n <= a[t + 2]) this[r] = n;
      else throw Error(Yn + r + ": " + n);
  if ((n = e[r = "LN10"]) !== void 0)
    if (n == Math.LN10) this[r] = new this(n);
    else throw Error(Yn + r + ": " + n);
  return this;
}
var kp = d5(eU);
Yt = new kp(1);
const Xe = kp;
function nU(e) {
  return uU(e) || oU(e) || iU(e) || aU();
}
function aU() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function iU(e, t) {
  if (e) {
    if (typeof e == "string") return Pd(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Pd(e, t);
  }
}
function oU(e) {
  if (typeof Symbol < "u" && Symbol.iterator in Object(e)) return Array.from(e);
}
function uU(e) {
  if (Array.isArray(e)) return Pd(e);
}
function Pd(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
var sU = function(t) {
  return t;
}, p5 = {
  "@@functional/placeholder": !0
}, h5 = function(t) {
  return t === p5;
}, tg = function(t) {
  return function r() {
    return arguments.length === 0 || arguments.length === 1 && h5(arguments.length <= 0 ? void 0 : arguments[0]) ? r : t.apply(void 0, arguments);
  };
}, cU = function e(t, r) {
  return t === 1 ? r : tg(function() {
    for (var n = arguments.length, a = new Array(n), i = 0; i < n; i++)
      a[i] = arguments[i];
    var o = a.filter(function(u) {
      return u !== p5;
    }).length;
    return o >= t ? r.apply(void 0, a) : e(t - o, tg(function() {
      for (var u = arguments.length, s = new Array(u), c = 0; c < u; c++)
        s[c] = arguments[c];
      var l = a.map(function(f) {
        return h5(f) ? s.shift() : f;
      });
      return r.apply(void 0, nU(l).concat(s));
    }));
  });
}, _c = function(t) {
  return cU(t.length, t);
}, Td = function(t, r) {
  for (var n = [], a = t; a < r; ++a)
    n[a - t] = a;
  return n;
}, lU = _c(function(e, t) {
  return Array.isArray(t) ? t.map(e) : Object.keys(t).map(function(r) {
    return t[r];
  }).map(e);
}), fU = function() {
  for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++)
    r[n] = arguments[n];
  if (!r.length)
    return sU;
  var a = r.reverse(), i = a[0], o = a.slice(1);
  return function() {
    return o.reduce(function(u, s) {
      return s(u);
    }, i.apply(void 0, arguments));
  };
}, Md = function(t) {
  return Array.isArray(t) ? t.reverse() : t.split("").reverse.join("");
}, v5 = function(t) {
  var r = null, n = null;
  return function() {
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return r && i.every(function(u, s) {
      return u === r[s];
    }) || (r = i, n = t.apply(void 0, i)), n;
  };
};
function dU(e) {
  var t;
  return e === 0 ? t = 1 : t = Math.floor(new Xe(e).abs().log(10).toNumber()) + 1, t;
}
function pU(e, t, r) {
  for (var n = new Xe(e), a = 0, i = []; n.lt(t) && a < 1e5; )
    i.push(n.toNumber()), n = n.add(r), a++;
  return i;
}
var hU = _c(function(e, t, r) {
  var n = +e, a = +t;
  return n + r * (a - n);
}), vU = _c(function(e, t, r) {
  var n = t - +e;
  return n = n || 1 / 0, (r - e) / n;
}), gU = _c(function(e, t, r) {
  var n = t - +e;
  return n = n || 1 / 0, Math.max(0, Math.min(1, (r - e) / n));
});
const Ic = {
  rangeStep: pU,
  getDigitCount: dU,
  interpolateNumber: hU,
  uninterpolateNumber: vU,
  uninterpolateTruncation: gU
};
function jd(e) {
  return bU(e) || yU(e) || g5(e) || mU();
}
function mU() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function yU(e) {
  if (typeof Symbol < "u" && Symbol.iterator in Object(e)) return Array.from(e);
}
function bU(e) {
  if (Array.isArray(e)) return Rd(e);
}
function So(e, t) {
  return wU(e) || CU(e, t) || g5(e, t) || xU();
}
function xU() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function g5(e, t) {
  if (e) {
    if (typeof e == "string") return Rd(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Rd(e, t);
  }
}
function Rd(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function CU(e, t) {
  if (!(typeof Symbol > "u" || !(Symbol.iterator in Object(e)))) {
    var r = [], n = !0, a = !1, i = void 0;
    try {
      for (var o = e[Symbol.iterator](), u; !(n = (u = o.next()).done) && (r.push(u.value), !(t && r.length === t)); n = !0)
        ;
    } catch (s) {
      a = !0, i = s;
    } finally {
      try {
        !n && o.return != null && o.return();
      } finally {
        if (a) throw i;
      }
    }
    return r;
  }
}
function wU(e) {
  if (Array.isArray(e)) return e;
}
function m5(e) {
  var t = So(e, 2), r = t[0], n = t[1], a = r, i = n;
  return r > n && (a = n, i = r), [a, i];
}
function y5(e, t, r) {
  if (e.lte(0))
    return new Xe(0);
  var n = Ic.getDigitCount(e.toNumber()), a = new Xe(10).pow(n), i = e.div(a), o = n !== 1 ? 0.05 : 0.1, u = new Xe(Math.ceil(i.div(o).toNumber())).add(r).mul(o), s = u.mul(a);
  return t ? s : new Xe(Math.ceil(s));
}
function OU(e, t, r) {
  var n = 1, a = new Xe(e);
  if (!a.isint() && r) {
    var i = Math.abs(e);
    i < 1 ? (n = new Xe(10).pow(Ic.getDigitCount(e) - 1), a = new Xe(Math.floor(a.div(n).toNumber())).mul(n)) : i > 1 && (a = new Xe(Math.floor(e)));
  } else e === 0 ? a = new Xe(Math.floor((t - 1) / 2)) : r || (a = new Xe(Math.floor(e)));
  var o = Math.floor((t - 1) / 2), u = fU(lU(function(s) {
    return a.add(new Xe(s - o).mul(n)).toNumber();
  }), Td);
  return u(0, t);
}
function b5(e, t, r, n) {
  var a = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 0;
  if (!Number.isFinite((t - e) / (r - 1)))
    return {
      step: new Xe(0),
      tickMin: new Xe(0),
      tickMax: new Xe(0)
    };
  var i = y5(new Xe(t).sub(e).div(r - 1), n, a), o;
  e <= 0 && t >= 0 ? o = new Xe(0) : (o = new Xe(e).add(t).div(2), o = o.sub(new Xe(o).mod(i)));
  var u = Math.ceil(o.sub(e).div(i).toNumber()), s = Math.ceil(new Xe(t).sub(o).div(i).toNumber()), c = u + s + 1;
  return c > r ? b5(e, t, r, n, a + 1) : (c < r && (s = t > 0 ? s + (r - c) : s, u = t > 0 ? u : u + (r - c)), {
    step: i,
    tickMin: o.sub(new Xe(u).mul(i)),
    tickMax: o.add(new Xe(s).mul(i))
  });
}
function SU(e) {
  var t = So(e, 2), r = t[0], n = t[1], a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 6, i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0, o = Math.max(a, 2), u = m5([r, n]), s = So(u, 2), c = s[0], l = s[1];
  if (c === -1 / 0 || l === 1 / 0) {
    var f = l === 1 / 0 ? [c].concat(jd(Td(0, a - 1).map(function() {
      return 1 / 0;
    }))) : [].concat(jd(Td(0, a - 1).map(function() {
      return -1 / 0;
    })), [l]);
    return r > n ? Md(f) : f;
  }
  if (c === l)
    return OU(c, a, i);
  var d = b5(c, l, o, i), p = d.step, h = d.tickMin, v = d.tickMax, g = Ic.rangeStep(h, v.add(new Xe(0.1).mul(p)), p);
  return r > n ? Md(g) : g;
}
function AU(e, t) {
  var r = So(e, 2), n = r[0], a = r[1], i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0, o = m5([n, a]), u = So(o, 2), s = u[0], c = u[1];
  if (s === -1 / 0 || c === 1 / 0)
    return [n, a];
  if (s === c)
    return [s];
  var l = Math.max(t, 2), f = y5(new Xe(c).sub(s).div(l - 1), i, 0), d = [].concat(jd(Ic.rangeStep(new Xe(s), new Xe(c).sub(new Xe(0.99).mul(f)), f)), [c]);
  return n > a ? Md(d) : d;
}
var EU = v5(SU), _U = v5(AU), IU = process.env.NODE_ENV === "production", ef = "Invariant failed";
function kt(e, t) {
  if (IU)
    throw new Error(ef);
  var r = typeof t == "function" ? t() : t, n = r ? "".concat(ef, ": ").concat(r) : ef;
  throw new Error(n);
}
var PU = ["offset", "layout", "width", "dataKey", "data", "dataPointFormatter", "xAxis", "yAxis"];
function _s() {
  return _s = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, _s.apply(this, arguments);
}
function TU(e, t) {
  return NU(e) || RU(e, t) || jU(e, t) || MU();
}
function MU() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function jU(e, t) {
  if (e) {
    if (typeof e == "string") return rg(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return rg(e, t);
  }
}
function rg(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function RU(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, a, i, o, u = [], s = !0, c = !1;
    try {
      if (i = (r = r.call(e)).next, t !== 0) for (; !(s = (n = i.call(r)).done) && (u.push(n.value), u.length !== t); s = !0) ;
    } catch (l) {
      c = !0, a = l;
    } finally {
      try {
        if (!s && r.return != null && (o = r.return(), Object(o) !== o)) return;
      } finally {
        if (c) throw a;
      }
    }
    return u;
  }
}
function NU(e) {
  if (Array.isArray(e)) return e;
}
function $U(e, t) {
  if (e == null) return {};
  var r = FU(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function FU(e, t) {
  if (e == null) return {};
  var r = {}, n = Object.keys(e), a, i;
  for (i = 0; i < n.length; i++)
    a = n[i], !(t.indexOf(a) >= 0) && (r[a] = e[a]);
  return r;
}
function Pc(e) {
  var t = e.offset, r = e.layout, n = e.width, a = e.dataKey, i = e.data, o = e.dataPointFormatter, u = e.xAxis, s = e.yAxis, c = $U(e, PU), l = Ie(c, !1);
  e.direction === "x" && u.type !== "number" && (process.env.NODE_ENV !== "production" ? kt(!1, 'ErrorBar requires Axis type property to be "number".') : kt());
  var f = i.map(function(d) {
    var p = o(d, a), h = p.x, v = p.y, g = p.value, b = p.errorVal;
    if (!b)
      return null;
    var x = [], w, y;
    if (Array.isArray(b)) {
      var m = TU(b, 2);
      w = m[0], y = m[1];
    } else
      w = y = b;
    if (r === "vertical") {
      var C = u.scale, O = v + t, S = O + n, A = O - n, P = C(g - w), T = C(g + y);
      x.push({
        x1: T,
        y1: S,
        x2: T,
        y2: A
      }), x.push({
        x1: P,
        y1: O,
        x2: T,
        y2: O
      }), x.push({
        x1: P,
        y1: S,
        x2: P,
        y2: A
      });
    } else if (r === "horizontal") {
      var M = s.scale, I = h + t, G = I - n, Y = I + n, L = M(g - w), X = M(g + y);
      x.push({
        x1: G,
        y1: X,
        x2: Y,
        y2: X
      }), x.push({
        x1: I,
        y1: L,
        x2: I,
        y2: X
      }), x.push({
        x1: G,
        y1: L,
        x2: Y,
        y2: L
      });
    }
    return /* @__PURE__ */ N.createElement(ut, _s({
      className: "recharts-errorBar",
      key: "bar-".concat(x.map(function(q) {
        return "".concat(q.x1, "-").concat(q.x2, "-").concat(q.y1, "-").concat(q.y2);
      }))
    }, l), x.map(function(q) {
      return /* @__PURE__ */ N.createElement("line", _s({}, q, {
        key: "line-".concat(q.x1, "-").concat(q.x2, "-").concat(q.y1, "-").concat(q.y2)
      }));
    }));
  });
  return /* @__PURE__ */ N.createElement(ut, {
    className: "recharts-errorBars"
  }, f);
}
Pc.defaultProps = {
  stroke: "black",
  strokeWidth: 1.5,
  width: 5,
  offset: 0,
  layout: "horizontal"
};
Pc.displayName = "ErrorBar";
function Ao(e) {
  "@babel/helpers - typeof";
  return Ao = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ao(e);
}
function ng(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function tf(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ng(Object(r), !0).forEach(function(n) {
      DU(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ng(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function DU(e, t, r) {
  return t = kU(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function kU(e) {
  var t = LU(e, "string");
  return Ao(t) == "symbol" ? t : String(t);
}
function LU(e, t) {
  if (Ao(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (Ao(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var x5 = function(t) {
  var r = t.children, n = t.formattedGraphicalItems, a = t.legendWidth, i = t.legendContent, o = Ut(r, Ra);
  if (!o)
    return null;
  var u;
  return o.props && o.props.payload ? u = o.props && o.props.payload : i === "children" ? u = (n || []).reduce(function(s, c) {
    var l = c.item, f = c.props, d = f.sectors || f.data || [];
    return s.concat(d.map(function(p) {
      return {
        type: o.props.iconType || l.props.legendType,
        value: p.name,
        color: p.fill,
        payload: p
      };
    }));
  }, []) : u = (n || []).map(function(s) {
    var c = s.item, l = c.props, f = l.dataKey, d = l.name, p = l.legendType, h = l.hide;
    return {
      inactive: h,
      dataKey: f,
      type: o.props.iconType || p || "square",
      color: Lp(c),
      value: d || f,
      // @ts-expect-error property strokeDasharray is required in Payload but optional in props
      payload: c.props
    };
  }), tf(tf(tf({}, o.props), Ra.getWithHeight(o, a)), {}, {
    payload: u,
    item: o
  });
};
function Eo(e) {
  "@babel/helpers - typeof";
  return Eo = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Eo(e);
}
function ag(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function nr(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ag(Object(r), !0).forEach(function(n) {
      xa(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ag(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function xa(e, t, r) {
  return t = BU(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function BU(e) {
  var t = VU(e, "string");
  return Eo(t) == "symbol" ? t : String(t);
}
function VU(e, t) {
  if (Eo(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (Eo(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function ig(e) {
  return UU(e) || HU(e) || GU(e) || WU();
}
function WU() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function GU(e, t) {
  if (e) {
    if (typeof e == "string") return Nd(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Nd(e, t);
  }
}
function HU(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function UU(e) {
  if (Array.isArray(e)) return Nd(e);
}
function Nd(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function Kt(e, t, r) {
  return Me(e) || Me(t) ? r : gt(t) ? ve(e, t, r) : _e(t) ? t(e) : r;
}
function qi(e, t, r, n) {
  var a = KH(e, function(u) {
    return Kt(u, t);
  });
  if (r === "number") {
    var i = a.filter(function(u) {
      return oe(u) || parseFloat(u);
    });
    return i.length ? [Ec(i), ln(i)] : [1 / 0, -1 / 0];
  }
  var o = n ? a.filter(function(u) {
    return !Me(u);
  }) : a;
  return o.map(function(u) {
    return gt(u) || u instanceof Date ? u : "";
  });
}
var zU = function(t) {
  var r, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], a = arguments.length > 2 ? arguments[2] : void 0, i = arguments.length > 3 ? arguments[3] : void 0, o = -1, u = (r = n == null ? void 0 : n.length) !== null && r !== void 0 ? r : 0;
  if (u <= 1)
    return 0;
  if (i && i.axisType === "angleAxis" && Math.abs(Math.abs(i.range[1] - i.range[0]) - 360) <= 1e-6)
    for (var s = i.range, c = 0; c < u; c++) {
      var l = c > 0 ? a[c - 1].coordinate : a[u - 1].coordinate, f = a[c].coordinate, d = c >= u - 1 ? a[0].coordinate : a[c + 1].coordinate, p = void 0;
      if (yr(f - l) !== yr(d - f)) {
        var h = [];
        if (yr(d - f) === yr(s[1] - s[0])) {
          p = d;
          var v = f + s[1] - s[0];
          h[0] = Math.min(v, (v + l) / 2), h[1] = Math.max(v, (v + l) / 2);
        } else {
          p = l;
          var g = d + s[1] - s[0];
          h[0] = Math.min(f, (g + f) / 2), h[1] = Math.max(f, (g + f) / 2);
        }
        var b = [Math.min(f, (p + f) / 2), Math.max(f, (p + f) / 2)];
        if (t > b[0] && t <= b[1] || t >= h[0] && t <= h[1]) {
          o = a[c].index;
          break;
        }
      } else {
        var x = Math.min(l, d), w = Math.max(l, d);
        if (t > (x + f) / 2 && t <= (w + f) / 2) {
          o = a[c].index;
          break;
        }
      }
    }
  else
    for (var y = 0; y < u; y++)
      if (y === 0 && t <= (n[y].coordinate + n[y + 1].coordinate) / 2 || y > 0 && y < u - 1 && t > (n[y].coordinate + n[y - 1].coordinate) / 2 && t <= (n[y].coordinate + n[y + 1].coordinate) / 2 || y === u - 1 && t > (n[y].coordinate + n[y - 1].coordinate) / 2) {
        o = n[y].index;
        break;
      }
  return o;
}, Lp = function(t) {
  var r = t, n = r.type.displayName, a = t.props, i = a.stroke, o = a.fill, u;
  switch (n) {
    case "Line":
      u = i;
      break;
    case "Area":
    case "Radar":
      u = i && i !== "none" ? i : o;
      break;
    default:
      u = o;
      break;
  }
  return u;
}, YU = function(t) {
  var r = t.barSize, n = t.totalSize, a = t.stackGroups, i = a === void 0 ? {} : a;
  if (!i)
    return {};
  for (var o = {}, u = Object.keys(i), s = 0, c = u.length; s < c; s++)
    for (var l = i[u[s]].stackGroups, f = Object.keys(l), d = 0, p = f.length; d < p; d++) {
      var h = l[f[d]], v = h.items, g = h.cateAxisId, b = v.filter(function(m) {
        return Hr(m.type).indexOf("Bar") >= 0;
      });
      if (b && b.length) {
        var x = b[0].props.barSize, w = b[0].props[g];
        o[w] || (o[w] = []);
        var y = Me(x) ? r : x;
        o[w].push({
          item: b[0],
          stackList: b.slice(1),
          barSize: Me(y) ? void 0 : Zn(y, n, 0)
        });
      }
    }
  return o;
}, XU = function(t) {
  var r = t.barGap, n = t.barCategoryGap, a = t.bandSize, i = t.sizeList, o = i === void 0 ? [] : i, u = t.maxBarSize, s = o.length;
  if (s < 1) return null;
  var c = Zn(r, a, 0, !0), l, f = [];
  if (o[0].barSize === +o[0].barSize) {
    var d = !1, p = a / s, h = o.reduce(function(y, m) {
      return y + m.barSize || 0;
    }, 0);
    h += (s - 1) * c, h >= a && (h -= (s - 1) * c, c = 0), h >= a && p > 0 && (d = !0, p *= 0.9, h = s * p);
    var v = (a - h) / 2 >> 0, g = {
      offset: v - c,
      size: 0
    };
    l = o.reduce(function(y, m) {
      var C = {
        item: m.item,
        position: {
          offset: g.offset + g.size + c,
          // @ts-expect-error the type check above does not check for type number explicitly
          size: d ? p : m.barSize
        }
      }, O = [].concat(ig(y), [C]);
      return g = O[O.length - 1].position, m.stackList && m.stackList.length && m.stackList.forEach(function(S) {
        O.push({
          item: S,
          position: g
        });
      }), O;
    }, f);
  } else {
    var b = Zn(n, a, 0, !0);
    a - 2 * b - (s - 1) * c <= 0 && (c = 0);
    var x = (a - 2 * b - (s - 1) * c) / s;
    x > 1 && (x >>= 0);
    var w = u === +u ? Math.min(x, u) : x;
    l = o.reduce(function(y, m, C) {
      var O = [].concat(ig(y), [{
        item: m.item,
        position: {
          offset: b + (x + c) * C + (x - w) / 2,
          size: w
        }
      }]);
      return m.stackList && m.stackList.length && m.stackList.forEach(function(S) {
        O.push({
          item: S,
          position: O[O.length - 1].position
        });
      }), O;
    }, f);
  }
  return l;
}, ZU = function(t, r, n, a) {
  var i = n.children, o = n.width, u = n.margin, s = o - (u.left || 0) - (u.right || 0), c = x5({
    children: i,
    legendWidth: s
  });
  if (c) {
    var l = a || {}, f = l.width, d = l.height, p = c.align, h = c.verticalAlign, v = c.layout;
    if ((v === "vertical" || v === "horizontal" && h === "middle") && p !== "center" && oe(t[p]))
      return nr(nr({}, t), {}, xa({}, p, t[p] + (f || 0)));
    if ((v === "horizontal" || v === "vertical" && p === "center") && h !== "middle" && oe(t[h]))
      return nr(nr({}, t), {}, xa({}, h, t[h] + (d || 0)));
  }
  return t;
}, KU = function(t, r, n) {
  return Me(r) ? !0 : t === "horizontal" ? r === "yAxis" : t === "vertical" || n === "x" ? r === "xAxis" : n === "y" ? r === "yAxis" : !0;
}, C5 = function(t, r, n, a, i) {
  var o = r.props.children, u = br(o, Pc).filter(function(c) {
    return KU(a, i, c.props.direction);
  });
  if (u && u.length) {
    var s = u.map(function(c) {
      return c.props.dataKey;
    });
    return t.reduce(function(c, l) {
      var f = Kt(l, n);
      if (Me(f)) return c;
      var d = Array.isArray(f) ? [Ec(f), ln(f)] : [f, f], p = s.reduce(function(h, v) {
        var g = Kt(l, v, 0), b = d[0] - Math.abs(Array.isArray(g) ? g[0] : g), x = d[1] + Math.abs(Array.isArray(g) ? g[1] : g);
        return [Math.min(b, h[0]), Math.max(x, h[1])];
      }, [1 / 0, -1 / 0]);
      return [Math.min(p[0], c[0]), Math.max(p[1], c[1])];
    }, [1 / 0, -1 / 0]);
  }
  return null;
}, qU = function(t, r, n, a, i) {
  var o = r.map(function(u) {
    return C5(t, u, n, i, a);
  }).filter(function(u) {
    return !Me(u);
  });
  return o && o.length ? o.reduce(function(u, s) {
    return [Math.min(u[0], s[0]), Math.max(u[1], s[1])];
  }, [1 / 0, -1 / 0]) : null;
}, w5 = function(t, r, n, a, i) {
  var o = r.map(function(s) {
    var c = s.props.dataKey;
    return n === "number" && c && C5(t, s, c, a) || qi(t, c, n, i);
  });
  if (n === "number")
    return o.reduce(
      // @ts-expect-error if (type === number) means that the domain is numerical type
      // - but this link is missing in the type definition
      function(s, c) {
        return [Math.min(s[0], c[0]), Math.max(s[1], c[1])];
      },
      [1 / 0, -1 / 0]
    );
  var u = {};
  return o.reduce(function(s, c) {
    for (var l = 0, f = c.length; l < f; l++)
      u[c[l]] || (u[c[l]] = !0, s.push(c[l]));
    return s;
  }, []);
}, O5 = function(t, r) {
  return t === "horizontal" && r === "xAxis" || t === "vertical" && r === "yAxis" || t === "centric" && r === "angleAxis" || t === "radial" && r === "radiusAxis";
}, S5 = function(t, r, n, a) {
  if (a)
    return t.map(function(s) {
      return s.coordinate;
    });
  var i, o, u = t.map(function(s) {
    return s.coordinate === r && (i = !0), s.coordinate === n && (o = !0), s.coordinate;
  });
  return i || u.push(r), o || u.push(n), u;
}, Wr = function(t, r, n) {
  if (!t) return null;
  var a = t.scale, i = t.duplicateDomain, o = t.type, u = t.range, s = t.realScaleType === "scaleBand" ? a.bandwidth() / 2 : 2, c = (r || n) && o === "category" && a.bandwidth ? a.bandwidth() / s : 0;
  if (c = t.axisType === "angleAxis" && (u == null ? void 0 : u.length) >= 2 ? yr(u[0] - u[1]) * 2 * c : c, r && (t.ticks || t.niceTicks)) {
    var l = (t.ticks || t.niceTicks).map(function(f) {
      var d = i ? i.indexOf(f) : f;
      return {
        // If the scaleContent is not a number, the coordinate will be NaN.
        // That could be the case for example with a PointScale and a string as domain.
        coordinate: a(d) + c,
        value: f,
        offset: c
      };
    });
    return l.filter(function(f) {
      return !ai(f.coordinate);
    });
  }
  return t.isCategorical && t.categoricalDomain ? t.categoricalDomain.map(function(f, d) {
    return {
      coordinate: a(f) + c,
      value: f,
      index: d,
      offset: c
    };
  }) : a.ticks && !n ? a.ticks(t.tickCount).map(function(f) {
    return {
      coordinate: a(f) + c,
      value: f,
      offset: c
    };
  }) : a.domain().map(function(f, d) {
    return {
      coordinate: a(f) + c,
      value: i ? i[f] : f,
      index: d,
      offset: c
    };
  });
}, rf = /* @__PURE__ */ new WeakMap(), Iu = function(t, r) {
  if (typeof r != "function")
    return t;
  rf.has(t) || rf.set(t, /* @__PURE__ */ new WeakMap());
  var n = rf.get(t);
  if (n.has(r))
    return n.get(r);
  var a = function() {
    t.apply(void 0, arguments), r.apply(void 0, arguments);
  };
  return n.set(r, a), a;
}, JU = function(t, r, n) {
  var a = t.scale, i = t.type, o = t.layout, u = t.axisType;
  if (a === "auto")
    return o === "radial" && u === "radiusAxis" ? {
      scale: mo(),
      realScaleType: "band"
    } : o === "radial" && u === "angleAxis" ? {
      scale: ws(),
      realScaleType: "linear"
    } : i === "category" && r && (r.indexOf("LineChart") >= 0 || r.indexOf("AreaChart") >= 0 || r.indexOf("ComposedChart") >= 0 && !n) ? {
      scale: Ki(),
      realScaleType: "point"
    } : i === "category" ? {
      scale: mo(),
      realScaleType: "band"
    } : {
      scale: ws(),
      realScaleType: "linear"
    };
  if (tu(a)) {
    var s = "scale".concat(pc(a));
    return {
      scale: (J2[s] || Ki)(),
      realScaleType: J2[s] ? s : "point"
    };
  }
  return _e(a) ? {
    scale: a
  } : {
    scale: Ki(),
    realScaleType: "point"
  };
}, og = 1e-4, QU = function(t) {
  var r = t.domain();
  if (!(!r || r.length <= 2)) {
    var n = r.length, a = t.range(), i = Math.min(a[0], a[1]) - og, o = Math.max(a[0], a[1]) + og, u = t(r[0]), s = t(r[n - 1]);
    (u < i || u > o || s < i || s > o) && t.domain([r[0], r[n - 1]]);
  }
}, ez = function(t, r) {
  if (!t)
    return null;
  for (var n = 0, a = t.length; n < a; n++)
    if (t[n].item === r)
      return t[n].position;
  return null;
}, tz = function(t, r) {
  if (!r || r.length !== 2 || !oe(r[0]) || !oe(r[1]))
    return t;
  var n = Math.min(r[0], r[1]), a = Math.max(r[0], r[1]), i = [t[0], t[1]];
  return (!oe(t[0]) || t[0] < n) && (i[0] = n), (!oe(t[1]) || t[1] > a) && (i[1] = a), i[0] > a && (i[0] = a), i[1] < n && (i[1] = n), i;
}, rz = function(t) {
  var r = t.length;
  if (!(r <= 0))
    for (var n = 0, a = t[0].length; n < a; ++n)
      for (var i = 0, o = 0, u = 0; u < r; ++u) {
        var s = ai(t[u][n][1]) ? t[u][n][0] : t[u][n][1];
        s >= 0 ? (t[u][n][0] = i, t[u][n][1] = i + s, i = t[u][n][1]) : (t[u][n][0] = o, t[u][n][1] = o + s, o = t[u][n][1]);
      }
}, nz = function(t) {
  var r = t.length;
  if (!(r <= 0))
    for (var n = 0, a = t[0].length; n < a; ++n)
      for (var i = 0, o = 0; o < r; ++o) {
        var u = ai(t[o][n][1]) ? t[o][n][0] : t[o][n][1];
        u >= 0 ? (t[o][n][0] = i, t[o][n][1] = i + u, i = t[o][n][1]) : (t[o][n][0] = 0, t[o][n][1] = 0);
      }
}, az = {
  sign: rz,
  // @ts-expect-error definitelytyped types are incorrect
  expand: Ij,
  // @ts-expect-error definitelytyped types are incorrect
  none: Ta,
  // @ts-expect-error definitelytyped types are incorrect
  silhouette: Pj,
  // @ts-expect-error definitelytyped types are incorrect
  wiggle: Tj,
  positive: nz
}, iz = function(t, r, n) {
  var a = r.map(function(u) {
    return u.props.dataKey;
  }), i = az[n], o = _j().keys(a).value(function(u, s) {
    return +Kt(u, s, 0);
  }).order(id).offset(i);
  return o(t);
}, oz = function(t, r, n, a, i, o) {
  if (!t)
    return null;
  var u = o ? r.reverse() : r, s = {}, c = u.reduce(function(f, d) {
    var p = d.props, h = p.stackId, v = p.hide;
    if (v)
      return f;
    var g = d.props[n], b = f[g] || {
      hasStack: !1,
      stackGroups: {}
    };
    if (gt(h)) {
      var x = b.stackGroups[h] || {
        numericAxisId: n,
        cateAxisId: a,
        items: []
      };
      x.items.push(d), b.hasStack = !0, b.stackGroups[h] = x;
    } else
      b.stackGroups[ru("_stackId_")] = {
        numericAxisId: n,
        cateAxisId: a,
        items: [d]
      };
    return nr(nr({}, f), {}, xa({}, g, b));
  }, s), l = {};
  return Object.keys(c).reduce(function(f, d) {
    var p = c[d];
    if (p.hasStack) {
      var h = {};
      p.stackGroups = Object.keys(p.stackGroups).reduce(function(v, g) {
        var b = p.stackGroups[g];
        return nr(nr({}, v), {}, xa({}, g, {
          numericAxisId: n,
          cateAxisId: a,
          items: b.items,
          stackedData: iz(t, b.items, i)
        }));
      }, h);
    }
    return nr(nr({}, f), {}, xa({}, d, p));
  }, l);
}, uz = function(t, r) {
  var n = r.realScaleType, a = r.type, i = r.tickCount, o = r.originalDomain, u = r.allowDecimals, s = n || r.scale;
  if (s !== "auto" && s !== "linear")
    return null;
  if (i && a === "number" && o && (o[0] === "auto" || o[1] === "auto")) {
    var c = t.domain();
    if (!c.length)
      return null;
    var l = EU(c, i, u);
    return t.domain([Ec(l), ln(l)]), {
      niceTicks: l
    };
  }
  if (i && a === "number") {
    var f = t.domain(), d = _U(f, i, u);
    return {
      niceTicks: d
    };
  }
  return null;
};
function ug(e) {
  var t = e.axis, r = e.ticks, n = e.bandSize, a = e.entry, i = e.index, o = e.dataKey;
  if (t.type === "category") {
    if (!t.allowDuplicatedCategory && t.dataKey && !Me(a[t.dataKey])) {
      var u = Qu(r, "value", a[t.dataKey]);
      if (u)
        return u.coordinate + n / 2;
    }
    return r[i] ? r[i].coordinate + n / 2 : null;
  }
  var s = Kt(a, Me(o) ? t.dataKey : o);
  return Me(s) ? null : t.scale(s);
}
var sg = function(t) {
  var r = t.axis, n = t.ticks, a = t.offset, i = t.bandSize, o = t.entry, u = t.index;
  if (r.type === "category")
    return n[u] ? n[u].coordinate + a : null;
  var s = Kt(o, r.dataKey, r.domain[u]);
  return Me(s) ? null : r.scale(s) - i / 2 + a;
}, sz = function(t) {
  var r = t.numericAxis, n = r.scale.domain();
  if (r.type === "number") {
    var a = Math.min(n[0], n[1]), i = Math.max(n[0], n[1]);
    return a <= 0 && i >= 0 ? 0 : i < 0 ? i : a;
  }
  return n[0];
}, cz = function(t, r) {
  var n = t.props.stackId;
  if (gt(n)) {
    var a = r[n];
    if (a) {
      var i = a.items.indexOf(t);
      return i >= 0 ? a.stackedData[i] : null;
    }
  }
  return null;
}, lz = function(t) {
  return t.reduce(function(r, n) {
    return [Ec(n.concat([r[0]]).filter(oe)), ln(n.concat([r[1]]).filter(oe))];
  }, [1 / 0, -1 / 0]);
}, A5 = function(t, r, n) {
  return Object.keys(t).reduce(function(a, i) {
    var o = t[i], u = o.stackedData, s = u.reduce(function(c, l) {
      var f = lz(l.slice(r, n + 1));
      return [Math.min(c[0], f[0]), Math.max(c[1], f[1])];
    }, [1 / 0, -1 / 0]);
    return [Math.min(s[0], a[0]), Math.max(s[1], a[1])];
  }, [1 / 0, -1 / 0]).map(function(a) {
    return a === 1 / 0 || a === -1 / 0 ? 0 : a;
  });
}, cg = /^dataMin[\s]*-[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/, lg = /^dataMax[\s]*\+[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/, $d = function(t, r, n) {
  if (_e(t))
    return t(r, n);
  if (!Array.isArray(t))
    return r;
  var a = [];
  if (oe(t[0]))
    a[0] = n ? t[0] : Math.min(t[0], r[0]);
  else if (cg.test(t[0])) {
    var i = +cg.exec(t[0])[1];
    a[0] = r[0] - i;
  } else _e(t[0]) ? a[0] = t[0](r[0]) : a[0] = r[0];
  if (oe(t[1]))
    a[1] = n ? t[1] : Math.max(t[1], r[1]);
  else if (lg.test(t[1])) {
    var o = +lg.exec(t[1])[1];
    a[1] = r[1] + o;
  } else _e(t[1]) ? a[1] = t[1](r[1]) : a[1] = r[1];
  return a;
}, Is = function(t, r, n) {
  if (t && t.scale && t.scale.bandwidth) {
    var a = t.scale.bandwidth();
    if (!n || a > 0)
      return a;
  }
  if (t && r && r.length >= 2) {
    for (var i = pp(r, function(f) {
      return f.coordinate;
    }), o = 1 / 0, u = 1, s = i.length; u < s; u++) {
      var c = i[u], l = i[u - 1];
      o = Math.min((c.coordinate || 0) - (l.coordinate || 0), o);
    }
    return o === 1 / 0 ? 0 : o;
  }
  return n ? void 0 : 0;
}, fg = function(t, r, n) {
  return !t || !t.length || wo(t, ve(n, "type.defaultProps.domain")) ? r : t;
}, E5 = function(t, r) {
  var n = t.props, a = n.dataKey, i = n.name, o = n.unit, u = n.formatter, s = n.tooltipType, c = n.chartType, l = n.hide;
  return nr(nr({}, Ie(t, !1)), {}, {
    dataKey: a,
    unit: o,
    formatter: u,
    name: i || a,
    color: Lp(t),
    value: Kt(r, a),
    type: s,
    payload: r,
    chartType: c,
    hide: l
  });
};
function _o(e) {
  "@babel/helpers - typeof";
  return _o = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, _o(e);
}
function dg(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function pg(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? dg(Object(r), !0).forEach(function(n) {
      fz(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : dg(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function fz(e, t, r) {
  return t = dz(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function dz(e) {
  var t = pz(e, "string");
  return _o(t) == "symbol" ? t : String(t);
}
function pz(e, t) {
  if (_o(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (_o(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var Ps = Math.PI / 180, hz = function(t) {
  return t * 180 / Math.PI;
}, It = function(t, r, n, a) {
  return {
    x: t + Math.cos(-Ps * a) * n,
    y: r + Math.sin(-Ps * a) * n
  };
}, vz = function(t, r) {
  var n = t.x, a = t.y, i = r.x, o = r.y;
  return Math.sqrt(Math.pow(n - i, 2) + Math.pow(a - o, 2));
}, gz = function(t, r) {
  var n = t.x, a = t.y, i = r.cx, o = r.cy, u = vz({
    x: n,
    y: a
  }, {
    x: i,
    y: o
  });
  if (u <= 0)
    return {
      radius: u
    };
  var s = (n - i) / u, c = Math.acos(s);
  return a > o && (c = 2 * Math.PI - c), {
    radius: u,
    angle: hz(c),
    angleInRadian: c
  };
}, mz = function(t) {
  var r = t.startAngle, n = t.endAngle, a = Math.floor(r / 360), i = Math.floor(n / 360), o = Math.min(a, i);
  return {
    startAngle: r - o * 360,
    endAngle: n - o * 360
  };
}, yz = function(t, r) {
  var n = r.startAngle, a = r.endAngle, i = Math.floor(n / 360), o = Math.floor(a / 360), u = Math.min(i, o);
  return t + u * 360;
}, hg = function(t, r) {
  var n = t.x, a = t.y, i = gz({
    x: n,
    y: a
  }, r), o = i.radius, u = i.angle, s = r.innerRadius, c = r.outerRadius;
  if (o < s || o > c)
    return !1;
  if (o === 0)
    return !0;
  var l = mz(r), f = l.startAngle, d = l.endAngle, p = u, h;
  if (f <= d) {
    for (; p > d; )
      p -= 360;
    for (; p < f; )
      p += 360;
    h = p >= f && p <= d;
  } else {
    for (; p > f; )
      p -= 360;
    for (; p < d; )
      p += 360;
    h = p >= d && p <= f;
  }
  return h ? pg(pg({}, r), {}, {
    radius: o,
    angle: yz(p, r)
  }) : null;
};
function Io(e) {
  "@babel/helpers - typeof";
  return Io = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Io(e);
}
var bz = ["offset"];
function xz(e) {
  return Sz(e) || Oz(e) || wz(e) || Cz();
}
function Cz() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function wz(e, t) {
  if (e) {
    if (typeof e == "string") return Fd(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Fd(e, t);
  }
}
function Oz(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function Sz(e) {
  if (Array.isArray(e)) return Fd(e);
}
function Fd(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function Az(e, t) {
  if (e == null) return {};
  var r = Ez(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function Ez(e, t) {
  if (e == null) return {};
  var r = {}, n = Object.keys(e), a, i;
  for (i = 0; i < n.length; i++)
    a = n[i], !(t.indexOf(a) >= 0) && (r[a] = e[a]);
  return r;
}
function vg(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function ht(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? vg(Object(r), !0).forEach(function(n) {
      _z(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : vg(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function _z(e, t, r) {
  return t = Iz(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Iz(e) {
  var t = Pz(e, "string");
  return Io(t) == "symbol" ? t : String(t);
}
function Pz(e, t) {
  if (Io(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (Io(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Po() {
  return Po = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Po.apply(this, arguments);
}
var Tz = function(t) {
  var r = t.value, n = t.formatter, a = Me(t.children) ? r : t.children;
  return _e(n) ? n(a) : a;
}, Mz = function(t, r) {
  var n = yr(r - t), a = Math.min(Math.abs(r - t), 360);
  return n * a;
}, jz = function(t, r, n) {
  var a = t.position, i = t.viewBox, o = t.offset, u = t.className, s = i, c = s.cx, l = s.cy, f = s.innerRadius, d = s.outerRadius, p = s.startAngle, h = s.endAngle, v = s.clockWise, g = (f + d) / 2, b = Mz(p, h), x = b >= 0 ? 1 : -1, w, y;
  a === "insideStart" ? (w = p + x * o, y = v) : a === "insideEnd" ? (w = h - x * o, y = !v) : a === "end" && (w = h + x * o, y = v), y = b <= 0 ? y : !y;
  var m = It(c, l, g, w), C = It(c, l, g, w + (y ? 1 : -1) * 359), O = "M".concat(m.x, ",").concat(m.y, `
    A`).concat(g, ",").concat(g, ",0,1,").concat(y ? 0 : 1, `,
    `).concat(C.x, ",").concat(C.y), S = Me(t.id) ? ru("recharts-radial-line-") : t.id;
  return /* @__PURE__ */ N.createElement("text", Po({}, n, {
    dominantBaseline: "central",
    className: Ne("recharts-radial-bar-label", u)
  }), /* @__PURE__ */ N.createElement("defs", null, /* @__PURE__ */ N.createElement("path", {
    id: S,
    d: O
  })), /* @__PURE__ */ N.createElement("textPath", {
    xlinkHref: "#".concat(S)
  }, r));
}, Rz = function(t) {
  var r = t.viewBox, n = t.offset, a = t.position, i = r, o = i.cx, u = i.cy, s = i.innerRadius, c = i.outerRadius, l = i.startAngle, f = i.endAngle, d = (l + f) / 2;
  if (a === "outside") {
    var p = It(o, u, c + n, d), h = p.x, v = p.y;
    return {
      x: h,
      y: v,
      textAnchor: h >= o ? "start" : "end",
      verticalAnchor: "middle"
    };
  }
  if (a === "center")
    return {
      x: o,
      y: u,
      textAnchor: "middle",
      verticalAnchor: "middle"
    };
  if (a === "centerTop")
    return {
      x: o,
      y: u,
      textAnchor: "middle",
      verticalAnchor: "start"
    };
  if (a === "centerBottom")
    return {
      x: o,
      y: u,
      textAnchor: "middle",
      verticalAnchor: "end"
    };
  var g = (s + c) / 2, b = It(o, u, g, d), x = b.x, w = b.y;
  return {
    x,
    y: w,
    textAnchor: "middle",
    verticalAnchor: "middle"
  };
}, Nz = function(t) {
  var r = t.viewBox, n = t.parentViewBox, a = t.offset, i = t.position, o = r, u = o.x, s = o.y, c = o.width, l = o.height, f = l >= 0 ? 1 : -1, d = f * a, p = f > 0 ? "end" : "start", h = f > 0 ? "start" : "end", v = c >= 0 ? 1 : -1, g = v * a, b = v > 0 ? "end" : "start", x = v > 0 ? "start" : "end";
  if (i === "top") {
    var w = {
      x: u + c / 2,
      y: s - f * a,
      textAnchor: "middle",
      verticalAnchor: p
    };
    return ht(ht({}, w), n ? {
      height: Math.max(s - n.y, 0),
      width: c
    } : {});
  }
  if (i === "bottom") {
    var y = {
      x: u + c / 2,
      y: s + l + d,
      textAnchor: "middle",
      verticalAnchor: h
    };
    return ht(ht({}, y), n ? {
      height: Math.max(n.y + n.height - (s + l), 0),
      width: c
    } : {});
  }
  if (i === "left") {
    var m = {
      x: u - g,
      y: s + l / 2,
      textAnchor: b,
      verticalAnchor: "middle"
    };
    return ht(ht({}, m), n ? {
      width: Math.max(m.x - n.x, 0),
      height: l
    } : {});
  }
  if (i === "right") {
    var C = {
      x: u + c + g,
      y: s + l / 2,
      textAnchor: x,
      verticalAnchor: "middle"
    };
    return ht(ht({}, C), n ? {
      width: Math.max(n.x + n.width - C.x, 0),
      height: l
    } : {});
  }
  var O = n ? {
    width: c,
    height: l
  } : {};
  return i === "insideLeft" ? ht({
    x: u + g,
    y: s + l / 2,
    textAnchor: x,
    verticalAnchor: "middle"
  }, O) : i === "insideRight" ? ht({
    x: u + c - g,
    y: s + l / 2,
    textAnchor: b,
    verticalAnchor: "middle"
  }, O) : i === "insideTop" ? ht({
    x: u + c / 2,
    y: s + d,
    textAnchor: "middle",
    verticalAnchor: h
  }, O) : i === "insideBottom" ? ht({
    x: u + c / 2,
    y: s + l - d,
    textAnchor: "middle",
    verticalAnchor: p
  }, O) : i === "insideTopLeft" ? ht({
    x: u + g,
    y: s + d,
    textAnchor: x,
    verticalAnchor: h
  }, O) : i === "insideTopRight" ? ht({
    x: u + c - g,
    y: s + d,
    textAnchor: b,
    verticalAnchor: h
  }, O) : i === "insideBottomLeft" ? ht({
    x: u + g,
    y: s + l - d,
    textAnchor: x,
    verticalAnchor: p
  }, O) : i === "insideBottomRight" ? ht({
    x: u + c - g,
    y: s + l - d,
    textAnchor: b,
    verticalAnchor: p
  }, O) : Ja(i) && (oe(i.x) || kn(i.x)) && (oe(i.y) || kn(i.y)) ? ht({
    x: u + Zn(i.x, c),
    y: s + Zn(i.y, l),
    textAnchor: "end",
    verticalAnchor: "end"
  }, O) : ht({
    x: u + c / 2,
    y: s + l / 2,
    textAnchor: "middle",
    verticalAnchor: "middle"
  }, O);
}, $z = function(t) {
  return "cx" in t && oe(t.cx);
};
function Mt(e) {
  var t = e.offset, r = t === void 0 ? 5 : t, n = Az(e, bz), a = ht({
    offset: r
  }, n), i = a.viewBox, o = a.position, u = a.value, s = a.children, c = a.content, l = a.className, f = l === void 0 ? "" : l, d = a.textBreakAll;
  if (!i || Me(u) && Me(s) && !/* @__PURE__ */ _r(c) && !_e(c))
    return null;
  if (/* @__PURE__ */ _r(c))
    return /* @__PURE__ */ vt(c, a);
  var p;
  if (_e(c)) {
    if (p = /* @__PURE__ */ zm(c, a), /* @__PURE__ */ _r(p))
      return p;
  } else
    p = Tz(a);
  var h = $z(i), v = Ie(a, !0);
  if (h && (o === "insideStart" || o === "insideEnd" || o === "end"))
    return jz(a, p, v);
  var g = h ? Rz(a) : Nz(a);
  return /* @__PURE__ */ N.createElement(vs, Po({
    className: Ne("recharts-label", f)
  }, v, g, {
    breakAll: d
  }), p);
}
Mt.displayName = "Label";
var _5 = function(t) {
  var r = t.cx, n = t.cy, a = t.angle, i = t.startAngle, o = t.endAngle, u = t.r, s = t.radius, c = t.innerRadius, l = t.outerRadius, f = t.x, d = t.y, p = t.top, h = t.left, v = t.width, g = t.height, b = t.clockWise, x = t.labelViewBox;
  if (x)
    return x;
  if (oe(v) && oe(g)) {
    if (oe(f) && oe(d))
      return {
        x: f,
        y: d,
        width: v,
        height: g
      };
    if (oe(p) && oe(h))
      return {
        x: p,
        y: h,
        width: v,
        height: g
      };
  }
  return oe(f) && oe(d) ? {
    x: f,
    y: d,
    width: 0,
    height: 0
  } : oe(r) && oe(n) ? {
    cx: r,
    cy: n,
    startAngle: i || a || 0,
    endAngle: o || a || 0,
    innerRadius: c || 0,
    outerRadius: l || s || u || 0,
    clockWise: b
  } : t.viewBox ? t.viewBox : {};
}, Fz = function(t, r) {
  return t ? t === !0 ? /* @__PURE__ */ N.createElement(Mt, {
    key: "label-implicit",
    viewBox: r
  }) : gt(t) ? /* @__PURE__ */ N.createElement(Mt, {
    key: "label-implicit",
    viewBox: r,
    value: t
  }) : /* @__PURE__ */ _r(t) ? t.type === Mt ? /* @__PURE__ */ vt(t, {
    key: "label-implicit",
    viewBox: r
  }) : /* @__PURE__ */ N.createElement(Mt, {
    key: "label-implicit",
    content: t,
    viewBox: r
  }) : _e(t) ? /* @__PURE__ */ N.createElement(Mt, {
    key: "label-implicit",
    content: t,
    viewBox: r
  }) : Ja(t) ? /* @__PURE__ */ N.createElement(Mt, Po({
    viewBox: r
  }, t, {
    key: "label-implicit"
  })) : null : null;
}, Dz = function(t, r) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0;
  if (!t || !t.children && n && !t.label)
    return null;
  var a = t.children, i = _5(t), o = br(a, Mt).map(function(s, c) {
    return /* @__PURE__ */ vt(s, {
      viewBox: r || i,
      // eslint-disable-next-line react/no-array-index-key
      key: "label-".concat(c)
    });
  });
  if (!n)
    return o;
  var u = Fz(t.label, r || i);
  return [u].concat(xz(o));
};
Mt.parseViewBox = _5;
Mt.renderCallByParent = Dz;
function kz(e) {
  var t = e == null ? 0 : e.length;
  return t ? e[t - 1] : void 0;
}
var Lz = kz;
const Bz = /* @__PURE__ */ Fe(Lz);
function To(e) {
  "@babel/helpers - typeof";
  return To = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, To(e);
}
var Vz = ["valueAccessor"], Wz = ["data", "dataKey", "clockWise", "id", "textBreakAll"];
function Gz(e) {
  return Yz(e) || zz(e) || Uz(e) || Hz();
}
function Hz() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Uz(e, t) {
  if (e) {
    if (typeof e == "string") return Dd(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Dd(e, t);
  }
}
function zz(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function Yz(e) {
  if (Array.isArray(e)) return Dd(e);
}
function Dd(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function Ts() {
  return Ts = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Ts.apply(this, arguments);
}
function gg(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function mg(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? gg(Object(r), !0).forEach(function(n) {
      Xz(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : gg(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Xz(e, t, r) {
  return t = Zz(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Zz(e) {
  var t = Kz(e, "string");
  return To(t) == "symbol" ? t : String(t);
}
function Kz(e, t) {
  if (To(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (To(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function yg(e, t) {
  if (e == null) return {};
  var r = qz(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function qz(e, t) {
  if (e == null) return {};
  var r = {}, n = Object.keys(e), a, i;
  for (i = 0; i < n.length; i++)
    a = n[i], !(t.indexOf(a) >= 0) && (r[a] = e[a]);
  return r;
}
var Jz = function(t) {
  return Array.isArray(t.value) ? Bz(t.value) : t.value;
};
function vn(e) {
  var t = e.valueAccessor, r = t === void 0 ? Jz : t, n = yg(e, Vz), a = n.data, i = n.dataKey, o = n.clockWise, u = n.id, s = n.textBreakAll, c = yg(n, Wz);
  return !a || !a.length ? null : /* @__PURE__ */ N.createElement(ut, {
    className: "recharts-label-list"
  }, a.map(function(l, f) {
    var d = Me(i) ? r(l, f) : Kt(l && l.payload, i), p = Me(u) ? {} : {
      id: "".concat(u, "-").concat(f)
    };
    return /* @__PURE__ */ N.createElement(Mt, Ts({}, Ie(l, !0), c, p, {
      parentViewBox: l.parentViewBox,
      value: d,
      textBreakAll: s,
      viewBox: Mt.parseViewBox(Me(o) ? l : mg(mg({}, l), {}, {
        clockWise: o
      })),
      key: "label-".concat(f),
      index: f
    }));
  }));
}
vn.displayName = "LabelList";
function Qz(e, t) {
  return e ? e === !0 ? /* @__PURE__ */ N.createElement(vn, {
    key: "labelList-implicit",
    data: t
  }) : /* @__PURE__ */ N.isValidElement(e) || _e(e) ? /* @__PURE__ */ N.createElement(vn, {
    key: "labelList-implicit",
    data: t,
    content: e
  }) : Ja(e) ? /* @__PURE__ */ N.createElement(vn, Ts({
    data: t
  }, e, {
    key: "labelList-implicit"
  })) : null : null;
}
function eY(e, t) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0;
  if (!e || !e.children && r && !e.label)
    return null;
  var n = e.children, a = br(n, vn).map(function(o, u) {
    return /* @__PURE__ */ vt(o, {
      data: t,
      // eslint-disable-next-line react/no-array-index-key
      key: "labelList-".concat(u)
    });
  });
  if (!r)
    return a;
  var i = Qz(e.label, t);
  return [i].concat(Gz(a));
}
vn.renderCallByParent = eY;
function Mo(e) {
  "@babel/helpers - typeof";
  return Mo = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Mo(e);
}
function kd() {
  return kd = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, kd.apply(this, arguments);
}
function bg(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function xg(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? bg(Object(r), !0).forEach(function(n) {
      tY(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : bg(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function tY(e, t, r) {
  return t = rY(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function rY(e) {
  var t = nY(e, "string");
  return Mo(t) == "symbol" ? t : String(t);
}
function nY(e, t) {
  if (Mo(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (Mo(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var aY = function(t, r) {
  var n = yr(r - t), a = Math.min(Math.abs(r - t), 359.999);
  return n * a;
}, Pu = function(t) {
  var r = t.cx, n = t.cy, a = t.radius, i = t.angle, o = t.sign, u = t.isExternal, s = t.cornerRadius, c = t.cornerIsExternal, l = s * (u ? 1 : -1) + a, f = Math.asin(s / l) / Ps, d = c ? i : i + o * f, p = It(r, n, l, d), h = It(r, n, a, d), v = c ? i - o * f : i, g = It(r, n, l * Math.cos(f * Ps), v);
  return {
    center: p,
    circleTangency: h,
    lineTangency: g,
    theta: f
  };
}, I5 = function(t) {
  var r = t.cx, n = t.cy, a = t.innerRadius, i = t.outerRadius, o = t.startAngle, u = t.endAngle, s = aY(o, u), c = o + s, l = It(r, n, i, o), f = It(r, n, i, c), d = "M ".concat(l.x, ",").concat(l.y, `
    A `).concat(i, ",").concat(i, `,0,
    `).concat(+(Math.abs(s) > 180), ",").concat(+(o > c), `,
    `).concat(f.x, ",").concat(f.y, `
  `);
  if (a > 0) {
    var p = It(r, n, a, o), h = It(r, n, a, c);
    d += "L ".concat(h.x, ",").concat(h.y, `
            A `).concat(a, ",").concat(a, `,0,
            `).concat(+(Math.abs(s) > 180), ",").concat(+(o <= c), `,
            `).concat(p.x, ",").concat(p.y, " Z");
  } else
    d += "L ".concat(r, ",").concat(n, " Z");
  return d;
}, iY = function(t) {
  var r = t.cx, n = t.cy, a = t.innerRadius, i = t.outerRadius, o = t.cornerRadius, u = t.forceCornerRadius, s = t.cornerIsExternal, c = t.startAngle, l = t.endAngle, f = yr(l - c), d = Pu({
    cx: r,
    cy: n,
    radius: i,
    angle: c,
    sign: f,
    cornerRadius: o,
    cornerIsExternal: s
  }), p = d.circleTangency, h = d.lineTangency, v = d.theta, g = Pu({
    cx: r,
    cy: n,
    radius: i,
    angle: l,
    sign: -f,
    cornerRadius: o,
    cornerIsExternal: s
  }), b = g.circleTangency, x = g.lineTangency, w = g.theta, y = s ? Math.abs(c - l) : Math.abs(c - l) - v - w;
  if (y < 0)
    return u ? "M ".concat(h.x, ",").concat(h.y, `
        a`).concat(o, ",").concat(o, ",0,0,1,").concat(o * 2, `,0
        a`).concat(o, ",").concat(o, ",0,0,1,").concat(-o * 2, `,0
      `) : I5({
      cx: r,
      cy: n,
      innerRadius: a,
      outerRadius: i,
      startAngle: c,
      endAngle: l
    });
  var m = "M ".concat(h.x, ",").concat(h.y, `
    A`).concat(o, ",").concat(o, ",0,0,").concat(+(f < 0), ",").concat(p.x, ",").concat(p.y, `
    A`).concat(i, ",").concat(i, ",0,").concat(+(y > 180), ",").concat(+(f < 0), ",").concat(b.x, ",").concat(b.y, `
    A`).concat(o, ",").concat(o, ",0,0,").concat(+(f < 0), ",").concat(x.x, ",").concat(x.y, `
  `);
  if (a > 0) {
    var C = Pu({
      cx: r,
      cy: n,
      radius: a,
      angle: c,
      sign: f,
      isExternal: !0,
      cornerRadius: o,
      cornerIsExternal: s
    }), O = C.circleTangency, S = C.lineTangency, A = C.theta, P = Pu({
      cx: r,
      cy: n,
      radius: a,
      angle: l,
      sign: -f,
      isExternal: !0,
      cornerRadius: o,
      cornerIsExternal: s
    }), T = P.circleTangency, M = P.lineTangency, I = P.theta, G = s ? Math.abs(c - l) : Math.abs(c - l) - A - I;
    if (G < 0 && o === 0)
      return "".concat(m, "L").concat(r, ",").concat(n, "Z");
    m += "L".concat(M.x, ",").concat(M.y, `
      A`).concat(o, ",").concat(o, ",0,0,").concat(+(f < 0), ",").concat(T.x, ",").concat(T.y, `
      A`).concat(a, ",").concat(a, ",0,").concat(+(G > 180), ",").concat(+(f > 0), ",").concat(O.x, ",").concat(O.y, `
      A`).concat(o, ",").concat(o, ",0,0,").concat(+(f < 0), ",").concat(S.x, ",").concat(S.y, "Z");
  } else
    m += "L".concat(r, ",").concat(n, "Z");
  return m;
}, oY = {
  cx: 0,
  cy: 0,
  innerRadius: 0,
  outerRadius: 0,
  startAngle: 0,
  endAngle: 0,
  cornerRadius: 0,
  forceCornerRadius: !1,
  cornerIsExternal: !1
}, P5 = function(t) {
  var r = xg(xg({}, oY), t), n = r.cx, a = r.cy, i = r.innerRadius, o = r.outerRadius, u = r.cornerRadius, s = r.forceCornerRadius, c = r.cornerIsExternal, l = r.startAngle, f = r.endAngle, d = r.className;
  if (o < i || l === f)
    return null;
  var p = Ne("recharts-sector", d), h = o - i, v = Zn(u, h, 0, !0), g;
  return v > 0 && Math.abs(l - f) < 360 ? g = iY({
    cx: n,
    cy: a,
    innerRadius: i,
    outerRadius: o,
    cornerRadius: Math.min(v, h / 2),
    forceCornerRadius: s,
    cornerIsExternal: c,
    startAngle: l,
    endAngle: f
  }) : g = I5({
    cx: n,
    cy: a,
    innerRadius: i,
    outerRadius: o,
    startAngle: l,
    endAngle: f
  }), /* @__PURE__ */ N.createElement("path", kd({}, Ie(r, !0), {
    className: p,
    d: g,
    role: "img"
  }));
};
function jo(e) {
  "@babel/helpers - typeof";
  return jo = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, jo(e);
}
function Ld() {
  return Ld = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Ld.apply(this, arguments);
}
function Cg(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function wg(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Cg(Object(r), !0).forEach(function(n) {
      uY(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Cg(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function uY(e, t, r) {
  return t = sY(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function sY(e) {
  var t = cY(e, "string");
  return jo(t) == "symbol" ? t : String(t);
}
function cY(e, t) {
  if (jo(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (jo(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var Og = {
  curveBasisClosed: gj,
  curveBasisOpen: mj,
  curveBasis: vj,
  curveBumpX: tj,
  curveBumpY: rj,
  curveLinearClosed: yj,
  curveLinear: vc,
  curveMonotoneX: bj,
  curveMonotoneY: xj,
  curveNatural: Cj,
  curveStep: wj,
  curveStepAfter: Sj,
  curveStepBefore: Oj
}, Tu = function(t) {
  return t.x === +t.x && t.y === +t.y;
}, ji = function(t) {
  return t.x;
}, Ri = function(t) {
  return t.y;
}, lY = function(t, r) {
  if (_e(t))
    return t;
  var n = "curve".concat(pc(t));
  return (n === "curveMonotone" || n === "curveBump") && r ? Og["".concat(n).concat(r === "vertical" ? "Y" : "X")] : Og[n] || vc;
}, fY = function(t) {
  var r = t.type, n = r === void 0 ? "linear" : r, a = t.points, i = a === void 0 ? [] : a, o = t.baseLine, u = t.layout, s = t.connectNulls, c = s === void 0 ? !1 : s, l = lY(n, u), f = c ? i.filter(function(v) {
    return Tu(v);
  }) : i, d;
  if (Array.isArray(o)) {
    var p = c ? o.filter(function(v) {
      return Tu(v);
    }) : o, h = f.map(function(v, g) {
      return wg(wg({}, v), {}, {
        base: p[g]
      });
    });
    return u === "vertical" ? d = xu().y(Ri).x1(ji).x0(function(v) {
      return v.base.x;
    }) : d = xu().x(ji).y1(Ri).y0(function(v) {
      return v.base.y;
    }), d.defined(Tu).curve(l), d(h);
  }
  return u === "vertical" && oe(o) ? d = xu().y(Ri).x1(ji).x0(o) : oe(o) ? d = xu().x(ji).y1(Ri).y0(o) : d = M3().x(ji).y(Ri), d.defined(Tu).curve(l), d(f);
}, Ji = function(t) {
  var r = t.className, n = t.points, a = t.path, i = t.pathRef;
  if ((!n || !n.length) && !a)
    return null;
  var o = n && n.length ? fY(t) : a;
  return /* @__PURE__ */ N.createElement("path", Ld({}, Ie(t, !1), es(t), {
    className: Ne("recharts-curve", r),
    d: o,
    ref: i
  }));
}, dY = Object.getOwnPropertyNames, pY = Object.getOwnPropertySymbols, hY = Object.prototype.hasOwnProperty;
function Sg(e, t) {
  return function(n, a, i) {
    return e(n, a, i) && t(n, a, i);
  };
}
function Mu(e) {
  return function(r, n, a) {
    if (!r || !n || typeof r != "object" || typeof n != "object")
      return e(r, n, a);
    var i = a.cache, o = i.get(r), u = i.get(n);
    if (o && u)
      return o === n && u === r;
    i.set(r, n), i.set(n, r);
    var s = e(r, n, a);
    return i.delete(r), i.delete(n), s;
  };
}
function Ag(e) {
  return dY(e).concat(pY(e));
}
var T5 = Object.hasOwn || function(e, t) {
  return hY.call(e, t);
};
function fi(e, t) {
  return e || t ? e === t : e === t || e !== e && t !== t;
}
var M5 = "_owner", Eg = Object.getOwnPropertyDescriptor, _g = Object.keys;
function vY(e, t, r) {
  var n = e.length;
  if (t.length !== n)
    return !1;
  for (; n-- > 0; )
    if (!r.equals(e[n], t[n], n, n, e, t, r))
      return !1;
  return !0;
}
function gY(e, t) {
  return fi(e.getTime(), t.getTime());
}
function Ig(e, t, r) {
  if (e.size !== t.size)
    return !1;
  for (var n = {}, a = e.entries(), i = 0, o, u; (o = a.next()) && !o.done; ) {
    for (var s = t.entries(), c = !1, l = 0; (u = s.next()) && !u.done; ) {
      var f = o.value, d = f[0], p = f[1], h = u.value, v = h[0], g = h[1];
      !c && !n[l] && (c = r.equals(d, v, i, l, e, t, r) && r.equals(p, g, d, v, e, t, r)) && (n[l] = !0), l++;
    }
    if (!c)
      return !1;
    i++;
  }
  return !0;
}
function mY(e, t, r) {
  var n = _g(e), a = n.length;
  if (_g(t).length !== a)
    return !1;
  for (var i; a-- > 0; )
    if (i = n[a], i === M5 && (e.$$typeof || t.$$typeof) && e.$$typeof !== t.$$typeof || !T5(t, i) || !r.equals(e[i], t[i], i, i, e, t, r))
      return !1;
  return !0;
}
function Ni(e, t, r) {
  var n = Ag(e), a = n.length;
  if (Ag(t).length !== a)
    return !1;
  for (var i, o, u; a-- > 0; )
    if (i = n[a], i === M5 && (e.$$typeof || t.$$typeof) && e.$$typeof !== t.$$typeof || !T5(t, i) || !r.equals(e[i], t[i], i, i, e, t, r) || (o = Eg(e, i), u = Eg(t, i), (o || u) && (!o || !u || o.configurable !== u.configurable || o.enumerable !== u.enumerable || o.writable !== u.writable)))
      return !1;
  return !0;
}
function yY(e, t) {
  return fi(e.valueOf(), t.valueOf());
}
function bY(e, t) {
  return e.source === t.source && e.flags === t.flags;
}
function Pg(e, t, r) {
  if (e.size !== t.size)
    return !1;
  for (var n = {}, a = e.values(), i, o; (i = a.next()) && !i.done; ) {
    for (var u = t.values(), s = !1, c = 0; (o = u.next()) && !o.done; )
      !s && !n[c] && (s = r.equals(i.value, o.value, i.value, o.value, e, t, r)) && (n[c] = !0), c++;
    if (!s)
      return !1;
  }
  return !0;
}
function xY(e, t) {
  var r = e.length;
  if (t.length !== r)
    return !1;
  for (; r-- > 0; )
    if (e[r] !== t[r])
      return !1;
  return !0;
}
var CY = "[object Arguments]", wY = "[object Boolean]", OY = "[object Date]", SY = "[object Map]", AY = "[object Number]", EY = "[object Object]", _Y = "[object RegExp]", IY = "[object Set]", PY = "[object String]", TY = Array.isArray, Tg = typeof ArrayBuffer == "function" && ArrayBuffer.isView ? ArrayBuffer.isView : null, Mg = Object.assign, MY = Object.prototype.toString.call.bind(Object.prototype.toString);
function jY(e) {
  var t = e.areArraysEqual, r = e.areDatesEqual, n = e.areMapsEqual, a = e.areObjectsEqual, i = e.arePrimitiveWrappersEqual, o = e.areRegExpsEqual, u = e.areSetsEqual, s = e.areTypedArraysEqual;
  return function(l, f, d) {
    if (l === f)
      return !0;
    if (l == null || f == null || typeof l != "object" || typeof f != "object")
      return l !== l && f !== f;
    var p = l.constructor;
    if (p !== f.constructor)
      return !1;
    if (p === Object)
      return a(l, f, d);
    if (TY(l))
      return t(l, f, d);
    if (Tg != null && Tg(l))
      return s(l, f, d);
    if (p === Date)
      return r(l, f, d);
    if (p === RegExp)
      return o(l, f, d);
    if (p === Map)
      return n(l, f, d);
    if (p === Set)
      return u(l, f, d);
    var h = MY(l);
    return h === OY ? r(l, f, d) : h === _Y ? o(l, f, d) : h === SY ? n(l, f, d) : h === IY ? u(l, f, d) : h === EY ? typeof l.then != "function" && typeof f.then != "function" && a(l, f, d) : h === CY ? a(l, f, d) : h === wY || h === AY || h === PY ? i(l, f, d) : !1;
  };
}
function RY(e) {
  var t = e.circular, r = e.createCustomConfig, n = e.strict, a = {
    areArraysEqual: n ? Ni : vY,
    areDatesEqual: gY,
    areMapsEqual: n ? Sg(Ig, Ni) : Ig,
    areObjectsEqual: n ? Ni : mY,
    arePrimitiveWrappersEqual: yY,
    areRegExpsEqual: bY,
    areSetsEqual: n ? Sg(Pg, Ni) : Pg,
    areTypedArraysEqual: n ? Ni : xY
  };
  if (r && (a = Mg({}, a, r(a))), t) {
    var i = Mu(a.areArraysEqual), o = Mu(a.areMapsEqual), u = Mu(a.areObjectsEqual), s = Mu(a.areSetsEqual);
    a = Mg({}, a, {
      areArraysEqual: i,
      areMapsEqual: o,
      areObjectsEqual: u,
      areSetsEqual: s
    });
  }
  return a;
}
function NY(e) {
  return function(t, r, n, a, i, o, u) {
    return e(t, r, u);
  };
}
function $Y(e) {
  var t = e.circular, r = e.comparator, n = e.createState, a = e.equals, i = e.strict;
  if (n)
    return function(s, c) {
      var l = n(), f = l.cache, d = f === void 0 ? t ? /* @__PURE__ */ new WeakMap() : void 0 : f, p = l.meta;
      return r(s, c, {
        cache: d,
        equals: a,
        meta: p,
        strict: i
      });
    };
  if (t)
    return function(s, c) {
      return r(s, c, {
        cache: /* @__PURE__ */ new WeakMap(),
        equals: a,
        meta: void 0,
        strict: i
      });
    };
  var o = {
    cache: void 0,
    equals: a,
    meta: void 0,
    strict: i
  };
  return function(s, c) {
    return r(s, c, o);
  };
}
var FY = En();
En({ strict: !0 });
En({ circular: !0 });
En({
  circular: !0,
  strict: !0
});
En({
  createInternalComparator: function() {
    return fi;
  }
});
En({
  strict: !0,
  createInternalComparator: function() {
    return fi;
  }
});
En({
  circular: !0,
  createInternalComparator: function() {
    return fi;
  }
});
En({
  circular: !0,
  createInternalComparator: function() {
    return fi;
  },
  strict: !0
});
function En(e) {
  e === void 0 && (e = {});
  var t = e.circular, r = t === void 0 ? !1 : t, n = e.createInternalComparator, a = e.createState, i = e.strict, o = i === void 0 ? !1 : i, u = RY(e), s = jY(u), c = n ? n(s) : NY(s);
  return $Y({ circular: r, comparator: s, createState: a, equals: c, strict: o });
}
function DY(e) {
  typeof requestAnimationFrame < "u" && requestAnimationFrame(e);
}
function jg(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, r = -1, n = function a(i) {
    r < 0 && (r = i), i - r > t ? (e(i), r = -1) : DY(a);
  };
  requestAnimationFrame(n);
}
function Bd(e) {
  "@babel/helpers - typeof";
  return Bd = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Bd(e);
}
function kY(e) {
  return WY(e) || VY(e) || BY(e) || LY();
}
function LY() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function BY(e, t) {
  if (e) {
    if (typeof e == "string") return Rg(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Rg(e, t);
  }
}
function Rg(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function VY(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function WY(e) {
  if (Array.isArray(e)) return e;
}
function GY() {
  var e = {}, t = function() {
    return null;
  }, r = !1, n = function a(i) {
    if (!r) {
      if (Array.isArray(i)) {
        if (!i.length)
          return;
        var o = i, u = kY(o), s = u[0], c = u.slice(1);
        if (typeof s == "number") {
          jg(a.bind(null, c), s);
          return;
        }
        a(s), jg(a.bind(null, c));
        return;
      }
      Bd(i) === "object" && (e = i, t(e)), typeof i == "function" && i();
    }
  };
  return {
    stop: function() {
      r = !0;
    },
    start: function(i) {
      r = !1, n(i);
    },
    subscribe: function(i) {
      return t = i, function() {
        t = function() {
          return null;
        };
      };
    }
  };
}
function Ro(e) {
  "@babel/helpers - typeof";
  return Ro = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ro(e);
}
function Ng(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function $g(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Ng(Object(r), !0).forEach(function(n) {
      j5(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Ng(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function j5(e, t, r) {
  return t = HY(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function HY(e) {
  var t = UY(e, "string");
  return Ro(t) === "symbol" ? t : String(t);
}
function UY(e, t) {
  if (Ro(e) !== "object" || e === null) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (Ro(n) !== "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var zY = function(t, r) {
  return [Object.keys(t), Object.keys(r)].reduce(function(n, a) {
    return n.filter(function(i) {
      return a.includes(i);
    });
  });
}, YY = function(t) {
  return t;
}, XY = function(t) {
  return t.replace(/([A-Z])/g, function(r) {
    return "-".concat(r.toLowerCase());
  });
}, Qi = function(t, r) {
  return Object.keys(r).reduce(function(n, a) {
    return $g($g({}, n), {}, j5({}, a, t(a, r[a])));
  }, {});
}, Fg = function(t, r, n) {
  return t.map(function(a) {
    return "".concat(XY(a), " ").concat(r, "ms ").concat(n);
  }).join(",");
}, ZY = process.env.NODE_ENV !== "production", Ms = function(t, r, n, a, i, o, u, s) {
  if (ZY && typeof console < "u" && console.warn && (r === void 0 && console.warn("LogUtils requires an error message argument"), !t))
    if (r === void 0)
      console.warn("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
    else {
      var c = [n, a, i, o, u, s], l = 0;
      console.warn(r.replace(/%s/g, function() {
        return c[l++];
      }));
    }
};
function KY(e, t) {
  return QY(e) || JY(e, t) || R5(e, t) || qY();
}
function qY() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function JY(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, a, i, o, u = [], s = !0, c = !1;
    try {
      if (i = (r = r.call(e)).next, t !== 0) for (; !(s = (n = i.call(r)).done) && (u.push(n.value), u.length !== t); s = !0) ;
    } catch (l) {
      c = !0, a = l;
    } finally {
      try {
        if (!s && r.return != null && (o = r.return(), Object(o) !== o)) return;
      } finally {
        if (c) throw a;
      }
    }
    return u;
  }
}
function QY(e) {
  if (Array.isArray(e)) return e;
}
function eX(e) {
  return nX(e) || rX(e) || R5(e) || tX();
}
function tX() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function R5(e, t) {
  if (e) {
    if (typeof e == "string") return Vd(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Vd(e, t);
  }
}
function rX(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function nX(e) {
  if (Array.isArray(e)) return Vd(e);
}
function Vd(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
var js = 1e-4, N5 = function(t, r) {
  return [0, 3 * t, 3 * r - 6 * t, 3 * t - 3 * r + 1];
}, $5 = function(t, r) {
  return t.map(function(n, a) {
    return n * Math.pow(r, a);
  }).reduce(function(n, a) {
    return n + a;
  });
}, Dg = function(t, r) {
  return function(n) {
    var a = N5(t, r);
    return $5(a, n);
  };
}, aX = function(t, r) {
  return function(n) {
    var a = N5(t, r), i = [].concat(eX(a.map(function(o, u) {
      return o * u;
    }).slice(1)), [0]);
    return $5(i, n);
  };
}, kg = function() {
  for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++)
    r[n] = arguments[n];
  var a = r[0], i = r[1], o = r[2], u = r[3];
  if (r.length === 1)
    switch (r[0]) {
      case "linear":
        a = 0, i = 0, o = 1, u = 1;
        break;
      case "ease":
        a = 0.25, i = 0.1, o = 0.25, u = 1;
        break;
      case "ease-in":
        a = 0.42, i = 0, o = 1, u = 1;
        break;
      case "ease-out":
        a = 0.42, i = 0, o = 0.58, u = 1;
        break;
      case "ease-in-out":
        a = 0, i = 0, o = 0.58, u = 1;
        break;
      default: {
        var s = r[0].split("(");
        if (s[0] === "cubic-bezier" && s[1].split(")")[0].split(",").length === 4) {
          var c = s[1].split(")")[0].split(",").map(function(g) {
            return parseFloat(g);
          }), l = KY(c, 4);
          a = l[0], i = l[1], o = l[2], u = l[3];
        } else
          Ms(!1, "[configBezier]: arguments should be one of oneOf 'linear', 'ease', 'ease-in', 'ease-out', 'ease-in-out','cubic-bezier(x1,y1,x2,y2)', instead received %s", r);
      }
    }
  Ms([a, o, i, u].every(function(g) {
    return typeof g == "number" && g >= 0 && g <= 1;
  }), "[configBezier]: arguments should be x1, y1, x2, y2 of [0, 1] instead received %s", r);
  var f = Dg(a, o), d = Dg(i, u), p = aX(a, o), h = function(b) {
    return b > 1 ? 1 : b < 0 ? 0 : b;
  }, v = function(b) {
    for (var x = b > 1 ? 1 : b, w = x, y = 0; y < 8; ++y) {
      var m = f(w) - x, C = p(w);
      if (Math.abs(m - x) < js || C < js)
        return d(w);
      w = h(w - m / C);
    }
    return d(w);
  };
  return v.isStepper = !1, v;
}, iX = function() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = t.stiff, n = r === void 0 ? 100 : r, a = t.damping, i = a === void 0 ? 8 : a, o = t.dt, u = o === void 0 ? 17 : o, s = function(l, f, d) {
    var p = -(l - f) * n, h = d * i, v = d + (p - h) * u / 1e3, g = d * u / 1e3 + l;
    return Math.abs(g - f) < js && Math.abs(v) < js ? [f, 0] : [g, v];
  };
  return s.isStepper = !0, s.dt = u, s;
}, oX = function() {
  for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++)
    r[n] = arguments[n];
  var a = r[0];
  if (typeof a == "string")
    switch (a) {
      case "ease":
      case "ease-in-out":
      case "ease-out":
      case "ease-in":
      case "linear":
        return kg(a);
      case "spring":
        return iX();
      default:
        if (a.split("(")[0] === "cubic-bezier")
          return kg(a);
        Ms(!1, "[configEasing]: first argument should be one of 'ease', 'ease-in', 'ease-out', 'ease-in-out','cubic-bezier(x1,y1,x2,y2)', 'linear' and 'spring', instead  received %s", r);
    }
  return typeof a == "function" ? a : (Ms(!1, "[configEasing]: first argument type should be function or string, instead received %s", r), null);
};
function No(e) {
  "@babel/helpers - typeof";
  return No = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, No(e);
}
function Lg(e) {
  return cX(e) || sX(e) || F5(e) || uX();
}
function uX() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function sX(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function cX(e) {
  if (Array.isArray(e)) return Gd(e);
}
function Bg(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function At(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Bg(Object(r), !0).forEach(function(n) {
      Wd(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Bg(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Wd(e, t, r) {
  return t = lX(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function lX(e) {
  var t = fX(e, "string");
  return No(t) === "symbol" ? t : String(t);
}
function fX(e, t) {
  if (No(e) !== "object" || e === null) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (No(n) !== "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function dX(e, t) {
  return vX(e) || hX(e, t) || F5(e, t) || pX();
}
function pX() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function F5(e, t) {
  if (e) {
    if (typeof e == "string") return Gd(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Gd(e, t);
  }
}
function Gd(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function hX(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, a, i, o, u = [], s = !0, c = !1;
    try {
      if (i = (r = r.call(e)).next, t !== 0) for (; !(s = (n = i.call(r)).done) && (u.push(n.value), u.length !== t); s = !0) ;
    } catch (l) {
      c = !0, a = l;
    } finally {
      try {
        if (!s && r.return != null && (o = r.return(), Object(o) !== o)) return;
      } finally {
        if (c) throw a;
      }
    }
    return u;
  }
}
function vX(e) {
  if (Array.isArray(e)) return e;
}
var Rs = function(t, r, n) {
  return t + (r - t) * n;
}, Hd = function(t) {
  var r = t.from, n = t.to;
  return r !== n;
}, gX = function e(t, r, n) {
  var a = Qi(function(i, o) {
    if (Hd(o)) {
      var u = t(o.from, o.to, o.velocity), s = dX(u, 2), c = s[0], l = s[1];
      return At(At({}, o), {}, {
        from: c,
        velocity: l
      });
    }
    return o;
  }, r);
  return n < 1 ? Qi(function(i, o) {
    return Hd(o) ? At(At({}, o), {}, {
      velocity: Rs(o.velocity, a[i].velocity, n),
      from: Rs(o.from, a[i].from, n)
    }) : o;
  }, r) : e(t, a, n - 1);
};
const mX = function(e, t, r, n, a) {
  var i = zY(e, t), o = i.reduce(function(g, b) {
    return At(At({}, g), {}, Wd({}, b, [e[b], t[b]]));
  }, {}), u = i.reduce(function(g, b) {
    return At(At({}, g), {}, Wd({}, b, {
      from: e[b],
      velocity: 0,
      to: t[b]
    }));
  }, {}), s = -1, c, l, f = function() {
    return null;
  }, d = function() {
    return Qi(function(b, x) {
      return x.from;
    }, u);
  }, p = function() {
    return !Object.values(u).filter(Hd).length;
  }, h = function(b) {
    c || (c = b);
    var x = b - c, w = x / r.dt;
    u = gX(r, u, w), a(At(At(At({}, e), t), d())), c = b, p() || (s = requestAnimationFrame(f));
  }, v = function(b) {
    l || (l = b);
    var x = (b - l) / n, w = Qi(function(m, C) {
      return Rs.apply(void 0, Lg(C).concat([r(x)]));
    }, o);
    if (a(At(At(At({}, e), t), w)), x < 1)
      s = requestAnimationFrame(f);
    else {
      var y = Qi(function(m, C) {
        return Rs.apply(void 0, Lg(C).concat([r(1)]));
      }, o);
      a(At(At(At({}, e), t), y));
    }
  };
  return f = r.isStepper ? h : v, function() {
    return requestAnimationFrame(f), function() {
      cancelAnimationFrame(s);
    };
  };
};
function La(e) {
  "@babel/helpers - typeof";
  return La = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, La(e);
}
var yX = ["children", "begin", "duration", "attributeName", "easing", "isActive", "steps", "from", "to", "canBegin", "onAnimationEnd", "shouldReAnimate", "onAnimationReStart"];
function bX(e, t) {
  if (e == null) return {};
  var r = xX(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function xX(e, t) {
  if (e == null) return {};
  var r = {}, n = Object.keys(e), a, i;
  for (i = 0; i < n.length; i++)
    a = n[i], !(t.indexOf(a) >= 0) && (r[a] = e[a]);
  return r;
}
function nf(e) {
  return SX(e) || OX(e) || wX(e) || CX();
}
function CX() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function wX(e, t) {
  if (e) {
    if (typeof e == "string") return Ud(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Ud(e, t);
  }
}
function OX(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function SX(e) {
  if (Array.isArray(e)) return Ud(e);
}
function Ud(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function Vg(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function hr(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Vg(Object(r), !0).forEach(function(n) {
      Bi(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Vg(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Bi(e, t, r) {
  return t = D5(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function AX(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function EX(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, D5(n.key), n);
  }
}
function _X(e, t, r) {
  return t && EX(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function D5(e) {
  var t = IX(e, "string");
  return La(t) === "symbol" ? t : String(t);
}
function IX(e, t) {
  if (La(e) !== "object" || e === null) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (La(n) !== "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function PX(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && zd(e, t);
}
function zd(e, t) {
  return zd = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, zd(e, t);
}
function TX(e) {
  var t = MX();
  return function() {
    var n = Ns(e), a;
    if (t) {
      var i = Ns(this).constructor;
      a = Reflect.construct(n, arguments, i);
    } else
      a = n.apply(this, arguments);
    return Yd(this, a);
  };
}
function Yd(e, t) {
  if (t && (La(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Xd(e);
}
function Xd(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function MX() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Ns(e) {
  return Ns = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Ns(e);
}
var Jr = /* @__PURE__ */ function(e) {
  PX(r, e);
  var t = TX(r);
  function r(n, a) {
    var i;
    AX(this, r), i = t.call(this, n, a);
    var o = i.props, u = o.isActive, s = o.attributeName, c = o.from, l = o.to, f = o.steps, d = o.children, p = o.duration;
    if (i.handleStyleChange = i.handleStyleChange.bind(Xd(i)), i.changeStyle = i.changeStyle.bind(Xd(i)), !u || p <= 0)
      return i.state = {
        style: {}
      }, typeof d == "function" && (i.state = {
        style: l
      }), Yd(i);
    if (f && f.length)
      i.state = {
        style: f[0].style
      };
    else if (c) {
      if (typeof d == "function")
        return i.state = {
          style: c
        }, Yd(i);
      i.state = {
        style: s ? Bi({}, s, c) : c
      };
    } else
      i.state = {
        style: {}
      };
    return i;
  }
  return _X(r, [{
    key: "componentDidMount",
    value: function() {
      var a = this.props, i = a.isActive, o = a.canBegin;
      this.mounted = !0, !(!i || !o) && this.runAnimation(this.props);
    }
  }, {
    key: "componentDidUpdate",
    value: function(a) {
      var i = this.props, o = i.isActive, u = i.canBegin, s = i.attributeName, c = i.shouldReAnimate, l = i.to, f = i.from, d = this.state.style;
      if (u) {
        if (!o) {
          var p = {
            style: s ? Bi({}, s, l) : l
          };
          this.state && d && (s && d[s] !== l || !s && d !== l) && this.setState(p);
          return;
        }
        if (!(FY(a.to, l) && a.canBegin && a.isActive)) {
          var h = !a.canBegin || !a.isActive;
          this.manager && this.manager.stop(), this.stopJSAnimation && this.stopJSAnimation();
          var v = h || c ? f : a.to;
          if (this.state && d) {
            var g = {
              style: s ? Bi({}, s, v) : v
            };
            (s && d[s] !== v || !s && d !== v) && this.setState(g);
          }
          this.runAnimation(hr(hr({}, this.props), {}, {
            from: v,
            begin: 0
          }));
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.mounted = !1;
      var a = this.props.onAnimationEnd;
      this.unSubscribe && this.unSubscribe(), this.manager && (this.manager.stop(), this.manager = null), this.stopJSAnimation && this.stopJSAnimation(), a && a();
    }
  }, {
    key: "handleStyleChange",
    value: function(a) {
      this.changeStyle(a);
    }
  }, {
    key: "changeStyle",
    value: function(a) {
      this.mounted && this.setState({
        style: a
      });
    }
  }, {
    key: "runJSAnimation",
    value: function(a) {
      var i = this, o = a.from, u = a.to, s = a.duration, c = a.easing, l = a.begin, f = a.onAnimationEnd, d = a.onAnimationStart, p = mX(o, u, oX(c), s, this.changeStyle), h = function() {
        i.stopJSAnimation = p();
      };
      this.manager.start([d, l, h, s, f]);
    }
  }, {
    key: "runStepAnimation",
    value: function(a) {
      var i = this, o = a.steps, u = a.begin, s = a.onAnimationStart, c = o[0], l = c.style, f = c.duration, d = f === void 0 ? 0 : f, p = function(v, g, b) {
        if (b === 0)
          return v;
        var x = g.duration, w = g.easing, y = w === void 0 ? "ease" : w, m = g.style, C = g.properties, O = g.onAnimationEnd, S = b > 0 ? o[b - 1] : g, A = C || Object.keys(m);
        if (typeof y == "function" || y === "spring")
          return [].concat(nf(v), [i.runJSAnimation.bind(i, {
            from: S.style,
            to: m,
            duration: x,
            easing: y
          }), x]);
        var P = Fg(A, x, y), T = hr(hr(hr({}, S.style), m), {}, {
          transition: P
        });
        return [].concat(nf(v), [T, x, O]).filter(YY);
      };
      return this.manager.start([s].concat(nf(o.reduce(p, [l, Math.max(d, u)])), [a.onAnimationEnd]));
    }
  }, {
    key: "runAnimation",
    value: function(a) {
      this.manager || (this.manager = GY());
      var i = a.begin, o = a.duration, u = a.attributeName, s = a.to, c = a.easing, l = a.onAnimationStart, f = a.onAnimationEnd, d = a.steps, p = a.children, h = this.manager;
      if (this.unSubscribe = h.subscribe(this.handleStyleChange), typeof c == "function" || typeof p == "function" || c === "spring") {
        this.runJSAnimation(a);
        return;
      }
      if (d.length > 1) {
        this.runStepAnimation(a);
        return;
      }
      var v = u ? Bi({}, u, s) : s, g = Fg(Object.keys(v), o, c);
      h.start([l, i, hr(hr({}, v), {}, {
        transition: g
      }), o, f]);
    }
  }, {
    key: "render",
    value: function() {
      var a = this.props, i = a.children;
      a.begin;
      var o = a.duration;
      a.attributeName, a.easing;
      var u = a.isActive;
      a.steps, a.from, a.to, a.canBegin, a.onAnimationEnd, a.shouldReAnimate, a.onAnimationReStart;
      var s = bX(a, yX), c = Gn.count(i), l = this.state.style;
      if (typeof i == "function")
        return i(l);
      if (!u || c === 0 || o <= 0)
        return i;
      var f = function(p) {
        var h = p.props, v = h.style, g = v === void 0 ? {} : v, b = h.className, x = /* @__PURE__ */ vt(p, hr(hr({}, s), {}, {
          style: hr(hr({}, g), l),
          className: b
        }));
        return x;
      };
      return c === 1 ? f(Gn.only(i)) : /* @__PURE__ */ N.createElement("div", null, Gn.map(i, function(d) {
        return f(d);
      }));
    }
  }]), r;
}(xn);
Jr.displayName = "Animate";
Jr.defaultProps = {
  begin: 0,
  duration: 1e3,
  from: "",
  to: "",
  attributeName: "",
  easing: "ease",
  isActive: !0,
  canBegin: !0,
  steps: [],
  onAnimationEnd: function() {
  },
  onAnimationStart: function() {
  }
};
Jr.propTypes = {
  from: ce.oneOfType([ce.object, ce.string]),
  to: ce.oneOfType([ce.object, ce.string]),
  attributeName: ce.string,
  // animation duration
  duration: ce.number,
  begin: ce.number,
  easing: ce.oneOfType([ce.string, ce.func]),
  steps: ce.arrayOf(ce.shape({
    duration: ce.number.isRequired,
    style: ce.object.isRequired,
    easing: ce.oneOfType([ce.oneOf(["ease", "ease-in", "ease-out", "ease-in-out", "linear"]), ce.func]),
    // transition css properties(dash case), optional
    properties: ce.arrayOf("string"),
    onAnimationEnd: ce.func
  })),
  children: ce.oneOfType([ce.node, ce.func]),
  isActive: ce.bool,
  canBegin: ce.bool,
  onAnimationEnd: ce.func,
  // decide if it should reanimate with initial from style when props change
  shouldReAnimate: ce.bool,
  onAnimationStart: ce.func,
  onAnimationReStart: ce.func
};
ce.object, ce.object, ce.object, ce.element;
ce.object, ce.object, ce.object, ce.oneOfType([ce.array, ce.element]), ce.any;
function $o(e) {
  "@babel/helpers - typeof";
  return $o = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, $o(e);
}
function $s() {
  return $s = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, $s.apply(this, arguments);
}
function jX(e, t) {
  return FX(e) || $X(e, t) || NX(e, t) || RX();
}
function RX() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function NX(e, t) {
  if (e) {
    if (typeof e == "string") return Wg(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Wg(e, t);
  }
}
function Wg(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function $X(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, a, i, o, u = [], s = !0, c = !1;
    try {
      if (i = (r = r.call(e)).next, t !== 0) for (; !(s = (n = i.call(r)).done) && (u.push(n.value), u.length !== t); s = !0) ;
    } catch (l) {
      c = !0, a = l;
    } finally {
      try {
        if (!s && r.return != null && (o = r.return(), Object(o) !== o)) return;
      } finally {
        if (c) throw a;
      }
    }
    return u;
  }
}
function FX(e) {
  if (Array.isArray(e)) return e;
}
function Gg(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Hg(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Gg(Object(r), !0).forEach(function(n) {
      DX(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Gg(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function DX(e, t, r) {
  return t = kX(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function kX(e) {
  var t = LX(e, "string");
  return $o(t) == "symbol" ? t : String(t);
}
function LX(e, t) {
  if ($o(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if ($o(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var Ug = function(t, r, n, a, i) {
  var o = Math.min(Math.abs(n) / 2, Math.abs(a) / 2), u = a >= 0 ? 1 : -1, s = n >= 0 ? 1 : -1, c = a >= 0 && n >= 0 || a < 0 && n < 0 ? 1 : 0, l;
  if (o > 0 && i instanceof Array) {
    for (var f = [0, 0, 0, 0], d = 0, p = 4; d < p; d++)
      f[d] = i[d] > o ? o : i[d];
    l = "M".concat(t, ",").concat(r + u * f[0]), f[0] > 0 && (l += "A ".concat(f[0], ",").concat(f[0], ",0,0,").concat(c, ",").concat(t + s * f[0], ",").concat(r)), l += "L ".concat(t + n - s * f[1], ",").concat(r), f[1] > 0 && (l += "A ".concat(f[1], ",").concat(f[1], ",0,0,").concat(c, `,
        `).concat(t + n, ",").concat(r + u * f[1])), l += "L ".concat(t + n, ",").concat(r + a - u * f[2]), f[2] > 0 && (l += "A ".concat(f[2], ",").concat(f[2], ",0,0,").concat(c, `,
        `).concat(t + n - s * f[2], ",").concat(r + a)), l += "L ".concat(t + s * f[3], ",").concat(r + a), f[3] > 0 && (l += "A ".concat(f[3], ",").concat(f[3], ",0,0,").concat(c, `,
        `).concat(t, ",").concat(r + a - u * f[3])), l += "Z";
  } else if (o > 0 && i === +i && i > 0) {
    var h = Math.min(o, i);
    l = "M ".concat(t, ",").concat(r + u * h, `
            A `).concat(h, ",").concat(h, ",0,0,").concat(c, ",").concat(t + s * h, ",").concat(r, `
            L `).concat(t + n - s * h, ",").concat(r, `
            A `).concat(h, ",").concat(h, ",0,0,").concat(c, ",").concat(t + n, ",").concat(r + u * h, `
            L `).concat(t + n, ",").concat(r + a - u * h, `
            A `).concat(h, ",").concat(h, ",0,0,").concat(c, ",").concat(t + n - s * h, ",").concat(r + a, `
            L `).concat(t + s * h, ",").concat(r + a, `
            A `).concat(h, ",").concat(h, ",0,0,").concat(c, ",").concat(t, ",").concat(r + a - u * h, " Z");
  } else
    l = "M ".concat(t, ",").concat(r, " h ").concat(n, " v ").concat(a, " h ").concat(-n, " Z");
  return l;
}, BX = function(t, r) {
  if (!t || !r)
    return !1;
  var n = t.x, a = t.y, i = r.x, o = r.y, u = r.width, s = r.height;
  if (Math.abs(u) > 0 && Math.abs(s) > 0) {
    var c = Math.min(i, i + u), l = Math.max(i, i + u), f = Math.min(o, o + s), d = Math.max(o, o + s);
    return n >= c && n <= l && a >= f && a <= d;
  }
  return !1;
}, VX = {
  x: 0,
  y: 0,
  width: 0,
  height: 0,
  // The radius of border
  // The radius of four corners when radius is a number
  // The radius of left-top, right-top, right-bottom, left-bottom when radius is an array
  radius: 0,
  isAnimationActive: !1,
  isUpdateAnimationActive: !1,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: "ease"
}, Bp = function(t) {
  var r = Hg(Hg({}, VX), t), n = mr(), a = gn(-1), i = jX(a, 2), o = i[0], u = i[1];
  Xa(function() {
    if (n.current && n.current.getTotalLength)
      try {
        var y = n.current.getTotalLength();
        y && u(y);
      } catch {
      }
  }, []);
  var s = r.x, c = r.y, l = r.width, f = r.height, d = r.radius, p = r.className, h = r.animationEasing, v = r.animationDuration, g = r.animationBegin, b = r.isAnimationActive, x = r.isUpdateAnimationActive;
  if (s !== +s || c !== +c || l !== +l || f !== +f || l === 0 || f === 0)
    return null;
  var w = Ne("recharts-rectangle", p);
  return x ? /* @__PURE__ */ N.createElement(Jr, {
    canBegin: o > 0,
    from: {
      width: l,
      height: f,
      x: s,
      y: c
    },
    to: {
      width: l,
      height: f,
      x: s,
      y: c
    },
    duration: v,
    animationEasing: h,
    isActive: x
  }, function(y) {
    var m = y.width, C = y.height, O = y.x, S = y.y;
    return /* @__PURE__ */ N.createElement(Jr, {
      canBegin: o > 0,
      from: "0px ".concat(o === -1 ? 1 : o, "px"),
      to: "".concat(o, "px 0px"),
      attributeName: "strokeDasharray",
      begin: g,
      duration: v,
      isActive: b,
      easing: h
    }, /* @__PURE__ */ N.createElement("path", $s({}, Ie(r, !0), {
      className: w,
      d: Ug(O, S, m, C, d),
      ref: n
    })));
  }) : /* @__PURE__ */ N.createElement("path", $s({}, Ie(r, !0), {
    className: w,
    d: Ug(s, c, l, f, d)
  }));
};
function Zd() {
  return Zd = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Zd.apply(this, arguments);
}
var Vp = function(t) {
  var r = t.cx, n = t.cy, a = t.r, i = t.className, o = Ne("recharts-dot", i);
  return r === +r && n === +n && a === +a ? /* @__PURE__ */ N.createElement("circle", Zd({}, Ie(t, !1), es(t), {
    className: o,
    cx: r,
    cy: n,
    r: a
  })) : null;
};
function Fo(e) {
  "@babel/helpers - typeof";
  return Fo = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Fo(e);
}
var WX = ["x", "y", "top", "left", "width", "height", "className"];
function Kd() {
  return Kd = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Kd.apply(this, arguments);
}
function zg(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function GX(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? zg(Object(r), !0).forEach(function(n) {
      HX(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : zg(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function HX(e, t, r) {
  return t = UX(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function UX(e) {
  var t = zX(e, "string");
  return Fo(t) == "symbol" ? t : String(t);
}
function zX(e, t) {
  if (Fo(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (Fo(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function YX(e, t) {
  if (e == null) return {};
  var r = XX(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function XX(e, t) {
  if (e == null) return {};
  var r = {}, n = Object.keys(e), a, i;
  for (i = 0; i < n.length; i++)
    a = n[i], !(t.indexOf(a) >= 0) && (r[a] = e[a]);
  return r;
}
var ZX = function(t, r, n, a, i, o) {
  return "M".concat(t, ",").concat(i, "v").concat(a, "M").concat(o, ",").concat(r, "h").concat(n);
}, KX = function(t) {
  var r = t.x, n = r === void 0 ? 0 : r, a = t.y, i = a === void 0 ? 0 : a, o = t.top, u = o === void 0 ? 0 : o, s = t.left, c = s === void 0 ? 0 : s, l = t.width, f = l === void 0 ? 0 : l, d = t.height, p = d === void 0 ? 0 : d, h = t.className, v = YX(t, WX), g = GX({
    x: n,
    y: i,
    top: u,
    left: c,
    width: f,
    height: p
  }, v);
  return !oe(n) || !oe(i) || !oe(f) || !oe(p) || !oe(u) || !oe(c) ? null : /* @__PURE__ */ N.createElement("path", Kd({}, Ie(g, !0), {
    className: Ne("recharts-cross", h),
    d: ZX(n, i, f, p, u, c)
  }));
}, qX = t4, JX = qX(Object.getPrototypeOf, Object), QX = JX, eZ = en, tZ = QX, rZ = tn, nZ = "[object Object]", aZ = Function.prototype, iZ = Object.prototype, k5 = aZ.toString, oZ = iZ.hasOwnProperty, uZ = k5.call(Object);
function sZ(e) {
  if (!rZ(e) || eZ(e) != nZ)
    return !1;
  var t = tZ(e);
  if (t === null)
    return !0;
  var r = oZ.call(t, "constructor") && t.constructor;
  return typeof r == "function" && r instanceof r && k5.call(r) == uZ;
}
var cZ = sZ;
const lZ = /* @__PURE__ */ Fe(cZ);
var fZ = en, dZ = tn, pZ = "[object Boolean]";
function hZ(e) {
  return e === !0 || e === !1 || dZ(e) && fZ(e) == pZ;
}
var vZ = hZ;
const gZ = /* @__PURE__ */ Fe(vZ);
function Do(e) {
  "@babel/helpers - typeof";
  return Do = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Do(e);
}
function Fs() {
  return Fs = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Fs.apply(this, arguments);
}
function mZ(e, t) {
  return CZ(e) || xZ(e, t) || bZ(e, t) || yZ();
}
function yZ() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function bZ(e, t) {
  if (e) {
    if (typeof e == "string") return Yg(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Yg(e, t);
  }
}
function Yg(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function xZ(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, a, i, o, u = [], s = !0, c = !1;
    try {
      if (i = (r = r.call(e)).next, t !== 0) for (; !(s = (n = i.call(r)).done) && (u.push(n.value), u.length !== t); s = !0) ;
    } catch (l) {
      c = !0, a = l;
    } finally {
      try {
        if (!s && r.return != null && (o = r.return(), Object(o) !== o)) return;
      } finally {
        if (c) throw a;
      }
    }
    return u;
  }
}
function CZ(e) {
  if (Array.isArray(e)) return e;
}
function Xg(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Zg(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Xg(Object(r), !0).forEach(function(n) {
      wZ(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Xg(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function wZ(e, t, r) {
  return t = OZ(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function OZ(e) {
  var t = SZ(e, "string");
  return Do(t) == "symbol" ? t : String(t);
}
function SZ(e, t) {
  if (Do(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (Do(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var Kg = function(t, r, n, a, i) {
  var o = n - a, u;
  return u = "M ".concat(t, ",").concat(r), u += "L ".concat(t + n, ",").concat(r), u += "L ".concat(t + n - o / 2, ",").concat(r + i), u += "L ".concat(t + n - o / 2 - a, ",").concat(r + i), u += "L ".concat(t, ",").concat(r, " Z"), u;
}, AZ = {
  x: 0,
  y: 0,
  upperWidth: 0,
  lowerWidth: 0,
  height: 0,
  isUpdateAnimationActive: !1,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: "ease"
}, EZ = function(t) {
  var r = Zg(Zg({}, AZ), t), n = mr(), a = gn(-1), i = mZ(a, 2), o = i[0], u = i[1];
  Xa(function() {
    if (n.current && n.current.getTotalLength)
      try {
        var w = n.current.getTotalLength();
        w && u(w);
      } catch {
      }
  }, []);
  var s = r.x, c = r.y, l = r.upperWidth, f = r.lowerWidth, d = r.height, p = r.className, h = r.animationEasing, v = r.animationDuration, g = r.animationBegin, b = r.isUpdateAnimationActive;
  if (s !== +s || c !== +c || l !== +l || f !== +f || d !== +d || l === 0 && f === 0 || d === 0)
    return null;
  var x = Ne("recharts-trapezoid", p);
  return b ? /* @__PURE__ */ N.createElement(Jr, {
    canBegin: o > 0,
    from: {
      upperWidth: 0,
      lowerWidth: 0,
      height: d,
      x: s,
      y: c
    },
    to: {
      upperWidth: l,
      lowerWidth: f,
      height: d,
      x: s,
      y: c
    },
    duration: v,
    animationEasing: h,
    isActive: b
  }, function(w) {
    var y = w.upperWidth, m = w.lowerWidth, C = w.height, O = w.x, S = w.y;
    return /* @__PURE__ */ N.createElement(Jr, {
      canBegin: o > 0,
      from: "0px ".concat(o === -1 ? 1 : o, "px"),
      to: "".concat(o, "px 0px"),
      attributeName: "strokeDasharray",
      begin: g,
      duration: v,
      easing: h
    }, /* @__PURE__ */ N.createElement("path", Fs({}, Ie(r, !0), {
      className: x,
      d: Kg(O, S, y, m, C),
      ref: n
    })));
  }) : /* @__PURE__ */ N.createElement("g", null, /* @__PURE__ */ N.createElement("path", Fs({}, Ie(r, !0), {
    className: x,
    d: Kg(s, c, l, f, d)
  })));
}, _Z = ["option", "shapeType", "propTransformer", "activeClassName", "isActive"];
function ko(e) {
  "@babel/helpers - typeof";
  return ko = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ko(e);
}
function IZ(e, t) {
  if (e == null) return {};
  var r = PZ(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function PZ(e, t) {
  if (e == null) return {};
  var r = {}, n = Object.keys(e), a, i;
  for (i = 0; i < n.length; i++)
    a = n[i], !(t.indexOf(a) >= 0) && (r[a] = e[a]);
  return r;
}
function qg(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Ds(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? qg(Object(r), !0).forEach(function(n) {
      TZ(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : qg(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function TZ(e, t, r) {
  return t = MZ(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function MZ(e) {
  var t = jZ(e, "string");
  return ko(t) == "symbol" ? t : String(t);
}
function jZ(e, t) {
  if (ko(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (ko(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function RZ(e, t) {
  return Ds(Ds({}, t), e);
}
function NZ(e, t) {
  return e === "symbols";
}
function Jg(e) {
  var t = e.shapeType, r = e.elementProps;
  switch (t) {
    case "rectangle":
      return /* @__PURE__ */ N.createElement(Bp, r);
    case "trapezoid":
      return /* @__PURE__ */ N.createElement(EZ, r);
    case "sector":
      return /* @__PURE__ */ N.createElement(P5, r);
    case "symbols":
      if (NZ(t))
        return /* @__PURE__ */ N.createElement(ip, r);
      break;
    default:
      return null;
  }
}
function $Z(e) {
  return /* @__PURE__ */ _r(e) ? e.props : e;
}
function FZ(e) {
  var t = e.option, r = e.shapeType, n = e.propTransformer, a = n === void 0 ? RZ : n, i = e.activeClassName, o = i === void 0 ? "recharts-active-shape" : i, u = e.isActive, s = IZ(e, _Z), c;
  if (/* @__PURE__ */ _r(t))
    c = /* @__PURE__ */ vt(t, Ds(Ds({}, s), $Z(t)));
  else if (_e(t))
    c = t(s);
  else if (lZ(t) && !gZ(t)) {
    var l = a(t, s);
    c = /* @__PURE__ */ N.createElement(Jg, {
      shapeType: r,
      elementProps: l
    });
  } else {
    var f = s;
    c = /* @__PURE__ */ N.createElement(Jg, {
      shapeType: r,
      elementProps: f
    });
  }
  return u ? /* @__PURE__ */ N.createElement(ut, {
    className: o
  }, c) : c;
}
function Tc(e, t) {
  return t != null && "trapezoids" in e.props;
}
function Mc(e, t) {
  return t != null && "sectors" in e.props;
}
function Lo(e, t) {
  return t != null && "points" in e.props;
}
function DZ(e, t) {
  var r, n, a = e.x === (t == null || (r = t.labelViewBox) === null || r === void 0 ? void 0 : r.x) || e.x === t.x, i = e.y === (t == null || (n = t.labelViewBox) === null || n === void 0 ? void 0 : n.y) || e.y === t.y;
  return a && i;
}
function kZ(e, t) {
  var r = e.endAngle === t.endAngle, n = e.startAngle === t.startAngle;
  return r && n;
}
function LZ(e, t) {
  var r = e.x === t.x, n = e.y === t.y, a = e.z === t.z;
  return r && n && a;
}
function BZ(e, t) {
  var r;
  return Tc(e, t) ? r = DZ : Mc(e, t) ? r = kZ : Lo(e, t) && (r = LZ), r;
}
function VZ(e, t) {
  var r;
  return Tc(e, t) ? r = "trapezoids" : Mc(e, t) ? r = "sectors" : Lo(e, t) && (r = "points"), r;
}
function WZ(e, t) {
  if (Tc(e, t)) {
    var r;
    return (r = t.tooltipPayload) === null || r === void 0 || (r = r[0]) === null || r === void 0 || (r = r.payload) === null || r === void 0 ? void 0 : r.payload;
  }
  if (Mc(e, t)) {
    var n;
    return (n = t.tooltipPayload) === null || n === void 0 || (n = n[0]) === null || n === void 0 || (n = n.payload) === null || n === void 0 ? void 0 : n.payload;
  }
  return Lo(e, t) ? t.payload : {};
}
function GZ(e) {
  var t = e.activeTooltipItem, r = e.graphicalItem, n = e.itemData, a = VZ(r, t), i = WZ(r, t), o = n.filter(function(s, c) {
    var l = wo(i, s), f = r.props[a].filter(function(h) {
      var v = BZ(r, t);
      return v(h, t);
    }), d = r.props[a].indexOf(f[f.length - 1]), p = c === d;
    return l && p;
  }), u = n.indexOf(o[o.length - 1]);
  return u;
}
var HZ = Math.ceil, UZ = Math.max;
function zZ(e, t, r, n) {
  for (var a = -1, i = UZ(HZ((t - e) / (r || 1)), 0), o = Array(i); i--; )
    o[n ? i : ++a] = e, e += r;
  return o;
}
var YZ = zZ, XZ = C4, Qg = 1 / 0, ZZ = 17976931348623157e292;
function KZ(e) {
  if (!e)
    return e === 0 ? e : 0;
  if (e = XZ(e), e === Qg || e === -Qg) {
    var t = e < 0 ? -1 : 1;
    return t * ZZ;
  }
  return e === e ? e : 0;
}
var L5 = KZ, qZ = YZ, JZ = bc, af = L5;
function QZ(e) {
  return function(t, r, n) {
    return n && typeof n != "number" && JZ(t, r, n) && (r = n = void 0), t = af(t), r === void 0 ? (r = t, t = 0) : r = af(r), n = n === void 0 ? t < r ? 1 : -1 : af(n), qZ(t, r, n, e);
  };
}
var eK = QZ, tK = eK, rK = tK(), nK = rK;
const ks = /* @__PURE__ */ Fe(nK);
function Bo(e) {
  "@babel/helpers - typeof";
  return Bo = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Bo(e);
}
function em(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function tm(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? em(Object(r), !0).forEach(function(n) {
      B5(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : em(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function B5(e, t, r) {
  return t = aK(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function aK(e) {
  var t = iK(e, "string");
  return Bo(t) == "symbol" ? t : String(t);
}
function iK(e, t) {
  if (Bo(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (Bo(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var oK = ["Webkit", "Moz", "O", "ms"], uK = function(t, r) {
  var n = t.replace(/(\w)/, function(i) {
    return i.toUpperCase();
  }), a = oK.reduce(function(i, o) {
    return tm(tm({}, i), {}, B5({}, o + n, r));
  }, {});
  return a[t] = r, a;
};
function Ba(e) {
  "@babel/helpers - typeof";
  return Ba = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ba(e);
}
function Ls() {
  return Ls = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Ls.apply(this, arguments);
}
function rm(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function of(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? rm(Object(r), !0).forEach(function(n) {
      Ht(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : rm(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function sK(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function nm(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, W5(n.key), n);
  }
}
function cK(e, t, r) {
  return t && nm(e.prototype, t), r && nm(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function lK(e, t, r) {
  return t = Bs(t), fK(e, V5() ? Reflect.construct(t, r || [], Bs(e).constructor) : t.apply(e, r));
}
function fK(e, t) {
  if (t && (Ba(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Cr(e);
}
function V5() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (V5 = function() {
    return !!e;
  })();
}
function Bs(e) {
  return Bs = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Bs(e);
}
function Cr(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function dK(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && qd(e, t);
}
function qd(e, t) {
  return qd = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, qd(e, t);
}
function Ht(e, t, r) {
  return t = W5(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function W5(e) {
  var t = pK(e, "string");
  return Ba(t) == "symbol" ? t : String(t);
}
function pK(e, t) {
  if (Ba(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (Ba(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var hK = function(t) {
  var r = t.data, n = t.startIndex, a = t.endIndex, i = t.x, o = t.width, u = t.travellerWidth;
  if (!r || !r.length)
    return {};
  var s = r.length, c = Ki().domain(ks(0, s)).range([i, i + o - u]), l = c.domain().map(function(f) {
    return c(f);
  });
  return {
    isTextActive: !1,
    isSlideMoving: !1,
    isTravellerMoving: !1,
    isTravellerFocused: !1,
    startX: c(n),
    endX: c(a),
    scale: c,
    scaleValues: l
  };
}, am = function(t) {
  return t.changedTouches && !!t.changedTouches.length;
}, Va = /* @__PURE__ */ function(e) {
  dK(t, e);
  function t(r) {
    var n;
    return sK(this, t), n = lK(this, t, [r]), Ht(Cr(n), "handleDrag", function(a) {
      n.leaveTimer && (clearTimeout(n.leaveTimer), n.leaveTimer = null), n.state.isTravellerMoving ? n.handleTravellerMove(a) : n.state.isSlideMoving && n.handleSlideDrag(a);
    }), Ht(Cr(n), "handleTouchMove", function(a) {
      a.changedTouches != null && a.changedTouches.length > 0 && n.handleDrag(a.changedTouches[0]);
    }), Ht(Cr(n), "handleDragEnd", function() {
      n.setState({
        isTravellerMoving: !1,
        isSlideMoving: !1
      }, function() {
        var a = n.props, i = a.endIndex, o = a.onDragEnd, u = a.startIndex;
        o == null || o({
          endIndex: i,
          startIndex: u
        });
      }), n.detachDragEndListener();
    }), Ht(Cr(n), "handleLeaveWrapper", function() {
      (n.state.isTravellerMoving || n.state.isSlideMoving) && (n.leaveTimer = window.setTimeout(n.handleDragEnd, n.props.leaveTimeOut));
    }), Ht(Cr(n), "handleEnterSlideOrTraveller", function() {
      n.setState({
        isTextActive: !0
      });
    }), Ht(Cr(n), "handleLeaveSlideOrTraveller", function() {
      n.setState({
        isTextActive: !1
      });
    }), Ht(Cr(n), "handleSlideDragStart", function(a) {
      var i = am(a) ? a.changedTouches[0] : a;
      n.setState({
        isTravellerMoving: !1,
        isSlideMoving: !0,
        slideMoveStartX: i.pageX
      }), n.attachDragEndListener();
    }), n.travellerDragStartHandlers = {
      startX: n.handleTravellerDragStart.bind(Cr(n), "startX"),
      endX: n.handleTravellerDragStart.bind(Cr(n), "endX")
    }, n.state = {}, n;
  }
  return cK(t, [{
    key: "componentWillUnmount",
    value: function() {
      this.leaveTimer && (clearTimeout(this.leaveTimer), this.leaveTimer = null), this.detachDragEndListener();
    }
  }, {
    key: "getIndex",
    value: function(n) {
      var a = n.startX, i = n.endX, o = this.state.scaleValues, u = this.props, s = u.gap, c = u.data, l = c.length - 1, f = Math.min(a, i), d = Math.max(a, i), p = t.getIndexInRange(o, f), h = t.getIndexInRange(o, d);
      return {
        startIndex: p - p % s,
        endIndex: h === l ? l : h - h % s
      };
    }
  }, {
    key: "getTextOfTick",
    value: function(n) {
      var a = this.props, i = a.data, o = a.tickFormatter, u = a.dataKey, s = Kt(i[n], u, n);
      return _e(o) ? o(s, n) : s;
    }
  }, {
    key: "attachDragEndListener",
    value: function() {
      window.addEventListener("mouseup", this.handleDragEnd, !0), window.addEventListener("touchend", this.handleDragEnd, !0), window.addEventListener("mousemove", this.handleDrag, !0);
    }
  }, {
    key: "detachDragEndListener",
    value: function() {
      window.removeEventListener("mouseup", this.handleDragEnd, !0), window.removeEventListener("touchend", this.handleDragEnd, !0), window.removeEventListener("mousemove", this.handleDrag, !0);
    }
  }, {
    key: "handleSlideDrag",
    value: function(n) {
      var a = this.state, i = a.slideMoveStartX, o = a.startX, u = a.endX, s = this.props, c = s.x, l = s.width, f = s.travellerWidth, d = s.startIndex, p = s.endIndex, h = s.onChange, v = n.pageX - i;
      v > 0 ? v = Math.min(v, c + l - f - u, c + l - f - o) : v < 0 && (v = Math.max(v, c - o, c - u));
      var g = this.getIndex({
        startX: o + v,
        endX: u + v
      });
      (g.startIndex !== d || g.endIndex !== p) && h && h(g), this.setState({
        startX: o + v,
        endX: u + v,
        slideMoveStartX: n.pageX
      });
    }
  }, {
    key: "handleTravellerDragStart",
    value: function(n, a) {
      var i = am(a) ? a.changedTouches[0] : a;
      this.setState({
        isSlideMoving: !1,
        isTravellerMoving: !0,
        movingTravellerId: n,
        brushMoveStartX: i.pageX
      }), this.attachDragEndListener();
    }
  }, {
    key: "handleTravellerMove",
    value: function(n) {
      var a = this.state, i = a.brushMoveStartX, o = a.movingTravellerId, u = a.endX, s = a.startX, c = this.state[o], l = this.props, f = l.x, d = l.width, p = l.travellerWidth, h = l.onChange, v = l.gap, g = l.data, b = {
        startX: this.state.startX,
        endX: this.state.endX
      }, x = n.pageX - i;
      x > 0 ? x = Math.min(x, f + d - p - c) : x < 0 && (x = Math.max(x, f - c)), b[o] = c + x;
      var w = this.getIndex(b), y = w.startIndex, m = w.endIndex, C = function() {
        var S = g.length - 1;
        return o === "startX" && (u > s ? y % v === 0 : m % v === 0) || u < s && m === S || o === "endX" && (u > s ? m % v === 0 : y % v === 0) || u > s && m === S;
      };
      this.setState(Ht(Ht({}, o, c + x), "brushMoveStartX", n.pageX), function() {
        h && C() && h(w);
      });
    }
  }, {
    key: "handleTravellerMoveKeyboard",
    value: function(n, a) {
      var i = this, o = this.state, u = o.scaleValues, s = o.startX, c = o.endX, l = this.state[a], f = u.indexOf(l);
      if (f !== -1) {
        var d = f + n;
        if (!(d === -1 || d >= u.length)) {
          var p = u[d];
          a === "startX" && p >= c || a === "endX" && p <= s || this.setState(Ht({}, a, p), function() {
            i.props.onChange(i.getIndex({
              startX: i.state.startX,
              endX: i.state.endX
            }));
          });
        }
      }
    }
  }, {
    key: "renderBackground",
    value: function() {
      var n = this.props, a = n.x, i = n.y, o = n.width, u = n.height, s = n.fill, c = n.stroke;
      return /* @__PURE__ */ N.createElement("rect", {
        stroke: c,
        fill: s,
        x: a,
        y: i,
        width: o,
        height: u
      });
    }
  }, {
    key: "renderPanorama",
    value: function() {
      var n = this.props, a = n.x, i = n.y, o = n.width, u = n.height, s = n.data, c = n.children, l = n.padding, f = Gn.only(c);
      return f ? /* @__PURE__ */ N.cloneElement(f, {
        x: a,
        y: i,
        width: o,
        height: u,
        margin: l,
        compact: !0,
        data: s
      }) : null;
    }
  }, {
    key: "renderTravellerLayer",
    value: function(n, a) {
      var i, o, u = this, s = this.props, c = s.y, l = s.travellerWidth, f = s.height, d = s.traveller, p = s.ariaLabel, h = s.data, v = s.startIndex, g = s.endIndex, b = Math.max(n, this.props.x), x = of(of({}, Ie(this.props, !1)), {}, {
        x: b,
        y: c,
        width: l,
        height: f
      }), w = p || "Min value: ".concat((i = h[v]) === null || i === void 0 ? void 0 : i.name, ", Max value: ").concat((o = h[g]) === null || o === void 0 ? void 0 : o.name);
      return /* @__PURE__ */ N.createElement(ut, {
        tabIndex: 0,
        role: "slider",
        "aria-label": w,
        "aria-valuenow": n,
        className: "recharts-brush-traveller",
        onMouseEnter: this.handleEnterSlideOrTraveller,
        onMouseLeave: this.handleLeaveSlideOrTraveller,
        onMouseDown: this.travellerDragStartHandlers[a],
        onTouchStart: this.travellerDragStartHandlers[a],
        onKeyDown: function(m) {
          ["ArrowLeft", "ArrowRight"].includes(m.key) && (m.preventDefault(), m.stopPropagation(), u.handleTravellerMoveKeyboard(m.key === "ArrowRight" ? 1 : -1, a));
        },
        onFocus: function() {
          u.setState({
            isTravellerFocused: !0
          });
        },
        onBlur: function() {
          u.setState({
            isTravellerFocused: !1
          });
        },
        style: {
          cursor: "col-resize"
        }
      }, t.renderTraveller(d, x));
    }
  }, {
    key: "renderSlide",
    value: function(n, a) {
      var i = this.props, o = i.y, u = i.height, s = i.stroke, c = i.travellerWidth, l = Math.min(n, a) + c, f = Math.max(Math.abs(a - n) - c, 0);
      return /* @__PURE__ */ N.createElement("rect", {
        className: "recharts-brush-slide",
        onMouseEnter: this.handleEnterSlideOrTraveller,
        onMouseLeave: this.handleLeaveSlideOrTraveller,
        onMouseDown: this.handleSlideDragStart,
        onTouchStart: this.handleSlideDragStart,
        style: {
          cursor: "move"
        },
        stroke: "none",
        fill: s,
        fillOpacity: 0.2,
        x: l,
        y: o,
        width: f,
        height: u
      });
    }
  }, {
    key: "renderText",
    value: function() {
      var n = this.props, a = n.startIndex, i = n.endIndex, o = n.y, u = n.height, s = n.travellerWidth, c = n.stroke, l = this.state, f = l.startX, d = l.endX, p = 5, h = {
        pointerEvents: "none",
        fill: c
      };
      return /* @__PURE__ */ N.createElement(ut, {
        className: "recharts-brush-texts"
      }, /* @__PURE__ */ N.createElement(vs, Ls({
        textAnchor: "end",
        verticalAnchor: "middle",
        x: Math.min(f, d) - p,
        y: o + u / 2
      }, h), this.getTextOfTick(a)), /* @__PURE__ */ N.createElement(vs, Ls({
        textAnchor: "start",
        verticalAnchor: "middle",
        x: Math.max(f, d) + s + p,
        y: o + u / 2
      }, h), this.getTextOfTick(i)));
    }
  }, {
    key: "render",
    value: function() {
      var n = this.props, a = n.data, i = n.className, o = n.children, u = n.x, s = n.y, c = n.width, l = n.height, f = n.alwaysShowText, d = this.state, p = d.startX, h = d.endX, v = d.isTextActive, g = d.isSlideMoving, b = d.isTravellerMoving, x = d.isTravellerFocused;
      if (!a || !a.length || !oe(u) || !oe(s) || !oe(c) || !oe(l) || c <= 0 || l <= 0)
        return null;
      var w = Ne("recharts-brush", i), y = N.Children.count(o) === 1, m = uK("userSelect", "none");
      return /* @__PURE__ */ N.createElement(ut, {
        className: w,
        onMouseLeave: this.handleLeaveWrapper,
        onTouchMove: this.handleTouchMove,
        style: m
      }, this.renderBackground(), y && this.renderPanorama(), this.renderSlide(p, h), this.renderTravellerLayer(p, "startX"), this.renderTravellerLayer(h, "endX"), (v || g || b || x || f) && this.renderText());
    }
  }], [{
    key: "renderDefaultTraveller",
    value: function(n) {
      var a = n.x, i = n.y, o = n.width, u = n.height, s = n.stroke, c = Math.floor(i + u / 2) - 1;
      return /* @__PURE__ */ N.createElement(N.Fragment, null, /* @__PURE__ */ N.createElement("rect", {
        x: a,
        y: i,
        width: o,
        height: u,
        fill: s,
        stroke: "none"
      }), /* @__PURE__ */ N.createElement("line", {
        x1: a + 1,
        y1: c,
        x2: a + o - 1,
        y2: c,
        fill: "none",
        stroke: "#fff"
      }), /* @__PURE__ */ N.createElement("line", {
        x1: a + 1,
        y1: c + 2,
        x2: a + o - 1,
        y2: c + 2,
        fill: "none",
        stroke: "#fff"
      }));
    }
  }, {
    key: "renderTraveller",
    value: function(n, a) {
      var i;
      return /* @__PURE__ */ N.isValidElement(n) ? i = /* @__PURE__ */ N.cloneElement(n, a) : _e(n) ? i = n(a) : i = t.renderDefaultTraveller(a), i;
    }
  }, {
    key: "getDerivedStateFromProps",
    value: function(n, a) {
      var i = n.data, o = n.width, u = n.x, s = n.travellerWidth, c = n.updateId, l = n.startIndex, f = n.endIndex;
      if (i !== a.prevData || c !== a.prevUpdateId)
        return of({
          prevData: i,
          prevTravellerWidth: s,
          prevUpdateId: c,
          prevX: u,
          prevWidth: o
        }, i && i.length ? hK({
          data: i,
          width: o,
          x: u,
          travellerWidth: s,
          startIndex: l,
          endIndex: f
        }) : {
          scale: null,
          scaleValues: null
        });
      if (a.scale && (o !== a.prevWidth || u !== a.prevX || s !== a.prevTravellerWidth)) {
        a.scale.range([u, u + o - s]);
        var d = a.scale.domain().map(function(p) {
          return a.scale(p);
        });
        return {
          prevData: i,
          prevTravellerWidth: s,
          prevUpdateId: c,
          prevX: u,
          prevWidth: o,
          startX: a.scale(n.startIndex),
          endX: a.scale(n.endIndex),
          scaleValues: d
        };
      }
      return null;
    }
  }, {
    key: "getIndexInRange",
    value: function(n, a) {
      for (var i = n.length, o = 0, u = i - 1; u - o > 1; ) {
        var s = Math.floor((o + u) / 2);
        n[s] > a ? u = s : o = s;
      }
      return a >= n[u] ? u : o;
    }
  }]), t;
}(xn);
Ht(Va, "displayName", "Brush");
Ht(Va, "defaultProps", {
  height: 40,
  travellerWidth: 5,
  gap: 1,
  fill: "#fff",
  stroke: "#666",
  padding: {
    top: 1,
    right: 1,
    bottom: 1,
    left: 1
  },
  leaveTimeOut: 1e3,
  alwaysShowText: !1
});
var vK = dp;
function gK(e, t) {
  var r;
  return vK(e, function(n, a, i) {
    return r = t(n, a, i), !r;
  }), !!r;
}
var mK = gK, yK = Y3, bK = On, xK = mK, CK = Wt, wK = bc;
function OK(e, t, r) {
  var n = CK(e) ? yK : xK;
  return r && wK(e, t, r) && (t = void 0), n(e, bK(t));
}
var SK = OK;
const AK = /* @__PURE__ */ Fe(SK);
var Mr = function(t, r) {
  var n = t.alwaysShow, a = t.ifOverflow;
  return n && (a = "extendDomain"), a === r;
}, im = g4;
function EK(e, t, r) {
  t == "__proto__" && im ? im(e, t, {
    configurable: !0,
    enumerable: !0,
    value: r,
    writable: !0
  }) : e[t] = r;
}
var _K = EK, IK = _K, PK = h4, TK = On;
function MK(e, t) {
  var r = {};
  return t = TK(t), PK(e, function(n, a, i) {
    IK(r, a, t(n, a, i));
  }), r;
}
var jK = MK;
const RK = /* @__PURE__ */ Fe(jK);
function NK(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length; ++r < n; )
    if (!t(e[r], r, e))
      return !1;
  return !0;
}
var $K = NK, FK = dp;
function DK(e, t) {
  var r = !0;
  return FK(e, function(n, a, i) {
    return r = !!t(n, a, i), r;
  }), r;
}
var kK = DK, LK = $K, BK = kK, VK = On, WK = Wt, GK = bc;
function HK(e, t, r) {
  var n = WK(e) ? LK : BK;
  return r && GK(e, t, r) && (t = void 0), n(e, VK(t));
}
var UK = HK;
const G5 = /* @__PURE__ */ Fe(UK);
var zK = ["x", "y"];
function Wa(e) {
  "@babel/helpers - typeof";
  return Wa = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Wa(e);
}
function Jd() {
  return Jd = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Jd.apply(this, arguments);
}
function om(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function $i(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? om(Object(r), !0).forEach(function(n) {
      YK(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : om(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function YK(e, t, r) {
  return t = XK(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function XK(e) {
  var t = ZK(e, "string");
  return Wa(t) == "symbol" ? t : String(t);
}
function ZK(e, t) {
  if (Wa(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (Wa(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function KK(e, t) {
  if (e == null) return {};
  var r = qK(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function qK(e, t) {
  if (e == null) return {};
  var r = {}, n = Object.keys(e), a, i;
  for (i = 0; i < n.length; i++)
    a = n[i], !(t.indexOf(a) >= 0) && (r[a] = e[a]);
  return r;
}
function JK(e, t) {
  var r = e.x, n = e.y, a = KK(e, zK), i = "".concat(r), o = parseInt(i, 10), u = "".concat(n), s = parseInt(u, 10), c = "".concat(t.height || a.height), l = parseInt(c, 10), f = "".concat(t.width || a.width), d = parseInt(f, 10);
  return $i($i($i($i($i({}, t), a), o ? {
    x: o
  } : {}), s ? {
    y: s
  } : {}), {}, {
    height: l,
    width: d,
    name: t.name,
    radius: t.radius
  });
}
function um(e) {
  return /* @__PURE__ */ N.createElement(FZ, Jd({
    shapeType: "rectangle",
    propTransformer: JK,
    activeClassName: "recharts-active-bar"
  }, e));
}
var QK = function(t) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
  return function(n, a) {
    if (typeof t == "number") return t;
    var i = typeof n == "number";
    return i ? t(n, a) : (i || (process.env.NODE_ENV !== "production" ? kt(!1, "minPointSize callback function received a value with type of ".concat(Wa(n), ". Currently only numbers are supported.")) : kt()), r);
  };
}, eq = ["value", "background"], H5;
function Ga(e) {
  "@babel/helpers - typeof";
  return Ga = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ga(e);
}
function tq(e, t) {
  if (e == null) return {};
  var r = rq(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function rq(e, t) {
  if (e == null) return {};
  var r = {}, n = Object.keys(e), a, i;
  for (i = 0; i < n.length; i++)
    a = n[i], !(t.indexOf(a) >= 0) && (r[a] = e[a]);
  return r;
}
function Vs() {
  return Vs = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Vs.apply(this, arguments);
}
function sm(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function xt(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? sm(Object(r), !0).forEach(function(n) {
      fn(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : sm(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function nq(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function cm(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, z5(n.key), n);
  }
}
function aq(e, t, r) {
  return t && cm(e.prototype, t), r && cm(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function iq(e, t, r) {
  return t = Ws(t), oq(e, U5() ? Reflect.construct(t, r || [], Ws(e).constructor) : t.apply(e, r));
}
function oq(e, t) {
  if (t && (Ga(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Vi(e);
}
function U5() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (U5 = function() {
    return !!e;
  })();
}
function Ws(e) {
  return Ws = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Ws(e);
}
function Vi(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function uq(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Qd(e, t);
}
function Qd(e, t) {
  return Qd = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, Qd(e, t);
}
function fn(e, t, r) {
  return t = z5(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function z5(e) {
  var t = sq(e, "string");
  return Ga(t) == "symbol" ? t : String(t);
}
function sq(e, t) {
  if (Ga(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (Ga(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var su = /* @__PURE__ */ function(e) {
  uq(t, e);
  function t() {
    var r;
    nq(this, t);
    for (var n = arguments.length, a = new Array(n), i = 0; i < n; i++)
      a[i] = arguments[i];
    return r = iq(this, t, [].concat(a)), fn(Vi(r), "state", {
      isAnimationFinished: !1
    }), fn(Vi(r), "id", ru("recharts-bar-")), fn(Vi(r), "handleAnimationEnd", function() {
      var o = r.props.onAnimationEnd;
      r.setState({
        isAnimationFinished: !0
      }), o && o();
    }), fn(Vi(r), "handleAnimationStart", function() {
      var o = r.props.onAnimationStart;
      r.setState({
        isAnimationFinished: !1
      }), o && o();
    }), r;
  }
  return aq(t, [{
    key: "renderRectanglesStatically",
    value: function(n) {
      var a = this, i = this.props, o = i.shape, u = i.dataKey, s = i.activeIndex, c = i.activeBar, l = Ie(this.props, !1);
      return n && n.map(function(f, d) {
        var p = d === s, h = p ? c : o, v = xt(xt(xt({}, l), f), {}, {
          isActive: p,
          option: h,
          index: d,
          dataKey: u,
          onAnimationStart: a.handleAnimationStart,
          onAnimationEnd: a.handleAnimationEnd
        });
        return /* @__PURE__ */ N.createElement(ut, Vs({
          className: "recharts-bar-rectangle"
        }, ts(a.props, f, d), {
          key: "rectangle-".concat(f == null ? void 0 : f.x, "-").concat(f == null ? void 0 : f.y, "-").concat(f == null ? void 0 : f.value)
        }), /* @__PURE__ */ N.createElement(um, v));
      });
    }
  }, {
    key: "renderRectanglesWithAnimation",
    value: function() {
      var n = this, a = this.props, i = a.data, o = a.layout, u = a.isAnimationActive, s = a.animationBegin, c = a.animationDuration, l = a.animationEasing, f = a.animationId, d = this.state.prevData;
      return /* @__PURE__ */ N.createElement(Jr, {
        begin: s,
        duration: c,
        isActive: u,
        easing: l,
        from: {
          t: 0
        },
        to: {
          t: 1
        },
        key: "bar-".concat(f),
        onAnimationEnd: this.handleAnimationEnd,
        onAnimationStart: this.handleAnimationStart
      }, function(p) {
        var h = p.t, v = i.map(function(g, b) {
          var x = d && d[b];
          if (x) {
            var w = rr(x.x, g.x), y = rr(x.y, g.y), m = rr(x.width, g.width), C = rr(x.height, g.height);
            return xt(xt({}, g), {}, {
              x: w(h),
              y: y(h),
              width: m(h),
              height: C(h)
            });
          }
          if (o === "horizontal") {
            var O = rr(0, g.height), S = O(h);
            return xt(xt({}, g), {}, {
              y: g.y + g.height - S,
              height: S
            });
          }
          var A = rr(0, g.width), P = A(h);
          return xt(xt({}, g), {}, {
            width: P
          });
        });
        return /* @__PURE__ */ N.createElement(ut, null, n.renderRectanglesStatically(v));
      });
    }
  }, {
    key: "renderRectangles",
    value: function() {
      var n = this.props, a = n.data, i = n.isAnimationActive, o = this.state.prevData;
      return i && a && a.length && (!o || !wo(o, a)) ? this.renderRectanglesWithAnimation() : this.renderRectanglesStatically(a);
    }
  }, {
    key: "renderBackground",
    value: function() {
      var n = this, a = this.props, i = a.data, o = a.dataKey, u = a.activeIndex, s = Ie(this.props.background, !1);
      return i.map(function(c, l) {
        c.value;
        var f = c.background, d = tq(c, eq);
        if (!f)
          return null;
        var p = xt(xt(xt(xt(xt({}, d), {}, {
          fill: "#eee"
        }, f), s), ts(n.props, c, l)), {}, {
          onAnimationStart: n.handleAnimationStart,
          onAnimationEnd: n.handleAnimationEnd,
          dataKey: o,
          index: l,
          key: "background-bar-".concat(l),
          className: "recharts-bar-background-rectangle"
        });
        return /* @__PURE__ */ N.createElement(um, Vs({
          option: n.props.background,
          isActive: l === u
        }, p));
      });
    }
  }, {
    key: "renderErrorBar",
    value: function(n, a) {
      if (this.props.isAnimationActive && !this.state.isAnimationFinished)
        return null;
      var i = this.props, o = i.data, u = i.xAxis, s = i.yAxis, c = i.layout, l = i.children, f = br(l, Pc);
      if (!f)
        return null;
      var d = c === "vertical" ? o[0].height / 2 : o[0].width / 2, p = function(g, b) {
        var x = Array.isArray(g.value) ? g.value[1] : g.value;
        return {
          x: g.x,
          y: g.y,
          value: x,
          errorVal: Kt(g, b)
        };
      }, h = {
        clipPath: n ? "url(#clipPath-".concat(a, ")") : null
      };
      return /* @__PURE__ */ N.createElement(ut, h, f.map(function(v) {
        return /* @__PURE__ */ N.cloneElement(v, {
          key: "error-bar-".concat(a, "-").concat(v.props.dataKey),
          data: o,
          xAxis: u,
          yAxis: s,
          layout: c,
          offset: d,
          dataPointFormatter: p
        });
      }));
    }
  }, {
    key: "render",
    value: function() {
      var n = this.props, a = n.hide, i = n.data, o = n.className, u = n.xAxis, s = n.yAxis, c = n.left, l = n.top, f = n.width, d = n.height, p = n.isAnimationActive, h = n.background, v = n.id;
      if (a || !i || !i.length)
        return null;
      var g = this.state.isAnimationFinished, b = Ne("recharts-bar", o), x = u && u.allowDataOverflow, w = s && s.allowDataOverflow, y = x || w, m = Me(v) ? this.id : v;
      return /* @__PURE__ */ N.createElement(ut, {
        className: b
      }, x || w ? /* @__PURE__ */ N.createElement("defs", null, /* @__PURE__ */ N.createElement("clipPath", {
        id: "clipPath-".concat(m)
      }, /* @__PURE__ */ N.createElement("rect", {
        x: x ? c : c - f / 2,
        y: w ? l : l - d / 2,
        width: x ? f : f * 2,
        height: w ? d : d * 2
      }))) : null, /* @__PURE__ */ N.createElement(ut, {
        className: "recharts-bar-rectangles",
        clipPath: y ? "url(#clipPath-".concat(m, ")") : null
      }, h ? this.renderBackground() : null, this.renderRectangles()), this.renderErrorBar(y, m), (!p || g) && vn.renderCallByParent(this.props, i));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(n, a) {
      return n.animationId !== a.prevAnimationId ? {
        prevAnimationId: n.animationId,
        curData: n.data,
        prevData: a.curData
      } : n.data !== a.curData ? {
        curData: n.data
      } : null;
    }
  }]), t;
}(xn);
H5 = su;
fn(su, "displayName", "Bar");
fn(su, "defaultProps", {
  xAxisId: 0,
  yAxisId: 0,
  legendType: "rect",
  minPointSize: 0,
  hide: !1,
  data: [],
  layout: "vertical",
  activeBar: !1,
  isAnimationActive: !zr.isSsr,
  animationBegin: 0,
  animationDuration: 400,
  animationEasing: "ease"
});
fn(su, "getComposedData", function(e) {
  var t = e.props, r = e.item, n = e.barPosition, a = e.bandSize, i = e.xAxis, o = e.yAxis, u = e.xAxisTicks, s = e.yAxisTicks, c = e.stackedData, l = e.dataStartIndex, f = e.displayedData, d = e.offset, p = ez(n, r);
  if (!p)
    return null;
  var h = t.layout, v = r.props, g = v.dataKey, b = v.children, x = v.minPointSize, w = h === "horizontal" ? o : i, y = c ? w.scale.domain() : null, m = sz({
    numericAxis: w
  }), C = br(b, O4), O = f.map(function(S, A) {
    var P, T, M, I, G, Y;
    c ? P = tz(c[l + A], y) : (P = Kt(S, g), Array.isArray(P) || (P = [m, P]));
    var L = QK(x, H5.defaultProps.minPointSize)(P[1], A);
    if (h === "horizontal") {
      var X, q = [o.scale(P[0]), o.scale(P[1])], re = q[0], j = q[1];
      T = sg({
        axis: i,
        ticks: u,
        bandSize: a,
        offset: p.offset,
        entry: S,
        index: A
      }), M = (X = j ?? re) !== null && X !== void 0 ? X : void 0, I = p.size;
      var W = re - j;
      if (G = Number.isNaN(W) ? 0 : W, Y = {
        x: T,
        y: o.y,
        width: I,
        height: o.height
      }, Math.abs(L) > 0 && Math.abs(G) < Math.abs(L)) {
        var D = yr(G || L) * (Math.abs(L) - Math.abs(G));
        M -= D, G += D;
      }
    } else {
      var R = [i.scale(P[0]), i.scale(P[1])], $ = R[0], B = R[1];
      if (T = $, M = sg({
        axis: o,
        ticks: s,
        bandSize: a,
        offset: p.offset,
        entry: S,
        index: A
      }), I = B - $, G = p.size, Y = {
        x: i.x,
        y: M,
        width: i.width,
        height: G
      }, Math.abs(L) > 0 && Math.abs(I) < Math.abs(L)) {
        var H = yr(I || L) * (Math.abs(L) - Math.abs(I));
        I += H;
      }
    }
    return xt(xt(xt({}, S), {}, {
      x: T,
      y: M,
      width: I,
      height: G,
      value: c ? P : P[1],
      payload: S,
      background: Y
    }, C && C[A] && C[A].props), {}, {
      tooltipPayload: [E5(r, S)],
      tooltipPosition: {
        x: T + I / 2,
        y: M + G / 2
      }
    });
  });
  return xt({
    data: O,
    layout: h
  }, d);
});
function Vo(e) {
  "@babel/helpers - typeof";
  return Vo = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Vo(e);
}
function cq(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function lm(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Y5(n.key), n);
  }
}
function lq(e, t, r) {
  return t && lm(e.prototype, t), r && lm(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function fm(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function vr(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? fm(Object(r), !0).forEach(function(n) {
      jc(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : fm(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function jc(e, t, r) {
  return t = Y5(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Y5(e) {
  var t = fq(e, "string");
  return Vo(t) == "symbol" ? t : String(t);
}
function fq(e, t) {
  if (Vo(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (Vo(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var dq = function(t, r, n, a, i) {
  var o = t.width, u = t.height, s = t.layout, c = t.children, l = Object.keys(r), f = {
    left: n.left,
    leftMirror: n.left,
    right: o - n.right,
    rightMirror: o - n.right,
    top: n.top,
    topMirror: n.top,
    bottom: u - n.bottom,
    bottomMirror: u - n.bottom
  }, d = !!Ut(c, su);
  return l.reduce(function(p, h) {
    var v = r[h], g = v.orientation, b = v.domain, x = v.padding, w = x === void 0 ? {} : x, y = v.mirror, m = v.reversed, C = "".concat(g).concat(y ? "Mirror" : ""), O, S, A, P, T;
    if (v.type === "number" && (v.padding === "gap" || v.padding === "no-gap")) {
      var M = b[1] - b[0], I = 1 / 0, G = v.categoricalDomain.sort();
      if (G.forEach(function($, B) {
        B > 0 && (I = Math.min(($ || 0) - (G[B - 1] || 0), I));
      }), Number.isFinite(I)) {
        var Y = I / M, L = v.layout === "vertical" ? n.height : n.width;
        if (v.padding === "gap" && (O = Y * L / 2), v.padding === "no-gap") {
          var X = Zn(t.barCategoryGap, Y * L), q = Y * L / 2;
          O = q - X - (q - X) / L * X;
        }
      }
    }
    a === "xAxis" ? S = [n.left + (w.left || 0) + (O || 0), n.left + n.width - (w.right || 0) - (O || 0)] : a === "yAxis" ? S = s === "horizontal" ? [n.top + n.height - (w.bottom || 0), n.top + (w.top || 0)] : [n.top + (w.top || 0) + (O || 0), n.top + n.height - (w.bottom || 0) - (O || 0)] : S = v.range, m && (S = [S[1], S[0]]);
    var re = JU(v, i, d), j = re.scale, W = re.realScaleType;
    j.domain(b).range(S), QU(j);
    var D = uz(j, vr(vr({}, v), {}, {
      realScaleType: W
    }));
    a === "xAxis" ? (T = g === "top" && !y || g === "bottom" && y, A = n.left, P = f[C] - T * v.height) : a === "yAxis" && (T = g === "left" && !y || g === "right" && y, A = f[C] - T * v.width, P = n.top);
    var R = vr(vr(vr({}, v), D), {}, {
      realScaleType: W,
      x: A,
      y: P,
      scale: j,
      width: a === "xAxis" ? n.width : v.width,
      height: a === "yAxis" ? n.height : v.height
    });
    return R.bandSize = Is(R, D), !v.hide && a === "xAxis" ? f[C] += (T ? -1 : 1) * R.height : v.hide || (f[C] += (T ? -1 : 1) * R.width), vr(vr({}, p), {}, jc({}, h, R));
  }, {});
}, X5 = function(t, r) {
  var n = t.x, a = t.y, i = r.x, o = r.y;
  return {
    x: Math.min(n, i),
    y: Math.min(a, o),
    width: Math.abs(i - n),
    height: Math.abs(o - a)
  };
}, pq = function(t) {
  var r = t.x1, n = t.y1, a = t.x2, i = t.y2;
  return X5({
    x: r,
    y: n
  }, {
    x: a,
    y: i
  });
}, Z5 = /* @__PURE__ */ function() {
  function e(t) {
    cq(this, e), this.scale = t;
  }
  return lq(e, [{
    key: "domain",
    get: function() {
      return this.scale.domain;
    }
  }, {
    key: "range",
    get: function() {
      return this.scale.range;
    }
  }, {
    key: "rangeMin",
    get: function() {
      return this.range()[0];
    }
  }, {
    key: "rangeMax",
    get: function() {
      return this.range()[1];
    }
  }, {
    key: "bandwidth",
    get: function() {
      return this.scale.bandwidth;
    }
  }, {
    key: "apply",
    value: function(r) {
      var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, a = n.bandAware, i = n.position;
      if (r !== void 0) {
        if (i)
          switch (i) {
            case "start":
              return this.scale(r);
            case "middle": {
              var o = this.bandwidth ? this.bandwidth() / 2 : 0;
              return this.scale(r) + o;
            }
            case "end": {
              var u = this.bandwidth ? this.bandwidth() : 0;
              return this.scale(r) + u;
            }
            default:
              return this.scale(r);
          }
        if (a) {
          var s = this.bandwidth ? this.bandwidth() / 2 : 0;
          return this.scale(r) + s;
        }
        return this.scale(r);
      }
    }
  }, {
    key: "isInRange",
    value: function(r) {
      var n = this.range(), a = n[0], i = n[n.length - 1];
      return a <= i ? r >= a && r <= i : r >= i && r <= a;
    }
  }], [{
    key: "create",
    value: function(r) {
      return new e(r);
    }
  }]), e;
}();
jc(Z5, "EPS", 1e-4);
var Wp = function(t) {
  var r = Object.keys(t).reduce(function(n, a) {
    return vr(vr({}, n), {}, jc({}, a, Z5.create(t[a])));
  }, {});
  return vr(vr({}, r), {}, {
    apply: function(a) {
      var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, o = i.bandAware, u = i.position;
      return RK(a, function(s, c) {
        return r[c].apply(s, {
          bandAware: o,
          position: u
        });
      });
    },
    isInRange: function(a) {
      return G5(a, function(i, o) {
        return r[o].isInRange(i);
      });
    }
  });
};
function hq(e) {
  return (e % 180 + 180) % 180;
}
var vq = function(t) {
  var r = t.width, n = t.height, a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, i = hq(a), o = i * Math.PI / 180, u = Math.atan(n / r), s = o > u && o < Math.PI - u ? n / Math.sin(o) : r / Math.cos(o);
  return Math.abs(s);
}, gq = On, mq = nu, yq = mc;
function bq(e) {
  return function(t, r, n) {
    var a = Object(t);
    if (!mq(t)) {
      var i = gq(r);
      t = yq(t), r = function(u) {
        return i(a[u], u, a);
      };
    }
    var o = e(t, r, n);
    return o > -1 ? a[i ? t[o] : o] : void 0;
  };
}
var xq = bq, Cq = L5;
function wq(e) {
  var t = Cq(e), r = t % 1;
  return t === t ? r ? t - r : t : 0;
}
var Oq = wq, Sq = u4, Aq = On, Eq = Oq, _q = Math.max;
function Iq(e, t, r) {
  var n = e == null ? 0 : e.length;
  if (!n)
    return -1;
  var a = r == null ? 0 : Eq(r);
  return a < 0 && (a = _q(n + a, 0)), Sq(e, Aq(t), a);
}
var Pq = Iq, Tq = xq, Mq = Pq, jq = Tq(Mq), Rq = jq;
const Nq = /* @__PURE__ */ Fe(Rq);
var $q = bA(function(e) {
  return {
    x: e.left,
    y: e.top,
    width: e.width,
    height: e.height
  };
}, function(e) {
  return ["l", e.left, "t", e.top, "w", e.width, "h", e.height].join("");
});
function Gs(e) {
  "@babel/helpers - typeof";
  return Gs = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Gs(e);
}
var Gp = /* @__PURE__ */ bn(void 0), Hp = /* @__PURE__ */ bn(void 0), K5 = /* @__PURE__ */ bn(void 0), q5 = /* @__PURE__ */ bn({}), J5 = /* @__PURE__ */ bn(void 0), Q5 = /* @__PURE__ */ bn(0), e6 = /* @__PURE__ */ bn(0), dm = function(t) {
  var r = t.state, n = r.xAxisMap, a = r.yAxisMap, i = r.offset, o = t.clipPathId, u = t.children, s = t.width, c = t.height, l = $q(i);
  return /* @__PURE__ */ N.createElement(Gp.Provider, {
    value: n
  }, /* @__PURE__ */ N.createElement(Hp.Provider, {
    value: a
  }, /* @__PURE__ */ N.createElement(q5.Provider, {
    value: i
  }, /* @__PURE__ */ N.createElement(K5.Provider, {
    value: l
  }, /* @__PURE__ */ N.createElement(J5.Provider, {
    value: o
  }, /* @__PURE__ */ N.createElement(Q5.Provider, {
    value: c
  }, /* @__PURE__ */ N.createElement(e6.Provider, {
    value: s
  }, u)))))));
}, Fq = function() {
  return $r(J5);
};
function t6(e) {
  var t = Object.keys(e);
  return t.length === 0 ? "There are no available ids." : "Available ids are: ".concat(t, ".");
}
var r6 = function(t) {
  var r = $r(Gp);
  r == null && (process.env.NODE_ENV !== "production" ? kt(!1, "Could not find Recharts context; are you sure this is rendered inside a Recharts wrapper component?") : kt());
  var n = r[t];
  return n == null && (process.env.NODE_ENV !== "production" ? kt(!1, 'Could not find xAxis by id "'.concat(t, '" [').concat(Gs(t), "]. ").concat(t6(r))) : kt()), n;
}, Dq = function() {
  var t = $r(Gp);
  return cn(t);
}, kq = function() {
  var t = $r(Hp), r = Nq(t, function(n) {
    return G5(n.domain, Number.isFinite);
  });
  return r || cn(t);
}, n6 = function(t) {
  var r = $r(Hp);
  r == null && (process.env.NODE_ENV !== "production" ? kt(!1, "Could not find Recharts context; are you sure this is rendered inside a Recharts wrapper component?") : kt());
  var n = r[t];
  return n == null && (process.env.NODE_ENV !== "production" ? kt(!1, 'Could not find yAxis by id "'.concat(t, '" [').concat(Gs(t), "]. ").concat(t6(r))) : kt()), n;
}, Lq = function() {
  var t = $r(K5);
  return t;
}, Bq = function() {
  return $r(q5);
}, Up = function() {
  return $r(e6);
}, zp = function() {
  return $r(Q5);
};
function Wo(e) {
  "@babel/helpers - typeof";
  return Wo = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Wo(e);
}
function pm(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function hm(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? pm(Object(r), !0).forEach(function(n) {
      Vq(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : pm(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Vq(e, t, r) {
  return t = Wq(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Wq(e) {
  var t = Gq(e, "string");
  return Wo(t) == "symbol" ? t : String(t);
}
function Gq(e, t) {
  if (Wo(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (Wo(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Hq(e, t) {
  return Xq(e) || Yq(e, t) || zq(e, t) || Uq();
}
function Uq() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function zq(e, t) {
  if (e) {
    if (typeof e == "string") return vm(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return vm(e, t);
  }
}
function vm(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function Yq(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, a, i, o, u = [], s = !0, c = !1;
    try {
      if (i = (r = r.call(e)).next, t !== 0) for (; !(s = (n = i.call(r)).done) && (u.push(n.value), u.length !== t); s = !0) ;
    } catch (l) {
      c = !0, a = l;
    } finally {
      try {
        if (!s && r.return != null && (o = r.return(), Object(o) !== o)) return;
      } finally {
        if (c) throw a;
      }
    }
    return u;
  }
}
function Xq(e) {
  if (Array.isArray(e)) return e;
}
function e1() {
  return e1 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, e1.apply(this, arguments);
}
var Zq = function(t, r) {
  var n;
  return /* @__PURE__ */ N.isValidElement(t) ? n = /* @__PURE__ */ N.cloneElement(t, r) : _e(t) ? n = t(r) : n = /* @__PURE__ */ N.createElement("line", e1({}, r, {
    className: "recharts-reference-line-line"
  })), n;
}, Kq = function(t, r, n, a, i, o, u, s, c) {
  var l = i.x, f = i.y, d = i.width, p = i.height;
  if (n) {
    var h = c.y, v = t.y.apply(h, {
      position: o
    });
    if (Mr(c, "discard") && !t.y.isInRange(v))
      return null;
    var g = [{
      x: l + d,
      y: v
    }, {
      x: l,
      y: v
    }];
    return s === "left" ? g.reverse() : g;
  }
  if (r) {
    var b = c.x, x = t.x.apply(b, {
      position: o
    });
    if (Mr(c, "discard") && !t.x.isInRange(x))
      return null;
    var w = [{
      x,
      y: f + p
    }, {
      x,
      y: f
    }];
    return u === "top" ? w.reverse() : w;
  }
  if (a) {
    var y = c.segment, m = y.map(function(C) {
      return t.apply(C, {
        position: o
      });
    });
    return Mr(c, "discard") && AK(m, function(C) {
      return !t.isInRange(C);
    }) ? null : m;
  }
  return null;
};
function Yp(e) {
  var t = e.x, r = e.y, n = e.segment, a = e.xAxisId, i = e.yAxisId, o = e.shape, u = e.className, s = e.alwaysShow, c = Fq(), l = r6(a), f = n6(i), d = Lq();
  if (!c || !d)
    return null;
  Ur(s === void 0, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
  var p = Wp({
    x: l.scale,
    y: f.scale
  }), h = gt(t), v = gt(r), g = n && n.length === 2, b = Kq(p, h, v, g, d, e.position, l.orientation, f.orientation, e);
  if (!b)
    return null;
  var x = Hq(b, 2), w = x[0], y = w.x, m = w.y, C = x[1], O = C.x, S = C.y, A = Mr(e, "hidden") ? "url(#".concat(c, ")") : void 0, P = hm(hm({
    clipPath: A
  }, Ie(e, !0)), {}, {
    x1: y,
    y1: m,
    x2: O,
    y2: S
  });
  return /* @__PURE__ */ N.createElement(ut, {
    className: Ne("recharts-reference-line", u)
  }, Zq(o, P), Mt.renderCallByParent(e, pq({
    x1: y,
    y1: m,
    x2: O,
    y2: S
  })));
}
Yp.displayName = "ReferenceLine";
Yp.defaultProps = {
  isFront: !1,
  ifOverflow: "discard",
  xAxisId: 0,
  yAxisId: 0,
  fill: "none",
  stroke: "#ccc",
  fillOpacity: 1,
  strokeWidth: 1,
  position: "middle"
};
function Go(e) {
  "@babel/helpers - typeof";
  return Go = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Go(e);
}
function t1() {
  return t1 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, t1.apply(this, arguments);
}
function gm(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function mm(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? gm(Object(r), !0).forEach(function(n) {
      qq(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : gm(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function qq(e, t, r) {
  return t = Jq(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Jq(e) {
  var t = Qq(e, "string");
  return Go(t) == "symbol" ? t : String(t);
}
function Qq(e, t) {
  if (Go(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (Go(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var eJ = function(t) {
  var r = t.x, n = t.y, a = t.xAxis, i = t.yAxis, o = Wp({
    x: a.scale,
    y: i.scale
  }), u = o.apply({
    x: r,
    y: n
  }, {
    bandAware: !0
  });
  return Mr(t, "discard") && !o.isInRange(u) ? null : u;
};
function cu(e) {
  var t = e.x, r = e.y, n = e.r, a = e.alwaysShow, i = e.clipPathId, o = gt(t), u = gt(r);
  if (Ur(a === void 0, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.'), !o || !u)
    return null;
  var s = eJ(e);
  if (!s)
    return null;
  var c = s.x, l = s.y, f = e.shape, d = e.className, p = Mr(e, "hidden") ? "url(#".concat(i, ")") : void 0, h = mm(mm({
    clipPath: p
  }, Ie(e, !0)), {}, {
    cx: c,
    cy: l
  });
  return /* @__PURE__ */ N.createElement(ut, {
    className: Ne("recharts-reference-dot", d)
  }, cu.renderDot(f, h), Mt.renderCallByParent(e, {
    x: c - n,
    y: l - n,
    width: 2 * n,
    height: 2 * n
  }));
}
cu.displayName = "ReferenceDot";
cu.defaultProps = {
  isFront: !1,
  ifOverflow: "discard",
  xAxisId: 0,
  yAxisId: 0,
  r: 10,
  fill: "#fff",
  stroke: "#ccc",
  fillOpacity: 1,
  strokeWidth: 1
};
cu.renderDot = function(e, t) {
  var r;
  return /* @__PURE__ */ N.isValidElement(e) ? r = /* @__PURE__ */ N.cloneElement(e, t) : _e(e) ? r = e(t) : r = /* @__PURE__ */ N.createElement(Vp, t1({}, t, {
    cx: t.cx,
    cy: t.cy,
    className: "recharts-reference-dot-dot"
  })), r;
};
function Ho(e) {
  "@babel/helpers - typeof";
  return Ho = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ho(e);
}
function r1() {
  return r1 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, r1.apply(this, arguments);
}
function ym(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function bm(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ym(Object(r), !0).forEach(function(n) {
      tJ(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ym(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function tJ(e, t, r) {
  return t = rJ(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function rJ(e) {
  var t = nJ(e, "string");
  return Ho(t) == "symbol" ? t : String(t);
}
function nJ(e, t) {
  if (Ho(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (Ho(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var aJ = function(t, r, n, a, i) {
  var o = i.x1, u = i.x2, s = i.y1, c = i.y2, l = i.xAxis, f = i.yAxis;
  if (!l || !f) return null;
  var d = Wp({
    x: l.scale,
    y: f.scale
  }), p = {
    x: t ? d.x.apply(o, {
      position: "start"
    }) : d.x.rangeMin,
    y: n ? d.y.apply(s, {
      position: "start"
    }) : d.y.rangeMin
  }, h = {
    x: r ? d.x.apply(u, {
      position: "end"
    }) : d.x.rangeMax,
    y: a ? d.y.apply(c, {
      position: "end"
    }) : d.y.rangeMax
  };
  return Mr(i, "discard") && (!d.isInRange(p) || !d.isInRange(h)) ? null : X5(p, h);
};
function lu(e) {
  var t = e.x1, r = e.x2, n = e.y1, a = e.y2, i = e.className, o = e.alwaysShow, u = e.clipPathId;
  Ur(o === void 0, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
  var s = gt(t), c = gt(r), l = gt(n), f = gt(a), d = e.shape;
  if (!s && !c && !l && !f && !d)
    return null;
  var p = aJ(s, c, l, f, e);
  if (!p && !d)
    return null;
  var h = Mr(e, "hidden") ? "url(#".concat(u, ")") : void 0;
  return /* @__PURE__ */ N.createElement(ut, {
    className: Ne("recharts-reference-area", i)
  }, lu.renderRect(d, bm(bm({
    clipPath: h
  }, Ie(e, !0)), p)), Mt.renderCallByParent(e, p));
}
lu.displayName = "ReferenceArea";
lu.defaultProps = {
  isFront: !1,
  ifOverflow: "discard",
  xAxisId: 0,
  yAxisId: 0,
  r: 10,
  fill: "#ccc",
  fillOpacity: 0.5,
  stroke: "none",
  strokeWidth: 1
};
lu.renderRect = function(e, t) {
  var r;
  return /* @__PURE__ */ N.isValidElement(e) ? r = /* @__PURE__ */ N.cloneElement(e, t) : _e(e) ? r = e(t) : r = /* @__PURE__ */ N.createElement(Bp, r1({}, t, {
    className: "recharts-reference-area-rect"
  })), r;
};
function a6(e, t, r) {
  if (t < 1)
    return [];
  if (t === 1 && r === void 0)
    return e;
  for (var n = [], a = 0; a < e.length; a += t)
    n.push(e[a]);
  return n;
}
function iJ(e, t, r) {
  var n = {
    width: e.width + t.width,
    height: e.height + t.height
  };
  return vq(n, r);
}
function oJ(e, t, r) {
  var n = r === "width", a = e.x, i = e.y, o = e.width, u = e.height;
  return t === 1 ? {
    start: n ? a : i,
    end: n ? a + o : i + u
  } : {
    start: n ? a + o : i + u,
    end: n ? a : i
  };
}
function Hs(e, t, r, n, a) {
  if (e * t < e * n || e * t > e * a)
    return !1;
  var i = r();
  return e * (t - e * i / 2 - n) >= 0 && e * (t + e * i / 2 - a) <= 0;
}
function uJ(e, t) {
  return a6(e, t + 1);
}
function sJ(e, t, r, n, a) {
  for (var i = (n || []).slice(), o = t.start, u = t.end, s = 0, c = 1, l = o, f = function() {
    var h = n == null ? void 0 : n[s];
    if (h === void 0)
      return {
        v: a6(n, c)
      };
    var v = s, g, b = function() {
      return g === void 0 && (g = r(h, v)), g;
    }, x = h.coordinate, w = s === 0 || Hs(e, x, b, l, u);
    w || (s = 0, l = o, c += 1), w && (l = x + e * (b() / 2 + a), s += c);
  }, d; c <= i.length; )
    if (d = f(), d) return d.v;
  return [];
}
function Uo(e) {
  "@babel/helpers - typeof";
  return Uo = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Uo(e);
}
function xm(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Tt(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? xm(Object(r), !0).forEach(function(n) {
      cJ(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : xm(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function cJ(e, t, r) {
  return t = lJ(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function lJ(e) {
  var t = fJ(e, "string");
  return Uo(t) == "symbol" ? t : String(t);
}
function fJ(e, t) {
  if (Uo(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (Uo(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function dJ(e, t, r, n, a) {
  for (var i = (n || []).slice(), o = i.length, u = t.start, s = t.end, c = function(d) {
    var p = i[d], h, v = function() {
      return h === void 0 && (h = r(p, d)), h;
    };
    if (d === o - 1) {
      var g = e * (p.coordinate + e * v() / 2 - s);
      i[d] = p = Tt(Tt({}, p), {}, {
        tickCoord: g > 0 ? p.coordinate - g * e : p.coordinate
      });
    } else
      i[d] = p = Tt(Tt({}, p), {}, {
        tickCoord: p.coordinate
      });
    var b = Hs(e, p.tickCoord, v, u, s);
    b && (s = p.tickCoord - e * (v() / 2 + a), i[d] = Tt(Tt({}, p), {}, {
      isShow: !0
    }));
  }, l = o - 1; l >= 0; l--)
    c(l);
  return i;
}
function pJ(e, t, r, n, a, i) {
  var o = (n || []).slice(), u = o.length, s = t.start, c = t.end;
  if (i) {
    var l = n[u - 1], f = r(l, u - 1), d = e * (l.coordinate + e * f / 2 - c);
    o[u - 1] = l = Tt(Tt({}, l), {}, {
      tickCoord: d > 0 ? l.coordinate - d * e : l.coordinate
    });
    var p = Hs(e, l.tickCoord, function() {
      return f;
    }, s, c);
    p && (c = l.tickCoord - e * (f / 2 + a), o[u - 1] = Tt(Tt({}, l), {}, {
      isShow: !0
    }));
  }
  for (var h = i ? u - 1 : u, v = function(x) {
    var w = o[x], y, m = function() {
      return y === void 0 && (y = r(w, x)), y;
    };
    if (x === 0) {
      var C = e * (w.coordinate - e * m() / 2 - s);
      o[x] = w = Tt(Tt({}, w), {}, {
        tickCoord: C < 0 ? w.coordinate - C * e : w.coordinate
      });
    } else
      o[x] = w = Tt(Tt({}, w), {}, {
        tickCoord: w.coordinate
      });
    var O = Hs(e, w.tickCoord, m, s, c);
    O && (s = w.tickCoord + e * (m() / 2 + a), o[x] = Tt(Tt({}, w), {}, {
      isShow: !0
    }));
  }, g = 0; g < h; g++)
    v(g);
  return o;
}
function Xp(e, t, r) {
  var n = e.tick, a = e.ticks, i = e.viewBox, o = e.minTickGap, u = e.orientation, s = e.interval, c = e.tickFormatter, l = e.unit, f = e.angle;
  if (!a || !a.length || !n)
    return [];
  if (oe(s) || zr.isSsr)
    return uJ(a, typeof s == "number" && oe(s) ? s : 0);
  var d = [], p = u === "top" || u === "bottom" ? "width" : "height", h = l && p === "width" ? Zi(l, {
    fontSize: t,
    letterSpacing: r
  }) : {
    width: 0,
    height: 0
  }, v = function(w, y) {
    var m = _e(c) ? c(w.value, y) : w.value;
    return p === "width" ? iJ(Zi(m, {
      fontSize: t,
      letterSpacing: r
    }), h, f) : Zi(m, {
      fontSize: t,
      letterSpacing: r
    })[p];
  }, g = a.length >= 2 ? yr(a[1].coordinate - a[0].coordinate) : 1, b = oJ(i, g, p);
  return s === "equidistantPreserveStart" ? sJ(g, b, v, a, o) : (s === "preserveStart" || s === "preserveStartEnd" ? d = pJ(g, b, v, a, o, s === "preserveStartEnd") : d = dJ(g, b, v, a, o), d.filter(function(x) {
    return x.isShow;
  }));
}
var hJ = ["viewBox"], vJ = ["viewBox"], gJ = ["ticks"];
function Ha(e) {
  "@babel/helpers - typeof";
  return Ha = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ha(e);
}
function ga() {
  return ga = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, ga.apply(this, arguments);
}
function Cm(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Nt(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Cm(Object(r), !0).forEach(function(n) {
      Zp(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Cm(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function uf(e, t) {
  if (e == null) return {};
  var r = mJ(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function mJ(e, t) {
  if (e == null) return {};
  var r = {}, n = Object.keys(e), a, i;
  for (i = 0; i < n.length; i++)
    a = n[i], !(t.indexOf(a) >= 0) && (r[a] = e[a]);
  return r;
}
function yJ(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function wm(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, o6(n.key), n);
  }
}
function bJ(e, t, r) {
  return t && wm(e.prototype, t), r && wm(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function xJ(e, t, r) {
  return t = Us(t), CJ(e, i6() ? Reflect.construct(t, r || [], Us(e).constructor) : t.apply(e, r));
}
function CJ(e, t) {
  if (t && (Ha(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return wJ(e);
}
function wJ(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function i6() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (i6 = function() {
    return !!e;
  })();
}
function Us(e) {
  return Us = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Us(e);
}
function OJ(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && n1(e, t);
}
function n1(e, t) {
  return n1 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, n1(e, t);
}
function Zp(e, t, r) {
  return t = o6(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function o6(e) {
  var t = SJ(e, "string");
  return Ha(t) == "symbol" ? t : String(t);
}
function SJ(e, t) {
  if (Ha(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (Ha(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var di = /* @__PURE__ */ function(e) {
  OJ(t, e);
  function t(r) {
    var n;
    return yJ(this, t), n = xJ(this, t, [r]), n.state = {
      fontSize: "",
      letterSpacing: ""
    }, n;
  }
  return bJ(t, [{
    key: "shouldComponentUpdate",
    value: function(n, a) {
      var i = n.viewBox, o = uf(n, hJ), u = this.props, s = u.viewBox, c = uf(u, vJ);
      return !ya(i, s) || !ya(o, c) || !ya(a, this.state);
    }
  }, {
    key: "componentDidMount",
    value: function() {
      var n = this.layerReference;
      if (n) {
        var a = n.getElementsByClassName("recharts-cartesian-axis-tick-value")[0];
        a && this.setState({
          fontSize: window.getComputedStyle(a).fontSize,
          letterSpacing: window.getComputedStyle(a).letterSpacing
        });
      }
    }
    /**
     * Calculate the coordinates of endpoints in ticks
     * @param  {Object} data The data of a simple tick
     * @return {Object} (x1, y1): The coordinate of endpoint close to tick text
     *  (x2, y2): The coordinate of endpoint close to axis
     */
  }, {
    key: "getTickLineCoord",
    value: function(n) {
      var a = this.props, i = a.x, o = a.y, u = a.width, s = a.height, c = a.orientation, l = a.tickSize, f = a.mirror, d = a.tickMargin, p, h, v, g, b, x, w = f ? -1 : 1, y = n.tickSize || l, m = oe(n.tickCoord) ? n.tickCoord : n.coordinate;
      switch (c) {
        case "top":
          p = h = n.coordinate, g = o + +!f * s, v = g - w * y, x = v - w * d, b = m;
          break;
        case "left":
          v = g = n.coordinate, h = i + +!f * u, p = h - w * y, b = p - w * d, x = m;
          break;
        case "right":
          v = g = n.coordinate, h = i + +f * u, p = h + w * y, b = p + w * d, x = m;
          break;
        default:
          p = h = n.coordinate, g = o + +f * s, v = g + w * y, x = v + w * d, b = m;
          break;
      }
      return {
        line: {
          x1: p,
          y1: v,
          x2: h,
          y2: g
        },
        tick: {
          x: b,
          y: x
        }
      };
    }
  }, {
    key: "getTickTextAnchor",
    value: function() {
      var n = this.props, a = n.orientation, i = n.mirror, o;
      switch (a) {
        case "left":
          o = i ? "start" : "end";
          break;
        case "right":
          o = i ? "end" : "start";
          break;
        default:
          o = "middle";
          break;
      }
      return o;
    }
  }, {
    key: "getTickVerticalAnchor",
    value: function() {
      var n = this.props, a = n.orientation, i = n.mirror, o = "end";
      switch (a) {
        case "left":
        case "right":
          o = "middle";
          break;
        case "top":
          o = i ? "start" : "end";
          break;
        default:
          o = i ? "end" : "start";
          break;
      }
      return o;
    }
  }, {
    key: "renderAxisLine",
    value: function() {
      var n = this.props, a = n.x, i = n.y, o = n.width, u = n.height, s = n.orientation, c = n.mirror, l = n.axisLine, f = Nt(Nt(Nt({}, Ie(this.props, !1)), Ie(l, !1)), {}, {
        fill: "none"
      });
      if (s === "top" || s === "bottom") {
        var d = +(s === "top" && !c || s === "bottom" && c);
        f = Nt(Nt({}, f), {}, {
          x1: a,
          y1: i + d * u,
          x2: a + o,
          y2: i + d * u
        });
      } else {
        var p = +(s === "left" && !c || s === "right" && c);
        f = Nt(Nt({}, f), {}, {
          x1: a + p * o,
          y1: i,
          x2: a + p * o,
          y2: i + u
        });
      }
      return /* @__PURE__ */ N.createElement("line", ga({}, f, {
        className: Ne("recharts-cartesian-axis-line", ve(l, "className"))
      }));
    }
  }, {
    key: "renderTicks",
    value: (
      /**
       * render the ticks
       * @param {Array} ticks The ticks to actually render (overrides what was passed in props)
       * @param {string} fontSize Fontsize to consider for tick spacing
       * @param {string} letterSpacing Letterspacing to consider for tick spacing
       * @return {ReactComponent} renderedTicks
       */
      function(n, a, i) {
        var o = this, u = this.props, s = u.tickLine, c = u.stroke, l = u.tick, f = u.tickFormatter, d = u.unit, p = Xp(Nt(Nt({}, this.props), {}, {
          ticks: n
        }), a, i), h = this.getTickTextAnchor(), v = this.getTickVerticalAnchor(), g = Ie(this.props, !1), b = Ie(l, !1), x = Nt(Nt({}, g), {}, {
          fill: "none"
        }, Ie(s, !1)), w = p.map(function(y, m) {
          var C = o.getTickLineCoord(y), O = C.line, S = C.tick, A = Nt(Nt(Nt(Nt({
            textAnchor: h,
            verticalAnchor: v
          }, g), {}, {
            stroke: "none",
            fill: c
          }, b), S), {}, {
            index: m,
            payload: y,
            visibleTicksCount: p.length,
            tickFormatter: f
          });
          return /* @__PURE__ */ N.createElement(ut, ga({
            className: "recharts-cartesian-axis-tick",
            key: "tick-".concat(y.value, "-").concat(y.coordinate, "-").concat(y.tickCoord)
          }, ts(o.props, y, m)), s && /* @__PURE__ */ N.createElement("line", ga({}, x, O, {
            className: Ne("recharts-cartesian-axis-tick-line", ve(s, "className"))
          })), l && t.renderTickItem(l, A, "".concat(_e(f) ? f(y.value, m) : y.value).concat(d || "")));
        });
        return /* @__PURE__ */ N.createElement("g", {
          className: "recharts-cartesian-axis-ticks"
        }, w);
      }
    )
  }, {
    key: "render",
    value: function() {
      var n = this, a = this.props, i = a.axisLine, o = a.width, u = a.height, s = a.ticksGenerator, c = a.className, l = a.hide;
      if (l)
        return null;
      var f = this.props, d = f.ticks, p = uf(f, gJ), h = d;
      return _e(s) && (h = d && d.length > 0 ? s(this.props) : s(p)), o <= 0 || u <= 0 || !h || !h.length ? null : /* @__PURE__ */ N.createElement(ut, {
        className: Ne("recharts-cartesian-axis", c),
        ref: function(g) {
          n.layerReference = g;
        }
      }, i && this.renderAxisLine(), this.renderTicks(h, this.state.fontSize, this.state.letterSpacing), Mt.renderCallByParent(this.props));
    }
  }], [{
    key: "renderTickItem",
    value: function(n, a, i) {
      var o;
      return /* @__PURE__ */ N.isValidElement(n) ? o = /* @__PURE__ */ N.cloneElement(n, a) : _e(n) ? o = n(a) : o = /* @__PURE__ */ N.createElement(vs, ga({}, a, {
        className: "recharts-cartesian-axis-tick-value"
      }), i), o;
    }
  }]), t;
}(Za);
Zp(di, "displayName", "CartesianAxis");
Zp(di, "defaultProps", {
  x: 0,
  y: 0,
  width: 0,
  height: 0,
  viewBox: {
    x: 0,
    y: 0,
    width: 0,
    height: 0
  },
  // The orientation of axis
  orientation: "bottom",
  // The ticks
  ticks: [],
  stroke: "#666",
  tickLine: !0,
  axisLine: !0,
  tick: !0,
  mirror: !1,
  minTickGap: 5,
  // The width or height of tick
  tickSize: 6,
  tickMargin: 2,
  interval: "preserveEnd"
});
var AJ = ["x1", "y1", "x2", "y2", "key"], EJ = ["offset"];
function qn(e) {
  "@babel/helpers - typeof";
  return qn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, qn(e);
}
function Om(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function jt(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Om(Object(r), !0).forEach(function(n) {
      _J(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Om(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function _J(e, t, r) {
  return t = IJ(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function IJ(e) {
  var t = PJ(e, "string");
  return qn(t) == "symbol" ? t : String(t);
}
function PJ(e, t) {
  if (qn(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (qn(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Vn() {
  return Vn = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Vn.apply(this, arguments);
}
function Sm(e, t) {
  if (e == null) return {};
  var r = TJ(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function TJ(e, t) {
  if (e == null) return {};
  var r = {}, n = Object.keys(e), a, i;
  for (i = 0; i < n.length; i++)
    a = n[i], !(t.indexOf(a) >= 0) && (r[a] = e[a]);
  return r;
}
var MJ = function(t) {
  var r = t.fill;
  if (!r || r === "none")
    return null;
  var n = t.fillOpacity, a = t.x, i = t.y, o = t.width, u = t.height;
  return /* @__PURE__ */ N.createElement("rect", {
    x: a,
    y: i,
    width: o,
    height: u,
    stroke: "none",
    fill: r,
    fillOpacity: n,
    className: "recharts-cartesian-grid-bg"
  });
};
function u6(e, t) {
  var r;
  if (/* @__PURE__ */ N.isValidElement(e))
    r = /* @__PURE__ */ N.cloneElement(e, t);
  else if (_e(e))
    r = e(t);
  else {
    var n = t.x1, a = t.y1, i = t.x2, o = t.y2, u = t.key, s = Sm(t, AJ), c = Ie(s, !1);
    c.offset;
    var l = Sm(c, EJ);
    r = /* @__PURE__ */ N.createElement("line", Vn({}, l, {
      x1: n,
      y1: a,
      x2: i,
      y2: o,
      fill: "none",
      key: u
    }));
  }
  return r;
}
function jJ(e) {
  var t = e.x, r = e.width, n = e.horizontal, a = n === void 0 ? !0 : n, i = e.horizontalPoints;
  if (!a || !i || !i.length)
    return null;
  var o = i.map(function(u, s) {
    var c = jt(jt({}, e), {}, {
      x1: t,
      y1: u,
      x2: t + r,
      y2: u,
      key: "line-".concat(s),
      index: s
    });
    return u6(a, c);
  });
  return /* @__PURE__ */ N.createElement("g", {
    className: "recharts-cartesian-grid-horizontal"
  }, o);
}
function RJ(e) {
  var t = e.y, r = e.height, n = e.vertical, a = n === void 0 ? !0 : n, i = e.verticalPoints;
  if (!a || !i || !i.length)
    return null;
  var o = i.map(function(u, s) {
    var c = jt(jt({}, e), {}, {
      x1: u,
      y1: t,
      x2: u,
      y2: t + r,
      key: "line-".concat(s),
      index: s
    });
    return u6(a, c);
  });
  return /* @__PURE__ */ N.createElement("g", {
    className: "recharts-cartesian-grid-vertical"
  }, o);
}
function NJ(e) {
  var t = e.horizontalFill, r = e.fillOpacity, n = e.x, a = e.y, i = e.width, o = e.height, u = e.horizontalPoints, s = e.horizontal, c = s === void 0 ? !0 : s;
  if (!c || !t || !t.length)
    return null;
  var l = u.map(function(d) {
    return Math.round(d + a - a);
  }).sort(function(d, p) {
    return d - p;
  });
  a !== l[0] && l.unshift(0);
  var f = l.map(function(d, p) {
    var h = !l[p + 1], v = h ? a + o - d : l[p + 1] - d;
    if (v <= 0)
      return null;
    var g = p % t.length;
    return /* @__PURE__ */ N.createElement("rect", {
      key: "react-".concat(p),
      y: d,
      x: n,
      height: v,
      width: i,
      stroke: "none",
      fill: t[g],
      fillOpacity: r,
      className: "recharts-cartesian-grid-bg"
    });
  });
  return /* @__PURE__ */ N.createElement("g", {
    className: "recharts-cartesian-gridstripes-horizontal"
  }, f);
}
function $J(e) {
  var t = e.vertical, r = t === void 0 ? !0 : t, n = e.verticalFill, a = e.fillOpacity, i = e.x, o = e.y, u = e.width, s = e.height, c = e.verticalPoints;
  if (!r || !n || !n.length)
    return null;
  var l = c.map(function(d) {
    return Math.round(d + i - i);
  }).sort(function(d, p) {
    return d - p;
  });
  i !== l[0] && l.unshift(0);
  var f = l.map(function(d, p) {
    var h = !l[p + 1], v = h ? i + u - d : l[p + 1] - d;
    if (v <= 0)
      return null;
    var g = p % n.length;
    return /* @__PURE__ */ N.createElement("rect", {
      key: "react-".concat(p),
      x: d,
      y: o,
      width: v,
      height: s,
      stroke: "none",
      fill: n[g],
      fillOpacity: a,
      className: "recharts-cartesian-grid-bg"
    });
  });
  return /* @__PURE__ */ N.createElement("g", {
    className: "recharts-cartesian-gridstripes-vertical"
  }, f);
}
var FJ = function(t, r) {
  var n = t.xAxis, a = t.width, i = t.height, o = t.offset;
  return S5(Xp(jt(jt(jt({}, di.defaultProps), n), {}, {
    ticks: Wr(n, !0),
    viewBox: {
      x: 0,
      y: 0,
      width: a,
      height: i
    }
  })), o.left, o.left + o.width, r);
}, DJ = function(t, r) {
  var n = t.yAxis, a = t.width, i = t.height, o = t.offset;
  return S5(Xp(jt(jt(jt({}, di.defaultProps), n), {}, {
    ticks: Wr(n, !0),
    viewBox: {
      x: 0,
      y: 0,
      width: a,
      height: i
    }
  })), o.top, o.top + o.height, r);
}, la = {
  horizontal: !0,
  vertical: !0,
  // The ordinates of horizontal grid lines
  horizontalPoints: [],
  // The abscissas of vertical grid lines
  verticalPoints: [],
  stroke: "#ccc",
  fill: "none",
  // The fill of colors of grid lines
  verticalFill: [],
  horizontalFill: []
};
function s6(e) {
  var t, r, n, a, i, o, u = Up(), s = zp(), c = Bq(), l = jt(jt({}, e), {}, {
    stroke: (t = e.stroke) !== null && t !== void 0 ? t : la.stroke,
    fill: (r = e.fill) !== null && r !== void 0 ? r : la.fill,
    horizontal: (n = e.horizontal) !== null && n !== void 0 ? n : la.horizontal,
    horizontalFill: (a = e.horizontalFill) !== null && a !== void 0 ? a : la.horizontalFill,
    vertical: (i = e.vertical) !== null && i !== void 0 ? i : la.vertical,
    verticalFill: (o = e.verticalFill) !== null && o !== void 0 ? o : la.verticalFill,
    x: oe(e.x) ? e.x : c.left,
    y: oe(e.y) ? e.y : c.top,
    width: oe(e.width) ? e.width : c.width,
    height: oe(e.height) ? e.height : c.height
  }), f = l.x, d = l.y, p = l.width, h = l.height, v = l.syncWithTicks, g = l.horizontalValues, b = l.verticalValues, x = Dq(), w = kq();
  if (!oe(p) || p <= 0 || !oe(h) || h <= 0 || !oe(f) || f !== +f || !oe(d) || d !== +d)
    return null;
  var y = l.verticalCoordinatesGenerator || FJ, m = l.horizontalCoordinatesGenerator || DJ, C = l.horizontalPoints, O = l.verticalPoints;
  if ((!C || !C.length) && _e(m)) {
    var S = g && g.length, A = m({
      yAxis: w ? jt(jt({}, w), {}, {
        ticks: S ? g : w.ticks
      }) : void 0,
      width: u,
      height: s,
      offset: c
    }, S ? !0 : v);
    Ur(Array.isArray(A), "horizontalCoordinatesGenerator should return Array but instead it returned [".concat(qn(A), "]")), Array.isArray(A) && (C = A);
  }
  if ((!O || !O.length) && _e(y)) {
    var P = b && b.length, T = y({
      xAxis: x ? jt(jt({}, x), {}, {
        ticks: P ? b : x.ticks
      }) : void 0,
      width: u,
      height: s,
      offset: c
    }, P ? !0 : v);
    Ur(Array.isArray(T), "verticalCoordinatesGenerator should return Array but instead it returned [".concat(qn(T), "]")), Array.isArray(T) && (O = T);
  }
  return /* @__PURE__ */ N.createElement("g", {
    className: "recharts-cartesian-grid"
  }, /* @__PURE__ */ N.createElement(MJ, {
    fill: l.fill,
    fillOpacity: l.fillOpacity,
    x: l.x,
    y: l.y,
    width: l.width,
    height: l.height
  }), /* @__PURE__ */ N.createElement(jJ, Vn({}, l, {
    offset: c,
    horizontalPoints: C,
    xAxis: x,
    yAxis: w
  })), /* @__PURE__ */ N.createElement(RJ, Vn({}, l, {
    offset: c,
    verticalPoints: O,
    xAxis: x,
    yAxis: w
  })), /* @__PURE__ */ N.createElement(NJ, Vn({}, l, {
    horizontalPoints: C
  })), /* @__PURE__ */ N.createElement($J, Vn({}, l, {
    verticalPoints: O
  })));
}
s6.displayName = "CartesianGrid";
var kJ = ["layout", "type", "stroke", "connectNulls", "isRange", "ref"], c6;
function Ua(e) {
  "@babel/helpers - typeof";
  return Ua = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ua(e);
}
function LJ(e, t) {
  if (e == null) return {};
  var r = BJ(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function BJ(e, t) {
  if (e == null) return {};
  var r = {}, n = Object.keys(e), a, i;
  for (i = 0; i < n.length; i++)
    a = n[i], !(t.indexOf(a) >= 0) && (r[a] = e[a]);
  return r;
}
function Wn() {
  return Wn = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Wn.apply(this, arguments);
}
function Am(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function un(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Am(Object(r), !0).forEach(function(n) {
      Er(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Am(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function VJ(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Em(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, f6(n.key), n);
  }
}
function WJ(e, t, r) {
  return t && Em(e.prototype, t), r && Em(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function GJ(e, t, r) {
  return t = zs(t), HJ(e, l6() ? Reflect.construct(t, r || [], zs(e).constructor) : t.apply(e, r));
}
function HJ(e, t) {
  if (t && (Ua(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Wi(e);
}
function l6() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (l6 = function() {
    return !!e;
  })();
}
function zs(e) {
  return zs = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, zs(e);
}
function Wi(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function UJ(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && a1(e, t);
}
function a1(e, t) {
  return a1 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, a1(e, t);
}
function Er(e, t, r) {
  return t = f6(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function f6(e) {
  var t = zJ(e, "string");
  return Ua(t) == "symbol" ? t : String(t);
}
function zJ(e, t) {
  if (Ua(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (Ua(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var _n = /* @__PURE__ */ function(e) {
  UJ(t, e);
  function t() {
    var r;
    VJ(this, t);
    for (var n = arguments.length, a = new Array(n), i = 0; i < n; i++)
      a[i] = arguments[i];
    return r = GJ(this, t, [].concat(a)), Er(Wi(r), "state", {
      isAnimationFinished: !0
    }), Er(Wi(r), "id", ru("recharts-area-")), Er(Wi(r), "handleAnimationEnd", function() {
      var o = r.props.onAnimationEnd;
      r.setState({
        isAnimationFinished: !0
      }), _e(o) && o();
    }), Er(Wi(r), "handleAnimationStart", function() {
      var o = r.props.onAnimationStart;
      r.setState({
        isAnimationFinished: !1
      }), _e(o) && o();
    }), r;
  }
  return WJ(t, [{
    key: "renderDots",
    value: function(n, a, i) {
      var o = this.props.isAnimationActive, u = this.state.isAnimationFinished;
      if (o && !u)
        return null;
      var s = this.props, c = s.dot, l = s.points, f = s.dataKey, d = Ie(this.props, !1), p = Ie(c, !0), h = l.map(function(g, b) {
        var x = un(un(un({
          key: "dot-".concat(b),
          r: 3
        }, d), p), {}, {
          index: b,
          cx: g.x,
          cy: g.y,
          dataKey: f,
          value: g.value,
          payload: g.payload,
          points: l
        });
        return t.renderDotItem(c, x);
      }), v = {
        clipPath: n ? "url(#clipPath-".concat(a ? "" : "dots-").concat(i, ")") : null
      };
      return /* @__PURE__ */ N.createElement(ut, Wn({
        className: "recharts-area-dots"
      }, v), h);
    }
  }, {
    key: "renderHorizontalRect",
    value: function(n) {
      var a = this.props, i = a.baseLine, o = a.points, u = a.strokeWidth, s = o[0].x, c = o[o.length - 1].x, l = n * Math.abs(s - c), f = ln(o.map(function(d) {
        return d.y || 0;
      }));
      return oe(i) && typeof i == "number" ? f = Math.max(i, f) : i && Array.isArray(i) && i.length && (f = Math.max(ln(i.map(function(d) {
        return d.y || 0;
      })), f)), oe(f) ? /* @__PURE__ */ N.createElement("rect", {
        x: s < c ? s : s - l,
        y: 0,
        width: l,
        height: Math.floor(f + (u ? parseInt("".concat(u), 10) : 1))
      }) : null;
    }
  }, {
    key: "renderVerticalRect",
    value: function(n) {
      var a = this.props, i = a.baseLine, o = a.points, u = a.strokeWidth, s = o[0].y, c = o[o.length - 1].y, l = n * Math.abs(s - c), f = ln(o.map(function(d) {
        return d.x || 0;
      }));
      return oe(i) && typeof i == "number" ? f = Math.max(i, f) : i && Array.isArray(i) && i.length && (f = Math.max(ln(i.map(function(d) {
        return d.x || 0;
      })), f)), oe(f) ? /* @__PURE__ */ N.createElement("rect", {
        x: 0,
        y: s < c ? s : s - l,
        width: f + (u ? parseInt("".concat(u), 10) : 1),
        height: Math.floor(l)
      }) : null;
    }
  }, {
    key: "renderClipRect",
    value: function(n) {
      var a = this.props.layout;
      return a === "vertical" ? this.renderVerticalRect(n) : this.renderHorizontalRect(n);
    }
  }, {
    key: "renderAreaStatically",
    value: function(n, a, i, o) {
      var u = this.props, s = u.layout, c = u.type, l = u.stroke, f = u.connectNulls, d = u.isRange;
      u.ref;
      var p = LJ(u, kJ);
      return /* @__PURE__ */ N.createElement(ut, {
        clipPath: i ? "url(#clipPath-".concat(o, ")") : null
      }, /* @__PURE__ */ N.createElement(Ji, Wn({}, Ie(p, !0), {
        points: n,
        connectNulls: f,
        type: c,
        baseLine: a,
        layout: s,
        stroke: "none",
        className: "recharts-area-area"
      })), l !== "none" && /* @__PURE__ */ N.createElement(Ji, Wn({}, Ie(this.props, !1), {
        className: "recharts-area-curve",
        layout: s,
        type: c,
        connectNulls: f,
        fill: "none",
        points: n
      })), l !== "none" && d && /* @__PURE__ */ N.createElement(Ji, Wn({}, Ie(this.props, !1), {
        className: "recharts-area-curve",
        layout: s,
        type: c,
        connectNulls: f,
        fill: "none",
        points: a
      })));
    }
  }, {
    key: "renderAreaWithAnimation",
    value: function(n, a) {
      var i = this, o = this.props, u = o.points, s = o.baseLine, c = o.isAnimationActive, l = o.animationBegin, f = o.animationDuration, d = o.animationEasing, p = o.animationId, h = this.state, v = h.prevPoints, g = h.prevBaseLine;
      return /* @__PURE__ */ N.createElement(Jr, {
        begin: l,
        duration: f,
        isActive: c,
        easing: d,
        from: {
          t: 0
        },
        to: {
          t: 1
        },
        key: "area-".concat(p),
        onAnimationEnd: this.handleAnimationEnd,
        onAnimationStart: this.handleAnimationStart
      }, function(b) {
        var x = b.t;
        if (v) {
          var w = v.length / u.length, y = u.map(function(S, A) {
            var P = Math.floor(A * w);
            if (v[P]) {
              var T = v[P], M = rr(T.x, S.x), I = rr(T.y, S.y);
              return un(un({}, S), {}, {
                x: M(x),
                y: I(x)
              });
            }
            return S;
          }), m;
          if (oe(s) && typeof s == "number") {
            var C = rr(g, s);
            m = C(x);
          } else if (Me(s) || ai(s)) {
            var O = rr(g, 0);
            m = O(x);
          } else
            m = s.map(function(S, A) {
              var P = Math.floor(A * w);
              if (g[P]) {
                var T = g[P], M = rr(T.x, S.x), I = rr(T.y, S.y);
                return un(un({}, S), {}, {
                  x: M(x),
                  y: I(x)
                });
              }
              return S;
            });
          return i.renderAreaStatically(y, m, n, a);
        }
        return /* @__PURE__ */ N.createElement(ut, null, /* @__PURE__ */ N.createElement("defs", null, /* @__PURE__ */ N.createElement("clipPath", {
          id: "animationClipPath-".concat(a)
        }, i.renderClipRect(x))), /* @__PURE__ */ N.createElement(ut, {
          clipPath: "url(#animationClipPath-".concat(a, ")")
        }, i.renderAreaStatically(u, s, n, a)));
      });
    }
  }, {
    key: "renderArea",
    value: function(n, a) {
      var i = this.props, o = i.points, u = i.baseLine, s = i.isAnimationActive, c = this.state, l = c.prevPoints, f = c.prevBaseLine, d = c.totalLength;
      return s && o && o.length && (!l && d > 0 || !wo(l, o) || !wo(f, u)) ? this.renderAreaWithAnimation(n, a) : this.renderAreaStatically(o, u, n, a);
    }
  }, {
    key: "render",
    value: function() {
      var n, a = this.props, i = a.hide, o = a.dot, u = a.points, s = a.className, c = a.top, l = a.left, f = a.xAxis, d = a.yAxis, p = a.width, h = a.height, v = a.isAnimationActive, g = a.id;
      if (i || !u || !u.length)
        return null;
      var b = this.state.isAnimationFinished, x = u.length === 1, w = Ne("recharts-area", s), y = f && f.allowDataOverflow, m = d && d.allowDataOverflow, C = y || m, O = Me(g) ? this.id : g, S = (n = Ie(o, !1)) !== null && n !== void 0 ? n : {
        r: 3,
        strokeWidth: 2
      }, A = S.r, P = A === void 0 ? 3 : A, T = S.strokeWidth, M = T === void 0 ? 2 : T, I = qT(o) ? o : {}, G = I.clipDot, Y = G === void 0 ? !0 : G, L = P * 2 + M;
      return /* @__PURE__ */ N.createElement(ut, {
        className: w
      }, y || m ? /* @__PURE__ */ N.createElement("defs", null, /* @__PURE__ */ N.createElement("clipPath", {
        id: "clipPath-".concat(O)
      }, /* @__PURE__ */ N.createElement("rect", {
        x: y ? l : l - p / 2,
        y: m ? c : c - h / 2,
        width: y ? p : p * 2,
        height: m ? h : h * 2
      })), !Y && /* @__PURE__ */ N.createElement("clipPath", {
        id: "clipPath-dots-".concat(O)
      }, /* @__PURE__ */ N.createElement("rect", {
        x: l - L / 2,
        y: c - L / 2,
        width: p + L,
        height: h + L
      }))) : null, x ? null : this.renderArea(C, O), (o || x) && this.renderDots(C, Y, O), (!v || b) && vn.renderCallByParent(this.props, u));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(n, a) {
      return n.animationId !== a.prevAnimationId ? {
        prevAnimationId: n.animationId,
        curPoints: n.points,
        curBaseLine: n.baseLine,
        prevPoints: a.curPoints,
        prevBaseLine: a.curBaseLine
      } : n.points !== a.curPoints || n.baseLine !== a.curBaseLine ? {
        curPoints: n.points,
        curBaseLine: n.baseLine
      } : null;
    }
  }]), t;
}(xn);
c6 = _n;
Er(_n, "displayName", "Area");
Er(_n, "defaultProps", {
  stroke: "#3182bd",
  fill: "#3182bd",
  fillOpacity: 0.6,
  xAxisId: 0,
  yAxisId: 0,
  legendType: "line",
  connectNulls: !1,
  // points of area
  points: [],
  dot: !1,
  activeDot: !0,
  hide: !1,
  isAnimationActive: !zr.isSsr,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: "ease"
});
Er(_n, "getBaseValue", function(e, t, r, n) {
  var a = e.layout, i = e.baseValue, o = t.props.baseValue, u = o ?? i;
  if (oe(u) && typeof u == "number")
    return u;
  var s = a === "horizontal" ? n : r, c = s.scale.domain();
  if (s.type === "number") {
    var l = Math.max(c[0], c[1]), f = Math.min(c[0], c[1]);
    return u === "dataMin" ? f : u === "dataMax" || l < 0 ? l : Math.max(Math.min(c[0], c[1]), 0);
  }
  return u === "dataMin" ? c[0] : u === "dataMax" ? c[1] : c[0];
});
Er(_n, "getComposedData", function(e) {
  var t = e.props, r = e.item, n = e.xAxis, a = e.yAxis, i = e.xAxisTicks, o = e.yAxisTicks, u = e.bandSize, s = e.dataKey, c = e.stackedData, l = e.dataStartIndex, f = e.displayedData, d = e.offset, p = t.layout, h = c && c.length, v = c6.getBaseValue(t, r, n, a), g = p === "horizontal", b = !1, x = f.map(function(y, m) {
    var C;
    h ? C = c[l + m] : (C = Kt(y, s), Array.isArray(C) ? b = !0 : C = [v, C]);
    var O = C[1] == null || h && Kt(y, s) == null;
    return g ? {
      x: ug({
        axis: n,
        ticks: i,
        bandSize: u,
        entry: y,
        index: m
      }),
      y: O ? null : a.scale(C[1]),
      value: C,
      payload: y
    } : {
      x: O ? null : n.scale(C[1]),
      y: ug({
        axis: a,
        ticks: o,
        bandSize: u,
        entry: y,
        index: m
      }),
      value: C,
      payload: y
    };
  }), w;
  return h || b ? w = x.map(function(y) {
    var m = Array.isArray(y.value) ? y.value[0] : null;
    return g ? {
      x: y.x,
      y: m != null && y.y != null ? a.scale(m) : null
    } : {
      x: m != null ? n.scale(m) : null,
      y: y.y
    };
  }) : w = g ? a.scale(v) : n.scale(v), un({
    points: x,
    baseLine: w,
    layout: p,
    isRange: b
  }, d);
});
Er(_n, "renderDotItem", function(e, t) {
  var r;
  if (/* @__PURE__ */ N.isValidElement(e))
    r = /* @__PURE__ */ N.cloneElement(e, t);
  else if (_e(e))
    r = e(t);
  else {
    var n = Ne("recharts-area-dot", typeof e != "boolean" ? e.className : "");
    r = /* @__PURE__ */ N.createElement(Vp, Wn({}, t, {
      className: n
    }));
  }
  return r;
});
function i1() {
  return i1 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, i1.apply(this, arguments);
}
var Rc = function(t) {
  var r = t.xAxisId, n = Up(), a = zp(), i = r6(r);
  return i == null ? null : (
    // @ts-expect-error the axisOptions type is not exactly what CartesianAxis is expecting.
    /* @__PURE__ */ N.createElement(di, i1({}, i, {
      className: Ne("recharts-".concat(i.axisType, " ").concat(i.axisType), i.className),
      viewBox: {
        x: 0,
        y: 0,
        width: n,
        height: a
      },
      ticksGenerator: function(u) {
        return Wr(u, !0);
      }
    }))
  );
};
Rc.displayName = "XAxis";
Rc.defaultProps = {
  allowDecimals: !0,
  hide: !1,
  orientation: "bottom",
  width: 0,
  height: 30,
  mirror: !1,
  xAxisId: 0,
  tickCount: 5,
  type: "category",
  padding: {
    left: 0,
    right: 0
  },
  allowDataOverflow: !1,
  scale: "auto",
  reversed: !1,
  allowDuplicatedCategory: !0
};
function o1() {
  return o1 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, o1.apply(this, arguments);
}
var Nc = function(t) {
  var r = t.yAxisId, n = Up(), a = zp(), i = n6(r);
  return i == null ? null : (
    // @ts-expect-error the axisOptions type is not exactly what CartesianAxis is expecting.
    /* @__PURE__ */ N.createElement(di, o1({}, i, {
      className: Ne("recharts-".concat(i.axisType, " ").concat(i.axisType), i.className),
      viewBox: {
        x: 0,
        y: 0,
        width: n,
        height: a
      },
      ticksGenerator: function(u) {
        return Wr(u, !0);
      }
    }))
  );
};
Nc.displayName = "YAxis";
Nc.defaultProps = {
  allowDuplicatedCategory: !0,
  allowDecimals: !0,
  hide: !1,
  orientation: "left",
  width: 60,
  height: 0,
  mirror: !1,
  yAxisId: 0,
  tickCount: 5,
  type: "number",
  padding: {
    top: 0,
    bottom: 0
  },
  allowDataOverflow: !1,
  scale: "auto",
  reversed: !1
};
function _m(e) {
  return KJ(e) || ZJ(e) || XJ(e) || YJ();
}
function YJ() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function XJ(e, t) {
  if (e) {
    if (typeof e == "string") return u1(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return u1(e, t);
  }
}
function ZJ(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function KJ(e) {
  if (Array.isArray(e)) return u1(e);
}
function u1(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
var s1 = function(t, r, n, a, i) {
  var o = br(t, Yp), u = br(t, cu), s = [].concat(_m(o), _m(u)), c = br(t, lu), l = "".concat(a, "Id"), f = a[0], d = r;
  if (s.length && (d = s.reduce(function(v, g) {
    if (g.props[l] === n && Mr(g.props, "extendDomain") && oe(g.props[f])) {
      var b = g.props[f];
      return [Math.min(v[0], b), Math.max(v[1], b)];
    }
    return v;
  }, d)), c.length) {
    var p = "".concat(f, "1"), h = "".concat(f, "2");
    d = c.reduce(function(v, g) {
      if (g.props[l] === n && Mr(g.props, "extendDomain") && oe(g.props[p]) && oe(g.props[h])) {
        var b = g.props[p], x = g.props[h];
        return [Math.min(v[0], b, x), Math.max(v[1], b, x)];
      }
      return v;
    }, d);
  }
  return i && i.length && (d = i.reduce(function(v, g) {
    return oe(g) ? [Math.min(v[0], g), Math.max(v[1], g)] : v;
  }, d)), d;
}, d6 = { exports: {} };
(function(e) {
  var t = Object.prototype.hasOwnProperty, r = "~";
  function n() {
  }
  Object.create && (n.prototype = /* @__PURE__ */ Object.create(null), new n().__proto__ || (r = !1));
  function a(s, c, l) {
    this.fn = s, this.context = c, this.once = l || !1;
  }
  function i(s, c, l, f, d) {
    if (typeof l != "function")
      throw new TypeError("The listener must be a function");
    var p = new a(l, f || s, d), h = r ? r + c : c;
    return s._events[h] ? s._events[h].fn ? s._events[h] = [s._events[h], p] : s._events[h].push(p) : (s._events[h] = p, s._eventsCount++), s;
  }
  function o(s, c) {
    --s._eventsCount === 0 ? s._events = new n() : delete s._events[c];
  }
  function u() {
    this._events = new n(), this._eventsCount = 0;
  }
  u.prototype.eventNames = function() {
    var c = [], l, f;
    if (this._eventsCount === 0) return c;
    for (f in l = this._events)
      t.call(l, f) && c.push(r ? f.slice(1) : f);
    return Object.getOwnPropertySymbols ? c.concat(Object.getOwnPropertySymbols(l)) : c;
  }, u.prototype.listeners = function(c) {
    var l = r ? r + c : c, f = this._events[l];
    if (!f) return [];
    if (f.fn) return [f.fn];
    for (var d = 0, p = f.length, h = new Array(p); d < p; d++)
      h[d] = f[d].fn;
    return h;
  }, u.prototype.listenerCount = function(c) {
    var l = r ? r + c : c, f = this._events[l];
    return f ? f.fn ? 1 : f.length : 0;
  }, u.prototype.emit = function(c, l, f, d, p, h) {
    var v = r ? r + c : c;
    if (!this._events[v]) return !1;
    var g = this._events[v], b = arguments.length, x, w;
    if (g.fn) {
      switch (g.once && this.removeListener(c, g.fn, void 0, !0), b) {
        case 1:
          return g.fn.call(g.context), !0;
        case 2:
          return g.fn.call(g.context, l), !0;
        case 3:
          return g.fn.call(g.context, l, f), !0;
        case 4:
          return g.fn.call(g.context, l, f, d), !0;
        case 5:
          return g.fn.call(g.context, l, f, d, p), !0;
        case 6:
          return g.fn.call(g.context, l, f, d, p, h), !0;
      }
      for (w = 1, x = new Array(b - 1); w < b; w++)
        x[w - 1] = arguments[w];
      g.fn.apply(g.context, x);
    } else {
      var y = g.length, m;
      for (w = 0; w < y; w++)
        switch (g[w].once && this.removeListener(c, g[w].fn, void 0, !0), b) {
          case 1:
            g[w].fn.call(g[w].context);
            break;
          case 2:
            g[w].fn.call(g[w].context, l);
            break;
          case 3:
            g[w].fn.call(g[w].context, l, f);
            break;
          case 4:
            g[w].fn.call(g[w].context, l, f, d);
            break;
          default:
            if (!x) for (m = 1, x = new Array(b - 1); m < b; m++)
              x[m - 1] = arguments[m];
            g[w].fn.apply(g[w].context, x);
        }
    }
    return !0;
  }, u.prototype.on = function(c, l, f) {
    return i(this, c, l, f, !1);
  }, u.prototype.once = function(c, l, f) {
    return i(this, c, l, f, !0);
  }, u.prototype.removeListener = function(c, l, f, d) {
    var p = r ? r + c : c;
    if (!this._events[p]) return this;
    if (!l)
      return o(this, p), this;
    var h = this._events[p];
    if (h.fn)
      h.fn === l && (!d || h.once) && (!f || h.context === f) && o(this, p);
    else {
      for (var v = 0, g = [], b = h.length; v < b; v++)
        (h[v].fn !== l || d && !h[v].once || f && h[v].context !== f) && g.push(h[v]);
      g.length ? this._events[p] = g.length === 1 ? g[0] : g : o(this, p);
    }
    return this;
  }, u.prototype.removeAllListeners = function(c) {
    var l;
    return c ? (l = r ? r + c : c, this._events[l] && o(this, l)) : (this._events = new n(), this._eventsCount = 0), this;
  }, u.prototype.off = u.prototype.removeListener, u.prototype.addListener = u.prototype.on, u.prefixed = r, u.EventEmitter = u, e.exports = u;
})(d6);
var qJ = d6.exports;
const JJ = /* @__PURE__ */ Fe(qJ);
var sf = new JJ(), cf = "recharts.syncMouseEvents";
function zo(e) {
  "@babel/helpers - typeof";
  return zo = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, zo(e);
}
function QJ(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function eQ(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, p6(n.key), n);
  }
}
function tQ(e, t, r) {
  return t && eQ(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function lf(e, t, r) {
  return t = p6(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function p6(e) {
  var t = rQ(e, "string");
  return zo(t) == "symbol" ? t : String(t);
}
function rQ(e, t) {
  if (zo(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (zo(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var nQ = /* @__PURE__ */ function() {
  function e() {
    QJ(this, e), lf(this, "activeIndex", 0), lf(this, "coordinateList", []), lf(this, "layout", "horizontal");
  }
  return tQ(e, [{
    key: "setDetails",
    value: function(r) {
      var n, a = r.coordinateList, i = a === void 0 ? null : a, o = r.container, u = o === void 0 ? null : o, s = r.layout, c = s === void 0 ? null : s, l = r.offset, f = l === void 0 ? null : l, d = r.mouseHandlerCallback, p = d === void 0 ? null : d;
      this.coordinateList = (n = i ?? this.coordinateList) !== null && n !== void 0 ? n : [], this.container = u ?? this.container, this.layout = c ?? this.layout, this.offset = f ?? this.offset, this.mouseHandlerCallback = p ?? this.mouseHandlerCallback, this.activeIndex = Math.min(Math.max(this.activeIndex, 0), this.coordinateList.length - 1);
    }
  }, {
    key: "focus",
    value: function() {
      this.spoofMouse();
    }
  }, {
    key: "keyboardEvent",
    value: function(r) {
      if (this.coordinateList.length !== 0)
        switch (r.key) {
          case "ArrowRight": {
            if (this.layout !== "horizontal")
              return;
            this.activeIndex = Math.min(this.activeIndex + 1, this.coordinateList.length - 1), this.spoofMouse();
            break;
          }
          case "ArrowLeft": {
            if (this.layout !== "horizontal")
              return;
            this.activeIndex = Math.max(this.activeIndex - 1, 0), this.spoofMouse();
            break;
          }
        }
    }
  }, {
    key: "setIndex",
    value: function(r) {
      this.activeIndex = r;
    }
  }, {
    key: "spoofMouse",
    value: function() {
      var r, n;
      if (this.layout === "horizontal" && this.coordinateList.length !== 0) {
        var a = this.container.getBoundingClientRect(), i = a.x, o = a.y, u = a.height, s = this.coordinateList[this.activeIndex].coordinate, c = ((r = window) === null || r === void 0 ? void 0 : r.scrollX) || 0, l = ((n = window) === null || n === void 0 ? void 0 : n.scrollY) || 0, f = i + s + c, d = o + this.offset.top + u / 2 + l;
        this.mouseHandlerCallback({
          pageX: f,
          pageY: d
        });
      }
    }
  }]), e;
}();
function aQ(e, t, r) {
  if (r === "number" && t === !0 && Array.isArray(e)) {
    var n = e == null ? void 0 : e[0], a = e == null ? void 0 : e[1];
    if (n && a && oe(n) && oe(a))
      return !0;
  }
  return !1;
}
function iQ(e, t, r, n) {
  var a = n / 2;
  return {
    stroke: "none",
    fill: "#ccc",
    x: e === "horizontal" ? t.x - a : r.left + 0.5,
    y: e === "horizontal" ? r.top + 0.5 : t.y - a,
    width: e === "horizontal" ? n : r.width - 1,
    height: e === "horizontal" ? r.height - 1 : n
  };
}
function h6(e) {
  var t = e.cx, r = e.cy, n = e.radius, a = e.startAngle, i = e.endAngle, o = It(t, r, n, a), u = It(t, r, n, i);
  return {
    points: [o, u],
    cx: t,
    cy: r,
    radius: n,
    startAngle: a,
    endAngle: i
  };
}
function oQ(e, t, r) {
  var n, a, i, o;
  if (e === "horizontal")
    n = t.x, i = n, a = r.top, o = r.top + r.height;
  else if (e === "vertical")
    a = t.y, o = a, n = r.left, i = r.left + r.width;
  else if (t.cx != null && t.cy != null)
    if (e === "centric") {
      var u = t.cx, s = t.cy, c = t.innerRadius, l = t.outerRadius, f = t.angle, d = It(u, s, c, f), p = It(u, s, l, f);
      n = d.x, a = d.y, i = p.x, o = p.y;
    } else
      return h6(t);
  return [{
    x: n,
    y: a
  }, {
    x: i,
    y: o
  }];
}
function Yo(e) {
  "@babel/helpers - typeof";
  return Yo = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Yo(e);
}
function Im(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function ju(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Im(Object(r), !0).forEach(function(n) {
      uQ(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Im(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function uQ(e, t, r) {
  return t = sQ(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function sQ(e) {
  var t = cQ(e, "string");
  return Yo(t) == "symbol" ? t : String(t);
}
function cQ(e, t) {
  if (Yo(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (Yo(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function lQ(e) {
  var t = e.element, r = e.tooltipEventType, n = e.isActive, a = e.activeCoordinate, i = e.activePayload, o = e.offset, u = e.activeTooltipIndex, s = e.tooltipAxisBandSize, c = e.layout, l = e.chartName;
  if (!t || !t.props.cursor || !n || !a || l !== "ScatterChart" && r !== "axis")
    return null;
  var f, d = Ji;
  if (l === "ScatterChart")
    f = a, d = KX;
  else if (l === "BarChart")
    f = iQ(c, a, o, s), d = Bp;
  else if (c === "radial") {
    var p = h6(a), h = p.cx, v = p.cy, g = p.radius, b = p.startAngle, x = p.endAngle;
    f = {
      cx: h,
      cy: v,
      startAngle: b,
      endAngle: x,
      innerRadius: g,
      outerRadius: g
    }, d = P5;
  } else
    f = {
      points: oQ(c, a, o)
    }, d = Ji;
  var w = ju(ju(ju(ju({
    stroke: "#ccc",
    pointerEvents: "none"
  }, o), f), Ie(t.props.cursor, !1)), {}, {
    payload: i,
    payloadIndex: u,
    className: Ne("recharts-tooltip-cursor", t.props.cursor.className)
  });
  return /* @__PURE__ */ _r(t.props.cursor) ? /* @__PURE__ */ vt(t.props.cursor, w) : /* @__PURE__ */ zm(d, w);
}
var fQ = ["item"], dQ = ["children", "className", "width", "height", "style", "compact", "title", "desc"];
function za(e) {
  "@babel/helpers - typeof";
  return za = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, za(e);
}
function eo() {
  return eo = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, eo.apply(this, arguments);
}
function Pm(e, t) {
  return vQ(e) || hQ(e, t) || g6(e, t) || pQ();
}
function pQ() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function hQ(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, a, i, o, u = [], s = !0, c = !1;
    try {
      if (i = (r = r.call(e)).next, t !== 0) for (; !(s = (n = i.call(r)).done) && (u.push(n.value), u.length !== t); s = !0) ;
    } catch (l) {
      c = !0, a = l;
    } finally {
      try {
        if (!s && r.return != null && (o = r.return(), Object(o) !== o)) return;
      } finally {
        if (c) throw a;
      }
    }
    return u;
  }
}
function vQ(e) {
  if (Array.isArray(e)) return e;
}
function Tm(e, t) {
  if (e == null) return {};
  var r = gQ(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function gQ(e, t) {
  if (e == null) return {};
  var r = {}, n = Object.keys(e), a, i;
  for (i = 0; i < n.length; i++)
    a = n[i], !(t.indexOf(a) >= 0) && (r[a] = e[a]);
  return r;
}
function mQ(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function yQ(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, m6(n.key), n);
  }
}
function bQ(e, t, r) {
  return t && yQ(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function xQ(e, t, r) {
  return t = Ys(t), CQ(e, v6() ? Reflect.construct(t, r || [], Ys(e).constructor) : t.apply(e, r));
}
function CQ(e, t) {
  if (t && (za(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Re(e);
}
function v6() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (v6 = function() {
    return !!e;
  })();
}
function Ys(e) {
  return Ys = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Ys(e);
}
function Re(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function wQ(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && c1(e, t);
}
function c1(e, t) {
  return c1 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, c1(e, t);
}
function Ya(e) {
  return AQ(e) || SQ(e) || g6(e) || OQ();
}
function OQ() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function g6(e, t) {
  if (e) {
    if (typeof e == "string") return l1(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return l1(e, t);
  }
}
function SQ(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function AQ(e) {
  if (Array.isArray(e)) return l1(e);
}
function l1(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function Mm(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function te(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Mm(Object(r), !0).forEach(function(n) {
      me(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Mm(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function me(e, t, r) {
  return t = m6(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function m6(e) {
  var t = EQ(e, "string");
  return za(t) == "symbol" ? t : String(t);
}
function EQ(e, t) {
  if (za(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (za(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var _Q = {
  xAxis: ["bottom", "top"],
  yAxis: ["left", "right"]
}, IQ = {
  width: "100%",
  height: "100%"
}, y6 = {
  x: 0,
  y: 0
};
function Ru(e) {
  return e;
}
var PQ = function(t, r) {
  return r === "horizontal" ? t.x : r === "vertical" ? t.y : r === "centric" ? t.angle : t.radius;
}, TQ = function(t, r, n, a) {
  var i = r.find(function(l) {
    return l && l.index === n;
  });
  if (i) {
    if (t === "horizontal")
      return {
        x: i.coordinate,
        y: a.y
      };
    if (t === "vertical")
      return {
        x: a.x,
        y: i.coordinate
      };
    if (t === "centric") {
      var o = i.coordinate, u = a.radius;
      return te(te(te({}, a), It(a.cx, a.cy, u, o)), {}, {
        angle: o,
        radius: u
      });
    }
    var s = i.coordinate, c = a.angle;
    return te(te(te({}, a), It(a.cx, a.cy, s, c)), {}, {
      angle: c,
      radius: s
    });
  }
  return y6;
}, $c = function(t, r) {
  var n = r.graphicalItems, a = r.dataStartIndex, i = r.dataEndIndex, o = (n ?? []).reduce(function(u, s) {
    var c = s.props.data;
    return c && c.length ? [].concat(Ya(u), Ya(c)) : u;
  }, []);
  return o.length > 0 ? o : t && t.length && oe(a) && oe(i) ? t.slice(a, i + 1) : [];
};
function b6(e) {
  return e === "number" ? [0, "auto"] : void 0;
}
var f1 = function(t, r, n, a) {
  var i = t.graphicalItems, o = t.tooltipAxis, u = $c(r, t);
  return n < 0 || !i || !i.length || n >= u.length ? null : i.reduce(function(s, c) {
    var l, f = (l = c.props.data) !== null && l !== void 0 ? l : r;
    f && t.dataStartIndex + t.dataEndIndex !== 0 && (f = f.slice(t.dataStartIndex, t.dataEndIndex + 1));
    var d;
    if (o.dataKey && !o.allowDuplicatedCategory) {
      var p = f === void 0 ? u : f;
      d = Qu(p, o.dataKey, a);
    } else
      d = f && f[n] || u[n];
    return d ? [].concat(Ya(s), [E5(c, d)]) : s;
  }, []);
}, jm = function(t, r, n, a) {
  var i = a || {
    x: t.chartX,
    y: t.chartY
  }, o = PQ(i, n), u = t.orderedTooltipTicks, s = t.tooltipAxis, c = t.tooltipTicks, l = zU(o, u, c, s);
  if (l >= 0 && c) {
    var f = c[l] && c[l].value, d = f1(t, r, l, f), p = TQ(n, u, l, i);
    return {
      activeTooltipIndex: l,
      activeLabel: f,
      activePayload: d,
      activeCoordinate: p
    };
  }
  return null;
}, MQ = function(t, r) {
  var n = r.axes, a = r.graphicalItems, i = r.axisType, o = r.axisIdKey, u = r.stackGroups, s = r.dataStartIndex, c = r.dataEndIndex, l = t.layout, f = t.children, d = t.stackOffset, p = O5(l, i);
  return n.reduce(function(h, v) {
    var g, b = v.props, x = b.type, w = b.dataKey, y = b.allowDataOverflow, m = b.allowDuplicatedCategory, C = b.scale, O = b.ticks, S = b.includeHidden, A = v.props[o];
    if (h[A])
      return h;
    var P = $c(t.data, {
      graphicalItems: a.filter(function(D) {
        return D.props[o] === A;
      }),
      dataStartIndex: s,
      dataEndIndex: c
    }), T = P.length, M, I, G;
    aQ(v.props.domain, y, x) && (M = $d(v.props.domain, null, y), p && (x === "number" || C !== "auto") && (G = qi(P, w, "category")));
    var Y = b6(x);
    if (!M || M.length === 0) {
      var L, X = (L = v.props.domain) !== null && L !== void 0 ? L : Y;
      if (w) {
        if (M = qi(P, w, x), x === "category" && p) {
          var q = WT(M);
          m && q ? (I = M, M = ks(0, T)) : m || (M = fg(X, M, v).reduce(function(D, R) {
            return D.indexOf(R) >= 0 ? D : [].concat(Ya(D), [R]);
          }, []));
        } else if (x === "category")
          m ? M = M.filter(function(D) {
            return D !== "" && !Me(D);
          }) : M = fg(X, M, v).reduce(function(D, R) {
            return D.indexOf(R) >= 0 || R === "" || Me(R) ? D : [].concat(Ya(D), [R]);
          }, []);
        else if (x === "number") {
          var re = qU(P, a.filter(function(D) {
            return D.props[o] === A && (S || !D.props.hide);
          }), w, i, l);
          re && (M = re);
        }
        p && (x === "number" || C !== "auto") && (G = qi(P, w, "category"));
      } else p ? M = ks(0, T) : u && u[A] && u[A].hasStack && x === "number" ? M = d === "expand" ? [0, 1] : A5(u[A].stackGroups, s, c) : M = w5(P, a.filter(function(D) {
        return D.props[o] === A && (S || !D.props.hide);
      }), x, l, !0);
      if (x === "number")
        M = s1(f, M, A, i, O), X && (M = $d(X, M, y));
      else if (x === "category" && X) {
        var j = X, W = M.every(function(D) {
          return j.indexOf(D) >= 0;
        });
        W && (M = j);
      }
    }
    return te(te({}, h), {}, me({}, A, te(te({}, v.props), {}, {
      axisType: i,
      domain: M,
      categoricalDomain: G,
      duplicateDomain: I,
      originalDomain: (g = v.props.domain) !== null && g !== void 0 ? g : Y,
      isCategorical: p,
      layout: l
    })));
  }, {});
}, jQ = function(t, r) {
  var n = r.graphicalItems, a = r.Axis, i = r.axisType, o = r.axisIdKey, u = r.stackGroups, s = r.dataStartIndex, c = r.dataEndIndex, l = t.layout, f = t.children, d = $c(t.data, {
    graphicalItems: n,
    dataStartIndex: s,
    dataEndIndex: c
  }), p = d.length, h = O5(l, i), v = -1;
  return n.reduce(function(g, b) {
    var x = b.props[o], w = b6("number");
    if (!g[x]) {
      v++;
      var y;
      return h ? y = ks(0, p) : u && u[x] && u[x].hasStack ? (y = A5(u[x].stackGroups, s, c), y = s1(f, y, x, i)) : (y = $d(w, w5(d, n.filter(function(m) {
        return m.props[o] === x && !m.props.hide;
      }), "number", l), a.defaultProps.allowDataOverflow), y = s1(f, y, x, i)), te(te({}, g), {}, me({}, x, te(te({
        axisType: i
      }, a.defaultProps), {}, {
        hide: !0,
        orientation: ve(_Q, "".concat(i, ".").concat(v % 2), null),
        domain: y,
        originalDomain: w,
        isCategorical: h,
        layout: l
        // specify scale when no Axis
        // scale: isCategorical ? 'band' : 'linear',
      })));
    }
    return g;
  }, {});
}, RQ = function(t, r) {
  var n = r.axisType, a = n === void 0 ? "xAxis" : n, i = r.AxisComp, o = r.graphicalItems, u = r.stackGroups, s = r.dataStartIndex, c = r.dataEndIndex, l = t.children, f = "".concat(a, "Id"), d = br(l, i), p = {};
  return d && d.length ? p = MQ(t, {
    axes: d,
    graphicalItems: o,
    axisType: a,
    axisIdKey: f,
    stackGroups: u,
    dataStartIndex: s,
    dataEndIndex: c
  }) : o && o.length && (p = jQ(t, {
    Axis: i,
    graphicalItems: o,
    axisType: a,
    axisIdKey: f,
    stackGroups: u,
    dataStartIndex: s,
    dataEndIndex: c
  })), p;
}, NQ = function(t) {
  var r = cn(t), n = Wr(r, !1, !0);
  return {
    tooltipTicks: n,
    orderedTooltipTicks: pp(n, function(a) {
      return a.coordinate;
    }),
    tooltipAxis: r,
    tooltipAxisBandSize: Is(r, n)
  };
}, Rm = function(t) {
  var r = t.children, n = t.defaultShowTooltip, a = Ut(r, Va), i = 0, o = 0;
  return t.data && t.data.length !== 0 && (o = t.data.length - 1), a && a.props && (a.props.startIndex >= 0 && (i = a.props.startIndex), a.props.endIndex >= 0 && (o = a.props.endIndex)), {
    chartX: 0,
    chartY: 0,
    dataStartIndex: i,
    dataEndIndex: o,
    activeTooltipIndex: -1,
    isTooltipActive: !!n
  };
}, $Q = function(t) {
  return !t || !t.length ? !1 : t.some(function(r) {
    var n = Hr(r && r.type);
    return n && n.indexOf("Bar") >= 0;
  });
}, Nm = function(t) {
  return t === "horizontal" ? {
    numericAxisName: "yAxis",
    cateAxisName: "xAxis"
  } : t === "vertical" ? {
    numericAxisName: "xAxis",
    cateAxisName: "yAxis"
  } : t === "centric" ? {
    numericAxisName: "radiusAxis",
    cateAxisName: "angleAxis"
  } : {
    numericAxisName: "angleAxis",
    cateAxisName: "radiusAxis"
  };
}, FQ = function(t, r) {
  var n = t.props, a = t.graphicalItems, i = t.xAxisMap, o = i === void 0 ? {} : i, u = t.yAxisMap, s = u === void 0 ? {} : u, c = n.width, l = n.height, f = n.children, d = n.margin || {}, p = Ut(f, Va), h = Ut(f, Ra), v = Object.keys(s).reduce(function(m, C) {
    var O = s[C], S = O.orientation;
    return !O.mirror && !O.hide ? te(te({}, m), {}, me({}, S, m[S] + O.width)) : m;
  }, {
    left: d.left || 0,
    right: d.right || 0
  }), g = Object.keys(o).reduce(function(m, C) {
    var O = o[C], S = O.orientation;
    return !O.mirror && !O.hide ? te(te({}, m), {}, me({}, S, ve(m, "".concat(S)) + O.height)) : m;
  }, {
    top: d.top || 0,
    bottom: d.bottom || 0
  }), b = te(te({}, g), v), x = b.bottom;
  p && (b.bottom += p.props.height || Va.defaultProps.height), h && r && (b = ZU(b, a, n, r));
  var w = c - b.left - b.right, y = l - b.top - b.bottom;
  return te(te({
    brushBottom: x
  }, b), {}, {
    // never return negative values for height and width
    width: Math.max(w, 0),
    height: Math.max(y, 0)
  });
}, DQ = function(t, r) {
  if (r === "xAxis")
    return t[r].width;
  if (r === "yAxis")
    return t[r].height;
}, kQ = function(t) {
  var r, n = t.chartName, a = t.GraphicalChild, i = t.defaultTooltipEventType, o = i === void 0 ? "axis" : i, u = t.validateTooltipEventTypes, s = u === void 0 ? ["axis"] : u, c = t.axisComponents, l = t.legendContent, f = t.formatAxisMap, d = t.defaultProps, p = function(g, b) {
    var x = b.graphicalItems, w = b.stackGroups, y = b.offset, m = b.updateId, C = b.dataStartIndex, O = b.dataEndIndex, S = g.barSize, A = g.layout, P = g.barGap, T = g.barCategoryGap, M = g.maxBarSize, I = Nm(A), G = I.numericAxisName, Y = I.cateAxisName, L = $Q(x), X = [];
    return x.forEach(function(q, re) {
      var j = $c(g.data, {
        graphicalItems: [q],
        dataStartIndex: C,
        dataEndIndex: O
      }), W = q.props, D = W.dataKey, R = W.maxBarSize, $ = q.props["".concat(G, "Id")], B = q.props["".concat(Y, "Id")], H = {}, z = c.reduce(function(pe, ie) {
        var Te, Qe, Ot = b["".concat(ie.axisType, "Map")], Gt = q.props["".concat(ie.axisType, "Id")];
        Ot && Ot[Gt] || ie.axisType === "zAxis" || (process.env.NODE_ENV !== "production" ? kt(!1, "Specifying a(n) ".concat(ie.axisType, "Id requires a corresponding ").concat(
          ie.axisType,
          "Id on the targeted graphical component "
        ).concat((Te = q == null || (Qe = q.type) === null || Qe === void 0 ? void 0 : Qe.displayName) !== null && Te !== void 0 ? Te : "")) : kt());
        var qt = Ot[Gt];
        return te(te({}, pe), {}, me(me({}, ie.axisType, qt), "".concat(ie.axisType, "Ticks"), Wr(qt)));
      }, H), J = z[Y], U = z["".concat(Y, "Ticks")], F = w && w[$] && w[$].hasStack && cz(q, w[$].stackGroups), k = Hr(q.type).indexOf("Bar") >= 0, E = Is(J, U), K = [], Z = L && YU({
        barSize: S,
        stackGroups: w,
        totalSize: DQ(z, Y)
      });
      if (k) {
        var Q, ne, ue = Me(R) ? M : R, de = (Q = (ne = Is(J, U, !0)) !== null && ne !== void 0 ? ne : ue) !== null && Q !== void 0 ? Q : 0;
        K = XU({
          barGap: P,
          barCategoryGap: T,
          bandSize: de !== E ? de : E,
          sizeList: Z[B],
          maxBarSize: ue
        }), de !== E && (K = K.map(function(pe) {
          return te(te({}, pe), {}, {
            position: te(te({}, pe.position), {}, {
              offset: pe.position.offset - de / 2
            })
          });
        }));
      }
      var le = q && q.type && q.type.getComposedData;
      le && X.push({
        props: te(te({}, le(te(te({}, z), {}, {
          displayedData: j,
          props: g,
          dataKey: D,
          item: q,
          bandSize: E,
          barPosition: K,
          offset: y,
          stackedData: F,
          layout: A,
          dataStartIndex: C,
          dataEndIndex: O
        }))), {}, me(me(me({
          key: q.key || "item-".concat(re)
        }, G, z[G]), Y, z[Y]), "animationId", m)),
        childIndex: eM(q, g.children),
        item: q
      });
    }), X;
  }, h = function(g, b) {
    var x = g.props, w = g.dataStartIndex, y = g.dataEndIndex, m = g.updateId;
    if (!av({
      props: x
    }))
      return null;
    var C = x.children, O = x.layout, S = x.stackOffset, A = x.data, P = x.reverseStackOrder, T = Nm(O), M = T.numericAxisName, I = T.cateAxisName, G = br(C, a), Y = oz(A, G, "".concat(M, "Id"), "".concat(I, "Id"), S, P), L = c.reduce(function(W, D) {
      var R = "".concat(D.axisType, "Map");
      return te(te({}, W), {}, me({}, R, RQ(x, te(te({}, D), {}, {
        graphicalItems: G,
        stackGroups: D.axisType === M && Y,
        dataStartIndex: w,
        dataEndIndex: y
      }))));
    }, {}), X = FQ(te(te({}, L), {}, {
      props: x,
      graphicalItems: G
    }), b == null ? void 0 : b.legendBBox);
    Object.keys(L).forEach(function(W) {
      L[W] = f(x, L[W], X, W.replace("Map", ""), n);
    });
    var q = L["".concat(I, "Map")], re = NQ(q), j = p(x, te(te({}, L), {}, {
      dataStartIndex: w,
      dataEndIndex: y,
      updateId: m,
      graphicalItems: G,
      stackGroups: Y,
      offset: X
    }));
    return te(te({
      formattedGraphicalItems: j,
      graphicalItems: G,
      offset: X,
      stackGroups: Y
    }, re), L);
  };
  return r = /* @__PURE__ */ function(v) {
    wQ(g, v);
    function g(b) {
      var x, w, y;
      return mQ(this, g), y = xQ(this, g, [b]), me(Re(y), "eventEmitterSymbol", Symbol("rechartsEventEmitter")), me(Re(y), "accessibilityManager", new nQ()), me(Re(y), "handleLegendBBoxUpdate", function(m) {
        if (m) {
          var C = y.state, O = C.dataStartIndex, S = C.dataEndIndex, A = C.updateId;
          y.setState(te({
            legendBBox: m
          }, h({
            props: y.props,
            dataStartIndex: O,
            dataEndIndex: S,
            updateId: A
          }, te(te({}, y.state), {}, {
            legendBBox: m
          }))));
        }
      }), me(Re(y), "handleReceiveSyncEvent", function(m, C, O) {
        if (y.props.syncId === m) {
          if (O === y.eventEmitterSymbol && typeof y.props.syncMethod != "function")
            return;
          y.applySyncEvent(C);
        }
      }), me(Re(y), "handleBrushChange", function(m) {
        var C = m.startIndex, O = m.endIndex;
        if (C !== y.state.dataStartIndex || O !== y.state.dataEndIndex) {
          var S = y.state.updateId;
          y.setState(function() {
            return te({
              dataStartIndex: C,
              dataEndIndex: O
            }, h({
              props: y.props,
              dataStartIndex: C,
              dataEndIndex: O,
              updateId: S
            }, y.state));
          }), y.triggerSyncEvent({
            dataStartIndex: C,
            dataEndIndex: O
          });
        }
      }), me(Re(y), "handleMouseEnter", function(m) {
        var C = y.getMouseInfo(m);
        if (C) {
          var O = te(te({}, C), {}, {
            isTooltipActive: !0
          });
          y.setState(O), y.triggerSyncEvent(O);
          var S = y.props.onMouseEnter;
          _e(S) && S(O, m);
        }
      }), me(Re(y), "triggeredAfterMouseMove", function(m) {
        var C = y.getMouseInfo(m), O = C ? te(te({}, C), {}, {
          isTooltipActive: !0
        }) : {
          isTooltipActive: !1
        };
        y.setState(O), y.triggerSyncEvent(O);
        var S = y.props.onMouseMove;
        _e(S) && S(O, m);
      }), me(Re(y), "handleItemMouseEnter", function(m) {
        y.setState(function() {
          return {
            isTooltipActive: !0,
            activeItem: m,
            activePayload: m.tooltipPayload,
            activeCoordinate: m.tooltipPosition || {
              x: m.cx,
              y: m.cy
            }
          };
        });
      }), me(Re(y), "handleItemMouseLeave", function() {
        y.setState(function() {
          return {
            isTooltipActive: !1
          };
        });
      }), me(Re(y), "handleMouseMove", function(m) {
        m.persist(), y.throttleTriggeredAfterMouseMove(m);
      }), me(Re(y), "handleMouseLeave", function(m) {
        y.throttleTriggeredAfterMouseMove.cancel();
        var C = {
          isTooltipActive: !1
        };
        y.setState(C), y.triggerSyncEvent(C);
        var O = y.props.onMouseLeave;
        _e(O) && O(C, m);
      }), me(Re(y), "handleOuterEvent", function(m) {
        var C = QT(m), O = ve(y.props, "".concat(C));
        if (C && _e(O)) {
          var S, A;
          /.*touch.*/i.test(C) ? A = y.getMouseInfo(m.changedTouches[0]) : A = y.getMouseInfo(m), O((S = A) !== null && S !== void 0 ? S : {}, m);
        }
      }), me(Re(y), "handleClick", function(m) {
        var C = y.getMouseInfo(m);
        if (C) {
          var O = te(te({}, C), {}, {
            isTooltipActive: !0
          });
          y.setState(O), y.triggerSyncEvent(O);
          var S = y.props.onClick;
          _e(S) && S(O, m);
        }
      }), me(Re(y), "handleMouseDown", function(m) {
        var C = y.props.onMouseDown;
        if (_e(C)) {
          var O = y.getMouseInfo(m);
          C(O, m);
        }
      }), me(Re(y), "handleMouseUp", function(m) {
        var C = y.props.onMouseUp;
        if (_e(C)) {
          var O = y.getMouseInfo(m);
          C(O, m);
        }
      }), me(Re(y), "handleTouchMove", function(m) {
        m.changedTouches != null && m.changedTouches.length > 0 && y.throttleTriggeredAfterMouseMove(m.changedTouches[0]);
      }), me(Re(y), "handleTouchStart", function(m) {
        m.changedTouches != null && m.changedTouches.length > 0 && y.handleMouseDown(m.changedTouches[0]);
      }), me(Re(y), "handleTouchEnd", function(m) {
        m.changedTouches != null && m.changedTouches.length > 0 && y.handleMouseUp(m.changedTouches[0]);
      }), me(Re(y), "triggerSyncEvent", function(m) {
        y.props.syncId !== void 0 && sf.emit(cf, y.props.syncId, m, y.eventEmitterSymbol);
      }), me(Re(y), "applySyncEvent", function(m) {
        var C = y.props, O = C.layout, S = C.syncMethod, A = y.state.updateId, P = m.dataStartIndex, T = m.dataEndIndex;
        if (m.dataStartIndex !== void 0 || m.dataEndIndex !== void 0)
          y.setState(te({
            dataStartIndex: P,
            dataEndIndex: T
          }, h({
            props: y.props,
            dataStartIndex: P,
            dataEndIndex: T,
            updateId: A
          }, y.state)));
        else if (m.activeTooltipIndex !== void 0) {
          var M = m.chartX, I = m.chartY, G = m.activeTooltipIndex, Y = y.state, L = Y.offset, X = Y.tooltipTicks;
          if (!L)
            return;
          if (typeof S == "function")
            G = S(X, m);
          else if (S === "value") {
            G = -1;
            for (var q = 0; q < X.length; q++)
              if (X[q].value === m.activeLabel) {
                G = q;
                break;
              }
          }
          var re = te(te({}, L), {}, {
            x: L.left,
            y: L.top
          }), j = Math.min(M, re.x + re.width), W = Math.min(I, re.y + re.height), D = X[G] && X[G].value, R = f1(y.state, y.props.data, G), $ = X[G] ? {
            x: O === "horizontal" ? X[G].coordinate : j,
            y: O === "horizontal" ? W : X[G].coordinate
          } : y6;
          y.setState(te(te({}, m), {}, {
            activeLabel: D,
            activeCoordinate: $,
            activePayload: R,
            activeTooltipIndex: G
          }));
        } else
          y.setState(m);
      }), me(Re(y), "renderCursor", function(m) {
        var C, O = y.state, S = O.isTooltipActive, A = O.activeCoordinate, P = O.activePayload, T = O.offset, M = O.activeTooltipIndex, I = O.tooltipAxisBandSize, G = y.getTooltipEventType(), Y = (C = m.props.active) !== null && C !== void 0 ? C : S, L = y.props.layout, X = m.key || "_recharts-cursor";
        return /* @__PURE__ */ N.createElement(lQ, {
          key: X,
          activeCoordinate: A,
          activePayload: P,
          activeTooltipIndex: M,
          chartName: n,
          element: m,
          isActive: Y,
          layout: L,
          offset: T,
          tooltipAxisBandSize: I,
          tooltipEventType: G
        });
      }), me(Re(y), "renderPolarAxis", function(m, C, O) {
        var S = ve(m, "type.axisType"), A = ve(y.state, "".concat(S, "Map")), P = A && A[m.props["".concat(S, "Id")]];
        return /* @__PURE__ */ vt(m, te(te({}, P), {}, {
          className: Ne(S, P.className),
          key: m.key || "".concat(C, "-").concat(O),
          ticks: Wr(P, !0)
        }));
      }), me(Re(y), "renderPolarGrid", function(m) {
        var C = m.props, O = C.radialLines, S = C.polarAngles, A = C.polarRadius, P = y.state, T = P.radiusAxisMap, M = P.angleAxisMap, I = cn(T), G = cn(M), Y = G.cx, L = G.cy, X = G.innerRadius, q = G.outerRadius;
        return /* @__PURE__ */ vt(m, {
          polarAngles: Array.isArray(S) ? S : Wr(G, !0).map(function(re) {
            return re.coordinate;
          }),
          polarRadius: Array.isArray(A) ? A : Wr(I, !0).map(function(re) {
            return re.coordinate;
          }),
          cx: Y,
          cy: L,
          innerRadius: X,
          outerRadius: q,
          key: m.key || "polar-grid",
          radialLines: O
        });
      }), me(Re(y), "renderLegend", function() {
        var m = y.state.formattedGraphicalItems, C = y.props, O = C.children, S = C.width, A = C.height, P = y.props.margin || {}, T = S - (P.left || 0) - (P.right || 0), M = x5({
          children: O,
          formattedGraphicalItems: m,
          legendWidth: T,
          legendContent: l
        });
        if (!M)
          return null;
        var I = M.item, G = Tm(M, fQ);
        return /* @__PURE__ */ vt(I, te(te({}, G), {}, {
          chartWidth: S,
          chartHeight: A,
          margin: P,
          onBBoxUpdate: y.handleLegendBBoxUpdate
        }));
      }), me(Re(y), "renderTooltip", function() {
        var m, C = y.props, O = C.children, S = C.accessibilityLayer, A = Ut(O, wr);
        if (!A)
          return null;
        var P = y.state, T = P.isTooltipActive, M = P.activeCoordinate, I = P.activePayload, G = P.activeLabel, Y = P.offset, L = (m = A.props.active) !== null && m !== void 0 ? m : T;
        return /* @__PURE__ */ vt(A, {
          viewBox: te(te({}, Y), {}, {
            x: Y.left,
            y: Y.top
          }),
          active: L,
          label: G,
          payload: L ? I : [],
          coordinate: M,
          accessibilityLayer: S
        });
      }), me(Re(y), "renderBrush", function(m) {
        var C = y.props, O = C.margin, S = C.data, A = y.state, P = A.offset, T = A.dataStartIndex, M = A.dataEndIndex, I = A.updateId;
        return /* @__PURE__ */ vt(m, {
          key: m.key || "_recharts-brush",
          onChange: Iu(y.handleBrushChange, m.props.onChange),
          data: S,
          x: oe(m.props.x) ? m.props.x : P.left,
          y: oe(m.props.y) ? m.props.y : P.top + P.height + P.brushBottom - (O.bottom || 0),
          width: oe(m.props.width) ? m.props.width : P.width,
          startIndex: T,
          endIndex: M,
          updateId: "brush-".concat(I)
        });
      }), me(Re(y), "renderReferenceElement", function(m, C, O) {
        if (!m)
          return null;
        var S = Re(y), A = S.clipPathId, P = y.state, T = P.xAxisMap, M = P.yAxisMap, I = P.offset, G = m.props, Y = G.xAxisId, L = G.yAxisId;
        return /* @__PURE__ */ vt(m, {
          key: m.key || "".concat(C, "-").concat(O),
          xAxis: T[Y],
          yAxis: M[L],
          viewBox: {
            x: I.left,
            y: I.top,
            width: I.width,
            height: I.height
          },
          clipPathId: A
        });
      }), me(Re(y), "renderActivePoints", function(m) {
        var C = m.item, O = m.activePoint, S = m.basePoint, A = m.childIndex, P = m.isRange, T = [], M = C.props.key, I = C.item.props, G = I.activeDot, Y = I.dataKey, L = te(te({
          index: A,
          dataKey: Y,
          cx: O.x,
          cy: O.y,
          r: 4,
          fill: Lp(C.item),
          strokeWidth: 2,
          stroke: "#fff",
          payload: O.payload,
          value: O.value,
          key: "".concat(M, "-activePoint-").concat(A)
        }, Ie(G, !1)), es(G));
        return T.push(g.renderActiveDot(G, L)), S ? T.push(g.renderActiveDot(G, te(te({}, L), {}, {
          cx: S.x,
          cy: S.y,
          key: "".concat(M, "-basePoint-").concat(A)
        }))) : P && T.push(null), T;
      }), me(Re(y), "renderGraphicChild", function(m, C, O) {
        var S = y.filterFormatItem(m, C, O);
        if (!S)
          return null;
        var A = y.getTooltipEventType(), P = y.state, T = P.isTooltipActive, M = P.tooltipAxis, I = P.activeTooltipIndex, G = P.activeLabel, Y = y.props.children, L = Ut(Y, wr), X = S.props, q = X.points, re = X.isRange, j = X.baseLine, W = S.item.props, D = W.activeDot, R = W.hide, $ = W.activeBar, B = W.activeShape, H = !!(!R && T && L && (D || $ || B)), z = {};
        A !== "axis" && L && L.props.trigger === "click" ? z = {
          onClick: Iu(y.handleItemMouseEnter, m.props.onClick)
        } : A !== "axis" && (z = {
          onMouseLeave: Iu(y.handleItemMouseLeave, m.props.onMouseLeave),
          onMouseEnter: Iu(y.handleItemMouseEnter, m.props.onMouseEnter)
        });
        var J = /* @__PURE__ */ vt(m, te(te({}, S.props), z));
        function U(ie) {
          return typeof M.dataKey == "function" ? M.dataKey(ie.payload) : null;
        }
        if (H)
          if (I >= 0) {
            var F, k;
            if (M.dataKey && !M.allowDuplicatedCategory) {
              var E = typeof M.dataKey == "function" ? U : "payload.".concat(M.dataKey.toString());
              F = Qu(q, E, G), k = re && j && Qu(j, E, G);
            } else
              F = q == null ? void 0 : q[I], k = re && j && j[I];
            if (B || $) {
              var K = m.props.activeIndex !== void 0 ? m.props.activeIndex : I;
              return [/* @__PURE__ */ vt(m, te(te(te({}, S.props), z), {}, {
                activeIndex: K
              })), null, null];
            }
            if (!Me(F))
              return [J].concat(Ya(y.renderActivePoints({
                item: S,
                activePoint: F,
                basePoint: k,
                childIndex: I,
                isRange: re
              })));
          } else {
            var Z, Q = (Z = y.getItemByXY(y.state.activeCoordinate)) !== null && Z !== void 0 ? Z : {
              graphicalItem: J
            }, ne = Q.graphicalItem, ue = ne.item, de = ue === void 0 ? m : ue, le = ne.childIndex, pe = te(te(te({}, S.props), z), {}, {
              activeIndex: le
            });
            return [/* @__PURE__ */ vt(de, pe), null, null];
          }
        return re ? [J, null, null] : [J, null];
      }), me(Re(y), "renderCustomized", function(m, C, O) {
        return /* @__PURE__ */ vt(m, te(te({
          key: "recharts-customized-".concat(O)
        }, y.props), y.state));
      }), me(Re(y), "renderMap", {
        CartesianGrid: {
          handler: Ru,
          once: !0
        },
        ReferenceArea: {
          handler: y.renderReferenceElement
        },
        ReferenceLine: {
          handler: Ru
        },
        ReferenceDot: {
          handler: y.renderReferenceElement
        },
        XAxis: {
          handler: Ru
        },
        YAxis: {
          handler: Ru
        },
        Brush: {
          handler: y.renderBrush,
          once: !0
        },
        Bar: {
          handler: y.renderGraphicChild
        },
        Line: {
          handler: y.renderGraphicChild
        },
        Area: {
          handler: y.renderGraphicChild
        },
        Radar: {
          handler: y.renderGraphicChild
        },
        RadialBar: {
          handler: y.renderGraphicChild
        },
        Scatter: {
          handler: y.renderGraphicChild
        },
        Pie: {
          handler: y.renderGraphicChild
        },
        Funnel: {
          handler: y.renderGraphicChild
        },
        Tooltip: {
          handler: y.renderCursor,
          once: !0
        },
        PolarGrid: {
          handler: y.renderPolarGrid,
          once: !0
        },
        PolarAngleAxis: {
          handler: y.renderPolarAxis
        },
        PolarRadiusAxis: {
          handler: y.renderPolarAxis
        },
        Customized: {
          handler: y.renderCustomized
        }
      }), y.clipPathId = "".concat((x = b.id) !== null && x !== void 0 ? x : ru("recharts"), "-clip"), y.throttleTriggeredAfterMouseMove = w4(y.triggeredAfterMouseMove, (w = b.throttleDelay) !== null && w !== void 0 ? w : 1e3 / 60), y.state = {}, y;
    }
    return bQ(g, [{
      key: "componentDidMount",
      value: function() {
        var x, w;
        this.addListener(), this.accessibilityManager.setDetails({
          container: this.container,
          offset: {
            left: (x = this.props.margin.left) !== null && x !== void 0 ? x : 0,
            top: (w = this.props.margin.top) !== null && w !== void 0 ? w : 0
          },
          coordinateList: this.state.tooltipTicks,
          mouseHandlerCallback: this.triggeredAfterMouseMove,
          layout: this.props.layout
        }), this.displayDefaultTooltip();
      }
    }, {
      key: "displayDefaultTooltip",
      value: function() {
        var x = this.props, w = x.children, y = x.data, m = x.height, C = x.layout, O = Ut(w, wr);
        if (O) {
          var S = O.props.defaultIndex;
          if (!(typeof S != "number" || S < 0 || S > this.state.tooltipTicks.length)) {
            var A = this.state.tooltipTicks[S] && this.state.tooltipTicks[S].value, P = f1(this.state, y, S, A), T = this.state.tooltipTicks[S].coordinate, M = (this.state.offset.top + m) / 2, I = C === "horizontal", G = I ? {
              x: T,
              y: M
            } : {
              y: T,
              x: M
            }, Y = this.state.formattedGraphicalItems.find(function(X) {
              var q = X.item;
              return q.type.name === "Scatter";
            });
            Y && (G = te(te({}, G), Y.props.points[S].tooltipPosition), P = Y.props.points[S].tooltipPayload);
            var L = {
              activeTooltipIndex: S,
              isTooltipActive: !0,
              activeLabel: A,
              activePayload: P,
              activeCoordinate: G
            };
            this.setState(L), this.renderCursor(O), this.accessibilityManager.setIndex(S);
          }
        }
      }
    }, {
      key: "getSnapshotBeforeUpdate",
      value: function(x, w) {
        if (!this.props.accessibilityLayer)
          return null;
        if (this.state.tooltipTicks !== w.tooltipTicks && this.accessibilityManager.setDetails({
          coordinateList: this.state.tooltipTicks
        }), this.props.layout !== x.layout && this.accessibilityManager.setDetails({
          layout: this.props.layout
        }), this.props.margin !== x.margin) {
          var y, m;
          this.accessibilityManager.setDetails({
            offset: {
              left: (y = this.props.margin.left) !== null && y !== void 0 ? y : 0,
              top: (m = this.props.margin.top) !== null && m !== void 0 ? m : 0
            }
          });
        }
        return null;
      }
    }, {
      key: "componentDidUpdate",
      value: function(x) {
        Kf([Ut(x.children, wr)], [Ut(this.props.children, wr)]) || this.displayDefaultTooltip();
      }
    }, {
      key: "componentWillUnmount",
      value: function() {
        this.removeListener(), this.throttleTriggeredAfterMouseMove.cancel();
      }
    }, {
      key: "getTooltipEventType",
      value: function() {
        var x = Ut(this.props.children, wr);
        if (x && typeof x.props.shared == "boolean") {
          var w = x.props.shared ? "axis" : "item";
          return s.indexOf(w) >= 0 ? w : o;
        }
        return o;
      }
      /**
       * Get the information of mouse in chart, return null when the mouse is not in the chart
       * @param  {MousePointer} event    The event object
       * @return {Object}          Mouse data
       */
    }, {
      key: "getMouseInfo",
      value: function(x) {
        if (!this.container)
          return null;
        var w = this.container, y = w.getBoundingClientRect(), m = EV(y), C = {
          chartX: Math.round(x.pageX - m.left),
          chartY: Math.round(x.pageY - m.top)
        }, O = y.width / w.offsetWidth || 1, S = this.inRange(C.chartX, C.chartY, O);
        if (!S)
          return null;
        var A = this.state, P = A.xAxisMap, T = A.yAxisMap, M = this.getTooltipEventType();
        if (M !== "axis" && P && T) {
          var I = cn(P).scale, G = cn(T).scale, Y = I && I.invert ? I.invert(C.chartX) : null, L = G && G.invert ? G.invert(C.chartY) : null;
          return te(te({}, C), {}, {
            xValue: Y,
            yValue: L
          });
        }
        var X = jm(this.state, this.props.data, this.props.layout, S);
        return X ? te(te({}, C), X) : null;
      }
    }, {
      key: "inRange",
      value: function(x, w) {
        var y = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, m = this.props.layout, C = x / y, O = w / y;
        if (m === "horizontal" || m === "vertical") {
          var S = this.state.offset, A = C >= S.left && C <= S.left + S.width && O >= S.top && O <= S.top + S.height;
          return A ? {
            x: C,
            y: O
          } : null;
        }
        var P = this.state, T = P.angleAxisMap, M = P.radiusAxisMap;
        if (T && M) {
          var I = cn(T);
          return hg({
            x: C,
            y: O
          }, I);
        }
        return null;
      }
    }, {
      key: "parseEventsOfWrapper",
      value: function() {
        var x = this.props.children, w = this.getTooltipEventType(), y = Ut(x, wr), m = {};
        y && w === "axis" && (y.props.trigger === "click" ? m = {
          onClick: this.handleClick
        } : m = {
          onMouseEnter: this.handleMouseEnter,
          onMouseMove: this.handleMouseMove,
          onMouseLeave: this.handleMouseLeave,
          onTouchMove: this.handleTouchMove,
          onTouchStart: this.handleTouchStart,
          onTouchEnd: this.handleTouchEnd
        });
        var C = es(this.props, this.handleOuterEvent);
        return te(te({}, C), m);
      }
    }, {
      key: "addListener",
      value: function() {
        sf.on(cf, this.handleReceiveSyncEvent);
      }
    }, {
      key: "removeListener",
      value: function() {
        sf.removeListener(cf, this.handleReceiveSyncEvent);
      }
    }, {
      key: "filterFormatItem",
      value: function(x, w, y) {
        for (var m = this.state.formattedGraphicalItems, C = 0, O = m.length; C < O; C++) {
          var S = m[C];
          if (S.item === x || S.props.key === x.key || w === Hr(S.item.type) && y === S.childIndex)
            return S;
        }
        return null;
      }
    }, {
      key: "renderClipPath",
      value: function() {
        var x = this.clipPathId, w = this.state.offset, y = w.left, m = w.top, C = w.height, O = w.width;
        return /* @__PURE__ */ N.createElement("defs", null, /* @__PURE__ */ N.createElement("clipPath", {
          id: x
        }, /* @__PURE__ */ N.createElement("rect", {
          x: y,
          y: m,
          height: C,
          width: O
        })));
      }
    }, {
      key: "getXScales",
      value: function() {
        var x = this.state.xAxisMap;
        return x ? Object.entries(x).reduce(function(w, y) {
          var m = Pm(y, 2), C = m[0], O = m[1];
          return te(te({}, w), {}, me({}, C, O.scale));
        }, {}) : null;
      }
    }, {
      key: "getYScales",
      value: function() {
        var x = this.state.yAxisMap;
        return x ? Object.entries(x).reduce(function(w, y) {
          var m = Pm(y, 2), C = m[0], O = m[1];
          return te(te({}, w), {}, me({}, C, O.scale));
        }, {}) : null;
      }
    }, {
      key: "getXScaleByAxisId",
      value: function(x) {
        var w;
        return (w = this.state.xAxisMap) === null || w === void 0 || (w = w[x]) === null || w === void 0 ? void 0 : w.scale;
      }
    }, {
      key: "getYScaleByAxisId",
      value: function(x) {
        var w;
        return (w = this.state.yAxisMap) === null || w === void 0 || (w = w[x]) === null || w === void 0 ? void 0 : w.scale;
      }
    }, {
      key: "getItemByXY",
      value: function(x) {
        var w = this.state, y = w.formattedGraphicalItems, m = w.activeItem;
        if (y && y.length)
          for (var C = 0, O = y.length; C < O; C++) {
            var S = y[C], A = S.props, P = S.item, T = Hr(P.type);
            if (T === "Bar") {
              var M = (A.data || []).find(function(L) {
                return BX(x, L);
              });
              if (M)
                return {
                  graphicalItem: S,
                  payload: M
                };
            } else if (T === "RadialBar") {
              var I = (A.data || []).find(function(L) {
                return hg(x, L);
              });
              if (I)
                return {
                  graphicalItem: S,
                  payload: I
                };
            } else if (Tc(S, m) || Mc(S, m) || Lo(S, m)) {
              var G = GZ({
                graphicalItem: S,
                activeTooltipItem: m,
                itemData: P.props.data
              }), Y = P.props.activeIndex === void 0 ? G : P.props.activeIndex;
              return {
                graphicalItem: te(te({}, S), {}, {
                  childIndex: Y
                }),
                payload: Lo(S, m) ? P.props.data[G] : S.props.data[G]
              };
            }
          }
        return null;
      }
    }, {
      key: "render",
      value: function() {
        var x = this;
        if (!av(this))
          return null;
        var w = this.props, y = w.children, m = w.className, C = w.width, O = w.height, S = w.style, A = w.compact, P = w.title, T = w.desc, M = Tm(w, dQ), I = Ie(M, !1);
        if (A)
          return /* @__PURE__ */ N.createElement(dm, {
            state: this.state,
            width: this.props.width,
            height: this.props.height,
            clipPathId: this.clipPathId
          }, /* @__PURE__ */ N.createElement(Jf, eo({}, I, {
            width: C,
            height: O,
            title: P,
            desc: T
          }), this.renderClipPath(), ov(y, this.renderMap)));
        if (this.props.accessibilityLayer) {
          var G, Y;
          I.tabIndex = (G = this.props.tabIndex) !== null && G !== void 0 ? G : 0, I.role = (Y = this.props.role) !== null && Y !== void 0 ? Y : "application", I.onKeyDown = function(X) {
            x.accessibilityManager.keyboardEvent(X);
          }, I.onFocus = function() {
            x.accessibilityManager.focus();
          };
        }
        var L = this.parseEventsOfWrapper();
        return /* @__PURE__ */ N.createElement(dm, {
          state: this.state,
          width: this.props.width,
          height: this.props.height,
          clipPathId: this.clipPathId
        }, /* @__PURE__ */ N.createElement("div", eo({
          className: Ne("recharts-wrapper", m),
          style: te({
            position: "relative",
            cursor: "default",
            width: C,
            height: O
          }, S)
        }, L, {
          ref: function(q) {
            x.container = q;
          }
        }), /* @__PURE__ */ N.createElement(Jf, eo({}, I, {
          width: C,
          height: O,
          title: P,
          desc: T,
          style: IQ
        }), this.renderClipPath(), ov(y, this.renderMap)), this.renderLegend(), this.renderTooltip()));
      }
    }]), g;
  }(Za), me(r, "displayName", n), me(r, "defaultProps", te({
    layout: "horizontal",
    stackOffset: "none",
    barCategoryGap: "10%",
    barGap: 4,
    margin: {
      top: 5,
      right: 5,
      bottom: 5,
      left: 5
    },
    reverseStackOrder: !1,
    syncMethod: "index"
  }, d)), me(r, "getDerivedStateFromProps", function(v, g) {
    var b = v.dataKey, x = v.data, w = v.children, y = v.width, m = v.height, C = v.layout, O = v.stackOffset, S = v.margin, A = g.dataStartIndex, P = g.dataEndIndex;
    if (g.updateId === void 0) {
      var T = Rm(v);
      return te(te(te({}, T), {}, {
        updateId: 0
      }, h(te(te({
        props: v
      }, T), {}, {
        updateId: 0
      }), g)), {}, {
        prevDataKey: b,
        prevData: x,
        prevWidth: y,
        prevHeight: m,
        prevLayout: C,
        prevStackOffset: O,
        prevMargin: S,
        prevChildren: w
      });
    }
    if (b !== g.prevDataKey || x !== g.prevData || y !== g.prevWidth || m !== g.prevHeight || C !== g.prevLayout || O !== g.prevStackOffset || !ya(S, g.prevMargin)) {
      var M = Rm(v), I = {
        // (chartX, chartY) are (0,0) in default state, but we want to keep the last mouse position to avoid
        // any flickering
        chartX: g.chartX,
        chartY: g.chartY,
        // The tooltip should stay active when it was active in the previous render. If this is not
        // the case, the tooltip disappears and immediately re-appears, causing a flickering effect
        isTooltipActive: g.isTooltipActive
      }, G = te(te({}, jm(g, x, C)), {}, {
        updateId: g.updateId + 1
      }), Y = te(te(te({}, M), I), G);
      return te(te(te({}, Y), h(te({
        props: v
      }, Y), g)), {}, {
        prevDataKey: b,
        prevData: x,
        prevWidth: y,
        prevHeight: m,
        prevLayout: C,
        prevStackOffset: O,
        prevMargin: S,
        prevChildren: w
      });
    }
    if (!Kf(w, g.prevChildren)) {
      var L, X, q, re, j = Ut(w, Va), W = j && (L = (X = j.props) === null || X === void 0 ? void 0 : X.startIndex) !== null && L !== void 0 ? L : A, D = j && (q = (re = j.props) === null || re === void 0 ? void 0 : re.endIndex) !== null && q !== void 0 ? q : P, R = W !== A || D !== P, $ = !Me(x), B = $ && !R ? g.updateId : g.updateId + 1;
      return te(te({
        updateId: B
      }, h(te(te({
        props: v
      }, g), {}, {
        updateId: B,
        dataStartIndex: W,
        dataEndIndex: D
      }), g)), {}, {
        prevChildren: w,
        dataStartIndex: W,
        dataEndIndex: D
      });
    }
    return null;
  }), me(r, "renderActiveDot", function(v, g) {
    var b;
    return /* @__PURE__ */ _r(v) ? b = /* @__PURE__ */ vt(v, g) : _e(v) ? b = v(g) : b = /* @__PURE__ */ N.createElement(Vp, g), /* @__PURE__ */ N.createElement(ut, {
      className: "recharts-active-dot",
      key: g.key
    }, b);
  }), r;
}, LQ = kQ({
  chartName: "AreaChart",
  GraphicalChild: _n,
  axisComponents: [{
    axisType: "xAxis",
    AxisComp: Rc
  }, {
    axisType: "yAxis",
    AxisComp: Nc
  }],
  formatAxisMap: dq
});
const Bre = (e) => {
  const [t, r] = gn(e);
  return { toggle: t, toggleOn: () => r(!0), toggleOff: () => r(!1) };
};
var x6 = { exports: {} };
(function(e, t) {
  (function(n, a) {
    e.exports = a(N);
  })(pa, (r) => (
    /******/
    (() => {
      var n = {
        /***/
        "./node_modules/css-mediaquery/index.js": (
          /*!**********************************************!*\
            !*** ./node_modules/css-mediaquery/index.js ***!
            \**********************************************/
          /***/
          (u, s) => {
            s.match = h, s.parse = v;
            var c = /(?:(only|not)?\s*([^\s\(\)]+)(?:\s*and)?\s*)?(.+)?/i, l = /\(\s*([^\s\:\)]+)\s*(?:\:\s*([^\s\)]+))?\s*\)/, f = /^(?:(min|max)-)?(.+)/, d = /(em|rem|px|cm|mm|in|pt|pc)?$/, p = /(dpi|dpcm|dppx)?$/;
            function h(w, y) {
              return v(w).some(function(m) {
                var C = m.inverse, O = m.type === "all" || y.type === m.type;
                if (O && C || !(O || C))
                  return !1;
                var S = m.expressions.every(function(A) {
                  var P = A.feature, T = A.modifier, M = A.value, I = y[P];
                  if (!I)
                    return !1;
                  switch (P) {
                    case "orientation":
                    case "scan":
                      return I.toLowerCase() === M.toLowerCase();
                    case "width":
                    case "height":
                    case "device-width":
                    case "device-height":
                      M = x(M), I = x(I);
                      break;
                    case "resolution":
                      M = b(M), I = b(I);
                      break;
                    case "aspect-ratio":
                    case "device-aspect-ratio":
                    case /* Deprecated */
                    "device-pixel-ratio":
                      M = g(M), I = g(I);
                      break;
                    case "grid":
                    case "color":
                    case "color-index":
                    case "monochrome":
                      M = parseInt(M, 10) || 1, I = parseInt(I, 10) || 0;
                      break;
                  }
                  switch (T) {
                    case "min":
                      return I >= M;
                    case "max":
                      return I <= M;
                    default:
                      return I === M;
                  }
                });
                return S && !C || !S && C;
              });
            }
            function v(w) {
              return w.split(",").map(function(y) {
                y = y.trim();
                var m = y.match(c), C = m[1], O = m[2], S = m[3] || "", A = {};
                return A.inverse = !!C && C.toLowerCase() === "not", A.type = O ? O.toLowerCase() : "all", S = S.match(/\([^\)]+\)/g) || [], A.expressions = S.map(function(P) {
                  var T = P.match(l), M = T[1].toLowerCase().match(f);
                  return {
                    modifier: M[1],
                    feature: M[2],
                    value: T[2]
                  };
                }), A;
              });
            }
            function g(w) {
              var y = Number(w), m;
              return y || (m = w.match(/^(\d+)\s*\/\s*(\d+)$/), y = m[1] / m[2]), y;
            }
            function b(w) {
              var y = parseFloat(w), m = String(w).match(p)[1];
              switch (m) {
                case "dpcm":
                  return y / 2.54;
                case "dppx":
                  return y * 96;
                default:
                  return y;
              }
            }
            function x(w) {
              var y = parseFloat(w), m = String(w).match(d)[1];
              switch (m) {
                case "em":
                  return y * 16;
                case "rem":
                  return y * 16;
                case "cm":
                  return y * 96 / 2.54;
                case "mm":
                  return y * 96 / 2.54 / 10;
                case "in":
                  return y * 96;
                case "pt":
                  return y * 72;
                case "pc":
                  return y * 72 / 12;
                default:
                  return y;
              }
            }
          }
        ),
        /***/
        "./node_modules/hyphenate-style-name/index.js": (
          /*!****************************************************!*\
            !*** ./node_modules/hyphenate-style-name/index.js ***!
            \****************************************************/
          /***/
          (u, s, c) => {
            c.r(s), c.d(s, {
              /* harmony export */
              default: () => v
              /* harmony export */
            });
            var l = /[A-Z]/g, f = /^ms-/, d = {};
            function p(g) {
              return "-" + g.toLowerCase();
            }
            function h(g) {
              if (d.hasOwnProperty(g))
                return d[g];
              var b = g.replace(l, p);
              return d[g] = f.test(b) ? "-" + b : b;
            }
            const v = h;
          }
        ),
        /***/
        "./node_modules/matchmediaquery/index.js": (
          /*!***********************************************!*\
            !*** ./node_modules/matchmediaquery/index.js ***!
            \***********************************************/
          /***/
          (u, s, c) => {
            var l = c(
              /*! css-mediaquery */
              "./node_modules/css-mediaquery/index.js"
            ).match, f = typeof window < "u" ? window.matchMedia : null;
            function d(h, v, g) {
              var b = this;
              if (f && !g) {
                var x = f.call(window, h);
                this.matches = x.matches, this.media = x.media, x.addListener(m);
              } else
                this.matches = l(h, v), this.media = h;
              this.addListener = w, this.removeListener = y, this.dispose = C;
              function w(O) {
                x && x.addListener(O);
              }
              function y(O) {
                x && x.removeListener(O);
              }
              function m(O) {
                b.matches = O.matches, b.media = O.media;
              }
              function C() {
                x && x.removeListener(m);
              }
            }
            function p(h, v, g) {
              return new d(h, v, g);
            }
            u.exports = p;
          }
        ),
        /***/
        "./node_modules/object-assign/index.js": (
          /*!*********************************************!*\
            !*** ./node_modules/object-assign/index.js ***!
            \*********************************************/
          /***/
          (u) => {
            /*
            object-assign
            (c) Sindre Sorhus
            @license MIT
            */
            var s = Object.getOwnPropertySymbols, c = Object.prototype.hasOwnProperty, l = Object.prototype.propertyIsEnumerable;
            function f(p) {
              if (p == null)
                throw new TypeError("Object.assign cannot be called with null or undefined");
              return Object(p);
            }
            function d() {
              try {
                if (!Object.assign)
                  return !1;
                var p = new String("abc");
                if (p[5] = "de", Object.getOwnPropertyNames(p)[0] === "5")
                  return !1;
                for (var h = {}, v = 0; v < 10; v++)
                  h["_" + String.fromCharCode(v)] = v;
                var g = Object.getOwnPropertyNames(h).map(function(x) {
                  return h[x];
                });
                if (g.join("") !== "0123456789")
                  return !1;
                var b = {};
                return "abcdefghijklmnopqrst".split("").forEach(function(x) {
                  b[x] = x;
                }), Object.keys(Object.assign({}, b)).join("") === "abcdefghijklmnopqrst";
              } catch {
                return !1;
              }
            }
            u.exports = d() ? Object.assign : function(p, h) {
              for (var v, g = f(p), b, x = 1; x < arguments.length; x++) {
                v = Object(arguments[x]);
                for (var w in v)
                  c.call(v, w) && (g[w] = v[w]);
                if (s) {
                  b = s(v);
                  for (var y = 0; y < b.length; y++)
                    l.call(v, b[y]) && (g[b[y]] = v[b[y]]);
                }
              }
              return g;
            };
          }
        ),
        /***/
        "./node_modules/prop-types/checkPropTypes.js": (
          /*!***************************************************!*\
            !*** ./node_modules/prop-types/checkPropTypes.js ***!
            \***************************************************/
          /***/
          (u, s, c) => {
            var l = function() {
            };
            {
              var f = c(
                /*! ./lib/ReactPropTypesSecret */
                "./node_modules/prop-types/lib/ReactPropTypesSecret.js"
              ), d = {}, p = c(
                /*! ./lib/has */
                "./node_modules/prop-types/lib/has.js"
              );
              l = function(v) {
                var g = "Warning: " + v;
                typeof console < "u" && console.error(g);
                try {
                  throw new Error(g);
                } catch {
                }
              };
            }
            function h(v, g, b, x, w) {
              for (var y in v)
                if (p(v, y)) {
                  var m;
                  try {
                    if (typeof v[y] != "function") {
                      var C = Error(
                        (x || "React class") + ": " + b + " type `" + y + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof v[y] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
                      );
                      throw C.name = "Invariant Violation", C;
                    }
                    m = v[y](g, y, x, b, null, f);
                  } catch (S) {
                    m = S;
                  }
                  if (m && !(m instanceof Error) && l(
                    (x || "React class") + ": type specification of " + b + " `" + y + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof m + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
                  ), m instanceof Error && !(m.message in d)) {
                    d[m.message] = !0;
                    var O = w ? w() : "";
                    l(
                      "Failed " + b + " type: " + m.message + (O ?? "")
                    );
                  }
                }
            }
            h.resetWarningCache = function() {
              d = {};
            }, u.exports = h;
          }
        ),
        /***/
        "./node_modules/prop-types/factoryWithTypeCheckers.js": (
          /*!************************************************************!*\
            !*** ./node_modules/prop-types/factoryWithTypeCheckers.js ***!
            \************************************************************/
          /***/
          (u, s, c) => {
            var l = c(
              /*! react-is */
              "./node_modules/react-is/index.js"
            ), f = c(
              /*! object-assign */
              "./node_modules/object-assign/index.js"
            ), d = c(
              /*! ./lib/ReactPropTypesSecret */
              "./node_modules/prop-types/lib/ReactPropTypesSecret.js"
            ), p = c(
              /*! ./lib/has */
              "./node_modules/prop-types/lib/has.js"
            ), h = c(
              /*! ./checkPropTypes */
              "./node_modules/prop-types/checkPropTypes.js"
            ), v = function() {
            };
            v = function(b) {
              var x = "Warning: " + b;
              typeof console < "u" && console.error(x);
              try {
                throw new Error(x);
              } catch {
              }
            };
            function g() {
              return null;
            }
            u.exports = function(b, x) {
              var w = typeof Symbol == "function" && Symbol.iterator, y = "@@iterator";
              function m(F) {
                var k = F && (w && F[w] || F[y]);
                if (typeof k == "function")
                  return k;
              }
              var C = "<<anonymous>>", O = {
                array: T("array"),
                bigint: T("bigint"),
                bool: T("boolean"),
                func: T("function"),
                number: T("number"),
                object: T("object"),
                string: T("string"),
                symbol: T("symbol"),
                any: M(),
                arrayOf: I,
                element: G(),
                elementType: Y(),
                instanceOf: L,
                node: j(),
                objectOf: q,
                oneOf: X,
                oneOfType: re,
                shape: D,
                exact: R
              };
              function S(F, k) {
                return F === k ? F !== 0 || 1 / F === 1 / k : F !== F && k !== k;
              }
              function A(F, k) {
                this.message = F, this.data = k && typeof k == "object" ? k : {}, this.stack = "";
              }
              A.prototype = Error.prototype;
              function P(F) {
                var k = {}, E = 0;
                function K(Q, ne, ue, de, le, pe, ie) {
                  if (de = de || C, pe = pe || ue, ie !== d) {
                    if (x) {
                      var Te = new Error(
                        "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
                      );
                      throw Te.name = "Invariant Violation", Te;
                    } else if (typeof console < "u") {
                      var Qe = de + ":" + ue;
                      !k[Qe] && // Avoid spamming the console because they are often not actionable except for lib authors
                      E < 3 && (v(
                        "You are manually calling a React.PropTypes validation function for the `" + pe + "` prop on `" + de + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
                      ), k[Qe] = !0, E++);
                    }
                  }
                  return ne[ue] == null ? Q ? ne[ue] === null ? new A("The " + le + " `" + pe + "` is marked as required " + ("in `" + de + "`, but its value is `null`.")) : new A("The " + le + " `" + pe + "` is marked as required in " + ("`" + de + "`, but its value is `undefined`.")) : null : F(ne, ue, de, le, pe);
                }
                var Z = K.bind(null, !1);
                return Z.isRequired = K.bind(null, !0), Z;
              }
              function T(F) {
                function k(E, K, Z, Q, ne, ue) {
                  var de = E[K], le = H(de);
                  if (le !== F) {
                    var pe = z(de);
                    return new A(
                      "Invalid " + Q + " `" + ne + "` of type " + ("`" + pe + "` supplied to `" + Z + "`, expected ") + ("`" + F + "`."),
                      { expectedType: F }
                    );
                  }
                  return null;
                }
                return P(k);
              }
              function M() {
                return P(g);
              }
              function I(F) {
                function k(E, K, Z, Q, ne) {
                  if (typeof F != "function")
                    return new A("Property `" + ne + "` of component `" + Z + "` has invalid PropType notation inside arrayOf.");
                  var ue = E[K];
                  if (!Array.isArray(ue)) {
                    var de = H(ue);
                    return new A("Invalid " + Q + " `" + ne + "` of type " + ("`" + de + "` supplied to `" + Z + "`, expected an array."));
                  }
                  for (var le = 0; le < ue.length; le++) {
                    var pe = F(ue, le, Z, Q, ne + "[" + le + "]", d);
                    if (pe instanceof Error)
                      return pe;
                  }
                  return null;
                }
                return P(k);
              }
              function G() {
                function F(k, E, K, Z, Q) {
                  var ne = k[E];
                  if (!b(ne)) {
                    var ue = H(ne);
                    return new A("Invalid " + Z + " `" + Q + "` of type " + ("`" + ue + "` supplied to `" + K + "`, expected a single ReactElement."));
                  }
                  return null;
                }
                return P(F);
              }
              function Y() {
                function F(k, E, K, Z, Q) {
                  var ne = k[E];
                  if (!l.isValidElementType(ne)) {
                    var ue = H(ne);
                    return new A("Invalid " + Z + " `" + Q + "` of type " + ("`" + ue + "` supplied to `" + K + "`, expected a single ReactElement type."));
                  }
                  return null;
                }
                return P(F);
              }
              function L(F) {
                function k(E, K, Z, Q, ne) {
                  if (!(E[K] instanceof F)) {
                    var ue = F.name || C, de = U(E[K]);
                    return new A("Invalid " + Q + " `" + ne + "` of type " + ("`" + de + "` supplied to `" + Z + "`, expected ") + ("instance of `" + ue + "`."));
                  }
                  return null;
                }
                return P(k);
              }
              function X(F) {
                if (!Array.isArray(F))
                  return arguments.length > 1 ? v(
                    "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
                  ) : v("Invalid argument supplied to oneOf, expected an array."), g;
                function k(E, K, Z, Q, ne) {
                  for (var ue = E[K], de = 0; de < F.length; de++)
                    if (S(ue, F[de]))
                      return null;
                  var le = JSON.stringify(F, function(ie, Te) {
                    var Qe = z(Te);
                    return Qe === "symbol" ? String(Te) : Te;
                  });
                  return new A("Invalid " + Q + " `" + ne + "` of value `" + String(ue) + "` " + ("supplied to `" + Z + "`, expected one of " + le + "."));
                }
                return P(k);
              }
              function q(F) {
                function k(E, K, Z, Q, ne) {
                  if (typeof F != "function")
                    return new A("Property `" + ne + "` of component `" + Z + "` has invalid PropType notation inside objectOf.");
                  var ue = E[K], de = H(ue);
                  if (de !== "object")
                    return new A("Invalid " + Q + " `" + ne + "` of type " + ("`" + de + "` supplied to `" + Z + "`, expected an object."));
                  for (var le in ue)
                    if (p(ue, le)) {
                      var pe = F(ue, le, Z, Q, ne + "." + le, d);
                      if (pe instanceof Error)
                        return pe;
                    }
                  return null;
                }
                return P(k);
              }
              function re(F) {
                if (!Array.isArray(F))
                  return v("Invalid argument supplied to oneOfType, expected an instance of array."), g;
                for (var k = 0; k < F.length; k++) {
                  var E = F[k];
                  if (typeof E != "function")
                    return v(
                      "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + J(E) + " at index " + k + "."
                    ), g;
                }
                function K(Z, Q, ne, ue, de) {
                  for (var le = [], pe = 0; pe < F.length; pe++) {
                    var ie = F[pe], Te = ie(Z, Q, ne, ue, de, d);
                    if (Te == null)
                      return null;
                    Te.data && p(Te.data, "expectedType") && le.push(Te.data.expectedType);
                  }
                  var Qe = le.length > 0 ? ", expected one of type [" + le.join(", ") + "]" : "";
                  return new A("Invalid " + ue + " `" + de + "` supplied to " + ("`" + ne + "`" + Qe + "."));
                }
                return P(K);
              }
              function j() {
                function F(k, E, K, Z, Q) {
                  return $(k[E]) ? null : new A("Invalid " + Z + " `" + Q + "` supplied to " + ("`" + K + "`, expected a ReactNode."));
                }
                return P(F);
              }
              function W(F, k, E, K, Z) {
                return new A(
                  (F || "React class") + ": " + k + " type `" + E + "." + K + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + Z + "`."
                );
              }
              function D(F) {
                function k(E, K, Z, Q, ne) {
                  var ue = E[K], de = H(ue);
                  if (de !== "object")
                    return new A("Invalid " + Q + " `" + ne + "` of type `" + de + "` " + ("supplied to `" + Z + "`, expected `object`."));
                  for (var le in F) {
                    var pe = F[le];
                    if (typeof pe != "function")
                      return W(Z, Q, ne, le, z(pe));
                    var ie = pe(ue, le, Z, Q, ne + "." + le, d);
                    if (ie)
                      return ie;
                  }
                  return null;
                }
                return P(k);
              }
              function R(F) {
                function k(E, K, Z, Q, ne) {
                  var ue = E[K], de = H(ue);
                  if (de !== "object")
                    return new A("Invalid " + Q + " `" + ne + "` of type `" + de + "` " + ("supplied to `" + Z + "`, expected `object`."));
                  var le = f({}, E[K], F);
                  for (var pe in le) {
                    var ie = F[pe];
                    if (p(F, pe) && typeof ie != "function")
                      return W(Z, Q, ne, pe, z(ie));
                    if (!ie)
                      return new A(
                        "Invalid " + Q + " `" + ne + "` key `" + pe + "` supplied to `" + Z + "`.\nBad object: " + JSON.stringify(E[K], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(F), null, "  ")
                      );
                    var Te = ie(ue, pe, Z, Q, ne + "." + pe, d);
                    if (Te)
                      return Te;
                  }
                  return null;
                }
                return P(k);
              }
              function $(F) {
                switch (typeof F) {
                  case "number":
                  case "string":
                  case "undefined":
                    return !0;
                  case "boolean":
                    return !F;
                  case "object":
                    if (Array.isArray(F))
                      return F.every($);
                    if (F === null || b(F))
                      return !0;
                    var k = m(F);
                    if (k) {
                      var E = k.call(F), K;
                      if (k !== F.entries) {
                        for (; !(K = E.next()).done; )
                          if (!$(K.value))
                            return !1;
                      } else
                        for (; !(K = E.next()).done; ) {
                          var Z = K.value;
                          if (Z && !$(Z[1]))
                            return !1;
                        }
                    } else
                      return !1;
                    return !0;
                  default:
                    return !1;
                }
              }
              function B(F, k) {
                return F === "symbol" ? !0 : k ? k["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && k instanceof Symbol : !1;
              }
              function H(F) {
                var k = typeof F;
                return Array.isArray(F) ? "array" : F instanceof RegExp ? "object" : B(k, F) ? "symbol" : k;
              }
              function z(F) {
                if (typeof F > "u" || F === null)
                  return "" + F;
                var k = H(F);
                if (k === "object") {
                  if (F instanceof Date)
                    return "date";
                  if (F instanceof RegExp)
                    return "regexp";
                }
                return k;
              }
              function J(F) {
                var k = z(F);
                switch (k) {
                  case "array":
                  case "object":
                    return "an " + k;
                  case "boolean":
                  case "date":
                  case "regexp":
                    return "a " + k;
                  default:
                    return k;
                }
              }
              function U(F) {
                return !F.constructor || !F.constructor.name ? C : F.constructor.name;
              }
              return O.checkPropTypes = h, O.resetWarningCache = h.resetWarningCache, O.PropTypes = O, O;
            };
          }
        ),
        /***/
        "./node_modules/prop-types/index.js": (
          /*!******************************************!*\
            !*** ./node_modules/prop-types/index.js ***!
            \******************************************/
          /***/
          (u, s, c) => {
            {
              var l = c(
                /*! react-is */
                "./node_modules/react-is/index.js"
              ), f = !0;
              u.exports = c(
                /*! ./factoryWithTypeCheckers */
                "./node_modules/prop-types/factoryWithTypeCheckers.js"
              )(l.isElement, f);
            }
          }
        ),
        /***/
        "./node_modules/prop-types/lib/ReactPropTypesSecret.js": (
          /*!*************************************************************!*\
            !*** ./node_modules/prop-types/lib/ReactPropTypesSecret.js ***!
            \*************************************************************/
          /***/
          (u) => {
            var s = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
            u.exports = s;
          }
        ),
        /***/
        "./node_modules/prop-types/lib/has.js": (
          /*!********************************************!*\
            !*** ./node_modules/prop-types/lib/has.js ***!
            \********************************************/
          /***/
          (u) => {
            u.exports = Function.call.bind(Object.prototype.hasOwnProperty);
          }
        ),
        /***/
        "./node_modules/react-is/cjs/react-is.development.js": (
          /*!***********************************************************!*\
            !*** ./node_modules/react-is/cjs/react-is.development.js ***!
            \***********************************************************/
          /***/
          (u, s) => {
            /** @license React v16.13.1
             * react-is.development.js
             *
             * Copyright (c) Facebook, Inc. and its affiliates.
             *
             * This source code is licensed under the MIT license found in the
             * LICENSE file in the root directory of this source tree.
             */
            (function() {
              var c = typeof Symbol == "function" && Symbol.for, l = c ? Symbol.for("react.element") : 60103, f = c ? Symbol.for("react.portal") : 60106, d = c ? Symbol.for("react.fragment") : 60107, p = c ? Symbol.for("react.strict_mode") : 60108, h = c ? Symbol.for("react.profiler") : 60114, v = c ? Symbol.for("react.provider") : 60109, g = c ? Symbol.for("react.context") : 60110, b = c ? Symbol.for("react.async_mode") : 60111, x = c ? Symbol.for("react.concurrent_mode") : 60111, w = c ? Symbol.for("react.forward_ref") : 60112, y = c ? Symbol.for("react.suspense") : 60113, m = c ? Symbol.for("react.suspense_list") : 60120, C = c ? Symbol.for("react.memo") : 60115, O = c ? Symbol.for("react.lazy") : 60116, S = c ? Symbol.for("react.block") : 60121, A = c ? Symbol.for("react.fundamental") : 60117, P = c ? Symbol.for("react.responder") : 60118, T = c ? Symbol.for("react.scope") : 60119;
              function M(ie) {
                return typeof ie == "string" || typeof ie == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
                ie === d || ie === x || ie === h || ie === p || ie === y || ie === m || typeof ie == "object" && ie !== null && (ie.$$typeof === O || ie.$$typeof === C || ie.$$typeof === v || ie.$$typeof === g || ie.$$typeof === w || ie.$$typeof === A || ie.$$typeof === P || ie.$$typeof === T || ie.$$typeof === S);
              }
              function I(ie) {
                if (typeof ie == "object" && ie !== null) {
                  var Te = ie.$$typeof;
                  switch (Te) {
                    case l:
                      var Qe = ie.type;
                      switch (Qe) {
                        case b:
                        case x:
                        case d:
                        case h:
                        case p:
                        case y:
                          return Qe;
                        default:
                          var Ot = Qe && Qe.$$typeof;
                          switch (Ot) {
                            case g:
                            case w:
                            case O:
                            case C:
                            case v:
                              return Ot;
                            default:
                              return Te;
                          }
                      }
                    case f:
                      return Te;
                  }
                }
              }
              var G = b, Y = x, L = g, X = v, q = l, re = w, j = d, W = O, D = C, R = f, $ = h, B = p, H = y, z = !1;
              function J(ie) {
                return z || (z = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), U(ie) || I(ie) === b;
              }
              function U(ie) {
                return I(ie) === x;
              }
              function F(ie) {
                return I(ie) === g;
              }
              function k(ie) {
                return I(ie) === v;
              }
              function E(ie) {
                return typeof ie == "object" && ie !== null && ie.$$typeof === l;
              }
              function K(ie) {
                return I(ie) === w;
              }
              function Z(ie) {
                return I(ie) === d;
              }
              function Q(ie) {
                return I(ie) === O;
              }
              function ne(ie) {
                return I(ie) === C;
              }
              function ue(ie) {
                return I(ie) === f;
              }
              function de(ie) {
                return I(ie) === h;
              }
              function le(ie) {
                return I(ie) === p;
              }
              function pe(ie) {
                return I(ie) === y;
              }
              s.AsyncMode = G, s.ConcurrentMode = Y, s.ContextConsumer = L, s.ContextProvider = X, s.Element = q, s.ForwardRef = re, s.Fragment = j, s.Lazy = W, s.Memo = D, s.Portal = R, s.Profiler = $, s.StrictMode = B, s.Suspense = H, s.isAsyncMode = J, s.isConcurrentMode = U, s.isContextConsumer = F, s.isContextProvider = k, s.isElement = E, s.isForwardRef = K, s.isFragment = Z, s.isLazy = Q, s.isMemo = ne, s.isPortal = ue, s.isProfiler = de, s.isStrictMode = le, s.isSuspense = pe, s.isValidElementType = M, s.typeOf = I;
            })();
          }
        ),
        /***/
        "./node_modules/react-is/index.js": (
          /*!****************************************!*\
            !*** ./node_modules/react-is/index.js ***!
            \****************************************/
          /***/
          (u, s, c) => {
            u.exports = c(
              /*! ./cjs/react-is.development.js */
              "./node_modules/react-is/cjs/react-is.development.js"
            );
          }
        ),
        /***/
        "./node_modules/shallow-equal/dist/index.esm.js": (
          /*!******************************************************!*\
            !*** ./node_modules/shallow-equal/dist/index.esm.js ***!
            \******************************************************/
          /***/
          (u, s, c) => {
            c.r(s), c.d(s, {
              /* harmony export */
              shallowEqualArrays: () => (
                /* binding */
                f
              ),
              /* harmony export */
              shallowEqualObjects: () => (
                /* binding */
                l
              )
              /* harmony export */
            });
            function l(d, p) {
              if (d === p)
                return !0;
              if (!d || !p)
                return !1;
              var h = Object.keys(d), v = Object.keys(p), g = h.length;
              if (v.length !== g)
                return !1;
              for (var b = 0; b < g; b++) {
                var x = h[b];
                if (d[x] !== p[x] || !Object.prototype.hasOwnProperty.call(p, x))
                  return !1;
              }
              return !0;
            }
            function f(d, p) {
              if (d === p)
                return !0;
              if (!d || !p)
                return !1;
              var h = d.length;
              if (p.length !== h)
                return !1;
              for (var v = 0; v < h; v++)
                if (d[v] !== p[v])
                  return !1;
              return !0;
            }
          }
        ),
        /***/
        "./src/Component.ts": (
          /*!**************************!*\
            !*** ./src/Component.ts ***!
            \**************************/
          /***/
          function(u, s, c) {
            var l = this && this.__rest || function(h, v) {
              var g = {};
              for (var b in h) Object.prototype.hasOwnProperty.call(h, b) && v.indexOf(b) < 0 && (g[b] = h[b]);
              if (h != null && typeof Object.getOwnPropertySymbols == "function")
                for (var x = 0, b = Object.getOwnPropertySymbols(h); x < b.length; x++)
                  v.indexOf(b[x]) < 0 && Object.prototype.propertyIsEnumerable.call(h, b[x]) && (g[b[x]] = h[b[x]]);
              return g;
            }, f = this && this.__importDefault || function(h) {
              return h && h.__esModule ? h : { default: h };
            };
            Object.defineProperty(s, "__esModule", { value: !0 });
            var d = f(c(
              /*! ./useMediaQuery */
              "./src/useMediaQuery.ts"
            )), p = function(h) {
              var v = h.children, g = h.device, b = h.onChange, x = l(h, ["children", "device", "onChange"]), w = (0, d.default)(x, g, b);
              return typeof v == "function" ? v(w) : w ? v : null;
            };
            s.default = p;
          }
        ),
        /***/
        "./src/Context.ts": (
          /*!************************!*\
            !*** ./src/Context.ts ***!
            \************************/
          /***/
          (u, s, c) => {
            Object.defineProperty(s, "__esModule", { value: !0 });
            var l = c(
              /*! react */
              "react"
            ), f = (0, l.createContext)(void 0);
            s.default = f;
          }
        ),
        /***/
        "./src/index.ts": (
          /*!**********************!*\
            !*** ./src/index.ts ***!
            \**********************/
          /***/
          function(u, s, c) {
            var l = this && this.__importDefault || function(v) {
              return v && v.__esModule ? v : { default: v };
            };
            Object.defineProperty(s, "__esModule", { value: !0 }), s.Context = s.toQuery = s.useMediaQuery = s.default = void 0;
            var f = l(c(
              /*! ./useMediaQuery */
              "./src/useMediaQuery.ts"
            ));
            s.useMediaQuery = f.default;
            var d = l(c(
              /*! ./Component */
              "./src/Component.ts"
            ));
            s.default = d.default;
            var p = l(c(
              /*! ./toQuery */
              "./src/toQuery.ts"
            ));
            s.toQuery = p.default;
            var h = l(c(
              /*! ./Context */
              "./src/Context.ts"
            ));
            s.Context = h.default;
          }
        ),
        /***/
        "./src/mediaQuery.ts": (
          /*!***************************!*\
            !*** ./src/mediaQuery.ts ***!
            \***************************/
          /***/
          function(u, s, c) {
            var l = this && this.__assign || function() {
              return l = Object.assign || function(y) {
                for (var m, C = 1, O = arguments.length; C < O; C++) {
                  m = arguments[C];
                  for (var S in m) Object.prototype.hasOwnProperty.call(m, S) && (y[S] = m[S]);
                }
                return y;
              }, l.apply(this, arguments);
            }, f = this && this.__rest || function(y, m) {
              var C = {};
              for (var O in y) Object.prototype.hasOwnProperty.call(y, O) && m.indexOf(O) < 0 && (C[O] = y[O]);
              if (y != null && typeof Object.getOwnPropertySymbols == "function")
                for (var S = 0, O = Object.getOwnPropertySymbols(y); S < O.length; S++)
                  m.indexOf(O[S]) < 0 && Object.prototype.propertyIsEnumerable.call(y, O[S]) && (C[O[S]] = y[O[S]]);
              return C;
            }, d = this && this.__importDefault || function(y) {
              return y && y.__esModule ? y : { default: y };
            };
            Object.defineProperty(s, "__esModule", { value: !0 });
            var p = d(c(
              /*! prop-types */
              "./node_modules/prop-types/index.js"
            )), h = p.default.oneOfType([
              p.default.string,
              p.default.number
            ]), v = {
              all: p.default.bool,
              grid: p.default.bool,
              aural: p.default.bool,
              braille: p.default.bool,
              handheld: p.default.bool,
              print: p.default.bool,
              projection: p.default.bool,
              screen: p.default.bool,
              tty: p.default.bool,
              tv: p.default.bool,
              embossed: p.default.bool
            }, g = {
              orientation: p.default.oneOf([
                "portrait",
                "landscape"
              ]),
              scan: p.default.oneOf([
                "progressive",
                "interlace"
              ]),
              aspectRatio: p.default.string,
              deviceAspectRatio: p.default.string,
              height: h,
              deviceHeight: h,
              width: h,
              deviceWidth: h,
              color: p.default.bool,
              colorIndex: p.default.bool,
              monochrome: p.default.bool,
              resolution: h,
              type: Object.keys(v)
            };
            g.type;
            var b = f(
              g,
              ["type"]
            ), x = l({ minAspectRatio: p.default.string, maxAspectRatio: p.default.string, minDeviceAspectRatio: p.default.string, maxDeviceAspectRatio: p.default.string, minHeight: h, maxHeight: h, minDeviceHeight: h, maxDeviceHeight: h, minWidth: h, maxWidth: h, minDeviceWidth: h, maxDeviceWidth: h, minColor: p.default.number, maxColor: p.default.number, minColorIndex: p.default.number, maxColorIndex: p.default.number, minMonochrome: p.default.number, maxMonochrome: p.default.number, minResolution: h, maxResolution: h }, b), w = l(l({}, v), x);
            s.default = {
              all: w,
              types: v,
              matchers: g,
              features: x
            };
          }
        ),
        /***/
        "./src/toQuery.ts": (
          /*!************************!*\
            !*** ./src/toQuery.ts ***!
            \************************/
          /***/
          function(u, s, c) {
            var l = this && this.__importDefault || function(b) {
              return b && b.__esModule ? b : { default: b };
            };
            Object.defineProperty(s, "__esModule", { value: !0 });
            var f = l(c(
              /*! hyphenate-style-name */
              "./node_modules/hyphenate-style-name/index.js"
            )), d = l(c(
              /*! ./mediaQuery */
              "./src/mediaQuery.ts"
            )), p = function(b) {
              return "not ".concat(b);
            }, h = function(b, x) {
              var w = (0, f.default)(b);
              return typeof x == "number" && (x = "".concat(x, "px")), x === !0 ? w : x === !1 ? p(w) : "(".concat(w, ": ").concat(x, ")");
            }, v = function(b) {
              return b.join(" and ");
            }, g = function(b) {
              var x = [];
              return Object.keys(d.default.all).forEach(function(w) {
                var y = b[w];
                y != null && x.push(h(w, y));
              }), v(x);
            };
            s.default = g;
          }
        ),
        /***/
        "./src/useMediaQuery.ts": (
          /*!******************************!*\
            !*** ./src/useMediaQuery.ts ***!
            \******************************/
          /***/
          function(u, s, c) {
            var l = this && this.__importDefault || function(A) {
              return A && A.__esModule ? A : { default: A };
            };
            Object.defineProperty(s, "__esModule", { value: !0 });
            var f = c(
              /*! react */
              "react"
            ), d = l(c(
              /*! matchmediaquery */
              "./node_modules/matchmediaquery/index.js"
            )), p = l(c(
              /*! hyphenate-style-name */
              "./node_modules/hyphenate-style-name/index.js"
            )), h = c(
              /*! shallow-equal */
              "./node_modules/shallow-equal/dist/index.esm.js"
            ), v = l(c(
              /*! ./toQuery */
              "./src/toQuery.ts"
            )), g = l(c(
              /*! ./Context */
              "./src/Context.ts"
            )), b = function(A) {
              return A.query || (0, v.default)(A);
            }, x = function(A) {
              if (A) {
                var P = Object.keys(A);
                return P.reduce(function(T, M) {
                  return T[(0, p.default)(M)] = A[M], T;
                }, {});
              }
            }, w = function() {
              var A = (0, f.useRef)(!1);
              return (0, f.useEffect)(function() {
                A.current = !0;
              }, []), A.current;
            }, y = function(A) {
              var P = (0, f.useContext)(g.default), T = function() {
                return x(A) || x(P);
              }, M = (0, f.useState)(T), I = M[0], G = M[1];
              return (0, f.useEffect)(function() {
                var Y = T();
                (0, h.shallowEqualObjects)(I, Y) || G(Y);
              }, [A, P]), I;
            }, m = function(A) {
              var P = function() {
                return b(A);
              }, T = (0, f.useState)(P), M = T[0], I = T[1];
              return (0, f.useEffect)(function() {
                var G = P();
                M !== G && I(G);
              }, [A]), M;
            }, C = function(A, P) {
              var T = function() {
                return (0, d.default)(A, P || {}, !!P);
              }, M = (0, f.useState)(T), I = M[0], G = M[1], Y = w();
              return (0, f.useEffect)(function() {
                if (Y) {
                  var L = T();
                  return G(L), function() {
                    L && L.dispose();
                  };
                }
              }, [A, P]), I;
            }, O = function(A) {
              var P = (0, f.useState)(A.matches), T = P[0], M = P[1];
              return (0, f.useEffect)(function() {
                var I = function(G) {
                  M(G.matches);
                };
                return A.addListener(I), M(A.matches), function() {
                  A.removeListener(I);
                };
              }, [A]), T;
            }, S = function(A, P, T) {
              var M = y(P), I = m(A);
              if (!I)
                throw new Error("Invalid or missing MediaQuery!");
              var G = C(I, M), Y = O(G), L = w();
              return (0, f.useEffect)(function() {
                L && T && T(Y);
              }, [Y]), (0, f.useEffect)(function() {
                return function() {
                  G && G.dispose();
                };
              }, []), Y;
            };
            s.default = S;
          }
        ),
        /***/
        react: (
          /*!**************************************************************************************!*\
            !*** external {"commonjs":"react","commonjs2":"react","amd":"react","root":"React"} ***!
            \**************************************************************************************/
          /***/
          (u) => {
            u.exports = r;
          }
        )
        /******/
      }, a = {};
      function i(u) {
        var s = a[u];
        if (s !== void 0)
          return s.exports;
        var c = a[u] = {
          /******/
          // no module.id needed
          /******/
          // no module.loaded needed
          /******/
          exports: {}
          /******/
        };
        return n[u].call(c.exports, c, c.exports, i), c.exports;
      }
      i.d = (u, s) => {
        for (var c in s)
          i.o(s, c) && !i.o(u, c) && Object.defineProperty(u, c, { enumerable: !0, get: s[c] });
      }, i.o = (u, s) => Object.prototype.hasOwnProperty.call(u, s), i.r = (u) => {
        typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(u, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(u, "__esModule", { value: !0 });
      };
      var o = i("./src/index.ts");
      return o;
    })()
  ));
})(x6);
var Nu = x6.exports, C6 = /* @__PURE__ */ ((e) => (e[e.sm = 480] = "sm", e[e.md = 768] = "md", e[e.lg = 1024] = "lg", e[e.xl = 1280] = "xl", e[e.xxl = 1536] = "xxl", e))(C6 || {});
const BQ = () => {
  const e = Nu.useMediaQuery({ query: "(min-width: 480px)" }), t = Nu.useMediaQuery({ query: "(min-width: 768px)" }), r = Nu.useMediaQuery({ query: "(min-width: 1024px)" }), n = Nu.useMediaQuery({ query: "(min-width: 1280px)" });
  return {
    screenSize: C6,
    isSmall: e,
    isMedium: t,
    isLarge: r,
    isXLarge: n,
    // devices
    isMobile: !t,
    isDesktop: n
  };
};
var w6 = { exports: {} };
/*! @preserve
 * numeral.js
 * version : 2.0.6
 * author : Adam Draper
 * license : MIT
 * http://adamwdraper.github.com/Numeral-js/
 */
(function(e) {
  (function(t, r) {
    e.exports ? e.exports = r() : t.numeral = r();
  })(pa, function() {
    var t, r, n = "2.0.6", a = {}, i = {}, o = {
      currentLocale: "en",
      zeroFormat: null,
      nullFormat: null,
      defaultFormat: "0,0",
      scalePercentBy100: !0
    }, u = {
      currentLocale: o.currentLocale,
      zeroFormat: o.zeroFormat,
      nullFormat: o.nullFormat,
      defaultFormat: o.defaultFormat,
      scalePercentBy100: o.scalePercentBy100
    };
    function s(c, l) {
      this._input = c, this._value = l;
    }
    return t = function(c) {
      var l, f, d, p;
      if (t.isNumeral(c))
        l = c.value();
      else if (c === 0 || typeof c > "u")
        l = 0;
      else if (c === null || r.isNaN(c))
        l = null;
      else if (typeof c == "string")
        if (u.zeroFormat && c === u.zeroFormat)
          l = 0;
        else if (u.nullFormat && c === u.nullFormat || !c.replace(/[^0-9]+/g, "").length)
          l = null;
        else {
          for (f in a)
            if (p = typeof a[f].regexps.unformat == "function" ? a[f].regexps.unformat() : a[f].regexps.unformat, p && c.match(p)) {
              d = a[f].unformat;
              break;
            }
          d = d || t._.stringToNumber, l = d(c);
        }
      else
        l = Number(c) || null;
      return new s(c, l);
    }, t.version = n, t.isNumeral = function(c) {
      return c instanceof s;
    }, t._ = r = {
      // formats numbers separators, decimals places, signs, abbreviations
      numberToFormat: function(c, l, f) {
        var d = i[t.options.currentLocale], p = !1, h = !1, v = 0, g = "", b = 1e12, x = 1e9, w = 1e6, y = 1e3, m = "", C = !1, O, S, A, P, T, M, I;
        if (c = c || 0, S = Math.abs(c), t._.includes(l, "(") ? (p = !0, l = l.replace(/[\(|\)]/g, "")) : (t._.includes(l, "+") || t._.includes(l, "-")) && (T = t._.includes(l, "+") ? l.indexOf("+") : c < 0 ? l.indexOf("-") : -1, l = l.replace(/[\+|\-]/g, "")), t._.includes(l, "a") && (O = l.match(/a(k|m|b|t)?/), O = O ? O[1] : !1, t._.includes(l, " a") && (g = " "), l = l.replace(new RegExp(g + "a[kmbt]?"), ""), S >= b && !O || O === "t" ? (g += d.abbreviations.trillion, c = c / b) : S < b && S >= x && !O || O === "b" ? (g += d.abbreviations.billion, c = c / x) : S < x && S >= w && !O || O === "m" ? (g += d.abbreviations.million, c = c / w) : (S < w && S >= y && !O || O === "k") && (g += d.abbreviations.thousand, c = c / y)), t._.includes(l, "[.]") && (h = !0, l = l.replace("[.]", ".")), A = c.toString().split(".")[0], P = l.split(".")[1], M = l.indexOf(","), v = (l.split(".")[0].split(",")[0].match(/0/g) || []).length, P ? (t._.includes(P, "[") ? (P = P.replace("]", ""), P = P.split("["), m = t._.toFixed(c, P[0].length + P[1].length, f, P[1].length)) : m = t._.toFixed(c, P.length, f), A = m.split(".")[0], t._.includes(m, ".") ? m = d.delimiters.decimal + m.split(".")[1] : m = "", h && Number(m.slice(1)) === 0 && (m = "")) : A = t._.toFixed(c, 0, f), g && !O && Number(A) >= 1e3 && g !== d.abbreviations.trillion)
          switch (A = String(Number(A) / 1e3), g) {
            case d.abbreviations.thousand:
              g = d.abbreviations.million;
              break;
            case d.abbreviations.million:
              g = d.abbreviations.billion;
              break;
            case d.abbreviations.billion:
              g = d.abbreviations.trillion;
              break;
          }
        if (t._.includes(A, "-") && (A = A.slice(1), C = !0), A.length < v)
          for (var G = v - A.length; G > 0; G--)
            A = "0" + A;
        return M > -1 && (A = A.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1" + d.delimiters.thousands)), l.indexOf(".") === 0 && (A = ""), I = A + m + (g || ""), p ? I = (p && C ? "(" : "") + I + (p && C ? ")" : "") : T >= 0 ? I = T === 0 ? (C ? "-" : "+") + I : I + (C ? "-" : "+") : C && (I = "-" + I), I;
      },
      // unformats numbers separators, decimals places, signs, abbreviations
      stringToNumber: function(c) {
        var l = i[u.currentLocale], f = c, d = {
          thousand: 3,
          million: 6,
          billion: 9,
          trillion: 12
        }, p, h, v;
        if (u.zeroFormat && c === u.zeroFormat)
          h = 0;
        else if (u.nullFormat && c === u.nullFormat || !c.replace(/[^0-9]+/g, "").length)
          h = null;
        else {
          h = 1, l.delimiters.decimal !== "." && (c = c.replace(/\./g, "").replace(l.delimiters.decimal, "."));
          for (p in d)
            if (v = new RegExp("[^a-zA-Z]" + l.abbreviations[p] + "(?:\\)|(\\" + l.currency.symbol + ")?(?:\\))?)?$"), f.match(v)) {
              h *= Math.pow(10, d[p]);
              break;
            }
          h *= (c.split("-").length + Math.min(c.split("(").length - 1, c.split(")").length - 1)) % 2 ? 1 : -1, c = c.replace(/[^0-9\.]+/g, ""), h *= Number(c);
        }
        return h;
      },
      isNaN: function(c) {
        return typeof c == "number" && isNaN(c);
      },
      includes: function(c, l) {
        return c.indexOf(l) !== -1;
      },
      insert: function(c, l, f) {
        return c.slice(0, f) + l + c.slice(f);
      },
      reduce: function(c, l) {
        if (this === null)
          throw new TypeError("Array.prototype.reduce called on null or undefined");
        if (typeof l != "function")
          throw new TypeError(l + " is not a function");
        var f = Object(c), d = f.length >>> 0, p = 0, h;
        if (arguments.length === 3)
          h = arguments[2];
        else {
          for (; p < d && !(p in f); )
            p++;
          if (p >= d)
            throw new TypeError("Reduce of empty array with no initial value");
          h = f[p++];
        }
        for (; p < d; p++)
          p in f && (h = l(h, f[p], p, f));
        return h;
      },
      /**
       * Computes the multiplier necessary to make x >= 1,
       * effectively eliminating miscalculations caused by
       * finite precision.
       */
      multiplier: function(c) {
        var l = c.toString().split(".");
        return l.length < 2 ? 1 : Math.pow(10, l[1].length);
      },
      /**
       * Given a variable number of arguments, returns the maximum
       * multiplier that must be used to normalize an operation involving
       * all of them.
       */
      correctionFactor: function() {
        var c = Array.prototype.slice.call(arguments);
        return c.reduce(function(l, f) {
          var d = r.multiplier(f);
          return l > d ? l : d;
        }, 1);
      },
      /**
       * Implementation of toFixed() that treats floats more like decimals
       *
       * Fixes binary rounding issues (eg. (0.615).toFixed(2) === '0.61') that present
       * problems for accounting- and finance-related software.
       */
      toFixed: function(c, l, f, d) {
        var p = c.toString().split("."), h = l - (d || 0), v, g, b, x;
        return p.length === 2 ? v = Math.min(Math.max(p[1].length, h), l) : v = h, b = Math.pow(10, v), x = (f(c + "e+" + v) / b).toFixed(v), d > l - v && (g = new RegExp("\\.?0{1," + (d - (l - v)) + "}$"), x = x.replace(g, "")), x;
      }
    }, t.options = u, t.formats = a, t.locales = i, t.locale = function(c) {
      return c && (u.currentLocale = c.toLowerCase()), u.currentLocale;
    }, t.localeData = function(c) {
      if (!c)
        return i[u.currentLocale];
      if (c = c.toLowerCase(), !i[c])
        throw new Error("Unknown locale : " + c);
      return i[c];
    }, t.reset = function() {
      for (var c in o)
        u[c] = o[c];
    }, t.zeroFormat = function(c) {
      u.zeroFormat = typeof c == "string" ? c : null;
    }, t.nullFormat = function(c) {
      u.nullFormat = typeof c == "string" ? c : null;
    }, t.defaultFormat = function(c) {
      u.defaultFormat = typeof c == "string" ? c : "0.0";
    }, t.register = function(c, l, f) {
      if (l = l.toLowerCase(), this[c + "s"][l])
        throw new TypeError(l + " " + c + " already registered.");
      return this[c + "s"][l] = f, f;
    }, t.validate = function(c, l) {
      var f, d, p, h, v, g, b, x;
      if (typeof c != "string" && (c += "", console.warn && console.warn("Numeral.js: Value is not string. It has been co-erced to: ", c)), c = c.trim(), c.match(/^\d+$/))
        return !0;
      if (c === "")
        return !1;
      try {
        b = t.localeData(l);
      } catch {
        b = t.localeData(t.locale());
      }
      return p = b.currency.symbol, v = b.abbreviations, f = b.delimiters.decimal, b.delimiters.thousands === "." ? d = "\\." : d = b.delimiters.thousands, x = c.match(/^[^\d]+/), x !== null && (c = c.substr(1), x[0] !== p) || (x = c.match(/[^\d]+$/), x !== null && (c = c.slice(0, -1), x[0] !== v.thousand && x[0] !== v.million && x[0] !== v.billion && x[0] !== v.trillion)) ? !1 : (g = new RegExp(d + "{2}"), c.match(/[^\d.,]/g) ? !1 : (h = c.split(f), h.length > 2 ? !1 : h.length < 2 ? !!h[0].match(/^\d+.*\d$/) && !h[0].match(g) : h[0].length === 1 ? !!h[0].match(/^\d+$/) && !h[0].match(g) && !!h[1].match(/^\d+$/) : !!h[0].match(/^\d+.*\d$/) && !h[0].match(g) && !!h[1].match(/^\d+$/)));
    }, t.fn = s.prototype = {
      clone: function() {
        return t(this);
      },
      format: function(c, l) {
        var f = this._value, d = c || u.defaultFormat, p, h, v;
        if (l = l || Math.round, f === 0 && u.zeroFormat !== null)
          h = u.zeroFormat;
        else if (f === null && u.nullFormat !== null)
          h = u.nullFormat;
        else {
          for (p in a)
            if (d.match(a[p].regexps.format)) {
              v = a[p].format;
              break;
            }
          v = v || t._.numberToFormat, h = v(f, d, l);
        }
        return h;
      },
      value: function() {
        return this._value;
      },
      input: function() {
        return this._input;
      },
      set: function(c) {
        return this._value = Number(c), this;
      },
      add: function(c) {
        var l = r.correctionFactor.call(null, this._value, c);
        function f(d, p, h, v) {
          return d + Math.round(l * p);
        }
        return this._value = r.reduce([this._value, c], f, 0) / l, this;
      },
      subtract: function(c) {
        var l = r.correctionFactor.call(null, this._value, c);
        function f(d, p, h, v) {
          return d - Math.round(l * p);
        }
        return this._value = r.reduce([c], f, Math.round(this._value * l)) / l, this;
      },
      multiply: function(c) {
        function l(f, d, p, h) {
          var v = r.correctionFactor(f, d);
          return Math.round(f * v) * Math.round(d * v) / Math.round(v * v);
        }
        return this._value = r.reduce([this._value, c], l, 1), this;
      },
      divide: function(c) {
        function l(f, d, p, h) {
          var v = r.correctionFactor(f, d);
          return Math.round(f * v) / Math.round(d * v);
        }
        return this._value = r.reduce([this._value, c], l), this;
      },
      difference: function(c) {
        return Math.abs(t(this._value).subtract(c).value());
      }
    }, t.register("locale", "en", {
      delimiters: {
        thousands: ",",
        decimal: "."
      },
      abbreviations: {
        thousand: "k",
        million: "m",
        billion: "b",
        trillion: "t"
      },
      ordinal: function(c) {
        var l = c % 10;
        return ~~(c % 100 / 10) === 1 ? "th" : l === 1 ? "st" : l === 2 ? "nd" : l === 3 ? "rd" : "th";
      },
      currency: {
        symbol: "$"
      }
    }), function() {
      t.register("format", "bps", {
        regexps: {
          format: /(BPS)/,
          unformat: /(BPS)/
        },
        format: function(c, l, f) {
          var d = t._.includes(l, " BPS") ? " " : "", p;
          return c = c * 1e4, l = l.replace(/\s?BPS/, ""), p = t._.numberToFormat(c, l, f), t._.includes(p, ")") ? (p = p.split(""), p.splice(-1, 0, d + "BPS"), p = p.join("")) : p = p + d + "BPS", p;
        },
        unformat: function(c) {
          return +(t._.stringToNumber(c) * 1e-4).toFixed(15);
        }
      });
    }(), function() {
      var c = {
        base: 1e3,
        suffixes: ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]
      }, l = {
        base: 1024,
        suffixes: ["B", "KiB", "MiB", "GiB", "TiB", "PiB", "EiB", "ZiB", "YiB"]
      }, f = c.suffixes.concat(l.suffixes.filter(function(p) {
        return c.suffixes.indexOf(p) < 0;
      })), d = f.join("|");
      d = "(" + d.replace("B", "B(?!PS)") + ")", t.register("format", "bytes", {
        regexps: {
          format: /([0\s]i?b)/,
          unformat: new RegExp(d)
        },
        format: function(p, h, v) {
          var g, b = t._.includes(h, "ib") ? l : c, x = t._.includes(h, " b") || t._.includes(h, " ib") ? " " : "", w, y, m;
          for (h = h.replace(/\s?i?b/, ""), w = 0; w <= b.suffixes.length; w++)
            if (y = Math.pow(b.base, w), m = Math.pow(b.base, w + 1), p === null || p === 0 || p >= y && p < m) {
              x += b.suffixes[w], y > 0 && (p = p / y);
              break;
            }
          return g = t._.numberToFormat(p, h, v), g + x;
        },
        unformat: function(p) {
          var h = t._.stringToNumber(p), v, g;
          if (h) {
            for (v = c.suffixes.length - 1; v >= 0; v--) {
              if (t._.includes(p, c.suffixes[v])) {
                g = Math.pow(c.base, v);
                break;
              }
              if (t._.includes(p, l.suffixes[v])) {
                g = Math.pow(l.base, v);
                break;
              }
            }
            h *= g || 1;
          }
          return h;
        }
      });
    }(), function() {
      t.register("format", "currency", {
        regexps: {
          format: /(\$)/
        },
        format: function(c, l, f) {
          var d = t.locales[t.options.currentLocale], p = {
            before: l.match(/^([\+|\-|\(|\s|\$]*)/)[0],
            after: l.match(/([\+|\-|\)|\s|\$]*)$/)[0]
          }, h, v, g;
          for (l = l.replace(/\s?\$\s?/, ""), h = t._.numberToFormat(c, l, f), c >= 0 ? (p.before = p.before.replace(/[\-\(]/, ""), p.after = p.after.replace(/[\-\)]/, "")) : c < 0 && !t._.includes(p.before, "-") && !t._.includes(p.before, "(") && (p.before = "-" + p.before), g = 0; g < p.before.length; g++)
            switch (v = p.before[g], v) {
              case "$":
                h = t._.insert(h, d.currency.symbol, g);
                break;
              case " ":
                h = t._.insert(h, " ", g + d.currency.symbol.length - 1);
                break;
            }
          for (g = p.after.length - 1; g >= 0; g--)
            switch (v = p.after[g], v) {
              case "$":
                h = g === p.after.length - 1 ? h + d.currency.symbol : t._.insert(h, d.currency.symbol, -(p.after.length - (1 + g)));
                break;
              case " ":
                h = g === p.after.length - 1 ? h + " " : t._.insert(h, " ", -(p.after.length - (1 + g) + d.currency.symbol.length - 1));
                break;
            }
          return h;
        }
      });
    }(), function() {
      t.register("format", "exponential", {
        regexps: {
          format: /(e\+|e-)/,
          unformat: /(e\+|e-)/
        },
        format: function(c, l, f) {
          var d, p = typeof c == "number" && !t._.isNaN(c) ? c.toExponential() : "0e+0", h = p.split("e");
          return l = l.replace(/e[\+|\-]{1}0/, ""), d = t._.numberToFormat(Number(h[0]), l, f), d + "e" + h[1];
        },
        unformat: function(c) {
          var l = t._.includes(c, "e+") ? c.split("e+") : c.split("e-"), f = Number(l[0]), d = Number(l[1]);
          d = t._.includes(c, "e-") ? d *= -1 : d;
          function p(h, v, g, b) {
            var x = t._.correctionFactor(h, v), w = h * x * (v * x) / (x * x);
            return w;
          }
          return t._.reduce([f, Math.pow(10, d)], p, 1);
        }
      });
    }(), function() {
      t.register("format", "ordinal", {
        regexps: {
          format: /(o)/
        },
        format: function(c, l, f) {
          var d = t.locales[t.options.currentLocale], p, h = t._.includes(l, " o") ? " " : "";
          return l = l.replace(/\s?o/, ""), h += d.ordinal(c), p = t._.numberToFormat(c, l, f), p + h;
        }
      });
    }(), function() {
      t.register("format", "percentage", {
        regexps: {
          format: /(%)/,
          unformat: /(%)/
        },
        format: function(c, l, f) {
          var d = t._.includes(l, " %") ? " " : "", p;
          return t.options.scalePercentBy100 && (c = c * 100), l = l.replace(/\s?\%/, ""), p = t._.numberToFormat(c, l, f), t._.includes(p, ")") ? (p = p.split(""), p.splice(-1, 0, d + "%"), p = p.join("")) : p = p + d + "%", p;
        },
        unformat: function(c) {
          var l = t._.stringToNumber(c);
          return t.options.scalePercentBy100 ? l * 0.01 : l;
        }
      });
    }(), function() {
      t.register("format", "time", {
        regexps: {
          format: /(:)/,
          unformat: /(:)/
        },
        format: function(c, l, f) {
          var d = Math.floor(c / 60 / 60), p = Math.floor((c - d * 60 * 60) / 60), h = Math.round(c - d * 60 * 60 - p * 60);
          return d + ":" + (p < 10 ? "0" + p : p) + ":" + (h < 10 ? "0" + h : h);
        },
        unformat: function(c) {
          var l = c.split(":"), f = 0;
          return l.length === 3 ? (f = f + Number(l[0]) * 60 * 60, f = f + Number(l[1]) * 60, f = f + Number(l[2])) : l.length === 2 && (f = f + Number(l[0]) * 60, f = f + Number(l[1])), Number(f);
        }
      });
    }(), t;
  });
})(w6);
var VQ = w6.exports;
const WQ = /* @__PURE__ */ Fe(VQ), Fc = (e, t) => {
  const r = WQ(e);
  return r.value() !== 0 && e !== null && r.add(Number.EPSILON), r.format(t, Math.floor);
}, Vre = (e, t) => (e >= 0 ? "+" : "") + Fc(e, t), GQ = (e, t = 2) => new Intl.NumberFormat("en-NZ", {
  style: "percent",
  minimumFractionDigits: t,
  maximumFractionDigits: t,
  signDisplay: "negative"
}).format(e), Wre = (e, t) => {
  const r = `0,0.${"0".repeat(t)}`;
  return Fc(e, r);
}, Gre = (e) => Fc(e, "0,0.0000"), Hre = (e, t = "") => e !== null && typeof e < "u" ? GQ(e, 1) : t, HQ = () => /* @__PURE__ */ _.jsxs("div", { className: "retirement-projector-graph__legend", children: [
  /* @__PURE__ */ _.jsx("hr", {}),
  /* @__PURE__ */ _.jsx("p", { children: "Your retirement projection" })
] }), UQ = (e) => {
  const t = [90];
  return e < 65 && t.push(65), (e < 55 || e >= 65) && t.push(e), t;
}, Ure = ({
  data: e
}) => {
  const t = ({
    active: a,
    payload: i
  }) => {
    if (!a || !i || i.length === 0)
      return null;
    const { age: o, startValueAdjusted: u } = i[0].payload;
    return /* @__PURE__ */ _.jsxs("div", { className: "retirement-projector-graph__tooltip", children: [
      /* @__PURE__ */ _.jsx("span", { children: "Age" }),
      /* @__PURE__ */ _.jsx("p", { className: "mt-0 mb-sm", children: o }),
      /* @__PURE__ */ _.jsx("span", { children: "Balance" }),
      /* @__PURE__ */ _.jsx("p", { className: "my-0", children: Fc(u, "$0,0") })
    ] });
  }, { isMobile: r } = BQ(), n = r ? 30 : 50;
  return /* @__PURE__ */ _.jsx(bV, { width: "100%", minHeight: 300 + n, className: "retirement-projector-graph", children: /* @__PURE__ */ _.jsxs(
    LQ,
    {
      data: e,
      margin: {
        top: 0,
        right: 0,
        left: 0,
        bottom: 0
      },
      children: [
        /* @__PURE__ */ _.jsx(s6, { fill: "#f4f7f9", horizontal: !1, vertical: !1 }),
        /* @__PURE__ */ _.jsx(
          _n,
          {
            animationDuration: 4e3,
            name: "Your retirement projection",
            dataKey: "startValueAdjusted",
            stroke: "#00AE9E",
            fill: "#B8F2EB",
            fillOpacity: 0.25,
            baseValue: 0,
            activeDot: { fill: "black", r: 6, strokeWidth: 6 }
          }
        ),
        /* @__PURE__ */ _.jsx(
          wr,
          {
            defaultIndex: e.findIndex((a) => a.age === 65),
            content: t
          }
        ),
        /* @__PURE__ */ _.jsx(
          Rc,
          {
            dataKey: "age",
            scale: "point",
            axisLine: !1,
            interval: "preserveStartEnd",
            ticks: UQ(e[0].age),
            tickFormatter: (a) => `${a}y`,
            tickLine: !1
          }
        ),
        /* @__PURE__ */ _.jsx(Nc, { padding: { top: n }, hide: !0 }),
        /* @__PURE__ */ _.jsx(Ra, { content: HQ })
      ]
    }
  ) });
};
var to = /* @__PURE__ */ ((e) => (e[e.EMPLOYED = 0] = "EMPLOYED", e[e.SELF_EMPLOYED = 1] = "SELF_EMPLOYED", e[e.NOT_IN_PAID_EMPLOYMENT = 2] = "NOT_IN_PAID_EMPLOYMENT", e))(to || {}), Gr = /* @__PURE__ */ ((e) => (e[e.WEEKLY = 0] = "WEEKLY", e[e.FORTNIGHTLY = 1] = "FORTNIGHTLY", e[e.MONTHLY = 2] = "MONTHLY", e[e.YEARLY = 3] = "YEARLY", e))(Gr || {});
const zre = ({ className: e, form: t }) => /* @__PURE__ */ _.jsx(
  qA,
  {
    form: t,
    className: He({ [`${e}`]: !!e }),
    name: "employmentStatus",
    label: "What is your employment status?",
    labelSize: "sm",
    direction: "horizontal",
    size: "small",
    options: [
      { label: "Employed", value: to.EMPLOYED },
      { label: "Self-Employed", value: to.SELF_EMPLOYED },
      { label: "Not in paid employment", value: to.NOT_IN_PAID_EMPLOYMENT }
    ]
  }
), Yre = ({ className: e, form: t }) => /* @__PURE__ */ _.jsx(
  KA,
  {
    className: He({ [`${e}`]: !!e }),
    form: t,
    hidden: t.values.employmentStatus !== to.EMPLOYED,
    amountName: "salary",
    selectName: "salaryFrequency",
    options: [
      { label: "Weekly", value: Gr.WEEKLY },
      { label: "Fortnightly", value: Gr.FORTNIGHTLY },
      { label: "Monthly", value: Gr.MONTHLY },
      { label: "Yearly", value: Gr.YEARLY }
    ],
    label: "Salary or wages (before tax)",
    labelSize: "sm"
  }
), Xre = ({ className: e, selectedValue: t, onChange: r }) => /* @__PURE__ */ _.jsx(
  lr,
  {
    label: "Your contributions",
    className: He({ [`${e}`]: !!e }),
    showErrorLabel: !1,
    labelSize: "sm",
    children: /* @__PURE__ */ _.jsx(
      W1,
      {
        setSelected: r,
        value: t,
        options: [
          { label: "3%", value: 3 },
          { label: "4%", value: 4 },
          { label: "6%", value: 6 },
          { label: "8%", value: 8 },
          { label: "10%", value: 10 }
        ]
      }
    )
  }
), Zre = ({ className: e, selectedValue: t, onChange: r }) => /* @__PURE__ */ _.jsx(
  lr,
  {
    label: "Employer contributions",
    className: He({ [`${e}`]: !!e }),
    showErrorLabel: !1,
    labelSize: "sm",
    children: /* @__PURE__ */ _.jsx(
      W1,
      {
        setSelected: r,
        value: t,
        options: [
          { label: "3%", value: 3 },
          { label: "4%", value: 4 },
          { label: "6%", value: 6 },
          { label: "8%", value: 8 }
        ]
      }
    )
  }
), Kre = ({ className: e, amountValue: t, onAmountChange: r, frequencyValue: n, onFrequencyChange: a, ...i }) => /* @__PURE__ */ _.jsx(
  lr,
  {
    className: He({ [`${e}`]: !!e }),
    label: "Voluntary contributions",
    labelSize: "sm",
    error: t === void 0 ? "Please enter a valid amount" : void 0,
    children: /* @__PURE__ */ _.jsx(
      sy,
      {
        amountValue: t,
        onAmountChange: (o) => {
          const u = o.target.value === "" ? void 0 : parseFloat(o.target.value);
          r(u);
        },
        error: t === void 0,
        selectValue: n,
        options: [
          { label: "Weekly", value: Gr.WEEKLY },
          { label: "Fortnightly", value: Gr.FORTNIGHTLY },
          { label: "Monthly", value: Gr.MONTHLY },
          { label: "Yearly", value: Gr.YEARLY }
        ],
        onSelectChange: a,
        ...i
      }
    )
  }
), qre = () => /* @__PURE__ */ _.jsxs("svg", { width: "431", height: "355", viewBox: "0 0 431 355", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ _.jsxs("g", { "clip-path": "url(#clip0_7543_524)", children: [
    /* @__PURE__ */ _.jsx("path", { d: "M134.543 270.119H157.458V311.887H211.507C215.211 312.003 219.03 311.714 222.676 312.118C224.99 312.408 227.189 313.218 229.504 313.507C230.951 314.259 232.224 314.722 233.844 315.127C236.969 314.837 240.21 315.127 243.334 315.127C246.459 315.127 249.816 315.011 252.94 315.416L252.362 315.705C252.998 317.383 254.098 319.87 253.23 321.664C252.767 322.647 251.783 323.052 250.799 323.341C252.246 323.804 266.134 324.614 267.06 324.325C267.581 324.151 267.755 323.92 267.986 323.515L266.713 323.284C269.549 323.515 274.004 324.267 276.608 322.937C277.187 323.11 277.65 323.284 278.229 323.515C279.965 324.151 282.742 323.862 284.652 323.978C287.661 324.151 290.67 324.788 293.679 324.846C298.888 325.019 304.154 324.325 309.362 325.135C311.85 325.713 315.148 325.308 317.753 325.308L334.708 325.193C337.659 325.193 340.726 324.961 343.677 325.193C344.314 325.598 343.967 325.54 344.661 325.482H345.876C346.166 325.945 346.166 326.003 346.166 326.465C346.166 326.118 346.397 325.771 346.513 325.424C349.638 325.019 353.11 325.308 356.293 325.308H375.1C371.57 328.606 368.155 331.788 364.105 334.449C355.135 340.407 345.182 344.63 335.113 348.391C291.191 364.994 235.464 372.514 188.591 370.837C178.638 370.49 168.569 370.085 158.674 368.985C120.134 364.705 68.1105 352.209 38.8293 325.424C38.1349 324.788 37.4984 324.036 36.8618 323.341C38.8293 323.341 40.739 322.994 42.6486 322.705C42.8222 323.11 42.9379 323.689 43.343 323.862C44.5582 324.383 78.0059 324.151 80.7257 323.631H81.1307C81.1886 323.515 81.3044 323.515 81.3622 323.515C81.2465 322.647 81.1886 321.722 81.0729 320.854C81.5358 319.523 82.2881 318.54 83.0983 317.383C82.6932 317.094 82.5774 316.92 82.5196 316.399C82.4038 315.821 82.5196 315.532 82.9247 315.069C84.3714 313.16 88.8272 312.813 91.084 312.466C92.7622 312.466 94.4404 312.35 96.1185 312.234C98.4911 311.135 122.564 311.714 126.731 311.771C128.525 297.829 131.939 283.887 134.543 270.061V270.119Z", fill: "#218094" }),
    /* @__PURE__ */ _.jsx("path", { d: "M134.543 270.119H157.458V311.887H211.507C215.211 312.003 219.03 311.714 222.676 312.118C224.99 312.408 227.189 313.218 229.504 313.507C230.951 314.259 232.224 314.722 233.844 315.127C236.969 314.837 240.21 315.127 243.334 315.127C246.459 315.127 249.816 315.011 252.94 315.416L252.362 315.705C252.998 317.383 254.098 319.87 253.23 321.664C252.767 322.647 251.783 323.052 250.799 323.341C252.246 323.804 266.134 324.614 267.06 324.325C267.581 324.151 267.755 323.92 267.986 323.515L266.713 323.284C269.549 323.515 274.004 324.267 276.608 322.937C277.187 323.11 277.65 323.284 278.229 323.515C279.965 324.151 282.742 323.862 284.652 323.978C287.661 324.151 290.67 324.788 293.679 324.846C298.888 325.019 304.154 324.325 309.362 325.135C311.85 325.713 315.148 325.308 317.752 325.308L334.708 325.193C337.659 325.193 340.726 324.961 343.677 325.193C344.314 325.598 343.967 325.54 344.661 325.482H345.876C346.166 325.945 346.166 326.003 346.166 326.465C344.43 327.217 311.676 326.986 309.188 326.581L308.841 325.656C306.931 325.019 295.531 325.482 292.464 325.482H94.7876C76.1541 325.482 57.5206 324.961 38.8872 325.482C38.1928 324.846 37.5562 324.094 36.9197 323.399C38.8872 323.399 40.7968 323.052 42.7065 322.763C42.8801 323.168 42.9958 323.746 43.4009 323.92C44.6161 324.441 78.0637 324.209 80.7835 323.689H81.1886C81.2465 323.573 81.3622 323.573 81.4201 323.573C81.3043 322.705 81.2465 321.78 81.1307 320.912C81.5937 319.581 82.346 318.598 83.1561 317.441C82.751 317.151 82.6353 316.978 82.5774 316.457C82.4617 315.879 82.5774 315.59 82.9825 315.127C84.4292 313.218 88.885 312.871 91.1419 312.523C92.82 312.523 94.4982 312.408 96.1764 312.292C98.549 311.193 122.622 311.771 126.788 311.829C128.582 297.887 131.997 283.945 134.601 270.119H134.543Z", fill: "#000001" }),
    /* @__PURE__ */ _.jsx("path", { d: "M91.1418 312.581C92.8199 312.581 94.4981 312.466 96.1763 312.35V315.763C99.9377 315.069 104.104 315.416 107.923 315.416C113.942 315.416 119.902 315.532 125.92 315.416C125.457 318.019 124.937 320.622 124.474 323.168L94.961 323.341C90.4473 323.341 85.9336 323.573 81.4778 323.515C81.3621 322.647 81.3042 321.722 81.1885 320.854C81.6514 319.523 82.4037 318.54 83.2139 317.383C82.8088 317.094 82.693 316.92 82.6352 316.399C82.5194 315.821 82.6352 315.532 83.0402 315.069C84.4869 313.16 88.9428 312.813 91.1996 312.466H91.1418V312.581Z", fill: "#646464" }),
    /* @__PURE__ */ _.jsx("path", { d: "M91.1419 312.581C92.8201 312.581 94.4982 312.466 96.1764 312.35V315.763C94.151 317.383 86.8018 315.358 83.214 317.441C82.8089 317.151 82.6932 316.978 82.6353 316.457C82.5196 315.879 82.6353 315.59 83.0404 315.127C84.4871 313.218 88.9429 312.871 91.1998 312.523H91.1419V312.581Z", fill: "#F0F0F0" }),
    /* @__PURE__ */ _.jsx("path", { d: "M233.844 315.127C236.969 314.837 240.21 315.127 243.334 315.127C246.459 315.127 249.816 315.011 252.941 315.416L252.362 315.705C252.998 317.383 254.098 319.87 253.23 321.664C252.767 322.647 251.783 323.052 250.799 323.342H157.401V315.242H210.755C215.095 315.242 230.488 315.937 233.844 315.069V315.127Z", fill: "#646464" }),
    /* @__PURE__ */ _.jsx("path", { d: "M125.052 70.8245C158.095 30.3871 197.271 6.72625 249.584 1.46186C291.48 -2.76122 341.768 7.76755 374.984 34.7837C409.184 62.6097 425.56 104.783 429.785 147.708C429.958 149.385 430.132 151.005 430.248 152.683C430.363 154.36 430.479 155.98 430.595 157.658C430.711 159.336 430.768 160.955 430.826 162.633C430.826 164.311 430.942 165.931 431 167.608V177.558C431 179.236 430.884 180.856 430.826 182.534C430.768 184.211 430.653 185.831 430.537 187.509C430.421 189.186 430.306 190.806 430.19 192.484C430.074 194.162 429.9 195.781 429.727 197.459C429.553 199.137 429.38 200.757 429.148 202.376C428.917 203.996 428.685 205.674 428.454 207.294C428.222 208.913 427.933 210.591 427.644 212.211C427.354 213.831 427.065 215.508 426.776 217.128C426.486 218.748 426.139 220.368 425.792 221.988C425.445 223.607 425.097 225.227 424.692 226.847C424.287 228.467 423.882 230.087 423.477 231.706C423.072 233.326 422.609 234.888 422.146 236.508C421.683 238.128 421.22 239.69 420.757 241.31C420.294 242.872 419.774 244.491 419.253 246.053C418.732 247.615 418.211 249.177 417.632 250.739C417.054 252.301 416.533 253.863 415.896 255.425C415.318 256.987 414.681 258.549 414.102 260.053C413.466 261.615 412.829 263.119 412.193 264.681C411.556 266.185 410.862 267.747 410.167 269.251C409.473 270.756 408.779 272.26 408.084 273.764C407.39 275.268 406.638 276.772 405.885 278.218C405.133 279.722 404.381 281.169 403.628 282.615C402.876 284.061 402.066 285.565 401.256 287.011C400.446 288.458 399.635 289.904 398.767 291.35C397.957 292.797 397.089 294.185 396.221 295.631C395.353 297.02 394.485 298.466 393.559 299.854C388.351 307.953 383.027 315.995 376.72 323.342L376.546 323.515C376.083 324.151 375.736 324.846 375.157 325.424H356.35C353.168 325.424 349.696 325.135 346.571 325.54C346.455 325.887 346.281 326.176 346.223 326.581C346.223 326.118 346.223 326.003 345.934 325.598H344.719C344.024 325.598 344.372 325.713 343.735 325.308C340.784 325.077 337.717 325.308 334.766 325.308L317.81 325.424C315.264 325.424 311.908 325.829 309.419 325.251C304.211 324.441 298.945 325.135 293.737 324.961C290.728 324.846 287.719 324.267 284.71 324.094C282.858 323.978 280.08 324.267 278.287 323.631C277.766 323.399 277.245 323.226 276.666 323.052C274.062 324.383 269.606 323.689 266.771 323.399L268.044 323.631C267.812 324.094 267.639 324.267 267.118 324.441C266.134 324.788 252.246 323.978 250.857 323.457C251.841 323.168 252.825 322.763 253.288 321.78C254.156 319.986 253.056 317.499 252.42 315.821L252.998 315.532C249.873 315.127 246.575 315.3 243.392 315.242C240.267 315.242 237.027 314.895 233.902 315.242C232.282 314.838 231.066 314.433 229.562 313.623C227.247 313.276 225.048 312.466 222.733 312.234C219.088 311.829 215.268 312.119 211.565 312.003H157.516V270.293H134.601C132.054 284.061 128.582 298.003 126.788 311.945C122.622 311.945 98.5489 311.367 96.1763 312.408C94.4981 312.524 92.82 312.581 91.1418 312.639C88.885 312.986 84.4291 313.333 82.9824 315.242C82.6352 315.705 82.4616 315.937 82.5774 316.573C82.6931 317.036 82.8088 317.267 83.156 317.557C82.3459 318.714 81.5936 319.697 81.1307 321.028C81.1885 321.895 81.2464 322.821 81.42 323.689H80.7835C78.0058 324.267 44.616 324.556 43.4008 324.036C42.9957 323.862 42.88 323.284 42.7064 322.879C40.7967 323.168 38.8871 323.457 36.9196 323.515C34.6049 320.912 31.943 318.656 29.744 315.937C28.9917 315.011 28.2973 314.085 27.6029 313.16C26.9085 312.234 26.214 311.251 25.5196 310.325C24.8252 309.342 24.1887 308.416 23.4942 307.433C22.8577 306.449 22.2212 305.466 21.5846 304.482C20.9481 303.499 20.3115 302.515 19.7328 301.474C19.1542 300.491 18.5176 299.449 17.9389 298.408C17.3603 297.367 16.7816 296.325 16.2608 295.284C15.74 294.243 15.1613 293.201 14.6405 292.16C14.1196 291.119 13.5988 290.02 13.1359 288.978C12.673 287.937 12.1521 286.838 11.6892 285.739C11.2263 284.64 10.7633 283.54 10.3582 282.499C9.95316 281.4 9.49022 280.301 9.08514 279.202C8.68007 278.103 8.27499 277.003 7.92779 275.846C7.58058 274.689 7.1755 273.59 6.8283 272.491C6.48109 271.392 6.13388 270.235 5.84454 269.078C5.5552 267.921 5.26586 266.822 4.97652 265.665C-1.50468 239.516 -1.85189 205.616 5.09226 179.583C5.78667 177.096 6.53896 174.666 7.34911 172.236C8.15926 169.807 9.08514 167.435 10.1268 165.063C11.1105 162.691 12.21 160.377 13.3674 158.063C14.5247 155.749 15.7978 153.551 17.1288 151.352C17.6496 150.485 18.2283 149.559 18.7491 148.691L20.4851 146.088C21.0638 145.22 21.7003 144.41 22.279 143.542C22.9156 142.733 23.5521 141.923 24.1887 141.113C24.8252 140.303 25.5196 139.493 26.1562 138.741C26.8506 137.931 27.545 137.179 28.2394 136.427C28.9338 135.675 29.6861 134.923 30.3805 134.171C31.1328 133.419 31.8272 132.724 32.5795 132.03C33.3318 131.336 34.0841 130.642 34.8942 129.948C35.6465 129.253 36.4567 128.617 37.2668 127.923C38.077 127.286 38.8871 126.65 39.6973 126.014C40.5074 125.377 41.3754 124.799 42.1856 124.163C43.0536 123.584 43.8637 123.006 44.7318 122.427C45.5998 121.849 46.4678 121.328 47.3358 120.749C48.2038 120.229 49.1297 119.708 49.9977 119.187C50.9236 118.667 51.7916 118.204 52.7175 117.741C56.4211 115.832 60.3561 114.386 64.1754 112.708C68.8048 110.626 73.8393 107.849 78.7581 106.634C78.5266 102.7 78.6423 98.7084 78.6423 94.7746V70.8245C89.0007 71.1138 99.4748 71.0559 109.833 70.9402C114.752 70.5352 119.902 70.9402 124.879 70.9402H125.11L125.052 70.8245Z", fill: "#B8F2EB" }),
    /* @__PURE__ */ _.jsx("path", { d: "M346.628 323.341C356.524 323.341 366.651 322.879 376.488 323.457C376.025 324.094 375.678 324.788 375.1 325.366H356.292C353.11 325.366 349.638 325.077 346.513 325.482C346.397 325.829 346.223 326.118 346.166 326.523C346.166 326.06 346.166 325.945 345.876 325.54H344.661C343.967 325.54 344.314 325.656 343.677 325.251L345.645 325.135C346.397 324.614 346.397 324.267 346.686 323.399L346.628 323.341Z", fill: "#132438" }),
    /* @__PURE__ */ _.jsx("path", { d: "M260.29 75.5682C261.447 75.9153 262.604 76.3781 263.762 76.6673C264.919 77.7665 267.292 82.1631 268.217 82.5102L268.391 82.1631C268.565 83.5515 268.623 84.4771 269.838 85.287C270.59 85.8077 271.4 86.2705 272.152 86.6754C271.979 91.9977 271.053 97.2042 270.822 102.469C268.623 103.336 266.481 103.973 264.109 104.262C263.646 105.361 263.241 106.923 261.968 107.386C261.042 107.675 259.827 107.386 258.901 107.212C257.396 97.8984 258.322 84.7664 260.29 75.5103V75.5682Z", fill: "#218094" }),
    /* @__PURE__ */ _.jsx("path", { d: "M248.774 82.7416C250.452 78.6921 250.568 76.9566 253.751 73.5434C256.297 73.717 258.496 73.5434 260.347 75.5682C258.38 84.8242 257.396 97.9563 258.959 107.27C258.033 108.196 257.049 108.832 255.892 109.469C254.503 109.179 253.114 108.948 251.783 108.543L250.799 107.964L250.626 107.791C250.394 107.559 250.105 107.328 249.931 107.039C248.022 104.783 248.542 86.5598 248.832 82.6838L248.774 82.7416Z", fill: "#132438" }),
    /* @__PURE__ */ _.jsx("path", { d: "M170.826 75.626H171.289C171.868 75.5682 172.388 75.3946 172.967 75.2789C173.604 75.3946 173.893 75.6839 174.414 76.0888C175.05 77.3615 175.108 78.9235 175.34 80.3119C176.728 89.163 176.902 99.2869 175.108 108.138C175.571 108.601 175.34 108.427 175.687 108.601L174.761 108.832L173.546 108.427C173.372 108.254 173.083 108.196 172.909 108.08C170.594 106.981 169.9 104.667 169.09 102.411C166.486 102.469 163.882 102.526 161.278 102.526C160.815 99.2868 160.525 95.9894 160.178 92.7498C160.005 91.0721 159.889 89.3944 159.831 87.7168C161.683 87.4275 163.477 87.4275 165.329 86.9069C164.287 84.7664 164.518 82.1053 164.576 79.7913C165.271 78.75 166.197 77.8822 167.007 76.9566C168.28 76.3781 169.495 75.8574 170.884 75.6839H170.826V75.626Z", fill: "#218094" }),
    /* @__PURE__ */ _.jsx("path", { d: "M190.501 35.3621C194.957 28.5358 199.991 24.2549 208.151 22.5193C219.146 20.0896 232.282 23.0979 241.714 29.1721C245.128 31.3705 247.79 34.0316 250.394 37.1555C246.517 37.3869 237.548 33.106 233.265 32.0068C224.122 29.7507 207.919 29.9821 198.776 32.4118C196.403 33.0481 193.279 35.3621 190.964 35.42H190.501V35.3621Z", fill: "#646464" }),
    /* @__PURE__ */ _.jsx("path", { d: "M19.0383 221.409C21.6424 219.384 24.1886 218.574 27.5449 218.979C33.3896 219.616 37.6718 223.492 41.086 228.004C49.9977 239.632 53.2383 254.442 53.9327 268.789C51.7337 267.4 48.8403 260.111 47.1621 257.508C42.5906 250.334 25.1145 224.996 18.9805 221.467H19.0383V221.409Z", fill: "#74DDBC" }),
    /* @__PURE__ */ _.jsx("path", { d: "M18.7492 221.814L19.0385 221.409C25.1725 224.938 42.6486 250.276 47.2202 257.45C48.8984 260.111 51.7918 267.4 53.9907 268.731C54.5116 269.888 55.1481 271.103 55.4374 272.375C53.5857 272.202 51.7339 272.086 49.8821 271.97C43.2273 269.02 36.6882 264.334 32.0588 258.665C31.8273 258.491 31.5959 258.26 31.3644 258.028C25.1147 252.07 16.666 238.475 16.3187 229.74C16.203 226.731 16.7817 224.012 18.8071 221.756L18.7492 221.814Z", fill: "#74DDBC" }),
    /* @__PURE__ */ _.jsx("path", { d: "M18.749 221.814L19.0384 221.409C25.1724 224.938 42.6485 250.276 47.22 257.45C48.8982 260.111 51.7916 267.4 53.9906 268.731C54.5114 269.888 55.1479 271.103 55.4373 272.375C53.5855 272.202 51.7337 272.086 49.8819 271.97C43.2271 269.02 36.6881 264.334 32.0586 258.665C33.5053 258.838 37.2089 263.293 38.6556 264.45C42.7642 267.747 47.22 270.061 51.9073 272.375C51.3865 271.16 51.155 270.235 50.0555 269.425C50.2292 269.078 50.4028 268.789 50.5185 268.441C51.0393 267.053 47.0464 261.499 46.1784 260.111C41.2596 252.59 36.283 245.301 30.8434 238.128C27.8343 234.136 24.8252 230.202 21.8739 226.153C20.8323 224.707 19.5592 223.376 18.749 221.756V221.814Z", fill: "#218094" }),
    /* @__PURE__ */ _.jsx("path", { d: "M329.153 271.97C329.153 268.615 328.979 265.26 329.268 261.904C330.426 249.177 335.229 235.004 344.256 225.748C348.249 221.64 353.746 218.227 359.591 218.285C362.485 218.285 365.204 219.326 367.23 221.409C369.371 223.607 370.065 226.5 369.892 229.45C369.429 240.442 359.36 251.896 351.547 258.954C346.108 263.871 340.032 268.21 333.84 272.086C332.22 272.549 330.715 272.26 329.095 271.97H329.153Z", fill: "#74DDBC" }),
    /* @__PURE__ */ _.jsx("path", { d: "M308.957 190.864C310.172 185.658 311.676 181.261 316.479 178.253C320.009 176.054 324.176 175.649 328.169 176.633C333.088 177.848 337.08 180.856 339.684 185.195C345.124 194.277 344.488 205.789 341.941 215.624C338.701 228.235 333.203 241.425 326.201 252.475L325.68 253.458C325.217 252.243 325.102 250.739 324.755 249.467C324.002 246.574 323.134 243.797 322.093 240.963L322.613 240.789C320.588 235.235 317.926 230.144 315.554 224.707C312.081 216.781 309.304 207.756 308.667 199.137C308.494 196.533 308.262 193.352 308.957 190.806V190.864Z", fill: "#74DDBC" }),
    /* @__PURE__ */ _.jsx("path", { d: "M323.886 240.673C322.787 230.954 323.423 219.558 323.481 209.665C323.481 202.723 322.961 195.203 324.234 188.376L324.581 188.203L324.465 187.798C325.449 191.443 324.465 200.352 324.465 204.748V233.326C324.697 236.392 324.639 239.458 324.87 242.524C325.102 245.822 325.622 249.177 326.085 252.475L325.565 253.458C325.102 252.243 324.986 250.739 324.639 249.467C323.886 246.574 323.018 243.797 321.977 240.963L322.498 240.789L323.424 242.698C323.829 242.293 323.713 241.194 323.713 240.615H323.886V240.673Z", fill: "#003B70" }),
    /* @__PURE__ */ _.jsx("path", { d: "M58.4464 266.648C57.752 260.805 56.7682 254.962 55.6688 249.177C55.2058 246.632 54.8586 243.797 53.9906 241.367C53.0647 238.822 50.75 236.219 49.419 233.789C44.9053 225.227 42.5327 215.393 42.417 205.789C42.3013 197.69 44.3266 186.872 50.287 180.914C52.8911 178.253 56.2474 176.749 59.951 176.749L62.2078 177.327C67.2423 179.294 70.3672 183.748 72.4504 188.55C75.286 195.087 76.2118 202.203 76.6169 209.203C74.0707 209.55 71.9875 210.244 70.3672 212.384C67.3002 216.55 69.7885 227.715 70.6565 232.69V232.921L71.1773 236.161C71.756 239.921 72.219 243.624 72.5662 247.384C73.4342 252.359 74.0129 257.508 74.4758 262.541C74.9388 265.78 75.1702 269.136 75.8647 272.317C72.3347 272.549 68.8626 272.549 65.3327 272.317L63.9439 272.433L62.0921 272.26H59.1408L58.2149 266.475L58.4464 266.648Z", fill: "#74DDBC" }),
    /* @__PURE__ */ _.jsx("path", { d: "M60.0089 176.749L62.2657 177.327C62.2657 186.641 62.6129 196.013 62.5551 205.327C62.5551 212.384 62.2657 219.442 62.0921 226.5C61.9764 231.591 62.0921 236.739 61.8028 241.83C64.2911 239.748 68.8627 234.02 70.7723 232.979L71.2931 236.219C68.6312 239.111 64.8698 241.657 61.4556 243.624C61.2241 253.285 61.6292 262.714 62.2079 272.317H59.2566L58.3307 266.532C59.8353 263.524 59.0251 246.863 58.9673 242.351C57.6942 241.715 56.1317 241.136 54.9744 240.268C56.0739 240.153 57.4048 241.078 58.3307 241.599L58.62 241.483C58.1571 240.5 57.1733 239.69 56.3632 238.938C57.3469 239.401 58.1571 240.153 59.0251 240.789C59.6617 234.078 59.4881 227.021 59.6038 220.252C59.8353 205.674 59.8931 191.153 59.8353 176.575L60.0089 176.749Z", fill: "#218094" }),
    /* @__PURE__ */ _.jsx("path", { d: "M71.3509 236.219C71.9296 239.979 72.3925 243.681 72.7397 247.442C73.6077 252.417 74.1864 257.566 74.6494 262.599C75.1123 265.838 75.3438 269.193 76.0382 272.375C72.5082 272.607 69.0362 272.607 65.5062 272.375L64.1174 272.491L62.2656 272.317C61.6291 262.714 61.2819 253.285 61.5134 243.624C64.9276 241.657 68.689 239.111 71.3509 236.219Z", fill: "#74DDBC" }),
    /* @__PURE__ */ _.jsx("path", { d: "M64.1175 272.549C64.0018 268.846 68.284 261.789 69.6729 257.797C70.7723 254.557 71.1774 250.508 72.7398 247.5C73.6079 252.475 74.1865 257.623 74.6495 262.656C75.1124 265.896 75.3439 269.251 76.0383 272.433C72.5084 272.665 69.0363 272.665 65.5064 272.433L64.1175 272.549Z", fill: "url(#paint0_linear_7543_524)" }),
    /* @__PURE__ */ _.jsx("path", { d: "M65.5063 272.433C69.3835 269.598 71.9297 266.532 74.6495 262.656C75.1124 265.896 75.3439 269.251 76.0383 272.433C72.5084 272.665 69.0363 272.665 65.5063 272.433Z", fill: "#B8F2EB" }),
    /* @__PURE__ */ _.jsx("path", { d: "M62.2657 177.327C67.3002 179.294 70.4251 183.748 72.5083 188.55C75.3438 195.087 76.2697 202.203 76.6748 209.203C74.1286 209.55 72.0454 210.244 70.4251 212.384C67.3581 216.55 69.8464 227.715 70.7144 232.69V232.921C68.8048 233.963 64.2332 239.748 61.7449 241.772C62.0342 236.682 61.9763 231.533 62.0342 226.442C62.1499 219.384 62.4393 212.327 62.4972 205.269C62.4972 195.955 62.2078 186.641 62.2078 177.269L62.2657 177.327Z", fill: "#74DDBC" }),
    /* @__PURE__ */ _.jsx("path", { d: "M32.5216 273.879C34.6627 271.045 45.8312 273.243 49.8241 271.97C51.6759 272.086 53.5277 272.26 55.3794 272.375C56.7104 272.549 57.9835 272.491 59.3723 272.375H62.3236L64.1753 272.549L65.5642 272.433C69.0941 272.607 72.5662 272.607 76.0961 272.433C76.5591 275.673 76.9063 279.028 77.6007 282.21L77.89 284.119C79.1631 290.83 79.3367 302.226 81.9987 308.011C83.6768 310.383 85.1814 311.714 88.1905 312.234C89.1743 312.408 90.2159 312.466 91.1997 312.581C88.9428 312.928 84.487 313.276 83.0403 315.185C82.6931 315.647 82.5195 315.879 82.6352 316.515C82.7509 316.978 82.8667 317.209 83.2139 317.499C82.4037 318.656 81.6515 319.639 81.1885 320.97C81.2464 321.837 81.3042 322.763 81.4778 323.631H80.8413C78.0636 324.209 44.6739 324.498 43.4586 323.978C43.0536 323.804 42.9378 323.226 42.7642 322.821C42.3592 316.978 40.5652 310.904 39.4079 305.119C37.9033 297.829 36.746 290.482 35.0099 283.193C34.4313 282.615 33.8526 281.921 33.5054 281.169C32.6374 279.317 31.8851 275.788 32.5795 273.822L32.5216 273.879Z", fill: "#F0F0F0" }),
    /* @__PURE__ */ _.jsx("path", { d: "M81.9408 307.953C83.619 310.325 85.1235 311.656 88.1326 312.176C89.1164 312.35 90.158 312.408 91.1418 312.523C88.8849 312.871 84.4291 313.218 82.9824 315.127C82.6352 315.59 82.4616 315.821 82.5773 316.457C82.6931 316.92 82.8088 317.151 83.156 317.441C82.3459 318.598 81.5936 319.581 81.1306 320.912C80.7256 316.747 81.4778 312.176 81.9408 307.953Z", fill: "#B8F2EB" }),
    /* @__PURE__ */ _.jsx("path", { d: "M32.5216 273.879C34.6627 271.045 45.8312 273.243 49.8241 271.97C51.6759 272.086 53.5277 272.26 55.3794 272.375C56.7104 272.549 57.9835 272.491 59.3723 272.375H62.3236L64.1753 272.549L65.5642 272.433C69.0941 272.607 72.5662 272.607 76.0961 272.433C76.5591 275.673 76.9063 279.028 77.6007 282.21L77.89 284.119C69.3835 283.772 60.7611 284.119 52.1967 284.119C43.6322 284.119 40.2759 284.871 35.0099 283.309C34.4313 282.731 33.8526 282.036 33.5054 281.284C32.6374 279.433 31.8851 275.904 32.5795 273.937L32.5216 273.879Z", fill: "#FED69C" }),
    /* @__PURE__ */ _.jsx("path", { d: "M32.5216 273.879L33.1582 274.226C33.8526 276.598 33.5632 280.185 35.7622 281.747C37.2668 282.788 73.1449 282.21 77.5428 282.21L77.8322 284.119C69.3256 283.772 60.7033 284.119 52.1388 284.119C43.5744 284.119 40.218 284.871 34.9521 283.309C34.3734 282.731 33.7947 282.036 33.4475 281.284C32.5795 279.433 31.8272 275.904 32.5216 273.937V273.879Z", fill: "#FEC79A" }),
    /* @__PURE__ */ _.jsx("path", { d: "M299.871 272.086C309.304 271.855 318.794 272.202 328.227 272.086L329.153 271.912C330.773 272.144 332.277 272.433 333.898 272.028C338.527 273.127 351.547 272.317 356.929 272.26C356.929 275.962 356.813 279.722 356.813 283.425H352.821C351.2 296.788 347.786 309.978 346.629 323.341C346.339 324.151 346.339 324.556 345.587 325.077L343.62 325.193C340.668 324.961 337.601 325.193 334.65 325.193L317.695 325.308C315.149 325.308 311.792 325.713 309.304 325.135C308.378 322.011 308.32 318.598 307.973 315.416C307.394 310.499 306.816 305.524 306.295 300.548C305.832 296.267 305.6 291.929 304.79 287.706C304.79 287.069 304.79 286.549 304.559 285.912L304.327 283.714C303.517 283.02 301.087 283.251 299.987 283.251C299.698 279.549 299.756 275.846 299.756 272.144H299.871V272.086Z", fill: "#F0F0F0" }),
    /* @__PURE__ */ _.jsx("path", { d: "M299.871 272.086C309.304 271.855 318.794 272.202 328.226 272.086L329.152 271.912C330.773 272.144 332.277 272.433 333.898 272.028C338.527 273.127 351.547 272.317 356.929 272.26C356.929 275.962 356.813 279.722 356.813 283.425H318.447C315.901 283.425 306.295 283.02 304.385 283.598C303.575 282.904 301.144 283.135 300.045 283.135C299.755 279.433 299.813 275.731 299.813 272.028H299.871V272.086Z", fill: "#FEC79A" }),
    /* @__PURE__ */ _.jsx("path", { d: "M190.501 35.3621H190.964C193.279 35.3621 196.403 32.9903 198.776 32.3539C207.861 29.9242 224.122 29.6928 233.265 31.949C237.547 33.0481 246.517 37.329 250.394 37.0976C261.331 46.8165 267.234 56.0147 268.102 70.9401C268.275 74.7004 268.391 78.4028 268.449 82.1631L268.275 82.5102C267.349 82.1631 264.977 77.7665 263.82 76.6673C262.662 76.3781 261.447 75.9153 260.347 75.5682C258.496 73.5434 256.297 73.717 253.75 73.5434C250.568 76.9566 250.452 78.6921 248.774 82.7416C248.6 77.5929 248.079 72.56 247.385 67.4691H242.408C225.337 67.0063 209.482 61.2791 197.619 48.7834C191.369 55.0891 185.351 71.8079 184.598 80.7747C184.367 79.2706 181.936 77.188 180.895 76.0888C179.39 75.3946 177.365 74.7004 175.687 75.0475C174.877 75.2211 174.877 75.4525 174.414 76.0888C173.893 75.6839 173.603 75.3946 172.967 75.2789C172.388 75.4525 171.867 75.5682 171.289 75.626H170.826C169.437 75.7996 168.222 76.3202 166.949 76.8987C166.601 73.8327 166.601 70.5352 167.064 67.4691C168.627 56.6511 174.414 45.0232 183.325 38.4282C185.466 36.8084 187.665 34.9572 190.501 35.3621Z", fill: "url(#paint1_linear_7543_524)" }),
    /* @__PURE__ */ _.jsx("path", { d: "M253.75 46.643C260.926 55.0891 263.299 65.7915 263.819 76.6673C262.662 76.3781 261.447 75.9153 260.347 75.5682C258.496 73.5434 256.297 73.717 253.75 73.5434C257.049 63.4774 257.049 56.6511 253.75 46.643Z", fill: "#B8F2EB" }),
    /* @__PURE__ */ _.jsx("path", { d: "M181.126 47.1636C177.191 57.9238 178.059 65.2129 180.895 76.0888C179.39 75.3946 177.365 74.7004 175.687 75.0475C174.877 75.2211 174.877 75.4525 174.414 76.0888C173.893 75.6839 173.604 75.3946 172.967 75.2789C172.388 75.4525 171.868 75.5682 171.289 75.626H170.826C171.636 64.5766 173.661 55.7833 181.126 47.1636Z", fill: "#B8F2EB" }),
    /* @__PURE__ */ _.jsx("path", { d: "M78.8159 70.7666C89.1743 71.0559 99.6484 70.998 110.065 70.8823C119.266 71.5187 128.756 71.1137 137.957 71.0559C141.429 71.0559 145.422 70.4773 148.778 71.1137C149.588 71.2873 150.225 71.8079 150.746 72.3864C151.209 72.9649 151.44 73.6013 151.498 74.2955C152.135 79.8491 151.729 85.8656 151.787 91.477C151.903 99.7497 152.482 108.196 152.077 116.468C151.614 116.989 151.267 116.873 150.861 117.22C150.572 117.51 150.861 131.047 150.861 132.724C144.67 127.576 139.23 121.675 133.038 116.584C120.597 116.642 108.213 116.642 95.7712 116.584C90.2738 116.584 84.6606 116.758 79.1631 116.526C79.1631 113.229 79.221 109.816 78.9895 106.576C78.7581 102.642 78.8738 98.6505 78.8738 94.7167V70.7666H78.8159Z", fill: "#218094" }),
    /* @__PURE__ */ _.jsx("path", { d: "M82.4616 74.5847C94.8453 74.4112 107.287 74.7004 119.671 74.7583C129.103 74.7583 138.536 74.5847 147.968 74.7583C147.968 79.502 148.952 110.51 148.084 112.535C147.621 112.65 147.158 112.824 146.753 113.055C146.579 116.295 147.042 119.708 147.158 123.006L147.042 124.105C145.711 123.873 136.279 114.328 134.485 112.824C117.182 113.055 99.8798 113.113 82.5773 113.055C82.4037 100.27 82.3458 87.4275 82.4616 74.6426V74.5847Z", fill: "#F0F0F0" }),
    /* @__PURE__ */ _.jsx("path", { d: "M92.6465 94.8324C102.253 94.2539 112.206 94.8324 121.812 94.8324C131.418 94.8324 134.369 94.4274 138.189 94.9481C138.709 95.5266 138.594 95.5844 138.594 96.3365C131.707 96.915 124.011 96.4522 117.009 96.4522C110.007 96.4522 101.442 96.9728 93.8039 96.5679C93.3409 96.5679 93.4566 96.5679 92.9937 96.2786L92.5886 94.8324H92.6465Z", fill: "#218094" }),
    /* @__PURE__ */ _.jsx("path", { d: "M93.3987 89.7415H125.284C129.161 89.7415 133.212 89.4523 137.089 89.6837C137.726 89.6837 138.131 89.7994 138.709 90.1465C138.767 90.7828 138.709 90.8985 138.42 91.477H109.081C104.278 91.477 99.3591 91.7663 94.5561 91.477C93.8617 91.477 93.3987 91.3613 92.8201 90.9564V90.2043L93.3987 89.8572V89.7415Z", fill: "#218094" }),
    /* @__PURE__ */ _.jsx("path", { d: "M175.687 108.601C177.712 108.312 179.159 107.791 180.837 106.75C181.821 107.733 182.862 108.716 183.672 109.873C185.409 114.675 189.286 119.824 192.758 123.526C193.279 126.708 193.973 139.666 192.816 142.443L193.105 142.559C192.816 143.253 192.584 144.005 192.295 144.699C196.577 147.881 200.917 151.121 205.315 154.129C207.977 155.922 210.986 157.542 213.474 159.567C214.053 160.03 214.458 160.203 214.458 161.071C214.458 161.939 214.111 162.807 213.937 163.501C212.028 165.468 210.465 167.955 208.903 170.211C210.697 173.278 212.086 176.575 213.59 179.757C212.664 189.996 209.945 200.409 208.035 210.533C204.968 209.434 202.074 209.955 199.007 209.26L198.776 208.856C197.677 209.897 190.443 209.55 188.649 209.492C188.128 209.492 187.839 209.376 187.434 209.145L186.971 209.55C186.624 209.55 186.161 209.55 185.814 209.376C182.804 209.665 179.622 209.492 176.555 209.492H157.806C144.496 209.492 131.128 209.839 117.819 209.26C121.117 200.004 125.168 190.806 131.013 182.823C135.642 176.517 141.487 170.096 147.737 165.41C156.301 158.931 170.826 152.914 181.531 151.294L181.705 151.121C181.821 151.005 181.936 150.889 182.052 150.832C184.135 148.865 187.087 147.592 189.517 146.03C186.739 144.352 184.425 141.807 182.515 139.204C177.133 131.914 174.934 123.468 173.835 114.617C173.603 112.65 173.141 110.394 173.43 108.485L174.645 108.89L175.571 108.659H175.687V108.601Z", fill: "#132438" }),
    /* @__PURE__ */ _.jsx("path", { d: "M175.629 171.137C176.439 167.145 178.927 158.815 180.895 155.344C181.184 154.823 181.242 154.592 181.821 154.418C182.399 156.79 178.059 166.509 177.365 169.864C177.365 169.98 177.365 170.096 177.307 170.269C180.085 172.294 183.094 174.03 186.045 175.881C186.682 176.286 187.492 176.633 187.839 177.327C186.508 180.567 180.721 185.195 178.175 188.029C181.011 195.203 184.541 202.087 187.55 209.145L187.087 209.55C186.74 209.55 186.277 209.55 185.929 209.376C182.515 202.376 179.622 194.914 176.555 187.74C179.68 184.616 183.73 181.203 186.161 177.501C182.747 175.36 179.159 173.335 175.745 171.137H175.629Z", fill: "#7C95AD" }),
    /* @__PURE__ */ _.jsx("path", { d: "M175.687 108.601C177.712 108.312 179.159 107.791 180.837 106.75C181.821 107.733 182.862 108.716 183.673 109.873C185.409 114.675 189.286 119.824 192.758 123.526C193.279 126.708 193.973 139.666 192.816 142.443C192.295 143.427 191.716 144.931 190.79 145.683L190.443 145.567C188.418 142.964 185.929 140.766 183.904 138.104C177.307 129.485 175.86 119.303 174.703 108.832L175.629 108.601H175.687Z", fill: "#B8F2EB" }),
    /* @__PURE__ */ _.jsx("path", { d: "M192.295 144.699C196.577 147.881 200.917 151.121 205.315 154.129C207.977 155.922 210.986 157.542 213.474 159.567C214.053 160.03 214.458 160.203 214.458 161.071C214.458 161.939 214.111 162.807 213.937 163.501C212.028 165.468 210.465 167.955 208.903 170.211C210.697 173.278 212.086 176.575 213.59 179.757C212.664 189.996 209.945 200.409 208.035 210.533C204.968 209.434 202.075 209.955 199.008 209.26L198.776 208.856C195.883 197.112 194.494 184.616 193.105 172.583C192.411 166.22 191.543 159.914 190.964 153.551C190.385 150.137 190.385 147.823 192.237 144.757L192.295 144.699Z", fill: "#B8F2EB" }),
    /* @__PURE__ */ _.jsx("path", { d: "M192.295 144.699C196.577 147.881 200.917 151.121 205.315 154.129C207.977 155.922 210.986 157.542 213.474 159.567C214.053 160.03 214.458 160.203 214.458 161.071C214.458 161.939 214.111 162.807 213.937 163.501C212.028 165.468 210.465 167.955 208.903 170.211C206.415 172.757 204.274 176.459 202.19 179.41C199.528 174.724 197.271 169.459 195.362 164.426C194.031 160.898 192.931 156.732 190.906 153.551C190.327 150.137 190.327 147.823 192.179 144.757H192.295V144.699Z", fill: "#F0F0F0" }),
    /* @__PURE__ */ _.jsx("path", { d: "M197.619 48.7834C209.482 61.2791 225.395 67.0063 242.409 67.4691H247.385C248.08 72.56 248.6 77.593 248.774 82.7416C248.543 86.6755 248.022 104.84 249.874 107.097C250.105 107.386 250.336 107.559 250.568 107.849L250.742 108.022C249.353 110.221 247.443 112.592 246.633 115.022C244.492 117.394 243.045 120.402 241.02 122.89C239.457 124.857 235.87 126.534 235.175 128.906C235.001 132.84 234.423 138.22 235.522 141.98C235.985 142.328 236.275 142.501 236.564 143.022C233.96 148.865 229.099 153.608 224.18 157.6C222.213 159.162 219.956 160.666 218.567 162.807C217.178 163.385 215.442 163.385 213.995 163.501C214.169 162.807 214.516 161.765 214.516 161.071C214.516 160.377 214.111 160.088 213.533 159.567C211.044 157.542 208.035 155.98 205.373 154.129C200.975 151.121 196.635 147.881 192.353 144.699C192.7 144.005 192.932 143.253 193.163 142.559L192.874 142.443C193.973 139.666 193.337 126.708 192.816 123.526C189.344 119.824 185.467 114.675 183.731 109.873C182.92 108.716 181.879 107.733 180.895 106.75C179.159 107.849 177.712 108.312 175.745 108.601C175.398 108.427 175.629 108.601 175.166 108.138C176.96 99.3447 176.729 89.163 175.398 80.3119C175.166 78.9235 175.108 77.3615 174.472 76.0888C174.935 75.4525 174.935 75.2211 175.745 75.0475C177.423 74.7004 179.448 75.3946 180.953 76.0888C181.995 77.2458 184.425 79.3285 184.656 80.7747C185.409 71.8079 191.369 55.0891 197.677 48.7834H197.619Z", fill: "#FEC79A" }),
    /* @__PURE__ */ _.jsx("path", { d: "M213.532 94.8902L214.516 95.1216C215.5 96.3943 215.211 100.27 215.442 102.064C216.542 102.122 218.74 102.064 219.551 102.758V103.394C218.683 103.683 217.872 103.799 217.004 103.857C216.079 103.915 215.153 103.857 214.458 103.105C212.838 101.369 213.475 97.1464 213.532 94.8902Z", fill: "#F37D69" }),
    /* @__PURE__ */ _.jsx("path", { d: "M231.819 74.3533C234.538 74.1798 237.432 74.1798 240.036 75.1054C241.367 75.5682 242.582 76.3202 243.161 77.5929C243.161 78.2872 243.045 78.2872 242.524 78.75C241.772 78.8078 241.425 78.75 240.73 78.4607C239.168 77.8822 237.49 77.2458 235.811 77.0723C233.612 76.8409 230.661 77.8243 228.694 76.783C228.173 76.4938 228.346 76.6673 228.173 76.0888C228.173 76.031 228.173 75.9153 228.289 75.8574C229.099 74.8161 230.545 74.5847 231.703 74.2955H231.819V74.3533Z", fill: "#132438" }),
    /* @__PURE__ */ _.jsx("path", { d: "M200.802 73.8327C201.727 73.8327 202.653 73.8327 203.579 73.8905C204.679 74.0062 206.53 74.2955 207.167 75.3368C207.514 75.9731 207.514 76.2045 207.341 76.8409C205.894 78.0557 200.859 76.8409 198.834 77.1301H198.487C197.098 77.5929 195.709 78.4028 194.262 78.4607C193.452 78.4607 192.642 78.4607 192.063 77.94C192.179 77.5929 192.063 77.7086 192.353 77.3615C194.089 74.9897 198.082 74.0641 200.859 73.7748H200.802V73.8327Z", fill: "#132438" }),
    /* @__PURE__ */ _.jsx("path", { d: "M232.282 84.4193C232.976 84.4193 233.67 84.3614 234.307 84.4193C235.406 84.535 236.506 85.2871 237.2 86.1548C237.895 87.0804 238.126 88.1796 237.953 89.3366C237.663 90.9564 236.737 91.882 235.406 92.8076C234.886 92.9233 234.365 92.9811 233.844 92.9811C232.744 92.9811 231.587 92.3448 230.893 91.5349C230.025 90.5514 229.735 89.2209 229.909 87.9482C230.14 86.2705 231.008 85.4606 232.339 84.4771L232.282 84.4193Z", fill: "#132438" }),
    /* @__PURE__ */ _.jsx("path", { d: "M200.339 84.4193C201.033 84.4193 201.785 84.3036 202.48 84.4193C203.695 84.5928 204.852 85.4606 205.489 86.5019C206.067 87.4275 206.241 88.5267 205.952 89.568C205.547 91.0142 204.563 91.8241 203.29 92.5762C202.595 92.5762 201.843 92.6919 201.149 92.5762C200.049 92.4605 198.95 91.7663 198.255 90.9564C197.561 90.0886 197.329 89.0473 197.503 87.9482C197.85 86.2126 198.95 85.3449 200.339 84.4771V84.4193Z", fill: "#132438" }),
    /* @__PURE__ */ _.jsx("path", { d: "M237.49 96.6836C239.052 96.7993 240.788 96.9728 242.177 97.7827C243.219 98.4191 244.087 99.2868 244.376 100.502C244.607 101.369 244.376 102.179 243.855 102.931C242.582 104.667 240.441 104.783 238.473 105.072C236.853 104.956 235.117 104.725 233.728 103.915C232.687 103.336 231.471 102.353 231.24 101.08C231.124 100.27 231.24 99.5183 231.761 98.8819C233.092 97.1464 235.522 96.915 237.548 96.6836H237.49Z", fill: "#FBA37C" }),
    /* @__PURE__ */ _.jsx("path", { d: "M193.915 96.3943C195.42 96.3365 196.809 96.3943 198.197 96.8571C200.049 97.4935 202.711 98.9397 203.463 100.907C203.695 101.601 203.753 102.237 203.463 102.874C202.711 104.262 201.091 104.84 199.702 105.303H199.297C197.561 105.303 196.114 105.188 194.436 104.551C192.526 103.799 189.98 102.122 189.286 100.097C189.054 99.4604 188.996 98.824 189.402 98.1877C190.443 96.6257 192.237 96.5679 193.915 96.3943Z", fill: "#FBA37C" }),
    /* @__PURE__ */ _.jsx("path", { d: "M185.467 111.32C185.177 110.741 184.83 110.336 184.946 109.7C185.582 109.816 186.219 109.989 186.855 110.163C193.51 115.196 198.14 117.22 206.357 118.609C206.588 117.741 206.993 116.873 207.341 116.063C208.209 115.138 209.134 114.501 210.176 113.807C212.78 113.171 215.442 112.882 217.815 114.444C219.261 115.369 220.303 116.873 220.65 118.551V120.287C220.65 120.46 220.65 120.634 220.534 120.865C220.534 121.039 220.419 121.212 220.361 121.386C220.303 121.559 220.245 121.733 220.129 121.906C220.129 122.08 219.956 122.253 219.84 122.427C219.724 122.601 219.666 122.774 219.551 122.89C218.451 124.336 216.831 125.03 215.037 125.204C212.78 125.435 209.829 124.972 208.035 123.41C207.514 122.948 207.167 122.427 206.82 121.849C206.704 121.501 206.473 121.27 206.299 121.039C198.371 119.534 191.311 116.931 185.293 111.435L185.409 111.32H185.467Z", fill: "#132438" }),
    /* @__PURE__ */ _.jsx("path", { d: "M174.414 76.0888C174.877 75.4525 174.877 75.2211 175.687 75.0475C177.365 74.7004 179.39 75.3946 180.895 76.0888C181.937 77.2458 184.367 79.3285 184.599 80.7747C185.062 81.3532 185.524 81.9896 185.698 82.7416C186.566 86.7912 185.872 97.3778 185.872 102.122C185.814 104.262 185.698 106.402 185.467 108.485L186.855 110.105C186.219 109.931 185.582 109.816 184.946 109.642C184.83 110.278 185.177 110.683 185.467 111.262L183.673 109.816C182.863 108.659 181.821 107.675 180.837 106.692C179.101 107.791 177.654 108.254 175.687 108.543C175.34 108.369 175.571 108.543 175.108 108.08C176.902 99.2869 176.671 89.1052 175.34 80.2541C175.108 78.8657 175.05 77.3037 174.414 76.031V76.0888Z", fill: "#003B70" }),
    /* @__PURE__ */ _.jsx("path", { d: "M209.077 112.245C210.234 111.725 211.333 111.204 212.664 111.088C216.252 110.683 219.782 111.609 223.37 111.725C227.652 111.898 231.934 111.725 236.217 111.898C236.217 116.179 236.737 121.501 233.497 124.857C229.851 128.617 223.717 130.353 218.625 130.353C213.532 130.353 210.523 129.427 207.861 126.766C205.199 124.105 206.415 124.567 206.53 123.121C206.53 122.543 206.704 122.138 207.109 121.675C207.456 122.196 207.861 122.774 208.324 123.237C210.06 124.799 213.012 125.262 215.326 125.03C217.062 124.857 218.741 124.163 219.84 122.716C219.956 122.543 220.071 122.427 220.129 122.253C220.245 122.08 220.303 121.906 220.419 121.733C220.419 121.559 220.592 121.386 220.65 121.212C220.65 121.039 220.766 120.865 220.824 120.692C220.824 120.518 220.824 120.344 220.94 120.113V118.377C220.65 116.642 219.551 115.196 218.104 114.27C215.731 112.708 213.069 112.997 210.465 113.634C209.424 114.328 208.44 114.964 207.63 115.89C207.283 115.254 207.225 114.964 207.225 114.27C207.63 113.287 208.498 112.766 209.308 112.187H209.134L209.077 112.245Z", fill: "#F0F0F0" }),
    /* @__PURE__ */ _.jsx("path", { d: "M192.816 123.526C192.931 123.526 192.989 123.526 193.105 123.584C194.494 124.105 196.751 127.113 198.255 128.212C206.646 134.286 218.104 134.981 227.71 131.683C230.198 130.815 232.397 129.832 234.596 128.443H235.001C235.001 128.501 235.233 128.906 235.233 128.906C235.059 132.84 234.481 138.22 235.58 141.98C236.043 142.328 236.332 142.501 236.622 143.022C234.018 148.865 229.157 153.608 224.238 157.6C222.27 159.162 220.014 160.666 218.625 162.807C217.236 163.385 215.5 163.385 214.053 163.501C214.227 162.807 214.574 161.765 214.574 161.071C214.574 160.377 214.169 160.088 213.59 159.567C211.102 157.542 208.093 155.98 205.431 154.129C201.033 151.121 196.693 147.881 192.411 144.699C192.758 144.005 192.989 143.253 193.221 142.559L192.931 142.443C194.031 139.666 193.394 126.708 192.874 123.526H192.816Z", fill: "#FBA37C" }),
    /* @__PURE__ */ _.jsx("path", { d: "M235.522 141.98C235.985 142.328 236.275 142.501 236.564 143.022C233.96 148.865 229.099 153.608 224.18 157.6C222.213 159.162 219.956 160.666 218.567 162.807C217.178 163.385 215.442 163.385 213.995 163.501C214.169 162.807 214.516 161.765 214.516 161.071C214.516 160.377 214.111 160.088 213.532 159.567C211.044 157.542 208.035 155.98 205.373 154.129C200.975 151.121 196.635 147.881 192.353 144.699C192.7 144.005 192.931 143.253 193.163 142.559C194.899 142.848 196.635 144.005 198.197 144.815C203.174 147.418 207.63 149.443 213.359 149.79C221.923 150.311 229.157 147.534 235.58 141.923L235.522 141.98Z", fill: "#FEC79A" }),
    /* @__PURE__ */ _.jsx("path", { d: "M198.834 208.856L199.066 209.26C202.133 209.897 205.026 209.376 208.093 210.533C209.482 211.517 210.466 212.327 211.276 213.889C213.243 217.764 216.137 234.83 217.178 240.5L220.245 258.202C220.766 261.326 221.113 264.913 222.213 267.921C222.444 270.466 222.791 274.516 224.007 276.772C224.007 277.64 224.007 278.623 224.412 279.375C224.238 281.573 225.28 284.64 225.743 286.78C227.189 293.028 229.215 299.854 229.33 306.276C228.115 308.821 226.842 310.325 224.412 311.771C220.129 311.771 215.731 311.54 211.449 311.887H157.401V270.177H134.485C131.939 283.945 128.467 297.887 126.673 311.829C122.506 311.829 98.4333 311.251 96.0607 312.292C94.3825 312.408 92.7044 312.466 91.0262 312.523C90.0424 312.408 89.0008 312.35 88.0171 312.176C85.0658 311.656 83.5034 310.325 81.8252 307.953C79.1633 302.168 78.9318 290.83 77.7166 284.061L77.4272 282.152C76.7328 278.97 76.3856 275.615 75.9227 272.375C75.2283 269.193 74.9968 265.838 74.5338 262.599C74.013 257.566 73.4344 252.417 72.6242 247.442C72.2191 243.681 71.8141 239.921 71.2354 236.219L70.7146 232.979V232.748C69.8465 227.773 67.3582 216.55 70.4252 212.442C72.0455 210.244 74.1288 209.608 76.675 209.26H117.819C131.071 209.897 144.496 209.492 157.806 209.55H176.555C179.622 209.55 182.805 209.723 185.814 209.434C186.161 209.434 186.624 209.55 186.971 209.608L187.434 209.203C187.897 209.434 188.186 209.492 188.649 209.55C190.443 209.55 197.735 209.955 198.776 208.913H198.834V208.856Z", fill: "#646464" }),
    /* @__PURE__ */ _.jsx("path", { d: "M236.564 142.964C239.284 144.584 243.855 145.567 245.88 147.939C245.996 147.534 246.112 147.187 246.228 146.782L246.98 146.551C247.906 146.724 248.6 147.245 249.41 147.765L251.609 148.749C275.625 157.427 296.11 167.319 308.899 190.864C308.146 193.409 308.378 196.591 308.609 199.194C309.246 207.814 312.023 216.839 315.496 224.764C317.868 230.144 320.588 235.235 322.555 240.847L322.035 241.02C323.076 243.797 323.944 246.632 324.697 249.524C325.044 250.797 325.102 252.301 325.622 253.516C327.474 259.648 327.764 265.491 328.111 271.855V272.144C318.736 272.144 309.304 271.855 299.871 272.144C299.871 275.846 299.755 279.549 300.103 283.251C301.144 283.251 303.633 283.02 304.443 283.714L304.674 285.912C304.848 286.549 304.906 287.069 304.906 287.706C305.658 291.929 305.947 296.267 306.41 300.548C306.931 305.524 307.51 310.441 308.088 315.416C308.436 318.656 308.551 322.011 309.419 325.135C304.211 324.325 298.945 325.019 293.737 324.846C290.728 324.73 287.719 324.151 284.71 323.978C282.858 323.862 280.08 324.151 278.287 323.515C277.766 323.284 277.245 323.11 276.666 322.937C274.062 324.267 269.606 323.573 266.771 323.284L268.044 323.515C267.812 323.978 267.639 324.151 267.118 324.325C266.134 324.672 252.246 323.862 250.857 323.342C251.841 323.052 252.825 322.647 253.288 321.664C254.156 319.87 253.056 317.383 252.42 315.705L252.998 315.416C249.873 315.011 246.575 315.185 243.392 315.127C240.267 315.127 237.027 314.78 233.902 315.127C232.282 314.722 231.066 314.317 229.562 313.507C227.247 313.16 225.048 312.35 222.733 312.118C219.088 311.714 215.268 312.003 211.565 311.887C215.847 311.598 220.245 311.887 224.527 311.771C227.016 310.325 228.231 308.821 229.446 306.276C229.272 299.854 227.247 293.028 225.858 286.78C225.337 284.582 224.354 281.573 224.527 279.375C224.122 278.623 224.18 277.64 224.122 276.772C222.907 274.516 222.56 270.466 222.328 267.921C221.229 264.913 220.882 261.384 220.361 258.202L217.294 240.5C216.252 234.83 213.359 217.707 211.391 213.889C210.581 212.384 209.597 211.517 208.208 210.533C210.06 200.409 212.838 189.996 213.764 179.757C212.259 176.575 210.87 173.278 209.077 170.211C210.639 167.955 212.201 165.468 214.111 163.501C215.616 163.385 217.352 163.385 218.683 162.807C220.071 160.666 222.328 159.162 224.296 157.6C229.215 153.608 234.075 148.922 236.68 143.022H236.564V142.964Z", fill: "#132438" }),
    /* @__PURE__ */ _.jsx("path", { d: "M227.421 268.499C227.884 268.036 228.231 267.689 228.52 267.169C228.52 267.574 228.52 267.863 228.81 268.152C227.652 271.855 226.263 275.962 224.47 279.375C224.064 278.623 224.122 277.64 224.064 276.772C225.106 273.995 226.09 271.16 227.421 268.557V268.499Z", fill: "#74DDBC" }),
    /* @__PURE__ */ _.jsx("path", { d: "M277.766 301.358C278.518 301.59 279.154 301.995 279.791 302.4C284.015 305.119 287.025 310.152 287.893 315.069C288.182 316.631 288.645 319.292 287.777 320.623H287.256C287.082 320.623 286.909 320.507 286.793 320.391C286.388 319.928 286.446 317.036 286.33 316.284C286.099 314.606 285.694 312.986 285.173 311.424C283.379 305.929 278.865 305.061 277.303 302.168L277.766 301.474V301.358Z", fill: "#74DDBC" }),
    /* @__PURE__ */ _.jsx("path", { d: "M304.616 285.854C304.79 286.491 304.848 287.011 304.848 287.648C296.226 290.54 287.256 292.623 278.46 294.879C274.583 295.863 270.359 296.499 266.655 297.945C266.019 297.772 266.076 297.945 265.671 297.251C266.771 295.689 280.775 292.854 283.61 291.987L284.826 291.871C289.629 289.673 299.64 288.92 304.038 286.722C304.559 286.433 304.443 286.433 304.674 285.854H304.616Z", fill: "#7C95AD" }),
    /* @__PURE__ */ _.jsx("path", { d: "M282.453 243.045C283.9 249.814 283.9 256.756 284.189 263.64C284.594 273.012 284.826 282.441 284.883 291.871L283.668 291.987C283.263 283.02 282.974 274.053 282.684 265.028C282.453 257.739 281.99 250.334 282.453 243.045Z", fill: "#7C95AD" }),
    /* @__PURE__ */ _.jsx("path", { d: "M266.771 298.755C272.153 301.358 276.203 308.879 278.113 314.317C278.692 316.052 279.675 318.829 278.981 320.565C278.75 321.085 278.634 321.317 278.113 321.606C276.493 321.606 274.988 321.837 273.368 322.127C273.831 320.623 274.004 319.581 273.657 318.019C272.616 312.755 269.664 305.234 265.324 301.763C264.283 300.953 263.009 300.548 261.91 299.796C261.794 299.796 261.678 299.623 261.563 299.565C263.299 299.16 264.977 298.986 266.713 298.813H266.771V298.755Z", fill: "#F0F0F0" }),
    /* @__PURE__ */ _.jsx("path", { d: "M229.504 313.507C229.793 312.581 230.083 311.714 230.603 310.961C232.455 308.416 243.855 305.234 247.501 302.978C249.584 301.705 251.262 298.986 253.751 298.466C256.355 297.945 258.843 300.028 261.158 299.565C261.273 299.565 261.447 299.565 261.563 299.449C261.678 299.449 261.794 299.623 261.91 299.681C263.009 300.433 264.283 300.838 265.324 301.648C269.664 305.119 272.615 312.639 273.657 317.904C273.946 319.466 273.831 320.507 273.368 322.011C270.937 322.3 268.565 322.358 266.134 322.416C266.134 320.97 266.655 317.209 265.729 316.11C262.257 314.722 256.702 315.358 252.883 315.3C249.758 314.895 246.459 315.069 243.276 315.011C240.152 315.011 236.911 314.664 233.786 315.011C232.166 314.606 230.951 314.201 229.446 313.391V313.565L229.504 313.507Z", fill: "#FBA37C" }),
    /* @__PURE__ */ _.jsx("path", { d: "M327.069 272.26C324.118 270.813 321.34 268.789 318.621 266.937C307.973 259.706 294.605 249.524 289.108 237.607C286.851 232.748 285.347 226.789 287.372 221.583C288.471 218.69 290.612 216.492 293.506 215.335C296.631 214.12 299.871 214.351 302.938 215.624C312.892 219.905 318.331 231.533 322.093 240.963C323.134 243.739 324.002 246.574 324.755 249.467C325.102 250.739 325.16 252.243 325.68 253.458C327.532 259.59 327.822 265.433 328.169 271.797C327.185 271.334 320.53 258.26 319.373 256.293C314.165 247.268 308.262 238.359 302.302 229.797C301.492 228.64 300.276 226.5 298.888 226.269C298.888 226.847 306.989 238.301 308.089 240.037C312.66 247.152 317.058 254.384 321.282 261.673C323.192 265.028 325.275 268.384 326.896 271.912L327.069 272.317V272.26Z", fill: "#74DDBC" }),
    /* @__PURE__ */ _.jsx("path", { d: "M245.938 147.997C246.054 147.592 246.17 147.245 246.286 146.84L247.038 146.608C247.964 146.782 248.658 147.303 249.468 147.823L251.667 148.807C252.304 150.08 252.883 151.41 253.577 152.683C254.734 154.534 255.602 156.443 256.413 158.468C258.206 161.65 259.943 164.947 261.331 168.302L257.396 172.641L249.584 182.939C252.883 185.542 257.049 186.93 260.926 188.492C258.669 195.261 255.718 201.798 252.998 208.393L238.763 243.161L231.819 260.632C230.893 263.004 230.141 266.012 228.81 268.152C228.52 267.863 228.578 267.574 228.52 267.169C228.231 267.747 227.826 268.094 227.421 268.499C226.148 271.16 225.106 273.995 224.064 276.714C222.849 274.458 222.502 270.408 222.271 267.863L223.023 265.665C224.932 261.499 226.206 257.045 227.999 252.88C229.967 248.657 230.893 243.103 231.819 238.533C232.745 234.194 233.902 229.855 234.654 225.516C235.927 218.343 236.622 210.938 237.721 203.707C239.515 191.674 241.83 179.525 242.814 167.435C244.087 161.013 244.897 154.476 245.881 147.997H245.938Z", fill: "#132438" }),
    /* @__PURE__ */ _.jsx("path", { d: "M249.468 147.765L251.667 148.749C252.304 150.022 252.882 151.352 253.577 152.625C254.734 154.476 255.602 156.385 256.412 158.41L255.255 158.757L252.593 153.551C251.494 151.641 250.452 149.732 249.468 147.823V147.765Z", fill: "#74DDBC" }),
    /* @__PURE__ */ _.jsx("path", { d: "M256.818 171.137C256.933 171.716 256.991 172.121 257.396 172.583L249.584 182.881C249.353 182.244 249.179 182.244 248.6 181.897C251.262 178.253 253.982 174.666 256.818 171.137Z", fill: "#7C95AD" }),
    /* @__PURE__ */ _.jsx("path", { d: "M256.355 158.41C258.149 161.592 259.885 164.889 261.273 168.245L257.338 172.583C256.933 172.121 256.875 171.716 256.76 171.137C257.686 170.038 258.669 168.997 259.595 167.897C258.322 164.774 256.644 161.765 255.139 158.757L256.297 158.41H256.355Z", fill: "#7C95AD" }),
    /* @__PURE__ */ _.jsx("path", { d: "M248.6 181.897C249.179 182.244 249.353 182.244 249.584 182.881C252.883 185.484 257.049 186.872 260.926 188.434C258.669 195.203 255.718 201.74 252.998 208.335L238.763 243.103L231.819 260.574C230.893 262.946 230.14 265.954 228.809 268.094C228.52 267.805 228.578 267.516 228.52 267.111C228.231 267.689 227.826 268.036 227.421 268.441C230.603 258.433 235.117 248.136 239.168 238.417C245.938 222.161 252.883 205.847 259.074 189.418C256.818 188.319 248.6 185.021 247.559 183.286L248.542 181.839H248.6V181.897Z", fill: "#7C95AD" }),
    /* @__PURE__ */ _.jsx("path", { d: "M236.564 142.964C239.284 144.584 243.855 145.567 245.88 147.939C244.897 154.418 244.087 160.955 242.813 167.377C241.83 179.468 239.515 191.616 237.721 203.649C236.622 210.88 235.927 218.285 234.654 225.459C233.902 229.797 232.744 234.136 231.819 238.475C230.893 243.045 229.967 248.599 227.999 252.822C226.205 257.045 224.932 261.499 223.023 265.607L222.27 267.805C221.171 264.797 220.824 261.268 220.303 258.086L217.236 240.384C216.194 234.715 213.301 217.591 211.333 213.773C210.523 212.269 209.539 211.401 208.151 210.417C210.002 200.294 212.78 189.881 213.706 179.641C212.201 176.459 210.813 173.162 209.019 170.096C210.581 167.84 212.144 165.352 214.053 163.385C215.558 163.269 217.294 163.269 218.625 162.691C220.014 160.55 222.27 159.046 224.238 157.484C229.157 153.493 234.018 148.807 236.622 142.906H236.564V142.964Z", fill: "#B8F2EB" }),
    /* @__PURE__ */ _.jsx("path", { d: "M218.625 162.749C222.502 163.501 225.395 165.988 228.462 168.36C226.611 172.236 224.47 175.592 222.213 179.178C221.75 179.583 221.229 180.104 220.592 180.335C218.393 181.319 215.789 180.451 213.706 179.641C212.202 176.459 210.813 173.162 209.019 170.096C210.581 167.84 212.144 165.352 214.053 163.385C215.558 163.269 217.294 163.269 218.625 162.691V162.749Z", fill: "#218094" }),
    /* @__PURE__ */ _.jsx("path", { d: "M236.564 142.964C239.284 144.584 243.855 145.567 245.881 147.939C244.897 154.418 244.087 160.955 242.814 167.377C240.209 169.864 237.258 171.137 234.423 173.22C232.455 171.6 230.488 169.806 228.404 168.36C225.337 165.988 222.502 163.443 218.567 162.749C219.956 160.608 222.213 159.104 224.18 157.542C229.099 153.551 233.96 148.865 236.564 142.964Z", fill: "#F0F0F0" }),
    /* @__PURE__ */ _.jsx("path", { d: "M222.155 179.236C222.155 180.104 222.328 180.972 222.328 181.839C224.469 194.798 225.395 207.93 226.321 221.004C226.784 227.83 227.421 234.657 227.826 241.483C228.057 245.243 227.71 249.177 227.999 252.88C226.205 257.103 224.932 261.557 223.023 265.665L222.27 267.863C221.171 264.855 220.824 261.326 220.303 258.144L217.236 240.442C216.194 234.773 213.301 217.649 211.333 213.831C210.523 212.327 209.539 211.459 208.151 210.475C210.002 200.352 212.78 189.938 213.706 179.699C215.847 180.509 218.393 181.377 220.592 180.393C221.171 180.104 221.692 179.641 222.213 179.236H222.155Z", fill: "#74DDBC" }),
    /* @__PURE__ */ _.jsx("path", { d: "M223.081 265.665C223.081 265.491 222.965 265.375 222.907 265.202C222.155 263.003 222.56 257.913 222.502 255.483C222.212 241.657 222.039 227.773 221.981 213.946C221.865 203.938 221.576 193.93 221.518 183.98C221.518 183.054 221.518 182.244 221.923 181.377L222.328 181.782C224.469 194.74 225.395 207.872 226.321 220.946C226.784 227.773 227.421 234.599 227.826 241.425C228.057 245.186 227.71 249.119 227.999 252.822C226.205 257.045 224.932 261.499 223.023 265.607L223.081 265.665Z", fill: "#218094" }),
    /* @__PURE__ */ _.jsx("path", { d: "M146.521 255.02C145.769 255.02 145.248 255.714 145.306 256.466C145.306 257.218 146.001 257.739 146.753 257.681C147.505 257.681 148.026 256.987 147.968 256.235C147.968 255.483 147.274 254.962 146.521 255.02Z", fill: "black" }),
    /* @__PURE__ */ _.jsx("path", { d: "M139.867 250.681C138.594 252.359 138.42 254.499 139.172 256.351H140.156L136.163 263.061C138.073 262.483 139.982 260.632 142.471 257.334L148.2 249.698C145.48 247.673 141.718 248.078 139.809 250.681H139.867Z", fill: "black" }),
    /* @__PURE__ */ _.jsx("path", { d: "M149.531 244.029C148.489 242.293 146.695 241.136 144.612 241.136C141.371 241.136 138.767 243.855 138.767 247.268H148.315C152.424 247.268 155.144 246.863 156.706 245.706L148.952 244.838L149.531 244.029ZM146.637 245.417C146.29 245.417 146.058 245.128 146.058 244.838C146.058 244.549 146.348 244.26 146.637 244.26C146.926 244.26 147.216 244.549 147.216 244.838C147.216 245.128 146.926 245.417 146.637 245.417Z", fill: "black" })
  ] }),
  /* @__PURE__ */ _.jsxs("defs", { children: [
    /* @__PURE__ */ _.jsxs("linearGradient", { id: "paint0_linear_7543_524", x1: "68.2204", y1: "259.943", x2: "74.0067", y2: "262.085", gradientUnits: "userSpaceOnUse", children: [
      /* @__PURE__ */ _.jsx("stop", { "stop-color": "#02AB7E" }),
      /* @__PURE__ */ _.jsx("stop", { offset: "1", "stop-color": "#04D09F" })
    ] }),
    /* @__PURE__ */ _.jsxs("linearGradient", { id: "paint1_linear_7543_524", x1: "217.543", y1: "80.7689", x2: "218.005", y2: "30.9019", gradientUnits: "userSpaceOnUse", children: [
      /* @__PURE__ */ _.jsx("stop", { "stop-color": "#392F26" }),
      /* @__PURE__ */ _.jsx("stop", { offset: "1", "stop-color": "#564131" })
    ] }),
    /* @__PURE__ */ _.jsx("clipPath", { id: "clip0_7543_524", children: /* @__PURE__ */ _.jsx("rect", { width: "431", height: "370.509", fill: "white", transform: "translate(0 0.559326)" }) })
  ] })
] });
var zQ = /* @__PURE__ */ ((e) => (e.STRATEGY = "strategy", e.FUND = "fund", e))(zQ || {});
const YQ = /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{1,4})(?: *x(\d+))?\s*$/, Jre = (e) => e.match(YQ), XQ = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/, Qre = (e) => e.match(XQ), ZQ = 40, ene = 80, KQ = 80, tne = ZQ + KQ + 1, rne = 100, nne = 55, ane = 40, ine = 4, one = 4, une = "dd/MM/yyyy", sne = (e) => async (t) => {
  const r = e.validate(t, {
    abortEarly: !1
  });
  if (r.error) {
    const n = {};
    return r.error.details.reduce((i, o) => o.path.length === 1 ? (i[o.path[0]] = o.message, i) : (o.path.reduce((u, s, c) => (c < o.path.length - 1 ? s in u || (u[s] = {}) : u[s] = o.message, u[s]), i), i), n);
  }
}, $u = {
  FFTWO_CONSERVATIVE: "FTCS",
  FFTWO_BALANCED: "FTBS",
  FFTWO_GROWTH: "FTGS",
  FFKS_CONSERVATIVE: "FCKS",
  FFKS_BALANCED: "FBSK",
  FFKS_GROWTH: "FGKS",
  FFMF_CONSERVATIVE_APEX: "MFCS",
  FFMF_BALANCED_APEX: "MFBS",
  FFMF_GROWTH_APEX: "MFGS",
  // TEL strategy codes will go away
  FFMF_CONSERVATIVE_TEL: "FCMF",
  FFMF_BALANCED_TEL: "FB21",
  FFMF_GROWTH_TEL: "FGMF",
  FF_LIFE_CONSERVATIVE: "FLCS",
  FF_LIFE_BALANCED: "FLBS",
  FF_LIFE_GROWTH: "FLGS",
  FFLS_CONSERVATIVE_APEX: "LSCS",
  FFLS_BALANCED_APEX: "LSBS",
  FFLS_GROWTH_APEX: "LSGS"
}, Ke = {
  ...$u,
  // We default to TEL. When APEX migration is done we'll default to APEX
  FFMF_CONSERVATIVE: $u.FFMF_CONSERVATIVE_TEL,
  FFMF_BALANCED: $u.FFMF_BALANCED_TEL,
  FFMF_GROWTH: $u.FFMF_GROWTH_TEL
}, we = {
  MF_INCOME: "FFM0003010",
  MF_PROPERTY_INFRASTRUCTURE: "FFM0003012",
  MF_NZ_GROWTH: "FFM0003000",
  MF_AUS_GROWTH: "FFM0003001",
  MF_INTERNATIONAL_GROWTH: "FFM0003007",
  PM_INCOME: "FFM0003013",
  PM_PROPERTY_INFRASTRUCTURE: "FFM0003009",
  PM_NZ: "FFM0003004",
  PM_AUS: "FFM0003005",
  PM_INTERNATIONAL: "FFM0003006",
  MF_CONSERVATIVE_FUND: "FFM0003049",
  MF_GROWTH_FUND: "FFM0003050",
  KS_GROWTH_FUND: "FFM0003008",
  KS_CONSERVATIVE_FUND: "FFM0003011",
  FFTWO_PRESERVATION: "FFM0003019",
  FFTWO_CONSERVATIVE: "FFM0003016",
  FFTWO_BALANCED: "FFM0003014",
  FFTWO_GROWTH: "FFM0003018",
  FFTWO_EQUITY: "FFM0003017",
  LIFE_BALANCED: "FFM0003020",
  LIFE_CONSERVATIVE: "FFM0003021",
  LIFE_GROWTH: "FFM0003023"
}, be = {
  // KP
  FFKP_CASH: "800300",
  FFKP_CASH_PLUS: "800301",
  FFKP_DEFAULT_CONSERVATIVE: "800302",
  FFKP_CONSERVATIVE: "800303",
  FFKP_DEFAULT: "800304",
  FFKP_BALANCED: "800305",
  FFKP_GROWTH: "800306",
  FFKP_AGGRESSIVE: "800307",
  // MF
  FFMF_CONSERVATIVE: "803105",
  FFMF_GROWTH: "803106",
  MF_INCOME: "803100",
  MF_PROPERTY_INFRASTRUCTURE: "803101",
  MF_NZ_GROWTH: "803102",
  MF_AUS_GROWTH: "803103",
  MF_INTERNATIONAL_GROWTH: "803104",
  CUSTOM_CODE: "custom",
  // PS
  PS_INCOME: "803200",
  PS_PROPERTY_INFRASTRUCTURE: "803201",
  PS_NZ: "803202",
  PS_AUS: "803203",
  PS_INTERNATIONAL: "803204",
  // FFTWO
  FFTWO_PRESERVATION: "809004",
  FFTWO_CASH_ENHANCED: "809005",
  FFTWO_CONSERVATIVE: "809000",
  FFTWO_BALANCED: "809001",
  FFTWO_GROWTH: "809002",
  FFTWO_EQUITY: "809003",
  // IS
  IS_CASH_PLUS: "803000",
  IS_NZ_FIXED_INCOME: "803001",
  IS_BOND_PLUS: "803002",
  IS_TASMAN_EQUITY: "803003",
  IS_GLOBAL: "803004",
  // LS
  LS_PRESERVATION: "801500",
  LS_CONSERVATIVE: "801501",
  LS_NZ_FIXED_INCOME: "801502",
  LS_BALANCED: "801503",
  LS_GROWTH: "801504",
  LS_EQUITY: "801505",
  LS_TRANS_TASMAN_EQUITY: "801506",
  // FP
  FP_CAPITAL_PROTECTED: "801000",
  FP_BALANCED: "801001",
  FP_GROWTH: "801002",
  FP_INTERNATIONAL_COMPANIES: "801003",
  FP_TRANS_TASMAN_EQUITIES: "801004"
}, O6 = [
  we.KS_CONSERVATIVE_FUND,
  we.KS_GROWTH_FUND,
  we.MF_CONSERVATIVE_FUND,
  we.MF_GROWTH_FUND,
  be.FFMF_CONSERVATIVE,
  be.FFMF_GROWTH
], cne = (e) => !O6.includes(e), lne = (e) => O6.includes(e), fne = {
  [we.MF_CONSERVATIVE_FUND]: "Managed Funds Conservative Fund",
  [we.MF_GROWTH_FUND]: "Managed Funds Growth Fund",
  [we.MF_INCOME]: "Managed Funds Income Fund",
  [we.MF_PROPERTY_INFRASTRUCTURE]: "Managed Funds Property & Infrastructure Fund",
  [we.MF_NZ_GROWTH]: "Managed Funds New Zealand Growth Fund",
  [we.MF_AUS_GROWTH]: "Managed Funds Australian Growth Fund",
  [we.MF_INTERNATIONAL_GROWTH]: "Managed Funds International Growth Fund",
  [we.PM_INCOME]: "Premium Income Fund",
  [we.PM_PROPERTY_INFRASTRUCTURE]: "Premium Property & Infrastructure Fund",
  [we.PM_NZ]: "Premium New Zealand Fund",
  [we.PM_AUS]: "Premium Australian Fund",
  [we.PM_INTERNATIONAL]: "Premium International Fund",
  [we.KS_GROWTH_FUND]: "KiwiSaver Growth Fund",
  [we.KS_CONSERVATIVE_FUND]: "KiwiSaver Conservative Fund",
  // Apex
  [be.FFMF_CONSERVATIVE]: "Managed Funds Conservative Fund",
  [be.FFMF_GROWTH]: "Managed Funds Growth Fund",
  [be.MF_INCOME]: "Managed Funds Income Fund",
  [be.MF_PROPERTY_INFRASTRUCTURE]: "Managed Funds Property & Infrastructure Fund",
  [be.MF_NZ_GROWTH]: "Managed Funds New Zealand Growth Fund",
  [be.MF_AUS_GROWTH]: "Managed Funds Australian Growth Fund",
  [be.MF_INTERNATIONAL_GROWTH]: "Managed Funds International Growth Fund",
  [be.PS_INCOME]: "Premium Income Fund",
  [be.PS_PROPERTY_INFRASTRUCTURE]: "Premium Property & Infrastructure Fund",
  [be.PS_NZ]: "Premium New Zealand Fund",
  [be.PS_AUS]: "Premium Australian Fund",
  [be.PS_INTERNATIONAL]: "Premium International Fund"
}, qQ = [
  we.MF_INCOME,
  be.MF_INCOME,
  we.MF_NZ_GROWTH,
  be.MF_NZ_GROWTH,
  we.MF_AUS_GROWTH,
  be.MF_AUS_GROWTH,
  we.MF_INTERNATIONAL_GROWTH,
  be.MF_INTERNATIONAL_GROWTH,
  we.MF_PROPERTY_INFRASTRUCTURE,
  be.MF_PROPERTY_INFRASTRUCTURE,
  we.PM_INCOME,
  be.PS_INCOME,
  we.PM_PROPERTY_INFRASTRUCTURE,
  be.PS_PROPERTY_INFRASTRUCTURE,
  we.PM_NZ,
  be.PS_NZ,
  we.PM_AUS,
  be.PS_AUS,
  we.PM_INTERNATIONAL,
  be.PS_INTERNATIONAL
], dne = (e) => qQ.includes(e), he = {
  INCOME_FUND_COMPOSITE_INDEX: "Income Fund Composite Index*",
  PROPERTY_AND_INFRASTRUCTURE_FUND_COMPOSITE_INDEX: "Property and Infrastructure Fund Composite Index*",
  AUSTRALIAN_EQUITY_COMPOSITE_INDEX: "Australian Equity Composite Index*",
  INTERNATIONAL_EQUITY_COMPOSITE_INDEX: "Equity Composite Index*",
  NZ_50_GROSS_DOLLAR_VALUE: "S&P/NZX50 Gross Index",
  PREMIUM_INCOME_FUND_COMPOSITE_INDEX: "Premium Income Fund Composite Index*",
  NINETY_DAY_BANK_BILL_RATE: "90 Day Bank Bill Rate",
  MF_CONSERVATIVE_COMPOSITE: "Managed Fund Conservative Composite Index",
  MF_GROWTH_COMPOSITE: "Managed Fund Growth Composite Index",
  KS_GROWTH_COMPOSITE: "KiwiSaver Growth Composite Index",
  KS_CONSERVATIVE_COMPOSITE: "KiwiSaver Conservative Composite Index"
}, JQ = {
  // TODO: Delete the TEL MF and PS codes after migration
  [we.MF_INCOME]: [
    he.INCOME_FUND_COMPOSITE_INDEX,
    he.NINETY_DAY_BANK_BILL_RATE
  ],
  [we.MF_PROPERTY_INFRASTRUCTURE]: [
    he.PROPERTY_AND_INFRASTRUCTURE_FUND_COMPOSITE_INDEX,
    he.NINETY_DAY_BANK_BILL_RATE
  ],
  [we.MF_NZ_GROWTH]: [
    he.NZ_50_GROSS_DOLLAR_VALUE,
    he.NINETY_DAY_BANK_BILL_RATE
  ],
  [we.MF_AUS_GROWTH]: [
    he.AUSTRALIAN_EQUITY_COMPOSITE_INDEX,
    he.NINETY_DAY_BANK_BILL_RATE
  ],
  [we.MF_INTERNATIONAL_GROWTH]: [
    he.INTERNATIONAL_EQUITY_COMPOSITE_INDEX,
    he.NINETY_DAY_BANK_BILL_RATE
  ],
  [we.PM_INCOME]: [
    he.PREMIUM_INCOME_FUND_COMPOSITE_INDEX,
    he.NINETY_DAY_BANK_BILL_RATE
  ],
  [we.PM_PROPERTY_INFRASTRUCTURE]: [
    he.PROPERTY_AND_INFRASTRUCTURE_FUND_COMPOSITE_INDEX,
    he.NINETY_DAY_BANK_BILL_RATE
  ],
  [we.PM_NZ]: [
    he.NZ_50_GROSS_DOLLAR_VALUE,
    he.NINETY_DAY_BANK_BILL_RATE
  ],
  [we.PM_AUS]: [
    he.AUSTRALIAN_EQUITY_COMPOSITE_INDEX,
    he.NINETY_DAY_BANK_BILL_RATE
  ],
  [we.PM_INTERNATIONAL]: [
    he.INTERNATIONAL_EQUITY_COMPOSITE_INDEX,
    he.NINETY_DAY_BANK_BILL_RATE
  ],
  [we.MF_CONSERVATIVE_FUND]: [
    he.MF_CONSERVATIVE_COMPOSITE,
    he.NINETY_DAY_BANK_BILL_RATE
  ],
  [we.MF_GROWTH_FUND]: [
    he.MF_GROWTH_COMPOSITE,
    he.NINETY_DAY_BANK_BILL_RATE
  ],
  // Apex Funds
  [be.MF_INCOME]: [
    he.INCOME_FUND_COMPOSITE_INDEX,
    he.NINETY_DAY_BANK_BILL_RATE
  ],
  [be.MF_PROPERTY_INFRASTRUCTURE]: [
    he.PROPERTY_AND_INFRASTRUCTURE_FUND_COMPOSITE_INDEX,
    he.NINETY_DAY_BANK_BILL_RATE
  ],
  [be.MF_NZ_GROWTH]: [
    he.NZ_50_GROSS_DOLLAR_VALUE,
    he.NINETY_DAY_BANK_BILL_RATE
  ],
  [be.MF_AUS_GROWTH]: [
    he.AUSTRALIAN_EQUITY_COMPOSITE_INDEX,
    he.NINETY_DAY_BANK_BILL_RATE
  ],
  [be.MF_INTERNATIONAL_GROWTH]: [
    he.INTERNATIONAL_EQUITY_COMPOSITE_INDEX,
    he.NINETY_DAY_BANK_BILL_RATE
  ],
  [be.PS_INCOME]: [
    he.PREMIUM_INCOME_FUND_COMPOSITE_INDEX,
    he.NINETY_DAY_BANK_BILL_RATE
  ],
  [be.PS_PROPERTY_INFRASTRUCTURE]: [
    he.PROPERTY_AND_INFRASTRUCTURE_FUND_COMPOSITE_INDEX,
    he.NINETY_DAY_BANK_BILL_RATE
  ],
  [be.PS_NZ]: [
    he.NZ_50_GROSS_DOLLAR_VALUE,
    he.NINETY_DAY_BANK_BILL_RATE
  ],
  [be.PS_AUS]: [
    he.AUSTRALIAN_EQUITY_COMPOSITE_INDEX,
    he.NINETY_DAY_BANK_BILL_RATE
  ],
  [be.PS_INTERNATIONAL]: [
    he.INTERNATIONAL_EQUITY_COMPOSITE_INDEX,
    he.NINETY_DAY_BANK_BILL_RATE
  ],
  [be.FFMF_CONSERVATIVE]: [
    he.MF_CONSERVATIVE_COMPOSITE,
    he.NINETY_DAY_BANK_BILL_RATE
  ],
  [be.FFMF_GROWTH]: [
    he.MF_GROWTH_COMPOSITE,
    he.NINETY_DAY_BANK_BILL_RATE
  ],
  [we.KS_GROWTH_FUND]: [
    he.KS_GROWTH_COMPOSITE,
    he.NINETY_DAY_BANK_BILL_RATE
  ],
  [we.KS_CONSERVATIVE_FUND]: [
    he.KS_CONSERVATIVE_COMPOSITE,
    he.NINETY_DAY_BANK_BILL_RATE
  ]
}, pne = (e) => {
  const t = JQ[e];
  if (!t)
    throw new Error(`Benchmarks not found for fund: ${e}.`);
  return t;
}, QQ = {
  [he.PROPERTY_AND_INFRASTRUCTURE_FUND_COMPOSITE_INDEX]: "* 65% S&P Global Infrastructure Index (70% hedged to NZD), 15% S&P/ASX200 A-REIT Index (70% hedged to NZD) and 20% S&P/NZX All Real Estate Index",
  [he.INCOME_FUND_COMPOSITE_INDEX]: `* S&P/NZX 2 Year Swap Index (1/11/2016 to now)
New Zealand Government Stock Index (Inception to 31/10/2016)`,
  [he.AUSTRALIAN_EQUITY_COMPOSITE_INDEX]: `* S&P/ASX 200 Accumulation Index 70% hedged into NZD (1/4/2015 to now)
S&P ASX 300 Industrials ex top 20 70% hedged to NZD (1/2/2012 - 31/3/2015)
S&P/ASX Small Industrials Index (Inception to 31/1/2012)`,
  [he.INTERNATIONAL_EQUITY_COMPOSITE_INDEX]: "* S&P Global LargeMidCap Index (50% hedged into NZD)",
  [he.PREMIUM_INCOME_FUND_COMPOSITE_INDEX]: `* S&P/NZX 2 Year Swap Index (1/11/2016 to now)
New Zealand Government Stock Index (Inception to 31/10/2016)`
}, $m = `Our Balanced Fund and our Default Fund are most suitable if you are a medium to long term investor who wants a balance between volatility of returns and achieving higher potential returns.
An enhanced passive investment style may be used at times in the Default Fund.`, Fm = `Conservative funds are most suitable if you are a short term or naturally cautious investor or value lower volatility of returns over achieving higher potential returns. We show you two conservative options below.
We also have a Cash Fund option, which people who are making a withdrawal in the short term might like to consider. The risk indicator of the Cash Fund is 1 and there is no minimum timeframe for this fund. You can find more information about the Cash Fund in the Product Disclosure Statement (PDS).`, eee = {
  [Ke.FFTWO_CONSERVATIVE]: `This investment strategy is most suitable if you are a short term or naturally cautious investor who is looking to make a withdrawal within the short term, or who values lower volatility of returns over achieving potential higher returns.
While this strategy is designed to be conservative in nature, in times of heightened market volatility the value of your investment may go up or down.`,
  [Ke.FFTWO_BALANCED]: "This investment strategy is most suitable if you are a medium or long term investor who wants a balance between volatility of returns and achieving higher potential returns.",
  [Ke.FFTWO_GROWTH]: "This investment strategy is most suitable if you are a long term investor who can tolerate volatility of returns in the expectation of potential higher returns and who has time on their side.",
  [Ke.FFMF_CONSERVATIVE_TEL]: `This investment strategy is most suitable if you are a short term or naturally cautious investor,  you are looking to make a withdrawal within the short term, or you value lower volatility of returns over achieving potential higher returns.
While this strategy is designed to be conservative in nature, in times of heightened market volatility the value of your investment may go up or down.`,
  [Ke.FFMF_BALANCED_TEL]: "This investment strategy is most suitable if you are a medium to long term investor who wants a balance between volatility of returns and achieving potential higher returns.",
  [Ke.FFMF_GROWTH_TEL]: "This investment strategy is most suitable if you are a long term investor who can tolerate volatility of returns in the expectation of potential higher returns, and has time on their side",
  [Ke.FF_LIFE_CONSERVATIVE]: `This investment strategy is most suitable if you are a short term or naturally cautious investor who is looking to make a withdrawal within the short term, or who values lower volatility of returns over achieving potential higher returns.
While this strategy is designed to be conservative in nature, in times of heightened market volatility the value of your investment may go up or down.`,
  [Ke.FF_LIFE_BALANCED]: "This investment strategy is most suitable if you are a medium to long term investor who wants a balance between volatility of returns and achieving potential higher returns.",
  [Ke.FF_LIFE_GROWTH]: "This investment strategy is most suitable if you are a long term investor who can tolerate volatility of returns in the expectation of potential higher returns and has time on their side.",
  [Ke.FFLS_CONSERVATIVE_APEX]: `This investment strategy is most suitable if you are a short term or naturally cautious investor who is looking to make a withdrawal within the short term, or who values lower volatility of returns over achieving potential higher returns.
While this strategy is designed to be conservative in nature, in times of heightened market volatility the value of your investment may go up or down.`,
  [Ke.FFLS_BALANCED_APEX]: "This investment strategy is most suitable if you are a medium to long term investor who wants a balance between volatility of returns and achieving potential higher returns.",
  [Ke.FFLS_GROWTH_APEX]: "This investment strategy is most suitable if you are a long term investor who can tolerate volatility of returns in the expectation of potential higher returns and has time on their side.",
  [Ke.FFKS_CONSERVATIVE]: `This investment strategy is most suitable if you are a short term or naturally cautious investor who is looking to make a withdrawal in the short term, or who values lower volatility of returns over achieving potential higher returns.
While this strategy is designed to be conservative in nature, in times of heightened market volatility the value of your investment may go up or down.`,
  [Ke.FFKS_BALANCED]: "This investment strategy is most suitable if you are a medium to long term investor who wants a balance between volatility of returns and achieving potential higher returns.",
  [Ke.FFKS_GROWTH]: "This investment strategy is most suitable if you are a long term investor who can tolerate volatility of returns in the expectation of potential higher returns and who has time on their side.",
  [be.FFKP_CASH]: "This Fund is suitable for a short term or naturally cautious investor who is looking to make a withdrawal within 12 months or who is most interested in low volatility of returns over achieving potential higher returns.",
  [be.FFKP_DEFAULT_CONSERVATIVE]: Fm,
  [be.FFKP_CONSERVATIVE]: Fm,
  [be.FFKP_DEFAULT]: $m,
  [be.FFKP_BALANCED]: $m,
  [be.FFKP_GROWTH]: "This investment fund is most suitable if you are a long term investor who can tolerate volatility of returns in the expectation of potential higher returns, or who has time on their side."
}, hne = "Mix of Funds", vne = (e) => eee[e], gne = (e) => QQ[e], Dm = [
  {
    id: 1,
    branches: [
      {
        from: 1,
        to: 999
      },
      {
        from: 1100,
        to: 1199
      },
      {
        from: 1800,
        to: 1899
      }
    ]
  },
  {
    id: 2,
    branches: [
      {
        from: 1,
        to: 999
      },
      {
        from: 1200,
        to: 1299
      }
    ]
  },
  {
    id: 3,
    branches: [
      {
        from: 1,
        to: 999
      },
      {
        from: 1300,
        to: 1399
      },
      {
        from: 1500,
        to: 1599
      },
      {
        from: 1700,
        to: 1799
      },
      {
        from: 1900,
        to: 1999
      }
    ]
  },
  {
    id: 4,
    branches: [
      {
        from: 2020,
        to: 2024
      }
    ]
  },
  {
    id: 6,
    branches: [
      {
        from: 1,
        to: 999
      },
      {
        from: 1400,
        to: 1499
      }
    ]
  },
  {
    id: 8,
    branches: [
      {
        from: 6500,
        to: 6599
      }
    ]
  },
  {
    id: 9,
    branches: [
      {
        from: 0,
        to: 0
      }
    ]
  },
  {
    id: 10,
    branches: [
      {
        from: 5165,
        to: 5169
      }
    ]
  },
  {
    id: 11,
    branches: [
      {
        from: 5e3,
        to: 6499
      },
      {
        from: 6600,
        to: 8999
      }
    ]
  },
  {
    id: 12,
    branches: [
      {
        from: 3e3,
        to: 3299
      },
      {
        from: 3400,
        to: 3499
      },
      {
        from: 3600,
        to: 3699
      }
    ]
  },
  {
    id: 13,
    branches: [
      {
        from: 4900,
        to: 4999
      }
    ]
  },
  {
    id: 14,
    branches: [
      {
        from: 4700,
        to: 4799
      }
    ]
  },
  {
    id: 15,
    branches: [
      {
        from: 3900,
        to: 3999
      }
    ]
  },
  {
    id: 16,
    branches: [
      {
        from: 4400,
        to: 4499
      }
    ]
  },
  {
    id: 17,
    branches: [
      {
        from: 3300,
        to: 3399
      }
    ]
  },
  {
    id: 18,
    branches: [
      {
        from: 3500,
        to: 3599
      }
    ]
  },
  {
    id: 19,
    branches: [
      {
        from: 4600,
        to: 4649
      }
    ]
  },
  {
    id: 20,
    branches: [
      {
        from: 4100,
        to: 4199
      }
    ]
  },
  {
    id: 21,
    branches: [
      {
        from: 4800,
        to: 4899
      }
    ]
  },
  {
    id: 22,
    branches: [
      {
        from: 4e3,
        to: 4049
      }
    ]
  },
  {
    id: 23,
    branches: [
      {
        from: 3700,
        to: 3799
      }
    ]
  },
  {
    id: 24,
    branches: [
      {
        from: 4300,
        to: 4349
      }
    ]
  },
  {
    id: 25,
    branches: [
      {
        from: 2500,
        to: 2599
      }
    ]
  },
  {
    id: 26,
    branches: [
      {
        from: 2600,
        to: 2699
      }
    ]
  },
  {
    id: 27,
    branches: [
      {
        from: 3800,
        to: 3849
      }
    ]
  },
  {
    id: 28,
    branches: [
      {
        from: 2100,
        to: 2149
      }
    ]
  },
  {
    id: 29,
    branches: [
      {
        from: 2150,
        to: 2299
      }
    ]
  },
  {
    id: 30,
    branches: [
      {
        from: 2900,
        to: 2949
      }
    ]
  },
  {
    id: 31,
    branches: [
      {
        from: 2800,
        to: 2849
      }
    ]
  },
  {
    id: 33,
    branches: [
      {
        from: 6700,
        to: 6799
      }
    ]
  },
  {
    id: 35,
    branches: [
      {
        from: 2400,
        to: 2499
      }
    ]
  },
  {
    id: 38,
    branches: [
      {
        from: 9e3,
        to: 9499
      }
    ]
  },
  {
    id: 88,
    branches: [
      {
        from: 8800,
        to: 8805
      }
    ]
  }
], tee = (e, t) => {
  if (!Dm.map((n) => n.id).includes(parseInt(e, 10)))
    return !1;
  const r = Dm.find((n) => n.id === parseInt(e, 10));
  return r && r.branches.map((n) => parseInt(t, 10) >= n.from && +t <= n.to).some((n) => n);
}, ree = (e, t) => {
  switch (parseInt(e, 10)) {
    case 8:
      return "000000076543210000";
    case 9:
      return "000000000054320001";
    case 25:
    case 33:
      return "000000017317310000";
    case 26:
    case 28:
    case 29:
      return "000000013713710371";
    case 31:
      return "000000000000000000";
    default:
      return parseInt(t, 10) < 99e4 ? "00637900A584210000" : "00000000A584210000";
  }
}, nee = (e, t) => {
  switch (parseInt(e, 10)) {
    case 9:
    case 26:
    case 28:
    case 29:
      return t.map((r) => r < 10 ? r : r.toString().split("").reduce((n, a) => parseInt(a, 10) + n, 0)).map((r) => r < 10 ? r : r.toString().split("").reduce((n, a) => parseInt(a, 10) + n, 0)).reduce((r, n) => r + n), 0;
    default:
      return t.reduce((r, n) => r + n, 0);
  }
}, aee = (e) => {
  switch (parseInt(e, 10)) {
    case 25:
    case 33:
    case 26:
    case 28:
    case 29:
      return 10;
    case 31:
      return 1;
    default:
      return 11;
  }
}, mne = (e) => {
  if (e.length < 15)
    return !1;
  const [t, r, n, a] = e.split("-"), i = t.padStart(2, "0"), o = r.padStart(4, "0"), u = n.padStart(8, "0"), s = a.padStart(4, "0");
  if (parseInt(u, 10) === 0 || !tee(i, o))
    return !1;
  const c = (i + o + u + s).split("").map((h) => parseInt(h, 10));
  if (c.length !== 18)
    return !1;
  const f = ree(i, u).split("").map((h) => parseInt(h, 16)).map((h, v) => h * +c[v]), d = nee(i, f), p = aee(i);
  return d % p === 0;
}, km = {
  primary: [3, 2, 7, 6, 5, 4, 3, 2],
  secondary: [7, 4, 3, 2, 5, 2, 7, 6]
}, Lm = 11, Bm = { min: 1e7, max: 15e7 }, S6 = (e, ...t) => t.reduce((r, n) => (...a) => n(r(...a)), e), iee = (e) => (t) => e.reduce(
  (r, n, a) => r + n * parseInt(t[a], 10),
  0
), oee = (e) => `00000000${e.substring(0, e.length - 1)}`.slice(-8), uee = (e) => parseInt(e.substring(e.length - 1), 10), see = (e) => ({
  number: parseInt(e, 10),
  base: oee(e),
  trailing: uee(e)
}), cee = (e) => {
  if (e.number < Bm.min || e.number > Bm.max)
    throw new Error("invalid-range");
  return e;
}, Vm = (e) => (t) => {
  const n = iee(e)(t) % Lm;
  return n === 0 ? n : Lm - n;
}, lee = ({ base: e, trailing: t }) => {
  const r = S6(
    (n) => Vm(km.primary)(n),
    (n) => n === 10 ? Vm(km.secondary)(e) : n
  )(e);
  if (t !== r)
    throw new Error("invalid-check-digit");
}, yne = S6(
  see,
  cee,
  lee
);
var fee = /* @__PURE__ */ ((e) => (e.FFKS = "FFKS", e.FFMF = "FFMF", e.FF_TWO = "FFTWO", e.FF_PREMIUM = "FFPS", e.FF_LIFE = "FFLS", e.FF_FUTURE = "FFFP", e.FF_INV = "FFIS", e.FF_INSTITUTIONAL = "FFINST", e.FFIF = "FFIF", e.FFKP = "FFKP", e))(fee || {}), zt = /* @__PURE__ */ ((e) => (e.FFKS = "kiwisaver", e.FFMF = "managed-funds", e.FF_TWO = "fisher-funds-two", e.FF_FUTURE = "futureplan", e.FF_PREMIUM = "premium-service", e.FF_LIFE = "lifesaver", e.FF_INV = "investment-series", e.FF_IMA = "ima", e.FFIF = "investment-funds", e.FFKP = "kiwisaver-plan", e))(zt || {}), dee = /* @__PURE__ */ ((e) => (e.FFKS = "Fisher Funds KiwiSaver Scheme", e.FFMF = "Fisher Funds Managed Funds", e.FF_TWO = "Fisher Funds TWO KiwiSaver", e.FF_PREMIUM = "Fisher Funds Premium Service", e.FF_LIFE = "Fisher Funds Lifesaver Plan", e.FF_FUTURE = "Fisher Funds FuturePlan", e.FF_INV = "Fisher Funds Investment Series", e.FFIF = "Fisher Funds Investment Funds", e.FFKP = "Fisher Funds KiwiSaver Plan", e))(dee || {});
const pee = [
  "kiwisaver",
  "kiwisaver-plan",
  "managed-funds",
  "premium-service"
  /* FF_PREMIUM */
], bne = (e) => pee.includes(e), hee = (e) => e.replace(/fund/i, "").replace(/strategy/i, "").replace(/\s/g, ""), vee = (e, t) => ({
  link: `${t ? "https://fisherfunds.co.nz" : ""}/${e}`,
  isLegacy: !1
  // TODO: This could be deleted as we were not returning this value before
}), gee = [
  zt.FFKP,
  zt.FFKS,
  zt.FFMF,
  zt.FF_PREMIUM,
  zt.FF_INV,
  zt.FF_LIFE,
  zt.FF_TWO
], xne = (e, t, r) => {
  const n = vee(e, r).link;
  if (gee.includes(e)) {
    const a = `${n}/investment-options`;
    return t ? `${a}#${hee(t)}` : a;
  }
  return n;
};
function Xs(e) {
  "@babel/helpers - typeof";
  return Xs = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Xs(e);
}
function st(e, t) {
  if (t.length < e)
    throw new TypeError(e + " argument" + (e > 1 ? "s" : "") + " required, but only " + t.length + " present");
}
function it(e) {
  st(1, arguments);
  var t = Object.prototype.toString.call(e);
  return e instanceof Date || Xs(e) === "object" && t === "[object Date]" ? new Date(e.getTime()) : typeof e == "number" || t === "[object Number]" ? new Date(e) : ((typeof e == "string" || t === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
}
function mee(e, t) {
  st(2, arguments);
  var r = it(e), n = it(t), a = r.getFullYear() - n.getFullYear(), i = r.getMonth() - n.getMonth();
  return a * 12 + i;
}
function ro(e, t) {
  st(2, arguments);
  var r = it(e), n = it(t), a = r.getTime() - n.getTime();
  return a < 0 ? -1 : a > 0 ? 1 : a;
}
function yee(e) {
  st(1, arguments);
  var t = it(e);
  return t.setHours(23, 59, 59, 999), t;
}
function bee(e) {
  st(1, arguments);
  var t = it(e), r = t.getMonth();
  return t.setFullYear(t.getFullYear(), r + 1, 0), t.setHours(23, 59, 59, 999), t;
}
function xee(e) {
  st(1, arguments);
  var t = it(e);
  return yee(t).getTime() === bee(t).getTime();
}
function Cee(e, t) {
  st(2, arguments);
  var r = it(e), n = it(t), a = ro(r, n), i = Math.abs(mee(r, n)), o;
  if (i < 1)
    o = 0;
  else {
    r.getMonth() === 1 && r.getDate() > 27 && r.setDate(30), r.setMonth(r.getMonth() - a * i);
    var u = ro(r, n) === -a;
    xee(it(e)) && i === 1 && ro(e, n) === 1 && (u = !1), o = a * (i - Number(u));
  }
  return o === 0 ? 0 : o;
}
function wee(e, t) {
  st(2, arguments);
  var r = it(e), n = it(t);
  return r.getFullYear() - n.getFullYear();
}
function Oee(e, t) {
  st(2, arguments);
  var r = it(e), n = it(t), a = ro(r, n), i = Math.abs(wee(r, n));
  r.setFullYear(1584), n.setFullYear(1584);
  var o = ro(r, n) === -a, u = a * (i - Number(o));
  return u === 0 ? 0 : u;
}
function See(e) {
  return st(1, arguments), e instanceof Date || Xs(e) === "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function Aee(e) {
  if (st(1, arguments), !See(e) && typeof e != "number")
    return !1;
  var t = it(e);
  return !isNaN(Number(t));
}
function Jn(e) {
  if (e === null || e === !0 || e === !1)
    return NaN;
  var t = Number(e);
  return isNaN(t) ? t : t < 0 ? Math.ceil(t) : Math.floor(t);
}
function Eee(e, t) {
  st(2, arguments);
  var r = it(e).getTime(), n = Jn(t);
  return new Date(r + n);
}
function _ee(e, t) {
  st(2, arguments);
  var r = Jn(t);
  return Eee(e, -r);
}
var Iee = 864e5;
function Pee(e) {
  st(1, arguments);
  var t = it(e), r = t.getTime();
  t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
  var n = t.getTime(), a = r - n;
  return Math.floor(a / Iee) + 1;
}
function Zs(e) {
  st(1, arguments);
  var t = 1, r = it(e), n = r.getUTCDay(), a = (n < t ? 7 : 0) + n - t;
  return r.setUTCDate(r.getUTCDate() - a), r.setUTCHours(0, 0, 0, 0), r;
}
function A6(e) {
  st(1, arguments);
  var t = it(e), r = t.getUTCFullYear(), n = /* @__PURE__ */ new Date(0);
  n.setUTCFullYear(r + 1, 0, 4), n.setUTCHours(0, 0, 0, 0);
  var a = Zs(n), i = /* @__PURE__ */ new Date(0);
  i.setUTCFullYear(r, 0, 4), i.setUTCHours(0, 0, 0, 0);
  var o = Zs(i);
  return t.getTime() >= a.getTime() ? r + 1 : t.getTime() >= o.getTime() ? r : r - 1;
}
function Tee(e) {
  st(1, arguments);
  var t = A6(e), r = /* @__PURE__ */ new Date(0);
  r.setUTCFullYear(t, 0, 4), r.setUTCHours(0, 0, 0, 0);
  var n = Zs(r);
  return n;
}
var Mee = 6048e5;
function jee(e) {
  st(1, arguments);
  var t = it(e), r = Zs(t).getTime() - Tee(t).getTime();
  return Math.round(r / Mee) + 1;
}
var Ree = {};
function Dc() {
  return Ree;
}
function Ks(e, t) {
  var r, n, a, i, o, u, s, c;
  st(1, arguments);
  var l = Dc(), f = Jn((r = (n = (a = (i = t == null ? void 0 : t.weekStartsOn) !== null && i !== void 0 ? i : t == null || (o = t.locale) === null || o === void 0 || (u = o.options) === null || u === void 0 ? void 0 : u.weekStartsOn) !== null && a !== void 0 ? a : l.weekStartsOn) !== null && n !== void 0 ? n : (s = l.locale) === null || s === void 0 || (c = s.options) === null || c === void 0 ? void 0 : c.weekStartsOn) !== null && r !== void 0 ? r : 0);
  if (!(f >= 0 && f <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var d = it(e), p = d.getUTCDay(), h = (p < f ? 7 : 0) + p - f;
  return d.setUTCDate(d.getUTCDate() - h), d.setUTCHours(0, 0, 0, 0), d;
}
function E6(e, t) {
  var r, n, a, i, o, u, s, c;
  st(1, arguments);
  var l = it(e), f = l.getUTCFullYear(), d = Dc(), p = Jn((r = (n = (a = (i = t == null ? void 0 : t.firstWeekContainsDate) !== null && i !== void 0 ? i : t == null || (o = t.locale) === null || o === void 0 || (u = o.options) === null || u === void 0 ? void 0 : u.firstWeekContainsDate) !== null && a !== void 0 ? a : d.firstWeekContainsDate) !== null && n !== void 0 ? n : (s = d.locale) === null || s === void 0 || (c = s.options) === null || c === void 0 ? void 0 : c.firstWeekContainsDate) !== null && r !== void 0 ? r : 1);
  if (!(p >= 1 && p <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var h = /* @__PURE__ */ new Date(0);
  h.setUTCFullYear(f + 1, 0, p), h.setUTCHours(0, 0, 0, 0);
  var v = Ks(h, t), g = /* @__PURE__ */ new Date(0);
  g.setUTCFullYear(f, 0, p), g.setUTCHours(0, 0, 0, 0);
  var b = Ks(g, t);
  return l.getTime() >= v.getTime() ? f + 1 : l.getTime() >= b.getTime() ? f : f - 1;
}
function Nee(e, t) {
  var r, n, a, i, o, u, s, c;
  st(1, arguments);
  var l = Dc(), f = Jn((r = (n = (a = (i = t == null ? void 0 : t.firstWeekContainsDate) !== null && i !== void 0 ? i : t == null || (o = t.locale) === null || o === void 0 || (u = o.options) === null || u === void 0 ? void 0 : u.firstWeekContainsDate) !== null && a !== void 0 ? a : l.firstWeekContainsDate) !== null && n !== void 0 ? n : (s = l.locale) === null || s === void 0 || (c = s.options) === null || c === void 0 ? void 0 : c.firstWeekContainsDate) !== null && r !== void 0 ? r : 1), d = E6(e, t), p = /* @__PURE__ */ new Date(0);
  p.setUTCFullYear(d, 0, f), p.setUTCHours(0, 0, 0, 0);
  var h = Ks(p, t);
  return h;
}
var $ee = 6048e5;
function Fee(e, t) {
  st(1, arguments);
  var r = it(e), n = Ks(r, t).getTime() - Nee(r, t).getTime();
  return Math.round(n / $ee) + 1;
}
function Ue(e, t) {
  for (var r = e < 0 ? "-" : "", n = Math.abs(e).toString(); n.length < t; )
    n = "0" + n;
  return r + n;
}
var an = {
  // Year
  y: function(t, r) {
    var n = t.getUTCFullYear(), a = n > 0 ? n : 1 - n;
    return Ue(r === "yy" ? a % 100 : a, r.length);
  },
  // Month
  M: function(t, r) {
    var n = t.getUTCMonth();
    return r === "M" ? String(n + 1) : Ue(n + 1, 2);
  },
  // Day of the month
  d: function(t, r) {
    return Ue(t.getUTCDate(), r.length);
  },
  // AM or PM
  a: function(t, r) {
    var n = t.getUTCHours() / 12 >= 1 ? "pm" : "am";
    switch (r) {
      case "a":
      case "aa":
        return n.toUpperCase();
      case "aaa":
        return n;
      case "aaaaa":
        return n[0];
      case "aaaa":
      default:
        return n === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h: function(t, r) {
    return Ue(t.getUTCHours() % 12 || 12, r.length);
  },
  // Hour [0-23]
  H: function(t, r) {
    return Ue(t.getUTCHours(), r.length);
  },
  // Minute
  m: function(t, r) {
    return Ue(t.getUTCMinutes(), r.length);
  },
  // Second
  s: function(t, r) {
    return Ue(t.getUTCSeconds(), r.length);
  },
  // Fraction of second
  S: function(t, r) {
    var n = r.length, a = t.getUTCMilliseconds(), i = Math.floor(a * Math.pow(10, n - 3));
    return Ue(i, r.length);
  }
}, fa = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, Dee = {
  // Era
  G: function(t, r, n) {
    var a = t.getUTCFullYear() > 0 ? 1 : 0;
    switch (r) {
      case "G":
      case "GG":
      case "GGG":
        return n.era(a, {
          width: "abbreviated"
        });
      case "GGGGG":
        return n.era(a, {
          width: "narrow"
        });
      case "GGGG":
      default:
        return n.era(a, {
          width: "wide"
        });
    }
  },
  // Year
  y: function(t, r, n) {
    if (r === "yo") {
      var a = t.getUTCFullYear(), i = a > 0 ? a : 1 - a;
      return n.ordinalNumber(i, {
        unit: "year"
      });
    }
    return an.y(t, r);
  },
  // Local week-numbering year
  Y: function(t, r, n, a) {
    var i = E6(t, a), o = i > 0 ? i : 1 - i;
    if (r === "YY") {
      var u = o % 100;
      return Ue(u, 2);
    }
    return r === "Yo" ? n.ordinalNumber(o, {
      unit: "year"
    }) : Ue(o, r.length);
  },
  // ISO week-numbering year
  R: function(t, r) {
    var n = A6(t);
    return Ue(n, r.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(t, r) {
    var n = t.getUTCFullYear();
    return Ue(n, r.length);
  },
  // Quarter
  Q: function(t, r, n) {
    var a = Math.ceil((t.getUTCMonth() + 1) / 3);
    switch (r) {
      case "Q":
        return String(a);
      case "QQ":
        return Ue(a, 2);
      case "Qo":
        return n.ordinalNumber(a, {
          unit: "quarter"
        });
      case "QQQ":
        return n.quarter(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return n.quarter(a, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return n.quarter(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(t, r, n) {
    var a = Math.ceil((t.getUTCMonth() + 1) / 3);
    switch (r) {
      case "q":
        return String(a);
      case "qq":
        return Ue(a, 2);
      case "qo":
        return n.ordinalNumber(a, {
          unit: "quarter"
        });
      case "qqq":
        return n.quarter(a, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return n.quarter(a, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return n.quarter(a, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(t, r, n) {
    var a = t.getUTCMonth();
    switch (r) {
      case "M":
      case "MM":
        return an.M(t, r);
      case "Mo":
        return n.ordinalNumber(a + 1, {
          unit: "month"
        });
      case "MMM":
        return n.month(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return n.month(a, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return n.month(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone month
  L: function(t, r, n) {
    var a = t.getUTCMonth();
    switch (r) {
      case "L":
        return String(a + 1);
      case "LL":
        return Ue(a + 1, 2);
      case "Lo":
        return n.ordinalNumber(a + 1, {
          unit: "month"
        });
      case "LLL":
        return n.month(a, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return n.month(a, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return n.month(a, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Local week of year
  w: function(t, r, n, a) {
    var i = Fee(t, a);
    return r === "wo" ? n.ordinalNumber(i, {
      unit: "week"
    }) : Ue(i, r.length);
  },
  // ISO week of year
  I: function(t, r, n) {
    var a = jee(t);
    return r === "Io" ? n.ordinalNumber(a, {
      unit: "week"
    }) : Ue(a, r.length);
  },
  // Day of the month
  d: function(t, r, n) {
    return r === "do" ? n.ordinalNumber(t.getUTCDate(), {
      unit: "date"
    }) : an.d(t, r);
  },
  // Day of year
  D: function(t, r, n) {
    var a = Pee(t);
    return r === "Do" ? n.ordinalNumber(a, {
      unit: "dayOfYear"
    }) : Ue(a, r.length);
  },
  // Day of week
  E: function(t, r, n) {
    var a = t.getUTCDay();
    switch (r) {
      case "E":
      case "EE":
      case "EEE":
        return n.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return n.day(a, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return n.day(a, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return n.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(t, r, n, a) {
    var i = t.getUTCDay(), o = (i - a.weekStartsOn + 8) % 7 || 7;
    switch (r) {
      case "e":
        return String(o);
      case "ee":
        return Ue(o, 2);
      case "eo":
        return n.ordinalNumber(o, {
          unit: "day"
        });
      case "eee":
        return n.day(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return n.day(i, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return n.day(i, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return n.day(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(t, r, n, a) {
    var i = t.getUTCDay(), o = (i - a.weekStartsOn + 8) % 7 || 7;
    switch (r) {
      case "c":
        return String(o);
      case "cc":
        return Ue(o, r.length);
      case "co":
        return n.ordinalNumber(o, {
          unit: "day"
        });
      case "ccc":
        return n.day(i, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return n.day(i, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return n.day(i, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return n.day(i, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(t, r, n) {
    var a = t.getUTCDay(), i = a === 0 ? 7 : a;
    switch (r) {
      case "i":
        return String(i);
      case "ii":
        return Ue(i, r.length);
      case "io":
        return n.ordinalNumber(i, {
          unit: "day"
        });
      case "iii":
        return n.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return n.day(a, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return n.day(a, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return n.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(t, r, n) {
    var a = t.getUTCHours(), i = a / 12 >= 1 ? "pm" : "am";
    switch (r) {
      case "a":
      case "aa":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return n.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return n.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(t, r, n) {
    var a = t.getUTCHours(), i;
    switch (a === 12 ? i = fa.noon : a === 0 ? i = fa.midnight : i = a / 12 >= 1 ? "pm" : "am", r) {
      case "b":
      case "bb":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return n.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return n.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(t, r, n) {
    var a = t.getUTCHours(), i;
    switch (a >= 17 ? i = fa.evening : a >= 12 ? i = fa.afternoon : a >= 4 ? i = fa.morning : i = fa.night, r) {
      case "B":
      case "BB":
      case "BBB":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return n.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return n.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(t, r, n) {
    if (r === "ho") {
      var a = t.getUTCHours() % 12;
      return a === 0 && (a = 12), n.ordinalNumber(a, {
        unit: "hour"
      });
    }
    return an.h(t, r);
  },
  // Hour [0-23]
  H: function(t, r, n) {
    return r === "Ho" ? n.ordinalNumber(t.getUTCHours(), {
      unit: "hour"
    }) : an.H(t, r);
  },
  // Hour [0-11]
  K: function(t, r, n) {
    var a = t.getUTCHours() % 12;
    return r === "Ko" ? n.ordinalNumber(a, {
      unit: "hour"
    }) : Ue(a, r.length);
  },
  // Hour [1-24]
  k: function(t, r, n) {
    var a = t.getUTCHours();
    return a === 0 && (a = 24), r === "ko" ? n.ordinalNumber(a, {
      unit: "hour"
    }) : Ue(a, r.length);
  },
  // Minute
  m: function(t, r, n) {
    return r === "mo" ? n.ordinalNumber(t.getUTCMinutes(), {
      unit: "minute"
    }) : an.m(t, r);
  },
  // Second
  s: function(t, r, n) {
    return r === "so" ? n.ordinalNumber(t.getUTCSeconds(), {
      unit: "second"
    }) : an.s(t, r);
  },
  // Fraction of second
  S: function(t, r) {
    return an.S(t, r);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(t, r, n, a) {
    var i = a._originalDate || t, o = i.getTimezoneOffset();
    if (o === 0)
      return "Z";
    switch (r) {
      case "X":
        return Gm(o);
      case "XXXX":
      case "XX":
        return Fn(o);
      case "XXXXX":
      case "XXX":
      default:
        return Fn(o, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(t, r, n, a) {
    var i = a._originalDate || t, o = i.getTimezoneOffset();
    switch (r) {
      case "x":
        return Gm(o);
      case "xxxx":
      case "xx":
        return Fn(o);
      case "xxxxx":
      case "xxx":
      default:
        return Fn(o, ":");
    }
  },
  // Timezone (GMT)
  O: function(t, r, n, a) {
    var i = a._originalDate || t, o = i.getTimezoneOffset();
    switch (r) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + Wm(o, ":");
      case "OOOO":
      default:
        return "GMT" + Fn(o, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(t, r, n, a) {
    var i = a._originalDate || t, o = i.getTimezoneOffset();
    switch (r) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + Wm(o, ":");
      case "zzzz":
      default:
        return "GMT" + Fn(o, ":");
    }
  },
  // Seconds timestamp
  t: function(t, r, n, a) {
    var i = a._originalDate || t, o = Math.floor(i.getTime() / 1e3);
    return Ue(o, r.length);
  },
  // Milliseconds timestamp
  T: function(t, r, n, a) {
    var i = a._originalDate || t, o = i.getTime();
    return Ue(o, r.length);
  }
};
function Wm(e, t) {
  var r = e > 0 ? "-" : "+", n = Math.abs(e), a = Math.floor(n / 60), i = n % 60;
  if (i === 0)
    return r + String(a);
  var o = t;
  return r + String(a) + o + Ue(i, 2);
}
function Gm(e, t) {
  if (e % 60 === 0) {
    var r = e > 0 ? "-" : "+";
    return r + Ue(Math.abs(e) / 60, 2);
  }
  return Fn(e, t);
}
function Fn(e, t) {
  var r = t || "", n = e > 0 ? "-" : "+", a = Math.abs(e), i = Ue(Math.floor(a / 60), 2), o = Ue(a % 60, 2);
  return n + i + r + o;
}
var Hm = function(t, r) {
  switch (t) {
    case "P":
      return r.date({
        width: "short"
      });
    case "PP":
      return r.date({
        width: "medium"
      });
    case "PPP":
      return r.date({
        width: "long"
      });
    case "PPPP":
    default:
      return r.date({
        width: "full"
      });
  }
}, _6 = function(t, r) {
  switch (t) {
    case "p":
      return r.time({
        width: "short"
      });
    case "pp":
      return r.time({
        width: "medium"
      });
    case "ppp":
      return r.time({
        width: "long"
      });
    case "pppp":
    default:
      return r.time({
        width: "full"
      });
  }
}, kee = function(t, r) {
  var n = t.match(/(P+)(p+)?/) || [], a = n[1], i = n[2];
  if (!i)
    return Hm(t, r);
  var o;
  switch (a) {
    case "P":
      o = r.dateTime({
        width: "short"
      });
      break;
    case "PP":
      o = r.dateTime({
        width: "medium"
      });
      break;
    case "PPP":
      o = r.dateTime({
        width: "long"
      });
      break;
    case "PPPP":
    default:
      o = r.dateTime({
        width: "full"
      });
      break;
  }
  return o.replace("{{date}}", Hm(a, r)).replace("{{time}}", _6(i, r));
}, Lee = {
  p: _6,
  P: kee
};
function Bee(e) {
  var t = new Date(Date.UTC(e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes(), e.getSeconds(), e.getMilliseconds()));
  return t.setUTCFullYear(e.getFullYear()), e.getTime() - t.getTime();
}
var Vee = ["D", "DD"], Wee = ["YY", "YYYY"];
function Gee(e) {
  return Vee.indexOf(e) !== -1;
}
function Hee(e) {
  return Wee.indexOf(e) !== -1;
}
function Um(e, t, r) {
  if (e === "YYYY")
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(t, "`) for formatting years to the input `").concat(r, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "YY")
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(t, "`) for formatting years to the input `").concat(r, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "D")
    throw new RangeError("Use `d` instead of `D` (in `".concat(t, "`) for formatting days of the month to the input `").concat(r, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "DD")
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(t, "`) for formatting days of the month to the input `").concat(r, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}
var Uee = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, zee = function(t, r, n) {
  var a, i = Uee[t];
  return typeof i == "string" ? a = i : r === 1 ? a = i.one : a = i.other.replace("{{count}}", r.toString()), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "in " + a : a + " ago" : a;
};
function ff(e) {
  return function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = t.width ? String(t.width) : e.defaultWidth, n = e.formats[r] || e.formats[e.defaultWidth];
    return n;
  };
}
var Yee = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, Xee = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, Zee = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Kee = {
  date: ff({
    formats: Yee,
    defaultWidth: "full"
  }),
  time: ff({
    formats: Xee,
    defaultWidth: "full"
  }),
  dateTime: ff({
    formats: Zee,
    defaultWidth: "full"
  })
}, qee = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, Jee = function(t, r, n, a) {
  return qee[t];
};
function Fi(e) {
  return function(t, r) {
    var n = r != null && r.context ? String(r.context) : "standalone", a;
    if (n === "formatting" && e.formattingValues) {
      var i = e.defaultFormattingWidth || e.defaultWidth, o = r != null && r.width ? String(r.width) : i;
      a = e.formattingValues[o] || e.formattingValues[i];
    } else {
      var u = e.defaultWidth, s = r != null && r.width ? String(r.width) : e.defaultWidth;
      a = e.values[s] || e.values[u];
    }
    var c = e.argumentCallback ? e.argumentCallback(t) : t;
    return a[c];
  };
}
var Qee = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, ete = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, tte = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
}, rte = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
}, nte = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, ate = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, ite = function(t, r) {
  var n = Number(t), a = n % 100;
  if (a > 20 || a < 10)
    switch (a % 10) {
      case 1:
        return n + "st";
      case 2:
        return n + "nd";
      case 3:
        return n + "rd";
    }
  return n + "th";
}, ote = {
  ordinalNumber: ite,
  era: Fi({
    values: Qee,
    defaultWidth: "wide"
  }),
  quarter: Fi({
    values: ete,
    defaultWidth: "wide",
    argumentCallback: function(t) {
      return t - 1;
    }
  }),
  month: Fi({
    values: tte,
    defaultWidth: "wide"
  }),
  day: Fi({
    values: rte,
    defaultWidth: "wide"
  }),
  dayPeriod: Fi({
    values: nte,
    defaultWidth: "wide",
    formattingValues: ate,
    defaultFormattingWidth: "wide"
  })
};
function Di(e) {
  return function(t) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = r.width, a = n && e.matchPatterns[n] || e.matchPatterns[e.defaultMatchWidth], i = t.match(a);
    if (!i)
      return null;
    var o = i[0], u = n && e.parsePatterns[n] || e.parsePatterns[e.defaultParseWidth], s = Array.isArray(u) ? ste(u, function(f) {
      return f.test(o);
    }) : ute(u, function(f) {
      return f.test(o);
    }), c;
    c = e.valueCallback ? e.valueCallback(s) : s, c = r.valueCallback ? r.valueCallback(c) : c;
    var l = t.slice(o.length);
    return {
      value: c,
      rest: l
    };
  };
}
function ute(e, t) {
  for (var r in e)
    if (e.hasOwnProperty(r) && t(e[r]))
      return r;
}
function ste(e, t) {
  for (var r = 0; r < e.length; r++)
    if (t(e[r]))
      return r;
}
function cte(e) {
  return function(t) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = t.match(e.matchPattern);
    if (!n) return null;
    var a = n[0], i = t.match(e.parsePattern);
    if (!i) return null;
    var o = e.valueCallback ? e.valueCallback(i[0]) : i[0];
    o = r.valueCallback ? r.valueCallback(o) : o;
    var u = t.slice(a.length);
    return {
      value: o,
      rest: u
    };
  };
}
var lte = /^(\d+)(th|st|nd|rd)?/i, fte = /\d+/i, dte = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, pte = {
  any: [/^b/i, /^(a|c)/i]
}, hte = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, vte = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, gte = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, mte = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, yte = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, bte = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, xte = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, Cte = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, wte = {
  ordinalNumber: cte({
    matchPattern: lte,
    parsePattern: fte,
    valueCallback: function(t) {
      return parseInt(t, 10);
    }
  }),
  era: Di({
    matchPatterns: dte,
    defaultMatchWidth: "wide",
    parsePatterns: pte,
    defaultParseWidth: "any"
  }),
  quarter: Di({
    matchPatterns: hte,
    defaultMatchWidth: "wide",
    parsePatterns: vte,
    defaultParseWidth: "any",
    valueCallback: function(t) {
      return t + 1;
    }
  }),
  month: Di({
    matchPatterns: gte,
    defaultMatchWidth: "wide",
    parsePatterns: mte,
    defaultParseWidth: "any"
  }),
  day: Di({
    matchPatterns: yte,
    defaultMatchWidth: "wide",
    parsePatterns: bte,
    defaultParseWidth: "any"
  }),
  dayPeriod: Di({
    matchPatterns: xte,
    defaultMatchWidth: "any",
    parsePatterns: Cte,
    defaultParseWidth: "any"
  })
}, Ote = {
  code: "en-US",
  formatDistance: zee,
  formatLong: Kee,
  formatRelative: Jee,
  localize: ote,
  match: wte,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
}, Ste = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, Ate = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, Ete = /^'([^]*?)'?$/, _te = /''/g, Ite = /[a-zA-Z]/;
function df(e, t, r) {
  var n, a, i, o, u, s, c, l, f, d, p, h, v, g;
  st(2, arguments);
  var b = String(t), x = Dc(), w = (n = (a = void 0) !== null && a !== void 0 ? a : x.locale) !== null && n !== void 0 ? n : Ote, y = Jn((i = (o = (u = (s = void 0) !== null && s !== void 0 ? s : void 0) !== null && u !== void 0 ? u : x.firstWeekContainsDate) !== null && o !== void 0 ? o : (c = x.locale) === null || c === void 0 || (l = c.options) === null || l === void 0 ? void 0 : l.firstWeekContainsDate) !== null && i !== void 0 ? i : 1);
  if (!(y >= 1 && y <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var m = Jn((f = (d = (p = (h = void 0) !== null && h !== void 0 ? h : void 0) !== null && p !== void 0 ? p : x.weekStartsOn) !== null && d !== void 0 ? d : (v = x.locale) === null || v === void 0 || (g = v.options) === null || g === void 0 ? void 0 : g.weekStartsOn) !== null && f !== void 0 ? f : 0);
  if (!(m >= 0 && m <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (!w.localize)
    throw new RangeError("locale must contain localize property");
  if (!w.formatLong)
    throw new RangeError("locale must contain formatLong property");
  var C = it(e);
  if (!Aee(C))
    throw new RangeError("Invalid time value");
  var O = Bee(C), S = _ee(C, O), A = {
    firstWeekContainsDate: y,
    weekStartsOn: m,
    locale: w,
    _originalDate: C
  }, P = b.match(Ate).map(function(T) {
    var M = T[0];
    if (M === "p" || M === "P") {
      var I = Lee[M];
      return I(T, w.formatLong);
    }
    return T;
  }).join("").match(Ste).map(function(T) {
    if (T === "''")
      return "'";
    var M = T[0];
    if (M === "'")
      return Pte(T);
    var I = Dee[M];
    if (I)
      return Hee(T) && Um(T, t, String(e)), Gee(T) && Um(T, t, String(e)), I(S, T, w.localize, A);
    if (M.match(Ite))
      throw new RangeError("Format string contains an unescaped latin alphabet character `" + M + "`");
    return T;
  }).join("");
  return P;
}
function Pte(e) {
  var t = e.match(Ete);
  return t ? t[1].replace(_te, "'") : e;
}
const Cne = (e) => {
  if (!(e != null && e.inceptionDate))
    return null;
  const t = new Date(e.inceptionDate), r = Cee(/* @__PURE__ */ new Date(), t) < 1, n = Oee(/* @__PURE__ */ new Date(), t), a = n >= 5, i = () => e.inceptionDate ? df(t, "dd MMM yyyy") : null, o = () => n < 1 ? "Return since inception" : a ? "Annualised 5 year return" : "Annualised return since inception", u = () => a ? e == null ? void 0 : e.return5Years : e == null ? void 0 : e.returnSinceInception, s = () => {
    if (r && e.displayName) {
      const c = df(t, "dd MMM yyyy");
      return `* As the ${e.displayName} was launched on ${c}, we cannot currently show a return since inception figure.`;
    }
    return e.priceDate ? `* After fees and before tax returns as at ${df(
      new Date(e.priceDate),
      "dd MMM yyyy"
    )}.
      Fund performance figures have been annualised where the performance period is more
      than one year. Fund performance figures do not include entry fees, exit fees or brokerage
      fees or tax, but do include any tax credits applicable to the funds since October 2007. Please
      note that past performance is not necessarily indicative of future returns. Returns can be positive
      or negative, and returns over different time periods may vary. No returns are promised or guaranteed.` : null;
  };
  return {
    inceptionDate: i(),
    title: o(),
    tooltip: s(),
    value: u()
  };
};
var Tte = /* @__PURE__ */ ((e) => (e.Balanced = "balanced", e.Cash = "cash", e.Conservative = "conservative", e.DefaultConservative = "defaultConservative", e.Growth = "growth", e.Aggressive = "aggressive", e))(Tte || {});
const wne = [
  {
    product: zt.FFKS,
    conservative: Ke.FFKS_CONSERVATIVE,
    balanced: Ke.FFKS_BALANCED,
    growth: Ke.FFKS_GROWTH
  },
  {
    product: zt.FF_TWO,
    conservative: Ke.FFTWO_CONSERVATIVE,
    balanced: Ke.FFTWO_BALANCED,
    growth: Ke.FFTWO_GROWTH
  },
  {
    product: zt.FFMF,
    conservative: Ke.FFMF_CONSERVATIVE_APEX,
    balanced: Ke.FFMF_BALANCED_APEX,
    growth: Ke.FFMF_GROWTH_APEX
  },
  {
    product: zt.FF_LIFE,
    conservative: Ke.FFLS_CONSERVATIVE_APEX,
    balanced: Ke.FFLS_BALANCED_APEX,
    growth: Ke.FFLS_GROWTH_APEX
  },
  {
    product: zt.FFKP,
    cash: be.FFKP_CASH,
    defaultConservative: be.FFKP_DEFAULT_CONSERVATIVE,
    conservative: be.FFKP_CONSERVATIVE,
    balanced: be.FFKP_BALANCED,
    growth: be.FFKP_GROWTH,
    aggressive: be.FFKP_AGGRESSIVE
  }
];
export {
  be as APEX_FUNDS_CODES,
  hne as APEX_MIX_MANDATE_SHORTNAME,
  n8 as AmountInput,
  sy as AmountSelectInput,
  he as BENCHMARK_NAMES,
  Pre as BankAccountInput,
  r8 as Button,
  Are as Card,
  Ere as Checkbox,
  Gr as ContributionFrequency,
  jre as ControlledAmountInput,
  KA as ControlledAmountSelectInput,
  Nre as ControlledButtonGroup,
  Tre as ControlledInput,
  Mre as ControlledNumberInput,
  qA as ControlledRadioMenu,
  Rre as ControlledSelect,
  to as EmploymentStatus,
  pee as FLAGSHIP_PRODUCTS_SLUGS,
  fne as FUNDS_NAMES,
  we as FUNDS_TEL_CODES,
  qQ as FUNDS_WITH_PERFORMANCE_CHARTS,
  qre as GraphicClientService,
  yre as IconAccount,
  Zte as IconAdd,
  Dte as IconAlert,
  Fte as IconAlertCircle,
  Bte as IconAlertCircleOutline,
  dre as IconAnchor,
  bre as IconAnnouncement,
  Jte as IconArrowDownCircleOutline,
  Hte as IconArrowForward,
  vre as IconArrowLeft,
  gre as IconArrowRight,
  Ute as IconArrowUpForward,
  are as IconCalendar,
  Xte as IconChatBubble,
  Yte as IconChatBubblesOutline,
  cre as IconCheck,
  X8 as IconCheckmarkCircle,
  Wte as IconCheckmarkCircleOutline,
  zte as IconChevronBack,
  uy as IconChevronDown,
  Gte as IconChevronForward,
  ere as IconChevronUp,
  Z8 as IconClose,
  kte as IconCloseCircle,
  Vte as IconCloseCircleOutline,
  ire as IconDownload,
  rre as IconEllipse,
  fre as IconEmail,
  dh as IconErrorDisclaimerCircle,
  sre as IconExternalLink,
  Nte as IconHome,
  xre as IconHouse,
  Cre as IconInformation,
  wre as IconIrd,
  Ore as IconLicense,
  nre as IconLightBulb,
  lre as IconLogout,
  pre as IconMail,
  Wu as IconMdInformationCircle,
  ore as IconPencilFill,
  mre as IconPhone,
  hre as IconPhoneAlt,
  tre as IconRefresh,
  Kte as IconRemove,
  Qte as IconRiArrowGoBackLine,
  ure as IconSearch,
  Sre as IconSupport,
  qte as IconSync,
  $te as IconSyncCircle,
  Lte as IconSyncCircleOutline,
  _re as InfoTooltip,
  Ire as Input,
  lr as InputWrapper,
  zQ as InvestmentOptionType,
  Tte as InvestorType,
  $re as IrdNumberInput,
  Rte as Link,
  qy as MaskedInput,
  kre as Notification,
  Fre as OPTION_ALL,
  W1 as OptionButtons,
  fee as ProductCode,
  zt as ProductSlug,
  dee as ProductType,
  Cb as Radio,
  f_ as RadioMenu,
  Zre as RetirementProjectorFormEmployerContributions,
  zre as RetirementProjectorFormEmploymentStatus,
  Yre as RetirementProjectorFormSalaryFrequency,
  Xre as RetirementProjectorFormYourContributions,
  Ure as RetirementProjectorGraph,
  Lre as RetirementProjectorOption,
  Kre as RetirementProjectorVoluntaryContributions,
  Ke as STRATEGY_CODES,
  C6 as ScreenSize,
  yT as Select,
  mT as SelectWrapper,
  Dre as Switch,
  bT as TextAreaInput,
  v3 as TextInput,
  b1 as Tooltip,
  rne as addressLineMaxLength,
  ane as cityMaxLength,
  une as dateFormat,
  XQ as emailRegex,
  ZQ as firstNameMaxLength,
  Fc as formatCurrency,
  GQ as formatPercentage,
  Hre as formatReturn,
  Vre as formatSignedCurrency,
  Gre as formatUnitPrice,
  Wre as formatWithDecimalPlaces,
  gne as getBenchmarkDescription,
  pne as getBenchmarksForFund,
  vne as getIPQTargetClientSummary,
  Cne as getPrettyReturns,
  xne as getProductInvestmentOptionsPagePath,
  vee as getProductPagePath,
  dne as hasPerformanceChart,
  hee as investmentOptionHash,
  Qre as isEmail,
  bne as isFlagshipProduct,
  lne as isMixedPortfolioFunds,
  Jre as isPhoneNumber,
  cne as isSingleSectorFunds,
  yne as isValidIRDNumber,
  mne as isValidNZBankNumber,
  KQ as lastNameMaxLength,
  ene as middleNameMaxLength,
  tne as nameMaxLength,
  YQ as phoneNumberRegex,
  ine as postcodeMaxLength,
  one as postcodeMinLength,
  wne as productCodeMap,
  sne as schemaValidation,
  nne as suburbMaxLength,
  BQ as useMedia,
  Bre as useToggle
};
